(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[888,741],{

/***/ 5061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bucketLog": function() { return /* binding */ bucketLog; },
/* harmony export */   "formattingLogData": function() { return /* binding */ formattingLogData; },
/* harmony export */   "getPageVariable": function() { return /* binding */ getPageVariable; },
/* harmony export */   "logPageviewAfterLoad": function() { return /* binding */ logPageviewAfterLoad; },
/* harmony export */   "logPageviewBeforeLoad": function() { return /* binding */ logPageviewBeforeLoad; },
/* harmony export */   "waitForInit": function() { return /* binding */ waitForInit; }
/* harmony export */ });
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};

var humps = {exports: {}};

(function (module) {

(function (global) {
  var _processKeys = function (convert, obj, options) {
    if (!_isObject(obj) || _isDate(obj) || _isRegExp(obj) || _isBoolean(obj) || _isFunction(obj)) {
      return obj;
    }

    var output,
        i = 0,
        l = 0;

    if (_isArray(obj)) {
      output = [];

      for (l = obj.length; i < l; i++) {
        output.push(_processKeys(convert, obj[i], options));
      }
    } else {
      output = {};

      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          output[convert(key, options)] = _processKeys(convert, obj[key], options);
        }
      }
    }

    return output;
  }; // String conversion methods


  var separateWords = function (string, options) {
    options = options || {};
    var separator = options.separator || '_';
    var split = options.split || /(?=[A-Z])/;
    return string.split(split).join(separator);
  };

  var camelize = function (string) {
    if (_isNumerical(string)) {
      return string;
    }

    string = string.replace(/[\-_\s]+(.)?/g, function (match, chr) {
      return chr ? chr.toUpperCase() : '';
    }); // Ensure 1st char is always lowercase

    return string.substr(0, 1).toLowerCase() + string.substr(1);
  };

  var pascalize = function (string) {
    var camelized = camelize(string); // Ensure 1st char is always uppercase

    return camelized.substr(0, 1).toUpperCase() + camelized.substr(1);
  };

  var decamelize = function (string, options) {
    return separateWords(string, options).toLowerCase();
  }; // Utilities
  // Taken from Underscore.js


  var toString = Object.prototype.toString;

  var _isFunction = function (obj) {
    return typeof obj === 'function';
  };

  var _isObject = function (obj) {
    return obj === Object(obj);
  };

  var _isArray = function (obj) {
    return toString.call(obj) == '[object Array]';
  };

  var _isDate = function (obj) {
    return toString.call(obj) == '[object Date]';
  };

  var _isRegExp = function (obj) {
    return toString.call(obj) == '[object RegExp]';
  };

  var _isBoolean = function (obj) {
    return toString.call(obj) == '[object Boolean]';
  }; // Performant way to determine if obj coerces to a number


  var _isNumerical = function (obj) {
    obj = obj - 0;
    return obj === obj;
  }; // Sets up function which handles processing keys
  // allowing the convert function to be modified by a callback


  var _processor = function (convert, options) {
    var callback = options && 'process' in options ? options.process : options;

    if (typeof callback !== 'function') {
      return convert;
    }

    return function (string, options) {
      return callback(string, convert, options);
    };
  };

  var humps = {
    camelize: camelize,
    decamelize: decamelize,
    pascalize: pascalize,
    depascalize: decamelize,
    camelizeKeys: function (object, options) {
      return _processKeys(_processor(camelize, options), object);
    },
    decamelizeKeys: function (object, options) {
      return _processKeys(_processor(decamelize, options), object, options);
    },
    pascalizeKeys: function (object, options) {
      return _processKeys(_processor(pascalize, options), object);
    },
    depascalizeKeys: function () {
      return this.decamelizeKeys.apply(this, arguments);
    }
  };

  if (module.exports) {
    module.exports = humps;
  } else {
    global.humps = humps;
  }
})(commonjsGlobal);
}(humps));

function filter(obj, cb) {
  var output = {};

  for (var k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, k) && cb(obj[k], k)) {
      output[k] = obj[k];
    }
  }

  return output;
}

var formattingLogData = function (logData) {
  return filter({
    data: logData.data,
    category: logData.category,
    object_section: logData.section,
    object_type: logData.type && humps.exports.decamelize(logData.type),
    object_id: logData.id,
    object_idx: logData.index,
    object_url: logData.url
  }, function (v) {
    return v != null;
  });
};
function bucketLog(logData) {
  // See app/assets/javascripts/v3/logging.js.
  // window.bucketLog is a global object; whenever the data is pushed into
  // bucketLog array, the logging.js tries to send the data to log.ohou.se.
  //
  // If bucketLog receives 'category' key, it tries to send the log immediately.
  // However if it receives 'url', 'params', 'user_id', or any variable stored
  // inside bucketLog, it tries to overwrite the variable. These variables
  // are sent with the log.
  //
  // After loading the page, this variables are not really a concern - the logs
  // can be sent without considering these variables.
  // However, we utilize history.pushState to make single page application
  // (SPA). This breaks 'url' variable inside bucketLog, or any logging system
  // being used, since most of them only sends 'pageview' event when the page is
  // initially loaded.
  // To keep this updated, logPageviewBeforeLoad / logPageviewAfterLoad
  // updates these variables.
  window.bucketLog = window.bucketLog || [];
  window.bucketLog.push(formattingLogData(logData));
}
var initializedPromise;
function waitForInit() {
  if (initializedPromise != null) {
    return initializedPromise;
  }

  var promise = new Promise(function (resolve) {
    var timerId = undefined;

    var handleInit = function () {
      clearTimeout(timerId);
      resolve();
    };

    window.bucketLog = window.bucketLog || [];
    window.bucketLog.push({
      category: 'waitForInit',
      callback: handleInit
    });
    timerId = setTimeout(handleInit, 8000);
  });
  initializedPromise = promise;
  return promise;
}
function getPageVariable(key) {
  var bucketLogInst = window.bucketLog;

  if (bucketLogInst && bucketLogInst.get) {
    return bucketLogInst.get(key);
  }

  return null;
}

function separateURLParams(url) {
  // /cards/12345 ?type=video #1234
  // ^            ^^          ^
  // 1            23          4
  var match = /^([^#\s?]*)(\?([^#\s]*))?(#(\w*))?$/.exec(url);

  if (match != null) {
    return [match[1], (match[3] || '') + (match[4] || '')];
  }

  return [url, ''];
}
/**
 * Logs the pageview transition event.
 * This should be triggered after changing the location.
 *
 * However, the application can perform loading data after changing the
 * location, which can be required to log the pageview event.
 * For instance, the Google Analytics (ga), logs the window title along with
 * the pageview log. This is only accessible after the loading the data.
 *
 * Therefore, there are two phases of the pageview log - one for immediate
 * logging, and one for normal logging.
 *
 * @param {string} prevUrl The previous URL the user was visiting.
 * @param {string} url The current URL the user is trying to navigate to.
 */


function logPageviewBeforeLoad(prevUrl, url) {
  // log.ohou.se Tracking
  var _a = separateURLParams(url),
      pathname = _a[0],
      params = _a[1];

  var refererUrl = location.origin + prevUrl; // See bucketLog (on the top of this file)

  window.bucketLog = window.bucketLog || [];
  window.bucketLog.push({
    url: location.origin + pathname,
    params: params,
    referer: refererUrl
  });
}
/**
 * Logs the pageview transtion event.
 * This should be triggered after changing the location, and after loading the
 * data necessary to loaded the page.
 */

function logPageviewAfterLoad() {
  // log.ohou.se Tracking
  // See bucketLog (on the top of this file)
  window.bucketLog = window.bucketLog || [];
  window.bucketLog.push({
    category: 'pageview',
    // if mode is 'auto', it can be blocked by disableAutoPageview
    mode: 'auto'
  });
}




/***/ }),

/***/ 41149:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var react = __webpack_require__(75213);
var React = __webpack_require__(67294);
var ui = __webpack_require__(9710);
var reactIntersectionObserver = __webpack_require__(57322);
var reactTransitionGroup = __webpack_require__(20266);
var _styled = __webpack_require__(7329);
var reactDom = __webpack_require__(73935);
var reactPopper = __webpack_require__(49374);
var classNames = __webpack_require__(94184);
var querystring = __webpack_require__(17673);
var _debounce = __webpack_require__(23279);
var eases = __webpack_require__(14967);
var isEqual = __webpack_require__(18446);
var findLastKey = __webpack_require__(31691);
var omit = __webpack_require__(57557);
var findLast = __webpack_require__(30988);
var size = __webpack_require__(84238);
var reactVirtuoso = __webpack_require__(9764);
var throttle = __webpack_require__(23493);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _styled__default = /*#__PURE__*/_interopDefaultLegacy(_styled);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var querystring__default = /*#__PURE__*/_interopDefaultLegacy(querystring);
var _debounce__default = /*#__PURE__*/_interopDefaultLegacy(_debounce);
var isEqual__default = /*#__PURE__*/_interopDefaultLegacy(isEqual);
var findLastKey__default = /*#__PURE__*/_interopDefaultLegacy(findLastKey);
var omit__default = /*#__PURE__*/_interopDefaultLegacy(omit);
var findLast__default = /*#__PURE__*/_interopDefaultLegacy(findLast);
var size__default = /*#__PURE__*/_interopDefaultLegacy(size);
var throttle__default = /*#__PURE__*/_interopDefaultLegacy(throttle);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function () {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) keys.push(key);

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function pxToRem(px) {
  return "".concat(px, "px");
}
function safeAreaInset(direction, cssProp) {
  return "\n    ".concat(cssProp, ": constant(safe-area-inset-").concat(direction, ");\n    ").concat(cssProp, ": env(safe-area-inset-").concat(direction, ");\n  ");
}
var BREAK_POINT_NAMES = ['mobile', 'tablet', 'laptop', 'desktop'];
var BREAK_POINT = {
  mobile: 0,
  tablet: 768,
  laptop: 1024,
  desktop: 1256
};
var MEDIA_QUERY = {
  min: function min(breakPoint, arg) {
    return /*#__PURE__*/react.css("@media (min-width: ", BREAK_POINT[breakPoint], "px){", arg, ";}");
  },
  max: function max(breakPoint, arg) {
    var nextValue = BREAK_POINT[BREAK_POINT_NAMES[BREAK_POINT_NAMES.indexOf(breakPoint) + 1]];

    if (nextValue == null) {
      return /*#__PURE__*/react.css(arg, ";");
    }

    return /*#__PURE__*/react.css("@media (max-width: ", nextValue - 1, "px){", arg, ";}");
  },
  only: function only(breakPoint, arg) {
    var nextValue = BREAK_POINT[BREAK_POINT_NAMES[BREAK_POINT_NAMES.indexOf(breakPoint) + 1]];

    if (nextValue == null) {
      return MEDIA_QUERY.min(breakPoint, arg);
    }

    if (BREAK_POINT[breakPoint] === 0) {
      return MEDIA_QUERY.max(breakPoint, arg);
    }

    return /*#__PURE__*/react.css("@media (min-width: ", BREAK_POINT[breakPoint], "px) and (max-width: ", nextValue - 1, "px){", arg, ";}");
  }
};

var FONT_STYLE = {
  largeTitle: /*#__PURE__*/react.css("font-size:", pxToRem(32), ";line-height:", pxToRem(42), ";"),
  title1: /*#__PURE__*/react.css("font-size:", pxToRem(24), ";line-height:", pxToRem(32), ";"),
  title2: /*#__PURE__*/react.css("font-size:", pxToRem(20), ";line-height:", pxToRem(28), ";"),
  title3: /*#__PURE__*/react.css("font-size:", pxToRem(18), ";line-height:", pxToRem(24), ";"),
  title4: /*#__PURE__*/react.css("font-size:", pxToRem(17), ";line-height:", pxToRem(26), ";"),
  subTitle1: /*#__PURE__*/react.css("font-size:", pxToRem(16), ";line-height:", pxToRem(20), ";"),
  subTitle2: /*#__PURE__*/react.css("font-size:", pxToRem(14), ";line-height:", pxToRem(18), ";"),
  body1_1: /*#__PURE__*/react.css("font-size:", pxToRem(16), ";line-height:", pxToRem(24), ";"),
  body1_2: /*#__PURE__*/react.css("font-size:", pxToRem(16), ";line-height:", pxToRem(28), ";"),
  body1_3: /*#__PURE__*/react.css("font-size:", pxToRem(16), ";line-height:", pxToRem(32), ";"),
  body1_small: /*#__PURE__*/react.css("font-size:", pxToRem(15), ";line-height:", pxToRem(24), ";"),
  body2: /*#__PURE__*/react.css("font-size:", pxToRem(14), ";line-height:", pxToRem(20), ";"),
  body2_small: /*#__PURE__*/react.css("font-size:", pxToRem(13), ";line-height:", pxToRem(18), ";"),
  body3: /*#__PURE__*/react.css("font-size:", pxToRem(12), ";line-height:", pxToRem(20), ";"),
  caption1: /*#__PURE__*/react.css("font-size:", pxToRem(12), ";line-height:", pxToRem(16), ";"),
  caption1_small: /*#__PURE__*/react.css("font-size:", pxToRem(11), ";line-height:", pxToRem(14), ";"),
  caption2: /*#__PURE__*/react.css("font-size:", pxToRem(10), ";line-height:", pxToRem(14), ";")
};

var PALETTE = {
  white: '#FFFFFF',
  black: '#000000',
  transparent: 'transparent',
  skyblue5: '#EFFBFF',
  skyblue10: '#E5F8FF',
  skyblue20: '#C7EFFB',
  skyblue30: '#AEE7F8',
  skyblue40: '#77D7F4',
  skyblue50: '#35C5F0',
  skyblue60: '#009FCE',
  skyblue70: '#0080A3',
  skyblue80: '#005364',
  skyblue90: '#003640',
  red5: '#FFF7F7',
  red10: '#FFEDED',
  red20: '#FFD9D9',
  red30: '#FFB2B2',
  red40: '#FF9494',
  red50: '#FF7777',
  red60: '#F05656',
  red70: '#DB3D3D',
  red80: '#552222',
  red90: '#331818',
  blue5: '#E3F3FD',
  blue10: '#C5E4FD',
  blue20: '#70BFFD',
  blue30: '#1494FD',
  blue40: '#0987DC',
  blue50: '#0987D1',
  blue60: '#09609C',
  blue70: '#004E83',
  blue80: '#003D63',
  blue90: '#002F43',
  indigo5: '#F7FAFF',
  indigo10: '#D9E6FF',
  indigo20: '#BDD4FF',
  indigo30: '#87B1FF',
  indigo40: '#6391E6',
  indigo50: '#4F78C2',
  indigo60: '#4566A3',
  indigo70: '#37507D',
  indigo80: '#22314D',
  indigo90: '#192438',
  gray5: '#F7F9FA',
  gray7: '#F4F7F8',
  gray10: '#EAEDEF',
  gray20: '#DADDE0',
  gray30: '#C2C8CC',
  gray40: '#A4ADB3',
  gray50: '#828C94',
  gray60: '#656E75',
  gray70: '#525B61',
  gray80: '#3F474D',
  gray90: '#2F3438',
  gray100: '#212629',
  gray110: '#131517',
  elevation0: '#0B0C0E',
  elevation10: '#17181A',
  elevation20: '#1C1D1F',
  elevation30: '#1F1F21',
  elevation40: '#212224',
  elevation50: '#262729',
  elevation60: '#28292B',
  elevation70: '#2D2E30',
  elevation80: '#303032',
  elevation90: '#323335',
  elevation100: '#3C3D3E'
};

function rgba(r, g, b, a) {
  return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(a, ")");
}
function hexToRgba(hex, opacity) {
  var r = parseInt(hex.slice(1, 3), 16);
  var g = parseInt(hex.slice(3, 5), 16);
  var b = parseInt(hex.slice(5, 7), 16);
  return rgba(r, g, b, opacity);
}
var LIGHT_THEME = {
  background: {
    base: PALETTE.white,
    groupedBase: PALETTE.gray5,
    groupedContents: PALETTE.white,
    elevated: PALETTE.white
  },
  layer: {
    dark: PALETTE.gray90,
    light: PALETTE.white
  },
  divider: PALETTE.gray10,
  dim: {
    thick: hexToRgba(PALETTE.gray100, 0.8),
    basic: hexToRgba(PALETTE.gray100, 0.5),
    thin: hexToRgba(PALETTE.gray100, 0.15),
    disabled: hexToRgba(PALETTE.gray60, 0.75),
    thumbnail: hexToRgba(PALETTE.gray100, 0.05),
    onDark: {
      thick: hexToRgba(PALETTE.white, 0.7),
      basic: hexToRgba(PALETTE.white, 0.5),
      thin: hexToRgba(PALETTE.white, 0.15)
    }
  },
  content: {
    base0: PALETTE.black,
    base1: PALETTE.gray90,
    base2: PALETTE.gray50,
    base3: PALETTE.gray30,
    base4: PALETTE.gray10,
    base4Second: PALETTE.gray7,
    base5: PALETTE.gray5,
    base6: PALETTE.white,
    white: PALETTE.white,
    primary1: {
      thick: PALETTE.skyblue60,
      basic: PALETTE.skyblue50,
      thin: PALETTE.skyblue5
    },
    primary2: {
      thick: PALETTE.red60,
      basic: PALETTE.red50,
      thin: PALETTE.red10
    },
    primary3: {
      thick: PALETTE.blue70,
      basic: PALETTE.blue60,
      thin: PALETTE.blue5
    },
    primary4: {
      thick: PALETTE.indigo70,
      basic: PALETTE.indigo40,
      thin: PALETTE.indigo5
    }
  },
  shadow: {
    thick: hexToRgba(PALETTE.gray80, 0.25),
    basic: hexToRgba(PALETTE.gray80, 0.15),
    thin: hexToRgba(PALETTE.gray80, 0.05)
  },
  interactive: {
    primary1: {
      thick: PALETTE.skyblue80,
      basic: PALETTE.skyblue60,
      thin: PALETTE.skyblue10,
      transparent: PALETTE.skyblue5
    },
    primary2: {
      thick: PALETTE.red70,
      basic: PALETTE.red60,
      thin: PALETTE.red20,
      transparent: PALETTE.red10
    },
    primary3: {
      thick: PALETTE.blue80,
      basic: PALETTE.blue70,
      thin: PALETTE.blue10,
      transparent: PALETTE.blue5
    },
    primary4: {
      thick: PALETTE.indigo80,
      basic: PALETTE.indigo50,
      thin: PALETTE.indigo20,
      transparent: PALETTE.indigo5
    },
    transparent: PALETTE.gray5,
    onDark: hexToRgba(PALETTE.white, 0.1),
    base1: PALETTE.gray100,
    base2: PALETTE.gray60,
    base3: PALETTE.gray40,
    base4: PALETTE.gray20,
    base5: PALETTE.gray10,
    dim: {
      thick: hexToRgba(PALETTE.gray100, 0.9)
    }
  },
  outline: hexToRgba(PALETTE.black, 0.08),
  border: PALETTE.gray20
};
var DARK_THEME = {
  background: {
    base: PALETTE.elevation10,
    groupedBase: PALETTE.elevation0,
    groupedContents: PALETTE.elevation10,
    elevated: PALETTE.elevation50
  },
  layer: {
    dark: PALETTE.gray80,
    light: PALETTE.gray80
  },
  divider: PALETTE.gray30,
  dim: {
    thick: hexToRgba(PALETTE.black, 0.75),
    basic: hexToRgba(PALETTE.black, 0.5),
    thin: hexToRgba(PALETTE.black, 0.15),
    disabled: hexToRgba(PALETTE.gray60, 0.75),
    thumbnail: PALETTE.black,
    onDark: {
      thick: hexToRgba(PALETTE.white, 0.65),
      basic: hexToRgba(PALETTE.white, 0.5),
      thin: hexToRgba(PALETTE.white, 0.15)
    }
  },
  content: {
    base0: PALETTE.white,
    base1: PALETTE.gray5,
    base2: PALETTE.gray30,
    base3: PALETTE.gray50,
    base4: PALETTE.gray80,
    base4Second: PALETTE.gray90,
    base5: PALETTE.gray100,
    base6: PALETTE.gray110,
    white: PALETTE.gray5,
    primary1: {
      thick: PALETTE.skyblue30,
      basic: PALETTE.skyblue60,
      thin: PALETTE.skyblue90
    },
    primary2: {
      thick: PALETTE.red50,
      basic: PALETTE.red60,
      thin: PALETTE.red90
    },
    primary3: {
      thick: PALETTE.blue10,
      basic: PALETTE.blue50,
      thin: PALETTE.blue90
    },
    primary4: {
      thick: PALETTE.indigo40,
      basic: PALETTE.indigo70,
      thin: PALETTE.indigo90
    }
  },
  shadow: {
    thick: PALETTE.transparent,
    basic: PALETTE.transparent,
    thin: PALETTE.transparent
  },
  interactive: {
    primary1: {
      thick: PALETTE.skyblue20,
      basic: PALETTE.skyblue50,
      thin: PALETTE.skyblue80,
      transparent: PALETTE.skyblue90
    },
    primary2: {
      thick: PALETTE.red40,
      basic: PALETTE.red50,
      thin: PALETTE.red80,
      transparent: PALETTE.red90
    },
    primary3: {
      thick: PALETTE.blue5,
      basic: PALETTE.blue30,
      thin: PALETTE.blue80,
      transparent: PALETTE.blue90
    },
    primary4: {
      thick: PALETTE.indigo30,
      basic: PALETTE.indigo60,
      thin: PALETTE.indigo80,
      transparent: PALETTE.indigo90
    },
    transparent: PALETTE.gray90,
    onDark: hexToRgba(PALETTE.white, 0.1),
    base1: PALETTE.white,
    base2: PALETTE.gray20,
    base3: PALETTE.gray40,
    base4: PALETTE.gray90,
    base5: PALETTE.gray90,
    dim: {
      thick: hexToRgba(PALETTE.black, 0.55)
    }
  },
  outline: hexToRgba(PALETTE.white, 0.12),
  border: PALETTE.gray60
};

function cssBaseBadge(theme, props) {
  return /*#__PURE__*/react.css(cssBadgeVariant$1(theme, props), " display:inline-block;font-weight:700;height:", pxToRem(props.size), ";line-height:", pxToRem(props.size), ";");
}

function cssBadgeVariant$1(theme, props) {
  if (props.disabled) {
    return cssDisabledBadge(theme, props.variant);
  }

  switch (props.type) {
    case 'fill':
      return cssFillBadge(theme, props.variant);

    case 'weak':
      return cssWeakBadge(theme, props.variant);
  }
}

function cssDisabledBadge(theme, variant) {
  switch (variant) {
    case 'dim':
      return /*#__PURE__*/react.css("color:", theme.content.base2, ";background-color:", theme.dim.disabled, ";");

    case 'base2Outline':
      return /*#__PURE__*/react.css("color:", theme.content.base3, ";background-color:", hexToRgba(theme.content.base5, 0.7), ";border:", pxToRem(1), " solid ", theme.outline, ";");

    default:
      return /*#__PURE__*/react.css("color:", theme.content.base3, ";background-color:", theme.content.base4, ";");
  }
}

function cssFillBadge(theme, variant) {
  switch (variant) {
    case 'dim':
      return /*#__PURE__*/react.css("color:", theme.content.white, ";background-color:", theme.dim.thick, ";");

    case 'base2':
      return /*#__PURE__*/react.css("color:", theme.content.base6, ";background-color:", theme.content.base2, ";");

    case 'primary1':
    case 'primary2':
    case 'primary3':
    case 'primary4':
      return /*#__PURE__*/react.css("color:", theme.content.white, ";background-color:", theme.content[variant].basic, ";");
  }
}

function cssWeakBadge(theme, variant) {
  switch (variant) {
    case 'base2Outline':
      return /*#__PURE__*/react.css("color:", theme.content.base2, ";background-color:", hexToRgba(theme.content.base6, 0.7), ";border:", pxToRem(1), " solid ", theme.outline, ";");

    case 'primary1':
    case 'primary3':
      return /*#__PURE__*/react.css("color:", theme.content[variant].basic, ";background-color:", theme.content[variant].thin, ";");

    case 'primary2':
    case 'primary4':
      return /*#__PURE__*/react.css("color:", theme.content[variant].thick, ";background-color:", theme.content[variant].thin, ";");

    case 'base2':
      return /*#__PURE__*/react.css("color:", theme.content.base2, ";background-color:", theme.content.base4, ";");
  }
}

var _excluded$1t = ["size", "children"];

function cssSize$6(size) {
  switch (size) {
    case 16:
      return /*#__PURE__*/react.css(FONT_STYLE.caption2, " padding:0 ", pxToRem(4), ";");

    case 20:
      return /*#__PURE__*/react.css(FONT_STYLE.caption2, " padding:0 ", pxToRem(6), ";");

    case 24:
      return /*#__PURE__*/react.css(FONT_STYLE.caption1, " padding:0 ", pxToRem(6), ";");

    case 28:
      return /*#__PURE__*/react.css(FONT_STYLE.subTitle1, " padding:0 ", pxToRem(8), ";");
  }
}

function SquareBadge(props) {
  var size = props.size,
      children = props.children,
      rest = _objectWithoutProperties(props, _excluded$1t);

  var theme = react.useTheme();
  return react.jsx("span", _extends({}, rest, {
    css: [cssSize$6(size), cssBaseBadge(theme, props), /*#__PURE__*/react.css("border-radius:", pxToRem(4), ";")]
  }), children);
}

var _excluded$1s = ["size", "children"];

function cssSize$5(size) {
  switch (size) {
    case 16:
      return /*#__PURE__*/react.css(FONT_STYLE.caption2, " padding:0 ", pxToRem(6), ";border-radius:", pxToRem(9), ";");

    case 20:
      return /*#__PURE__*/react.css(FONT_STYLE.caption1, " padding:0 ", pxToRem(6), ";border-radius:", pxToRem(10), ";");

    case 24:
      return /*#__PURE__*/react.css(FONT_STYLE.body3, " padding:0 ", pxToRem(8), ";border-radius:", pxToRem(12), ";");
  }
}

function PillBadge(props) {
  var size = props.size,
      children = props.children,
      rest = _objectWithoutProperties(props, _excluded$1s);

  var theme = react.useTheme();
  return react.jsx("span", _extends({}, rest, {
    css: [cssSize$5(size), cssBaseBadge(theme, props)]
  }), children);
}

var _excluded$1r = ["size", "children"];

function cssSize$4(size) {
  switch (size) {
    case 16:
      return /*#__PURE__*/react.css(FONT_STYLE.caption2, " padding:0 ", pxToRem(5), ";");

    case 20:
      return /*#__PURE__*/react.css(FONT_STYLE.caption2, " padding:0 ", pxToRem(7), ";");

    case 24:
      return /*#__PURE__*/react.css(FONT_STYLE.caption1, " padding:0 ", pxToRem(8), ";");
  }
}

function CircleBadge(props) {
  var size = props.size,
      children = props.children,
      rest = _objectWithoutProperties(props, _excluded$1r);

  var theme = react.useTheme();
  return react.jsx("span", _extends({}, rest, {
    css: [cssSize$4(size), cssBaseBadge(theme, props), /*#__PURE__*/react.css("border-radius:", pxToRem(size / 2), ";")]
  }), children);
}

/**
 * @author TroyTae
 * @version 1.3.8
 * @license MIT
 * @name one-spaces
 */
function n(r) {
  for (var t, e = 0, o = ""; e < r.length;) (t = r[e++]) && (t.pop && !(t = n(t)) || (o && (o += " "), o += t));

  return o;
}

function spaces () {
  return n(arguments);
}

var _excluded$1q = ["fill", "name", "size", "className"];
function Icon(_ref) {
  var fill = _ref.fill,
      name = _ref.name,
      size = _ref.size,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded$1q);

  var theme = react.useTheme();
  return react.jsx("span", _extends({}, rest, {
    css: [/*#__PURE__*/react.css("display:inline-block;font-size:", pxToRem(size), ";line-height:1;&::before{font-family:OhouseIcon;vertical-align:top;}"), fill && /*#__PURE__*/react.css("color:", fill(theme), ";")],
    className: spaces(className, "_".concat(name, "_").concat(size))
  }));
}

var RESET_BUTTON = "\n  display: inline-block;\n  margin: 0;\n  padding: 0;\n  border: none;\n  background: none;\n  font: inherit;\n";
var RESET_INPUT = "\n  display: inline-block;\n  margin: 0;\n  padding: 0;\n  border: none;\n  background: none;\n  font: inherit;\n";

var _excluded$1p = ["text", "isActive"];
function Crumb(_ref) {
  var text = _ref.text,
      isActive = _ref.isActive,
      rest = _objectWithoutProperties(_ref, _excluded$1p);

  var theme = react.useTheme();
  return react.jsx("button", _extends({
    type: "button"
  }, rest, {
    css: /*#__PURE__*/react.css(RESET_BUTTON, " font:inherit;vertical-align:top;color:", isActive ? theme.content.base1 : theme.content.base2, ";")
  }), text);
}

var _excluded$1o = ["activeIndex", "onChangeIndex", "crumbs"],
    _excluded2$5 = ["text"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$15() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$13 =  true ? {
  name: "1v7jawo",
  styles: "overflow-x:auto;white-space:nowrap"
} : 0;

function Breadcrumb(_ref2) {
  var activeIndex = _ref2.activeIndex,
      onChangeIndex = _ref2.onChangeIndex,
      crumbs = _ref2.crumbs,
      rest = _objectWithoutProperties(_ref2, _excluded$1o);

  var theme = react.useTheme();
  return react.jsx("nav", _extends({}, rest, {
    css: [FONT_STYLE.subTitle2, _ref$13]
  }), crumbs.map(function (_ref3, index) {
    var text = _ref3.text,
        rest = _objectWithoutProperties(_ref3, _excluded2$5);

    return react.jsx(React.Fragment, {
      key: text
    }, react.jsx(Crumb, _extends({}, rest, {
      text: text,
      isActive: index === activeIndex,
      onClick: function onClick() {
        return onChangeIndex(index);
      }
    })), index + 1 < crumbs.length && react.jsx(Icon, {
      size: 18,
      name: "chevron_right",
      css: /*#__PURE__*/react.css("vertical-align:top;margin:0 ", pxToRem(4), ";color:", theme.content.base2, ";")
    }));
  }));
}

function HOVER(template) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  // NOTE: I'm unable to use MEDIA_QUERY.min here because it must consume
  // SerializedStyles to allow emotion's selectors to propagate.
  return /*#__PURE__*/react.css("&.focus-visible:focus{", /*#__PURE__*/react.css.apply(void 0, [template].concat(args)), ";}@media (min-width: ", BREAK_POINT.tablet, "px){&:hover,&:active{", /*#__PURE__*/react.css.apply(void 0, [template].concat(args)), ";}}");
}
function FOCUS(template) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return /*#__PURE__*/react.css("&::-moz-focus-inner{border:0;}&.focus-visible:focus,&:focus-visible{", /*#__PURE__*/react.css.apply(void 0, [template].concat(args)), ";}");
}

var _excluded$1n = ["id", "onClick", "forwardedRef", "className", "size", "full", "disabled", "children"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$14() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function getWithIconOptions(size, iconSize) {
  return {
    gap: {
      32: 4,
      40: 6,
      44: 6,
      50: 6
    }[size],
    iconSize: iconSize !== null && iconSize !== void 0 ? iconSize : 18
  };
}
function cssBaseButton(size, full) {
  return /*#__PURE__*/react.css(RESET_BUTTON, " ", {
    32: FONT_STYLE.body2,
    40: FONT_STYLE.subTitle2,
    44: FONT_STYLE.subTitle2,
    50: FONT_STYLE.subTitle1
  }[size], " display:inline-flex;justify-content:center;align-items:center;width:", full ? '100%' : 'auto', ";height:", pxToRem(size), ";border-radius:", pxToRem(4), ";padding:0 ", pxToRem(size === 32 ? 8 : 16), ";font-weight:", size === 50 ? 700 : 400, ";box-sizing:border-box;text-align:center;");
}

var _ref$12 =  true ? {
  name: "ebd3ti",
  styles: "position:absolute;top:0;left:0;width:0;height:0;opacity:0"
} : 0;

var _ref2$n =  true ? {
  name: "1989ovb",
  styles: "vertical-align:middle"
} : 0;

var _ref3$7 =  true ? {
  name: "1azakc",
  styles: "text-align:center"
} : 0;

var _ref4$4 =  true ? {
  name: "11408bl",
  styles: "cursor:pointer;position:relative"
} : 0;

function FileInputLabel(_ref5) {
  var id = _ref5.id,
      _onClick = _ref5.onClick,
      forwardedRef = _ref5.forwardedRef,
      className = _ref5.className,
      size = _ref5.size,
      full = _ref5.full,
      disabled = _ref5.disabled,
      children = _ref5.children,
      rest = _objectWithoutProperties(_ref5, _excluded$1n);

  return react.jsx("label", {
    className: className,
    htmlFor: id,
    css: [cssBaseButton(size, full), _ref4$4, full && _ref3$7]
  }, react.jsx("span", {
    css: _ref2$n
  }, children), react.jsx("input", _extends({}, rest, {
    id: id,
    ref: forwardedRef,
    type: "file",
    css: _ref$12,
    onClick: function onClick(e) {
      if (disabled) {
        e.preventDefault();
      }

      if (_onClick) {
        _onClick(e);
      }
    }
  })));
}

var _excluded$1m = ["forwardedRef", "full", "size", "variant", "disabled", "children"],
    _excluded2$4 = ["forwardedRef", "full", "size", "variant", "children", "disabled"],
    _excluded3$3 = ["full", "size", "variant", "disabled"];

var _templateObject$l, _templateObject2$e, _templateObject3$4;

function cssDisabled$1(theme, variant) {
  switch (variant) {
    case 'dim':
      return /*#__PURE__*/react.css("color:", theme.content.base2, ";background-color:", theme.dim.disabled, ";pointer-events:none;");

    case 'primary1':
    case 'primary2':
    case 'primary3':
    case 'base1':
      return /*#__PURE__*/react.css("color:", theme.content.base3, ";background-color:", theme.content.base4, ";pointer-events:none;");
  }
}

function cssVariant$8(theme, variant) {
  switch (variant) {
    case 'primary1':
    case 'primary2':
    case 'primary3':
      return /*#__PURE__*/react.css("color:", theme.content.white, ";background-color:", theme.content[variant].basic, ";", HOVER(_templateObject$l || (_templateObject$l = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "])), theme.interactive[variant].basic), ";");

    case 'base1':
      return /*#__PURE__*/react.css("color:", theme.content.base6, ";background-color:", theme.content.base1, ";", HOVER(_templateObject2$e || (_templateObject2$e = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "])), theme.interactive.base1), ";");

    case 'dim':
      return /*#__PURE__*/react.css("color:", theme.content.white, ";background-color:", theme.dim.thick, ";", HOVER(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "])), theme.interactive.dim.thick), ";");
  }
}

function Button$1(_ref) {
  var forwardedRef = _ref.forwardedRef,
      full = _ref.full,
      size = _ref.size,
      variant = _ref.variant,
      disabled = _ref.disabled,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded$1m);

  var theme = react.useTheme();
  return react.jsx("button", _extends({}, rest, {
    ref: forwardedRef,
    disabled: disabled,
    css: [cssBaseButton(size, full), (disabled ? cssDisabled$1 : cssVariant$8)(theme, variant)]
  }), children);
}
function AnchorButton(_ref2) {
  var forwardedRef = _ref2.forwardedRef,
      full = _ref2.full,
      size = _ref2.size,
      variant = _ref2.variant,
      children = _ref2.children,
      disabled = _ref2.disabled,
      rest = _objectWithoutProperties(_ref2, _excluded2$4);

  var theme = react.useTheme();
  return react.jsx("a", _extends({}, rest, {
    ref: forwardedRef,
    css: [cssBaseButton(size, full), (disabled ? cssDisabled$1 : cssVariant$8)(theme, variant)]
  }), children);
}
function FileButton(_ref3) {
  var full = _ref3.full,
      size = _ref3.size,
      variant = _ref3.variant,
      disabled = _ref3.disabled,
      rest = _objectWithoutProperties(_ref3, _excluded3$3);

  var theme = react.useTheme();
  return react.jsx(FileInputLabel, _extends({}, rest, {
    size: size,
    full: full,
    disabled: disabled,
    css: (disabled ? cssDisabled$1 : cssVariant$8)(theme, variant)
  }));
}

var _excluded$1l = ["text", "icon", "isTrailing"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$13() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$11 =  true ? {
  name: "1989ovb",
  styles: "vertical-align:middle"
} : 0;

function MiddleIcon(props) {
  return react.jsx(Icon, _extends({}, props, {
    css: _ref$11
  }));
}

function withIcon(Component, getOptions) {
  return function (_ref2) {
    var text = _ref2.text,
        icon = _ref2.icon,
        isTrailing = _ref2.isTrailing,
        rest = _objectWithoutProperties(_ref2, _excluded$1l);

    var _getOptions = getOptions(rest),
        gap = _getOptions.gap,
        iconSize = _getOptions.iconSize;

    var middleIcon = react.jsx(MiddleIcon, {
      name: icon,
      size: iconSize
    });

    return react.jsx(Component, rest, !isTrailing && middleIcon, react.jsx("span", {
      css: /*#__PURE__*/react.css("vertical-align:middle;margin-", isTrailing ? 'right' : 'left', ":", pxToRem(gap), ";")
    }, text), isTrailing && middleIcon);
  };
}

var ButtonWithIcon = withIcon(Button$1, function (_ref) {
  var size = _ref.size,
      iconSize = _ref.iconSize;
  return getWithIconOptions(size, iconSize);
});
var AnchorButtonWithIcon = withIcon(AnchorButton, function (_ref2) {
  var size = _ref2.size,
      iconSize = _ref2.iconSize;
  return getWithIconOptions(size, iconSize);
});
var FileButtonWithIcon = withIcon(FileButton, function (_ref3) {
  var size = _ref3.size,
      iconSize = _ref3.iconSize;
  return getWithIconOptions(size, iconSize);
});

var _excluded$1k = ["forwardedRef", "full", "size", "variant", "disabled", "children", "filled"],
    _excluded2$3 = ["forwardedRef", "full", "size", "variant", "children", "disabled", "filled"],
    _excluded3$2 = ["full", "size", "variant", "disabled", "filled"];

function cssVariant$7(theme, variant, filled) {
  switch (variant) {
    case 'primary1':
    case 'primary2':
    case 'primary3':
      return /*#__PURE__*/react.css("color:", theme.content[variant].basic, ";border:", pxToRem(1), " solid ", theme.content[variant].basic, ";", filled && /*#__PURE__*/react.css("background-color:", theme.content.base6, ";"), " &:hover,&:active{background-color:", theme.interactive[variant].transparent, ";}");

    case 'base1':
      return /*#__PURE__*/react.css("color:", theme.content.base1, ";border:", pxToRem(1), " solid ", theme.border, ";", filled && /*#__PURE__*/react.css("background-color:", theme.content.base6, ";"), " &:hover,&:active{background-color:", theme.interactive.transparent, ";}");

    case 'onDark':
      return /*#__PURE__*/react.css("color:", theme.content.white, ";border:", pxToRem(1), " solid ", theme.content.white, ";", filled && /*#__PURE__*/react.css("background-color:", theme.dim.thin, ";"), " &:hover,&:active{background-color:", theme.interactive.onDark, ";}");
  }
}

function cssDisabled(theme) {
  return /*#__PURE__*/react.css("color:", theme.content.base3, ";border:", pxToRem(1), " solid ", theme.content.base4, ";background-color:", theme.content.base5, ";");
}

function OutlineButton(_ref) {
  var forwardedRef = _ref.forwardedRef,
      full = _ref.full,
      size = _ref.size,
      variant = _ref.variant,
      disabled = _ref.disabled,
      children = _ref.children,
      _ref$filled = _ref.filled,
      filled = _ref$filled === void 0 ? false : _ref$filled,
      rest = _objectWithoutProperties(_ref, _excluded$1k);

  var theme = react.useTheme();
  return react.jsx("button", _extends({}, rest, {
    ref: forwardedRef,
    disabled: disabled,
    css: [cssBaseButton(size, full), disabled ? cssDisabled(theme) : cssVariant$7(theme, variant, filled)]
  }), children);
}
function OutlineAnchorButton(_ref2) {
  var forwardedRef = _ref2.forwardedRef,
      full = _ref2.full,
      size = _ref2.size,
      variant = _ref2.variant,
      children = _ref2.children,
      disabled = _ref2.disabled,
      _ref2$filled = _ref2.filled,
      filled = _ref2$filled === void 0 ? false : _ref2$filled,
      rest = _objectWithoutProperties(_ref2, _excluded2$3);

  var theme = react.useTheme();
  return react.jsx("a", _extends({}, rest, {
    ref: forwardedRef,
    css: [cssBaseButton(size, full), disabled ? cssDisabled(theme) : cssVariant$7(theme, variant, filled)]
  }), children);
}
function OutlineFileButton(_ref3) {
  var full = _ref3.full,
      size = _ref3.size,
      variant = _ref3.variant,
      disabled = _ref3.disabled,
      _ref3$filled = _ref3.filled,
      filled = _ref3$filled === void 0 ? false : _ref3$filled,
      rest = _objectWithoutProperties(_ref3, _excluded3$2);

  var theme = react.useTheme();
  return react.jsx(FileInputLabel, _extends({}, rest, {
    size: size,
    full: full,
    disabled: disabled,
    css: disabled ? cssDisabled(theme) : cssVariant$7(theme, variant, filled)
  }));
}

var OutlineButtonWithIcon = withIcon(OutlineButton, function (_ref) {
  var size = _ref.size,
      iconSize = _ref.iconSize;
  return getWithIconOptions(size, iconSize);
});
var OutlineAnchorButtonWithIcon = withIcon(OutlineAnchorButton, function (_ref2) {
  var size = _ref2.size,
      iconSize = _ref2.iconSize;
  return getWithIconOptions(size, iconSize);
});
var OutlineFileButtonWithIcon = withIcon(OutlineFileButton, function (_ref3) {
  var size = _ref3.size,
      iconSize = _ref3.iconSize;
  return getWithIconOptions(size, iconSize);
});

var _excluded$1j = ["forwardedRef", "error", "disabled", "grid", "size", "variant", "options", "onChange"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$12() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

function cssVariant$6(theme, checked, variant) {
  if (checked) {
    switch (variant) {
      case 'primary1':
      case 'primary3':
        return /*#__PURE__*/react.css("color:", theme.content[variant].basic, ";border-color:", theme.content[variant].basic, ";&:hover,&:active{background-color:", theme.interactive[variant].transparent, ";}");

      case 'primary2':
      case 'primary4':
        return /*#__PURE__*/react.css("color:", theme.content[variant].thick, ";border-color:", theme.content[variant].thick, ";&:hover,&:active{background-color:", theme.interactive[variant].transparent, ";}");
    }
  }

  return /*#__PURE__*/react.css("color:", theme.content.base2, ";border-color:", theme.border, ";&:hover,&:active{background-color:", theme.interactive.transparent, ";}");
}

var _ref$10 =  true ? {
  name: "d3v9zr",
  styles: "overflow:hidden"
} : 0;

function SelectButton(_ref2) {
  var forwardedRef = _ref2.forwardedRef,
      error = _ref2.error,
      disabled = _ref2.disabled,
      grid = _ref2.grid,
      size = _ref2.size,
      variant = _ref2.variant,
      options = _ref2.options,
      onChange = _ref2.onChange,
      rest = _objectWithoutProperties(_ref2, _excluded$1j);

  var theme = react.useTheme();

  var getMsGridColums = function getMsGridColums(grid) {
    if (grid === 1) return '1fr';
    return new Array(grid).fill('1fr').join(" ".concat(pxToRem(6), " "));
  };

  var getMsGridRows = function getMsGridRows(grid, buttonCount) {
    return new Array(Math.ceil(buttonCount / grid)).fill('1fr').join(" ".concat(pxToRem(6), " "));
  };

  return react.jsx("div", _extends({}, rest, {
    css: _ref$10
  }), react.jsx("div", {
    css: /*#__PURE__*/react.css("display:grid;grid-template-columns:repeat(", grid, ", 1fr);grid-gap:", pxToRem(6), ";display:-ms-grid;-ms-grid-columns:", getMsGridColums(grid), ";-ms-grid-columns:", getMsGridRows(grid, options.length), ";")
  }, options.map(function (option) {
    return _objectSpread2(_objectSpread2({}, option), {}, {
      disabled: option.disabled || disabled
    });
  }).map(function (_ref3, index) {
    var text = _ref3.text,
        checked = _ref3.checked,
        disabled = _ref3.disabled;
    return react.jsx("div", {
      key: text,
      css: /*#__PURE__*/react.css("display:inline-block;vertical-align:top;-ms-grid-column:", Math.floor(index % grid) * 2 + 1, ";-ms-grid-row:", Math.floor(index / grid) * 2 + 1, ";")
    }, react.jsx("button", {
      type: "button",
      disabled: disabled,
      ref: index === 0 ? forwardedRef : null,
      css: [cssBaseButton(size), disabled ? /*#__PURE__*/react.css("color:", theme.content.base3, ";border-color:", theme.content.base4, ";background-color:", theme.content.base5, ";") : cssVariant$6(theme, checked, variant), /*#__PURE__*/react.css("width:100%;border-width:", pxToRem(1), ";border-style:solid;font-weight:", checked ? 700 : 400, ";"), error && /*#__PURE__*/react.css("border-color:", theme.content.primary2.basic, ";")],
      onClick: function onClick() {
        return onChange(index, !checked);
      }
    }, text));
  })));
}

var InactiveScrapIcon24 = function InactiveScrapIcon24(props) {
  return react.jsx("svg", props, react.jsx("g", {
    clipPath: "url(#clip0_15409_67579)"
  }, react.jsx("g", {
    filter: "url(#filter0_d_15409_67579)"
  }, react.jsx("path", {
    d: "M4.3 4.05V19.4992L10.9309 16.018C11.6003 15.6666 12.3997 15.6666 13.0691 16.018L19.7 19.4992V4.05H4.3ZM4 2.75H20C20.5523 2.75 21 3.19772 21 3.75V20.8228C21 21.1988 20.6005 21.4403 20.2676 21.2655L12.4648 17.169C12.1738 17.0162 11.8262 17.0162 11.5352 17.169L3.73242 21.2655C3.39948 21.4403 3 21.1988 3 20.8228V3.75C3 3.19771 3.44772 2.75 4 2.75Z",
    fill: "white"
  }), react.jsx("path", {
    d: "M4.3 4.05V19.4992L10.9309 16.018C11.6003 15.6666 12.3997 15.6666 13.0691 16.018L19.7 19.4992V4.05H4.3Z",
    fill: "white",
    fillOpacity: "0.5"
  }))), react.jsx("defs", null, react.jsx("filter", {
    id: "filter0_d_15409_67579",
    x: "-2",
    y: "-0.25",
    width: "28",
    height: "28.5735",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, react.jsx("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), react.jsx("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), react.jsx("feOffset", {
    dy: "2"
  }), react.jsx("feGaussianBlur", {
    stdDeviation: "2.5"
  }), react.jsx("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.247059 0 0 0 0 0.278431 0 0 0 0 0.301961 0 0 0 0.15 0"
  }), react.jsx("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15409_67579"
  }), react.jsx("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_15409_67579",
    result: "shape"
  })), react.jsx("clipPath", {
    id: "clip0_15409_67579"
  }, react.jsx("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};

InactiveScrapIcon24.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var InactiveScrapIcon32 = function InactiveScrapIcon32(props) {
  return react.jsx("svg", props, react.jsx("g", {
    clipPath: "url(#clip0_15409_67578)"
  }, react.jsx("g", {
    filter: "url(#filter0_d_15409_67578)"
  }, react.jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.3 5.3V26.8492L14.8356 21.843C15.5051 21.4916 16.3045 21.4916 16.9739 21.843L26.5095 26.8492V5.3H5.3ZM5 4C4.44772 4 4 4.44772 4 5V28.1728C4 28.5488 4.39948 28.7903 4.73242 28.6155L15.4399 22.994C15.731 22.8412 16.0785 22.8412 16.3696 22.994L27.0771 28.6155C27.41 28.7903 27.8095 28.5488 27.8095 28.1728V5C27.8095 4.44772 27.3618 4 26.8095 4H5Z",
    fill: "white"
  }), react.jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.3 5.3V26.8492L14.8356 21.843C15.5051 21.4916 16.3045 21.4916 16.9739 21.843L26.5095 26.8492V5.3H5.3Z",
    fill: "white",
    fillOpacity: "0.5"
  }))), react.jsx("defs", null, react.jsx("filter", {
    id: "filter0_d_15409_67578",
    x: "-1",
    y: "1",
    width: "33.8096",
    height: "34.6735",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, react.jsx("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), react.jsx("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), react.jsx("feOffset", {
    dy: "2"
  }), react.jsx("feGaussianBlur", {
    stdDeviation: "2.5"
  }), react.jsx("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.247059 0 0 0 0 0.278431 0 0 0 0 0.301961 0 0 0 0.15 0"
  }), react.jsx("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15409_67578"
  }), react.jsx("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_15409_67578",
    result: "shape"
  })), react.jsx("clipPath", {
    id: "clip0_15409_67578"
  }, react.jsx("rect", {
    width: "32",
    height: "32",
    fill: "white"
  }))));
};

InactiveScrapIcon32.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ActiveScrapIcon24 = function ActiveScrapIcon24(props) {
  return react.jsx("svg", props, react.jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 2.75H4C3.44772 2.75 3 3.19771 3 3.75V20.8228C3 21.1988 3.39948 21.4403 3.73242 21.2655L11.5352 17.169C11.8262 17.0162 12.1738 17.0162 12.4648 17.169L20.2676 21.2655C20.6005 21.4403 21 21.1988 21 20.8228V3.75C21 3.19772 20.5523 2.75 20 2.75Z",
    fill: "#35C5F0"
  }));
};

ActiveScrapIcon24.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ActiveScrapIcon32 = function ActiveScrapIcon32(props) {
  return react.jsx("svg", props, react.jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5C4 4.44772 4.44772 4 5 4H26.8095C27.3618 4 27.8095 4.44772 27.8095 5V28.1728C27.8095 28.5488 27.41 28.7903 27.0771 28.6155L16.3696 22.994C16.0785 22.8412 15.731 22.8412 15.4399 22.994L4.73242 28.6155C4.39948 28.7903 4 28.5488 4 28.1728V5Z",
    fill: "#35C5F0"
  }));
};

ActiveScrapIcon32.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var SCRAP = {
  inactive: {
    24: InactiveScrapIcon24,
    32: InactiveScrapIcon32
  },
  active: {
    24: ActiveScrapIcon24,
    32: ActiveScrapIcon32
  }
};
var ScrapButtonSet = function ScrapButtonSet(_ref) {
  var size = _ref.size,
      isActive = _ref.isActive;
  var InactiveIcon = SCRAP['inactive'][size];
  var ActiveIcon = SCRAP['active'][size];
  return react.jsx(React__default['default'].Fragment, null, react.jsx(ActiveIcon, {
    css: /*#__PURE__*/react.css("opacity:", isActive ? 1 : 0, ";")
  }), react.jsx(InactiveIcon, {
    css: /*#__PURE__*/react.css("opacity:", isActive ? 0 : 1, ";")
  }));
};
var ICONS_MAP = {
  scrap: ScrapButtonSet
};

var _excluded$1i = ["name", "size", "onActive", "onInactive", "initialActive"];
function ToggleButton(_ref) {
  var name = _ref.name,
      size = _ref.size,
      onActive = _ref.onActive,
      onInactive = _ref.onInactive,
      _ref$initialActive = _ref.initialActive,
      initialActive = _ref$initialActive === void 0 ? false : _ref$initialActive,
      rest = _objectWithoutProperties(_ref, _excluded$1i);

  var theme = react.useTheme();

  var _useState = React.useState(initialActive),
      _useState2 = _slicedToArray(_useState, 2),
      isActive = _useState2[0],
      setActive = _useState2[1];

  React.useEffect(function () {
    if (typeof initialActive === 'undefined') return;
    setActive(initialActive);
  }, [initialActive]);
  var Icons = ICONS_MAP[name];
  var handleClick = React.useCallback(function () {
    setActive(function (isActive) {
      var _ref2;

      (_ref2 = isActive ? onInactive : onActive) === null || _ref2 === void 0 ? void 0 : _ref2();
      return !isActive;
    });
  }, [onActive, onInactive]);
  return react.jsx("button", _extends({
    type: "button",
    onClick: handleClick,
    "aria-label": "".concat(name, " \uD1A0\uAE00 \uBC84\uD2BC"),
    css: [RESET_BUTTON, /*#__PURE__*/react.css("display:flex;justify-content:center;align-items:center;width:", pxToRem(size + 12), ";height:", pxToRem(size + 12), ";position:relative;")]
  }, rest), react.jsx("span", {
    css: [/*#__PURE__*/react.css("display:inline-block;font-size:", pxToRem(size), ";line-height:1;transform:translateZ(0);&>svg{position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);}"), !isActive && name === 'scrap' && /*#__PURE__*/react.css("&>svg{filter:drop-shadow(0 ", pxToRem(2), " ", pxToRem(5), " ", theme.shadow.thick, ");}")]
  }, react.jsx(Icons, {
    size: size,
    isActive: isActive
  })));
}

var _excluded$1h = ["forwardedRef", "size", "variant", "disabled", "children"];
function getTextButtonWithIconOptions(size, iconSize) {
  return {
    gap: {
      30: 4,
      32: 2
    }[size],
    iconSize: iconSize !== null && iconSize !== void 0 ? iconSize : 18
  };
}

function cssSize$3(size) {
  switch (size) {
    case 30:
      return /*#__PURE__*/react.css(FONT_STYLE.subTitle1, " padding:0 ", pxToRem(8), ";");

    case 32:
      return /*#__PURE__*/react.css(FONT_STYLE.subTitle2, " padding:0 ", pxToRem(6), ";");
  }
}

function cssVariant$5(theme, variant) {
  switch (variant) {
    case 'primary1':
      return /*#__PURE__*/react.css("color:", theme.content.primary1.basic, ";font-weight:700;&:active{background-color:", theme.interactive.transparent, ";}@media(hover: hover){&:hover{background-color:", theme.interactive.transparent, ";}}");

    case 'base1':
      return /*#__PURE__*/react.css("color:", theme.content.base1, ";font-weight:500;&:active{background-color:", theme.interactive.transparent, ";}@media(hover: hover){&:hover{background-color:", theme.interactive.transparent, ";}}");

    case 'onDark':
      return /*#__PURE__*/react.css("color:", theme.content.white, ";font-weight:500;&:active{background-color:", theme.interactive.onDark, ";}@media(hover: hover){&:hover{background-color:", theme.interactive.onDark, ";}}");
  }
}

function TextButton(_ref) {
  var forwardedRef = _ref.forwardedRef,
      size = _ref.size,
      variant = _ref.variant,
      disabled = _ref.disabled,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded$1h);

  var theme = react.useTheme();
  return react.jsx("button", _extends({
    type: "button"
  }, rest, {
    ref: forwardedRef,
    disabled: disabled,
    css: [/*#__PURE__*/react.css(RESET_BUTTON, " height:", pxToRem(size), ";border-radius:", pxToRem(4), ";"), cssSize$3(size), disabled ? /*#__PURE__*/react.css("color:", theme.content.base3, ";background-color:transparent;") : cssVariant$5(theme, variant)]
  }), children);
}

var TextButtonWithIcon = withIcon(TextButton, function (_ref) {
  var size = _ref.size,
      iconSize = _ref.iconSize;
  return getTextButtonWithIconOptions(size, iconSize);
});

var SHADOW_STYLE = {
  depth10: function depth10(theme) {
    return /*#__PURE__*/react.css("box-shadow:0 ", pxToRem(2), " ", pxToRem(6), " ", theme.shadow.thin, ";");
  },
  depth20: function depth20(theme) {
    return /*#__PURE__*/react.css("box-shadow:0 ", pxToRem(2), " ", pxToRem(6), " ", theme.shadow.basic, ";");
  },
  depth30: function depth30(theme) {
    return /*#__PURE__*/react.css("box-shadow:0 ", pxToRem(2), " ", pxToRem(10), " ", theme.shadow.thick, ";");
  }
};

function cssBaseFab(theme, size) {
  return /*#__PURE__*/react.css(RESET_BUTTON, " ", SHADOW_STYLE.depth30(theme), " height:", pxToRem(size), ";line-height:0;");
}
function cssFabVariant(theme, variant) {
  switch (variant) {
    case 'white':
      return /*#__PURE__*/react.css("color:", theme.content.base1, ";background-color:", theme.background.elevated, ";&:hover,&:active{background-color:", theme.interactive.transparent, ";}");

    case 'primary1':
    case 'primary3':
    case 'primary4':
      return /*#__PURE__*/react.css("color:", theme.content.white, ";background-color:", theme.content[variant].basic, ";&:hover,&:active{background-color:", theme.interactive[variant].basic, ";}");
  }
}

var _excluded$1g = ["forwardedRef", "size", "variant", "children"];
function Fab(_ref) {
  var forwardedRef = _ref.forwardedRef,
      size = _ref.size,
      variant = _ref.variant,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded$1g);

  var theme = react.useTheme();
  return react.jsx("button", _extends({}, rest, {
    type: "button",
    ref: forwardedRef,
    css: [cssBaseFab(theme, size), cssFabVariant(theme, variant), /*#__PURE__*/react.css("border-radius:50%;width:", pxToRem(size), ";")]
  }), children);
}

var _excluded$1f = ["icon"];
function IconFab(_ref) {
  var icon = _ref.icon,
      rest = _objectWithoutProperties(_ref, _excluded$1f);

  return react.jsx(Fab, rest, react.jsx(Icon, {
    size: 24,
    name: icon
  }));
}

var _excluded$1e = ["forwardedRef", "size", "variant", "children"];
function ExtendedFab(_ref) {
  var forwardedRef = _ref.forwardedRef,
      size = _ref.size,
      variant = _ref.variant,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded$1e);

  var theme = react.useTheme();
  return react.jsx("button", _extends({}, rest, {
    type: "button",
    ref: forwardedRef,
    css: [cssBaseFab(theme, size), cssFabVariant(theme, variant), /*#__PURE__*/react.css(FONT_STYLE.subTitle1, " font-weight:700;padding:0 ", pxToRem(16), ";border-radius:", pxToRem(size / 2), ";")]
  }), children);
}

var ExtendedFabWithIcon = withIcon(ExtendedFab, function () {
  return {
    gap: 8,
    iconSize: 24
  };
});

function onCheckHandler(event, callback) {
  if (callback.onChange) {
    callback.onChange(event);
  }

  if (callback.onCheck) {
    callback.onCheck(event.target.checked);
  }
}

var _excluded$1d = ["forwardedRef", "onCheck", "onChange"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$11() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$$ =  true ? {
  name: "8um586",
  styles: "position:absolute;top:0;left:0;opacity:0;width:100%;height:100%;margin:0;cursor:pointer"
} : 0;

function HiddenInput(_ref2) {
  var forwardedRef = _ref2.forwardedRef,
      onCheck = _ref2.onCheck,
      _onChange = _ref2.onChange,
      rest = _objectWithoutProperties(_ref2, _excluded$1d);

  return react.jsx("input", _extends({}, rest, {
    ref: forwardedRef,
    type: "checkbox",
    onChange: function onChange(e) {
      return onCheckHandler(e, {
        onChange: _onChange,
        onCheck: onCheck
      });
    },
    css: _ref$$
  }));
}

var _excluded$1c = ["className", "checked"];
function Toggle(_ref) {
  var className = _ref.className,
      checked = _ref.checked,
      rest = _objectWithoutProperties(_ref, _excluded$1c);

  var theme = react.useTheme();
  return react.jsx("div", {
    className: className,
    css: /*#__PURE__*/react.css("position:relative;display:inline-block;width:", pxToRem(50), ";height:", pxToRem(30), ";border-radius:", pxToRem(25), ";background-color:", checked ? theme.content.primary1.basic : theme.content.base3, ";&::before{", SHADOW_STYLE.depth20(theme), " content:\"\";position:absolute;top:", pxToRem(2), ";left:", pxToRem(2), ";width:", pxToRem(26), ";height:", pxToRem(26), ";border-radius:50%;background-color:", theme.content.white, ";transform:translateX(", pxToRem(checked ? 20 : 0), ");transition:transform 0.2s ease;}")
  }, react.jsx(HiddenInput, _extends({}, rest, {
    checked: checked
  })));
}

var _excluded$1b = ["className", "icon", "disabled", "checked"];
function Checkbox$1(_ref) {
  var className = _ref.className,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? 'check' : _ref$icon,
      disabled = _ref.disabled,
      checked = _ref.checked,
      rest = _objectWithoutProperties(_ref, _excluded$1b);

  var theme = react.useTheme();
  return react.jsx("div", {
    className: className,
    css: [/*#__PURE__*/react.css("display:inline-block;position:relative;width:", pxToRem(20), ";height:", pxToRem(20), ";border:", pxToRem(1), " solid;border-radius:", pxToRem(4), ";box-sizing:border-box;"), disabled ? /*#__PURE__*/react.css("border-color:", theme.content.base3, ";background-color:", theme.content.base3, ";") : /*#__PURE__*/react.css("border-color:", checked ? theme.content.primary1.basic : theme.border, ";background-color:", checked ? theme.content.primary1.basic : theme.content.white, ";transition:border-color 0.1s,background-color 0.1s;&:hover{background-color:", checked ? theme.interactive.primary1.basic : theme.interactive.transparent, ";border-color:", checked ? theme.interactive.primary1.basic : theme.border, ";}")]
  }, react.jsx("div", {
    css: /*#__PURE__*/react.css("position:absolute;overflow:hidden;top:", pxToRem(3.6), ";left:", pxToRem(3), ";width:", pxToRem(checked ? 12 : 0), ";height:", pxToRem(12), ";transition:width 0.2s 0.1s;")
  }, react.jsx(Icon, {
    size: 12,
    name: icon,
    css: /*#__PURE__*/react.css("vertical-align:top;color:", theme.content.base6, ";")
  })), react.jsx(HiddenInput, _extends({}, rest, {
    checked: checked,
    disabled: disabled
  })));
}

var _excluded$1a = ["id", "className", "children"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$10() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$_ =  true ? {
  name: "ozd7xs",
  styles: "flex-shrink:0"
} : 0;

var _ref2$m =  true ? {
  name: "11dqc0c",
  styles: "display:inline-flex;align-items:center;cursor:pointer"
} : 0;

function CheckboxWithText(_ref3) {
  var id = _ref3.id,
      className = _ref3.className,
      children = _ref3.children,
      rest = _objectWithoutProperties(_ref3, _excluded$1a);

  var theme = react.useTheme();
  return react.jsx("label", {
    css: _ref2$m,
    className: className,
    htmlFor: id
  }, react.jsx(Checkbox$1, _extends({}, rest, {
    id: id,
    css: _ref$_
  })), react.jsx("span", {
    css: /*#__PURE__*/react.css("flex:1;", FONT_STYLE.subTitle1, " margin-left:", pxToRem(6), ";color:", theme.content.base1, ";")
  }, children));
}

var _excluded$19 = ["className", "disabled", "checked"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$$() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$Z =  true ? {
  name: "s6rm2m",
  styles: "cursor:pointer;position:absolute;top:0;left:0;opacity:0;width:100%;height:100%;margin:0;&:disabled{cursor:default;}"
} : 0;

function Radio(_ref2) {
  var className = _ref2.className,
      disabled = _ref2.disabled,
      checked = _ref2.checked,
      rest = _objectWithoutProperties(_ref2, _excluded$19);

  var theme = react.useTheme();
  return react.jsx("div", {
    className: className,
    css: [/*#__PURE__*/react.css("display:inline-block;position:relative;width:", pxToRem(20), ";height:", pxToRem(20), ";border:", pxToRem(1), " solid;border-radius:50%;box-sizing:border-box;&::before{content:\"\";position:absolute;border-radius:50%;top:", pxToRem(5), ";left:", pxToRem(5), ";width:", pxToRem(8), ";height:", pxToRem(8), ";transform:scale(", checked ? 1 : 0, ");transition:transform 0.4s cubic-bezier(0.5, 2, 0.5, 0.5);background-color:", theme.content.base6, ";}"), disabled ? /*#__PURE__*/react.css("border-color:", theme.content.base3, ";background-color:", theme.content.base3, ";") : /*#__PURE__*/react.css("border-color:", checked ? theme.content.primary1.basic : theme.content.base3, ";background-color:", checked ? theme.content.primary1.basic : theme.content.white, ";transition:border-color 0.1s,background-color 0.1s;&:hover{background-color:", checked ? theme.interactive.primary1.basic : theme.interactive.transparent, ";border-color:", checked ? theme.interactive.primary1.basic : theme.content.base3, ";}")]
  }, react.jsx("input", _extends({}, rest, {
    type: "radio",
    checked: checked,
    disabled: disabled,
    css: _ref$Z
  })));
}

var _excluded$18 = ["id", "className", "children"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$Y =  true ? {
  name: "1989ovb",
  styles: "vertical-align:middle"
} : 0;

var _ref2$l =  true ? {
  name: "1r5gb7q",
  styles: "display:inline-block"
} : 0;

function RadioWithText(_ref3) {
  var id = _ref3.id,
      className = _ref3.className,
      children = _ref3.children,
      rest = _objectWithoutProperties(_ref3, _excluded$18);

  var theme = react.useTheme();
  return react.jsx("label", {
    css: _ref2$l,
    className: className,
    htmlFor: id
  }, react.jsx(Radio, _extends({}, rest, {
    id: id,
    css: _ref$Y
  })), react.jsx("span", {
    css: /*#__PURE__*/react.css(FONT_STYLE.subTitle1, " vertical-align:middle;margin-left:", pxToRem(6), ";color:", theme.content.base1, ";")
  }, children));
}

var GRID_ITEM_CLASS_NAME = 'bucketplace-grid-item';
var COLUMN_CLASS_NAME = 'bucketplace-column';

function cssBaseGap(gap, className) {
  var _split$map = "".concat(gap).split(' ').map(Number),
      _split$map2 = _slicedToArray(_split$map, 2),
      vertical = _split$map2[0],
      horizontal = _split$map2[1];

  if (horizontal) {
    var verticalGap = pxToRem(vertical / 2);
    var horizontalGap = pxToRem(horizontal / 2);
    return "\n      margin: -".concat(verticalGap, " -").concat(horizontalGap, ";\n      > .").concat(className, " {\n        padding: ").concat(verticalGap, " ").concat(horizontalGap, ";\n      }\n    ");
  }

  var halfGap = pxToRem(vertical / 2);
  return "\n    margin: -".concat(halfGap, ";\n    > .").concat(className, " {\n      padding: ").concat(halfGap, ";\n    }\n  ");
}

function cssGap(gap, className) {
  if (_typeof(gap) === 'object') {
    var _gap$mobile = gap.mobile,
        mobile = _gap$mobile === void 0 ? 0 : _gap$mobile,
        _gap$tablet = gap.tablet,
        tablet = _gap$tablet === void 0 ? mobile : _gap$tablet,
        _gap$laptop = gap.laptop,
        laptop = _gap$laptop === void 0 ? tablet : _gap$laptop;
    return /*#__PURE__*/react.css(cssBaseGap(mobile, className), " ", MEDIA_QUERY.min('tablet', cssBaseGap(tablet, className)), " ", MEDIA_QUERY.min('laptop', cssBaseGap(laptop, className)), ";");
  }

  return /*#__PURE__*/react.css(cssBaseGap(gap, className), ";");
}

var _excluded$17 = ["gap", "children"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$Z() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var DEFAULT_GAP = {
  mobile: 12,
  tablet: 16,
  laptop: 20,
  // FIXME:
  // at this point, we do not have a grid-gap specification for `desktop` size, deriving `laptop` size for now.
  // revisit later to fix this: https://ohou-se.slack.com/archives/C017TF9FQUV/p1650524602037409
  desktop: 20
};

var _ref$X =  true ? {
  name: "d3v9zr",
  styles: "overflow:hidden"
} : 0;

function Grid(_ref2) {
  var _ref2$gap = _ref2.gap,
      gap = _ref2$gap === void 0 ? DEFAULT_GAP : _ref2$gap,
      children = _ref2.children,
      rest = _objectWithoutProperties(_ref2, _excluded$17);

  return react.jsx("div", _extends({}, rest, {
    css: _ref$X
  }), react.jsx("div", {
    css: cssGap(gap, GRID_ITEM_CLASS_NAME)
  }, children));
}

var _excluded$16 = ["column", "className", "children"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$Y() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var TOTAL_COLUMN = {
  mobile: 4,
  tablet: 8,
  laptop: 12,
  // FIXME:
  // at this point, we do not have a grid-gap specification for `desktop` size, deriving `laptop` size for now.
  // revisit later to fix this: https://ohou-se.slack.com/archives/C017TF9FQUV/p1650524602037409
  desktop: 12
};
var COLUMN_PRESET = {
  full: {
    mobile: 4,
    tablet: 8,
    laptop: 12,
    desktop: 12
  },
  half: {
    mobile: 2,
    tablet: 4,
    laptop: 6,
    desktop: 6
  },
  quarter: {
    mobile: 1,
    tablet: 2,
    laptop: 3,
    desktop: 3
  }
};

function cssColumn$1(breakPoint, column) {
  return /*#__PURE__*/react.css(MEDIA_QUERY.min(breakPoint, "\n      width: ".concat(100 / TOTAL_COLUMN[breakPoint] * (typeof column === 'number' ? column : COLUMN_PRESET[column][breakPoint]), "%;\n    ")), ";");
}

var _ref$W =  true ? {
  name: "1kgy64",
  styles: "display:inline-block;vertical-align:top;box-sizing:border-box"
} : 0;

function GridItem(_ref2) {
  var column = _ref2.column,
      className = _ref2.className,
      children = _ref2.children,
      rest = _objectWithoutProperties(_ref2, _excluded$16);

  var _ref3 = _typeof(column) === 'object' ? column : COLUMN_PRESET[column],
      _ref3$mobile = _ref3.mobile,
      mobile = _ref3$mobile === void 0 ? 1 : _ref3$mobile,
      _ref3$tablet = _ref3.tablet,
      tablet = _ref3$tablet === void 0 ? mobile : _ref3$tablet,
      _ref3$laptop = _ref3.laptop,
      laptop = _ref3$laptop === void 0 ? tablet : _ref3$laptop,
      _ref3$desktop = _ref3.desktop,
      desktop = _ref3$desktop === void 0 ? laptop : _ref3$desktop;

  return react.jsx("div", _extends({}, rest, {
    css: [_ref$W, cssColumn$1('mobile', mobile), cssColumn$1('tablet', tablet), cssColumn$1('laptop', laptop), cssColumn$1('desktop', desktop)],
    className: spaces(className, GRID_ITEM_CLASS_NAME)
  }), children);
}

var _excluded$15 = ["gap", "columns", "children"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$X() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

function cssColumn(column) {
  var ratios = column.split(' ').map(Number);
  var total = ratios.reduce(function (v1, v2) {
    return v1 + v2;
  });
  return "\n    > .".concat(COLUMN_CLASS_NAME, " {\n      ").concat(ratios.map(function (ratio, index) {
    return "\n        &:nth-of-type(".concat(ratios.length, "n + ").concat(index + 1, ") {\n          width: ").concat(100 / total * ratio, "%;\n        }\n      ");
  }), "\n    }\n  ");
}

function cssColumns(columns) {
  if (_typeof(columns) === 'object') {
    var mobile = columns.mobile,
        _columns$tablet = columns.tablet,
        tablet = _columns$tablet === void 0 ? mobile : _columns$tablet,
        _columns$laptop = columns.laptop,
        laptop = _columns$laptop === void 0 ? tablet : _columns$laptop;
    return /*#__PURE__*/react.css(cssColumn(mobile), " ", MEDIA_QUERY.min('tablet', cssColumn(tablet)), " ", MEDIA_QUERY.min('laptop', cssColumn(laptop)), ";");
  }

  return /*#__PURE__*/react.css(cssColumn(columns), ";");
}

var _ref$V =  true ? {
  name: "d3v9zr",
  styles: "overflow:hidden"
} : 0;

function Row$1(_ref2) {
  var gap = _ref2.gap,
      columns = _ref2.columns,
      children = _ref2.children,
      rest = _objectWithoutProperties(_ref2, _excluded$15);

  return react.jsx("div", _extends({}, rest, {
    css: _ref$V
  }), react.jsx("div", {
    css: [gap && cssGap(gap, COLUMN_CLASS_NAME), cssColumns(columns)]
  }, children));
}

var _excluded$14 = ["children", "className"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$W() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$U =  true ? {
  name: "x9illq",
  styles: "display:inline-block;vertical-align:top"
} : 0;

function Column(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      rest = _objectWithoutProperties(_ref2, _excluded$14);

  return react.jsx("div", _extends({}, rest, {
    className: spaces(className, COLUMN_CLASS_NAME),
    css: _ref$U
  }), children);
}

function getActiveIds(menuSchema, fallbackMenuSchema) {
  // Check for fallback menu schema first
  if (fallbackMenuSchema != null) {
    var index = fallbackMenuSchema.findIndex(function (item) {
      return item.active;
    });

    if (index !== -1) {
      return [null, index];
    }
  } // Try to descend down to the matching entry


  for (var i = 0; i < menuSchema.length; i += 1) {
    var child = menuSchema[i];
    var childActiveIds = getActiveIdsEntry(child); // If the child has 'active' entry, merge all indices

    if (childActiveIds != null) {
      return [i].concat(_toConsumableArray(childActiveIds));
    }
  } // Nothing matched


  return [null];
}

function getActiveIdsEntry(entry) {
  if (entry.entries != null) {
    for (var i = 0; i < entry.entries.length; i += 1) {
      var child = entry.entries[i];
      var childActiveIds = getActiveIdsEntry(child); // If the child has 'active' entry, merge all indices

      if (childActiveIds != null) {
        return [i].concat(_toConsumableArray(childActiveIds));
      }
    }
  }

  if (entry.active) {
    // If the entry itself is active, return itself
    return [];
  } // Otherwise, it didn't match


  return null;
}

var LinkContext = React.createContext('a');
var useLinkContext = function useLinkContext() {
  return React.useContext(LinkContext);
};
function LinkProvider(_ref) {
  var children = _ref.children,
      linkComponent = _ref.linkComponent;
  return react.jsx(LinkContext.Provider, {
    value: linkComponent
  }, children);
}

var _excluded$13 = ["children"];
function Container$4(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded$13);

  return react.jsx("div", _extends({}, rest, {
    css: /*#__PURE__*/react.css("padding:0 ", pxToRem(16), ";box-sizing:border-box;", MEDIA_QUERY.min('tablet', "\n          padding: 0 ".concat(pxToRem(40), ";\n        ")), " ", MEDIA_QUERY.min('laptop', "\n          padding: 0 ".concat(pxToRem(60), ";\n        ")), " ", MEDIA_QUERY.min('desktop', "\n          max-width: ".concat(BREAK_POINT.desktop, "px;\n          margin: 0 auto;\n          padding: 0 ").concat(pxToRem(60), ";\n        ")), ";")
  }), children);
}

function useMedia(mediaQuery) {
  var initialValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var _useState = React.useState(initialValue),
      _useState2 = _slicedToArray(_useState, 2),
      isMatched = _useState2[0],
      setMatched = _useState2[1];

  React.useEffect(function () {
    var queryList = window.matchMedia(mediaQuery);

    var handleChange = function handleChange() {
      setMatched(queryList.matches);
    };

    handleChange();
    queryList.addListener(handleChange);
    return function () {
      queryList.removeListener(handleChange);
    };
  }, [mediaQuery]);
  return isMatched;
}

var LogContext = React.createContext(function () {
  /* noop */
});
var useLogContext = function useLogContext() {
  return React.useContext(LogContext);
};
function LogProvider(_ref) {
  var children = _ref.children,
      onLog = _ref.onLog;
  return react.jsx(LogContext.Provider, {
    value: onLog
  }, children);
}

function useHover(onHover) {
  var onHoverRef = React.useRef(onHover);
  onHoverRef.current = onHover;
  var timeoutRef = React.useRef(null);
  var handleMouseTimeout = React.useCallback(function () {
    onHoverRef.current();
    timeoutRef.current = null;
  }, []);
  var handleMouseMove = React.useCallback(function () {
    if (timeoutRef.current != null) {
      window.clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = window.setTimeout(handleMouseTimeout, 50);
  }, [handleMouseTimeout]);
  var handleMouseEnter = React.useCallback(function () {
    window.addEventListener('mousemove', handleMouseMove);

    if (timeoutRef.current != null) {
      window.clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = window.setTimeout(handleMouseTimeout, 50);
  }, [handleMouseTimeout, handleMouseMove]);
  var handleMouseLeave = React.useCallback(function () {
    window.removeEventListener('mousemove', handleMouseMove);

    if (timeoutRef.current != null) {
      window.clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }, [handleMouseMove]);
  React.useEffect(function () {
    return function () {
      window.removeEventListener('mousemove', handleMouseMove);

      if (timeoutRef.current != null) {
        window.clearTimeout(timeoutRef.current);
      }
    };
  }, [handleMouseMove]);
  return [handleMouseEnter, handleMouseLeave];
}

var _templateObject$k, _templateObject2$d;

var _excluded$12 = ["component", "index", "isActive", "isOpen", "children", "onSelect", "forwardedRef", "onClick"];
function NavigationBarPrimaryTabItem(props) {
  var _props$component = props.component,
      component = _props$component === void 0 ? 'button' : _props$component,
      index = props.index,
      isActive = props.isActive,
      isOpen = props.isOpen,
      children = props.children,
      onSelect = props.onSelect,
      forwardedRef = props.forwardedRef,
      onClick = props.onClick,
      rest = _objectWithoutProperties(props, _excluded$12);

  var theme = react.useTheme();
  var log = useLogContext();
  var handleClick = React.useCallback(function (e) {
    if (onClick) onClick(e);
    log({
      key: 'primary.item',
      category: 'click',
      params: {
        index: index
      }
    });
  }, [log, onClick, index]);

  var _useHover = useHover(onSelect),
      _useHover2 = _slicedToArray(_useHover, 2),
      handleMouseEnter = _useHover2[0],
      handleMouseLeave = _useHover2[1];

  var Component = component;
  return react.jsx(Component, _extends({
    css: [/*#__PURE__*/react.css(RESET_BUTTON, " position:relative;display:inline-block;margin:0 ", pxToRem(10), ";padding:", pxToRem(21), " ", pxToRem(5), " ", pxToRem(15), ";font-size:", pxToRem(18), ";line-height:1;font-weight:bold;color:", theme.content.base1, ";outline:none;"), isActive && /*#__PURE__*/react.css("color:", theme.content.primary1.basic, ";"), isOpen && /*#__PURE__*/react.css("color:", theme.content.primary1.basic, ";"), HOVER(_templateObject$k || (_templateObject$k = _taggedTemplateLiteral(["\n          color: ", ";\n        "])), theme.content.primary1.basic), FOCUS(_templateObject2$d || (_templateObject2$d = _taggedTemplateLiteral(["\n          color: ", ";\n          & > span {\n            box-shadow: 0 0 0 ", " ", ";\n          }\n        "])), theme.content.primary1.basic, pxToRem(3), theme.interactive.primary1.thin)],
    ref: forwardedRef,
    onClick: handleClick,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, rest), react.jsx("span", {
    css: /*#__PURE__*/react.css("display:inline-block;margin:", pxToRem(-4), ";padding:", pxToRem(4), ";border-radius:", pxToRem(3), ";")
  }, children));
}

var ZINDEX = {
  dropdown: 900,
  banner: 1000,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};

var INITIAL_NODE_HEIGHT$1 = 81;
function NavigationBarPrimary(props) {
  var leftmost = props.leftmost,
      left = props.left,
      right = props.right,
      menuEntries = props.menuEntries,
      activeId = props.activeId,
      selectedId = props.selectedId,
      onMouseEnter = props.onMouseEnter,
      onMouseLeave = props.onMouseLeave,
      _onSelect = props.onSelect;
  var LinkComponent = useLinkContext();
  var theme = react.useTheme();
  var childRef = React.useRef(null);
  var isPc = useMedia("(min-width: ".concat(BREAK_POINT.tablet, "px)"), true);
  var nodeHeight = ui.useNodeHeight(childRef, INITIAL_NODE_HEIGHT$1);
  var scrollDir = ui.useScrollDirection();
  return react.jsx(ui.Sticky, {
    css: /*#__PURE__*/react.css("background:", theme.background.base, ";border-bottom:", pxToRem(1), " solid ", theme.divider, ";"),
    direction: "top",
    offset: !isPc && scrollDir === 'down' ? -nodeHeight : 0,
    offsetRange: isPc ? [0, 0] : [-nodeHeight, 0],
    type: "navigation",
    disableNativeSticky: true,
    disableBottom: true,
    zIndex: ZINDEX.appBar + 2,
    transition: 0.1,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    forwardRef: childRef
  }, react.jsx(Container$4, {
    css: /*#__PURE__*/react.css("position:relative;display:flex;align-items:center;justify-content:space-between;height:", pxToRem(50), ";box-sizing:border-box;line-height:0;", MEDIA_QUERY.min('tablet', "\n            height: ".concat(pxToRem(80), ";\n            padding-top: ").concat(pxToRem(10), ";\n            padding-bottom: ").concat(pxToRem(10), ";\n          ")), ";")
  }, react.jsx("div", {
    css: /*#__PURE__*/react.css("flex:0 0 auto;display:block;margin-left:", pxToRem(-7), ";", MEDIA_QUERY.min('tablet', "\n              display: none;\n            "), ";")
  }, leftmost), react.jsx("div", {
    css: /*#__PURE__*/react.css("position:absolute;flex:0 0 auto;left:50%;top:50%;color:", theme.interactive.base1, ";transform:translate(-50%, -50%);", MEDIA_QUERY.min('tablet', "\n              position: static;\n              margin-right: ".concat(pxToRem(20), ";\n              left: none;\n              top: none;\n              transform: none;\n            ")), " ", MEDIA_QUERY.min('laptop', "\n              margin-right: ".concat(pxToRem(35), ";\n            ")), ";")
  }, left), react.jsx("div", {
    css: /*#__PURE__*/react.css("flex:1 1 0px;display:none;white-space:nowrap;", MEDIA_QUERY.min('tablet', "\n              display: block;\n            "), ";")
  }, menuEntries.map(function (item, index) {
    return react.jsx(NavigationBarPrimaryTabItem, {
      key: index,
      index: index,
      component: LinkComponent,
      href: item.href,
      isActive: activeId === index,
      isOpen: selectedId === index,
      onSelect: function onSelect() {
        return _onSelect(item, index);
      }
    }, item.title);
  })), react.jsx("div", {
    css: /*#__PURE__*/react.css("flex:0 0 auto;", MEDIA_QUERY.min('tablet', "\n              flex: 0 1 ".concat(pxToRem(476), ";\n            ")), " ", MEDIA_QUERY.min('desktop', "\n              flex: 0 1 ".concat(pxToRem(650), ";\n            ")), " ", MEDIA_QUERY.max('mobile', "\n              margin-right: ".concat(pxToRem(-7), ";\n            ")), ";")
  }, right)));
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$V() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$T =  true ? {
  name: "11ase34",
  styles: "display:flex;align-items:stretch;overflow-x:auto;white-space:nowrap;&&>*{flex:1 0 0px;min-width:0;}"
} : 0;

var FixedTab = React.forwardRef(function (_ref2, ref) {
  var rest = _extends({}, _ref2);

  return react.jsx("nav", _extends({}, rest, {
    ref: ref,
    css: _ref$T
  }));
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$U() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$S =  true ? {
  name: "sbestf",
  styles: "display:flex;align-items:stretch;overflow-x:auto;white-space:nowrap;margin:0 -5px;&&>*{margin:0 5px;}"
} : 0;

var Tab = React.forwardRef(function (_ref2, ref) {
  var rest = _extends({}, _ref2);

  return react.jsx("nav", _extends({}, rest, {
    ref: ref,
    css: _ref$S
  }));
});

function DotNotification(props) {
  var theme = react.useTheme();
  return react.jsx("span", _extends({}, props, {
    css: /*#__PURE__*/react.css("position:absolute;border-radius:50%;width:", pxToRem(4), ";height:", pxToRem(4), ";background-color:", theme.content.primary2.basic, ";")
  }));
}

var _templateObject$j, _templateObject2$c;

var _excluded$11 = ["component", "isActive", "children", "subText", "bullet", "forwardedRef", "onClick", "badge"];

var NewIcon$2 = function NewIcon(props) {
  return react.jsx("svg", props, react.jsx("path", {
    d: "M0 9a9 9 0 1118 0A9 9 0 010 9z",
    fill: "#fff"
  }), react.jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 18A9 9 0 109 0a9 9 0 000 18zm-1.7-5.25H5.26v-7.5h2.61l2.8 4.2h.03v-4.2h2.06v7.5h-2.3L7.36 8.07h-.05v4.68z",
    fill: "#F77"
  }));
};

NewIcon$2.defaultProps = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18",
  width: "18",
  height: "18"
};
function TabItem(_ref) {
  var _ref$component = _ref.component,
      component = _ref$component === void 0 ? 'button' : _ref$component,
      isActive = _ref.isActive,
      children = _ref.children,
      subText = _ref.subText,
      bullet = _ref.bullet,
      forwardedRef = _ref.forwardedRef,
      _onClick = _ref.onClick,
      badge = _ref.badge,
      rest = _objectWithoutProperties(_ref, _excluded$11);

  var theme = react.useTheme();
  var Component = component;
  return react.jsx(Component, _extends({
    css: [/*#__PURE__*/react.css(RESET_BUTTON, " position:relative;display:inline-flex;flex-direction:column;justify-content:center;vertical-align:top;text-align:center;box-sizing:border-box;&:after{content:'';display:block;position:absolute;left:0;bottom:0;width:100%;height:", pxToRem(2), ";background-color:", theme.content.primary1.basic, ";transition:transform 0.2s;transform:scale(", isActive ? 1 : 0, ");}"), HOVER(_templateObject$j || (_templateObject$j = _taggedTemplateLiteral(["\n          & > div > p:first-of-type {\n            color: ", ";\n          }\n        "])), theme.content.primary1.basic), FOCUS(_templateObject2$c || (_templateObject2$c = _taggedTemplateLiteral(["\n          & > div {\n            box-shadow: 0 0 0 3px ", ";\n            border-radius: 3px;\n          }\n        "])), theme.content.primary1.basic), subText ? /*#__PURE__*/react.css("padding:", pxToRem(11), " ", pxToRem(6), " ", pxToRem(5), ";") : /*#__PURE__*/react.css("padding:", pxToRem(12), " ", pxToRem(6), ";")],
    ref: forwardedRef,
    onClick: function onClick() {
      if (_onClick) {
        _onClick();
      }
    }
  }, rest), react.jsx("div", {
    css: /*#__PURE__*/react.css("padding:", pxToRem(4), ";margin:-", pxToRem(4), ";")
  }, react.jsx("p", {
    css: [FONT_STYLE.subTitle1, /*#__PURE__*/react.css("position:relative;font-weight:", isActive ? 700 : 500, ";color:", isActive ? theme.content.primary1.basic : theme.content.base1, ";")]
  }, children, badge && react.jsx(SquareBadge, {
    size: 16,
    type: badge.type,
    variant: badge.variant,
    css: /*#__PURE__*/react.css("vertical-align:middle;margin-left:", pxToRem(3), ";")
  }, badge.text), bullet === 'dot' && react.jsx(DotNotification, {
    css: /*#__PURE__*/react.css("top:0;right:", pxToRem(-6), ";")
  }), bullet === 'new' && react.jsx(NewIcon$2, {
    css: /*#__PURE__*/react.css("vertical-align:middle;margin:0 ", pxToRem(1.5), " ", pxToRem(1.5), " ", pxToRem(1.5), ";")
  })), subText && react.jsx("p", {
    css: [FONT_STYLE.caption2, /*#__PURE__*/react.css("color:", theme.content.base2, ";")]
  }, subText)));
}

var _excluded$10 = ["children", "onIntersect", "style", "className"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$T() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$R =  true ? {
  name: "1ecsbek",
  styles: "height:inherit;display:block"
} : 0;

var IntersectionObserver = function IntersectionObserver(_ref2) {
  var children = _ref2.children,
      onIntersect = _ref2.onIntersect,
      style = _ref2.style,
      className = _ref2.className,
      options = _objectWithoutProperties(_ref2, _excluded$10);

  var _useInView = reactIntersectionObserver.useInView(_objectSpread2({
    triggerOnce: true,
    threshold: 0.5
  }, options)),
      ref = _useInView.ref,
      inView = _useInView.inView;

  React.useEffect(function () {
    if (inView) {
      onIntersect();
    }
  }, [inView, onIntersect]);
  return react.jsx("span", {
    ref: ref,
    css: _ref$R,
    style: style,
    className: className
  }, children);
};

var _templateObject$i, _templateObject2$b;

var _excluded$$ = ["onSelect", "title", "index", "logId", "primaryId"];
function NavigationBarSecondaryTabItem(props) {
  var onSelect = props.onSelect,
      title = props.title,
      index = props.index,
      logId = props.logId,
      primaryId = props.primaryId,
      rest = _objectWithoutProperties(props, _excluded$$);

  var LinkComponent = useLinkContext();
  var log = useLogContext();

  var _useHover = useHover(onSelect),
      _useHover2 = _slicedToArray(_useHover, 2),
      handleMouseEnter = _useHover2[0],
      handleMouseLeave = _useHover2[1];

  var theme = react.useTheme();
  var isHncSecondaryTabItem = primaryId === 0;
  var handleIntersect = React.useCallback(function () {
    if (!isHncSecondaryTabItem || !logId) return;
    log({
      key: 'secondary.item',
      category: 'impression',
      params: {
        index: index,
        id: logId,
        type: 'topic',
        section: '서브 메뉴',
        section_id: 'LNB'
      }
    });
  }, [log, index, logId, isHncSecondaryTabItem]);
  return react.jsx(IntersectionObserver, {
    onIntersect: handleIntersect
  }, react.jsx(TabItem, _extends({}, rest, {
    component: LinkComponent,
    css: [/*#__PURE__*/react.css("height:inherit;outline:none;", MEDIA_QUERY.max('mobile', "\n              padding: ".concat(pxToRem(11), " ").concat(pxToRem(5), ";\n              > div > p {\n                font-size: ").concat(pxToRem(14), ";\n                line-height: ").concat(pxToRem(18), ";\n              }\n            ")), ";"), HOVER(_templateObject$i || (_templateObject$i = _taggedTemplateLiteral(["\n            color: ", ";\n          "])), theme.content.primary1.basic), FOCUS(_templateObject2$b || (_templateObject2$b = _taggedTemplateLiteral(["\n            * {\n              color: ", ";\n            }\n            & > div {\n              box-shadow: 0 0 0 ", " ", ";\n              border-radius: ", ";\n            }\n          "])), theme.content.primary1.basic, pxToRem(3), theme.interactive.primary1.thin, pxToRem(3))],
    onClick: function onClick() {
      var defaultParams = {
        index: index,
        section: '서브 메뉴',
        type: 'tab',
        id: title
      };
      var params = isHncSecondaryTabItem && logId ? _objectSpread2(_objectSpread2({}, defaultParams), {}, {
        id: logId,
        type: 'topic',
        section_id: 'LNB'
      }) : defaultParams;
      log({
        key: 'secondary.item',
        category: 'click',
        params: params
      });
    },
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  })));
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$S() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var INITIAL_NODE_HEIGHT = 51;

var _ref$Q =  true ? {
  name: "17fh4sh",
  styles: "flex:1 0 0px"
} : 0;

var _ref2$k =  true ? {
  name: "7dthhr",
  styles: "display:flex;align-items:center;justify-content:space-between;box-sizing:border-box;overflow:auto"
} : 0;

function NavigationBarSecondary(props) {
  var hasItems = props.hasItems,
      isForceOpened = props.isForceOpened,
      isFallback = props.isFallback,
      right = props.right,
      menuEntries = props.menuEntries,
      activeId = props.activeId,
      onMouseEnter = props.onMouseEnter,
      onMouseLeave = props.onMouseLeave,
      _onSelect = props.onSelect,
      primaryId = props.primaryId;
  var theme = react.useTheme();
  var childRef = React.useRef(null);
  var nodeHeight = ui.useNodeHeight(childRef, INITIAL_NODE_HEIGHT);
  var scrollDir = ui.useScrollDirection();
  var shouldOpen = hasItems && scrollDir !== 'down' || isForceOpened;
  if (menuEntries.length === 0) return null; // NOTE: Secondary의 모바일/PC 동작은 완전히 동일합니다.

  return react.jsx(ui.Sticky, {
    className: "layout-navigation-secondary",
    css: /*#__PURE__*/react.css("background:", theme.background.base, ";border-bottom:", pxToRem(1), " solid ", theme.divider, ";", isFallback && /*#__PURE__*/react.css("background:", theme.background.groupedBase, ";"), ";"),
    containerStyle: !hasItems ? {
      position: 'relative',
      top: isForceOpened ? '0' : pxToRem(-nodeHeight),
      height: '0px',
      transition: '.1s top'
    } : undefined,
    direction: "top",
    offset: shouldOpen ? 0 : -nodeHeight,
    offsetRange: [-nodeHeight, 0],
    type: "navigation",
    disableNativeSticky: true,
    disableBottom: true,
    disableHeight: !hasItems,
    forwardRef: childRef,
    zIndex: ZINDEX.appBar + 1,
    transition: 0.1,
    initialState: !hasItems ? _objectSpread2(_objectSpread2({}, ui.DEFAULT_STICKY_STATE), {}, {
      disabled: false,
      emulatedDisabled: false,
      offset: -nodeHeight,
      emulatedOffset: -nodeHeight
    }) : undefined,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, react.jsx(Container$4, {
    css: _ref2$k
  }, react.jsx("div", {
    css: _ref$Q
  }, react.jsx(Tab, {
    css: /*#__PURE__*/react.css("height:", pxToRem(50), ";", MEDIA_QUERY.max('mobile', "\n                height: ".concat(pxToRem(40), ";\n                justify-content: center;\n                margin: 0 -2px;\n                && > * {\n                  margin: 0 2px;\n                }\n              ")), ";")
  }, menuEntries.map(function (item, index) {
    return react.jsx(NavigationBarSecondaryTabItem, {
      key: item.title,
      index: index,
      title: item.title,
      href: item.href,
      bullet: item.bullet,
      badge: item.badge,
      logId: item.logId,
      primaryId: primaryId,
      isActive: activeId === index,
      onSelect: function onSelect() {
        return _onSelect(item, index);
      }
    }, item.title);
  }))), right && react.jsx("div", {
    css: /*#__PURE__*/react.css("flex:0 0 auto;display:none;", MEDIA_QUERY.min('tablet', "\n                display: block;\n                margin-left: 10px;\n              "), ";")
  }, right)));
}

function NavigationBarTertiary(_ref) {
  var _currentItem$renderBa;

  var item = _ref.item,
      isOpen = _ref.isOpen,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave;
  var itemRef = React.useRef(item);

  if (item != null) {
    itemRef.current = item;
  }

  var currentItem = itemRef.current;
  var nodeRef = React.useRef(null);

  var _useState = React.useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      top = _useState2[0],
      setTop = _useState2[1];

  React.useEffect(function () {
    if (!isOpen) {
      return;
    }

    if (nodeRef.current == null) {
      nodeRef.current = document.querySelector('.layout-navigation-secondary');
    }

    if (nodeRef.current) {
      setTop(nodeRef.current.getBoundingClientRect().bottom);
    }

    var timer = null;

    function handleScroll() {
      if (timer != null) {
        cancelAnimationFrame(timer);
      }

      timer = requestAnimationFrame(function () {
        timer = null;

        if (nodeRef.current) {
          setTop(nodeRef.current.getBoundingClientRect().bottom);
        }
      });
    }

    window.addEventListener('scroll', handleScroll);
    return function () {
      window.removeEventListener('scroll', handleScroll);

      if (timer != null) {
        cancelAnimationFrame(timer);
      }
    };
  }, [isOpen]);
  var show = React.useMemo(function () {
    return Boolean(isOpen && (item === null || item === void 0 ? void 0 : item.renderBarChild));
  }, [isOpen, item]);

  if (top == null) {
    return null;
  }

  return react.jsx(reactTransitionGroup.CSSTransition, {
    timeout: 200,
    "in": show,
    appear: show,
    unmountOnExit: true,
    classNames: {
      enterActive: 'open opening',
      enterDone: 'open open-active',
      appearActive: 'open opening',
      appearDone: 'open open-active',
      exit: 'exiting'
    }
  }, react.jsx("div", {
    css: /*#__PURE__*/react.css("position:fixed;top:", top, "px;left:0;right:0;background-color:#ffffff;border-bottom:1px solid #ededed;z-index:500;opacity:0;transform:translateY(-100%);&.opening{transition:.2s opacity,.2s transform;}&.exiting{transition:.2s opacity,.2s transform;}&.open{opacity:1;transform:none;}"),
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, currentItem === null || currentItem === void 0 ? void 0 : (_currentItem$renderBa = currentItem.renderBarChild) === null || _currentItem$renderBa === void 0 ? void 0 : _currentItem$renderBa.call(currentItem)));
}

function onValueHandler(event, callback) {
  if (callback.onChange) {
    callback.onChange(event);
  }

  if (callback.onValue) {
    callback.onValue(event.target.value);
  }
}

function isIconAction(action) {
  return 'icon' in action;
}
function cssBaseTextField(theme) {
  var onDimmed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var _ref = arguments.length > 2 ? arguments[2] : undefined,
      error = _ref.error,
      focused = _ref.focused,
      disabled = _ref.disabled,
      readOnly = _ref.readOnly;

  return /*#__PURE__*/react.css("display:inline-flex;align-items:center;line-height:0;box-sizing:border-box;border:", pxToRem(1), " solid ", theme.border, ";border-radius:", pxToRem(4), ";&:hover{background-color:", theme.content.base5, ";}", disabled && "\n      border-color: ".concat(theme.content.base4, ";\n      background-color: ").concat(theme.content.base5, ";\n    "), " ", readOnly && "\n      background-color: ".concat(theme.content.base5, ";\n    "), " ", focused && "border-color: ".concat(theme.content.primary1.basic, ";"), " ", error && "border-color: ".concat(theme.content.primary2.basic, ";"), " ", onDimmed && "background-color: ".concat(theme.background.base, ";"), ";");
}
function cssTextField(theme) {
  return /*#__PURE__*/react.css(RESET_INPUT, " height:100%;color:", theme.content.base1, ";outline:none;&::placeholder{color:", theme.content.base3, ";}");
}

var _excluded$_ = ["onChange", "onValue", "onFocus", "onBlur", "forwardedRef", "className", "size", "icon", "action", "onDimmed", "error", "disabled", "readOnly"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$R() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var ICON_SIZE$2 = 24;

function cssContainer(size) {
  return /*#__PURE__*/react.css("height:", pxToRem(size), ";padding:0 ", pxToRem({
    32: 8,
    40: 14,
    44: 16,
    50: 16
  }[size]), ";");
}

function cssFontSize$1(size) {
  return /*#__PURE__*/react.css({
    32: FONT_STYLE.body2,
    40: FONT_STYLE.body1_1,
    44: FONT_STYLE.body1_1,
    50: FONT_STYLE.body1_1
  }[size], ";");
}

function cssIconInputPadding(size) {
  return /*#__PURE__*/react.css(pxToRem({
    32: 4,
    40: 6,
    44: 6,
    50: 8
  }[size]), ";");
}

var _ref$P =  true ? {
  name: "s5xdrg",
  styles: "display:flex;align-items:center"
} : 0;

function Input$1(_ref2) {
  var _onChange = _ref2.onChange,
      onValue = _ref2.onValue,
      _onFocus = _ref2.onFocus,
      _onBlur = _ref2.onBlur,
      forwardedRef = _ref2.forwardedRef,
      className = _ref2.className,
      size = _ref2.size,
      icon = _ref2.icon,
      action = _ref2.action,
      _ref2$onDimmed = _ref2.onDimmed,
      onDimmed = _ref2$onDimmed === void 0 ? false : _ref2$onDimmed,
      _ref2$error = _ref2.error,
      error = _ref2$error === void 0 ? false : _ref2$error,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      _ref2$readOnly = _ref2.readOnly,
      readOnly = _ref2$readOnly === void 0 ? false : _ref2$readOnly,
      rest = _objectWithoutProperties(_ref2, _excluded$_);

  var theme = react.useTheme();

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var actions = Array.isArray(action) ? action : [action];
  return react.jsx("div", {
    className: className,
    css: [cssBaseTextField(theme, onDimmed, {
      error: error,
      focused: focused,
      disabled: disabled,
      readOnly: readOnly
    }), cssContainer(size)]
  }, icon && react.jsx(Icon, {
    size: ICON_SIZE$2,
    name: _typeof(icon) === 'object' ? icon.name : icon,
    css: /*#__PURE__*/react.css("vertical-align:middle;padding-right:", cssIconInputPadding(size), ";color:", _typeof(icon) === 'object' ? "".concat((icon === null || icon === void 0 ? void 0 : icon.color) || theme.content.base2) : theme.content.base2, ";")
  }), react.jsx(StyledInput, _extends({}, rest, {
    ref: forwardedRef,
    disabled: disabled,
    readOnly: readOnly,
    onChange: function onChange(e) {
      return onValueHandler(e, {
        onChange: _onChange,
        onValue: onValue
      });
    },
    onFocus: function onFocus(e) {
      if (_onFocus) {
        _onFocus(e);
      }

      setFocused(true);
    },
    onBlur: function onBlur(e) {
      if (_onBlur) {
        _onBlur(e);
      }

      setFocused(false);
    },
    css: [cssTextField(theme), cssFontSize$1(size), /*#__PURE__*/react.css("padding-right:", cssIconInputPadding(size), ";")]
  })), react.jsx("div", {
    css: _ref$P
  }, actions.map(function (action, i) {
    return !!action && (isIconAction(action) ? react.jsx(ActionButton, {
      key: i,
      type: action.type || 'button',
      disabled: disabled || action.disabled,
      tabIndex: action.tabIndex || 0,
      css: /*#__PURE__*/react.css("color:", action.color || theme.content.base2, ";"),
      onClick: function onClick(e) {
        var _action$onClick;

        e.stopPropagation();
        (_action$onClick = action.onClick) === null || _action$onClick === void 0 ? void 0 : _action$onClick.call(action, e);
      }
    }, react.jsx(Icon, {
      size: ICON_SIZE$2,
      name: action.icon
    })) : react.jsx(ActionTextButton, {
      key: i,
      size: 30,
      variant: "primary1",
      type: action.type || 'button',
      disabled: disabled || action.disabled,
      tabIndex: action.tabIndex || 0,
      css: [cssFontSize$1(size)],
      onClick: function onClick(e) {
        var _action$onClick2;

        e.stopPropagation();
        (_action$onClick2 = action.onClick) === null || _action$onClick2 === void 0 ? void 0 : _action$onClick2.call(action, e);
      }
    }, action.text));
  })));
}

var StyledInput = _styled__default['default']("input", {
  target: "ej5pc7c2"
})( true ? {
  name: "ua3caf",
  styles: "box-sizing:border-box;flex:1 0 0%;vertical-align:middle;outline:none"
} : 0);

var ActionButton = _styled__default['default']("button", {
  target: "ej5pc7c1"
})(RESET_BUTTON, " vertical-align:middle;width:", pxToRem(ICON_SIZE$2), ";height:", pxToRem(ICON_SIZE$2), ";outline:none;margin-left:", pxToRem(8), ";&:first-of-type{margin-left:0;}");

var ActionTextButton = /*#__PURE__*/_styled__default['default'](TextButton, {
  target: "ej5pc7c0"
})("flex-shrink:0;margin-left:", pxToRem(8), ";padding:0;&:first-of-type{margin-left:0;}");

var _excluded$Z = ["value", "placeholder", "onChange", "onClear"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$Q() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$O =  true ? {
  name: "d02zr5",
  styles: "width:100%;input::-ms-clear{display:none;}"
} : 0;

var Input = React.forwardRef(function (_ref2, ref) {
  var value = _ref2.value,
      placeholder = _ref2.placeholder,
      onChange = _ref2.onChange,
      onClear = _ref2.onClear,
      props = _objectWithoutProperties(_ref2, _excluded$Z);

  var input = React.useRef(null);
  var handleChange = React.useCallback(function (e) {
    onChange(e.target.value);
  }, [onChange]);
  var handleClear = React.useCallback(function () {
    onChange('');
    onClear();
  }, [onChange, onClear]);
  React.useImperativeHandle(ref, function () {
    return input.current;
  });
  return react.jsx(Input$1, _extends({
    css: _ref$O,
    forwardedRef: input,
    type: "text",
    size: 40,
    value: value,
    placeholder: placeholder,
    icon: "search",
    action: value ? {
      icon: 'dismiss_circle',
      type: 'button',
      onClick: handleClear
    } : undefined,
    onChange: handleChange
  }, props));
});

/**
 * Determines if the given value has changed.
 * @param {any} value The value to compare against.
 * @param {function} isEqual The checking mechanism. Defaults to shallow equal.
 * @return {boolean} Whether if the value has changed.
 */

function useChanged(value) {
  var isEqual = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (a, b) {
    return a === b;
  };
  var prevValueRef = React.useRef();

  if (prevValueRef.current == null) {
    prevValueRef.current = {
      value: value
    };
    return false;
  }

  var prevValue = prevValueRef.current.value;
  var changed = !isEqual(prevValue, value);
  prevValueRef.current.value = value;
  return changed;
}

function useFocused() {
  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFocused = _useState2[0],
      setFocused = _useState2[1];

  var wasClicked = React.useRef(false);
  var handleFocus = React.useCallback(function () {
    setFocused(true);
  }, []);
  var handleClick = React.useCallback(function () {
    wasClicked.current = true;
  }, []);
  var handleKeyDown = React.useCallback(function (e) {
    if (e.keyCode === 9) {
      // Tab
      setFocused(false);
    }
  }, []);
  React.useEffect(function () {
    if (isFocused) {
      var handleClickCapture = function handleClickCapture() {
        wasClicked.current = false;
      };

      var _handleClick = function _handleClick() {
        if (!wasClicked.current) {
          setFocused(false);
        }
      };

      window.addEventListener('click', _handleClick);
      window.addEventListener('click', handleClickCapture, true);
      return function () {
        window.removeEventListener('click', _handleClick);
        window.removeEventListener('click', handleClickCapture, true);
      };
    }
  }, [isFocused]);
  return [isFocused, setFocused, {
    handleFocus: handleFocus,
    handleClick: handleClick,
    handleKeyDown: handleKeyDown
  }];
}

var HANGUL_INITIAL = 'rRseEfaqQtTdwWczxvg'.split('');
var HANGUL_MEDIAL = 'k,o,i,O,j,p,u,P,h,hk,ho,hl,y,n,nj,np,nl,b,m,ml,l'.split(',');
var HANGUL_FINAL = (',r,R,rt,s,sw,sg,e,f,fr,fa,fq,ft,fx,fv,fg,a,q,qt,t,T,' + 'd,w,c,z,x,v,g').split(',');
var HANGUL_JAMO = (',r,R,rt,s,sw,sg,e,E,f,fr,fa,fq,ft,fx,fv,fg,a,q,Q,qt,t,' + 'T,d,w,W,c,z,x,v,g,k,o,i,O,j,p,u,P,h,hk,ho,hl,y,n,nj,np,nl,b,m,ml,l').split(',');
function decomposeHangul(input) {
  return input.split('').map(function (_char) {
    var code = _char.charCodeAt(0);

    if (code >= 0xAC00 && code <= 0xD7A3) {
      // Decompose hangul to dubeolsik characters.
      code -= 0xAC00;
      var _final = HANGUL_FINAL[code % HANGUL_FINAL.length];
      code = code / HANGUL_FINAL.length | 0;
      var medial = HANGUL_MEDIAL[code % HANGUL_MEDIAL.length];
      code = code / HANGUL_MEDIAL.length | 0;
      var initial = HANGUL_INITIAL[code % HANGUL_INITIAL.length];
      return [initial, medial, _final].join('');
    } else if (code >= 0x3130 && code <= 0x3163) {
      return HANGUL_JAMO[code - 0x3130];
    }

    return _char;
  }).join('');
}

function canInferQuery(query, oldQuery) {
  if (query == null || oldQuery == null) {
    return false;
  }

  var queryDecompsed = decomposeHangul(query);
  var oldQueryDecomposed = decomposeHangul(oldQuery);
  return queryDecompsed.startsWith(oldQueryDecomposed);
} // Creates simple query cache for useAutoCompleteFetch.


function createCachedFetch(onFetch, shouldCache) {
  var cache = {};
  return function (query) {
    var queryDecomposed = query == null ? '' : decomposeHangul(query);

    if (cache[queryDecomposed] != null) {
      return Promise.resolve(cache[queryDecomposed]);
    }

    return onFetch(query).then(function (value) {
      if (shouldCache != null && !shouldCache(query)) {
        return value;
      }

      cache[queryDecomposed] = value;
      return value;
    });
  };
}
function useAutoCompleteFetch(pageKey, query, isEnabled, onFetch, isValueEmpty) {
  var hasDisabledRef = React.useRef(false);
  var pendingRef = React.useRef(false);

  var _useState = React.useState(function () {
    return {
      pageKey: null,
      query: null,
      value: null
    };
  }),
      _useState2 = _slicedToArray(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  var handleSetData = React.useCallback(function (data) {
    return setData(function (prev) {
      return {
        pageKey: prev.pageKey,
        query: prev.query,
        value: typeof data === 'function' ? data(prev.value) : data
      };
    });
  }, []);
  var shouldLoad = isEnabled && (data == null || pageKey !== data.pageKey || query !== data.query || hasDisabledRef.current); // If the query completely extends previous query and previous query was
  // empty, the query would be empty too - don't fetch if that's the case.

  if (shouldLoad && !hasDisabledRef.current && data != null && data.value != null && pageKey === data.pageKey && canInferQuery(query, data.query) && isValueEmpty != null) {
    shouldLoad = !isValueEmpty(data.value);
  }

  React.useEffect(function () {
    if (shouldLoad) {
      if (pendingRef.current) {
        return;
      }

      _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                pendingRef.current = true;
                _context.prev = 1;
                _context.next = 4;
                return onFetch(query);

              case 4:
                result = _context.sent;
                setData({
                  pageKey: pageKey,
                  query: query,
                  value: result
                });
                hasDisabledRef.current = false;
                pendingRef.current = false;
                _context.next = 15;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](1);
                hasDisabledRef.current = false;
                pendingRef.current = false;
                throw _context.t0;

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 10]]);
      }))();
    }
  }, [pageKey, query, data, isEnabled, onFetch, shouldLoad]);

  if (!isEnabled) {
    hasDisabledRef.current = true;
    return [null, handleSetData];
  }

  if (data == null || pageKey !== data.pageKey) {
    return [null, handleSetData];
  } // Otherwise, return the current value.


  return [data.value, handleSetData];
}

function useAutoComplete(inputRef, options) {
  var pageKey = options.pageKey,
      isAlwaysFocused = options.isAlwaysFocused,
      onFetch = options.onFetch,
      getItemQuery = options.getItemQuery,
      inputQuery = options.query,
      _options$initialQuery = options.initialQuery,
      initialQuery = _options$initialQuery === void 0 ? null : _options$initialQuery,
      onFocus = options.onFocus,
      onSubmit = options.onSubmit,
      onSubmitItem = options.onSubmitItem;

  var _useState = React.useState(initialQuery),
      _useState2 = _slicedToArray(_useState, 2),
      currentQuery = _useState2[0],
      setQuery = _useState2[1];

  var query = currentQuery == null ? inputQuery : currentQuery;

  var _useFocused = useFocused(),
      _useFocused2 = _slicedToArray(_useFocused, 3),
      isCurrentlyFocused = _useFocused2[0],
      setFocused = _useFocused2[1],
      focusCallbacks = _useFocused2[2];

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isOpened = _useState4[0],
      setOpened = _useState4[1];

  var ignoreMouseUntilRef = React.useRef(0);
  var isFocused = isAlwaysFocused || isCurrentlyFocused;

  var _useState5 = React.useState({
    selected: -1,
    hovered: -1
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      currentIndex = _useState6[0],
      setIndex = _useState6[1];

  var setSelectedIndex = React.useCallback(function (index) {
    setIndex(function (prev) {
      var nextIndex = typeof index === 'function' ? index(prev.hovered) : index;
      return {
        selected: nextIndex,
        hovered: nextIndex
      };
    });
  }, []);
  var setHoveredIndex = React.useCallback(function (index) {
    if (Date.now() > ignoreMouseUntilRef.current) {
      setIndex(function (prev) {
        return {
          selected: prev.selected,
          hovered: index
        };
      });
    }
  }, []);
  var handleSubmit = React.useCallback(function (value) {
    if (value == null || value.trim() === '') {
      // Do nothing if value is empty
      return;
    }

    if (inputRef.current != null) {
      inputRef.current.blur();
    }

    setFocused(false);
    setOpened(false);
    onSubmit(value);
  }, [onSubmit, inputRef, setFocused]);
  var handleSubmitItem = React.useCallback(function (item, index) {
    if (inputRef.current != null) {
      inputRef.current.blur();
    }

    setFocused(false);
    setOpened(false);
    onSubmitItem(item, index);
  }, [onSubmitItem, inputRef, setFocused]);
  var handleReset = React.useCallback(function () {
    setQuery(null);
  }, []);

  var _useAutoCompleteFetch = useAutoCompleteFetch(pageKey, query, isFocused, onFetch),
      _useAutoCompleteFetch2 = _slicedToArray(_useAutoCompleteFetch, 1),
      data = _useAutoCompleteFetch2[0];

  var maxIndex = data == null ? 0 : data.length;
  var shownQuery = currentIndex.selected >= 0 && isOpened && data != null && data[currentIndex.selected] != null ? getItemQuery(data[currentIndex.selected]) : query;
  var handleInputChange = React.useCallback(function (value) {
    setFocused(true);
    setQuery(value);
    setSelectedIndex(-1);
  }, [setQuery, setSelectedIndex, setFocused]);

  if (isOpened && !isFocused) {
    setOpened(false);
  }

  var hasDataChanged = useChanged(data);

  if (hasDataChanged && maxIndex > 0) {
    setTimeout(function () {
      ignoreMouseUntilRef.current = Date.now() + 100;
      setSelectedIndex(-1);
      setOpened(true);
    });
  }

  var hasPageChanged = useChanged(pageKey);

  if (hasPageChanged) {
    setQuery(null);
  }

  var handleInputKeyDown = React.useCallback(function (e) {
    focusCallbacks.handleKeyDown(e);

    switch (e.keyCode) {
      case 27:
        // ESC
        setOpened(false);
        break;

      case 13:
        // Return
        if (data != null && currentIndex.hovered >= 0) {
          handleSubmitItem(data[currentIndex.hovered], currentIndex.hovered);
        } else {
          handleSubmit(shownQuery);
        }

        e.preventDefault();
        break;

      case 9:
        // Tab
        // Commit current shownQuery
        if (query !== shownQuery) {
          setQuery(shownQuery);
        }

        break;

      case 38:
        // Up arrow
        e.preventDefault();
        ignoreMouseUntilRef.current = Date.now() + 100;

        if (isOpened) {
          setSelectedIndex(function (prev) {
            return prev <= -1 ? maxIndex - 1 : prev - 1;
          });
        } else if (maxIndex > 0) {
          setOpened(true);
          setSelectedIndex(maxIndex - 1);
        }

        break;

      case 40:
        // Down arrow
        e.preventDefault();
        ignoreMouseUntilRef.current = Date.now() + 100;

        if (isOpened) {
          setSelectedIndex(function (prev) {
            return prev >= maxIndex - 1 ? 0 : prev + 1;
          });
        } else if (maxIndex > 0) {
          setOpened(true);
          setSelectedIndex(0);
        }

        break;

      case 37:
        // Left arrow
        setQuery(shownQuery);
        setSelectedIndex(-1);
        break;

      case 39:
        // Right arrow
        setQuery(shownQuery);
        setSelectedIndex(-1);
        break;
    }
  }, [maxIndex, data, isOpened, query, shownQuery, currentIndex.hovered, handleSubmit, handleSubmitItem, focusCallbacks, setSelectedIndex]);
  var handleListMouseEnter = React.useCallback(function (_, i) {
    return setHoveredIndex(i);
  }, [setHoveredIndex]);
  var handleInputFocus = React.useCallback(function (e) {
    focusCallbacks.handleFocus(e);

    if (onFocus != null) {
      onFocus();
    }
  }, [focusCallbacks, onFocus]);
  React.useEffect(function () {
    setQuery(initialQuery);
  }, [initialQuery]);
  return {
    isOpened: isOpened && maxIndex > 0,
    isFocused: isFocused,
    shownQuery: shownQuery,
    selectedIndex: currentIndex.selected,
    hoveredIndex: currentIndex.hovered,
    items: data || [],
    onInputFocus: handleInputFocus,
    onInputClick: focusCallbacks.handleClick,
    onInputKeyDown: handleInputKeyDown,
    onInputChange: handleInputChange,
    onListMouseEnter: handleListMouseEnter,
    onListClick: handleSubmitItem,
    onReset: handleReset
  };
}

var _excluded$Y = ["id", "className", "pageKey", "initialQuery", "placeholder", "isInputAutoFocused", "isListBoxAlwaysOpened", "renderInputRight", "fetchList", "getItemQuery", "renderListBox", "onSubmit", "onSubmitItem", "onInputBlur"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$P() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$N =  true ? {
  name: "mvrlf6",
  styles: "min-height:0"
} : 0;

var _ref2$j =  true ? {
  name: "1tnn3ml",
  styles: ">input{width:100%;}"
} : 0;

var _ref3$6 =  true ? {
  name: "7whenc",
  styles: "display:flex;width:100%"
} : 0;

var _ref4$3 =  true ? {
  name: "13y1wtx",
  styles: "position:relative;display:flex;flex-direction:column;height:100%"
} : 0;

function Search(_ref5) {
  var id = _ref5.id,
      className = _ref5.className,
      pageKey = _ref5.pageKey,
      initialQuery = _ref5.initialQuery,
      placeholder = _ref5.placeholder,
      isInputAutoFocused = _ref5.isInputAutoFocused,
      isListBoxAlwaysOpened = _ref5.isListBoxAlwaysOpened,
      renderInputRight = _ref5.renderInputRight,
      fetchList = _ref5.fetchList,
      getItemQuery = _ref5.getItemQuery,
      renderListBox = _ref5.renderListBox,
      onSubmit = _ref5.onSubmit,
      onSubmitItem = _ref5.onSubmitItem,
      onInputBlur = _ref5.onInputBlur,
      props = _objectWithoutProperties(_ref5, _excluded$Y);

  var input = React.useRef(null);

  var _useAutoComplete = useAutoComplete(input, {
    pageKey: pageKey,
    query: '',
    initialQuery: initialQuery,
    isAlwaysFocused: isInputAutoFocused,
    onFetch: fetchList,
    getItemQuery: getItemQuery,
    onSubmit: onSubmit,
    onSubmitItem: onSubmitItem
  }),
      items = _useAutoComplete.items,
      isOpened = _useAutoComplete.isOpened,
      shownQuery = _useAutoComplete.shownQuery,
      hoveredIndex = _useAutoComplete.hoveredIndex,
      onInputFocus = _useAutoComplete.onInputFocus,
      onInputClick = _useAutoComplete.onInputClick,
      onInputChange = _useAutoComplete.onInputChange,
      onInputKeyDown = _useAutoComplete.onInputKeyDown,
      onReset = _useAutoComplete.onReset,
      onListClick = _useAutoComplete.onListClick,
      onListMouseEnter = _useAutoComplete.onListMouseEnter;

  var handleInputFocus = React.useCallback(function (e) {
    onInputFocus(e);
    if (props.onInputFocus) props.onInputFocus(e);
  }, [onInputFocus, props]);
  var handleInputChange = React.useCallback(function (value) {
    onInputChange(value);
    if (props.onInputChange) props.onInputChange(value);
  }, [onInputChange, props]);
  var handleInputBlur = React.useCallback(function (e) {
    onInputBlur === null || onInputBlur === void 0 ? void 0 : onInputBlur(e);
  }, [onInputBlur]);
  return react.jsx("div", {
    className: className,
    css: _ref4$3
  }, react.jsx("div", {
    id: "".concat(id, "-combobox"),
    role: "combobox",
    "aria-expanded": isOpened,
    "aria-haspopup": "listbox",
    "aria-controls": isOpened ? "".concat(id, "-listbox") : undefined,
    css: _ref3$6
  }, react.jsx(Input, {
    css: _ref2$j,
    ref: input,
    value: shownQuery,
    placeholder: placeholder,
    autoFocus: isInputAutoFocused,
    onFocus: handleInputFocus,
    onClick: onInputClick,
    onChange: handleInputChange,
    onKeyDown: onInputKeyDown,
    onBlur: handleInputBlur,
    onClear: onReset,
    autoComplete: "off",
    "aria-autocomplete": "list"
  }), renderInputRight && renderInputRight()), (isListBoxAlwaysOpened || isOpened) && react.jsx("div", {
    id: "".concat(id, "-listbox"),
    role: "listbox",
    css: _ref$N
  }, renderListBox({
    items: items,
    query: shownQuery,
    hoveredIndex: hoveredIndex,
    onItemClick: onListClick,
    onItemMouseEnter: onListMouseEnter
  })));
}

var _excluded$X = ["children"];
var HistoryStorageContext = React.createContext({});
var useHistoryStorage = function useHistoryStorage() {
  return React.useContext(HistoryStorageContext);
};
function HistoryStorageProvider(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded$X);

  return react.jsx(HistoryStorageContext.Provider, {
    value: props
  }, children);
}

var _excluded$W = ["variant"];

function cssVariant$4(theme, variant) {
  switch (variant) {
    case 'thin':
      return /*#__PURE__*/react.css("margin:0;padding:0;height:", pxToRem(1), ";border:none;background-color:", theme.divider, ";");

    case 'thick':
      return /*#__PURE__*/react.css("margin:0;padding:0;height:", pxToRem(10), ";border:none;background-color:", theme.background.groupedBase, ";");
  }
}

function Divider$1(_ref) {
  var variant = _ref.variant,
      rest = _objectWithoutProperties(_ref, _excluded$W);

  var theme = react.useTheme();
  return react.jsx("hr", _extends({}, rest, {
    css: cssVariant$4(theme, variant)
  }));
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$O() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function HighlightedText(_ref2) {
  var item = _ref2.item,
      query = _ref2.query;
  var highlightedDisplay = item.value.highlightedDisplay;
  if (!query) return react.jsx(React__default['default'].Fragment, null, item.query);
  var parts = highlightedDisplay ? highlightedDisplay.split(/<strong>|<\/strong>/gi) : item.query.split(new RegExp("(".concat(query, ")"), 'gi'));
  return react.jsx(React__default['default'].Fragment, null, parts.map(function (part, index) {
    return react.jsx(React.Fragment, {
      key: index
    }, index % 2 === 1 ? react.jsx("strong", null, part) : part);
  }));
}

var _ref$M =  true ? {
  name: "17uk3v8",
  styles: "display:flex;align-items:center;white-space:nowrap"
} : 0;

function KeywordItem(props) {
  return react.jsx("div", {
    css: _ref$M
  }, react.jsx(Icon, {
    name: "search",
    size: 18,
    fill: function fill(theme) {
      return theme.content.base1;
    },
    css: /*#__PURE__*/react.css("width:", pxToRem(32), ";height:", pxToRem(32), ";display:flex;align-items:center;justify-content:center;", MEDIA_QUERY.min('laptop', "\n            width: ".concat(pxToRem(24), ";\n            height: ").concat(pxToRem(24), ";\n          ")), ";")
  }), react.jsx("div", {
    css: /*#__PURE__*/react.css("flex:1;text-overflow:ellipsis;overflow:hidden;margin-left:", pxToRem(8), ";")
  }, react.jsx(HighlightedText, props)));
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$N() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$L =  true ? {
  name: "1kghokd",
  styles: "display:flex;align-items:center;overflow:hidden"
} : 0;

var _ref2$i =  true ? {
  name: "7gjpkq",
  styles: "display:flex;align-items:center;justify-content:space-between;white-space:nowrap"
} : 0;

function CategoryItem(props) {
  var theme = react.useTheme();
  return react.jsx("div", {
    css: _ref2$i
  }, react.jsx("div", {
    css: _ref$L
  }, react.jsx(Icon, {
    css: /*#__PURE__*/react.css("width:", pxToRem(32), ";height:", pxToRem(32), ";display:flex;align-items:center;justify-content:center;", MEDIA_QUERY.min('laptop', "\n              width: ".concat(pxToRem(24), ";\n              height: ").concat(pxToRem(24), ";\n              min-width: ").concat(pxToRem(24), ";\n            ")), ";"),
    name: "search",
    size: 18,
    fill: function fill(theme) {
      return theme.content.base1;
    }
  }), react.jsx("div", {
    css: /*#__PURE__*/react.css("text-overflow:ellipsis;overflow:hidden;margin-left:", pxToRem(8), ";")
  }, react.jsx(HighlightedText, props)), react.jsx("span", {
    css: /*#__PURE__*/react.css("width:", pxToRem(1), ";height:", pxToRem(10), ";background:", theme.content.base4, ";margin:0 ", pxToRem(4), ";")
  }), react.jsx("span", {
    css: /*#__PURE__*/react.css(FONT_STYLE.caption1, " margin-right:", pxToRem(14), ";color:", theme.content.base2, ";", MEDIA_QUERY.min('laptop', "\n            ".concat(FONT_STYLE.caption2, "\n          ")), ";")
  }, "\uCE74\uD14C\uACE0\uB9AC")), react.jsx(Icon, {
    name: "chevron_right",
    size: 18,
    fill: function fill(theme) {
      return theme.content.base3;
    }
  }));
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$M() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var MAX_DEPTH = 2;

var _ref$K =  true ? {
  name: "n0fp6c",
  styles: "display:flex;flex-flow:row wrap;align-items:center;width:100%"
} : 0;

function CategoryHierarchy(_ref2) {
  var hierarchy = _ref2.hierarchy;
  var trailings = hierarchy.slice(-MAX_DEPTH);
  var theme = react.useTheme();
  return react.jsx("div", {
    css: _ref$K
  }, trailings.map(function (depth, index) {
    return react.jsx(React.Fragment, {
      key: index
    }, react.jsx("span", {
      css: /*#__PURE__*/react.css("display:inline-block;font-weight:bold;line-height:1.4;&:last-of-type{color:", theme.content.primary1.thick, ";}")
    }, depth), index < trailings.length - 1 && react.jsx(Icon, {
      name: "chevron_right",
      size: 12,
      css: /*#__PURE__*/react.css("margin:0 ", pxToRem(6), ";")
    }));
  }));
}

var _templateObject$h, _templateObject2$a;

function _EMOTION_STRINGIFIED_CSS_ERROR__$L() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$J =  true ? {
  name: "fzu03x",
  styles: "text-overflow:ellipsis;overflow:hidden"
} : 0;

function HistoryItem(_ref2) {
  var item = _ref2.item,
      hovered = _ref2.hovered;
  var theme = react.useTheme();
  var query = item.query,
      value = item.value;
  var historyStorage = useHistoryStorage();

  var handleDeleteClick = function handleDeleteClick(e) {
    e.stopPropagation();
    historyStorage.remove(value);
  };

  var renderItem = function renderItem() {
    var elem = query;

    if (_typeof(value) === 'object' && value.type === 'category') {
      var _value$value$orgDispl;

      // 기존 History 데이터가 undefined 인 경우가 있어, 옵셔널 값 추가
      var orgDisplay = (_value$value$orgDispl = value.value.orgDisplay) !== null && _value$value$orgDispl !== void 0 ? _value$value$orgDispl : '';
      elem = react.jsx(CategoryHierarchy, {
        hierarchy: orgDisplay.split('>').map(function (value) {
          return value.trim();
        })
      });
    }

    return react.jsx("span", {
      css: _ref$J
    }, elem);
  };

  return react.jsx("div", {
    css: /*#__PURE__*/react.css("display:flex;align-items:center;justify-content:space-between;width:100%;padding:", pxToRem(4), " 0;box-sizing:border-box;", MEDIA_QUERY.min('laptop', /*#__PURE__*/react.css("padding:", pxToRem(4), " ", pxToRem(4), ";")), ";")
  }, renderItem(), react.jsx("button", {
    type: "button",
    onClick: handleDeleteClick,
    css: [/*#__PURE__*/react.css(RESET_BUTTON, " margin-right:", pxToRem(-6), ";padding:", pxToRem(6), ";transition:.1s opacity;font-size:0;line-height:0;border-radius:", pxToRem(2), ";outline:none;"), HOVER(_templateObject$h || (_templateObject$h = _taggedTemplateLiteral(["\n            opacity: .4;\n          "]))), FOCUS(_templateObject2$a || (_templateObject2$a = _taggedTemplateLiteral(["\n            box-shadow: 0 0 0 ", " ", ";\n          "])), pxToRem(3), theme.interactive.primary1.thin)]
  }, react.jsx(Icon, {
    name: "dismiss",
    size: 12,
    fill: function fill(theme) {
      return hovered ? theme.content.base2 : theme.content.base3;
    }
  })));
}

var _excluded$V = ["className", "verticalRatio", "horizontalRatio", "alt"],
    _excluded2$2 = ["className", "verticalRatio", "horizontalRatio", "alt"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$K() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function HorizontalImage(_ref2) {
  var className = _ref2.className,
      verticalRatio = _ref2.verticalRatio,
      horizontalRatio = _ref2.horizontalRatio,
      alt = _ref2.alt,
      rest = _objectWithoutProperties(_ref2, _excluded$V);

  return react.jsx("figure", {
    className: className
  }, react.jsx("img", _extends({}, rest, {
    alt: alt,
    height: 0,
    css: /*#__PURE__*/react.css("height:0;display:block;visibility:hidden;padding-top:", 100 / verticalRatio * horizontalRatio, "%;")
  })));
}

var _ref$I =  true ? {
  name: "upuxee",
  styles: "width:0;height:0;visibility:hidden"
} : 0;

function VerticalImage(_ref3) {
  var className = _ref3.className,
      verticalRatio = _ref3.verticalRatio,
      horizontalRatio = _ref3.horizontalRatio,
      alt = _ref3.alt,
      rest = _objectWithoutProperties(_ref3, _excluded2$2);

  var _useState = React.useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      clientHeight = _useState2[0],
      setClientHeight = _useState2[1];

  return react.jsx("figure", {
    ref: function ref(el) {
      if (el) {
        setClientHeight(el.getBoundingClientRect().height);
      }
    },
    css: /*#__PURE__*/react.css("width:", pxToRem(clientHeight / horizontalRatio * verticalRatio), ";"),
    className: className
  }, react.jsx("img", _extends({}, rest, {
    alt: alt,
    width: 0,
    height: 0,
    css: _ref$I
  })));
}

var _excluded$U = ["src", "src2x", "src3x", "axis", "radius", "aspectRatio"];
function Image(_ref) {
  var _ref$src = _ref.src,
      src = _ref$src === void 0 ? '' : _ref$src,
      _ref$src2x = _ref.src2x,
      src2x = _ref$src2x === void 0 ? src : _ref$src2x,
      _ref$src3x = _ref.src3x,
      src3x = _ref$src3x === void 0 ? src2x : _ref$src3x,
      _ref$axis = _ref.axis,
      axis = _ref$axis === void 0 ? 'width' : _ref$axis,
      _ref$radius = _ref.radius,
      radius = _ref$radius === void 0 ? 0 : _ref$radius,
      aspectRatio = _ref.aspectRatio,
      rest = _objectWithoutProperties(_ref, _excluded$U);

  var _useState = React.useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      url = _useState2[0],
      setUrl = _useState2[1];

  var imageCss = /*#__PURE__*/react.css("display:inline-block;background:no-repeat 50%/cover;border-radius:", pxToRem(radius), ";background-image:url(", src, ");@media only screen and (-webkit-min-device-pixel-ratio: 2),only screen and (min--moz-device-pixel-ratio: 2),only screen and (-o-min-device-pixel-ratio: 2/1),only screen and (min-device-pixel-ratio: 2),only screen and (min-resolution: 2dppx){background-image:url(", src2x, ");}@media only screen and (-webkit-min-device-pixel-ratio: 3),only screen and (min--moz-device-pixel-ratio: 3),only screen and (-o-min-device-pixel-ratio: 3/1),only screen and (min-device-pixel-ratio: 3),only screen and (min-resolution: 3dppx){background-image:url(", src3x, ");}");

  var _aspectRatio$split$ma = aspectRatio.split(':').map(function (ratio) {
    return parseInt(ratio, 10);
  }),
      _aspectRatio$split$ma2 = _slicedToArray(_aspectRatio$split$ma, 2),
      verticalRatio = _aspectRatio$split$ma2[0],
      horizontalRatio = _aspectRatio$split$ma2[1];

  React.useEffect(function () {
    switch (window.devicePixelRatio) {
      case 2:
        setUrl(src2x);
        break;

      case 3:
        setUrl(src3x);
        break;

      default:
        setUrl(src);
        break;
    }
  }, [src, src2x, src3x]);
  return axis === 'width' ? react.jsx(HorizontalImage, _extends({}, rest, {
    src: url,
    verticalRatio: verticalRatio,
    horizontalRatio: horizontalRatio,
    css: imageCss
  })) : react.jsx(VerticalImage, _extends({}, rest, {
    src: url,
    verticalRatio: verticalRatio,
    horizontalRatio: horizontalRatio,
    css: imageCss
  }));
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$J() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$H =  true ? {
  name: "18wgrk7",
  styles: "border-radius:50%"
} : 0;

function CircleImage(_ref2) {
  var rest = _extends({}, _ref2);

  return react.jsx(Image, _extends({}, rest, {
    aspectRatio: "1:1",
    css: _ref$H
  }));
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$I() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$G =  true ? {
  name: "1kghokd",
  styles: "display:flex;align-items:center;overflow:hidden"
} : 0;

var _ref2$h =  true ? {
  name: "7gjpkq",
  styles: "display:flex;align-items:center;justify-content:space-between;white-space:nowrap"
} : 0;

function ConsultingItem(props) {
  var value = props.item.value;
  var theme = react.useTheme();
  var cta = " ".concat(value.info.cta);
  return react.jsx("div", {
    css: _ref2$h
  }, react.jsx("div", {
    css: _ref$G
  }, react.jsx("div", {
    css: /*#__PURE__*/react.css("width:", pxToRem(32), ";height:", pxToRem(32), ";display:flex;align-items:center;justify-content:center;", MEDIA_QUERY.min('laptop', "\n              width: ".concat(pxToRem(24), ";\n              height: ").concat(pxToRem(24), ";\n            ")), ";")
  }, value.info.iconFileUrl ? react.jsx(CircleImage, {
    src: value.info.iconFileUrl,
    css: /*#__PURE__*/react.css("width:100%;border:", pxToRem(0.5), " solid ", theme.outline, ";")
  }) : react.jsx(Icon, {
    name: "search",
    size: 18,
    fill: function fill(theme) {
      return theme.content.base1;
    }
  })), react.jsx("div", {
    css: /*#__PURE__*/react.css("flex:1;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;margin-left:", pxToRem(8), ";")
  }, react.jsx(HighlightedText, props), cta)), react.jsx(Icon, {
    name: "chevron_right",
    size: 18,
    fill: function fill(theme) {
      return theme.content.base3;
    }
  }));
}

var _templateObject$g;

var _excluded$T = ["item", "hovered", "query", "showDivider", "onHover"];
function ListBoxItem(_ref) {
  var item = _ref.item,
      hovered = _ref.hovered,
      query = _ref.query,
      _ref$showDivider = _ref.showDivider,
      showDivider = _ref$showDivider === void 0 ? false : _ref$showDivider,
      onHover = _ref.onHover,
      props = _objectWithoutProperties(_ref, _excluded$T);

  var theme = react.useTheme();
  var ref = React.useRef(null);

  var renderItem = function renderItem() {
    switch (item.type) {
      case 'query':
        return react.jsx(KeywordItem, {
          item: item,
          query: query
        });

      case 'category':
        return react.jsx(CategoryItem, {
          item: item,
          query: query
        });

      case 'consulting':
        return react.jsx(ConsultingItem, {
          item: item,
          query: query
        });

      case 'history':
        return react.jsx(HistoryItem, {
          item: item,
          hovered: hovered
        });

      default:
        return null;
    }
  };

  React.useEffect(function () {
    if (!hovered || !ref.current) return;
    onHover(ref.current);
  }, [hovered, onHover]);
  return react.jsx(React__default['default'].Fragment, null, react.jsx("li", _extends({
    ref: ref,
    role: "option",
    "aria-selected": undefined,
    css: [/*#__PURE__*/react.css(FONT_STYLE.subTitle1, " position:relative;margin:0;padding:", pxToRem(8), " ", pxToRem(16), ";color:", theme.content.base1, ";line-height:", pxToRem(21), ";cursor:pointer;border-radius:", pxToRem(2), ";outline:none;strong{color:", theme.content.primary1.thick, ";font-weight:700;}", hovered && "background: ".concat(theme.background.groupedBase, ";"), " ", MEDIA_QUERY.min('laptop', /*#__PURE__*/react.css(FONT_STYLE.subTitle2, " padding:", pxToRem(8), ";")), ";"), FOCUS(_templateObject$g || (_templateObject$g = _taggedTemplateLiteral(["\n          background: ", ";\n        "])), theme.background.groupedBase)],
    tabIndex: 0
  }, props), renderItem()), showDivider && react.jsx(Divider$1, {
    css: /*#__PURE__*/react.css("margin:", pxToRem(8), " 0;", MEDIA_QUERY.min('laptop', "\n              margin: ".concat(pxToRem(10), " 0;\n            ")), ";"),
    variant: "thin"
  }));
}

var _templateObject$f, _templateObject2$9;

function _EMOTION_STRINGIFIED_CSS_ERROR__$H() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

function filterOnlyHistoryKeyword(items) {
  return items.filter(function (item) {
    return item.type === 'history' && typeof item.value !== 'string' && item.value.type === 'query';
  });
}

var _ref$F =  true ? {
  name: "1xclg2i",
  styles: "margin:0;padding:0"
} : 0;

function ListBox(_ref2) {
  var items = _ref2.items,
      query = _ref2.query,
      hoveredIndex = _ref2.hoveredIndex,
      isHistoryList = _ref2.isHistoryList,
      onItemClick = _ref2.onItemClick,
      onItemMouseEnter = _ref2.onItemMouseEnter;
  var theme = react.useTheme();
  var container = React.useRef(null);
  var log = useLogContext();
  var handleIntersect = React.useCallback(function () {
    if (filterOnlyHistoryKeyword(items).length > 0) {
      log({
        key: 'primary.right.search.history',
        category: 'impression',
        params: {
          type: 'keyword'
        }
      });
    }
  }, [items, log]);
  var isShowDivider = React.useCallback(function (item, index) {
    return index < items.length - 1 && items[index + 1].type !== item.type;
  }, [items]);
  var handleItemHover = React.useCallback(function (item) {
    if (!container.current) return;
    container.current.scrollTop = item.offsetTop - (container.current.offsetHeight - item.offsetHeight) / 2;
  }, []);
  var handleItemClick = React.useCallback(function (item, index) {
    return function () {
      return onItemClick(item, index);
    };
  }, [onItemClick]);
  var handleItemMouseEnter = React.useCallback(function (item, index) {
    return function () {
      return onItemMouseEnter(item, index);
    };
  }, [onItemMouseEnter]);
  return react.jsx(IntersectionObserver, {
    onIntersect: handleIntersect
  }, react.jsx("div", {
    ref: container,
    css: /*#__PURE__*/react.css("overflow-y:auto;position:relative;width:100%;padding:", pxToRem(10), " 0;border:", pxToRem(1), " solid ", theme.divider, ";border-radius:", pxToRem(4), ";background:", theme.background.base, ";box-shadow:0 ", pxToRem(4), " ", pxToRem(6), " 0 ", theme.shadow.basic, ";box-sizing:border-box;", MEDIA_QUERY.min('laptop', "\n          position: absolute;\n          top: calc(100% + ".concat(pxToRem(4), ");\n          left: 0;\n          max-height: ").concat(pxToRem(400), ";\n        ")), " ", MEDIA_QUERY.only('tablet', "\n          top: ".concat(pxToRem(4), ";\n          height: 100%;\n        ")), " ", MEDIA_QUERY.only('mobile', "\n          height: 100%;\n          padding: ".concat(pxToRem(8), " 0;\n          border: 0;\n          box-shadow: none;\n        ")), ";")
  }, !isHistoryList && react.jsx(HistoryListBoxHeader, {
    hasDeleteButton: items.length > 0
  }), items.length > 0 ? react.jsx("ul", {
    css: _ref$F
  }, items.map(function (item, index) {
    return react.jsx(ListBoxItem, {
      key: "".concat(item.query).concat(index),
      item: item,
      query: query,
      hovered: hoveredIndex === index,
      showDivider: isShowDivider(item, index),
      onHover: handleItemHover,
      onClick: handleItemClick(item, index),
      onMouseEnter: handleItemMouseEnter(item, index)
    });
  })) : react.jsx("p", {
    css: /*#__PURE__*/react.css("margin:0;padding:", pxToRem(10), " ", pxToRem(16), ";color:", theme.content.base3, ";font-size:", pxToRem(15), ";line-height:1.4;")
  }, "\uCD5C\uADFC \uAC80\uC0C9\uD55C \uB0B4\uC5ED\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.")));
}

function HistoryListBoxHeader(_ref3) {
  var hasDeleteButton = _ref3.hasDeleteButton;
  var theme = react.useTheme();
  var historyStorage = useHistoryStorage();
  return react.jsx("div", {
    css: /*#__PURE__*/react.css("display:flex;align-items:center;justify-content:space-between;padding:", pxToRem(7), " ", pxToRem(8), " ", pxToRem(10), ";font-size:", pxToRem(15), ";line-height:", pxToRem(21), ";")
  }, react.jsx("span", {
    css: /*#__PURE__*/react.css("font-size:", pxToRem(13), ";color:", theme.content.base2, ";")
  }, "\uCD5C\uADFC \uAC80\uC0C9\uC5B4"), hasDeleteButton && react.jsx("button", {
    type: "button",
    onClick: historyStorage.removeAll,
    css: [/*#__PURE__*/react.css(RESET_BUTTON, " margin:", pxToRem(-2), ";padding:", pxToRem(2), ";font-size:", pxToRem(12), ";color:", theme.content.base2, ";border-radius:", pxToRem(2), ";outline:none;transition:.1s opacity;"), HOVER(_templateObject$f || (_templateObject$f = _taggedTemplateLiteral(["\n              opacity: .4;\n            "]))), FOCUS(_templateObject2$9 || (_templateObject2$9 = _taggedTemplateLiteral(["\n              box-shadow: 0 0 0 ", " ", ";\n            "])), pxToRem(3), theme.interactive.primary1.thin)]
  }, "\uC804\uCCB4 \uC0AD\uC81C"));
}

function getSearchPlaceholder(searchType) {
  return searchType === 'store' && '쇼핑 검색' || searchType === 'expert_user' && '시공업체 검색' || '통합검색';
}

var _excluded$S = ["searchType", "initialQuery", "onFetch", "onSubmit", "onSubmitItem", "onInputFocus", "historyStorage", "placeholder"];
function NavigationSearch(_ref) {
  var searchType = _ref.searchType,
      initialQuery = _ref.initialQuery,
      onFetch = _ref.onFetch,
      onSubmit = _ref.onSubmit,
      onSubmitItem = _ref.onSubmitItem,
      onInputFocus = _ref.onInputFocus,
      historyStorage = _ref.historyStorage,
      placeholder = _ref.placeholder,
      props = _objectWithoutProperties(_ref, _excluded$S);

  var _useState = React.useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      pageKey = _useState2[0],
      setPageKey = _useState2[1];

  var _useState3 = React.useState(initialQuery),
      _useState4 = _slicedToArray(_useState3, 2),
      manuallyTypedInputValue = _useState4[0],
      setManuallyTypedInputValue = _useState4[1];

  var fetchListFromSearchHistory = React.useCallback(function () {
    var history = historyStorage.get();
    return history.map(function (value) {
      return {
        type: 'history',
        value: value,
        query: typeof value === 'string' ? value : value.query
      };
    });
  }, [historyStorage]);
  var fetchList = React.useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(query) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (manuallyTypedInputValue) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", fetchListFromSearchHistory());

            case 2:
              return _context.abrupt("return", onFetch(query));

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [manuallyTypedInputValue, fetchListFromSearchHistory, onFetch]);
  var handleHistoryUpdate = React.useCallback(function () {
    setPageKey(_objectSpread2(_objectSpread2({}, window.location), {}, {
      timestamp: new Date().getTime()
    }));
  }, []);
  var handleSubmit = React.useCallback(function (value) {
    historyStorage.append(value);
    if (onSubmit) onSubmit(value);
  }, [historyStorage, onSubmit]);
  var log = useLogContext();
  var logAutocompleteKeyword = React.useCallback(function (item, index) {
    var params = {
      type: item.type,
      index: index,
      id: item.query
    };

    if (item.type === 'history' && typeof item.value !== 'string') {
      log({
        key: 'primary.right.search.history',
        category: 'click',
        params: _objectSpread2(_objectSpread2({}, params), {}, {
          type: item.value.type
        })
      });
    }

    if (item.type === 'category' || item.type === 'query') {
      log({
        key: "primary.right.search.autocomplete.".concat(item.type),
        category: 'click',
        params: params
      });
    }
  }, [log]);
  var handleSubmitItem = React.useCallback(function (item, index) {
    var value = item.type === 'history' ? item.value : item;
    historyStorage.append(value);
    if (onSubmitItem) onSubmitItem(item);
    logAutocompleteKeyword(item, index);
  }, [historyStorage, onSubmitItem, logAutocompleteKeyword]);
  var handleInputFocus = React.useCallback(function (e) {
    if (onInputFocus) onInputFocus(e);
    log({
      key: 'primary.right.search.input',
      category: 'click',
      params: {
        search_type: searchType
      }
    });
  }, [onInputFocus, log, searchType]);
  return react.jsx(HistoryStorageProvider, {
    get: historyStorage.get,
    set: function set(histories) {
      historyStorage.set(histories);
      handleHistoryUpdate();
    },
    append: function append(history) {
      historyStorage.append(history);
      handleHistoryUpdate();
    },
    remove: function remove(history) {
      historyStorage.remove(history);
      handleHistoryUpdate();
    },
    removeAll: function removeAll() {
      historyStorage.removeAll();
      handleHistoryUpdate();
    }
  }, react.jsx(Search, _extends({
    id: "global-search",
    pageKey: pageKey,
    initialQuery: initialQuery,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : getSearchPlaceholder(searchType),
    fetchList: fetchList,
    getItemQuery: function getItemQuery(item) {
      return item.query;
    },
    renderListBox: function renderListBox(props) {
      return react.jsx(ListBox, _extends({}, props, {
        isHistoryList: !!manuallyTypedInputValue
      }));
    },
    onSubmit: handleSubmit,
    onSubmitItem: handleSubmitItem,
    onInputFocus: handleInputFocus,
    onInputChange: setManuallyTypedInputValue
  }, props)));
}

function Portal(_ref) {
  var children = _ref.children,
      container = _ref.container;
  return reactDom.createPortal(children, container);
}

function BodyPortal(_ref) {
  var children = _ref.children;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      mounted = _useState2[0],
      setMounted = _useState2[1];

  React.useEffect(function () {
    setMounted(true);
    return function () {
      setMounted(false);
    };
  }, []);
  return mounted ? react.jsx(Portal, {
    container: document.body
  }, children) : react.jsx(React__default['default'].Fragment, null);
}

var OverlayContext = React.createContext(null);
function OverlayProvider(_ref) {
  var children = _ref.children;

  var _useState = React.useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      container = _useState2[0],
      setContainer = _useState2[1];

  return react.jsx(OverlayContext.Provider, {
    value: container
  }, children, react.jsx(BodyPortal, null, react.jsx("div", {
    ref: function ref(container) {
      if (container !== null) {
        setContainer(container);
      }
    }
  })));
}
function OverlayPortal(_ref2) {
  var children = _ref2.children;
  var container = React.useContext(OverlayContext);
  return container ? react.jsx(Portal, {
    container: container
  }, children) : react.jsx(React__default['default'].Fragment, null, children);
}

var _excluded$R = ["onDark", "variant", "children"];
var Dim = React.forwardRef(function (props, ref) {
  var onDark = props.onDark,
      variant = props.variant,
      children = props.children,
      rest = _objectWithoutProperties(props, _excluded$R);

  var theme = react.useTheme();
  return react.jsx("div", _extends({}, rest, {
    ref: ref,
    css: [/*#__PURE__*/react.css("position:fixed;top:0;left:0;width:100%;height:100%;text-align:center;z-index:", ZINDEX.modal, ";&::before{content:\"\";height:100%;display:inline-block;vertical-align:middle;}"), variant && /*#__PURE__*/react.css("background-color:", (onDark ? theme.dim.onDark : theme.dim)[variant], ";")]
  }), children);
});

var _templateObject$e, _templateObject2$8;
var KEYFRAMES = {
  overlay: react.keyframes(_templateObject$e || (_templateObject$e = _taggedTemplateLiteral(["\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  "]))),
  drawer: react.keyframes(_templateObject2$8 || (_templateObject2$8 = _taggedTemplateLiteral(["\n    from {\n      transform: translateX(-100%);\n    }\n    to {\n      transform: translateX(0);\n    }\n  "])))
};
var Animation = {
  open: 'open',
  close: 'close'
};
function Drawer(_ref) {
  var open = _ref.open,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'left' : _ref$align,
      width = _ref.width,
      padding = _ref.padding,
      animationKeyframes = _ref.animationKeyframes,
      containerCss = _ref.containerCss,
      children = _ref.children,
      onClose = _ref.onClose,
      onClosed = _ref.onClosed;
  var theme = react.useTheme();
  var scrollAvailableRef = React.useRef(null);

  var _useState = React.useState(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      animation = _useState2[0],
      setAnimation = _useState2[1];

  var _useState3 = React.useState(open),
      _useState4 = _slicedToArray(_useState3, 2),
      visible = _useState4[0],
      setVisible = _useState4[1];

  React.useEffect(function () {
    setAnimation(open ? Animation.open : Animation.close);
  }, [open]);
  React.useEffect(function () {
    if (open) {
      setVisible(true);
    }
  }, [open]);
  var overlayAnimation = (animationKeyframes === null || animationKeyframes === void 0 ? void 0 : animationKeyframes.overlay) || KEYFRAMES.overlay;
  var drawerAnimation = (animationKeyframes === null || animationKeyframes === void 0 ? void 0 : animationKeyframes.drawer) || KEYFRAMES.drawer;
  var handleNavigationClose = React.useCallback(function () {
    onClose();
  }, [onClose]);
  var handleAnimationEnd = React.useCallback(function () {
    if (animation === Animation.open) {
      setAnimation(undefined);
    }

    if (animation === Animation.close) {
      setVisible(false);
      onClosed === null || onClosed === void 0 ? void 0 : onClosed();
    }
  }, [animation, onClosed]);

  if (!visible) {
    return null;
  }

  return react.jsx(OverlayPortal, null, react.jsx(ui.ScrollLock, {
    enabled: open,
    getElement: function getElement() {
      return scrollAvailableRef.current;
    }
  }), react.jsx(Dim, {
    ref: scrollAvailableRef,
    variant: "basic",
    onClick: handleNavigationClose,
    css: /*#__PURE__*/react.css(animation === Animation.open && /*#__PURE__*/react.css("animation:", overlayAnimation, " .2s forwards;"), " ", animation === Animation.close && /*#__PURE__*/react.css("pointer-events:none;animation:", overlayAnimation, " .2s reverse forwards;"), ";")
  }, react.jsx("div", {
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    onAnimationEnd: handleAnimationEnd,
    css: [/*#__PURE__*/react.css("position:absolute;overflow-y:auto;top:0;bottom:0;", align === 'left' ? 'left: 0' : 'right: 0', ";width:", width != null ? "".concat(width, "px") : '100%', ";height:100%;padding:", padding != null ? "".concat(padding[0], " ").concat(padding[1]) : "".concat(pxToRem(26), " ").concat(pxToRem(16)), ";box-sizing:border-box;background:", theme.background.base, ";text-align:left;", animation === Animation.open && /*#__PURE__*/react.css("animation:", drawerAnimation, " .3s forwards;"), " ", animation === Animation.close && /*#__PURE__*/react.css("animation:", drawerAnimation, " .3s reverse forwards;"), ";"), containerCss]
  }, children)));
}

var _excluded$Q = ["className", "onSubmit", "onSubmitItem"];

var _templateObject$d, _templateObject2$7, _templateObject3$3, _templateObject4$1;
var slideIn = react.keyframes(_templateObject$d || (_templateObject$d = _taggedTemplateLiteral(["\n  from {\n    transform: translateX(50px);\n  }\n  to {\n    transform: translateX(0);  \n  }\n"])));
function SearchDrawer(_ref) {
  var className = _ref.className,
      onSubmit = _ref.onSubmit,
      onSubmitItem = _ref.onSubmitItem,
      searchProps = _objectWithoutProperties(_ref, _excluded$Q);

  var theme = react.useTheme();

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var log = useLogContext();
  var drawerAnimation = {
    drawer: slideIn
  };
  var handleDrawerOpen = React.useCallback(function () {
    setOpen(true);
    log({
      key: 'primary.right.search',
      category: 'click'
    });
  }, [log]);
  var handleDrawerClose = React.useCallback(function () {
    setOpen(false);
  }, []);
  var handleSubmit = React.useCallback(function (value) {
    setOpen(false);
    onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(value);
  }, [onSubmit]);
  var handleSubmitItem = React.useCallback(function (item) {
    setOpen(false);
    onSubmitItem === null || onSubmitItem === void 0 ? void 0 : onSubmitItem(item);
  }, [onSubmitItem]);
  return react.jsx("div", {
    css: className
  }, react.jsx("button", {
    type: "button",
    css: [/*#__PURE__*/react.css(RESET_BUTTON, " padding:", pxToRem(6), ";margin:", pxToRem(3), " ", pxToRem(1), ";color:", theme.content.base1, ";line-height:0;outline:none;"), HOVER(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteral(["\n            color: ", ";\n          "])), theme.content.primary1.basic), FOCUS(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteral(["\n            color: ", ";\n          "])), theme.content.primary1.basic)],
    onClick: handleDrawerOpen
  }, react.jsx(Icon, {
    name: "search",
    size: 24
  })), react.jsx(Drawer, {
    open: open,
    align: "right",
    onClose: handleDrawerClose,
    animationKeyframes: drawerAnimation,
    containerCss: /*#__PURE__*/react.css(safeAreaInset('bottom', 'padding-bottom'), " ", MEDIA_QUERY.min('tablet', "\n            min-width: ".concat(pxToRem(256), ";\n            max-width: ").concat(pxToRem(326), ";\n            padding: ").concat(pxToRem(30), ";\n          ")), ";")
  }, react.jsx(NavigationSearch, _extends({}, searchProps, {
    onSubmit: handleSubmit,
    onSubmitItem: handleSubmitItem,
    isInputAutoFocused: true,
    renderInputRight: function renderInputRight() {
      return react.jsx("button", {
        type: "button",
        onClick: handleDrawerClose,
        css: [/*#__PURE__*/react.css(RESET_BUTTON, " flex-shrink:0;margin-left:", pxToRem(15), ";padding:", pxToRem(9), " ", pxToRem(5), " ", pxToRem(10), ";color:", theme.content.base1, ";font-size:", pxToRem(15), ";line-height:1;font-weight:700;outline:none;", MEDIA_QUERY.min('tablet', "\n                    display: none;\n                  "), ";"), FOCUS(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n                  & > span {\n                    box-shadow: 0 0 0 ", " ", ";\n                  }\n                "])), pxToRem(3), theme.interactive.primary1.thin)]
      }, react.jsx("span", {
        css: /*#__PURE__*/react.css("display:inline-block;margin:", pxToRem(-4), ";padding:", pxToRem(4), ";border-radius:", pxToRem(2), ";")
      }, "\uCDE8\uC18C"));
    }
  }))));
}

var _excluded$P = ["renderButton", "onChange", "usePortal", "children"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$G() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

function PopperContent(_ref2) {
  var referenceRef = _ref2.referenceRef,
      isOpen = _ref2.isOpen,
      onClose = _ref2.onClose,
      onExited = _ref2.onExited,
      children = _ref2.children,
      _ref2$placement = _ref2.placement,
      placement = _ref2$placement === void 0 ? 'bottom' : _ref2$placement,
      size = _ref2.size,
      className = _ref2.className,
      style = _ref2.style;
  var theme = react.useTheme();

  var _useState = React.useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      popperRef = _useState2[0],
      setPopperRef = _useState2[1];

  var _usePopper = reactPopper.usePopper(referenceRef, popperRef, {
    placement: placement,
    modifiers: [{
      name: 'offset',
      enabled: true,
      options: {
        offset: [0, 10]
      }
    }]
  }),
      styles = _usePopper.styles,
      attributes = _usePopper.attributes,
      state = _usePopper.state;

  React.useEffect(function () {
    var handleClick = function handleClick(e) {
      var target = e.target; // Chrome regression

      if (e.target === document.body) return;

      if (e.defaultPrevented || target == null || target.parentElement == null) {
        return;
      } // If the user clicked somewhere else, close the popper


      while (target != null) {
        if (referenceRef === target || popperRef === target || target instanceof HTMLElement && target.hasAttribute('data-popout')) {
          return;
        }

        target = target.parentElement;
      }

      onClose();
    };

    window.addEventListener('click', handleClick);
    return function () {
      window.removeEventListener('click', handleClick);
    };
  }, [onClose, referenceRef, popperRef]);
  return react.jsx(reactTransitionGroup.CSSTransition // NOTE: This is a quirky workaround happening due to 'setPopperRef' -
  // which will confuse CSSTransition.
  // In order to workaround this, the timeout is set to 0 until the user
  // decides to close the popper.
  // https://github.com/reactjs/react-transition-group/issues/284
  , {
    "in": popperRef != null && isOpen,
    timeout: isOpen ? 0 : 200,
    classNames: {
      enterActive: 'open',
      enterDone: 'open open-active',
      appearActive: 'open',
      exitActive: 'exiting',
      exit: 'exiting',
      exitDone: 'exiting'
    },
    onExited: onExited
  }, react.jsx("div", _extends({
    ref: setPopperRef,
    style: _objectSpread2(_objectSpread2({}, styles.popper), style)
  }, attributes.popper, {
    className: classNames__default['default']("placement-".concat((state || {}).placement), className),
    css: /*#__PURE__*/react.css("opacity:1;visibility:visible;pointer-events:none;z-index:", ZINDEX.dropdown, ";&.placement-top .popper-item{transform:translate(0, 10px);}&.placement-bottom .popper-item{transform:translate(0, -10px);}&.open{transform:none;transition:.2s opacity;}&.open .popper-item{transform:none;transition:.2s transform;}&.open-active{pointer-events:auto;transition:.2s opacity;}&.exiting{opacity:0;visibility:hidden;transition:0s visibility .2s,.2s opacity;}&.exiting .popper-item{transition:.2s transform;}")
  }), react.jsx("div", {
    className: "popper-item",
    style: styles.offset,
    css: /*#__PURE__*/react.css("position:relative;padding:8px;background-color:", theme.background.base, ";border:1px solid ", theme.interactive.base4, ";border-radius:6px;box-shadow:0 4px 10px 0 rgb(63, 71, 77, 0.2);width:", size ? pxToRem(size) : undefined, ";")
  }, children)));
}

var _ref$E =  true ? {
  name: "1amee4m",
  styles: "line-height:0"
} : 0;

function Popper(_ref3) {
  var renderButton = _ref3.renderButton,
      onChange = _ref3.onChange,
      _ref3$usePortal = _ref3.usePortal,
      usePortal = _ref3$usePortal === void 0 ? true : _ref3$usePortal,
      children = _ref3.children,
      other = _objectWithoutProperties(_ref3, _excluded$P);

  var _useState3 = React.useState({
    isVisible: false,
    isOpen: false
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      state = _useState4[0],
      setState = _useState4[1];

  var referenceRef = React.useRef(null);
  var handleClose = React.useCallback(function () {
    setState(function (v) {
      return _objectSpread2(_objectSpread2({}, v), {}, {
        isOpen: false
      });
    });
  }, []);
  var handleExited = React.useCallback(function () {
    setState({
      isVisible: false,
      isOpen: false
    });
  }, []);
  var handleToggle = React.useCallback(function () {
    setState(function (v) {
      return {
        isOpen: !v.isOpen,
        // If the node is visible, keep it visible. But if we need to reveal it,
        // make it visible
        isVisible: v.isVisible || !v.isOpen
      };
    });
  }, []);
  React.useEffect(function () {
    onChange === null || onChange === void 0 ? void 0 : onChange(state.isOpen);
  }, [state.isOpen, onChange]);
  return react.jsx(React__default['default'].Fragment, null, react.jsx("span", {
    ref: referenceRef,
    css: _ref$E
  }, renderButton({
    onClick: handleToggle
  })), state.isVisible && usePortal && react.jsx(OverlayPortal, null, react.jsx(PopperContent, _extends({
    referenceRef: referenceRef.current,
    isOpen: state.isOpen,
    onClose: handleClose,
    onExited: handleExited
  }, other), children)), state.isVisible && !usePortal && react.jsx(PopperContent, _extends({
    referenceRef: referenceRef.current,
    isOpen: state.isOpen,
    onClose: handleClose,
    onExited: handleExited
  }, other), children));
}

var _templateObject$c, _templateObject2$6;

function _EMOTION_STRINGIFIED_CSS_ERROR__$F() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$D =  true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0;

function UploadDropdownContentItem(_ref2) {
  var href = _ref2.href,
      icon = _ref2.icon,
      title = _ref2.title,
      subTitle = _ref2.subTitle,
      logKey = _ref2.logKey;
  var theme = react.useTheme();
  var LinkComponent = useLinkContext();
  var log = useLogContext();
  return react.jsx(LinkComponent, {
    href: href,
    css: [/*#__PURE__*/react.css("display:flex;align-items:center;padding:", pxToRem(15), ";background-color:", theme.background.base, ";border-radius:", pxToRem(2), ";transition:.1s background-color;word-break:keep-all;white-space:nowrap;font-size:", pxToRem(15), ";line-height:0;outline:none;"), HOVER(_templateObject$c || (_templateObject$c = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "])), theme.background.groupedBase), FOCUS(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteral(["\n          background-color: ", ";\n        "])), theme.background.groupedBase)],
    onClick: function onClick() {
      if (logKey) {
        log({
          key: logKey,
          category: 'click'
        });
      }
    }
  }, react.jsx("div", {
    css: _ref$D
  }, icon), react.jsx("div", {
    css: /*#__PURE__*/react.css("margin-left:", pxToRem(12), ";")
  }, react.jsx("div", {
    css: /*#__PURE__*/react.css("font-size:", pxToRem(15), ";font-weight:bold;line-height:", pxToRem(21), ";color:", theme.content.base1, ";")
  }, title), react.jsx("div", {
    css: /*#__PURE__*/react.css("margin:", pxToRem(4), " 0 0;font-size:", pxToRem(12), ";line-height:", pxToRem(16), ";color:", theme.content.base2, ";")
  }, subTitle)));
}

var _templateObject$b;

function _EMOTION_STRINGIFIED_CSS_ERROR__$E() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var PhotoIcon = function PhotoIcon(props) {
  return react.jsx("svg", props, react.jsx("rect", {
    x: "6.54",
    y: "3.59",
    width: "27",
    height: "29",
    rx: "2.5",
    transform: "rotate(4 6.54 3.6)",
    fill: "#DBDBDB",
    stroke: "#000",
    strokeLinejoin: "round"
  }), react.jsx("rect", {
    x: "2.5",
    y: "1.5",
    width: "27",
    height: "29",
    rx: "2.5",
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "round"
  }), react.jsx("rect", {
    x: "5",
    y: "4",
    width: "22",
    height: "22",
    rx: "1",
    fill: "#FFE2C7"
  }), react.jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 7l5 .45v3.5l-5-.45V7zm0 4.5V15l5 .45v-3.5l-5-.45zm6 .55v3.5l5 .45v-3.5l-5-.45zm5-.55V8l-5-.45v3.5l5 .45z",
    fill: "#fff"
  }), react.jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 19l22 2v7L5 26v-7z",
    fill: "#E6A87C"
  }), react.jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3.45h5v16l-5 4v-20z",
    fill: "#F1C8A3"
  }));
};

PhotoIcon.defaultProps = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 36 36",
  width: "36",
  height: "36"
};

var ProjectIcon = function ProjectIcon(props) {
  return react.jsx("svg", props, react.jsx("g", {
    fill: "none",
    fillRule: "evenodd"
  }, react.jsx("path", {
    d: "M0 0h36v36H0z"
  }), react.jsx("path", {
    fill: "#FFF6E6",
    d: "M27.2 29.31H4.8V14.38h22.4"
  }), react.jsx("path", {
    fill: "#EDE2CD",
    d: "M27.2 17.18H4.8v-2.8h22.4"
  }), react.jsx("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.8 29.31V14.38h22.4v14.93H4.8z"
  }), react.jsx("path", {
    fill: "#FFF",
    d: "M16 19.05a4.67 4.67 0 014.67 4.66v5.6h-9.34v-5.6A4.67 4.67 0 0116 19.05z"
  }), react.jsx("path", {
    fill: "#fff",
    d: "M16 19.05a4.67 4.67 0 014.67 4.66v5.6h-9.34v-5.6A4.67 4.67 0 0116 19.05z"
  }), react.jsx("path", {
    stroke: "#000",
    d: "M16 19.05a4.67 4.67 0 014.67 4.66v5.6h-9.34v-5.6A4.67 4.67 0 0116 19.05z"
  }), react.jsx("path", {
    fill: "#FBDEC1",
    d: "M2.94 14.38a.9.9 0 01-.81-1.3l3.25-6.6a.9.9 0 01.8-.5h19.64c.34 0 .65.2.8.5l3.25 6.6a.9.9 0 01-.8 1.3H2.93z"
  }), react.jsx("path", {
    fill: "#E9C39D",
    d: "M2.94 14.38a.9.9 0 01-.81-1.3l.74-1.5h26.26l.74 1.5a.9.9 0 01-.8 1.3H2.92z"
  }), react.jsx("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.94 14.38a.9.9 0 01-.81-1.3l3.25-6.6a.9.9 0 01.8-.5h19.64c.34 0 .65.2.8.5h0l3.25 6.6a.9.9 0 01-.8 1.3h0H2.93z"
  }), react.jsx("g", {
    transform: "translate(26 9)"
  }, react.jsx("path", {
    fill: "#fff",
    d: "M0 5h8.07v12H0z"
  }), react.jsx("path", {
    fill: "#ffdb92",
    d: "M0 0h8v4H0z"
  }), react.jsx("path", {
    d: "M8.5 17.43H-.52 8.5L4 23.8l-4.52-6.37H8.5",
    fill: "#fff6e6"
  }), react.jsx("path", {
    d: "M8.5 1v0A1.49 1.49 0 007-.5H1v0A1.5 1.5 0 00-.5 1l-.02 16.43L4 23.8l4.5-6.37z",
    stroke: "#000"
  }), react.jsx("path", {
    fill: "#000",
    d: "M4 23l2-2H2z"
  }), react.jsx("rect", {
    width: "6",
    height: "2",
    x: "-14",
    y: "3",
    stroke: "#000",
    rx: "1",
    transform: "rotate(-90)",
    ry: "1"
  }), react.jsx("rect", {
    width: "5",
    height: "1",
    x: "-13.5",
    y: "3.5",
    fill: "#ffdb92",
    rx: ".5",
    transform: "rotate(-90)",
    ry: ".5"
  }), react.jsx("path", {
    fill: "#000",
    d: "M0 4h8v1H0z",
    opacity: ".9"
  }), react.jsx("path", {
    d: "M-.52 17.43H8.5",
    stroke: "#000"
  })), react.jsx("path", {
    fill: "#000",
    d: "M30 32l2-2h-4z"
  })));
};

ProjectIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "36",
  viewBox: "0 0 36 36"
};

var AdviceIcon = function AdviceIcon(props) {
  return react.jsx("svg", props, react.jsx("g", {
    fill: "none",
    fillRule: "evenodd"
  }, react.jsx("path", {
    d: "M0 0h36v36H0z"
  }), react.jsx("path", {
    fill: "#EDEDED",
    d: "M17 10h2v22h-2z"
  }), react.jsx("path", {
    fill: "#FFF",
    d: "M3 10.2c3.65-1.07 6.98-1.07 10 0h10.16c2.98-1 6.26-1 9.84 0v21c-5.79-1.62-10.79-1.29-15 1-4.21-2.37-9.21-2.7-15-1z"
  }), react.jsx("path", {
    fill: "#EDEDED",
    d: "M16.5 15h3v16c-.66.8-1.16 1.2-1.5 1.2-.34 0-.84-.4-1.5-1.2V15z"
  }), react.jsx("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 10.2c3.65-1.07 6.98-1.07 10 0h10.16c2.98-1 6.26-1 9.84 0h0v1.97h0V31.2c-5.79-1.62-10.79-1.29-15 1-4.21-2.37-9.21-2.7-15-1z"
  }), react.jsx("g", {
    transform: "translate(11 3)"
  }, react.jsx("path", {
    fill: "#FFDB92",
    stroke: "#000",
    d: "M7 0a7 7 0 013 13.33V17H4v-3.67A7 7 0 017 0z"
  }), react.jsx("path", {
    stroke: "#000",
    strokeLinecap: "square",
    d: "M7 15.68V8.5"
  }), react.jsx("circle", {
    cx: "7",
    cy: "7.5",
    r: "1.5",
    fill: "#000"
  }), react.jsx("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 16h8v7H3z"
  }), react.jsx("path", {
    stroke: "#000",
    strokeLinecap: "square",
    d: "M3 18.5h8m-8 2h8"
  }))));
};

AdviceIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "36",
  viewBox: "0 0 36 36"
};

var ProductReviewIcon = function ProductReviewIcon(props) {
  return react.jsx("svg", props, react.jsx("g", {
    fill: "none",
    fillRule: "evenodd"
  }, react.jsx("path", {
    d: "M0 0h36v36H0z"
  }), react.jsx("g", {
    strokeLinejoin: "round",
    transform: "translate(2 3)"
  }, react.jsx("rect", {
    width: "4",
    height: "8",
    x: "3",
    y: "21",
    fill: "#FFB787",
    stroke: "#000",
    rx: "2"
  }), react.jsx("rect", {
    fill: "#FFE2C7",
    width: "24",
    height: "25",
    rx: "3"
  }), react.jsx("rect", {
    fill: "#ffe2c7",
    width: "24",
    height: "25",
    rx: "3"
  }), react.jsx("rect", {
    stroke: "#000",
    width: "24",
    height: "25",
    rx: "3",
    strokeWidth: "1.2"
  }), react.jsx("rect", {
    width: "6",
    height: "3",
    x: "9",
    y: "5",
    fill: "#DB9F77",
    stroke: "#FFF",
    rx: "1.5"
  }), react.jsx("rect", {
    width: "6",
    height: "3",
    x: "9",
    y: "17",
    fill: "#DB9F77",
    stroke: "#FFF",
    rx: "1.5"
  }), react.jsx("path", {
    fill: "#FFDB92",
    stroke: "#EDC29B",
    d: "M1.5 12.5h21"
  })), react.jsx("path", {
    fill: "#35C5F0",
    d: "M26.25 31.53l-3.7 1.32a1 1 0 01-1.34-.97l.1-3.93a.99.99 0 00-.2-.64l-2.4-3.11a1 1 0 01.51-1.57l3.77-1.12a1 1 0 00.55-.39l2.22-3.24a1 1 0 011.65 0l2.22 3.24a1 1 0 00.55.4l3.77 1.1a1 1 0 01.5 1.58l-2.4 3.11a1 1 0 00-.2.64l.11 3.93a1 1 0 01-1.33.97l-3.71-1.32a1 1 0 00-.67 0z"
  }), react.jsx("path", {
    fill: "#9AE2F7",
    d: "M27.15 17.61a1 1 0 01.26.26l2.22 3.25c.06.09.13.16.22.23l-8.59 8.58.06-1.98a.99.99 0 00-.21-.64l-2.4-3.11a1 1 0 01.51-1.57l3.77-1.12a1 1 0 00.55-.39l2.22-3.24a1 1 0 011.39-.26z"
  }), react.jsx("path", {
    stroke: "#000",
    d: "M26.29 30.85l-3.31 1.17a.9.9 0 01-1.2-.86l.1-3.51c0-.2-.06-.4-.18-.57l-2.14-2.78a.9.9 0 01.45-1.4l3.37-.99a.9.9 0 00.48-.35l1.99-2.9a.9.9 0 011.47 0l1.99 2.9c.11.17.28.3.48.35l3.37 1a.9.9 0 01.45 1.4l-2.14 2.77a.89.89 0 00-.18.57l.1 3.5a.9.9 0 01-1.2.87l-3.3-1.17a.9.9 0 00-.6 0z",
    strokeWidth: "1.2"
  })));
};

ProductReviewIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "36",
  viewBox: "0 0 36 36"
};

var ProReviewIcon = function ProReviewIcon(props) {
  return react.jsx("svg", props, react.jsx("g", {
    fill: "none",
    fillRule: "evenodd"
  }, react.jsx("path", {
    d: "M0 0h36v36H0z"
  }), react.jsx("path", {
    fill: "#FFDB92",
    d: "M13.75 3.52h1.9a8.1 8.1 0 018.1 8.1v1.9H5.65v-1.9a8.1 8.1 0 018.1-8.1z"
  }), react.jsx("path", {
    fill: "#FFDB92",
    d: "M12 3h5v2h-5z"
  }), react.jsx("path", {
    fill: "#FFF",
    d: "M12.2 23.92h5.4a7.2 7.2 0 017.2 7.2v2.8H5v-2.8a7.2 7.2 0 017.2-7.2z"
  }), react.jsx("path", {
    fill: "#EDEDED",
    fillOpacity: ".14",
    d: "M17.6 23.92c1.2 0 2.33.3 3.32.8a10.84 10.84 0 01-6.19 1.78c-2.28 0-4.38-.57-6.04-1.67a7.15 7.15 0 013.51-.91h5.4z"
  }), react.jsx("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5 33.59V30.9a6.59 6.59 0 015.47-6.37"
  }), react.jsx("path", {
    d: "M10.64 24.6v3.19",
    fillRule: "nonzero",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), react.jsx("path", {
    fill: "#B1C0CB",
    fillRule: "nonzero",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.9 33.92l.98-6H21.9l.98 6"
  }), react.jsx("path", {
    fill: "#FFF6E6",
    fillRule: "nonzero",
    d: "M22.04 14.29c.31.9.48 2.3.48 3.31 0 4.65-3.49 7.2-7.79 7.2s-7.78-2.55-7.78-7.2c0-1.02.17-2.4.48-3.31"
  }), react.jsx("path", {
    fill: "#EDE2CD",
    fillRule: "nonzero",
    d: "M22.04 14.29c.16.48.29 1.09.37 1.71H7.06c.08-.62.2-1.23.37-1.71h14.6z"
  }), react.jsx("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M22.04 14.29c.31.9.48 2.3.48 3.31 0 4.65-3.49 7.2-7.79 7.2s-7.78-2.55-7.78-7.2c0-1.02.17-2.4.48-3.31"
  }), react.jsx("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.29 20.9c-.23.46-.84.79-1.56.79-.72 0-1.33-.33-1.56-.78"
  }), react.jsx("path", {
    d: "M12 17.55V17m5.46.55V17",
    fillRule: "nonzero",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.3"
  }), react.jsx("path", {
    fill: "#EFC570",
    d: "M9.5 5l2.88 4.72v-5.9zM19.94 5l-2.89 4.72v-5.9z"
  }), react.jsx("g", {
    stroke: "#000",
    strokeLinecap: "round"
  }, react.jsx("path", {
    strokeLinejoin: "round",
    d: "M5.75 11.76c0-4.08 2.9-7.45 6.63-7.94v-.3c0-.55.43-1 .95-1h2.84c.53 0 .95.45.95 1v.3c3.74.5 6.63 3.86 6.63 7.94"
  }), react.jsx("path", {
    d: "M12.38 5.52v-2c0-.55.43-1 .95-1h2.84c.53 0 .95.45.95 1v2"
  }), react.jsx("path", {
    fill: "#F5F5F5",
    fillRule: "nonzero",
    d: "M4.2 14.02h20.7"
  })), react.jsx("g", null, react.jsx("path", {
    fill: "#35C5F0",
    d: "M26.25 33.1l-3.71 1.31a1 1 0 01-1.34-.97l.11-3.93a.99.99 0 00-.2-.64l-2.4-3.11a1 1 0 01.5-1.57L23 23.07a1 1 0 00.54-.39l2.23-3.24a1 1 0 011.65 0l2.22 3.24a1 1 0 00.54.4l3.78 1.1a1 1 0 01.5 1.58l-2.4 3.11a1 1 0 00-.2.64l.1 3.93a1 1 0 01-1.33.97l-3.7-1.32a1 1 0 00-.67 0z"
  }), react.jsx("path", {
    fill: "#9AE2F7",
    d: "M27.15 19.18a1 1 0 01.26.26l2.22 3.24c.06.09.13.16.21.23l-8.58 8.58.05-1.98a.99.99 0 00-.2-.64l-2.4-3.11a1 1 0 01.5-1.57L23 23.07a1 1 0 00.54-.39l2.23-3.24a1 1 0 011.39-.26z"
  }), react.jsx("path", {
    stroke: "#000",
    d: "M26.25 33.1l-3.71 1.31a1 1 0 01-1.34-.97l.11-3.93a.99.99 0 00-.2-.64l-2.4-3.11a1 1 0 01.5-1.57L23 23.07a1 1 0 00.54-.39l2.23-3.24a1 1 0 011.65 0l2.22 3.24a1 1 0 00.54.4l3.78 1.1a1 1 0 01.5 1.58l-2.4 3.11a1 1 0 00-.2.64l.1 3.93a1 1 0 01-1.33.97l-3.7-1.32a1 1 0 00-.67 0z"
  }))));
};

ProReviewIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "36",
  viewBox: "0 0 36 36"
};
var BUTTON_SIZE = 40;

var _ref$C =  true ? {
  name: "12whrtl",
  styles: "outline:none;overflow:hidden"
} : 0;

function UploadDropdownContentButton(_ref2) {
  var uploadMenuLinks = _ref2.uploadMenuLinks;
  var theme = react.useTheme();
  var log = useLogContext();

  var _getWithIconOptions = getWithIconOptions(BUTTON_SIZE),
      gap = _getWithIconOptions.gap,
      iconSize = _getWithIconOptions.iconSize;

  return react.jsx(Popper, {
    usePortal: false,
    renderButton: function renderButton(_ref3) {
      var _onClick = _ref3.onClick;
      return react.jsx(Button$1, {
        variant: "primary1",
        size: BUTTON_SIZE,
        type: "button",
        css: [_ref$C, FOCUS(_templateObject$b || (_templateObject$b = _taggedTemplateLiteral(["\n              box-shadow: 0 0 0 ", " ", ";\n            "])), pxToRem(3), theme.interactive.primary1.thin)],
        onClick: function onClick() {
          _onClick();

          log({
            key: 'primary.right.upload',
            category: 'click'
          });
        }
      }, react.jsx("span", {
        css: /*#__PURE__*/react.css("vertical-align:middle;white-space:nowrap;", MEDIA_QUERY.min('laptop', "\n                margin-right: ".concat(pxToRem(gap), ";\n              ")), ";")
      }, "\uAE00\uC4F0\uAE30"), react.jsx(Icon, {
        css: /*#__PURE__*/react.css("vertical-align:middle;display:none;", MEDIA_QUERY.min('laptop', "\n                display: inline-block;\n              "), ";"),
        name: "chevron_down",
        size: iconSize
      }));
    }
  }, react.jsx(React__default['default'].Fragment, null, getUploadMenus(uploadMenuLinks).map(function (item) {
    return react.jsx(UploadDropdownContentItem, _extends({
      key: item.title,
      logKey: item.logKey
    }, item));
  })));
}

function getUploadMenus(menuLinks) {
  return [{
    href: (menuLinks === null || menuLinks === void 0 ? void 0 : menuLinks.photo) || 'https://ohou.se/contents/card_collections/new',
    icon: react.jsx(PhotoIcon, null),
    title: '사진/동영상 올리기',
    subTitle: '우리 집의 공간과 나의 일상을 기록해 보세요.',
    logKey: 'primary.right.upload.photo'
  }, {
    href: (menuLinks === null || menuLinks === void 0 ? void 0 : menuLinks.project) || 'https://ohou.se/projects/write',
    icon: react.jsx(ProjectIcon, null),
    title: '집들이 글쓰기',
    subTitle: '집에 관한 이야기를 글로 작성해 보세요.'
  }, {
    href: (menuLinks === null || menuLinks === void 0 ? void 0 : menuLinks.advice) || 'https://ohou.se/advices/write',
    icon: react.jsx(AdviceIcon, null),
    title: '노하우 글쓰기',
    subTitle: '다양한 인테리어 노하우를 공유해 주세요.'
  }, {
    href: (menuLinks === null || menuLinks === void 0 ? void 0 : menuLinks.productionReview) || 'https://ohou.se/production_reviews/write',
    icon: react.jsx(ProductReviewIcon, null),
    title: '상품 리뷰 쓰기',
    subTitle: '상품 리뷰를 작성하고 포인트도 받아 보세요.'
  }, {
    href: (menuLinks === null || menuLinks === void 0 ? void 0 : menuLinks.expertReview) || 'https://ohou.se/expert_reviews/new?source=6',
    icon: react.jsx(ProReviewIcon, null),
    title: '시공 전문가 리뷰쓰기',
    subTitle: '시공 전문가 리뷰를 작성하고 포인트도 받아 보세요.'
  }];
}

var _templateObject$a, _templateObject2$5;

function _EMOTION_STRINGIFIED_CSS_ERROR__$D() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var NewIcon$1 = function NewIcon(props) {
  return react.jsx("svg", props, react.jsx("path", {
    d: "M0 9a9 9 0 1118 0A9 9 0 010 9z",
    fill: "#fff"
  }), react.jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 18A9 9 0 109 0a9 9 0 000 18zm-1.7-5.25H5.26v-7.5h2.61l2.8 4.2h.03v-4.2h2.06v7.5h-2.3L7.36 8.07h-.05v4.68z",
    fill: "#F77"
  }));
};

NewIcon$1.defaultProps = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18",
  width: "18",
  height: "18"
};

var _ref$B =  true ? {
  name: "1dnrp50",
  styles: "vertical-align:middle;margin:0 1.5px 1.5px 0"
} : 0;

function UserDropdownContentItem(_ref2) {
  var bullet = _ref2.bullet,
      title = _ref2.title,
      href = _ref2.href,
      _onClick = _ref2.onClick,
      logKey = _ref2.logKey;
  var theme = react.useTheme();
  var LinkComponent = useLinkContext();
  var log = useLogContext();
  var Component = href ? LinkComponent : 'button';
  return react.jsx(Component, _extends({}, Component === LinkComponent ? {
    href: href
  } : {
    type: 'button'
  }, {
    css: [/*#__PURE__*/react.css("display:block;position:relative;width:100%;margin:0;padding:", pxToRem(10), " ", pxToRem(14), " ", pxToRem(11), ";box-sizing:border-box;border:none;background:", theme.background.base, ";color:", theme.content.base1, ";font-family:inherit;font-weight:normal;font-size:", pxToRem(15), ";line-height:", pxToRem(21), ";text-decoration:none;text-align:left;cursor:pointer;border-radius:", pxToRem(2), ";outline:none;"), HOVER(_templateObject$a || (_templateObject$a = _taggedTemplateLiteral(["\n          background: ", ";\n        "])), theme.background.groupedBase), FOCUS(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteral(["\n          background: ", ";\n        "])), theme.background.groupedBase)],
    onClick: function onClick() {
      if (logKey) {
        log({
          key: logKey,
          category: 'click'
        });
      }

      if (_onClick) {
        _onClick();
      }
    }
  }), title, bullet === 'new' && react.jsx(NewIcon$1, {
    css: _ref$B
  }));
}

var _templateObject$9, _templateObject2$4;

function _EMOTION_STRINGIFIED_CSS_ERROR__$C() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var DEFAULT_PROFILE_URL = 'https://image.ohou.se/i/bucketplace-v2-development/uploads/users/profile_images1542987307_LkcmI.jpeg';

var _ref$A =  true ? {
  name: "xnm8en",
  styles: "vertical-align:middle;width:100%;height:100%;object-fit:cover"
} : 0;

function UserDropdownContentButton(_ref2) {
  var profileUrl = _ref2.profileUrl,
      userMenu = _ref2.userMenu;
  var theme = react.useTheme();
  var items = React.useMemo(function () {
    return userMenu.filter(function (menu) {
      var _menu$showOn;

      return (_menu$showOn = menu.showOn) === null || _menu$showOn === void 0 ? void 0 : _menu$showOn.includes('bar');
    });
  }, [userMenu]);
  return react.jsx(Popper, {
    usePortal: false,
    renderButton: function renderButton(_ref3) {
      var onClick = _ref3.onClick;
      return react.jsx("button", {
        css: [/*#__PURE__*/react.css(RESET_BUTTON, " position:relative;overflow:hidden;width:", pxToRem(40), ";height:", pxToRem(40), ";border-radius:100%;outline:none;&:after{content:'';display:none;position:absolute;top:0;left:0;width:100%;height:100%;border-radius:100%;border:", pxToRem(2), " solid ", theme.content.primary1.basic, ";box-sizing:border-box;}"), HOVER(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral(["\n              &:after {\n                display: block;\n              }\n            "]))), FOCUS(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteral(["\n              &:after {\n                display: block;\n              }\n            "])))],
        type: "button",
        onClick: onClick,
        "aria-label": "\uD504\uB85C\uD544 \uBA54\uB274"
      }, react.jsx(ui.ResizeImage, {
        width: 40,
        aspect: 1,
        src: profileUrl || DEFAULT_PROFILE_URL,
        alt: "\uD504\uB85C\uD544 \uC0AC\uC9C4",
        css: _ref$A
      }));
    }
  }, react.jsx("div", {
    css: /*#__PURE__*/react.css("width:", pxToRem(184), ";")
  }, items.map(function (item, index) {
    return react.jsx(UserDropdownContentItem, _extends({
      key: index
    }, item));
  })));
}

var _excluded$O = ["count", "maxCount"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$B() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$z =  true ? {
  name: "a4hmbt",
  styles: "position:absolute"
} : 0;

function NumberNotification(_ref2) {
  var count = _ref2.count,
      maxCount = _ref2.maxCount,
      rest = _objectWithoutProperties(_ref2, _excluded$O);

  return react.jsx(CircleBadge, _extends({}, rest, {
    size: 16,
    type: "fill",
    variant: "primary2",
    css: _ref$z
  }), maxCount < count ? "+".concat(maxCount) : count);
}

var _templateObject$8, _templateObject2$3;

var _excluded$N = ["component", "iconName", "type", "count"];
var NotificationType = {
  Dot: 'DOT',
  Number: 'NUMBER',
  None: 'NONE'
};
function IconNotification(_ref) {
  var _ref$component = _ref.component,
      component = _ref$component === void 0 ? 'div' : _ref$component,
      iconName = _ref.iconName,
      type = _ref.type,
      _ref$count = _ref.count,
      count = _ref$count === void 0 ? 0 : _ref$count,
      restProps = _objectWithoutProperties(_ref, _excluded$N);

  var theme = react.useTheme();
  var Component = component;
  return react.jsx(Component // FIXME: 이거 IconNotification에서 높이를 임의로 지정하면 안될 것 같아요
  // NOTE: 디자인에서는 아이콘마다 14px의 거리를 규정하고 있습니다. 즉, 각 아이콘이
  //       한 방향에서 가질 수 있는 가로 padding+margin은 7px까지입니다.
  , _extends({
    css: [/*#__PURE__*/react.css("position:relative;display:inline-block;padding:", pxToRem(6), ";margin:", pxToRem(3), " ", pxToRem(1), ";color:", theme.content.base1, ";line-height:0;outline:none;", MEDIA_QUERY.min('tablet', "\n            margin: ".concat(pxToRem(9), " ").concat(pxToRem(1), ";\n          ")), ";"), HOVER(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral(["\n          color: ", ";\n        "])), theme.content.primary1.basic), FOCUS(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral(["\n          color: ", ";\n        "])), theme.content.primary1.basic)]
  }, restProps), react.jsx(Icon, {
    css: /*#__PURE__*/react.css("font-size:", pxToRem(24), ";"),
    name: iconName,
    size: 24
  }), type === NotificationType.Dot && react.jsx(DotNotification, null), type === NotificationType.Number && count > 0 && react.jsx("span", {
    css: /*#__PURE__*/react.css("position:absolute;top:0;right:", pxToRem(20), ";")
  }, react.jsx(NumberNotification, {
    count: count,
    maxCount: 99
  })));
}

var _excluded$M = ["component", "label", "href", "logKey"];
function NoLoginMenuItem(_ref) {
  var _ref$component = _ref.component,
      component = _ref$component === void 0 ? 'a' : _ref$component,
      label = _ref.label,
      href = _ref.href,
      logKey = _ref.logKey,
      rest = _objectWithoutProperties(_ref, _excluded$M);

  var theme = react.useTheme();
  var Component = component;
  var log = useLogContext();
  return react.jsx(Component, _extends({}, rest, {
    href: href,
    css: /*#__PURE__*/react.css(FONT_STYLE.subTitle2, ";color:", theme.content.base1, ";padding:0 10px;border-left:1px solid ", theme.content.base4, ";&:first-of-type{border-left:none;}"),
    onClick: function onClick() {
      return log({
        key: logKey,
        category: 'click'
      });
    }
  }), label);
}

var _excluded$L = ["userableType"];
var SELLER_USERABLE_TYPE = 'SalesUser';
var SellerButton = React.memo(function (_ref) {
  var userableType = _ref.userableType,
      rest = _objectWithoutProperties(_ref, _excluded$L);

  if (userableType !== SELLER_USERABLE_TYPE) {
    return null;
  }

  return react.jsx(OutlineAnchorButton, _extends({
    css: /*#__PURE__*/react.css("display:none;margin-left:8px;", MEDIA_QUERY.min('laptop', "\n          display: flex;\n          align-items: center;\n        "), ";"),
    variant: "base1",
    size: 40
  }, rest), "\uD310\uB9E4\uC790 \uC804\uC6A9\uC11C\uBE44\uC2A4");
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$A() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$y =  true ? {
  name: "1kpxvh4",
  styles: "display:flex;margin:0 10px 0 8px"
} : 0;

var _ref2$g =  true ? {
  name: "10vibjk",
  styles: "display:flex;align-items:center;justify-content:flex-end;line-height:0"
} : 0;

function PrimaryRight(_ref3) {
  var searchProps = _ref3.searchProps,
      userProfile = _ref3.userProfile,
      userMenu = _ref3.userMenu,
      scrap = _ref3.scrap,
      cart = _ref3.cart,
      notification = _ref3.notification,
      signin = _ref3.signin,
      signup = _ref3.signup,
      cs = _ref3.cs,
      seller = _ref3.seller,
      uploadMenuLinks = _ref3.uploadMenuLinks;
  var LinkComponent = useLinkContext();
  var log = useLogContext();

  var _ref4 = userProfile || {},
      userId = _ref4.userId,
      imageUrl = _ref4.imageUrl;

  var loggedIn = userId != null;
  return react.jsx("div", {
    css: _ref2$g
  }, searchProps && react.jsx(React__default['default'].Fragment, null, react.jsx(NavigationSearch, _extends({
    css: /*#__PURE__*/react.css("flex:1 1 0px;min-width:0;margin-right:", pxToRem(9), ";", MEDIA_QUERY.min('desktop', "\n                margin-right: ".concat(pxToRem(14), ";\n              ")), " ", MEDIA_QUERY.max('tablet', "\n                display: none;\n              "), ";")
  }, searchProps)), react.jsx(SearchDrawer, _extends({
    css: /*#__PURE__*/react.css(MEDIA_QUERY.min('laptop', "\n                display: none;\n              "), ";")
  }, searchProps))), loggedIn && react.jsx("div", {
    css: /*#__PURE__*/react.css(MEDIA_QUERY.max('mobile', "\n              display: none;\n            "), ";")
  }, react.jsx(IconNotification, {
    iconName: "scrap_outline",
    type: NotificationType.None,
    component: LinkComponent,
    "aria-label": "\uC2A4\uD06C\uB7A9\uBD81 \uD398\uC774\uC9C0 \uB9C1\uD06C \uBC84\uD2BC",
    href: scrap.href,
    onClick: function onClick() {
      return log({
        key: 'primary.right.scrap',
        category: 'click'
      });
    }
  })), loggedIn && react.jsx("div", {
    css: /*#__PURE__*/react.css(MEDIA_QUERY.max('mobile', "\n              display: none;\n            "), ";")
  }, react.jsx(IconNotification, {
    iconName: "notification_outline",
    type: NotificationType.Number,
    count: notification.count,
    component: LinkComponent,
    href: notification.href,
    "aria-label": "\uB0B4\uC18C\uC2DD \uD398\uC774\uC9C0 \uB9C1\uD06C \uBC84\uD2BC",
    onClick: function onClick() {
      return log({
        key: 'primary.right.notification',
        category: 'click'
      });
    }
  })), react.jsx(IconNotification, {
    iconName: "cart",
    type: NotificationType.Number,
    count: cart.count,
    component: LinkComponent,
    href: cart.href,
    "aria-label": "\uC7A5\uBC14\uAD6C\uB2C8 \uD398\uC774\uC9C0 \uB9C1\uD06C \uBC84\uD2BC",
    onClick: function onClick() {
      return log({
        key: 'primary.right.cart',
        category: 'click'
      });
    }
  }), react.jsx("div", {
    css: /*#__PURE__*/react.css("display:flex;align-items:center;", MEDIA_QUERY.max('mobile', "\n            display: none;\n          "), ";")
  }, loggedIn ? react.jsx("div", {
    css: /*#__PURE__*/react.css("margin:0 ", pxToRem(12), " 0 ", pxToRem(5), ";", MEDIA_QUERY.min('laptop', "\n                margin: 0 ".concat(pxToRem(16), " 0 ").concat(pxToRem(9), ";\n              ")), " ", MEDIA_QUERY.min('desktop', "\n                margin: 0 ".concat(pxToRem(20), " 0 ").concat(pxToRem(13), ";\n              ")), ";")
  }, react.jsx(UserDropdownContentButton, {
    profileUrl: imageUrl,
    userMenu: userMenu
  })) : react.jsx("div", {
    css: _ref$y
  }, react.jsx(NoLoginMenuItem, {
    label: "\uB85C\uADF8\uC778",
    href: signin.href,
    component: LinkComponent,
    logKey: "primary.right.login"
  }), react.jsx(NoLoginMenuItem, {
    label: "\uD68C\uC6D0\uAC00\uC785",
    href: signup.href,
    component: LinkComponent,
    logKey: "primary.right.signup"
  }), react.jsx(NoLoginMenuItem, {
    label: "\uACE0\uAC1D\uC13C\uD130",
    href: cs.href,
    component: LinkComponent,
    logKey: "primary.right.cs",
    css: /*#__PURE__*/react.css(MEDIA_QUERY.max('laptop', "\n                  display: none;\n                "), ";")
  })), react.jsx(UploadDropdownContentButton, {
    uploadMenuLinks: uploadMenuLinks
  }), react.jsx(SellerButton, {
    href: seller.href
  })));
}

var _templateObject$7;

var _excluded$K = ["logo", "children"];

var LogoIcon$1 = function LogoIcon(props) {
  return react.jsx("svg", props, react.jsx("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.2 25.17H9.28V20.7a1.45 1.45 0 00-2.9 0v4.47H1.44a1.45 1.45 0 100 2.9H14.2a1.45 1.45 0 000-2.9zM4.5 9.15c0-4.6 2.08-5.28 3.33-5.28 1.24 0 3.33.69 3.33 5.28v.36c0 4.6-2.09 5.28-3.33 5.28-1.25 0-3.34-.69-3.34-5.28v-.36zm3.33 8.54c3.84 0 6.23-3.13 6.23-8.18v-.36c0-5.05-2.39-8.18-6.23-8.18-3.85 0-6.24 3.13-6.24 8.18v.36c0 5.05 2.39 8.18 6.24 8.18zM33.37 10.35H17.81a1.45 1.45 0 000 2.9h15.56a1.45 1.45 0 100-2.9zM31.82 25.84c-7.08 1.84-9.45.8-10.14.26-.45-.35-.65-.8-.65-1.48v-.87h10.25c.8 0 1.46-.65 1.46-1.45v-5.08c0-.8-.65-1.45-1.46-1.45h-11.7a1.45 1.45 0 100 2.9h10.25v2.18H19.57c-.8 0-1.45.65-1.45 1.45v2.32a4.6 4.6 0 001.78 3.78c1.2.92 2.94 1.39 5.21 1.39 2.05 0 4.54-.38 7.44-1.13a1.45 1.45 0 10-.73-2.82zM20.3 7.83h10.82a1.45 1.45 0 100-2.9h-9.36V1.44a1.45 1.45 0 10-2.9 0v4.93c0 .8.65 1.45 1.45 1.45z",
    clipRule: "evenodd"
  }), react.jsx("rect", {
    width: "3",
    height: "15",
    x: "70",
    fill: "currentColor",
    rx: "1.5"
  }), react.jsx("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M64.5 13.28a1.45 1.45 0 002.73-1c-.05-.13-1-2.68-3.38-4.5l3.7-4.1a1.45 1.45 0 00-1.09-2.42h-9.05a1.45 1.45 0 100 2.9h5.8l-6.88 7.64a1.45 1.45 0 102.16 1.95l3.41-3.8a8.02 8.02 0 012.6 3.33zM69.56 26.52h-7.01a.82.82 0 01-.82-.82v-1.95h8.65v1.95c0 .45-.37.82-.82.82zm2.27-9.37c-.8 0-1.45.65-1.45 1.45v2.25h-8.65V18.6a1.45 1.45 0 10-2.9 0v7.1a3.72 3.72 0 003.72 3.72h7.01a3.72 3.72 0 003.72-3.72v-7.1c0-.8-.65-1.45-1.45-1.45zM42.46 3.87c2.22 0 2.33 4.24 2.33 5.08 0 .85-.11 5.09-2.33 5.09-2.21 0-2.32-4.24-2.32-5.09 0-.84.11-5.08 2.32-5.08zm0 13.07c1.76 0 3.23-.93 4.14-2.62.71-1.34 1.1-3.2 1.1-5.37 0-2.16-.39-4.02-1.1-5.36A4.59 4.59 0 0042.46.97c-1.75 0-3.22.93-4.13 2.62-.72 1.34-1.1 3.2-1.1 5.36 0 2.17.38 4.03 1.1 5.37a4.59 4.59 0 004.13 2.62z",
    clipRule: "evenodd"
  }), react.jsx("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M51.4.49c-.8 0-1.45.65-1.45 1.45v17.78c-1.93.6-5.75 1.12-10.38 1.12h-2.2a1.45 1.45 0 000 2.91h2.2c2.64 0 7.21-.23 10.38-1.02v4.84a1.45 1.45 0 002.9 0V1.94c0-.8-.65-1.45-1.45-1.45z",
    clipRule: "evenodd"
  }));
};

LogoIcon$1.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "74",
  height: "30",
  fill: "none",
  viewBox: "0 0 74 30"
};
function Logo(_ref) {
  var logo = _ref.logo,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded$K);

  var theme = react.useTheme();
  var Link = useLinkContext();
  return react.jsx(Link, _extends({}, rest, {
    href: (logo === null || logo === void 0 ? void 0 : logo.href) || 'https://ohou.se',
    "aria-label": "\uC624\uB298\uC758\uC9D1 \uB85C\uACE0",
    css: [/*#__PURE__*/react.css(RESET_BUTTON, " display:inline-flex;align-items:center;margin:", pxToRem(-4), ";padding:", pxToRem(4), ";font-size:0;line-height:0;color:", theme.interactive.base1, ";outline:none;"), FOCUS(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral(["\n          box-shadow: 0 0 0 ", " ", ";\n          border-radius: ", ";\n        "])), pxToRem(3), theme.interactive.primary1.thin, pxToRem(3))]
  }), children || (logo === null || logo === void 0 ? void 0 : logo.item) || react.jsx(LogoIcon$1, {
    css: /*#__PURE__*/react.css("vertical-align:top;height:", pxToRem(26), ";", MEDIA_QUERY.min('tablet', "\n            height: ".concat(pxToRem(30), ";\n          ")), ";")
  }));
}

function useFocusedLatch(onChange) {
  var focusRef = React.useRef(null);
  var handleFocusIn = React.useCallback(function () {
    if (focusRef.current != null) {
      cancelAnimationFrame(focusRef.current);
    }

    onChange(true);
  }, [onChange]);
  var handleFocusOut = React.useCallback(function () {
    if (focusRef.current != null) {
      cancelAnimationFrame(focusRef.current);
    }

    focusRef.current = requestAnimationFrame(function () {
      return onChange(false);
    });
  }, [onChange]);
  return [handleFocusIn, handleFocusOut];
}

function NavigationBar(props) {
  var _supplementary$primar;

  var log = useLogContext();
  var logo = props.logo,
      primaryLeftmost = props.primaryLeftmost,
      menuSchema = props.menuSchema,
      fallbackMenuSchema = props.fallbackMenuSchema,
      searchOptions = props.searchOptions,
      supplementary = props.supplementary;

  var _useState = React.useState({
    isHovered: false,
    selectedIds: null
  }),
      _useState2 = _slicedToArray(_useState, 2),
      _useState2$ = _useState2[0],
      isHovered = _useState2$.isHovered,
      selectedIds = _useState2$.selectedIds,
      setState = _useState2[1];

  var setHovered = React.useCallback(function (value) {
    setState(function (prevState) {
      return _objectSpread2(_objectSpread2({}, prevState), {}, {
        isHovered: value,
        selectedIds: !value ? null : prevState.selectedIds
      });
    });
  }, []);

  var _useFocusedLatch = useFocusedLatch(setHovered),
      _useFocusedLatch2 = _slicedToArray(_useFocusedLatch, 2),
      onMouseEnter = _useFocusedLatch2[0],
      onMouseLeave = _useFocusedLatch2[1];

  var activeIds = React.useMemo(function () {
    return getActiveIds(menuSchema, fallbackMenuSchema);
  }, [menuSchema, fallbackMenuSchema]);
  var currentSelectedIds = selectedIds == null ? activeIds : selectedIds;
  var primaryEntries = menuSchema;
  var activePrimaryItem = activeIds[0] != null ? primaryEntries[activeIds[0]] : null;
  var primaryItem = currentSelectedIds[0] != null ? primaryEntries[currentSelectedIds[0]] : null;
  var secondaryEntries = getSecondaryEntries({
    primary: primaryItem,
    activeIds: activeIds,
    fallbackMenuSchema: fallbackMenuSchema
  });
  var secondaryItem = currentSelectedIds[1] != null ? secondaryEntries[currentSelectedIds[1]] : null;
  var hasFallbackMenuSchema = fallbackMenuSchema != null && fallbackMenuSchema.length > 0;
  var handlePrimarySelect = React.useCallback(function (_, index) {
    setState(function (prevState) {
      return _objectSpread2(_objectSpread2({}, prevState), {}, {
        selectedIds: [index]
      });
    });
  }, []);
  var handleSecondarySelect = React.useCallback(function (_, index) {
    setState(function (prevState) {
      return _objectSpread2(_objectSpread2({}, prevState), {}, {
        selectedIds: [currentSelectedIds[0], index]
      });
    });
  }, [currentSelectedIds]);
  var CustomPrimaryRight = (_supplementary$primar = supplementary.primaryRight) !== null && _supplementary$primar !== void 0 ? _supplementary$primar : null;
  var showTertiary = selectedIds != null && selectedIds[1] != null && secondaryItem != null && secondaryItem.renderBarChild != null;
  var secondaryRightElement = supplementary.secondaryRight != null ? React__default['default'].createElement(supplementary.secondaryRight) : null;
  return react.jsx("header", null, react.jsx(NavigationBarPrimary, {
    leftmost: primaryLeftmost,
    left: react.jsx(Logo, {
      css: /*#__PURE__*/react.css("height:", pxToRem(26), ";", MEDIA_QUERY.min('tablet', "\n                height: 30px;\n              "), ";"),
      logo: logo,
      onClick: function onClick() {
        log({
          key: 'logo',
          category: 'click'
        });
      }
    }),
    right: CustomPrimaryRight ? react.jsx("div", {
      css: /*#__PURE__*/react.css(MEDIA_QUERY.max('mobile', "\n                  display: none;\n                "), ";")
    }, react.jsx(CustomPrimaryRight, null)) : react.jsx(PrimaryRight, _extends({
      searchProps: searchOptions
    }, supplementary)),
    menuEntries: primaryEntries,
    activeId: activeIds[0],
    selectedId: currentSelectedIds[0],
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onSelect: handlePrimarySelect
  }), react.jsx(NavigationBarSecondary, {
    right: secondaryRightElement,
    menuEntries: secondaryEntries,
    hasItems: activePrimaryItem != null && activePrimaryItem.entries != null ? activePrimaryItem.entries.length > 0 : hasFallbackMenuSchema,
    activeId: currentSelectedIds[0] === activeIds[0] ? activeIds[1] : null,
    primaryId: currentSelectedIds[0],
    isForceOpened: isHovered && secondaryEntries.length > 0,
    isFallback: currentSelectedIds[0] == null && hasFallbackMenuSchema,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onSelect: handleSecondarySelect
  }), showTertiary && react.jsx(NavigationBarTertiary, {
    item: showTertiary ? secondaryItem : null,
    isOpen: showTertiary,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }));
}
/** Secondary 메뉴 스키마를 리턴합니다 */

function getSecondaryEntries(_ref) {
  var primary = _ref.primary,
      activeIds = _ref.activeIds,
      fallbackMenuSchema = _ref.fallbackMenuSchema;

  if (primary != null) {
    var _primary$entries;

    return (_primary$entries = primary.entries) !== null && _primary$entries !== void 0 ? _primary$entries : [];
  }

  if (activeIds[1] != null) {
    return fallbackMenuSchema !== null && fallbackMenuSchema !== void 0 ? fallbackMenuSchema : [];
  }

  return [];
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$z() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var STORE_CATEGORIES = [{
  id: 11090000,
  title: '크리스마스',
  hash: '2_6',
  imageUrl: 'https://image.ohou.se/image/resize/bucketplace-v2-development/uploads-category-store_home_categories-163654148296283533.png/1280/none',
  count: 9330,
  to: '/store/category?affect_type=StoreHamburger&category=2_6'
}, {
  id: 29000000,
  title: '겨울용품',
  hash: '28',
  imageUrl: 'https://image.ohou.se/image/resize/bucketplace-v2-development/uploads-category-store_home_categories-163572945028172903.png/1280/none',
  count: 27955,
  to: '/store/category?affect_type=StoreHamburger&category=28'
}, {
  id: 10000000,
  title: '가구',
  hash: '0',
  imageUrl: 'https://image.ohou.se/image/resize/bucketplace-v2-development/uploads-category-store_home_categories-162823224728615402.png/1280/none',
  count: 131291,
  to: '/store/category?affect_type=StoreHamburger&category=0'
}, {
  id: 18000000,
  title: '패브릭',
  hash: '1',
  imageUrl: 'https://image.ohou.se/image/resize/bucketplace-v2-development/uploads-category-store_home_categories-162823225115177697.png/1280/none',
  count: 83933,
  to: '/store/category?affect_type=StoreHamburger&category=1'
}, {
  id: 28000000,
  title: '조명',
  hash: '27',
  imageUrl: 'https://image.ohou.se/image/resize/bucketplace-v2-development/uploads-category-store_home_categories-162823225665741013.png/1280/none',
  count: 28004,
  to: '/store/category?affect_type=StoreHamburger&category=27'
}, {
  id: 14000000,
  title: '가전',
  hash: '3',
  imageUrl: 'https://image.ohou.se/image/resize/bucketplace-v2-development/uploads-category-store_home_categories-162823226017937426.png/1280/none',
  count: 31297,
  to: '/store/category?affect_type=StoreHamburger&category=3'
}, {
  id: 16000000,
  title: '주방용품',
  hash: '5',
  imageUrl: 'https://image.ohou.se/image/resize/bucketplace-v2-development/uploads-category-store_home_categories-162823226903946200.png/1280/none',
  count: 119023,
  to: '/store/category?affect_type=StoreHamburger&category=5'
}, {
  id: 11000000,
  title: '데코/취미',
  hash: '2',
  imageUrl: 'https://image.ohou.se/image/resize/bucketplace-v2-development/uploads-category-store_home_categories-162823227719846773.png/1280/none',
  count: 131077,
  to: '/store/category?affect_type=StoreHamburger&category=2'
}, {
  id: 13000000,
  title: '수납/정리',
  hash: '11',
  imageUrl: 'https://image.ohou.se/image/resize/bucketplace-v2-development/uploads-category-store_home_categories-162823228178967968.png/1280/none',
  count: 21662,
  to: '/store/category?affect_type=StoreHamburger&category=11'
}, {
  id: 12000000,
  title: '생활용품',
  hash: '4',
  imageUrl: 'https://image.ohou.se/image/resize/bucketplace-v2-development/uploads-category-store_home_categories-163609843911228804.png/1280/none',
  count: 25579,
  to: '/store/category?affect_type=StoreHamburger&category=4'
}, {
  id: 23000000,
  title: '생필품',
  hash: '21',
  imageUrl: 'https://image.ohou.se/image/resize/bucketplace-v2-development/uploads-category-store_home_categories-163575474448469686.png/1280/none',
  count: 19152,
  to: '/store/category?affect_type=StoreHamburger&category=21'
}, {
  id: 19000000,
  title: '공구/DIY',
  hash: '6',
  imageUrl: 'https://image.ohou.se/image/resize/bucketplace-v2-development/uploads-category-store_home_categories-162823230480918647.png/1280/none',
  count: 21070,
  to: '/store/category?affect_type=StoreHamburger&category=6'
}, {
  id: 17000000,
  title: '인테리어시공',
  hash: '7',
  imageUrl: 'https://image.ohou.se/image/resize/bucketplace-v2-development/uploads-category-store_home_categories-162823230908544036.png/1280/none',
  count: 1916,
  to: '/store/category?affect_type=StoreHamburger&category=7'
}, {
  id: 15000000,
  title: '반려동물',
  hash: '8',
  imageUrl: 'https://image.ohou.se/image/resize/bucketplace-v2-development/uploads-category-store_home_categories-162823231401891024.png/1280/none',
  count: 17221,
  to: '/store/category?affect_type=StoreHamburger&category=8'
}, {
  id: 20000000,
  title: '캠핑용품',
  hash: '20',
  imageUrl: 'https://image.ohou.se/image/resize/bucketplace-v2-development/uploads-category-store_home_categories-162823242317048198.png/1280/none',
  count: 10898,
  to: '/store/category?affect_type=StoreHamburger&category=20'
}, {
  id: 22000000,
  title: '실내운동',
  hash: '22',
  imageUrl: 'https://image.ohou.se/image/resize/bucketplace-v2-development/uploads-category-store_home_categories-162823231949249287.png/1280/none',
  count: 3850,
  to: '/store/category?affect_type=StoreHamburger&category=22'
}];

var _ref$x =  true ? {
  name: "10qs83r",
  styles: "display:block;margin:20px -10px 0;line-height:1"
} : 0;

var _ref2$f =  true ? {
  name: "vjtxpj",
  styles: "position:absolute;top:0;left:0;width:100%;border:0"
} : 0;

var _ref3$5 =  true ? {
  name: "60e040",
  styles: "position:relative;display:block;width:80px;height:80px"
} : 0;

var _ref4$2 =  true ? {
  name: "dg5hsf",
  styles: "display:block;padding:10px 0;font-size:14px;font-weight:bold;text-align:center"
} : 0;

var _ref5$1 =  true ? {
  name: "1qmr6ab",
  styles: "overflow:auto"
} : 0;

function StoreCategory(_ref6) {
  var categories = _ref6.categories,
      selectedIndex = _ref6.selectedIndex,
      onSelect = _ref6.onSelect;
  var Link = useLinkContext();
  var log = useLogContext();
  var theme = react.useTheme();
  return react.jsx("div", {
    css: _ref5$1
  }, react.jsx("ul", {
    css: /*#__PURE__*/react.css("display:flex;justify-content:space-between;margin:0 auto;padding:10px 0 10px 40px;box-sizing:border-box;", MEDIA_QUERY.min('laptop', "\n          max-width: 1276px;\n          padding: 10px 0 10px 60px;\n        "), ";")
  }, categories.map(function (category, index) {
    return react.jsx("li", {
      key: category.id,
      css: /*#__PURE__*/react.css("flex:0 0 auto;margin:0;padding:0 0 0 10px;color:", index === selectedIndex ? theme.content.primary1.basic : theme.content.base1, ";&:last-of-type{padding-right:40px;", MEDIA_QUERY.min('laptop', "\n                  padding-right: 60px;\n                "), ";}&:hover{color:", theme.content.primary1.basic, ";}")
    }, react.jsx(Link, {
      href: category.to,
      onClick: function onClick() {
        log({
          key: 'tertiary.store.category.item',
          category: 'click',
          params: {
            id: category.hash,
            index: index
          }
        });
        onSelect(index);
      },
      css: _ref4$2
    }, react.jsx("span", {
      css: _ref3$5
    }, react.jsx("img", {
      alt: category.title,
      src: category.imageUrl,
      css: _ref2$f
    })), react.jsx("span", {
      css: _ref$x
    }, category.title)));
  })));
}

function isInApp(query) {
  if (typeof window === 'undefined') {
    if (query != null) {
      return query.os_type != null || query.app != null;
    }

    return false;
  } // NOTE: It's fine to use sessionStorage here because webview will always
  // try to set these parameters.


  var triggered = false;

  try {
    triggered = sessionStorage.webviewTriggered === 'yes';
  } catch (e) {//
  }

  var search = querystring__default['default'].parse(location.search.slice(1));
  var isExpertCenterAndroid = search.pro_app != null && search.os_type === 'Android';

  if (!isExpertCenterAndroid && (triggered || search.os_type != null && search.os_type !== '' || search.app != null)) {
    try {
      sessionStorage.webviewTriggered = 'yes';
    } catch (e) {//
    }

    return true;
  }

  return false;
}

function useIsInApp(location) {
  var _useState = React.useState(function () {
    return querystring__default['default'].parse(location.search.slice(1)).app != null;
  }),
      _useState2 = _slicedToArray(_useState, 2),
      inApp = _useState2[0],
      setInApp = _useState2[1];

  var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
  useIsomorphicLayoutEffect(function () {
    setInApp(isInApp());
  }, []);
  return inApp;
}

function NavigationDrawerDivider() {
  return react.jsx(Divider$1, {
    variant: "thin",
    css: /*#__PURE__*/react.css("margin:", pxToRem(20), " 0;")
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$y() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$w =  true ? {
  name: "d3v9zr",
  styles: "overflow:hidden"
} : 0;

function NavigationDrawerMenuAccordion(_ref2) {
  var children = _ref2.children,
      isExpanded = _ref2.isExpanded,
      onTransitionStart = _ref2.onTransitionStart,
      onTransitionEnd = _ref2.onTransitionEnd;
  var container = React.useRef(null);
  var content = React.useRef(null);
  var isExpanding = React.useRef(false);
  var isCollapsing = React.useRef(false);
  var expand = React.useCallback(function () {
    if (!container.current || !content.current) return;
    if (isExpanding.current) return;
    if (isCollapsing.current) return;
    isExpanding.current = true;
    container.current.style.display = 'block';
    container.current.style.height = "".concat(content.current.clientHeight, "px");
    onTransitionStart();
  }, [onTransitionStart]);
  var collapse = React.useCallback(function () {
    if (!container.current || !content.current) return;
    if (isExpanding.current) return;
    if (isCollapsing.current) return;
    isCollapsing.current = true;
    container.current.style.height = "".concat(content.current.clientHeight, "px");
    setTimeout(function () {
      if (!container.current) return;
      container.current.style.height = '0px';
      onTransitionStart();
    }, 50);
  }, [onTransitionStart]);
  var handleTransitionEnd = React.useCallback(function () {
    if (!container.current || !content.current) return;

    if (isExpanding.current) {
      container.current.style.height = 'auto';
      isExpanding.current = false;
    } else if (isCollapsing.current) {
      container.current.style.display = 'none';
      isCollapsing.current = false;
    }

    onTransitionEnd();
  }, [onTransitionEnd]);
  React.useEffect(function () {
    if (!container.current) return;
    if (!container.current.style.transition) return;
    (isExpanded ? expand : collapse)();
  }, [isExpanded, expand, collapse]);
  React.useEffect(function () {
    if (!container.current) return;
    container.current.style.height = isExpanded ? 'auto' : '0px';
    container.current.style.display = isExpanded ? 'block' : 'none';
    setTimeout(function () {
      if (!container.current) return;
      container.current.style.transition = 'height .3s';
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return react.jsx("div", {
    ref: container,
    css: _ref$w,
    onTransitionEnd: handleTransitionEnd
  }, react.jsx("div", {
    ref: content
  }, children));
}

var _templateObject$6, _templateObject2$2, _templateObject3$2, _templateObject4;

function _EMOTION_STRINGIFIED_CSS_ERROR__$x() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var NewIcon = function NewIcon(props) {
  return react.jsx("svg", props, react.jsx("path", {
    d: "M0 9a9 9 0 1118 0A9 9 0 010 9z",
    fill: "#fff"
  }), react.jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 18A9 9 0 109 0a9 9 0 000 18zm-1.7-5.25H5.26v-7.5h2.61l2.8 4.2h.03v-4.2h2.06v7.5h-2.3L7.36 8.07h-.05v4.68z",
    fill: "#F77"
  }));
};

NewIcon.defaultProps = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18",
  width: "18",
  height: "18"
};

var _ref3$4 =  true ? {
  name: "1hcx8jb",
  styles: "padding:0"
} : 0;

function NavigationDrawerMenu(_ref4) {
  var items = _ref4.items,
      indents = _ref4.indents,
      fontStyles = _ref4.fontStyles,
      onClose = _ref4.onClose;

  var _useState = React.useState(function () {
    return items.findIndex(function (item) {
      return item.active;
    });
  }),
      _useState2 = _slicedToArray(_useState, 2),
      expandedIndex = _useState2[0],
      setExpandedIndex = _useState2[1];

  return react.jsx("ul", {
    css: _ref3$4
  }, items.map(function (item, index) {
    return react.jsx(NavigationDrawerMenuItem, {
      key: index,
      title: item.title,
      icon: item.icon,
      bullet: item.bullet,
      href: item.href,
      isActive: item.active,
      items: item.entries,
      renderChild: item.renderDrawerChild,
      indents: indents,
      fontStyles: fontStyles,
      isExpanded: index === expandedIndex,
      onExpand: function onExpand() {
        return setExpandedIndex(index);
      },
      onCollapse: function onCollapse() {
        return setExpandedIndex(-1);
      },
      onClick: function onClick() {
        var _item$onClick;

        (_item$onClick = item.onClick) === null || _item$onClick === void 0 ? void 0 : _item$onClick.call(item, {
          item: item,
          index: index
        });
        !item.entries && (onClose === null || onClose === void 0 ? void 0 : onClose());
      },
      onClose: onClose
    });
  }));
}

var _ref$v =  true ? {
  name: "1r7xtnv",
  styles: "margin-left:1.5px"
} : 0;

var _ref2$e =  true ? {
  name: "6103ef",
  styles: "display:flex;flex-wrap:wrap;align-items:center;width:100%;height:100%;line-height:1"
} : 0;

function NavigationDrawerMenuItem(_ref5) {
  var title = _ref5.title,
      icon = _ref5.icon,
      href = _ref5.href,
      bullet = _ref5.bullet,
      items = _ref5.items,
      _ref5$indents = _ref5.indents,
      indents = _ref5$indents === void 0 ? [] : _ref5$indents,
      _ref5$fontStyles = _ref5.fontStyles,
      fontStyles = _ref5$fontStyles === void 0 ? [] : _ref5$fontStyles,
      isActive = _ref5.isActive,
      isExpanded = _ref5.isExpanded,
      onExpand = _ref5.onExpand,
      onCollapse = _ref5.onCollapse,
      renderChild = _ref5.renderChild,
      _onClick = _ref5.onClick,
      onClose = _ref5.onClose;
  var theme = react.useTheme();
  var Link = useLinkContext();
  var isAccordionTransitioning = React.useRef(false);
  var handleAccordionTransitionStart = React.useCallback(function () {
    isAccordionTransitioning.current = true;
  }, []);
  var handleAccordionTransitionEnd = React.useCallback(function () {
    isAccordionTransitioning.current = false;
  }, []);
  var handleAccordionToggle = React.useCallback(function () {
    if (isAccordionTransitioning.current) return;
    (isExpanded ? onCollapse : onExpand)();
  }, [isExpanded, onCollapse, onExpand]);

  var renderTitle = function renderTitle() {
    return react.jsx("div", {
      css: _ref2$e
    }, icon && react.jsx("span", {
      css: /*#__PURE__*/react.css("display:inline-block;margin-right:", pxToRem(8), ";border-radius:", pxToRem(4), ";")
    }, icon), title, bullet === 'new' && react.jsx(NewIcon, {
      css: _ref$v
    }));
  };

  var _indents = _slicedToArray(indents, 1),
      indent = _indents[0];

  var _fontStyles = _slicedToArray(fontStyles, 1),
      _fontStyles$ = _fontStyles[0],
      fontStyle = _fontStyles$ === void 0 ? {} : _fontStyles$;

  return react.jsx("li", {
    css: /*#__PURE__*/react.css("margin:", pxToRem(4), " 0 0;padding:0;font-size:", pxToRem(fontStyle.size || 14), ";font-weight:", isActive ? 'bold' : fontStyle.weight || 'normal', ";color:", fontStyle.color || theme.content.base1, ";")
  }, items && items.length || renderChild ? react.jsx(React__default['default'].Fragment, null, react.jsx("button", {
    type: "button",
    onClick: function onClick() {
      handleAccordionToggle();
      _onClick === null || _onClick === void 0 ? void 0 : _onClick();
    },
    css: /*#__PURE__*/react.css(RESET_BUTTON, " overflow:hidden;position:relative;display:block;width:100%;height:", pxToRem(40), ";margin:0;padding:0 ", pxToRem(40), " 0 ", pxToRem(indent || 14), ";color:inherit;text-align:left;text-overflow:ellipsis;white-space:nowrap;box-sizing:border-box;outline:none;border-radius:4px;", isActive ? /*#__PURE__*/react.css("background-color:", theme.interactive.transparent, ";", HOVER(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n                      background-color: ", ";\n                    "])), theme.content.base5), ";") : HOVER(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n                    background-color: ", ";\n                  "])), theme.content.base5), ";")
  }, renderTitle(), react.jsx(Icon, {
    size: 12,
    name: isExpanded ? 'chevron_thick_up' : 'chevron_thick_down',
    css: /*#__PURE__*/react.css("position:absolute;top:", pxToRem(14), ";right:", pxToRem(14), ";color:", theme.content.base1, ";")
  })), react.jsx(NavigationDrawerMenuAccordion, {
    isExpanded: isExpanded,
    onTransitionStart: handleAccordionTransitionStart,
    onTransitionEnd: handleAccordionTransitionEnd
  }, items && react.jsx(NavigationDrawerMenu, {
    items: items,
    fontStyles: fontStyles.slice(1),
    indents: indents.length > 1 ? indents.slice(1) : indents.slice(-1),
    onClose: onClose
  }) || renderChild && renderChild())) : react.jsx(Link, {
    href: href,
    onClick: _onClick,
    css: /*#__PURE__*/react.css("overflow:hidden;display:block;width:100%;height:", pxToRem(40), ";padding:0 ", pxToRem(14), " 0 ", pxToRem(indent || 14), ";color:inherit;text-overflow:ellipsis;white-space:nowrap;box-sizing:border-box;outline:none;border-radius:4px;", isActive ? /*#__PURE__*/react.css("background-color:", theme.interactive.transparent, ";", HOVER(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral(["\n                  background-color: ", ";\n                "])), theme.content.base5), ";") : HOVER(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n                background-color: ", ";\n              "])), theme.content.base5), ";")
  }, renderTitle()));
}

var _excluded$J = ["size"];
function Avatar(_ref) {
  var size = _ref.size,
      rest = _objectWithoutProperties(_ref, _excluded$J);

  return react.jsx(CircleImage, _extends({}, rest, {
    css: /*#__PURE__*/react.css("width:", pxToRem(size), ";")
  }));
}

var _excluded$I = ["text"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$w() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$u =  true ? {
  name: "1rw4zr4",
  styles: "font-weight:bold;outline:none;display:flex;flex:1;justify-content:center;align-items:center;height:42px"
} : 0;

var _ref2$d =  true ? {
  name: "1200b05",
  styles: "position:absolute;top:0;right:0;display:flex;align-items:center;outline:none"
} : 0;

function NavigationDrawerHeader(_ref3) {
  var logo = _ref3.logo,
      action = _ref3.action,
      supplementary = _ref3.supplementary;
  var log = useLogContext();
  var userProfile = supplementary.userProfile,
      signup = supplementary.signup,
      signin = supplementary.signin;
  return react.jsx(React__default['default'].Fragment, null, react.jsx("div", {
    css: /*#__PURE__*/react.css("position:relative;font-size:", pxToRem(14), ";line-height:", pxToRem(18), ";")
  }, react.jsx(Logo, _extends({}, logo, {
    onClick: function onClick() {
      return log({
        key: 'drawer.logo',
        category: 'click'
      });
    }
  })), action && function (_ref4) {
    var text = _ref4.text,
        rest = _objectWithoutProperties(_ref4, _excluded$I);

    return react.jsx(TextButton, _extends({}, rest, {
      size: 32,
      variant: "primary1",
      css: _ref2$d
    }), text, react.jsx(Icon, {
      name: "chevron_right",
      size: 12,
      fill: function fill(theme) {
        return theme.content.primary1.basic;
      },
      css: /*#__PURE__*/react.css("margin-left:", pxToRem(4), ";")
    }));
  }(action)), userProfile == null ? react.jsx("div", {
    css: /*#__PURE__*/react.css("display:flex;justify-content:space-between;width:100%;margin:", pxToRem(20), " 0 ", pxToRem(10), ";")
  }, react.jsx(OutlineAnchorButton, {
    href: signin.href,
    size: 44,
    variant: "primary1",
    onClick: function onClick() {// to signIn page
    },
    css: _ref$u
  }, "\uB85C\uADF8\uC778"), react.jsx(AnchorButton, {
    href: signup.href,
    size: 44,
    variant: "primary1",
    onClick: function onClick() {// to signUp page
    },
    css: /*#__PURE__*/react.css("margin-left:", pxToRem(8), ";font-weight:bold;outline:none;display:flex;flex:1;justify-content:center;align-items:center;")
  }, "\uD68C\uC6D0\uAC00\uC785")) : react.jsx("div", {
    css: /*#__PURE__*/react.css("display:flex;align-items:center;margin:", pxToRem(24), " 0 ", pxToRem(20), ";")
  }, react.jsx(Avatar, {
    size: 20,
    src: userProfile.imageUrl
  }), react.jsx("p", {
    css: /*#__PURE__*/react.css("font-size:", pxToRem(14), ";line-height:", pxToRem(20), ";margin-left:", pxToRem(4), ";")
  }, userProfile.nickname)));
}

var _templateObject$5;
function NavigationDrawerFooterListItem(_ref) {
  var title = _ref.title,
      href = _ref.href,
      onClick = _ref.onClick,
      onClose = _ref.onClose;
  var theme = react.useTheme();
  var LinkComponent = useLinkContext();
  return react.jsx("li", {
    css: [/*#__PURE__*/react.css("display:inline-block;padding:", pxToRem(6), ";border-radius:", pxToRem(4), ";margin:0 0 0 ", pxToRem(7), ";line-height:", pxToRem(18), ";&:first-of-type{margin:0;}"), HOVER(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "])), theme.background.groupedBase)]
  }, href != null ? react.jsx(LinkComponent, {
    href: href,
    css: /*#__PURE__*/react.css(FONT_STYLE.subTitle2, " outline:none;vertical-align:middle;white-space:nowrap;"),
    onClick: onClose
  }, title) : react.jsx("button", {
    css: /*#__PURE__*/react.css(RESET_BUTTON, " ", FONT_STYLE.subTitle2, " color:", theme.content.base1, ";outline:none;cursor:pointer;vertical-align:middle;white-space:nowrap;"),
    onClick: onClick,
    type: "button"
  }, title));
}
function NavigationDrawerFooter(_ref2) {
  var items = _ref2.items,
      onClose = _ref2.onClose;
  return react.jsx("ul", {
    css: /*#__PURE__*/react.css("padding:0;margin-top:", pxToRem(14), ";display:flex;align-items:center;>button{font-size:", pxToRem(14), ";font-weight:normal;}")
  }, items.map(function (item, index) {
    return react.jsx(NavigationDrawerFooterListItem, _extends({
      key: index,
      onClose: onClose
    }, item));
  }));
}

var _excluded$H = ["open", "logo", "menuSchema", "supplementary", "onClose", "onLogout", "onAppDownload"];
function NavigationDrawer(_ref) {
  var open = _ref.open,
      logo = _ref.logo,
      menuSchema = _ref.menuSchema,
      supplementary = _ref.supplementary,
      onClose = _ref.onClose;
      _ref.onLogout;
      var onAppDownload = _ref.onAppDownload,
      rest = _objectWithoutProperties(_ref, _excluded$H);

  var userMenu = supplementary.userMenu,
      _supplementary$showAp = supplementary.showAppDownloadButton,
      showAppDownloadButton = _supplementary$showAp === void 0 ? true : _supplementary$showAp;
  var log = useLogContext();
  var drawerMenu = React.useMemo(function () {
    return menuSchema.map(function (mainMenu) {
      var _mainMenu$entries;

      return _objectSpread2(_objectSpread2({}, mainMenu), {}, {
        onClick: function onClick(_ref2) {
          var index = _ref2.index;
          log({
            key: 'drawer.main.item',
            category: 'click',
            params: {
              index: index
            }
          });
        },
        entries: (_mainMenu$entries = mainMenu.entries) === null || _mainMenu$entries === void 0 ? void 0 : _mainMenu$entries.map(function (subMenu) {
          return _objectSpread2(_objectSpread2({}, subMenu), {}, {
            onClick: function onClick(_ref3) {
              var href = _ref3.item.href,
                  index = _ref3.index;
              log({
                key: 'drawer.sub.item',
                category: 'click',
                params: {
                  index: index,
                  href: href
                }
              });
            }
          });
        })
      });
    });
  }, [menuSchema, log]);
  var drawerUserMenu = React.useMemo(function () {
    return userMenu.filter(function (menu) {
      var _menu$showOn;

      return (_menu$showOn = menu.showOn) === null || _menu$showOn === void 0 ? void 0 : _menu$showOn.includes('drawer');
    }).map(function (_ref4) {
      var title = _ref4.title,
          href = _ref4.href,
          bullet = _ref4.bullet;
      return {
        title: title,
        href: href,
        bullet: bullet,
        onClick: function onClick(_ref5) {
          var index = _ref5.index;
          log({
            key: 'drawer.user.item',
            category: 'click',
            params: {
              index: index
            }
          });
        }
      };
    });
  }, [userMenu, log]);
  var drawerFooterMenu = React.useMemo(function () {
    return userMenu.filter(function (menu) {
      return menu.type === 'bottom';
    });
  }, [userMenu]);
  return react.jsx(Drawer, _extends({
    open: open,
    width: 270,
    onClose: onClose
  }, rest), react.jsx(NavigationDrawerHeader, {
    logo: {
      logo: logo,
      onClick: function onClick() {
        return window.open((logo === null || logo === void 0 ? void 0 : logo.href) || 'https://ohou.se');
      }
    },
    action: showAppDownloadButton ? {
      text: '앱다운로드',
      onClick: function onClick() {
        log({
          key: 'drawer.user.profile',
          category: 'click'
        });
        onAppDownload === null || onAppDownload === void 0 ? void 0 : onAppDownload();
      }
    } : undefined,
    supplementary: supplementary
  }), react.jsx(NavigationDrawerDivider, null), react.jsx(NavigationDrawerMenu, {
    items: drawerMenu,
    fontStyles: [{
      size: 16,
      weight: 'bold'
    }],
    indents: [14, 42, 50],
    onClose: onClose
  }), drawerUserMenu.length > 0 && react.jsx(NavigationDrawerDivider, null), react.jsx(NavigationDrawerMenu, {
    items: drawerUserMenu,
    onClose: onClose
  }), react.jsx(NavigationDrawerDivider, null), react.jsx(NavigationDrawerFooter, {
    items: drawerFooterMenu,
    onClose: onClose
  }));
}

function Navigation(props) {
  var logo = props.logo,
      menuSchema = props.menuSchema,
      searchOptions = props.searchOptions,
      supplementary = props.supplementary,
      fallbackMenuSchema = props.fallbackMenuSchema,
      linkComponent = props.linkComponent,
      onLog = props.onLog,
      onLogout = props.onLogout,
      onAppDownload = props.onAppDownload,
      location = props.location;
  var theme = react.useTheme();

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isDrawerOpen = _useState2[0],
      setDrawerOpen = _useState2[1];

  var handleDrawerToggle = React.useCallback(function () {
    setDrawerOpen(function (v) {
      return !v;
    });
  }, []);
  var handleDrawerClose = React.useCallback(function () {
    setDrawerOpen(false);
  }, []);
  var isInApp = useIsInApp(location);

  if (isInApp) {
    return null;
  }

  return react.jsx(LinkProvider, {
    linkComponent: linkComponent
  }, react.jsx(LogProvider, {
    onLog: onLog
  }, react.jsx(React__default['default'].Fragment, null, react.jsx(NavigationBar, {
    logo: logo,
    menuSchema: menuSchema,
    primaryLeftmost: react.jsx("button", {
      type: "button",
      onClick: function onClick() {
        onLog({
          key: 'drawer.button',
          category: 'click'
        });
        handleDrawerToggle();
      },
      css: /*#__PURE__*/react.css(RESET_BUTTON, " padding:", pxToRem(6), ";margin:", pxToRem(3), " ", pxToRem(1), ";color:", theme.content.base1, ";outline:none;")
    }, react.jsx(Icon, {
      size: 24,
      name: "menu"
    })),
    searchOptions: searchOptions,
    supplementary: supplementary,
    fallbackMenuSchema: fallbackMenuSchema
  }), react.jsx(NavigationDrawer, {
    open: isDrawerOpen,
    logo: logo,
    menuSchema: menuSchema,
    supplementary: supplementary,
    onOpen: handleDrawerToggle,
    onClose: handleDrawerClose,
    onLogout: onLogout,
    onAppDownload: onAppDownload
  }))));
}

var _templateObject$4;

function _EMOTION_STRINGIFIED_CSS_ERROR__$v() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$t =  true ? {
  name: "mzbvs0",
  styles: "margin-left:8px;line-height:0"
} : 0;

var NavigationRightButton = React.memo(function (_ref2) {
  var title = _ref2.title,
      href = _ref2.href;
  var theme = react.useTheme();
  var LinkComponent = useLinkContext();
  var log = useLogContext();
  return react.jsx(LinkComponent, {
    href: href,
    css: [/*#__PURE__*/react.css("display:flex;align-items:center;", FONT_STYLE.subTitle1, ";color:", theme.content.primary1.basic, ";font-weight:700;outline:none;"), FOCUS(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n          & > span {\n            box-shadow: 0 0 0 ", " ", ";\n          }\n        "])), pxToRem(3), theme.content.primary1.thin)],
    onClick: function onClick() {
      return log({
        key: 'secondary.interior',
        category: 'click'
      });
    }
  }, react.jsx("span", {
    css: /*#__PURE__*/react.css("display:inline-block;padding:", pxToRem(4), ";margin:", pxToRem(-4), ";border-radius:", pxToRem(3), ";")
  }, title, react.jsx(Icon, {
    css: _ref$t,
    name: "chevron_thick_right",
    size: 18
  })));
});

var _excluded$G = ["index", "href"];

/* eslint-disable camelcase */
var TYPE_MAP = {
  'logo': function logo() {
    return {
      click: {
        bucket: {
          section: '로고'
        }
      }
    };
  },
  // primary
  'primary.item': function primaryItem(_ref) {
    var index = _ref.index;
    return {
      click: {
        bucket: {
          section: '메인 메뉴',
          index: index
        }
      }
    };
  },
  'primary.right.search': function primaryRightSearch() {
    return {
      click: {
        bucket: {
          section: '검색'
        }
      }
    };
  },
  'primary.right.search.input': function primaryRightSearchInput(_ref2) {
    var search_type = _ref2.search_type;
    return {
      click: {
        bucket: {
          section: '검색'
        },
        amplitude: {
          type: '검색 필드 Clicked',
          search_type: search_type
        }
      }
    };
  },
  'primary.right.search.autocomplete.query': function primaryRightSearchAutocompleteQuery(_ref3) {
    var id = _ref3.id,
        type = _ref3.type,
        index = _ref3.index;
    return {
      click: {
        bucket: {
          section: '자동완성',
          id: id,
          type: type,
          index: index
        }
      }
    };
  },
  'primary.right.search.autocomplete.category': function primaryRightSearchAutocompleteCategory(_ref4) {
    var id = _ref4.id,
        type = _ref4.type,
        index = _ref4.index;
    return {
      click: {
        bucket: {
          section: '추천 카테고리',
          id: id,
          type: type,
          index: index
        }
      }
    };
  },
  'primary.right.search.history': function primaryRightSearchHistory(_ref5) {
    var id = _ref5.id,
        type = _ref5.type,
        index = _ref5.index;
    return {
      click: {
        bucket: {
          section: '최근 검색어',
          id: id,
          type: type,
          index: index
        }
      },
      impression: {
        bucket: {
          section: '최근 검색어',
          type: type
        }
      }
    };
  },
  'primary.right.scrap': function primaryRightScrap() {
    return {
      click: {
        bucket: {
          section: '스크랩북'
        },
        amplitude: {
          type: '스크랩북 Viewed',
          data: {
            source: {
              page: {
                tab: {
                  main: '스크랩북'
                }
              },
              referrer: {
                type: '바로가기'
              }
            }
          }
        }
      }
    };
  },
  'primary.right.cart': function primaryRightCart() {
    return {
      click: {
        bucket: {
          section: '장바구니'
        }
      }
    };
  },
  'primary.right.notification': function primaryRightNotification() {
    return {
      click: {
        bucket: {
          section: '알림'
        },
        amplitude: {
          type: '알림 리스트 Viewed'
        }
      }
    };
  },
  'primary.right.login': function primaryRightLogin() {
    return {
      click: {
        bucket: {
          section: '로그인'
        }
      }
    };
  },
  'primary.right.signup': function primaryRightSignup() {
    return {
      click: {
        bucket: {
          section: '회원가입'
        }
      }
    };
  },
  'primary.right.cs': function primaryRightCs() {
    return {
      click: {
        bucket: {
          section: '고객센터'
        }
      }
    };
  },
  'primary.right.mypage': function primaryRightMypage() {
    return {
      click: {
        amplitude: {
          type: '계정 Viewed'
        }
      }
    };
  },
  'primary.right.logout': function primaryRightLogout() {
    return {
      click: {
        amplitude: {
          type: '계정 Logout'
        }
      }
    };
  },
  'primary.right.upload': function primaryRightUpload() {
    return {
      click: {
        bucket: {
          section: '글쓰기'
        }
      }
    };
  },
  'primary.right.upload.photo': function primaryRightUploadPhoto() {
    return {
      click: {
        bucket: {
          section: '사진 올리기'
        }
      }
    };
  },
  // secondary
  'secondary.item': function secondaryItem(_ref6) {
    var index = _ref6.index,
        href = _ref6.href,
        rest = _objectWithoutProperties(_ref6, _excluded$G);

    return {
      click: {
        bucket: _objectSpread2({
          index: index,
          url: typeof href === 'string' ? href : '/'
        }, rest)
      },
      impression: {
        bucket: _objectSpread2({
          index: index
        }, rest)
      }
    };
  },
  'secondary.interior': function secondaryInterior() {
    return {
      click: {
        bucket: {
          section: '3D인테리어'
        }
      }
    };
  },
  // tertiary
  'tertiary.store.category.item': function tertiaryStoreCategoryItem(_ref7) {
    var id = _ref7.id,
        index = _ref7.index;
    return {
      click: {
        bucket: {
          section: '카테고리 메뉴',
          type: 'category',
          id: id,
          index: index
        }
      }
    };
  },
  // drawer
  'drawer.logo': function drawerLogo() {
    return {
      click: {
        bucket: {
          section: 'drawer 로고'
        }
      }
    };
  },
  'drawer.button': function drawerButton() {
    return {
      click: {
        bucket: {
          section: '햄버거 메뉴'
        }
      }
    };
  },
  'drawer.main.item': function drawerMainItem(_ref8) {
    var index = _ref8.index;
    return {
      click: {
        bucket: {
          section: '메인 메뉴',
          index: index
        }
      }
    };
  },
  'drawer.sub.item': function drawerSubItem(_ref9) {
    var index = _ref9.index,
        href = _ref9.href;
    return {
      click: {
        bucket: {
          section: '서브 메뉴',
          index: index,
          url: typeof href === 'string' ? href : '/'
        }
      }
    };
  },
  'drawer.user.item': function drawerUserItem(_ref10) {
    var index = _ref10.index;
    return {
      click: {
        bucket: {
          section: '유저 메뉴',
          index: index
        }
      }
    };
  },
  'drawer.user.profile': function drawerUserProfile() {
    return {
      click: {
        bucket: {
          section: '유저 프로필'
        },
        amplitude: {
          type: '계정 Viewed'
        }
      }
    };
  }
};

var BREAKPOINTS = [['desktop', BREAK_POINT.desktop], ['laptop', BREAK_POINT.laptop], ['tablet', BREAK_POINT.tablet], ['mobile', BREAK_POINT.mobile]];

/**
 * Returns the current breakpoint of the viewport. (mobile, tablet, laptop)
 */
function useResponsive(options) {
  var _ref = options !== null && options !== void 0 ? options : {},
      fallbackBreakpoint = _ref.fallbackBreakpoint,
      populateOnInitialRender = _ref.populateOnInitialRender,
      preventSyncOnInitialRender = _ref.preventSyncOnInitialRender;

  var _useState = React.useState(function () {
    if (!populateOnInitialRender) {
      return undefined;
    }

    if (typeof window === 'undefined') {
      return fallbackBreakpoint || undefined;
    }

    var matchingBreakpoint = BREAKPOINTS.find(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          minWidth = _ref3[1];

      return window.matchMedia("(min-width: ".concat(minWidth, "px)")).matches;
    });
    return matchingBreakpoint != null ? matchingBreakpoint[0] : fallbackBreakpoint || undefined;
  }),
      _useState2 = _slicedToArray(_useState, 2),
      breakpoint = _useState2[0],
      setBreakpoint = _useState2[1];

  React.useEffect(function () {
    var mediaRefs = BREAKPOINTS.map(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
          breakpoint = _ref5[0],
          minWidth = _ref5[1];

      return [breakpoint, window.matchMedia("(min-width: ".concat(minWidth, "px)"))];
    });

    function update() {
      var hasMatch = false;

      var _iterator = _createForOfIteratorHelper(mediaRefs),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
              _breakpoint = _step$value[0],
              media = _step$value[1];

          if (!hasMatch && media.matches) {
            setBreakpoint(_breakpoint);
            hasMatch = true;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    var _iterator2 = _createForOfIteratorHelper(mediaRefs),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _step2$value = _slicedToArray(_step2.value, 2),
            media = _step2$value[1];

        media.addListener(update);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    if (!preventSyncOnInitialRender) {
      update();
    }

    return function () {
      var _iterator3 = _createForOfIteratorHelper(mediaRefs),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _step3$value = _slicedToArray(_step3.value, 2),
              media = _step3$value[1];

          media.removeListener(update);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    };
  }, [preventSyncOnInitialRender]);
  return {
    breakpoint: breakpoint
  };
}

var GAP$1 = 10;
var ICON_SIZE$1 = 24;
function ModalHeader(_ref) {
  var title = _ref.title,
      onBack = _ref.onBack,
      onClose = _ref.onClose;
  var theme = react.useTheme();
  return react.jsx("div", {
    css: /*#__PURE__*/react.css("padding:", pxToRem(16), " ", pxToRem(16), " ", pxToRem(10), " ", pxToRem(16), ";line-height:0;")
  }, onBack && react.jsx("button", {
    type: "button",
    onClick: onBack,
    css: /*#__PURE__*/react.css(RESET_BUTTON, " vertical-align:middle;width:", pxToRem(ICON_SIZE$1), ";height:", pxToRem(ICON_SIZE$1), ";")
  }, react.jsx(Icon, {
    size: ICON_SIZE$1,
    name: "arrow_left",
    css: /*#__PURE__*/react.css("color:", theme.content.base1, ";")
  })), react.jsx("span", {
    css: [FONT_STYLE.title2, /*#__PURE__*/react.css("display:inline-block;vertical-align:middle;font-weight:700;text-align:center;width:calc(100% - ", pxToRem((GAP$1 + ICON_SIZE$1) * 2), ");margin-left:", pxToRem(onBack ? GAP$1 : ICON_SIZE$1), ";margin-right:", pxToRem(onClose ? GAP$1 : ICON_SIZE$1), ";")]
  }, title), onClose && react.jsx("button", {
    type: "button",
    onClick: onClose,
    css: /*#__PURE__*/react.css(RESET_BUTTON, " vertical-align:middle;width:", pxToRem(ICON_SIZE$1), ";height:", pxToRem(ICON_SIZE$1), ";")
  }, react.jsx(Icon, {
    size: ICON_SIZE$1,
    name: "dismiss",
    css: /*#__PURE__*/react.css("color:", theme.content.base1, ";")
  })));
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$u() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$s =  true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0;

function ModalFooter(_ref2) {
  var _action$secondary$dis, _action$primary$disab, _subAction$disabled;

  var action = _ref2.action,
      subAction = _ref2.subAction,
      style = _ref2.style;
  return react.jsx("div", {
    css: [style, /*#__PURE__*/react.css("padding:", pxToRem(9), " ", pxToRem(16), ";line-height:0;")]
  }, action && react.jsx("div", {
    css: /*#__PURE__*/react.css("padding-top:", pxToRem(1), ";padding-bottom:", pxToRem(subAction ? 9 : 7), ";")
  }, action.secondary && (!Array.isArray(action.secondary) ? react.jsx(OutlineButton, {
    size: 50,
    variant: "base1",
    onClick: action.secondary.onClick,
    disabled: (_action$secondary$dis = action.secondary.disabled) !== null && _action$secondary$dis !== void 0 ? _action$secondary$dis : false,
    css: /*#__PURE__*/react.css("width:calc(50% - ", pxToRem(5), ");margin-right:", pxToRem(10), ";")
  }, action.secondary.text) : react.jsx(React__default['default'].Fragment, null, action.secondary.map(function (secondaryAction, index) {
    var _secondaryAction$disa;

    return react.jsx(OutlineButton, {
      key: index,
      size: 50,
      variant: "base1",
      onClick: secondaryAction.onClick,
      disabled: (_secondaryAction$disa = secondaryAction.disabled) !== null && _secondaryAction$disa !== void 0 ? _secondaryAction$disa : false,
      css: [/*#__PURE__*/react.css("width:calc(50% - ", pxToRem(5), ");"), index === 0 && /*#__PURE__*/react.css("margin-right:", pxToRem(10), ";")]
    }, secondaryAction.text);
  }))), action.primary && react.jsx(Button$1, {
    size: 50,
    variant: "primary1",
    onClick: action.primary.onClick,
    disabled: (_action$primary$disab = action.primary.disabled) !== null && _action$primary$disab !== void 0 ? _action$primary$disab : false,
    css: action.secondary ? /*#__PURE__*/react.css("width:calc(50% - ", pxToRem(5), ");") : _ref$s
  }, action.primary.text)), subAction && react.jsx(TextButton, {
    size: 32,
    variant: "base1",
    onClick: subAction.onClick,
    disabled: (_subAction$disabled = subAction.disabled) !== null && _subAction$disabled !== void 0 ? _subAction$disabled : false
  }, subAction.text));
}

var _excluded$F = ["width", "onBlur", "header", "footer", "isPopupInMobile", "isStretch", "children", "hasInteraction", "height", "hasGrabber"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$t() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var LAPTOP_HEIGHT = {
  300: '48%',
  400: '78%',
  500: '84%',
  600: '90%',
  700: '96%'
};

var _ref2$c =  true ? {
  name: "1uvus3f",
  styles: "display:flex;flex-direction:column;width:100%;height:100%;word-break:break-all;overflow-y:auto"
} : 0;

function Modal(_ref3) {
  var width = _ref3.width,
      onBlur = _ref3.onBlur,
      header = _ref3.header,
      footer = _ref3.footer,
      _ref3$isPopupInMobile = _ref3.isPopupInMobile,
      isPopupInMobile = _ref3$isPopupInMobile === void 0 ? false : _ref3$isPopupInMobile,
      _ref3$isStretch = _ref3.isStretch,
      isStretch = _ref3$isStretch === void 0 ? false : _ref3$isStretch,
      children = _ref3.children,
      _ref3$hasInteraction = _ref3.hasInteraction,
      hasInteraction = _ref3$hasInteraction === void 0 ? false : _ref3$hasInteraction,
      _ref3$height = _ref3.height,
      height = _ref3$height === void 0 ? '' : _ref3$height,
      _ref3$hasGrabber = _ref3.hasGrabber,
      hasGrabber = _ref3$hasGrabber === void 0 ? false : _ref3$hasGrabber,
      rest = _objectWithoutProperties(_ref3, _excluded$F);

  var theme = react.useTheme();
  var isMobile = useResponsive().breakpoint === 'mobile';
  var scrollAvailableRef = React.useRef(null);
  var modalRef = React.useRef(null);
  var grabberRef = React.useRef(null);

  var _useState = React.useState(height),
      _useState2 = _slicedToArray(_useState, 2),
      customHeight = _useState2[0],
      setCustomHeight = _useState2[1];

  var isPopup = isPopupInMobile && width === 300;
  React.useEffect(function () {
    if (height !== 'auto') {
      setCustomHeight(height);
      return;
    }

    if (!modalRef.current || hasGrabber && !grabberRef.current) return;
    setCustomHeight("".concat(modalRef.current.getBoundingClientRect().height, "px"));
  }, [height, hasGrabber, isMobile]);
  return react.jsx(OverlayPortal, null, react.jsx(Dim, _extends({}, rest, {
    ref: scrollAvailableRef,
    variant: "basic",
    onClick: onBlur
  }), react.jsx("div", {
    ref: modalRef,
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    css: /*#__PURE__*/react.css(createSizeStyle({
      width: width,
      customHeight: customHeight,
      hasInteraction: hasInteraction,
      isStretch: isStretch,
      isPopup: isPopup
    }), " vertical-align:middle;width:", pxToRem(width), ";border-radius:", pxToRem(8), ";display:inline-flex;flex-direction:column;color:", theme.content.base1, ";background-color:", theme.background.elevated, ";", !isPopup && MEDIA_QUERY.max('mobile', /*#__PURE__*/react.css(safeAreaInset('bottom', 'padding-bottom'), " width:100%;vertical-align:bottom;border-bottom-left-radius:initial;border-bottom-right-radius:initial;")), ";")
  }, isMobile && hasGrabber && react.jsx(Grabber, {
    ref: grabberRef
  }), header && react.jsx(ModalHeader, header), react.jsx("div", {
    css: [FONT_STYLE.body1_1, _ref2$c, !footer && /*#__PURE__*/react.css("padding-bottom:", pxToRem(9), ";")]
  }, children), footer && react.jsx(ModalFooter, footer))));
}
/**
 * 모달 사이즈 스타일을 생성합니다.
 */

var _ref$r =  true ? {
  name: "tjpccj",
  styles: "height:90%"
} : 0;

function createSizeStyle(_ref4) {
  var width = _ref4.width,
      customHeight = _ref4.customHeight,
      hasInteraction = _ref4.hasInteraction,
      isStretch = _ref4.isStretch,
      isPopup = _ref4.isPopup;
  var height = LAPTOP_HEIGHT[width];
  var interactionCSS = /*#__PURE__*/react.css("height:", customHeight, ";transition:height 0.3s;");

  if (isStretch) {
    return /*#__PURE__*/react.css("height:", height, ";", !isPopup && MEDIA_QUERY.max('mobile', _ref$r), ";");
  }

  return /*#__PURE__*/react.css("max-height:", height, ";", !isPopup && MEDIA_QUERY.max('mobile', /*#__PURE__*/react.css("max-height:90%;", hasInteraction && interactionCSS, ";")), ";");
}

var Grabber = _styled__default['default']("div", {
  target: "e1ht8eqj0"
})("width:", pxToRem(32), ";min-height:", pxToRem(4), ";border-radius:", pxToRem(2), ";background-color:", function (_ref5) {
  var theme = _ref5.theme;
  return theme.content.base4;
}, ";margin:", pxToRem(6), " auto 0;");

function _EMOTION_STRINGIFIED_CSS_ERROR__$s() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var LogoIcon = function LogoIcon(props) {
  return react.jsx("svg", props, react.jsx("g", {
    fill: "none",
    fillRule: "evenodd"
  }, react.jsx("path", {
    fill: "#35C5F0",
    d: "M16.41 0H3.59A3.59 3.59 0 0 0 0 3.59v12.82A3.59 3.59 0 0 0 3.59 20h12.82A3.59 3.59 0 0 0 20 16.41V3.59A3.59 3.59 0 0 0 16.41 0"
  }), react.jsx("path", {
    fill: "#FFF",
    d: "M14.75 10.34c-.74 0-1.33-.6-1.33-1.34 0-.74.6-1.34 1.33-1.34s1.32.6 1.32 1.34c0 .74-.59 1.34-1.32 1.34zm-1 3.53H6.12V8.75l3.82-2.7 2.2 1.55a3.01 3.01 0 0 0-.35 1.4 3 3 0 0 0 1.98 2.83v2.04zm1-7.87c-.34 0-.66.06-.97.17l-3.17-2.24a1.18 1.18 0 0 0-1.35 0L4.5 7.28a1.2 1.2 0 0 0-.51.98v6.54c0 .66.53 1.2 1.19 1.2h9.5a1.2 1.2 0 0 0 1.18-1.2v-3.02A3 3 0 0 0 17.7 9c0-1.65-1.32-3-2.96-3z"
  })));
};

LogoIcon.defaultProps = {
  className: "icon",
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  preserveAspectRatio: "xMidYMid meet"
};

var _ref$q =  true ? {
  name: "1fxvqh3",
  styles: "flex:0 1 auto;min-width:0"
} : 0;

var _ref2$b =  true ? {
  name: "1wnowod",
  styles: "display:flex;align-items:center;justify-content:center"
} : 0;

function AppDownloadPopup(_ref3) {
  var isOpen = _ref3.isOpen,
      onClose = _ref3.onClose,
      _ref3$onAppOpen = _ref3.onAppOpen,
      onAppOpen = _ref3$onAppOpen === void 0 ? function () {//
  } : _ref3$onAppOpen;
  var theme = react.useTheme();

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasBottomPadding = _useState2[0],
      setHasBottomPadding = _useState2[1];

  React.useEffect(function () {
    if (/(?:iPad|iPhone|iPod).*Instagram/gi.test(navigator.userAgent)) {
      setHasBottomPadding(true);
    }
  }, []);
  if (!isOpen) return null;
  return react.jsx(Modal, {
    width: 400
  }, react.jsx("div", {
    css: /*#__PURE__*/react.css("max-width:", pxToRem(300), ";margin:0 auto;padding:", pxToRem(30), " 0 ", pxToRem(20), ";text-align:left;", hasBottomPadding && "\n          padding-bottom: ".concat(pxToRem(100), ";\n        "), ";")
  }, react.jsx("div", {
    css: _ref2$b
  }, react.jsx("div", {
    css: /*#__PURE__*/react.css("flex:0 0 auto;margin-right:", pxToRem(20), ";")
  }, react.jsx(LogoIcon, {
    css: /*#__PURE__*/react.css("width:", pxToRem(90), ";height:", pxToRem(90), ";")
  })), react.jsx("div", {
    css: _ref$q
  }, react.jsx("div", {
    css: /*#__PURE__*/react.css("margin-bottom:10px;font-size:", pxToRem(20), ";font-weight:700;color:", theme.content.base1, ";")
  }, "\uC571\uC5D0\uC11C\uB294 1\uCD08\uB9CC\uC5D0!", react.jsx("br", null), "\uAC04\uD3B8\uD558\uAC8C \uB85C\uADF8\uC778\uD558\uAE30"), react.jsx("div", {
    css: /*#__PURE__*/react.css("font-size:", pxToRem(11), ";line-height:1;")
  }, react.jsx("div", {
    css: /*#__PURE__*/react.css("display:inline-block;margin-right:", pxToRem(2), ";")
  }, new Array(5).fill(0).map(function (_, index) {
    return react.jsx(Icon, {
      key: index,
      name: "star",
      fill: function fill(theme) {
        return theme.content.primary1.basic;
      },
      size: 12
    });
  })), react.jsx("div", {
    css: /*#__PURE__*/react.css("display:inline-block;font-size:", pxToRem(10), ";line-height:1;color:", theme.interactive.base2, ";")
  }, "\uD2B9\uAC00, \uCFE0\uD3F0 \uB4F1 \uC571 \uC804\uC6A9 \uD61C\uD0DD\uAE4C\uC9C0")))), react.jsx("button", {
    css: /*#__PURE__*/react.css(RESET_BUTTON, " display:block;position:relative;box-sizing:border-box;width:100%;margin:", pxToRem(25), " 0 ", pxToRem(10), ";padding:", pxToRem(25), " 0;box-sizing:border-box;background-color:", theme.background.groupedBase, ";color:", theme.content.base1, ";text-align:center;font-family:inherit;font-size:", pxToRem(18), ";font-weight:normal;border-radius:", pxToRem(8), ";cursor:pointer;"),
    type: "button",
    onClick: function onClick() {
      onAppOpen();
    }
  }, "\uD3B8\uB9AC\uD55C \uC571\uC73C\uB85C \uBCF4\uAE30"), react.jsx("button", {
    css: /*#__PURE__*/react.css(RESET_BUTTON, " display:block;box-sizing:border-box;width:100%;padding:", pxToRem(10), " ", pxToRem(15), ";text-align:center;font-family:inherit;font-size:", pxToRem(13), ";color:", theme.interactive.base2, ";"),
    type: "button",
    onClick: function onClick() {
      onClose();
    }
  }, "\uBAA8\uBC14\uC77C \uC6F9\uC73C\uB85C \uBCFC\uB798\uC694")));
}

function AppDownloadPopupContainer(props) {
  var onCheck = props.onCheck,
      onAppOpen = props.onAppOpen,
      onClose = props.onClose;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var checked = onCheck();
  React.useEffect(function () {
    setOpen(checked);
  }, [checked]);
  var handleClose = React.useCallback(function () {
    onClose();
    setOpen(false);
  }, [onClose]);
  return react.jsx(AppDownloadPopup, {
    isOpen: isOpen,
    onClose: handleClose,
    onAppOpen: onAppOpen
  });
}

var mobileBannerSrc = "https://assets.ohou.se/design-system/e6dc84d40e34cceb.jpg";

function MobileTopBanner(_ref) {
  var isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      _ref$onAppOpen = _ref.onAppOpen,
      onAppOpen = _ref$onAppOpen === void 0 ? function () {//
  } : _ref$onAppOpen,
      _ref$imageSrc = _ref.imageSrc,
      imageSrc = _ref$imageSrc === void 0 ? mobileBannerSrc : _ref$imageSrc,
      className = _ref.className;
  var theme = react.useTheme();
  if (!isOpen) return null;
  return react.jsx("div", {
    className: className,
    css: /*#__PURE__*/react.css("position:relative;width:100%;z-index:", ZINDEX.banner, ";border-bottom:1px solid ", theme.divider, ";display:none;", MEDIA_QUERY.max('mobile', "\n          display: block;\n        "), ";")
  }, react.jsx("button", {
    css: /*#__PURE__*/react.css(RESET_BUTTON, " display:block;width:100%;height:", pxToRem(76), ";background:#f0f5f7;box-sizing:border-box;"),
    type: "button",
    "aria-label": "\uC624\uB298\uC758\uC9D1 \uC571\uC73C\uB85C \uBCF4\uAE30",
    onClick: function onClick() {
      onAppOpen();
    }
  }, react.jsx("div", {
    css: /*#__PURE__*/react.css("width:100%;height:100%;background-position:50%;background-size:contain;background-repeat:no-repeat;background-image:url(", imageSrc, ");")
  })), react.jsx("button", {
    css: /*#__PURE__*/react.css(RESET_BUTTON, " position:absolute;top:50%;left:0;display:block;box-sizing:border-box;margin:-", pxToRem(24), " 0 0;padding:", pxToRem(18), ";color:", theme.content.base2, ";width:", pxToRem(48), ";height:", pxToRem(48), ";line-height:0;font-size:0;"),
    type: "button",
    "aria-label": "\uB2EB\uAE30",
    onClick: function onClick() {
      onClose();
    }
  }, react.jsx(Icon, {
    size: 12,
    name: "dismiss_thick"
  })));
}

var getContentsUrl = function getContentsUrl(_ref) {
  var contentId = _ref.contentId,
      contentType = _ref.contentType,
      contentUrl = _ref.contentUrl,
      isUserLoggedIn = _ref.isUserLoggedIn,
      origin = _ref.origin;

  switch (contentType === null || contentType === void 0 ? void 0 : contentType.split(/(?=[A-Z])/).join('_').toLowerCase()) {
    case 'competition':
      return "".concat(origin, "/competitions/").concat(contentId);

    case 'production':
      return "".concat(origin, "/productions/").concat(contentId, "/selling");

    case 'exhibition':
      return "".concat(origin, "/exhibitions/").concat(contentId);

    case 'advice':
      return "".concat(origin, "/advices/").concat(contentId);

    case 'project':
      return "".concat(origin, "/projects/").concat(contentId, "/detail");

    case 'card_collection':
      return "".concat(origin, "/contents/card_collections/").concat(contentId);

    case 'invite_friend':
      if (!isUserLoggedIn) {
        return "".concat(origin, "/users/sign_in?redirect_to=/invite_codes/recommend_code");
      }

      return "".concat(origin, "/invite_codes/recommend_code");

    default:
      return contentUrl || '';
  }
};

function PCTopBanner(_ref2) {
  var className = _ref2.className,
      isOpen = _ref2.isOpen,
      onClose = _ref2.onClose,
      _onClick = _ref2.onClick,
      contentList = _ref2.contentList,
      linkComponent = _ref2.linkComponent,
      isUserLoggedIn = _ref2.isUserLoggedIn,
      origin = _ref2.origin;
  var LinkComponent = linkComponent;
  var backgroundContent = [contentList[0], contentList[contentList.length - 1]];
  if (!isOpen) return null;
  return react.jsx("div", {
    className: className,
    css: /*#__PURE__*/react.css("position:relative;display:none;z-index:", ZINDEX.banner, ";", MEDIA_QUERY.min('tablet', "\n          display: block;\n        "), ";")
  }, backgroundContent.map(function (content, index) {
    /* 왼쪽, 오른쪽 배너의 끝 부분을 채워주기 위해 필요합니다. */
    var pcGradientColor = content.pcGradientColor;
    var url = getContentsUrl(_objectSpread2(_objectSpread2({}, content), {}, {
      isUserLoggedIn: isUserLoggedIn,
      origin: origin
    }));
    var isFirst = index === 0;
    return react.jsx(LinkComponent, {
      key: index,
      href: url,
      "aria-label": "PC \uCD5C\uC0C1\uB2E8 \uBC30\uB108",
      onClick: function onClick() {
        return _onClick && _onClick(content, index >= 1 ? contentList.length - 1 : 0);
      },
      css: /*#__PURE__*/react.css("position:absolute;top:0;bottom:0;width:50%;background-color:", pcGradientColor, ";", isFirst ? 'left: 0;' : 'right: 0;', ";")
    });
  }), react.jsx("div", {
    css: /*#__PURE__*/react.css("display:flex;max-width:", pxToRem(1156), ";margin:0 auto;padding:0 ", pxToRem(40), ";", MEDIA_QUERY.min('laptop', "\n            padding: 0 ".concat(pxToRem(60), ";\n          ")), ";")
  }, contentList.map(function (content, index) {
    var coverImageUrl = content.coverImageUrl,
        pcGradientColor = content.pcGradientColor;
    var url = getContentsUrl(_objectSpread2(_objectSpread2({}, content), {}, {
      isUserLoggedIn: isUserLoggedIn,
      origin: origin
    }));
    return react.jsx(LinkComponent, {
      key: index,
      href: url,
      onClick: function onClick() {
        return _onClick && _onClick(content, index);
      },
      "aria-label": "PC \uCD5C\uC0C1\uB2E8 \uBC30\uB108",
      css: /*#__PURE__*/react.css("flex:1 0 0;background-image:url(", coverImageUrl, ");background-color:", pcGradientColor, ";position:relative;height:", pxToRem(50), ";background-size:auto 100%;background-repeat:no-repeat;background-position:center;z-index:1;")
    });
  })), react.jsx("button", {
    css: /*#__PURE__*/react.css(RESET_BUTTON, " position:absolute;top:50%;right:", pxToRem(8), ";display:block;margin:-", pxToRem(25), " 0 0;padding:", pxToRem(12), ";color:white;width:", pxToRem(48), ";height:", pxToRem(48), ";box-sizing:border-box;font-size:0;line-height:0;"),
    type: "button",
    "aria-label": "\uB2EB\uAE30",
    onClick: function onClick() {
      onClose();
    }
  }, react.jsx(Icon, {
    size: 24,
    name: "dismiss_thick",
    fill: function fill(theme) {
      return theme.background.base;
    }
  })));
}

function TopBannerContainer(props) {
  var pathname = props.pathname,
      isVisible = props.isVisible,
      onCheck = props.onCheck,
      onClose = props.onClose,
      ssrCheckLiteral = props.ssrCheckLiteral,
      ssrClassName = props.ssrClassName,
      children = props.children;
  /**
   * isOpen과 isUnsure은 무엇인가요? ...
   * React에서 자체적으로 배너 상태를 관리하고 있긴 하지만, 유저가 오늘의집에 들어와서 로딩하는
   * 시점에는 아직 React가 로딩되지 않은 상황이기 때문에, 이 때 layout shift를 최소화하기
   * 위해 배너의 동작을 <script> 태그를 통해서 제어하고 있습니다.
   *
   * script 태그 안에서는 유저가 앱 다운로드 팝업을 봤는지, 배너를 닫았는지 등 여러가지를
   * 판단해서 배너가 보여져야 하는지, 아니면 숨겨져야 하는지 결정해서, 만약 숨겨져야 한다면
   * style 태그를 추가해서 노드를 숨겨버립니다.
   *
   * 문제는 이 style 태그는 지워지지 않기 때문에, React에서 다시 배너를 표출하려고 할 때
   * 이슈가 생기게 됩니다.
   * PC 배너와 달리, 모바일 배너는 앱 다운로드 팝업을 닫고, 유저가 다른 페이지로 이동했을 때
   * 다시 보여지는데요, 다른 페이지로 이동하는 것의 인식을 'pathname'을 통해서 하고 있습니다.
   *
   * 즉, 실제 reload가 아닌, SPA 안에서 페이지가 바뀌어도 배너가 보여져야 합니다. 하지만
   * 이 때 페이지 진입 시 배너를 강제로 숨겨버렸기 때문에, React에서 다시 배너를 보여줄 수
   * 없는 상황이 되어버립니다.
   *
   * 이를 해결하기 위해, SSR 시점의 배너 로직은 순전히 SSR 과정중 layout shift를 막는
   * 용도로만 쓰고, React가 로딩되고 나면 이 스타일에 영향받지 않도록 구성하면 됩니다.
   *
   * 이를 위해 "isUnsure" 플래그가 추가되었습니다. 아직 리액트가 렌더링되지 않은 상황에서는
   * isUnsure가 true라서 클래스 네임이 입력되겠지만, 리액트가 초기화된 뒤에는 리액트가
   * 자유롭게 제어할 수 있도록 클래스 네임을 해제합니다.
   */

  var _useState = React.useState({
    isOpen: false,
    isUnsure: true
  }),
      _useState2 = _slicedToArray(_useState, 2),
      _useState2$ = _useState2[0],
      isOpen = _useState2$.isOpen,
      isUnsure = _useState2$.isUnsure,
      setState = _useState2[1];

  React.useEffect(function () {
    setState({
      isOpen: onCheck(),
      isUnsure: false
    });
  }, [pathname, onCheck]);
  var handleClose = React.useCallback(function () {
    setState({
      isOpen: false,
      isUnsure: false
    });
    onClose();
  }, [onClose]);
  return react.jsx(React__default['default'].Fragment, null, ssrCheckLiteral && react.jsx("script", {
    dangerouslySetInnerHTML: {
      __html: "(function() {\n  if (!(".concat(ssrCheckLiteral, ")) {\n    var style = document.createElement('style');\n    style.append('.").concat(ssrClassName, " { display: none !important; }');\n    document.head.appendChild(style);\n  }\n})();")
    }
  }), children({
    className: isUnsure ? ssrClassName : '',
    isOpen: isVisible && (isOpen || isUnsure),
    onClose: handleClose
  }));
}

function useForkRef() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  return React.useCallback(function (v) {
    return refs.forEach(function (ref) {
      if (typeof ref === 'function') {
        ref(v);
      } else if (ref != null) {
        ref.current = v;
      }
    });
  }, [refs]);
}

/**
 * 현재 브라우저가 IE 인지를 체크합니다.
 * @param {boolean} [UseIEDetectorOptions] 체크 옵션
 * @param {boolean} [UseIEDetectorOptions.includeEdge] 엣지 포함 여부
 * @return {boolean} IE 체크 결과
 */
function useIEDetector() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$includeEdge = _ref.includeEdge,
      includeEdge = _ref$includeEdge === void 0 ? false : _ref$includeEdge;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isIE = _useState2[0],
      setIE = _useState2[1];

  React.useEffect(function () {
    var ua = window.navigator.userAgent;
    var isIE = /MSIE|Trident\//i.test(ua);
    var isEdge = /Edge\//i.test(ua);
    setIE(isIE || includeEdge && isEdge);
  }, [includeEdge]);
  return isIE;
}

function useMatchMedia(query, options) {
  var _ref = options || {},
      fallback = _ref.fallback,
      populateOnInitialRender = _ref.populateOnInitialRender;

  var _useState = React.useState(function () {
    if (!populateOnInitialRender || typeof window === 'undefined') {
      return fallback != null ? fallback : undefined;
    }

    var mediaInstance = window.matchMedia(query);
    return mediaInstance.matches;
  }),
      _useState2 = _slicedToArray(_useState, 2),
      matches = _useState2[0],
      setMatches = _useState2[1];

  React.useEffect(function () {
    var mediaInstance = window.matchMedia(query);

    var handleChange = function handleChange() {
      return setMatches(mediaInstance.matches);
    };

    mediaInstance.addListener(handleChange);
    setMatches(mediaInstance.matches);
    return function () {
      mediaInstance.removeListener(handleChange);
    };
  }, [query]);
  return {
    matches: matches
  };
}

function useResize(ref, handleResize) {
  React.useEffect(function () {
    var targetNode = ref.current;
    var resizeObserver = null;

    if (window.ResizeObserver != null && targetNode != null) {
      resizeObserver = new ResizeObserver(handleResize);
      resizeObserver.observe(targetNode);
    } else {
      window.addEventListener('resize', handleResize);
    }

    return function () {
      if (resizeObserver != null) {
        resizeObserver.disconnect();
      } else {
        window.removeEventListener('resize', handleResize);
      }
    };
  }, [ref, handleResize]);
}

function useNodeSizeObserver(callback) {
  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var ref = React.useRef(null);
  var triggerCallback = React.useCallback(function () {
    if (!ref.current) return;
    callback({
      width: ref.current.clientWidth,
      height: ref.current.clientHeight
    });
  }, [callback]);
  var setRef = React.useCallback(function (element) {
    ref.current = element;
    triggerCallback();
  }, [triggerCallback]);
  var handleResize = React.useMemo(function () {
    return _debounce__default['default'](triggerCallback, 500);
  }, [triggerCallback]);
  useResize(ref, handleResize);
  React.useEffect(function () {
    triggerCallback(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerCallback].concat(_toConsumableArray(deps)));
  return setRef;
}

/**
 * OS 타입이 Windows 인지 체크합니다.
 */

function useWindowsOSDetector() {
  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isWindowsOS = _useState2[0],
      setWindowsOS = _useState2[1];

  React.useEffect(function () {
    var ua = window.navigator.userAgent;
    var isWindowsOS = /'Win32|Win64|Windows|Windows NT|WinCE/gi.test(ua);
    setWindowsOS(isWindowsOS);
  }, []);
  return isWindowsOS;
}

/**
 * app인지 web인지 확인하고, app일 경우 추가로 app의 osType, osVersion도 확인합니다.
 * @param query query
 * @returns app이라면 isApp: true, osType, osVersion을 return. web이라면 isApp: false를 return.
 */
function getDeviceInfo(query) {
  var osType = null;
  var osVersion = null;

  if (typeof window === 'undefined') {
    if (query != null) {
      osType = query.os_type;
      osVersion = query.version;
    }
  } else {
    var search = querystring__default['default'].parse(location.search.slice(1));

    if (search.os_type != null) {
      osType = search.os_type;
      sessionStorage.os_type = search.os_type;
    } else {
      osType = sessionStorage.os_type;
    }

    if (search.os_version != null) {
      osVersion = search.version;
      sessionStorage.os_version = search.version;
    } else {
      osVersion = sessionStorage.os_version;
    }
  }

  if (osVersion == null && osType == null) {
    return {
      isApp: false
    };
  } else {
    return {
      isApp: true,
      osType: osType,
      osVersion: osVersion
    };
  }
}

/**
 * params로 받은 AOS, iOS 버전보다 높은 버전의 app인지 확인합니다.
 * @param AOS 기준 AOS 버전
 * @param iOS 기준 iOS 버전
 * @param query query
 * @returns params로 받은 AOS, iOS 버전보다 높은 버전인 App일 경우 true. Web or MWeb or 기준보다 낮은 버전일 경우 false.
 */
function isHigherAppVersion(_ref) {
  var AOS = _ref.AOS,
      iOS = _ref.iOS,
      query = _ref.query;

  var _getDeviceInfo = getDeviceInfo(query),
      isApp = _getDeviceInfo.isApp,
      osType = _getDeviceInfo.osType,
      osVersion = _getDeviceInfo.osVersion;

  if (!isApp || !osType || !osVersion) return false;
  var targetSelected;

  if (osType === 'Android') {
    targetSelected = AOS;
  } else if (osType === 'iOS') {
    targetSelected = iOS;
  } else {
    return false;
  }

  var currentVersion = /^\d+(\.(\d+))+/.exec(osVersion);

  if (!currentVersion) {
    return false;
  }

  var targetFragments = targetSelected.split('.');
  var versionFragments = currentVersion[0].split('.');

  for (var i = 0; i < targetFragments.length; i += 1) {
    var targetFragment = parseInt(targetFragments[i], 10);
    var versionFragment = parseInt(versionFragments[i], 10);

    if (targetFragment > versionFragment) {
      return false;
    } else if (targetFragment < versionFragment) {
      return true;
    }
  }

  return false;
}

function openPopup() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'about:blank';
  var openPage = arguments.length > 1 ? arguments[1] : undefined;
  var popupOption = arguments.length > 2 ? arguments[2] : undefined;
  var popupWindow = window.open(url, 'popupWindow', popupOption);
  if (popupWindow == null) return false;

  if (!openPage) {
    popupWindow.close();
  }

  return true;
}

var bizchannelUUID = '@오늘의집_고객센터';
var bizChannelURL = "https://bizmessage.kakao.com/chat/open/".concat(bizchannelUUID);
var channelPublicId = '_TsNUK';
var channelUrl = "https://pf.kakao.com/".concat(channelPublicId, "/chat");

/**
 * iOS 8.34보다 낮은 버전의 app / 그외 를 구분하여 기기에 따른 알맞은 카카오톡 상담하기 채팅창을 엽니다.
 * @param query
 * @returns 카카오톡 상담하기 채팅창을 여는 함수
 */
var useKakaoChat = function useKakaoChat(query) {
  var _getDeviceInfo = getDeviceInfo(query),
      isApp = _getDeviceInfo.isApp;

  var openKakaoChat = React.useCallback(function () {
    if (!isApp || isHigherAppVersion({
      AOS: '0',
      iOS: '8.34',
      query: query
    })) {
      try {
        var isCanOpenPopup = openPopup(bizChannelURL, true, 'width=1024, height=800');

        if (!isCanOpenPopup) {
          window.location.href = bizChannelURL;
        }
      } catch (_unused) {
        window.location.href = bizChannelURL;
      }
    } else {
      window.location.href = channelUrl;
    }
  }, [query, isApp]);
  return {
    openKakaoChat: openKakaoChat
  };
};

var SnackbarContext = React.createContext(null);
function useSnackbar() {
  var result = React.useContext(SnackbarContext);

  if (result == null) {
    throw new Error('SnackbarContext is not mounted');
  }

  return result;
}

var APP_BANNER_PATHNAME_BLACKLIST = /^\/normal_users|^\/sessions|^\/orders|^\/contacts|^\/exhibitions|^\/cart|^\/3d_intro|^\/interior3ds/;
var APP_BANNER_SEARCH_BLACKLIST = /utm_source=naver_shop|no_app_banner=true/;

function isMarketingHidden() {
  var triggered = false;

  try {
    triggered = sessionStorage.marketingHiddenTriggered === 'yes';
  } catch (e) {//
  }

  var search = querystring__default['default'].parse(location.search.slice(1));

  if (triggered || search.pro_app != null) {
    try {
      sessionStorage.marketingHiddenTriggered = 'yes';
    } catch (e) {//
    }

    return true;
  }

  return false;
}

function isMobile() {
  if (typeof window === 'undefined') return false;

  if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
    return true;
  }

  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}

function getCookie(name) {
  if (typeof window !== 'undefined') {
    var cookies = (document.cookie || '').split('; ');

    for (var i = 0; i < cookies.length; i += 1) {
      var match = /([^=]+)=(.+)/.exec(cookies[i]);

      if (match && match[1] === name) {
        return match[2];
      }
    }
  }

  return null;
}

function setCookie(name, value, delay, domain) {
  var cookieStr = "".concat(name, "=").concat(value, "; path=/; ") + "expires=".concat(new Date(Date.now() + delay).toUTCString(), ";");

  if (domain) {
    cookieStr += " domain=".concat(domain);
  }

  document.cookie = cookieStr;
}

function NavigationTopBanner(props) {
  var location = props.location,
      _onAppOpen = props.onAppOpen,
      mobileImageSrc = props.mobileImageSrc,
      _props$pcContentList = props.pcContentList,
      pcContentList = _props$pcContentList === void 0 ? [] : _props$pcContentList,
      linkComponent = props.linkComponent,
      onLog = props.onLog,
      isUserLoggedIn = props.isUserLoggedIn,
      onClosePCTopBanner = props.onClosePCTopBanner,
      onCloseMobileTopBanner = props.onCloseMobileTopBanner,
      onCloseAppDownloadPopup = props.onCloseAppDownloadPopup;
  var cookieDomain = location.origin ? ".".concat(location.origin.split(/\.|\/\//).slice(-2).join('.')) : '.ohou.se';
  var isInApp = useIsInApp(location);
  var hiddenAppBanner = isInApp || APP_BANNER_PATHNAME_BLACKLIST.test(location.pathname) || APP_BANNER_SEARCH_BLACKLIST.test(location.search);
  return react.jsx(React__default['default'].Fragment, null, react.jsx(TopBannerContainer, {
    pathname: location.pathname,
    isVisible: !isInApp && pcContentList.length > 0,
    onCheck: function onCheck() {
      return getCookie('ohsTopBannerClosed') !== 'yes' && !isMarketingHidden();
    },
    onClose: function onClose() {
      onLog('banner.top.pc.close', {});
      setCookie('ohsTopBannerClosed', 'yes', 24 * 3600 * 1000, cookieDomain);
      onClosePCTopBanner === null || onClosePCTopBanner === void 0 ? void 0 : onClosePCTopBanner();
    },
    ssrClassName: "gnb-pc-top-banner--unsure" // eslint-disable-next-line max-len
    ,
    ssrCheckLiteral: "!/(^|;)ohsTopBannerClosed=yes($|;)/.test(document.cookie)"
  }, function (props) {
    return react.jsx(PCTopBanner, _extends({}, props, {
      contentList: pcContentList,
      linkComponent: linkComponent,
      onClick: function onClick(content, index) {
        onLog('banner.top.pc.click', {
          content: content,
          index: index
        });
      },
      isUserLoggedIn: isUserLoggedIn,
      origin: location.origin || 'https://ohou.se'
    }));
  }), react.jsx(TopBannerContainer, {
    pathname: location.pathname,
    isVisible: !hiddenAppBanner,
    onCheck: function onCheck() {
      return getCookie('ohsAppDownloadPopupClosed') === 'yes' && getCookie('ohsTopBannerClosed') !== 'yes' && !isMarketingHidden();
    },
    onClose: function onClose() {
      onLog('banner.top.mobile.close', {});
      setCookie('ohsTopBannerClosed', 'yes', 12 * 3600 * 1000, cookieDomain);
      onCloseMobileTopBanner === null || onCloseMobileTopBanner === void 0 ? void 0 : onCloseMobileTopBanner();
    },
    ssrClassName: "gnb-mobile-top-banner--unsure",
    ssrCheckLiteral: '/(^|;)ohsAppDownloadPopupClosed=yes($|;)/.test(document.cookie) ' + '&& !/(^|;)ohsTopBannerClosed=yes($|;)/.test(document.cookie)'
  }, function (props) {
    return react.jsx(MobileTopBanner, _extends({}, props, {
      imageSrc: mobileImageSrc,
      onAppOpen: function onAppOpen() {
        onLog('banner.top.mobile.click', {});

        _onAppOpen('banner.top.mobile.click');
      }
    }));
  }), react.jsx(AppDownloadPopupContainer, {
    onCheck: function onCheck() {
      return isMobile() && !hiddenAppBanner && getCookie('ohsAppDownloadPopupClosed') !== 'yes' && !isMarketingHidden();
    },
    onClose: function onClose() {
      onLog('banner.bottom.mobile.close', {});
      setCookie('ohsAppDownloadPopupClosed', 'yes', 12 * 3600 * 1000, cookieDomain);
      onCloseAppDownloadPopup === null || onCloseAppDownloadPopup === void 0 ? void 0 : onCloseAppDownloadPopup();
    },
    onAppOpen: function onAppOpen() {
      onLog('banner.bottom.mobile.click', {});

      _onAppOpen('banner.bottom.mobile.click');
    }
  }));
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$r() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$p =  true ? {
  name: "1089mxj",
  styles: "white-space:pre-wrap"
} : 0;

function NotSupportedBrowserBanner(_ref2) {
  var buttons = _ref2.buttons;
  var theme = react.useTheme();
  return react.jsx(ui.Sticky, {
    direction: "top",
    offset: 0,
    zIndex: ZINDEX.appBar + 3,
    disableNativeSticky: true,
    disableBottom: true
  }, react.jsx("div", {
    css: /*#__PURE__*/react.css("display:flex;flex-wrap:wrap;align-items:center;justify-content:center;width:100%;padding:", pxToRem(18), ";box-sizing:border-box;background:", theme.content.base4, ";")
  }, react.jsx("p", {
    css: [FONT_STYLE.body1_1, /*#__PURE__*/react.css("margin:", pxToRem(6), " ", pxToRem(12), ";color:", theme.content.base1, ";font-weight:500;text-align:center;"), MEDIA_QUERY.max('mobile', _ref$p)]
  }, '이 브라우저는 지원이 종료되었습니다.\n다른 브라우저를 이용해 주세요.'), react.jsx("div", {
    css: /*#__PURE__*/react.css("margin:", pxToRem(2), " ", pxToRem(12), ";text-align:center;line-height:0;")
  }, buttons.map(function (button) {
    return react.jsx(Button$1, {
      key: button.id,
      variant: "base1",
      size: 32,
      onClick: button.onClick,
      css: /*#__PURE__*/react.css("margin:", pxToRem(4), ";")
    }, button.text);
  }))));
}

function NotSupportedBrowserPopup(_ref) {
  var buttons = _ref.buttons,
      onClose = _ref.onClose;
  var isMobile = useResponsive().breakpoint === 'mobile';
  var modalWidthProps = React.useMemo(function () {
    return isMobile ? {
      width: 300,
      isPopupInMobile: true
    } : {
      width: 400
    };
  }, [isMobile]);
  return react.jsx(Modal, _extends({}, modalWidthProps, {
    header: {
      title: '브라우저 지원 종료 안내',
      onClose: onClose
    },
    footer: {
      // IE flex 버그 때문에 height 고정
      style: /*#__PURE__*/react.css("height:", pxToRem(76), ";box-sizing:border-box;"),
      action: {
        secondary: [buttons[0], buttons[1]]
      }
    }
  }), react.jsx("p", {
    css: /*#__PURE__*/react.css("padding:", pxToRem(10), " ", pxToRem(16), ";word-break:keep-all;white-space:pre-wrap;")
  }, '이 브라우저(인터넷 익스플로러)는\n서비스 지원이 종료되었습니다.\n다른 브라우저로 오늘의집을 이용해 주세요.'));
}

var POPUP_CLOSED_FLAG_SESSION_KEY = 'ohsNotSupportedBrowserPopupClosed';
function NotSupportedBrowser() {
  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isPopupOpened = _useState2[0],
      setPopupOpened = _useState2[1];

  var isWindowsOS = useWindowsOSDetector();
  React.useEffect(function () {
    setPopupOpened(window.sessionStorage.getItem(POPUP_CLOSED_FLAG_SESSION_KEY) !== 'true');
  }, []);
  var buttons = React.useMemo(function () {
    return [{
      id: 'chrome',
      text: '크롬 설치하기',
      onClick: function onClick() {
        window.location.href = 'https://www.google.co.kr/chrome';
      }
    }, {
      id: 'edge',
      text: isWindowsOS ? '엣지로 열기' : '엣지 설치하기',
      onClick: isWindowsOS ? function () {
        window.location.href = 'microsoft-edge:https://ohou.se';
      } : function () {
        window.location.href = 'https://www.microsoft.com/edge';
      }
    }];
  }, [isWindowsOS]);
  var handlePopupClose = React.useCallback(function () {
    window.sessionStorage.setItem(POPUP_CLOSED_FLAG_SESSION_KEY, 'true');
    setPopupOpened(false);
  }, []);
  return react.jsx(React__default['default'].Fragment, null, react.jsx(NotSupportedBrowserBanner, {
    buttons: buttons
  }), isPopupOpened && react.jsx(NotSupportedBrowserPopup, {
    buttons: buttons,
    onClose: handlePopupClose
  }));
}

var _excluded$E = ["children", "error"];
function Hint(_ref) {
  var children = _ref.children,
      error = _ref.error,
      rest = _objectWithoutProperties(_ref, _excluded$E);

  var theme = react.useTheme();
  return react.jsx("div", _extends({}, rest, {
    css: /*#__PURE__*/react.css(FONT_STYLE.caption1, " color:", error ? theme.content.primary2.thick : theme.content.base2, ";")
  }), error && react.jsx(Icon, {
    name: "alert",
    size: 18,
    css: /*#__PURE__*/react.css("vertical-align:middle;margin-right:", pxToRem(6), ";")
  }), children);
}

var _excluded$D = ["children", "count", "maxCount"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$q() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$o =  true ? {
  name: "rvw9kk",
  styles: "flex:1;overflow:hidden;text-overflow:ellipsis"
} : 0;

var _ref2$a =  true ? {
  name: "uoloz",
  styles: "display:flex;white-space:nowrap"
} : 0;

function CounterHint(_ref3) {
  var children = _ref3.children,
      count = _ref3.count,
      maxCount = _ref3.maxCount,
      rest = _objectWithoutProperties(_ref3, _excluded$D);

  return react.jsx(Hint, _extends({}, rest, {
    css: _ref2$a
  }), react.jsx("span", {
    css: _ref$o
  }, children), react.jsx("span", {
    css: /*#__PURE__*/react.css("text-align:right;padding-left:", pxToRem(10), ";")
  }, count, "/", maxCount));
}

/**
 * c = 가로, 세로 값을 사용해서 중앙을 기준으로 이미지를 잘라냅니다. (cover)
 * w=256&h=256&c=c를 지정한다면 256x256의 이미지가 반환됩니다.
 * i = 가로, 세로 안에 모두 들어가도록 이미지를 리사이징합니다. (inside, 기본값)
 * w=256&h=256&c=i를 사용하고, 2:1 비율의 원본 이미지를 요청한다면 256x128의 이미지가 반환됩니다.
 * o = 가로나 세로중 하나에 꽉 차도록 이미지를 리사이징합니다. (outside)
 */

// e.g.
// https://image.ohou.se/image/central_crop/{bucketplace-v2-development}/*
// https://image.ohou.se/image/resize/{bucketplace-v2-development}/*
var IMAGE_OHOUSE_LEGACY_PATTERN = /^https?:\/\/image\.ohou\.se\/image\/(?:central_crop|resize)\/([^/]+)\/([^/]+)\/.+\/.*$/; // e.g. https://image.ohou.se/i/{bucketplace-v2-development}/*

var IMAGE_OHOUSE_PATTERN = /^https?:\/\/image\.ohou\.se\/i\/([^/]+)\/([^?]+)(?:\?.*)?$/; // e.g. https://s3-ap-northeast-1.amazonaws.com/{bucketplace-v2-development}/*

var S3_LOCAL_PATTERN = /^https?:\/\/s3-ap-northeast-1\.amazonaws\.com\/([^/]+)\/([^?]+)(?:\?.*)?$/; // e.g. https://{bucketplace-v2-development}.s3-ap-northeast-1.amazonaws.com/*

var S3_LOCAL_PATTERN_2 = /^https?:\/\/([^.]+)\.s3-ap-northeast-1\.amazonaws\.com\/([^?]+)(?:\?.*)?$/; // e.g.
// https://{bucketplace-v2-development}.s3.amazonaws.com/*
// https://{bucketplace-v2-development}.cloudfront.net/*

var S3_GLOBAL_PATTERN = /^https?:\/\/([^.]+)\.(?:s3\.(?:[a-zA-Z0-9-]+\.)?amazonaws\.com|cloudfront\.net)\/([^?]+)(?:\?.*)?$/;
var OLD_BUCKET_NAMES = ['d224jl0o7z9gbn', 'd12gkpu9h0k5iq'];
var NEW_BUCKET_NAME = 'bucketplace-v2-development';
var IMAGE_PREFIX = 'https://image.ohou.se';

function getImageServerPath(src) {
  var match;

  if (match = IMAGE_OHOUSE_LEGACY_PATTERN.exec(src), match != null) {
    return "".concat(match[1], "/").concat(match[2].replace(/-/g, '/'));
  } else if (match = IMAGE_OHOUSE_PATTERN.exec(src), match != null) {
    return "".concat(match[1], "/").concat(match[2]);
  } else if (match = S3_LOCAL_PATTERN.exec(src), match != null) {
    return "".concat(match[1], "/").concat(match[2]);
  } else if (match = S3_LOCAL_PATTERN_2.exec(src), match != null) {
    return "".concat(match[1], "/").concat(match[2]);
  } else if (match = S3_GLOBAL_PATTERN.exec(src), match != null) {
    // eslint-disable-next-line prefer-destructuring
    var bucketName = match[1]; // 새 bucket 이름으로 변환

    if (OLD_BUCKET_NAMES.includes(bucketName)) {
      bucketName = NEW_BUCKET_NAME;
    }

    return "".concat(bucketName, "/").concat(match[2]);
  }

  return null;
}

function getOptionQueries(_ref) {
  var width = _ref.width,
      height = _ref.height,
      mode = _ref.mode,
      quality = _ref.quality;
  var query = {};
  if (width != null) query.w = String(width);
  if (height != null) query.h = String(height);
  if (mode != null) query.c = String(mode[0]);
  if (quality != null) query.q = String(quality);
  return querystring.stringify(query);
}

var QUERY_PATTERN = /\?(.+)/;

function getExtraQueries(src) {
  var match = src.match(QUERY_PATTERN);
  return match ? match[1] : '';
}

function getImageUrl(imageOptions) {
  var src = imageOptions.src;
  if (!src) return src;
  var path = getImageServerPath(src);
  if (!path) return src;
  var url = "".concat(IMAGE_PREFIX, "/i/").concat(path);
  var optionQuries = getOptionQueries(imageOptions);
  var extraQueries = getExtraQueries(src);
  return "".concat(url, "?").concat(optionQuries, "&").concat(extraQueries).replace(/&$/, '');
}

var getImageSrcSet = function getImageSrcSet(imageOptions, ratios) {
  return ratios.map(function (ratio) {
    return "".concat(getImageUrl(_objectSpread2(_objectSpread2(_objectSpread2({}, imageOptions), imageOptions.width && {
      width: imageOptions.width * ratio
    }), imageOptions.height && {
      height: imageOptions.height * ratio
    })), " ").concat(ratio, "x");
  }).join(',');
};

var IMAGE_SIZES = [36, 72, 144, 180, 256, 360, 480, 512, 640, 720, 850, 960, 1024, 1280, 1360, 1440, 1536, 1700, 1920, 2048, 2560];
function getNearestSize(originSize) {
  var _IMAGE_SIZES$find;

  return (_IMAGE_SIZES$find = IMAGE_SIZES.find(function (size) {
    return size >= originSize;
  })) !== null && _IMAGE_SIZES$find !== void 0 ? _IMAGE_SIZES$find : IMAGE_SIZES[IMAGE_SIZES.length - 1];
}

function pickIfExists(input, keys) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var output = {};
  keys.forEach(function (key) {
    if (Object.prototype.hasOwnProperty.call(input, key)) {
      output[key] = input[key];
    }
  });
  return output;
}
function omitKeys(obj, keys) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var output = {};
  Object.keys(obj).filter(function (k) {
    return !keys.includes(k);
  }).forEach(function (k) {
    output[k] = obj[k];
  });
  return output;
}

var DEFAULT_WIDTH = 240;
var PIXEL_RATIOS = [1.5, 2, 3];
var ResizeImage = React.memo(function (_ref) {
  var src = _ref.src,
      alt = _ref.alt,
      style = _ref.style,
      className = _ref.className,
      quality = _ref.quality,
      objectFit = _ref.objectFit,
      placeholderColor = _ref.placeholderColor,
      _ref$intrinsicInitial = _ref.intrinsicInitialWidth,
      intrinsicInitialWidth = _ref$intrinsicInitial === void 0 ? DEFAULT_WIDTH : _ref$intrinsicInitial,
      intrinsicInitialHeight = _ref.intrinsicInitialHeight,
      intrinsicAspect = _ref.intrinsicAspect,
      _ref$lazy = _ref.lazy,
      lazy = _ref$lazy === void 0 ? {
    threshold: 0
  } : _ref$lazy,
      onError = _ref.onError;
  var theme = react.useTheme();
  var getImageOptions = React.useCallback(function () {
    if (intrinsicInitialHeight) {
      var nearestHeight = getNearestSize(intrinsicInitialHeight);
      return _objectSpread2({
        src: src,
        quality: quality,
        height: nearestHeight
      }, intrinsicAspect && {
        width: nearestHeight * intrinsicAspect,
        mode: 'cover'
      });
    }

    var nearestWidth = getNearestSize(intrinsicInitialWidth);
    return _objectSpread2({
      src: src,
      quality: quality,
      width: nearestWidth
    }, intrinsicAspect && {
      height: nearestWidth / intrinsicAspect,
      mode: 'cover'
    });
  }, [src, intrinsicAspect, intrinsicInitialWidth, intrinsicInitialHeight, quality]);

  var _useState = React.useState(function () {
    return getImageOptions();
  }),
      _useState2 = _slicedToArray(_useState, 2),
      image = _useState2[0],
      setImage = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoaded = _useState4[0],
      setLoaded = _useState4[1];

  React.useEffect(function () {
    setImage(getImageOptions());
    setLoaded(false);
  }, [src, intrinsicAspect, getImageOptions]);
  var handleChangeImgNodeSize = React.useCallback(function (size) {
    if (size.width === 0 || size.height === 0 || !isLoaded) return;
    setImage(function (image) {
      if (size.width > (image.width || 0) || size.height > (image.height || 0)) {
        var width = getNearestSize(size.width);
        var height = Math.ceil(width * size.height / size.width);
        return _objectSpread2(_objectSpread2(_objectSpread2({}, image), typeof image.width !== 'undefined' && {
          width: width
        }), typeof image.height !== 'undefined' && {
          height: height
        });
      }

      return image;
    });
  }, [isLoaded]);
  var imgNodeRef = useNodeSizeObserver(handleChangeImgNodeSize, [isLoaded]);
  var imgCSS = /*#__PURE__*/react.css(objectFit && /*#__PURE__*/react.css("width:100%;height:100%;object-fit:", objectFit, ";"), " ", !isLoaded && /*#__PURE__*/react.css("background-color:", placeholderColor || theme.content.base4, ";"), ";");

  var _useState5 = React.useState(!lazy),
      _useState6 = _slicedToArray(_useState5, 2),
      isLazyRendered = _useState6[0],
      setLazyRendered = _useState6[1];

  if (!isLazyRendered) {
    return react.jsx(IntersectionObserver, _extends({
      onIntersect: function onIntersect() {
        return setLazyRendered(true);
      }
    }, lazy, {
      style: style,
      className: className
    }), react.jsx("img", {
      // 1x1 transparent image
      src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAQSURBVHgBAQUA+v8AAAAAAAAFAAFkeJU4AAAAAElFTkSuQmCC",
      style: style,
      css: imgCSS,
      className: className,
      alt: ""
    }));
  }

  var imageSrc = getImageUrl(image);
  var imageSrcSet = getImageSrcSet(image, PIXEL_RATIOS);
  return react.jsx("img", {
    src: imageSrc,
    srcSet: imageSrcSet,
    ref: imgNodeRef,
    alt: alt,
    style: style,
    css: imgCSS,
    className: className,
    onError: onError,
    onLoad: function onLoad() {
      return setLoaded(true);
    }
  });
});

var _excluded$C = ["disabled", "variant", "onDimmed"];

var _templateObject$3;
var rotate = react.keyframes(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"])));

function cssVariant$3(theme, variant, onDimmed) {
  switch (variant) {
    case 'default':
      return /*#__PURE__*/react.css("border-color:", theme.dim.onDark.thick, ";border-top-color:", theme.content.white, ";");

    case 'white':
      return /*#__PURE__*/react.css("border-color:", theme.dim.onDark.basic, ";border-top-color:", theme.content.white, ";");

    case 'base1':
      return /*#__PURE__*/react.css("border-color:", onDimmed ? theme.content.base6 : theme.content.base5, ";border-top-color:", theme.content.base1, ";");

    case 'primary1':
    case 'primary2':
    case 'primary3':
    case 'primary4':
      return /*#__PURE__*/react.css("border-color:", onDimmed ? theme.content.base6 : theme.content[variant].thin, ";border-top-color:", theme.content[variant].basic, ";");
  }
}

function Loading(_ref) {
  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant,
      _ref$onDimmed = _ref.onDimmed,
      onDimmed = _ref$onDimmed === void 0 ? false : _ref$onDimmed,
      rest = _objectWithoutProperties(_ref, _excluded$C);

  var theme = react.useTheme();
  return react.jsx("div", _extends({}, rest, {
    css: /*#__PURE__*/react.css("display:inline-block;width:", pxToRem(24), ";height:", pxToRem(24), ";")
  }), react.jsx("div", {
    css: [/*#__PURE__*/react.css("border-radius:50%;width:100%;height:100%;border:", pxToRem(2), " solid;animation:", rotate, " 1.1s infinite linear;box-sizing:border-box;"), disabled ? /*#__PURE__*/react.css("border-color:", theme.content.base3, ";border-top-color:", theme.content.white, ";") : cssVariant$3(theme, variant, onDimmed)]
  }));
}

var _excluded$B = ["className"];
function DimLoading(_ref) {
  var className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded$B);

  var theme = react.useTheme();
  return react.jsx(BodyPortal, null, react.jsx(Dim, null, react.jsx("div", {
    className: className,
    css: /*#__PURE__*/react.css("position:relative;display:inline-block;vertical-align:middle;width:", pxToRem(80), ";height:", pxToRem(80), ";border-radius:", pxToRem(8), ";background-color:", theme.dim.basic, ";")
  }, react.jsx(Loading, _extends({}, rest, {
    css: /*#__PURE__*/react.css("position:absolute;top:", pxToRem(28), ";left:", pxToRem(28), ";")
  })))));
}

var _excluded$A = ["onChange", "onValue", "error", "size", "value", "options", "className", "placeholder", "forwardedRef"];
var ICON_SIZE = 24;
var SELECT_PADDING = {
  32: 13,
  40: 13,
  44: 15,
  50: 15
};
function Select(_ref) {
  var _onChange = _ref.onChange,
      onValue = _ref.onValue,
      error = _ref.error,
      size = _ref.size,
      value = _ref.value,
      options = _ref.options,
      className = _ref.className,
      placeholder = _ref.placeholder,
      forwardedRef = _ref.forwardedRef,
      rest = _objectWithoutProperties(_ref, _excluded$A);

  var theme = react.useTheme();
  return react.jsx("div", {
    className: className,
    css: /*#__PURE__*/react.css("position:relative;display:inline-block;line-height:0;&:hover{background-color:", theme.interactive.transparent, ";}")
  }, react.jsx(Icon, {
    size: ICON_SIZE,
    name: "dropdown",
    css: /*#__PURE__*/react.css("position:absolute;top:", pxToRem(size / 2 - ICON_SIZE / 2), ";right:", pxToRem(SELECT_PADDING[size]), ";color:", theme.content.base2, ";")
  }), react.jsx("select", _extends({}, rest, {
    value: value,
    ref: forwardedRef,
    onChange: function onChange(e) {
      return onValueHandler(e, {
        onChange: _onChange,
        onValue: onValue
      });
    },
    css: [/*#__PURE__*/react.css(RESET_INPUT, ";"), size === 32 ? FONT_STYLE.body2 : FONT_STYLE.subTitle1, /*#__PURE__*/react.css("position:relative;appearance:none;width:100%;height:", pxToRem(size), ";border-radius:", pxToRem(4), ";border:", pxToRem(1), " solid ", theme.border, ";color:", value !== '' ? theme.content.base1 : theme.content.base3, ";padding-left:", pxToRem(SELECT_PADDING[size]), ";padding-right:", pxToRem(ICON_SIZE + SELECT_PADDING[size]), ";"), error ? /*#__PURE__*/react.css("border-color:", theme.content.primary2.basic, ";") : /*#__PURE__*/react.css("&:disabled{background-color:", theme.interactive.transparent, ";}&:focus{border-color:", theme.content.primary1.basic, ";}")]
  }), placeholder && react.jsx("option", {
    value: "",
    hidden: true,
    disabled: true
  }, placeholder), options.map(function (option) {
    return typeof option === 'number' || typeof option === 'string' ? react.jsx("option", {
      key: option,
      value: option
    }, option) : react.jsx("option", {
      key: option.value,
      value: option.value
    }, option.text);
  })));
}

function cssBaseIconButton(size) {
  return /*#__PURE__*/react.css("width:", pxToRem(size), ";padding:0;");
}

var _excluded$z = ["size", "icon"];
function OutlineIconButton(_ref) {
  var size = _ref.size,
      icon = _ref.icon,
      rest = _objectWithoutProperties(_ref, _excluded$z);

  return react.jsx(OutlineButton, _extends({}, rest, {
    size: size,
    css: cssBaseIconButton(size)
  }), react.jsx(Icon, {
    size: 18,
    name: icon
  }));
}

var SIZE = 32;
var GAP = 10;

function PageButton(_ref) {
  var page = _ref.page,
      selected = _ref.selected,
      onClick = _ref.onClick;
  var pageButtonCss = /*#__PURE__*/react.css("width:", pxToRem(SIZE), ";padding:0;vertical-align:middle;margin-right:", pxToRem(GAP), ";");
  return selected ? react.jsx(Button$1, {
    size: SIZE,
    variant: "primary1",
    onClick: onClick,
    css: pageButtonCss
  }, page) : react.jsx(TextButton, {
    size: SIZE,
    variant: "base1",
    onClick: onClick,
    css: pageButtonCss
  }, page);
}

var _excluded$y = ["page", "total", "pageCount", "onPageChange", "row", "rowOptions", "onRowChange"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$p() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

function firstPage(page, lastPage, pageCount) {
  var halfPage = Math.floor(pageCount / 2);

  if (page <= halfPage) {
    return 1;
  }

  if (lastPage < page + halfPage) {
    return lastPage - pageCount + 1;
  }

  return page - halfPage;
}

var _ref$n =  true ? {
  name: "1989ovb",
  styles: "vertical-align:middle"
} : 0;

function Pagination$1(_ref2) {
  var page = _ref2.page,
      total = _ref2.total,
      _ref2$pageCount = _ref2.pageCount,
      pageCount = _ref2$pageCount === void 0 ? 10 : _ref2$pageCount,
      onPageChange = _ref2.onPageChange,
      _ref2$row = _ref2.row,
      row = _ref2$row === void 0 ? 10 : _ref2$row,
      rowOptions = _ref2.rowOptions,
      onRowChange = _ref2.onRowChange,
      rest = _objectWithoutProperties(_ref2, _excluded$y);

  var lastPage = Math.ceil(total / row);
  var actualPageCount = Math.min(lastPage, pageCount);
  React.useEffect(function () {
    if (lastPage < page) {
      onPageChange(Math.max(lastPage, 1));
    }
  }, [page, lastPage, onPageChange]);
  return react.jsx("div", rest, rowOptions && onRowChange && react.jsx(Select, {
    size: SIZE,
    value: row,
    options: rowOptions,
    onValue: function onValue(value) {
      return onRowChange(parseInt(value));
    },
    css: /*#__PURE__*/react.css("vertical-align:middle;margin-right:", pxToRem(16), ";")
  }), react.jsx(OutlineIconButton, {
    disabled: page === 1,
    size: SIZE,
    variant: "base1",
    icon: "chevron_left",
    css: /*#__PURE__*/react.css("vertical-align:middle;margin-right:", pxToRem(GAP), ";"),
    onClick: function onClick() {
      return onPageChange(page - 1);
    }
  }), Array(actualPageCount).fill(firstPage(page, lastPage, actualPageCount)).map(function (v, i) {
    return v + i;
  }).map(function (pageNumber) {
    return react.jsx(PageButton, {
      key: pageNumber,
      page: pageNumber,
      selected: page === pageNumber,
      onClick: function onClick() {
        return onPageChange(pageNumber);
      }
    });
  }), react.jsx(OutlineIconButton, {
    disabled: page === lastPage,
    size: SIZE,
    variant: "base1",
    icon: "chevron_right",
    css: _ref$n,
    onClick: function onClick() {
      return onPageChange(page + 1);
    }
  }));
}

var _excluded$x = ["className", "hint", "error"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$o() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$m =  true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0;

function withHint(Component) {
  return function (_ref2) {
    var className = _ref2.className,
        hint = _ref2.hint,
        error = _ref2.error,
        rest = _objectWithoutProperties(_ref2, _excluded$x);

    return react.jsx("div", {
      className: className
    }, react.jsx(Component, _extends({}, rest, {
      error: error,
      css: _ref$m
    })), hint && react.jsx(Hint, {
      error: error,
      css: /*#__PURE__*/react.css("margin-top:", pxToRem(8), ";")
    }, hint));
  };
}

var SelectWithHint = withHint(Select);

var InputWithHint = withHint(Input$1);

var _excluded$w = ["className", "value", "hint", "error", "maxCount"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$n() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$l =  true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0;

function withCountHint(Component) {
  return function (_ref2) {
    var className = _ref2.className,
        value = _ref2.value,
        hint = _ref2.hint,
        error = _ref2.error,
        maxCount = _ref2.maxCount,
        rest = _objectWithoutProperties(_ref2, _excluded$w);

    var data = typeof value === 'string' ? value.substring(0, maxCount) : value;
    return react.jsx("div", {
      className: className
    }, react.jsx(Component, _extends({}, rest, {
      error: error,
      value: data,
      css: _ref$l
    })), react.jsx(CounterHint, {
      error: error,
      count: data ? "".concat(data).length : 0,
      maxCount: maxCount,
      css: /*#__PURE__*/react.css("margin-top:", pxToRem(8), ";")
    }, hint));
  };
}

var InputWithCountHint = withCountHint(Input$1);

var _excluded$v = ["className", "error", "disabled", "readOnly", "onDimmed", "thumbnail", "onThumbnailDelete"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$m() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$k =  true ? {
  name: "w1atjl",
  styles: "width:100%;height:100%"
} : 0;

var _ref2$9 =  true ? {
  name: "1heawd3",
  styles: "width:100%;padding:0;border:0"
} : 0;

function withThumbnail(Component) {
  return function (_ref3) {
    var className = _ref3.className,
        _ref3$error = _ref3.error,
        error = _ref3$error === void 0 ? false : _ref3$error,
        _ref3$disabled = _ref3.disabled,
        disabled = _ref3$disabled === void 0 ? false : _ref3$disabled,
        _ref3$readOnly = _ref3.readOnly,
        readOnly = _ref3$readOnly === void 0 ? false : _ref3$readOnly,
        _ref3$onDimmed = _ref3.onDimmed,
        onDimmed = _ref3$onDimmed === void 0 ? false : _ref3$onDimmed,
        thumbnail = _ref3.thumbnail,
        onThumbnailDelete = _ref3.onThumbnailDelete,
        props = _objectWithoutProperties(_ref3, _excluded$v);

    var _useState = React.useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        focused = _useState2[0],
        setFocused = _useState2[1];

    var theme = react.useTheme();
    return react.jsx("div", {
      className: className,
      css: [cssBaseTextField(theme, onDimmed, {
        error: error,
        disabled: disabled,
        readOnly: readOnly,
        focused: focused
      }), /*#__PURE__*/react.css("display:block;padding:", pxToRem(0), " ", pxToRem(16), ";cursor:text;")]
    }, react.jsx(Component, _extends({}, props, {
      size: 44,
      error: error,
      disabled: disabled,
      readOnly: readOnly,
      onFocus: function onFocus(e) {
        var _props$onFocus;

        setFocused(true);
        (_props$onFocus = props.onFocus) === null || _props$onFocus === void 0 ? void 0 : _props$onFocus.call(props, e);
      },
      onBlur: function onBlur(e) {
        var _props$onBlur;

        setFocused(false);
        (_props$onBlur = props.onBlur) === null || _props$onBlur === void 0 ? void 0 : _props$onBlur.call(props, e);
      },
      css: _ref2$9
    })), thumbnail && react.jsx("div", {
      css: /*#__PURE__*/react.css("margin-bottom:", pxToRem(12), ";")
    }, react.jsx("span", {
      css: /*#__PURE__*/react.css("overflow:hidden;position:relative;display:inline-block;width:", pxToRem(100), ";height:", pxToRem(100), ";")
    }, react.jsx(Image, {
      aspectRatio: "1:1",
      src: thumbnail,
      radius: 4,
      css: _ref$k
    }), react.jsx("button", {
      type: "button",
      title: "\uC0AD\uC81C",
      css: /*#__PURE__*/react.css("position:absolute;top:0;right:0;width:", pxToRem(32), ";height:", pxToRem(32), ";margin:0;padding:0;border:0;background:none;"),
      onClick: function onClick(e) {
        e.stopPropagation();
        onThumbnailDelete === null || onThumbnailDelete === void 0 ? void 0 : onThumbnailDelete();
      }
    }, react.jsx(Icon, {
      name: "dismiss_circle",
      size: 18,
      fill: function fill(theme) {
        return theme.content.base1;
      }
    })))));
  };
}

var InputWithThumbnail = withThumbnail(Input$1);

var _excluded$u = ["className", "value", "disabled", "readOnly", "placeholder", "onCut", "onPaste", "onInput", "onValue", "onFocus", "onBlur"];
var ContentEditable = React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      disabled = _ref.disabled,
      readOnly = _ref.readOnly,
      placeholder = _ref.placeholder,
      _onCut = _ref.onCut,
      _onPaste = _ref.onPaste,
      _onInput = _ref.onInput,
      onValue = _ref.onValue,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      props = _objectWithoutProperties(_ref, _excluded$u);

  var theme = react.useTheme();
  var node = React.useRef(null);
  React.useImperativeHandle(ref, function () {
    return node.current;
  });
  var innerValue = React.useRef('');
  var handleUpdate = React.useCallback(function () {
    var _node$current;

    var newValue = ((_node$current = node.current) === null || _node$current === void 0 ? void 0 : _node$current.innerHTML) || '';
    innerValue.current = newValue;
    onValue === null || onValue === void 0 ? void 0 : onValue(newValue);
  }, [onValue]);
  React.useEffect(function () {
    if (!node.current) return;

    if (innerValue.current !== value) {
      node.current.innerHTML = value;
      handleUpdate();
    }
  }, [value, handleUpdate]);
  React.useEffect(function () {
    if (!node.current) return;
    var observer = new MutationObserver(function (mutations) {
      var _iterator = _createForOfIteratorHelper(mutations),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var mutation = _step.value;

          if (mutation.type === 'childList') {
            handleUpdate();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
    observer.observe(node.current, {
      childList: true,
      subtree: true
    });
    return function () {
      observer.disconnect();
    };
  }, [handleUpdate]);
  return react.jsx("div", _extends({
    ref: node,
    contentEditable: !readOnly && !disabled,
    onCut: function onCut(e) {
      handleUpdate();
      _onCut === null || _onCut === void 0 ? void 0 : _onCut(e);
    },
    onPaste: function onPaste(e) {
      handleUpdate();
      _onPaste === null || _onPaste === void 0 ? void 0 : _onPaste(e);
    },
    onInput: function onInput(e) {
      handleUpdate();
      _onInput === null || _onInput === void 0 ? void 0 : _onInput(e);
    },
    onFocus: onFocus,
    onBlur: onBlur,
    "data-placeholder": placeholder,
    className: className,
    css: /*#__PURE__*/react.css("word-break:break-word;cursor:", disabled ? 'default' : 'text', ";&&:empty:before{content:attr(data-placeholder);color:", theme.content.base3, ";pointer-events:none;}")
  }, props));
});

var _excluded$t = ["className", "autoHeight", "maxRows", "disabled", "readOnly", "error", "value", "action", "onValue", "useContentEditable", "onDimmed"],
    _excluded2$1 = ["forwardedRef", "onFocus", "onBlur", "onChange"],
    _excluded3$1 = ["forwardedRef", "onFocus", "onBlur"];

function cssTextareaField(theme, _ref) {
  var autoHeight = _ref.autoHeight,
      height = _ref.height;
  return /*#__PURE__*/react.css(cssTextField(theme), " ", FONT_STYLE.body1_1, " overflow-y:auto;flex:1 0 0%;height:", pxToRem(78), ";min-height:", pxToRem(24), ";margin:", pxToRem(9), " 0;box-sizing:border-box;resize:none;vertical-align:top;", autoHeight && /*#__PURE__*/react.css("height:", pxToRem(height), ";"), ";");
}

function Textarea(_ref2) {
  var _rest$style2;

  var className = _ref2.className,
      _ref2$autoHeight = _ref2.autoHeight,
      autoHeight = _ref2$autoHeight === void 0 ? false : _ref2$autoHeight,
      maxRows = _ref2.maxRows,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      _ref2$readOnly = _ref2.readOnly,
      readOnly = _ref2$readOnly === void 0 ? false : _ref2$readOnly,
      _ref2$error = _ref2.error,
      error = _ref2$error === void 0 ? false : _ref2$error,
      value = _ref2.value,
      action = _ref2.action,
      onValue = _ref2.onValue,
      useContentEditable = _ref2.useContentEditable,
      _ref2$onDimmed = _ref2.onDimmed,
      onDimmed = _ref2$onDimmed === void 0 ? false : _ref2$onDimmed,
      rest = _objectWithoutProperties(_ref2, _excluded$t);

  var theme = react.useTheme();

  var _useState = React.useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      element = _useState2[0],
      setElement = _useState2[1];

  var _useState3 = React.useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      height = _useState4[0],
      setHeight = _useState4[1];

  var _useState5 = React.useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      focused = _useState6[0],
      setFocused = _useState6[1];

  var actions = Array.isArray(action) ? action : [action];
  var updateHeight = React.useCallback(function (element) {
    var _rest$style$height, _rest$style;

    element.style.height = '0';

    if (maxRows) {
      var _window$getComputedSt = window.getComputedStyle(element),
          lineHeight = _window$getComputedSt.lineHeight;

      var maxHeight = maxRows * parseInt(lineHeight, 10);
      setHeight(Math.min(element.scrollHeight, maxHeight));
    } else {
      setHeight(element.scrollHeight);
    }

    element.style.height = (_rest$style$height = (_rest$style = rest.style) === null || _rest$style === void 0 ? void 0 : _rest$style.height) !== null && _rest$style$height !== void 0 ? _rest$style$height : null;
  }, [maxRows, (_rest$style2 = rest.style) === null || _rest$style2 === void 0 ? void 0 : _rest$style2.height]);
  var handleValue = React.useCallback(function (value) {
    if (autoHeight && element) {
      updateHeight(element);
    }

    onValue === null || onValue === void 0 ? void 0 : onValue(value);
  }, [autoHeight, element, updateHeight, onValue]);
  React.useEffect(function () {
    if (!value) return;
    handleValue(value);
  }, [value, handleValue]);
  return react.jsx("div", {
    className: className,
    css: [cssBaseTextField(theme, onDimmed, {
      error: error,
      focused: focused,
      disabled: disabled,
      readOnly: readOnly
    }), /*#__PURE__*/react.css("align-items:flex-start;padding:", pxToRem(6), " ", pxToRem(15), ";")]
  }, !useContentEditable ? function () {
    var _ref3 = rest,
        forwardedRef = _ref3.forwardedRef,
        _onFocus = _ref3.onFocus,
        _onBlur = _ref3.onBlur,
        _onChange = _ref3.onChange,
        assertedRest = _objectWithoutProperties(_ref3, _excluded2$1);

    return react.jsx("textarea", _extends({}, assertedRest, {
      ref: function ref(el) {
        setElement(el);

        if (forwardedRef) {
          if (typeof forwardedRef === 'function') {
            forwardedRef(el);
          } else {
            forwardedRef.current = el;
          }
        }
      },
      value: value,
      disabled: disabled,
      readOnly: readOnly,
      onFocus: function onFocus(e) {
        if (_onFocus) {
          _onFocus(e);
        }

        setFocused(true);
      },
      onBlur: function onBlur(e) {
        if (_onBlur) {
          _onBlur(e);
        }

        setFocused(false);
      },
      onChange: function onChange(e) {
        return onValueHandler(e, {
          onChange: _onChange,
          onValue: handleValue
        });
      },
      css: cssTextareaField(theme, {
        autoHeight: autoHeight,
        height: height
      })
    }));
  }() : function () {
    var _ref4 = rest,
        forwardedRef = _ref4.forwardedRef,
        _onFocus2 = _ref4.onFocus,
        _onBlur2 = _ref4.onBlur,
        assertedRest = _objectWithoutProperties(_ref4, _excluded3$1);

    return react.jsx(ContentEditable, _extends({}, assertedRest, {
      ref: function ref(el) {
        setElement(el);

        if (forwardedRef) {
          if (typeof forwardedRef === 'function') {
            forwardedRef(el);
          } else {
            forwardedRef.current = el;
          }
        }
      },
      value: value,
      disabled: disabled,
      readOnly: readOnly,
      onFocus: function onFocus(e) {
        if (_onFocus2) {
          _onFocus2(e);
        }

        setFocused(true);
      },
      onBlur: function onBlur(e) {
        if (_onBlur2) {
          _onBlur2(e);
        }

        setFocused(false);
      },
      onValue: handleValue,
      css: [cssTextareaField(theme, {
        autoHeight: autoHeight,
        height: height
      }), /*#__PURE__*/react.css("min-width:", pxToRem(100), ";")]
    }));
  }(), react.jsx("div", {
    css: /*#__PURE__*/react.css("box-sizing:border-box;display:flex;align-items:center;height:", pxToRem(42), ";padding:", pxToRem(9), " 0;&:not(:empty){margin-left:", pxToRem(8), ";}")
  }, actions.map(function (action, i) {
    return !!action && (isIconAction(action) ? react.jsx("button", {
      key: i,
      type: action.type || 'button',
      disabled: disabled || action.disabled,
      css: /*#__PURE__*/react.css(RESET_BUTTON, " vertical-align:top;width:", pxToRem(24), ";height:", pxToRem(24), ";margin-left:", pxToRem(12), ";&:first-of-type{margin-left:0;}"),
      onClick: function onClick(e) {
        var _action$onClick;

        e.stopPropagation();
        (_action$onClick = action.onClick) === null || _action$onClick === void 0 ? void 0 : _action$onClick.call(action, e);
      }
    }, react.jsx(Icon, {
      size: 24,
      name: action.icon,
      css: /*#__PURE__*/react.css("color:", action.color || theme.content.base2, ";")
    })) : react.jsx(TextButton, {
      key: i,
      size: 30,
      variant: "primary1",
      type: action.type || 'button',
      disabled: disabled || action.disabled,
      css: /*#__PURE__*/react.css("flex-shrink:0;margin-left:", pxToRem(12), ";padding:0;&:first-of-type{margin-left:0;}"),
      onClick: function onClick(e) {
        var _action$onClick2;

        e.stopPropagation();
        (_action$onClick2 = action.onClick) === null || _action$onClick2 === void 0 ? void 0 : _action$onClick2.call(action, e);
      }
    }, action.text));
  })));
}

var TextareaWithHint = withHint(Textarea);

var TextareaWithCountHint = withCountHint(Textarea);

var TextareaWithThumbnail = withThumbnail(Textarea);

var _excluded$s = ["header", "body", "footer"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$l() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$j =  true ? {
  name: "1uixtsi",
  styles: "width:100%;border-collapse:collapse"
} : 0;

function Table(_ref2) {
  var header = _ref2.header,
      body = _ref2.body,
      footer = _ref2.footer,
      rest = _objectWithoutProperties(_ref2, _excluded$s);

  return react.jsx("table", _extends({}, rest, {
    css: [FONT_STYLE.subTitle1, _ref$j]
  }), header && react.jsx("thead", null, header), body && react.jsx("tbody", null, body), footer && react.jsx("tfoot", null, footer));
}

var TABLE_HEADER_CLASS_NAME = 'bucketplace-table-header';
var TABLE_DATA_CLASS_NAME = 'bucketplace-table-data';

var _excluded$r = ["emphasized", "children"];
function TableRow(_ref) {
  var emphasized = _ref.emphasized,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded$r);

  var theme = react.useTheme();
  return react.jsx("tr", _extends({}, rest, {
    css: [/*#__PURE__*/react.css(">.", TABLE_HEADER_CLASS_NAME, ",>.", TABLE_DATA_CLASS_NAME, "{color:", theme.content.base1, ";border:", pxToRem(1), " solid ", theme.content.base4, ";}"), emphasized && /*#__PURE__*/react.css("background-color:", theme.content.base5, ";")]
  }), children);
}

var _excluded$q = ["className", "children"];
function TableHeader(_ref) {
  var className = _ref.className,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded$q);

  var theme = react.useTheme();
  return react.jsx("th", _extends({}, rest, {
    className: spaces(className, TABLE_HEADER_CLASS_NAME),
    css: /*#__PURE__*/react.css("text-align:left;font-weight:700;height:", pxToRem(56), ";padding:0 ", pxToRem(16), ";background-color:", theme.content.base5, ";&:hover{background-color:", theme.interactive.base5, ";}")
  }), children);
}

var _excluded$p = ["text", "action"];
var ACTION_BUTTON_SIZE = 18;
function TableHeaderWithAction(_ref) {
  var text = _ref.text,
      action = _ref.action,
      rest = _objectWithoutProperties(_ref, _excluded$p);

  var theme = react.useTheme();
  return react.jsx(TableHeader, rest, react.jsx("span", {
    css: /*#__PURE__*/react.css("margin-right:", pxToRem(6), ";")
  }, text), react.jsx("button", {
    type: "button",
    css: /*#__PURE__*/react.css(RESET_BUTTON, ";width:", pxToRem(ACTION_BUTTON_SIZE), ";height:", pxToRem(ACTION_BUTTON_SIZE), ";"),
    onClick: action.onClick
  }, react.jsx(Icon, {
    size: ACTION_BUTTON_SIZE,
    name: action.icon,
    css: /*#__PURE__*/react.css("color:", theme.content.base1, ";")
  })));
}

var _excluded$o = ["className", "children"];
function TableData(_ref) {
  var className = _ref.className,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded$o);

  var theme = react.useTheme();
  return react.jsx("td", _extends({}, rest, {
    className: spaces(className, TABLE_DATA_CLASS_NAME),
    css: /*#__PURE__*/react.css("height:", pxToRem(52), ";padding:0 ", pxToRem(16), ";&:hover{background-color:", theme.interactive.transparent, ";}")
  }), children);
}

var _excluded$n = ["size", "children"],
    _excluded2 = ["checked", "onChange", "onCheck"],
    _excluded3 = ["size"],
    _excluded4 = ["fill", "size"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$k() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var THUMBNAIL_LEFT_MARGIN = 4;

var calcSidePadding = function calcSidePadding(size) {
  switch (size) {
    case 32:
      return 12;

    case 38:
      return 14;

    case 48:
      return 16;

    default:
      return 0;
  }
};

var calcThumbnailRightMargin = function calcThumbnailRightMargin(size) {
  switch (size) {
    case 32:
      return 4;

    case 38:
      return 6;

    case 48:
      return 8;

    default:
      return 0;
  }
};

var getFontStyle = function getFontStyle(size) {
  if (size === 48) {
    return FONT_STYLE.subTitle1;
  }

  return FONT_STYLE.subTitle2;
};

var getChipSpacing = function getChipSpacing(size) {
  return /*#__PURE__*/react.css("margin-left:-", pxToRem(calcSidePadding(size) - THUMBNAIL_LEFT_MARGIN), ";margin-right:", pxToRem(calcThumbnailRightMargin(size)), ";");
};

function cssBaseChip(size) {
  return /*#__PURE__*/react.css("display:inline-block;position:relative;height:", pxToRem(size), ";border-radius:", pxToRem(size / 2), ";padding-left:", pxToRem(calcSidePadding(size)), ";padding-right:", pxToRem(calcSidePadding(size)), ";line-height:0;&::before{content:\"\";height:100%;display:inline-block;vertical-align:middle;}");
}

var _ref2$8 =  true ? {
  name: "1aeh6hi",
  styles: "vertical-align:middle;white-space:nowrap;cursor:inherit"
} : 0;

function Text(_ref3) {
  var size = _ref3.size,
      children = _ref3.children,
      rest = _objectWithoutProperties(_ref3, _excluded$n);

  return react.jsx("span", _extends({}, rest, {
    css: [getFontStyle(size), _ref2$8]
  }), children);
}

var _ref$i =  true ? {
  name: "ebd3ti",
  styles: "position:absolute;top:0;left:0;width:0;height:0;opacity:0"
} : 0;

function Checkbox(_ref4) {
  var checked = _ref4.checked,
      _onChange = _ref4.onChange,
      onCheck = _ref4.onCheck,
      rest = _objectWithoutProperties(_ref4, _excluded2);

  return react.jsx("input", _extends({}, rest, {
    type: "checkbox",
    css: _ref$i,
    checked: checked,
    onChange: function onChange(e) {
      return onCheckHandler(e, {
        onChange: _onChange,
        onCheck: onCheck
      });
    }
  }));
}
function Thumbnail(_ref5) {
  var size = _ref5.size,
      rest = _objectWithoutProperties(_ref5, _excluded3);

  return react.jsx(CircleImage, _extends({}, rest, {
    css: [getChipSpacing(size), /*#__PURE__*/react.css("width:", pxToRem(size - 8), ";vertical-align:middle;")]
  }));
}
function RemoveButton(_ref6) {
  var fill = _ref6.fill;
      _ref6.size;
      var rest = _objectWithoutProperties(_ref6, _excluded4);

  var theme = react.useTheme();
  return react.jsx("button", _extends({}, rest, {
    type: "button",
    css: /*#__PURE__*/react.css(RESET_BUTTON, " width:", pxToRem(12), ";height:", pxToRem(12), ";margin-left:", pxToRem(4), ";margin-right:", pxToRem(-4), ";vertical-align:middle;")
  }), react.jsx(Icon, {
    size: 12,
    name: "dismiss",
    css: /*#__PURE__*/react.css("vertical-align:top;color:", theme.content[fill], ";")
  }));
}

var _excluded$m = ["children", "size", "variant", "thumbnail", "onRemove", "onClick"];

function cssVariant$2(_ref) {
  var theme = _ref.theme,
      variant = _ref.variant,
      hasInteraction = _ref.hasInteraction;

  switch (variant) {
    case 'default':
      return /*#__PURE__*/react.css("color:", theme.content.base1, ";background-color:", theme.content.base5, ";", hasInteraction && /*#__PURE__*/react.css("&:hover{background-color:", theme.interactive.base5, ";}"), ";");

    case 'outline':
      return /*#__PURE__*/react.css("color:", theme.content.base1, ";border:", pxToRem(1), " solid ", theme.border, ";", hasInteraction && /*#__PURE__*/react.css("&:hover{background-color:", theme.interactive.transparent, ";}"), ";");

    case 'primary1':
    case 'primary3':
    case 'primary4':
      return /*#__PURE__*/react.css("color:", theme.content.white, ";background-color:", theme.content[variant].basic, ";", hasInteraction && /*#__PURE__*/react.css("&:hover{background-color:", theme.interactive[variant].basic, ";}"), ";");
  }
}

function Chip(_ref2) {
  var children = _ref2.children,
      size = _ref2.size,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? 'default' : _ref2$variant,
      thumbnail = _ref2.thumbnail,
      onRemove = _ref2.onRemove,
      onClick = _ref2.onClick,
      rest = _objectWithoutProperties(_ref2, _excluded$m);

  var theme = react.useTheme();
  return react.jsx("div", _extends({
    css: [cssBaseChip(size), cssVariant$2({
      theme: theme,
      variant: variant,
      hasInteraction: !!onClick
    }), /*#__PURE__*/react.css("cursor:", onClick ? 'pointer' : 'default', ";")],
    onClick: onClick
  }, rest), thumbnail && react.jsx(Thumbnail, {
    src: thumbnail,
    size: size
  }), react.jsx(Text, {
    size: size
  }, children), onRemove && react.jsx(RemoveButton, {
    size: size,
    fill: {
      "default": 'base2',
      outline: 'base2',
      primary1: 'white',
      primary3: 'white',
      primary4: 'white'
    }[variant],
    onClick: onRemove
  }));
}

var _excluded$l = ["className", "prefix", "value", "placeholder", "onChange", "onValue", "onFocus", "onBlur", "onRemove"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$j() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$h =  true ? {
  name: "1ro929w",
  styles: "position:absolute;display:inline-block;white-space:pre;visibility:hidden;top:0;left:0"
} : 0;

function InputChip(_ref2) {
  var className = _ref2.className,
      prefix = _ref2.prefix,
      value = _ref2.value,
      placeholder = _ref2.placeholder,
      _onChange = _ref2.onChange,
      onValue = _ref2.onValue,
      _onFocus = _ref2.onFocus,
      _onBlur = _ref2.onBlur,
      onRemove = _ref2.onRemove,
      rest = _objectWithoutProperties(_ref2, _excluded$l);

  var theme = react.useTheme();
  var ref = React.useRef(null);

  var _useState = React.useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      width = _useState2[0],
      setWidth = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      focused = _useState4[0],
      setFocused = _useState4[1];

  React.useEffect(function () {
    if (ref.current) {
      ref.current.style.width = '0';
      setWidth(ref.current.scrollWidth);
      ref.current.removeAttribute('style');
    }
  }, [value, placeholder]);
  return react.jsx("div", {
    className: className,
    css: [FONT_STYLE.subTitle2, cssBaseChip(32), /*#__PURE__*/react.css("position:relative;white-space:nowrap;color:", theme.content.base1, ";border:", pxToRem(1), " solid ", focused ? theme.content.primary1.basic : theme.content.base5, ";background-color:", theme.content.base5, ";&:hover{border-color:", focused ? theme.content.primary1.basic : theme.interactive.base5, ";background-color:", theme.interactive.base5, ";}")]
  }, react.jsx("span", {
    ref: ref,
    css: _ref$h
  }, value || placeholder), prefix && react.jsx(Text, {
    size: 32,
    css: /*#__PURE__*/react.css("margin-right:", pxToRem(1), ";")
  }, prefix), react.jsx("input", _extends({}, rest, {
    value: value,
    placeholder: placeholder,
    onFocus: function onFocus(e) {
      if (_onFocus) {
        _onFocus(e);
      }

      setFocused(true);
    },
    onBlur: function onBlur(e) {
      if (_onBlur) {
        _onBlur(e);
      }

      setFocused(false);
    },
    onChange: function onChange(e) {
      return onValueHandler(e, {
        onChange: _onChange,
        onValue: onValue
      });
    },
    css: /*#__PURE__*/react.css(RESET_INPUT, " width:", pxToRem(width), ";font:inherit;color:inherit;vertical-align:middle;&::placeholder{color:", theme.content.base3, ";}")
  })), onRemove && react.jsx(RemoveButton, {
    fill: "base2",
    onClick: onRemove
  }));
}

var _excluded$k = ["id", "children", "className", "size", "variant", "thumbnail", "extraText", "checked", "onChange", "onCheck"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$i() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

function cssVariant$1(theme, variant) {
  switch (variant) {
    case 'primary1':
    case 'primary3':
      return /*#__PURE__*/react.css("color:", theme.content.white, ";background-color:", theme.content[variant].basic, ";@media (hover: hover) and (pointer: fine){&:hover{background-color:", theme.interactive[variant].basic, ";}}");

    case 'primary4':
      return /*#__PURE__*/react.css("color:", theme.content.white, ";background-color:", theme.content.primary4.thick, ";@media (hover: hover) and (pointer: fine){&:hover{background-color:", theme.interactive.primary4.thick, ";}}");
  }
}

var _ref$g =  true ? {
  name: "e0dnmk",
  styles: "cursor:pointer"
} : 0;

function SelectChip(_ref2) {
  var id = _ref2.id,
      children = _ref2.children,
      className = _ref2.className,
      size = _ref2.size,
      variant = _ref2.variant,
      thumbnail = _ref2.thumbnail,
      extraText = _ref2.extraText,
      checked = _ref2.checked,
      onChange = _ref2.onChange,
      onCheck = _ref2.onCheck,
      rest = _objectWithoutProperties(_ref2, _excluded$k);

  var theme = react.useTheme();
  return react.jsx("label", {
    className: className,
    htmlFor: id,
    css: [cssBaseChip(size), checked ? cssVariant$1(theme, variant) : /*#__PURE__*/react.css("color:", theme.content.base1, ";background-color:", theme.content.base5, ";&:hover{background-color:", theme.interactive.base5, ";}"), _ref$g]
  }, react.jsx(Checkbox, _extends({}, rest, {
    id: id,
    checked: checked,
    onCheck: onCheck,
    onChange: onChange
  })), thumbnail && react.jsx(Thumbnail, {
    src: thumbnail,
    size: size
  }), react.jsx(Text, {
    size: size
  }, children), extraText && react.jsx(Text, {
    size: size,
    css: [checked ? /*#__PURE__*/react.css("color:", theme.content.white, ";") : /*#__PURE__*/react.css("color:", theme.content[variant].thick, ";"), /*#__PURE__*/react.css("margin-left:", pxToRem(2), ";")]
  }, extraText));
}

var _excluded$j = ["id", "children", "size", "variant", "thumbnail", "extraText", "checked", "onChange", "onCheck"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$h() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

function cssVariant(theme, variant) {
  switch (variant) {
    case 'primary1':
    case 'primary4':
      return /*#__PURE__*/react.css("color:", theme.content[variant].thick, ";background-color:", theme.content[variant].thin, ";border:", pxToRem(1), " solid ", theme.content[variant].thick, ";@media(hover: hover) and (pointer: fine){&:hover{background-color:", theme.interactive[variant].thin, ";}}");

    case 'primary3':
      return /*#__PURE__*/react.css("color:", theme.content[variant].basic, ";background-color:", theme.content[variant].thin, ";border:", pxToRem(1), " solid ", theme.content[variant].basic, ";@media(hover: hover) and (pointer: fine){&:hover{background-color:", theme.interactive[variant].thin, ";}}");
  }
}

var _ref$f =  true ? {
  name: "e0dnmk",
  styles: "cursor:pointer"
} : 0;

function OutlineSelectChip(_ref2) {
  var id = _ref2.id,
      children = _ref2.children,
      size = _ref2.size,
      variant = _ref2.variant,
      thumbnail = _ref2.thumbnail,
      extraText = _ref2.extraText,
      _ref2$checked = _ref2.checked,
      checked = _ref2$checked === void 0 ? false : _ref2$checked,
      onChange = _ref2.onChange,
      onCheck = _ref2.onCheck,
      rest = _objectWithoutProperties(_ref2, _excluded$j);

  var theme = react.useTheme();
  return react.jsx("label", {
    htmlFor: id,
    css: [cssBaseChip(size), checked ? cssVariant(theme, variant) : /*#__PURE__*/react.css("color:", theme.content.base1, ";border:", pxToRem(1), " solid ", theme.border, ";@media(hover: hover) and (pointer: fine){&:hover{background-color:", theme.interactive.base5, ";}}"), _ref$f]
  }, react.jsx(Checkbox, _extends({}, rest, {
    id: id,
    checked: checked,
    onCheck: onCheck,
    onChange: onChange
  })), thumbnail && react.jsx(Thumbnail, {
    src: thumbnail,
    size: size
  }), react.jsx(Text, {
    size: size
  }, children), extraText && react.jsx(Text, {
    size: size,
    css: [/*#__PURE__*/react.css("color:", variant === 'primary3' ? theme.content[variant].basic : theme.content[variant].thick, ";"), /*#__PURE__*/react.css("margin-left:", pxToRem(2), ";")]
  }, extraText));
}

function FillOutlineSelectChip(props) {
  var checked = props.checked;
  return checked ? react.jsx(SelectChip, props) : react.jsx(OutlineSelectChip, props);
}

var cat1x1 = "https://assets.ohou.se/design-system/4115b98dcf15cece.png";

var cat1x2 = "https://assets.ohou.se/design-system/0d544e95b1db25b2.png";

var cat1x3 = "https://assets.ohou.se/design-system/266288958944af51.png";

var man1x1 = "https://assets.ohou.se/design-system/23babe1bcb31c86f.png";

var man1x2 = "https://assets.ohou.se/design-system/b3ed77dde9be5229.png";

var man1x3 = "https://assets.ohou.se/design-system/5a7ef2ef9bba815e.png";

function EmptyImage(_ref) {
  var image = _ref.image;
  return react.jsx(Image, {
    aspectRatio: "1:1",
    css: /*#__PURE__*/react.css("width:", pxToRem(100), ";vertical-align:top;"),
    src: {
      cat1: cat1x1,
      man1: man1x1
    }[image],
    src2x: {
      cat1: cat1x2,
      man1: man1x2
    }[image],
    src3x: {
      cat1: cat1x3,
      man1: man1x3
    }[image]
  });
}

var _excluded$i = ["image", "title", "description", "action", "subAction"];
function EmptyPage(_ref) {
  var image = _ref.image,
      title = _ref.title,
      description = _ref.description,
      action = _ref.action,
      subAction = _ref.subAction,
      rest = _objectWithoutProperties(_ref, _excluded$i);

  var theme = react.useTheme();
  return react.jsx("div", _extends({}, rest, {
    css: /*#__PURE__*/react.css("width:", pxToRem(343), ";margin:0 auto;text-align:center;")
  }), image && react.jsx("div", {
    css: /*#__PURE__*/react.css("margin-bottom:", pxToRem(10), ";")
  }, react.jsx(EmptyImage, {
    image: image
  })), title && react.jsx("p", {
    css: [FONT_STYLE.title1, /*#__PURE__*/react.css("color:", theme.content.base1, ";white-space:pre-wrap;")]
  }, title), description && react.jsx("p", {
    css: [FONT_STYLE.body1_1, /*#__PURE__*/react.css("margin-top:", pxToRem(10), ";color:", theme.content.base2, ";white-space:pre-wrap;")]
  }, description), action && react.jsx("div", {
    css: /*#__PURE__*/react.css("margin-top:", pxToRem(10), ";")
  }, react.jsx(Button$1, {
    size: 44,
    variant: "primary1",
    onClick: action.onClick
  }, action.text)), subAction && react.jsx("div", {
    css: /*#__PURE__*/react.css("margin-top:", pxToRem(3), ";")
  }, react.jsx(TextButton, {
    size: 32,
    variant: "primary1",
    onClick: subAction.onClick
  }, subAction.text)));
}

/* eslint-disable max-len */
function SocialLink(_ref) {
  var type = _ref.type,
      href = _ref.href;
  var theme = react.useTheme();
  return react.jsx("a", {
    href: href,
    target: "_blank",
    css: /*#__PURE__*/react.css("display:inline-block;margin-right:", pxToRem(14), ";"),
    rel: "noreferrer",
    "aria-label": "\uC624\uB298\uC758\uC9D1 ".concat(type, " \uB9C1\uD06C \uBC84\uD2BC")
  }, react.jsx("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    css: /*#__PURE__*/react.css("vertical-align:top;color:", theme.content.base2, ";&:hover{color:", theme.interactive.base2, ";}")
  }, type === 'KakaoStory' && react.jsx(KakaoStorySvg, null), type === 'Facebook' && react.jsx(FacebookSvg, null), type === 'Instagram' && react.jsx(InstagramSvg, null), type === 'NaverPost' && react.jsx(NaverPostSvg, null), type === 'Youtube' && react.jsx(YoutubeSvg, null)));
}

function KakaoStorySvg() {
  return react.jsx(React__default['default'].Fragment, null, react.jsx("circle", {
    cx: "12",
    cy: "12",
    r: "11",
    fill: "currentColor"
  }), react.jsx("path", {
    d: "M14.6548 6.5H9.34617C8.98953 6.5 8.70036 6.77492 8.70036 7.11427V12.4991C8.70036 12.8382 8.98953 13.1132 9.34617 13.1132H11.7936C11.7768 13.7122 11.5225 14.3691 11.1359 14.9432C10.7632 15.4965 10.1507 16.0415 9.81838 16.3021C9.80983 16.3089 9.80136 16.3154 9.79337 16.3217C9.72167 16.3871 9.66939 16.4632 9.66826 16.5686C9.66714 16.6486 9.71075 16.7105 9.75928 16.7761L9.77173 16.7896L11.4662 18.6074C11.4662 18.6074 11.549 18.6908 11.6175 18.7066C11.6948 18.7243 11.7823 18.7265 11.8429 18.6818C14.7987 16.5067 15.2256 13.7794 15.2999 12.3034C15.3001 12.295 15.3004 7.11427 15.3004 7.11427C15.3004 6.77492 15.0114 6.5 14.6548 6.5Z",
    fill: "white"
  }));
}

function FacebookSvg() {
  return react.jsx(React__default['default'].Fragment, null, react.jsx("g", {
    clipPath: "url(#clip0_21132_87052)"
  }, react.jsx("path", {
    d: "M23 12C23 5.92486 18.0751 1 12 1C5.92486 1 1 5.92486 1 12C1 17.4903 5.02252 22.0412 10.2812 22.8664V15.1797H7.48828V12H10.2812V9.57656C10.2812 6.81969 11.9235 5.29688 14.4361 5.29688C15.6397 5.29688 16.8984 5.51172 16.8984 5.51172V8.21875H15.5114C14.145 8.21875 13.7188 9.06674 13.7188 9.93664V12H16.7695L16.2818 15.1797H13.7188V22.8664C18.9775 22.0412 23 17.4905 23 12Z",
    fill: "currentColor"
  }), react.jsx("path", {
    d: "M16.2818 15.1797L16.7695 12H13.7188V9.93664C13.7188 9.06674 14.145 8.21875 15.5114 8.21875H16.8984V5.51172C16.8984 5.51172 15.6397 5.29688 14.4361 5.29688C11.9235 5.29688 10.2812 6.81969 10.2812 9.57656V12H7.48828V15.1797H10.2812V22.8664C10.8413 22.9542 11.4152 23 12 23C12.5848 23 13.1587 22.9542 13.7188 22.8664V15.1797H16.2818Z",
    fill: "white"
  })), react.jsx("defs", null, react.jsx("clipPath", {
    id: "clip0_21132_87052"
  }, react.jsx("rect", {
    width: "22",
    height: "22",
    fill: "white",
    transform: "translate(1 1)"
  }))));
}

function InstagramSvg() {
  return react.jsx(React__default['default'].Fragment, null, react.jsx("circle", {
    cx: "12",
    cy: "12",
    r: "11",
    fill: "currentColor"
  }), react.jsx("path", {
    d: "M9.10061 5.04896C8.3558 5.0841 7.84718 5.20296 7.40253 5.37768C6.94235 5.55702 6.5523 5.79768 6.16422 6.18717C5.77614 6.57665 5.53715 6.96698 5.35907 7.42786C5.18673 7.87349 5.06997 8.38253 5.03707 9.12776C5.00417 9.87299 4.99689 10.1125 5.00053 12.0135C5.00417 13.9144 5.01257 14.1527 5.04869 14.8995C5.08425 15.6441 5.20269 16.1526 5.37741 16.5974C5.55703 17.0576 5.79742 17.4475 6.18704 17.8357C6.57666 18.2239 6.96671 18.4624 7.42871 18.6407C7.87392 18.8128 8.3831 18.9301 9.12819 18.9627C9.87328 18.9953 10.1131 19.0029 12.0135 18.9993C13.9139 18.9956 14.1531 18.9872 14.8997 18.9518C15.6464 18.9164 16.1522 18.7971 16.5971 18.6232C17.0573 18.4432 17.4475 18.2032 17.8354 17.8134C18.2234 17.4237 18.4622 17.0331 18.6402 16.5719C18.8126 16.1267 18.9298 15.6175 18.9622 14.873C18.9948 14.1258 19.0025 13.8872 18.9988 11.9866C18.9952 10.0859 18.9867 9.84765 18.9513 9.10116C18.9158 8.35467 18.7972 7.84773 18.6227 7.40266C18.4428 6.94248 18.2027 6.55285 17.8132 6.16435C17.4237 5.77584 17.0328 5.53714 16.5718 5.35962C16.1263 5.18728 15.6174 5.06982 14.8723 5.03762C14.1272 5.00542 13.8874 4.99716 11.9863 5.0008C10.0852 5.00444 9.84724 5.01256 9.10061 5.04896ZM9.18237 17.7034C8.49986 17.6737 8.12928 17.5603 7.88232 17.4654C7.55527 17.3394 7.32231 17.1871 7.07619 16.9433C6.83007 16.6996 6.67886 16.4658 6.55118 16.1394C6.45528 15.8925 6.33978 15.5223 6.30786 14.8398C6.27314 14.1021 6.26586 13.8807 6.2618 12.0118C6.25774 10.1429 6.26488 9.92171 6.29722 9.18376C6.32634 8.50181 6.44044 8.13081 6.53522 7.88399C6.66122 7.55652 6.81299 7.32398 7.05729 7.078C7.30159 6.83201 7.53469 6.68053 7.86132 6.55285C8.108 6.45653 8.47816 6.34201 9.16039 6.30953C9.89862 6.27453 10.1198 6.26753 11.9884 6.26347C13.857 6.25941 14.0788 6.26641 14.8173 6.29889C15.4992 6.32857 15.8704 6.44155 16.1169 6.53689C16.4441 6.66289 16.6769 6.81423 16.9229 7.05896C17.1689 7.30368 17.3205 7.53594 17.4482 7.86327C17.5447 8.10925 17.6592 8.47927 17.6914 9.16192C17.7265 9.90015 17.7345 10.1215 17.7379 11.9899C17.7412 13.8584 17.7346 14.0803 17.7023 14.818C17.6725 15.5005 17.5594 15.8712 17.4643 16.1184C17.3383 16.4454 17.1864 16.6785 16.9419 16.9243C16.6975 17.1701 16.4647 17.3216 16.1379 17.4493C15.8915 17.5455 15.5209 17.6603 14.8393 17.6928C14.101 17.7275 13.8798 17.7348 12.0105 17.7388C10.1412 17.7429 9.92074 17.7353 9.18251 17.7034M14.889 8.25877C14.8898 8.72273 15.2664 9.09822 15.7304 9.09738C16.1943 9.09654 16.5698 8.71993 16.569 8.25597C16.5681 7.792 16.1915 7.41652 15.7276 7.41736C15.7276 7.41736 15.7274 7.41736 15.7273 7.41736C15.2635 7.41834 14.8881 7.79494 14.889 8.25877ZM8.4055 12.007C8.40942 13.9922 10.0217 15.5979 12.0065 15.5941C13.9913 15.5904 15.5981 13.9782 15.5943 11.993C15.5905 10.0078 13.9778 8.40171 11.9928 8.40563C10.0077 8.40955 8.40172 10.0221 8.4055 12.007ZM9.66635 12.0045C9.66383 10.7158 10.7064 9.669 11.9951 9.66648C13.2839 9.66396 14.3306 10.7066 14.3332 11.9953C14.3357 13.284 13.2931 14.3308 12.0044 14.3333C10.7158 14.336 9.66901 13.2936 9.66635 12.0051V12.0045Z",
    fill: "white"
  }));
}

function NaverPostSvg() {
  return react.jsx(React__default['default'].Fragment, null, react.jsx("circle", {
    cx: "12",
    cy: "12",
    r: "11",
    fill: "currentColor"
  }), react.jsx("path", {
    d: "M7.96631 5.76685H16.033V13.8335H7.96631V5.76685ZM12.5913 8.24889V9.81433L11.4126 8.24889H10.1381V11.3515H11.4082V9.78601L12.5872 11.3515H13.8612V8.24889H12.5913Z",
    fill: "white"
  }), react.jsx("path", {
    d: "M7.96631 14.454H16.033L14.5204 16.3156H9.47869L7.96631 14.454Z",
    fill: "white"
  }), react.jsx("path", {
    d: "M9.98281 16.9361H14.0161L11.9993 19.4181L9.98281 16.9361Z",
    fill: "white"
  }));
}
function YoutubeSvg() {
  return react.jsx(React__default['default'].Fragment, null, react.jsx("circle", {
    cx: "12",
    cy: "12",
    r: "11",
    fill: "currentColor"
  }), react.jsx("path", {
    d: "M18.7086 8.63031C18.5472 8.02758 18.0736 7.55392 17.4709 7.39258C16.3783 7.09985 12.0002 7.09985 12.0002 7.09985C12.0002 7.09985 7.62199 7.09985 6.53062 7.39258C5.92789 7.55392 5.45423 8.02758 5.29289 8.63031C5.00016 9.72168 5.00016 12.0001 5.00016 12.0001C5.00016 12.0001 5.00016 14.2785 5.29289 15.3699C5.45423 15.9726 5.92789 16.4462 6.53062 16.6076C7.62199 16.9003 12.0002 16.9003 12.0002 16.9003C12.0002 16.9003 16.3783 16.9003 17.4697 16.6076C18.0724 16.4462 18.5461 15.9726 18.7074 15.3699C19.0002 14.2785 19.0002 12.0001 19.0002 12.0001C19.0002 12.0001 19.0002 9.72168 18.7074 8.63031H18.7086Z",
    fill: "white"
  }), react.jsx("path", {
    d: "M10.6013 14.0994L14.2396 11.9997L10.6013 9.8999V14.0994Z",
    fill: "currentColor"
  }));
}

var CUSTOMER_CENTER_EMAIL = 'cs@bucketplace.net';
function ServiceCenter(_ref) {
  var phone = _ref.phone,
      openingHour = _ref.openingHour,
      ohouseFooterLinks = _ref.ohouseFooterLinks;

  var _useKakaoChat = useKakaoChat(),
      openKakaoChat = _useKakaoChat.openKakaoChat;

  var _getDeviceInfo = getDeviceInfo(),
      isApp = _getDeviceInfo.isApp;

  return react.jsx(ServiceCenterContainer, null, react.jsx(ServiceCenterAnchorContainer, null, react.jsx(ServiceCenterAnchor, {
    href: ohouseFooterLinks === null || ohouseFooterLinks === void 0 ? void 0 : ohouseFooterLinks.serviceCenter
  }, "\uACE0\uAC1D\uC13C\uD130"), react.jsx(Icon, {
    name: "chevron_thick_right",
    size: 12
  })), react.jsx(ServiceCenterInfo, null, react.jsx(ServiceCenterNumberAnchor, {
    href: "tel:".concat(phone)
  }, phone), react.jsx(ServiceCenterTime, {
    dateTime: openingHour.start
  }, openingHour.start), "~", react.jsx(ServiceCenterTime, {
    dateTime: openingHour.end
  }, openingHour.end)), react.jsx(ServiceCenterDescription, null, '평일: 전체 문의 상담 가능\n주말, 공휴일: 오늘의집 직접배송, 이사/시공/수리 문의 상담 가능'), react.jsx(AnchorContainer, null, react.jsx(OutlineButton, {
    variant: "base1",
    size: 32,
    onClick: openKakaoChat,
    css: cssServiceButton
  }, "\uCE74\uD1A1 \uC0C1\uB2F4(\uD3C9\uC77C 09:00~18:00)"), react.jsx(OutlineAnchorButton, {
    href: !isApp || isHigherAppVersion({
      AOS: '0',
      iOS: '8.8'
    }) ? ohouseFooterLinks === null || ohouseFooterLinks === void 0 ? void 0 : ohouseFooterLinks.voiceOfCustomer : "mailto:".concat(CUSTOMER_CENTER_EMAIL),
    variant: "base1",
    size: 32,
    css: cssServiceButton
  }, "\uC774\uBA54\uC77C \uBB38\uC758")));
}

var ServiceCenterContainer = _styled__default['default']("div", {
  target: "eocurwa7"
})("color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.content.base1;
}, ";");

var ServiceCenterAnchor = _styled__default['default']("a", {
  target: "eocurwa6"
})(FONT_STYLE.title3, " font-weight:700;display:flex;align-items:center;");

var ServiceCenterNumberAnchor = _styled__default['default']("a", {
  target: "eocurwa5"
})(FONT_STYLE.subTitle1, " font-weight:700;white-space:nowrap;margin-right:", pxToRem(6), ";");

var ServiceCenterInfo = _styled__default['default']("div", {
  target: "eocurwa4"
})("display:flex;align-items:center;margin:", pxToRem(20), " 0 ", pxToRem(8), ";");

var ServiceCenterTime = _styled__default['default']("time", {
  target: "eocurwa3"
})(FONT_STYLE.body2, ";");

var ServiceCenterDescription = _styled__default['default']("p", {
  target: "eocurwa2"
})(FONT_STYLE.body3, " white-space:pre-wrap;margin-bottom:", pxToRem(12), ";");

var AnchorContainer = _styled__default['default']("div", {
  target: "eocurwa1"
})("display:flex;flex-direction:column;gap:", pxToRem(12), ";margin-top:", pxToRem(12), ";", MEDIA_QUERY.max('mobile', "\n    flex-direction: row;\n  "), ";");

var cssServiceButton = /*#__PURE__*/react.css("width:fit-content;white-space:nowrap;", MEDIA_QUERY.max('mobile', "\n    white-space: normal;\n  "), ";");

var ServiceCenterAnchorContainer = _styled__default['default']("div", {
  target: "eocurwa0"
})("display:flex;align-items:center;gap:", pxToRem(2), ";");

function Certification(_ref) {
  var certification = _ref.certification;
  return react.jsx(Container$3, null, certification.imgSrc && react.jsx("img", {
    src: certification.imgSrc,
    width: 32,
    height: 32,
    alt: "".concat(certification.id, " \uC778\uC99D \uB9C8\uD06C")
  }), (certification.title || certification.date) && react.jsx(Description, null, certification.title, react.jsx("br", null), certification.date));
}

var Container$3 = _styled__default['default']("div", {
  target: "e11l4n981"
})("display:flex;gap:", pxToRem(6), ";align-items:center;");

var Description = _styled__default['default']("div", {
  target: "e11l4n980"
})(FONT_STYLE.caption2, " color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.content.base2;
}, ";");

function Responsive(_ref) {
  var mobile = _ref.mobile,
      _ref$tablet = _ref.tablet,
      tablet = _ref$tablet === void 0 ? mobile : _ref$tablet,
      _ref$laptop = _ref.laptop,
      laptop = _ref$laptop === void 0 ? tablet : _ref$laptop,
      _ref$desktop = _ref.desktop,
      desktop = _ref$desktop === void 0 ? laptop : _ref$desktop,
      defaultBreakpoint = _ref.defaultBreakpoint,
      preventSyncOnInitialRender = _ref.preventSyncOnInitialRender;

  var _useResponsive = useResponsive({
    fallbackBreakpoint: defaultBreakpoint !== null && defaultBreakpoint !== void 0 ? defaultBreakpoint : 'mobile',
    preventSyncOnInitialRender: preventSyncOnInitialRender
  }),
      breakpoint = _useResponsive.breakpoint;

  return react.jsx(React__default['default'].Fragment, null, breakpoint === 'mobile' && mobile, breakpoint === 'tablet' && tablet, breakpoint === 'laptop' && laptop, breakpoint === 'desktop' && desktop);
}

function CompanyInfo$1(_ref) {
  var companyInfo = _ref.companyInfo;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpenCompanyInfo = _useState2[0],
      setOpenCompanyInfo = _useState2[1];

  return react.jsx(Responsive, {
    mobile: react.jsx(React__default['default'].Fragment, null, react.jsx(Button, {
      type: "button",
      onClick: function onClick() {
        return setOpenCompanyInfo(function (isOpenCompanyInfo) {
          return !isOpenCompanyInfo;
        });
      }
    }, companyInfo['상호명'], react.jsx(Icon, {
      name: isOpenCompanyInfo ? 'chevron_thick_up' : 'chevron_thick_down',
      size: 12
    })), isOpenCompanyInfo && react.jsx("div", {
      css: /*#__PURE__*/react.css("margin-top:", pxToRem(12), ";")
    }, Object.keys(companyInfo).map(function (key) {
      return key !== '상호명' && react.jsx(CompanyInfoItem, {
        key: key
      }, companyInfo[key]);
    }))),
    tablet: react.jsx("div", {
      css: /*#__PURE__*/react.css("margin-left:", pxToRem(-9), ";")
    }, Object.keys(companyInfo).map(function (key) {
      return react.jsx(CompanyInfoItem, {
        key: key
      }, react.jsx("span", {
        css: /*#__PURE__*/react.css("margin:0 ", pxToRem(4), ";")
      }, "|"), companyInfo[key]);
    }))
  });
}

var CompanyInfoItem = _styled__default['default']("div", {
  target: "e1j25pi01"
})(FONT_STYLE.body3, " display:inline-block;white-space:nowrap;", MEDIA_QUERY.max('mobile', "\n    display: block;\n  "), ";");

var Button = _styled__default['default']("button", {
  target: "e1j25pi00"
})(RESET_BUTTON, " ", FONT_STYLE.caption1, " color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.content.base1;
}, ";font-weight:700;display:flex;gap:", pxToRem(2), ";align-items:center;");

var _excluded$h = ["copyright", "serviceCenter", "socialLinks", "companyLinks", "companyInfo", "responsibilityInfo", "certifications"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$g() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$e =  true ? {
  name: "15bx5k",
  styles: "overflow-x:hidden"
} : 0;

function Footer(_ref2) {
  var copyright = _ref2.copyright,
      serviceCenter = _ref2.serviceCenter,
      socialLinks = _ref2.socialLinks,
      companyLinks = _ref2.companyLinks,
      companyInfo = _ref2.companyInfo,
      responsibilityInfo = _ref2.responsibilityInfo,
      certifications = _ref2.certifications,
      rest = _objectWithoutProperties(_ref2, _excluded$h);

  return react.jsx(FooterComponenet, rest, react.jsx(StyledContainer$1, null, serviceCenter && react.jsx(ServiceCenter, serviceCenter), react.jsx(Divider, {
    css: /*#__PURE__*/react.css(MEDIA_QUERY.max('mobile', "\n            grid-column-start: 1;\n            grid-column-end: 2;\n            width: 100%;\n            height: ".concat(pxToRem(1), ";\n          ")), ";")
  }), companyLinks && react.jsx(CompanyLinksContainer$1, null, companyLinks.map(function (_ref3) {
    var text = _ref3.text,
        href = _ref3.href,
        target = _ref3.target,
        isBold = _ref3.isBold;
    return react.jsx(CompanyLink, {
      key: text,
      href: href,
      target: target || '_self',
      isBold: !!isBold
    }, text);
  })), react.jsx(Divider, {
    css: /*#__PURE__*/react.css(MEDIA_QUERY.max('tablet', "\n            grid-column-start: 1;\n            grid-column-end: 4;\n            width: 100%;\n            height: ".concat(pxToRem(1), ";\n          ")), " ", MEDIA_QUERY.max('mobile', "\n            grid-column-start: 1;\n            grid-column-end: 2;\n          "), ";")
  }), react.jsx(InfoContainer, null, companyInfo && react.jsx("div", {
    css: _ref$e
  }, react.jsx(CompanyInfo$1, {
    companyInfo: companyInfo
  })), certifications && react.jsx(CertificationContainer, null, certifications.map(function (certification) {
    return react.jsx(Certification, {
      key: certification.id,
      certification: certification
    });
  })), responsibilityInfo && react.jsx("div", null, responsibilityInfo), socialLinks && react.jsx("div", null, socialLinks.map(function (socialLink) {
    return react.jsx(SocialLink, _extends({
      key: socialLink.href
    }, socialLink));
  })), copyright && react.jsx("p", null, copyright))));
}
var FooterComponenet = _styled__default['default']("footer", {
  target: "e1l1p3426"
})("padding:", pxToRem(40), " 0;background-color:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.content.base5;
}, ";", MEDIA_QUERY.max('mobile', "\n    padding: ".concat(pxToRem(30), " 0;\n  ")), " & a:hover{text-decoration:underline;}");

var StyledContainer$1 = /*#__PURE__*/_styled__default['default'](Container$4, {
  target: "e1l1p3425"
})(FONT_STYLE.caption1, ";display:grid;grid-template-columns:1fr 1px 1fr 1px 2fr;grid-column-gap:", pxToRem(30), ";", MEDIA_QUERY.max('tablet', "\n    grid-template-columns: 1fr 1px 1fr;\n    grid-row-gap: ".concat(pxToRem(24), ";\n  ")), " ", MEDIA_QUERY.max('mobile', "\n    padding: 0 ".concat(pxToRem(16), ";\n    grid-template-columns: 1fr;\n    grid-row-gap: ").concat(pxToRem(20), ";\n  ")), ";");

var InfoContainer = _styled__default['default']("div", {
  target: "e1l1p3424"
})(FONT_STYLE.caption2, " display:flex;flex-direction:column;gap:", pxToRem(12), ";color:", function (_ref5) {
  var theme = _ref5.theme;
  return theme.content.base2;
}, ";", MEDIA_QUERY.max('tablet', "\n    grid-column-start: 1;\n    grid-column-end: 4;\n  "), " ", MEDIA_QUERY.max('mobile', "\n    grid-column-start: 1;\n    grid-column-end: 2;\n  "), ";");

var CompanyLinksContainer$1 = _styled__default['default']("div", {
  target: "e1l1p3423"
})("display:grid;grid-template-columns:repeat(2, 1fr);grid-template-rows:repeat(6, min-content);grid-auto-flow:column;grid-column-gap:", pxToRem(10), ";grid-row-gap:", pxToRem(20), ";", MEDIA_QUERY.max('mobile', "\n    display: block;\n  "), ";");

var CompanyLink = _styled__default['default']("a", {
  target: "e1l1p3422"
})(FONT_STYLE.caption1, " display:inline-block;color:", function (_ref6) {
  var theme = _ref6.theme;
  return theme.content.base1;
}, ";white-space:nowrap;font-weight:", function (_ref7) {
  var isBold = _ref7.isBold;
  return isBold && '700';
}, ";", MEDIA_QUERY.max('mobile', "\n    margin: ".concat(pxToRem(8), " ").concat(pxToRem(12), " ").concat(pxToRem(8), " 0;\n  ")), ";");

var CertificationContainer = _styled__default['default']("div", {
  target: "e1l1p3421"
})("display:grid;grid-column-gap:", pxToRem(16), ";grid-template-columns:max-content 1fr;", MEDIA_QUERY.max('mobile', "\n    grid-template-columns: 1fr;\n  "), ";");

var Divider = _styled__default['default']("div", {
  target: "e1l1p3420"
})("width:", pxToRem(1), ";background-color:", function (_ref8) {
  var theme = _ref8.theme;
  return theme.divider;
}, ";");

var markIsmsSrc = "https://assets.ohou.se/design-system/8f5b2c2e98ea1196.png";

var markIso27001Src = "https://assets.ohou.se/design-system/d5fb816a58bb6a06.png";

var _excluded$g = ["ohouseFooterLinks"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$f() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var PHONE_NUMBER = '1670-0876';
var ADDRESS = '서울 서초구 서초대로74길 4 삼성생명서초타워 25층, 27층';
var COPYRIGHT_TEXT = 'Copyright 2014. bucketplace, Co., Ltd. All rights reserved.';
var BUCKETPLACE_HOMEPAGE_URL = 'https://www.bucketplace.com';
var OPENING_HOUR = {
  START: '09:00',
  END: '18:00'
};
var EMAIL = {
  CS: 'cs@bucketplace.net',
  CONTACT: 'contact@bucketplace.net'
};

/**
 * ohouse 서비스 도메인과 연결된 link schema를 create합니다.
 * @param ohs prod, stage 등 환경에 따른 `ohou.se` url
 * @param pro prod, stage 등 환경에 따른 `pro.ohou.se` url
 * @returns 서비스 도메인과 연결된 link schema
 */
function createOhouseFooterLinkSchema(_ref2) {
  var ohs = _ref2.ohs,
      pro = _ref2.pro;
  return {
    serviceCenter: "".concat(ohs, "/customer_center"),
    usepolicy: "".concat(ohs, "/usepolicy"),
    privacy: "".concat(ohs, "/privacy"),
    notice: "".concat(ohs, "/customer_notices"),
    inquiry: "".concat(ohs, "/contacts/new?type=request"),
    businessPurchasingMember: "".concat(ohs, "/contacts/b2b"),
    voiceOfCustomer: "".concat(ohs, "/contacts/new"),
    pro: "".concat(pro, "/?utm_source=ohouse&utm_medium=web&utm_campaign=prosignup&utm_content=footer")
  };
}

var _ref$d =  true ? {
  name: "ya1ij",
  styles: "display:inline-block;font-style:normal"
} : 0;

function OhouseFooter(props) {
  var ohouseFooterLinks = props.ohouseFooterLinks,
      restProps = _objectWithoutProperties(props, _excluded$g);

  var theme = react.useTheme();
  var isMobile = useResponsive().breakpoint === 'mobile';
  var iso27001 = {
    id: 'iso27001',
    title: react.jsx(React__default['default'].Fragment, null, react.jsx("span", null, "\uACE0\uAC1D\uB2D8\uC774 \uD604\uAE08\uACB0\uC81C\uD55C \uAE08\uC561\uC5D0 \uB300\uD574 \uC6B0\uB9AC\uC740\uD589\uACFC \uCC44\uBB34\uC9C0\uAE09\uBCF4\uC99D \uACC4\uC57D\uC744 \uCCB4\uACB0\uD558\uC5EC \uC548\uC804\uAC70\uB798\uB97C \uBCF4\uC7A5\uD558\uACE0 \uC788\uC2B5\uB2C8\uB2E4."), react.jsx("a", {
      target: "_blank",
      href: "https://image.ohou.se/i/bucketplace-v2-development/uploads/static/images/167904458404594951.jpg?w=1440",
      css: /*#__PURE__*/react.css("font-weight:700;color:", theme.content.base2, ";"),
      rel: "noreferrer"
    }, ' ', "\uC11C\uBE44\uC2A4\uAC00\uC785\uC0AC\uC2E4\uD655\uC778"))
  };
  var isms = {
    id: 'isms',
    imgSrc: markIsmsSrc,
    title: react.jsx("span", null, "\uC624\uB298\uC758\uC9D1 \uC11C\uBE44\uC2A4 \uC6B4\uC601"),
    date: '2021. 09. 08 ~ 2024. 09. 07'
  };
  return react.jsx(Footer, _extends({}, restProps, {
    copyright: COPYRIGHT_TEXT,
    serviceCenter: {
      phone: PHONE_NUMBER,
      openingHour: {
        start: OPENING_HOUR.START,
        end: OPENING_HOUR.END
      },
      ohouseFooterLinks: ohouseFooterLinks
    },
    socialLinks: [{
      type: 'Youtube',
      href: 'https://www.youtube.com/channel/UCBKtitA1RwY7F32rCniV1dA'
    }, {
      type: 'Instagram',
      href: 'https://www.instagram.com/todayhouse'
    }, {
      type: 'Facebook',
      href: 'https://www.facebook.com/interiortoday'
    }, {
      type: 'KakaoStory',
      href: 'https://story.kakao.com/ch/bucketplace'
    }, {
      type: 'NaverPost',
      href: 'https://naver.me/51ckkDZh'
    }],
    companyLinks: [{
      text: '회사소개',
      href: BUCKETPLACE_HOMEPAGE_URL
    }, {
      text: '채용정보',
      href: "".concat(BUCKETPLACE_HOMEPAGE_URL, "/careers")
    }, {
      text: '이용약관',
      href: ohouseFooterLinks.usepolicy
    }, {
      text: '개인정보 처리방침',
      href: ohouseFooterLinks.privacy,
      isBold: true
    }, {
      text: '공지사항',
      href: ohouseFooterLinks.notice
    }, {
      text: '안전거래센터',
      href: 'https://safetybucketplace.zendesk.com/hc/ko',
      target: 'blank'
    }, {
      text: '입점신청',
      href: 'https://partnerbucketplace.zendesk.com/hc/ko/articles/19259629646361-오늘의집-입점안내'
    }, {
      text: '제휴/광고 문의',
      href: ohouseFooterLinks.inquiry
    }, {
      text: '사업자 구매 회원',
      href: ohouseFooterLinks.businessPurchasingMember
    }, {
      text: '시공파트너 안내',
      href: ohouseFooterLinks.pro
    }, {
      text: '상품광고 소개',
      href: 'https://ohouse-ad.oopy.io'
    }, {
      text: '고객의 소리',
      href: ohouseFooterLinks.voiceOfCustomer
    }],
    companyInfo: {
      상호명: '(주)버킷플레이스',
      대표이사: '대표이사 이승재',
      주소: react.jsx("address", {
        css: _ref$d
      }, ADDRESS),
      이메일: react.jsx("a", {
        href: "mailto:contact@bucketplace.net"
      }, EMAIL.CONTACT),
      사업자등록번호: react.jsx(React__default['default'].Fragment, null, react.jsx("span", null, "\uC0AC\uC5C5\uC790\uB4F1\uB85D\uBC88\uD638 119-86-91245"), react.jsx("a", {
        target: "_blank",
        href: "https://www.ftc.go.kr/bizCommPop.do?wrkr_no=1198691245",
        css: /*#__PURE__*/react.css("font-weight:700;color:", theme.content.base2, ";"),
        rel: "noreferrer"
      }, ' ', "\uC0AC\uC5C5\uC790\uC815\uBCF4\uD655\uC778")),
      통신판매업신고번호: react.jsx("span", null, "\uD1B5\uC2E0\uD310\uB9E4\uC5C5\uC2E0\uACE0\uBC88\uD638 \uC81C2018-\uC11C\uC6B8\uC11C\uCD08-0580\uD638")
    },
    responsibilityInfo: "(\uC8FC)\uBC84\uD0B7\uD50C\uB808\uC774\uC2A4\uB294 \uD1B5\uC2E0\uD310\uB9E4\uC911\uAC1C\uC790\uB85C \uAC70\uB798 \uB2F9\uC0AC\uC790\uAC00 \uC544\uB2C8\uBBC0\uB85C, \uD310\uB9E4\uC790\uAC00 \uB4F1\uB85D\uD55C \uC0C1\uD488\uC815\uBCF4 \uBC0F \uAC70\uB798 \uB4F1\uC5D0 \uB300\uD574 \uCC45\uC784\uC744 \uC9C0\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uB2E8, (\uC8FC)\uBC84\uD0B7\uD50C\uB808\uC774\uC2A4\uAC00 \uD310\uB9E4\uC790\uB85C \uB4F1\uB85D \uD310\uB9E4\uD55C \uC0C1\uD488\uC740 \uD310\uB9E4\uC790\uB85C\uC11C \uCC45\uC784\uC744 \uBD80\uB2F4\uD569\uB2C8\uB2E4.",
    certifications: isMobile ? [iso27001] : [isms, _objectSpread2(_objectSpread2({}, iso27001), {}, {
      imgSrc: markIso27001Src
    })]
  }));
}

var _excluded$f = ["ohouseFooterLinks"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$e() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref2$7 =  true ? {
  name: "15bx5k",
  styles: "overflow-x:hidden"
} : 0;

function SimpleFooter(_ref3) {
  var copyright = _ref3.copyright,
      companyLinks = _ref3.companyLinks,
      companyInfo = _ref3.companyInfo;
  return react.jsx(FooterComponenet, null, react.jsx(StyledContainer, null, companyLinks && react.jsx(CompanyLinksContainer, null, companyLinks.map(function (_ref4) {
    var text = _ref4.text,
        href = _ref4.href,
        target = _ref4.target,
        isBold = _ref4.isBold;
    return react.jsx(CompanyLink, {
      key: text,
      href: href,
      target: target || '_self',
      isBold: !!isBold
    }, text);
  })), companyInfo && react.jsx("div", {
    css: _ref2$7
  }, react.jsx(CompanyInfoContainer, null, Object.keys(companyInfo).map(function (key) {
    return react.jsx(CompanyInfo, {
      key: key
    }, react.jsx("span", {
      css: /*#__PURE__*/react.css("margin:0 ", pxToRem(4), ";")
    }, "|"), companyInfo[key]);
  }))), copyright && react.jsx(Copyright, null, copyright)));
}

var StyledContainer = /*#__PURE__*/_styled__default['default'](Container$4, {
  target: "elc0e3t4"
})("display:flex;flex-direction:column;gap:", pxToRem(12), ";");

var CompanyInfoContainer = _styled__default['default']("div", {
  target: "elc0e3t3"
})(FONT_STYLE.body3, " color:", function (_ref5) {
  var theme = _ref5.theme;
  return theme.content.base2;
}, ";margin-left:", pxToRem(-12), ";");

var CompanyLinksContainer = _styled__default['default']("div", {
  target: "elc0e3t2"
})(FONT_STYLE.caption1, " display:flex;gap:", pxToRem(12), ";color:", function (_ref6) {
  var theme = _ref6.theme;
  return theme.content.base1;
}, ";");

var CompanyInfo = _styled__default['default']("div", {
  target: "elc0e3t1"
})( true ? {
  name: "26mdob",
  styles: "white-space:nowrap;display:inline-block"
} : 0);

var Copyright = _styled__default['default']("p", {
  target: "elc0e3t0"
})(FONT_STYLE.caption2, " color:", function (_ref7) {
  var theme = _ref7.theme;
  return theme.content.base2;
}, ";");

/**
 * ohouse 서비스 도메인과 연결된 link schema를 create합니다.
 * @param ohs prod, stage 등 환경에 따른 `ohou.se` url
 * @returns 서비스 도메인과 연결된 link schema
 */
function createOhouseSimpleFooterLinkSchema(_ref8) {
  var ohs = _ref8.ohs;
  return {
    usepolicy: "".concat(ohs, "/usepolicy"),
    privacy: "".concat(ohs, "/privacy")
  };
}

var _ref$c =  true ? {
  name: "ya1ij",
  styles: "display:inline-block;font-style:normal"
} : 0;

function OhouseSimpleFooter(props) {
  var ohouseFooterLinks = props.ohouseFooterLinks,
      restProps = _objectWithoutProperties(props, _excluded$f);

  return react.jsx(SimpleFooter, _extends({}, restProps, {
    copyright: COPYRIGHT_TEXT,
    companyLinks: [{
      text: '회사소개',
      href: BUCKETPLACE_HOMEPAGE_URL
    }, {
      text: '이용약관',
      href: ohouseFooterLinks.usepolicy
    }, {
      text: '개인정보 처리방침',
      href: ohouseFooterLinks.privacy,
      isBold: true
    }],
    companyInfo: {
      상호명: '(주)버킷플레이스',
      대표이사: '대표이사 이승재',
      주소: react.jsx("address", {
        css: _ref$c
      }, ADDRESS),
      이메일: react.jsx("a", {
        href: "mailto:contact@bucketplace.net"
      }, EMAIL.CONTACT),
      사업자등록번호: react.jsx("span", null, "\uC0AC\uC5C5\uC790\uB4F1\uB85D\uBC88\uD638 119-86-91245")
    }
  }));
}

var _templateObject$2, _templateObject2$1, _templateObject3$1;

function _EMOTION_STRINGIFIED_CSS_ERROR__$d() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var fadeIn = react.keyframes(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  0% {\n    transform: translateY(", ");\n    opacity: 0;\n  }\n  100% {\n    transform: none;\n    opacity: 1;\n  }\n"])), pxToRem(58));
var fadeOut = react.keyframes(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  0% {\n    transform: translateY(", ");\n    opacity: 1;\n  }\n\n  100% {\n    transform: none;\n    opacity: 0;\n  }\n"])), pxToRem(58));
var lastItemFadeOut = react.keyframes(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n"])));

function cssAnimation(isClosing, isLast) {
  if (!isClosing) return /*#__PURE__*/react.css("animation:", fadeIn, " 0.4s 0.1s ease both;");
  if (isLast) return /*#__PURE__*/react.css("animation:", lastItemFadeOut, " 0.4s 1.2s ease forwards;");
  return /*#__PURE__*/react.css("animation:", fadeOut, " 0.4s ease forwards;");
}

var _ref$b =  true ? {
  name: "2qga7i",
  styles: "text-align:right"
} : 0;

var _ref2$6 =  true ? {
  name: "zykzq1",
  styles: "flex:1 0 0px;display:flex;min-width:0;align-items:center"
} : 0;

var _ref3$3 =  true ? {
  name: "s5xdrg",
  styles: "display:flex;align-items:center"
} : 0;

var _ref4$1 =  true ? {
  name: "4zleql",
  styles: "display:block"
} : 0;

function SnackbarItem(_ref5) {
  var className = _ref5.className,
      icon = _ref5.icon,
      content = _ref5.content,
      buttons = _ref5.buttons,
      multiline = _ref5.multiline,
      type = _ref5.type,
      onClose = _ref5.onClose,
      onClosed = _ref5.onClosed,
      isClosing = _ref5.isClosing,
      _ref5$isLast = _ref5.isLast,
      isLast = _ref5$isLast === void 0 ? false : _ref5$isLast;
  var theme = react.useTheme();
  var align = !!icon || !!buttons || multiline ? 'left' : 'center';
  return react.jsx("div", {
    className: className,
    css: [FONT_STYLE.subTitle1, multiline ? _ref4$1 : _ref3$3, /*#__PURE__*/react.css("padding:", pxToRem(14), " ", pxToRem(16), ";border-radius:", pxToRem(4), ";color:", theme.content.white, ";background-color:", {
      normal: theme.layer.dark,
      critical: theme.content.primary2.thick
    }[type || 'normal'], ";"), cssAnimation(isClosing, isLast)],
    onClick: onClose,
    onAnimationEnd: isClosing ? onClosed : undefined
  }, react.jsx("div", {
    css: _ref2$6
  }, !!icon && react.jsx(Icon, {
    name: icon === true ? 'info_outline' : icon,
    size: 24,
    css: /*#__PURE__*/react.css("margin:", pxToRem(-2), " ", pxToRem(8), " ", pxToRem(-2), " 0;")
  }), react.jsx("div", {
    css: /*#__PURE__*/react.css("flex:1 0 0px;min-width:0;margin:0;text-align:", align, ";white-space:pre-line;word-break:keep-all;overflow-wrap:break-word;")
  }, content)), (buttons || []).length > 0 && react.jsx("div", {
    css: [_ref$b, multiline ? /*#__PURE__*/react.css("margin:", pxToRem(10), " ", pxToRem(-3), " 0;") : /*#__PURE__*/react.css("margin:0 ", pxToRem(-3), ";")]
  }, (buttons || []).map(function (buttonProps, i) {
    return react.jsx("button", _extends({
      key: i,
      type: "button",
      css: /*#__PURE__*/react.css(RESET_BUTTON, " margin:", pxToRem(-5), " ", pxToRem(3), ";padding:", pxToRem(5), " ", pxToRem(8), ";", FONT_STYLE.subTitle1, " color:", {
        normal: theme.content.primary1.basic,
        critical: theme.content.white
      }[type || 'normal'], ";font-weight:700;")
    }, buttonProps));
  })));
}

/**
 * 스낵바 메시지 위치 옵션
 * - basic : 바텀 하단에 스낵바 메시지 노출
 * - fab : FAB 가 보이도록 메시지 노출
 */
var SNACKBAR_PLACEMENT = {
  basic: 'basic',
  fab: 'fab'
};
/**
 * 스낵바 메시지 위치 옵션 코드
 */

var _BOTTOM_SIZE;
var BOTTOM_SIZE = (_BOTTOM_SIZE = {}, _defineProperty(_BOTTOM_SIZE, SNACKBAR_PLACEMENT.basic, {
  mobile: 8,
  tablet: 40
}), _defineProperty(_BOTTOM_SIZE, SNACKBAR_PLACEMENT.fab, {
  mobile: 70,
  tablet: 40
}), _BOTTOM_SIZE);
function SnackbarList(props) {
  var _useSnackbar = useSnackbar(),
      _useSnackbar$state = _useSnackbar.state,
      items = _useSnackbar$state.items,
      placement = _useSnackbar$state.placement,
      close = _useSnackbar.close,
      closed = _useSnackbar.closed,
      engage = _useSnackbar.engage,
      disengage = _useSnackbar.disengage;

  var bottom = BOTTOM_SIZE[placement];
  return react.jsx(BodyPortal, null, react.jsx("div", _extends({}, props, {
    onMouseEnter: engage,
    onMouseLeave: disengage,
    css: /*#__PURE__*/react.css("position:fixed;width:", pxToRem(470), ";left:calc(50% - ", pxToRem(235), ");bottom:", pxToRem(bottom.tablet), ";z-index:", ZINDEX.snackbar, ";", MEDIA_QUERY.max('mobile', "\n            width: calc(100% - ".concat(pxToRem(16), ");\n            left: ").concat(pxToRem(8), ";\n            bottom: ").concat(pxToRem(bottom.mobile), ";\n            ").concat(safeAreaInset('bottom', 'padding-bottom'), "\n          ")), ";")
  }), items.map(function (_ref, index) {
    var id = _ref.id,
        state = _ref.state,
        options = _ref.options;
    return react.jsx(SnackbarItem, _extends({}, options, {
      key: id,
      isClosing: state === 'closing',
      onClose: function onClose() {
        return close(id);
      },
      onClosed: function onClosed() {
        return closed(id);
      },
      css: /*#__PURE__*/react.css("margin-top:", pxToRem(15), ";"),
      isLast: index === items.length - 1
    }));
  })));
}

function snackBarReducer(state, action) {
  switch (action.type) {
    case 'open':
      {
        var newItem = {
          id: state.id,
          state: 'open',
          options: action.options
        };

        var changeItemList = function changeItemList(items) {
          return items.length === 1 ? [_objectSpread2(_objectSpread2({}, items[0]), {}, {
            state: 'closing'
          }), newItem] : [newItem];
        };

        var items = changeItemList(state.items);
        return _objectSpread2(_objectSpread2({}, state), {}, {
          id: state.id + 1,
          items: items,
          placement: getPlacement(items)
        });
      }

    case 'close':
      {
        var _items = state.items.map(function (v) {
          if (v.id === action.id) {
            return _objectSpread2(_objectSpread2({}, v), {}, {
              state: 'closing'
            });
          }

          return v;
        });

        return _objectSpread2(_objectSpread2({}, state), {}, {
          items: _items,
          placement: getPlacement(_items)
        });
      }

    case 'closeAll':
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          items: state.items.map(function (v) {
            return _objectSpread2(_objectSpread2({}, v), {}, {
              state: 'closing'
            });
          })
        });
      }

    case 'closed':
      {
        var entry = state.items.find(function (v) {
          return v.id === action.id;
        });

        if (entry != null && entry.options.onClose != null) {
          entry.options.onClose();
        }

        var _items2 = state.items.filter(function (v) {
          return v.id !== action.id;
        });

        return _objectSpread2(_objectSpread2({}, state), {}, {
          isEngaged: state.items.length > 1 ? state.isEngaged : false,
          items: _items2,
          placement: getPlacement(_items2)
        });
      }

    case 'engage':
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isEngaged: true
      });

    case 'disengage':
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isEngaged: false
      });

    case 'shift':
      {
        var closeItem = state.items.find(function (v) {
          return v.state === 'open';
        });
        if (closeItem == null) return state;
        return snackBarReducer(state, {
          type: 'close',
          id: closeItem.id
        });
      }

    default:
      return state;
  }
}

function useSnackbarState() {
  var _useReducer = React.useReducer(snackBarReducer, {
    id: 0,
    isEngaged: false,
    items: [],
    placement: SNACKBAR_PLACEMENT.basic
  }),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var handleEngage = React.useCallback(function () {
    dispatch({
      type: 'engage'
    });
  }, [dispatch]);
  var handleDisengage = React.useCallback(function () {
    dispatch({
      type: 'disengage'
    });
  }, [dispatch]);
  var handleOpen = React.useCallback(function (options) {
    dispatch({
      type: 'open',
      options: options
    });
  }, [dispatch]);
  var handleClose = React.useCallback(function (id) {
    dispatch({
      type: 'close',
      id: id
    });
  }, [dispatch]);
  var handleClosed = React.useCallback(function (id) {
    dispatch({
      type: 'closed',
      id: id
    });
  }, [dispatch]);
  var handleCloseAll = React.useCallback(function () {
    dispatch({
      type: 'closeAll'
    });
  }, [dispatch]);
  React.useEffect(function () {
    if (state.isEngaged || state.items.length === 0) return;
    var closeItem = state.items.find(function (v) {
      return v.state === 'open';
    });

    if (closeItem != null) {
      // If it's not engaged, try to remove items every few seconds
      var duration = closeItem.options.duration || 3000;
      var timer = setTimeout(function () {
        return dispatch({
          type: 'shift'
        });
      }, duration);
      return function () {
        clearTimeout(timer);
      };
    }
  }, [dispatch, state]);
  var result = React.useMemo(function () {
    return {
      state: state,
      closeAll: handleCloseAll,
      close: handleClose,
      closed: handleClosed,
      open: handleOpen,
      engage: handleEngage,
      disengage: handleDisengage
    };
  }, [state, handleCloseAll, handleClose, handleClosed, handleOpen, handleEngage, handleDisengage]);
  return result;
}
/**
 * 오픈된 스낵바 아이템을 순회하여 스낵바를 노출할 위치를 리턴합니다.
 */

function getPlacement(items) {
  return items.some(function (item) {
    return item.options.placement === SNACKBAR_PLACEMENT.fab;
  }) ? SNACKBAR_PLACEMENT.fab : SNACKBAR_PLACEMENT.basic;
}

function SnackbarProvider(_ref) {
  var children = _ref.children;
  var state = useSnackbarState();
  return react.jsx(SnackbarContext.Provider, {
    value: state
  }, children, react.jsx(SnackbarList, null));
}

function BdsProvider(_ref) {
  var mode = _ref.mode,
      children = _ref.children;
  return react.jsx(react.ThemeProvider, {
    theme: mode === 'dark' ? DARK_THEME : LIGHT_THEME
  }, react.jsx(SnackbarProvider, null, react.jsx(ui.StickyProvider, null, react.jsx(OverlayProvider, null, children))));
}

var GLOBAL_IMPORT_ICON = "\n  @import \"https://assets.ohou.se/design-system/bbf3fca1e650ee6d.css\";\n";
var GLOBAL_STYLE_ICON = "\n  @font-face {\n    font-family: OhouseIcon;\n    src: url(https://assets.ohou.se/design-system/3298ed52addbc709.eot);\n    src:\n      url(https://assets.ohou.se/design-system/3298ed52addbc709.eot#iefix) format(\"embedded-opentype\"),\n      url(https://assets.ohou.se/design-system/d8923b386a66fd50.woff2) format(\"woff2\"),\n      url(https://assets.ohou.se/design-system/9e79341d6a2fe0d2.woff) format(\"woff\"),\n      url(https://assets.ohou.se/design-system/5355f736e6a7bc5b.ttf) format(\"truetype\"),\n      url(https://assets.ohou.se/design-system/3ba7913eab100858.svg#OhouseIcon) format(\"svg\");\n  }\n";
var GLOBAL_IMPORT_FONT = "\n  @import \"https://assets.ohou.se/fonts/pretendard/v1.3.8/pretendardvariable-dynamic-subset.css\";\n";
var GLOBAL_STYLE_FONT = "\n  html {\n    font-family: 'Pretendard Variable', sans-serif;\n    letter-spacing: ".concat(pxToRem(-0.3), ";\n    -webkit-font-smoothing: antialiased;\n  }\n");
var GLOBAL_STYLE = "\n  ".concat(GLOBAL_IMPORT_ICON, "\n  ").concat(GLOBAL_IMPORT_FONT, "\n  ").concat(GLOBAL_STYLE_ICON, "\n  ").concat(GLOBAL_STYLE_FONT, "\n  * {\n    box-sizing: border-box;\n  }\n  html, body { height: 100%; }\n  body, figure, input, p, h1, h2, h3, h4, h5, h6, hr,\n  ul {\n    margin: 0;\n  }\n  input,\n  textarea,\n  button,\n  ul {\n    padding: 0;\n  }\n  button,\n  hr,\n  input,\n  textarea,\n  select {\n    border: none;\n  }\n  button,\n  input,\n  textarea,\n  select {\n    background: none;\n  }\n  input,\n  textarea,\n  select {\n    outline: none;\n  }\n  button,\n  input,\n  textarea {\n    font-family: inherit;\n  }\n  ol,\n  ul {\n    list-style: none;\n  }\n  a {\n    text-decoration: none;\n    color: inherit;\n  }\n  a,\n  button:enabled {\n    cursor: pointer;\n    touch-action: manipulation;\n  }\n");

var _excluded$e = ["title", "type", "icon", "children"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$c() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$a =  true ? {
  name: "15ne7tr",
  styles: "font-weight:700;vertical-align:middle"
} : 0;

function Callout(_ref2) {
  var title = _ref2.title,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? 'notice' : _ref2$type,
      icon = _ref2.icon,
      children = _ref2.children,
      rest = _objectWithoutProperties(_ref2, _excluded$e);

  var theme = react.useTheme();
  return react.jsx("div", _extends({}, rest, {
    css: /*#__PURE__*/react.css("color:", theme.content.base1, ";padding:", pxToRem(16), ";border-radius:", pxToRem(4), ";background-color:", {
      notice: theme.content.base5,
      confirm: theme.content.base5,
      alert: theme.content.primary2.thin
    }[type], ";")
  }), react.jsx("div", {
    css: FONT_STYLE.subTitle1
  }, icon && react.jsx(Icon, {
    size: 18,
    name: icon,
    css: /*#__PURE__*/react.css("vertical-align:middle;margin-right:", pxToRem(6), ";color:", {
      notice: theme.content.base1,
      confirm: theme.content.primary1.basic,
      alert: theme.content.primary2.thick
    }[type], ";")
  }), react.jsx("span", {
    css: _ref$a
  }, title)), react.jsx("div", {
    css: [FONT_STYLE.body1_1, /*#__PURE__*/react.css("margin-top:", pxToRem(12), ";")]
  }, children));
}

var _excluded$d = ["size", "selected", "disabled", "forwardedRef", "children"];
function ListItem(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'basic' : _ref$size,
      selected = _ref.selected,
      disabled = _ref.disabled,
      forwardedRef = _ref.forwardedRef,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded$d);

  var theme = react.useTheme();
  return react.jsx("div", _extends({
    ref: forwardedRef,
    css: /*#__PURE__*/react.css("padding:", pxToRem({
      basic: 16,
      compact: 11
    }[size]), " ", pxToRem(16), ";color:", theme.content.base1, ";", FONT_STYLE.subTitle1, " transition:background-color .2s ease-in-out;", disabled && "\n          color: ".concat(theme.content.base3, ";\n        "), " &:hover,&:focus{background-color:", theme.content.base5, ";}", selected && "\n          background-color: ".concat(theme.content.base5, ";\n        "), ";")
  }, props), children);
}

var _excluded$c = ["variant"];
function DividerListItem(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'thin' : _ref$variant,
      props = _objectWithoutProperties(_ref, _excluded$c);

  return react.jsx(React__default['default'].Fragment, null, react.jsx(ListItem, props), react.jsx(Divider$1, {
    variant: variant
  }));
}

var _excluded$b = ["currentPage", "maxPage", "size", "dimmed", "fontWeight", "children"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$b() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function cssSize$2(size) {
  return /*#__PURE__*/react.css({
    small: /*#__PURE__*/react.css("padding:", pxToRem(4), " ", pxToRem(8), ";font-size:", pxToRem(12), ";height:", pxToRem(24), ";border-radius:", pxToRem(12), ";"),
    medium: /*#__PURE__*/react.css("padding:", pxToRem(4), " ", pxToRem(10), ";font-size:", pxToRem(14), ";height:", pxToRem(26), ";border-radius:", pxToRem(13), ";"),
    large: /*#__PURE__*/react.css("padding:", pxToRem(4), " ", pxToRem(12), ";font-size:", pxToRem(16), ";height:", pxToRem(28), ";border-radius:", pxToRem(14), ";")
  }[size], ";");
}
function cssDimmed(dimmed, theme) {
  return /*#__PURE__*/react.css({
    basic: /*#__PURE__*/react.css("background-color:", theme.dim.basic, ";"),
    thick: /*#__PURE__*/react.css("background-color:", theme.dim.thick, ";")
  }[dimmed], ";");
}

var _ref$9 =  true ? {
  name: "1j389vi",
  styles: "font-weight:700"
} : 0;

var _ref2$5 =  true ? {
  name: "mmvz9h",
  styles: "font-weight:400"
} : 0;

function cssFontWeight(fontWeight) {
  return /*#__PURE__*/react.css({
    regular: _ref2$5,
    bold: _ref$9
  }[fontWeight], ";");
}
function IndicatorNumber(_ref3) {
  var _ref3$currentPage = _ref3.currentPage,
      currentPage = _ref3$currentPage === void 0 ? 1 : _ref3$currentPage,
      _ref3$maxPage = _ref3.maxPage,
      maxPage = _ref3$maxPage === void 0 ? 1 : _ref3$maxPage,
      _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? 'small' : _ref3$size,
      _ref3$dimmed = _ref3.dimmed,
      dimmed = _ref3$dimmed === void 0 ? 'basic' : _ref3$dimmed,
      _ref3$fontWeight = _ref3.fontWeight,
      fontWeight = _ref3$fontWeight === void 0 ? 'regular' : _ref3$fontWeight,
      children = _ref3.children,
      rest = _objectWithoutProperties(_ref3, _excluded$b);

  var theme = react.useTheme();
  return react.jsx("span", _extends({
    css: [cssSize$2(size), cssDimmed(dimmed, theme), cssFontWeight(fontWeight), /*#__PURE__*/react.css("display:inline-flex;align-items:center;text-overflow:ellipsis;white-space:nowrap;word-wrap:normal;line-height:0;overflow:hidden;max-width:100%;color:", theme.content.white, ";box-sizing:border-box;")]
  }, rest), children || "".concat(currentPage, "/").concat(maxPage));
}

var _excluded$a = ["currentPage", "maxPage", "size", "fontWeight"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$a() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

function getGap(size) {
  return {
    small: 2,
    medium: 2,
    large: 4
  }[size];
}

function getIconSize(size) {
  return {
    small: 12,
    medium: 12,
    large: 18
  }[size];
}

function getIconName(fontWeight) {
  return {
    regular: 'add',
    bold: 'add_thick'
  }[fontWeight];
}

function cssSize$1(size) {
  return /*#__PURE__*/react.css({
    small: /*#__PURE__*/react.css("padding:", pxToRem(4), " ", pxToRem(6), " ", pxToRem(4), " ", pxToRem(8), ";"),
    medium: /*#__PURE__*/react.css("padding:", pxToRem(4), " ", pxToRem(8), " ", pxToRem(4), " ", pxToRem(10), ";"),
    large: /*#__PURE__*/react.css("padding:", pxToRem(4), " ", pxToRem(8), " ", pxToRem(4), " ", pxToRem(12), ";")
  }[size], ";");
}

var _ref2$4 =  true ? {
  name: "1989ovb",
  styles: "vertical-align:middle"
} : 0;

var _ref3$2 =  true ? {
  name: "1989ovb",
  styles: "vertical-align:middle"
} : 0;

function cssIcon(size) {
  return /*#__PURE__*/react.css({
    small: _ref3$2,
    medium: _ref2$4,
    large: /*#__PURE__*/react.css()
  }[size], ";");
}

var _ref$8 =  true ? {
  name: "e0dnmk",
  styles: "cursor:pointer"
} : 0;

function IndicatorNumberWithIcon(_ref4) {
  var currentPage = _ref4.currentPage,
      maxPage = _ref4.maxPage,
      _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? 'small' : _ref4$size,
      _ref4$fontWeight = _ref4.fontWeight,
      fontWeight = _ref4$fontWeight === void 0 ? 'regular' : _ref4$fontWeight,
      rest = _objectWithoutProperties(_ref4, _excluded$a);

  return react.jsx(IndicatorNumber, _extends({
    size: size,
    currentPage: currentPage,
    maxPage: maxPage,
    fontWeight: fontWeight,
    css: [cssSize$1(size), _ref$8]
  }, rest), react.jsx("span", {
    css: /*#__PURE__*/react.css("vertical-align:middle;margin-right:", pxToRem(getGap(size)), ";")
  }, currentPage, "/", maxPage), react.jsx(Icon, {
    name: getIconName(fontWeight),
    size: getIconSize(size),
    css: cssIcon(size)
  }));
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$9() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

function cssVariantDot(theme, variant) {
  switch (variant) {
    case 'basic':
      return /*#__PURE__*/react.css("background-color:", theme.content.base3, ";");

    case 'onDimmed':
      return /*#__PURE__*/react.css("background-color:", theme.dim.onDark.thick, ";box-shadow:", pxToRem(0), " ", pxToRem(1), " ", pxToRem(6), " ", theme.shadow.basic, ";");
  }
}

function cssCurrentDot(theme, variant) {
  switch (variant) {
    case 'basic':
      return /*#__PURE__*/react.css("width:", pxToRem(8), ";height:", pxToRem(8), ";background-color:", theme.content.base1, ";");

    case 'onDimmed':
      return /*#__PURE__*/react.css("width:", pxToRem(8), ";height:", pxToRem(8), ";background-color:", theme.content.white, ";box-shadow:", pxToRem(0), " ", pxToRem(1), " ", pxToRem(6), " ", theme.shadow.basic, ";");
  }
}

function cssMoreDot() {
  return /*#__PURE__*/react.css("width:", pxToRem(4), ";height:", pxToRem(4), ";");
}

function cssHiddenDot() {
  return /*#__PURE__*/react.css("width:", pxToRem(0), ";height:", pxToRem(0), ";margin:", pxToRem(0), ";");
}

var VISIBLE_COUNT = 6;

var _ref$7 =  true ? {
  name: "wv42kf",
  styles: "margin:0;padding:0;height:0;vertical-align:bottom;display:inline-block"
} : 0;

var _ref2$3 =  true ? {
  name: "ofztlr",
  styles: "text-align:center;white-space:nowrap;font-size:0;line-height:0;padding:0"
} : 0;

function IndicatorDots(_ref3) {
  var _ref3$variant = _ref3.variant,
      variant = _ref3$variant === void 0 ? 'basic' : _ref3$variant,
      maxPage = _ref3.maxPage,
      _ref3$currentPage = _ref3.currentPage,
      currentPage = _ref3$currentPage === void 0 ? 1 : _ref3$currentPage,
      className = _ref3.className,
      _onClick = _ref3.onClick;
  var theme = react.useTheme();

  var _useState = React.useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      visibleStartIndex = _useState2[0],
      setVisibleStartIndex = _useState2[1];

  var _useState3 = React.useState(currentPage - 1),
      _useState4 = _slicedToArray(_useState3, 2),
      currentIndex = _useState4[0],
      setCurrentIndex = _useState4[1];

  var isLeftEnd = currentIndex < VISIBLE_COUNT / 2;
  var isRightEnd = currentIndex > maxPage - VISIBLE_COUNT / 2;
  var getVisibleCount = React.useCallback(function () {
    var changedVisibleCount = VISIBLE_COUNT + 1 ;
    return isLeftEnd || isRightEnd ? VISIBLE_COUNT : changedVisibleCount;
  }, [isLeftEnd, isRightEnd]);
  var visibleLastIndex = visibleStartIndex + getVisibleCount() - 1;

  var isCurrentDot = function isCurrentDot(index) {
    return index === currentIndex;
  };

  var isHiddenDot = function isHiddenDot(index) {
    return index < visibleStartIndex || visibleLastIndex < index;
  };

  var isMoreDot = function isMoreDot(index) {
    if (isLeftEnd) {
      return index === visibleLastIndex;
    } else if (isRightEnd) {
      return index === visibleStartIndex;
    }

    return index === visibleStartIndex || index === visibleLastIndex;
  };

  React.useEffect(function () {
    if (isLeftEnd) {
      setVisibleStartIndex(0);
    } else if (isRightEnd) {
      setVisibleStartIndex(maxPage - getVisibleCount());
    } else {
      setVisibleStartIndex(currentIndex - Math.floor(getVisibleCount() / 2));
    }
  }, [currentIndex, getVisibleCount, isLeftEnd, isRightEnd, maxPage]);
  React.useEffect(function () {
    setCurrentIndex(currentPage - 1);
  }, [currentPage]);
  if (maxPage <= 1) return null;
  return react.jsx("ul", {
    css: _ref2$3,
    className: className
  }, Array(maxPage).fill(0).map(function (_, index) {
    return react.jsx("li", {
      key: "dot-".concat(index),
      css: _ref$7
    }, react.jsx("button", {
      type: "button",
      "aria-label": "".concat(index + 1, " \uD398\uC774\uC9C0"),
      "aria-current": isCurrentDot(index) ? 'true' : undefined,
      onClick: function onClick() {
        setCurrentIndex(index);
        _onClick === null || _onClick === void 0 ? void 0 : _onClick(index);
      },
      css: [/*#__PURE__*/react.css(RESET_BUTTON, " width:", pxToRem(6), ";height:", pxToRem(6), ";border-radius:50%;background-color:", hexToRgba(theme.content.base3, 0.7), ";transition:0.15s background-color,0.15s width,0.15s height;transform:translateY(-50%);box-sizing:border-box;margin:0 ", pxToRem(3), ";"), cssVariantDot(theme, variant), isMoreDot(index) && cssMoreDot(), isCurrentDot(index) && cssCurrentDot(theme, variant), isHiddenDot(index) && cssHiddenDot()]
    }));
  }));
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$8() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$6 =  true ? {
  name: "1aslf6p",
  styles: "position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)"
} : 0;

function MoreAnchor(_ref2) {
  var rest = _extends({}, _ref2);

  var theme = react.useTheme();
  return react.jsx("a", _extends({
    css: [/*#__PURE__*/react.css("color:", theme.content.base1, ";display:inline-block;font-weight:500;padding:", pxToRem(6), " ", pxToRem(16), ";&:hover{&>div:first-of-type{background-color:", theme.interactive.base4, ";}}")]
  }, rest), react.jsx("div", {
    css: /*#__PURE__*/react.css("width:", pxToRem(40), ";height:", pxToRem(40), ";border-radius:", pxToRem(20), ";background-color:", theme.content.base4, ";margin-bottom:", pxToRem(6), ";position:relative;")
  }, react.jsx(Icon, {
    name: "arrow_right",
    size: 18,
    css: _ref$6
  })), react.jsx("div", {
    css: FONT_STYLE.body2
  }, "\uB354\uBCF4\uAE30"));
}

var _templateObject$1;

var _excluded$9 = ["thumbnail", "size", "label", "hasHoverEffect", "hasBorder", "active", "children"];

function cssSize(size) {
  return /*#__PURE__*/react.css({
    72: /*#__PURE__*/react.css("border-radius:", pxToRem(24), ";"),
    100: /*#__PURE__*/react.css("border-radius:", pxToRem(32), ";")
  }[size], ";");
}

function cssLabel(size) {
  return /*#__PURE__*/react.css({
    72: FONT_STYLE.subTitle2,
    100: FONT_STYLE.subTitle1
  }[size], ";");
}

function ThumbnailAnchor(_ref) {
  var thumbnail = _ref.thumbnail,
      size = _ref.size,
      label = _ref.label,
      _ref$hasHoverEffect = _ref.hasHoverEffect,
      hasHoverEffect = _ref$hasHoverEffect === void 0 ? true : _ref$hasHoverEffect,
      _ref$hasBorder = _ref.hasBorder,
      hasBorder = _ref$hasBorder === void 0 ? true : _ref$hasBorder,
      active = _ref.active,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded$9);

  var theme = react.useTheme();
  return react.jsx("a", _extends({
    css: [/*#__PURE__*/react.css("display:flex;flex-direction:column;margin-top:", pxToRem(12), ";max-width:", pxToRem(size), ";"), hasHoverEffect && HOVER(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n          & > div:first-of-type:after {\n            border: ", " solid ", ";\n          }\n          & > div:first-of-type > figure {\n            transition: transform ease-in-out 0.2s;\n            transform: scale(1.05);\n          }\n        "])), pxToRem(2), theme.content.primary1.basic), active && /*#__PURE__*/react.css("&>div:first-of-type:after{border:", pxToRem(2), " solid ", theme.content.primary1.basic, ";}")]
  }, rest), react.jsx("div", {
    css: [/*#__PURE__*/react.css("overflow:hidden;position:relative;box-sizing:border-box;width:", pxToRem(size), ";height:", pxToRem(size), ";"), hasBorder && /*#__PURE__*/react.css("&:after{content:\"\";position:absolute;top:0;left:0;right:0;bottom:0;border-radius:inherit;border:", pxToRem(1), " solid ", theme.outline, ";}"), cssSize(size)]
  }, react.jsx(Image, {
    src: thumbnail,
    aspectRatio: "1:1",
    css: /*#__PURE__*/react.css("box-sizing:border-box;border-radius:inherit;width:", pxToRem(size), ";height:", pxToRem(size), ";")
  })), label && react.jsx("div", {
    css: [cssLabel(size), /*#__PURE__*/react.css("text-align:center;margin-top:", pxToRem(10), ";color:", theme.content.base1, ";overflow:hidden;word-break:break-all;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;")]
  }, label), children);
}

var _excluded$8 = ["badge"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$7() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref2$2 =  true ? {
  name: "t8gs49",
  styles: "top:0;right:0;position:absolute;display:flex;min-width:fit-content"
} : 0;

function cssBadgePosition() {
  var badgePosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'right';
  return /*#__PURE__*/react.css({
    center: /*#__PURE__*/react.css("top:", pxToRem(-12), ";left:50%;transform:translateX(-50%);position:absolute;display:flex;min-width:fit-content;"),
    right: _ref2$2
  }[badgePosition], ";");
}

var _ref$5 =  true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0;

function withBadge(Component, cssBadgeVariant) {
  return function (_ref3) {
    var rest = _extends({}, _ref3);

    var badge = rest.badge,
        props = _objectWithoutProperties(rest, _excluded$8);

    return react.jsx(Component, _extends({}, props, {
      css: _ref$5
    }), badge.component === 'SquareBadge' && react.jsx(SquareBadge, _extends({
      size: 24
    }, badge, {
      css: [cssBadgePosition(badge.position), cssBadgeVariant(rest)]
    }), badge.label), badge.component === 'PillBadge' && react.jsx(PillBadge, _extends({
      size: 24
    }, badge, {
      css: [cssBadgePosition(badge.position), cssBadgeVariant(rest)]
    }), badge.label));
  };
}

function cssBadgeVariant(size) {
  var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'right';
  return /*#__PURE__*/react.css({
    center: /*#__PURE__*/react.css(),
    right: /*#__PURE__*/react.css({
      72: /*#__PURE__*/react.css("top:", pxToRem(-8), ";right:", pxToRem(-8), ";"),
      100: /*#__PURE__*/react.css("top:", pxToRem(-6), ";right:", pxToRem(-6), ";")
    }[size], ";")
  }[position], ";");
}

var ThumbnailAnchorWithBadge = withBadge(ThumbnailAnchor, function (_ref) {
  var size = _ref.size,
      badge = _ref.badge;
  return cssBadgeVariant(size, badge.position);
});

var DEFAULT_AUTO_PLAY_INTERVAL = 3000;

/**
 * 현재 캐러셀에서 가능한 currentOffset의 범위를 계산합니다.
 * @return [가능한 currentOffset의 최솟값, 가능한 currentOffset의 최댓값]
 */
var getCurrentOffsetBounds = function getCurrentOffsetBounds(_ref) {
  var align = _ref.align,
      _ref$itemRatio = _ref.itemRatio,
      itemRatio = _ref$itemRatio === void 0 ? 1 : _ref$itemRatio,
      _ref$edgeSpaceRatio = _ref.edgeSpaceRatio,
      edgeSpaceRatio = _ref$edgeSpaceRatio === void 0 ? 0 : _ref$edgeSpaceRatio,
      childrenLength = _ref.childrenLength;
  var visibleChildrenCount = 1 / itemRatio;

  switch (align) {
    case 'centerConstrained':
      {
        var left = (visibleChildrenCount - 1) / 2;
        return [left - edgeSpaceRatio, Math.max(0, childrenLength - visibleChildrenCount) + left + edgeSpaceRatio];
      }

    case 'left':
      return [0, Math.max(0, childrenLength - visibleChildrenCount)];

    case 'center':
      return [0, Math.max(0, childrenLength - 1)];

    default:
      return [0, 0];
  }
};

function useOffset(_ref) {
  var loop = _ref.loop,
      childrenLength = _ref.childrenLength,
      align = _ref.align,
      _ref$itemRatio = _ref.itemRatio,
      itemRatio = _ref$itemRatio === void 0 ? 1 : _ref$itemRatio,
      _ref$edgeSpaceRatio = _ref.edgeSpaceRatio,
      edgeSpaceRatio = _ref$edgeSpaceRatio === void 0 ? 0 : _ref$edgeSpaceRatio;

  var _useMemo = React.useMemo(function () {
    return getCurrentOffsetBounds({
      align: align,
      itemRatio: itemRatio,
      edgeSpaceRatio: edgeSpaceRatio,
      childrenLength: childrenLength
    });
  }, [align, edgeSpaceRatio, itemRatio, childrenLength]),
      _useMemo2 = _slicedToArray(_useMemo, 2),
      minCurrentOffset = _useMemo2[0],
      maxCurrentOffset = _useMemo2[1];

  var getLimitOffset = React.useCallback(function (offset) {
    if (!loop) {
      return Math.min(maxCurrentOffset, Math.max(minCurrentOffset, offset));
    }

    return offset;
  }, [loop, minCurrentOffset, maxCurrentOffset]);
  var getLimitOffsetData = React.useCallback(function (prevOffset, newOffset) {
    var fromOffset = getLimitOffset(prevOffset);
    var toOffset = typeof newOffset === 'number' ? getLimitOffset(newOffset) : null;
    return {
      currentOffset: fromOffset,
      fromOffset: fromOffset,
      toOffset: toOffset
    };
  }, [getLimitOffset]);

  var getMinMaxOffset = function getMinMaxOffset(offsetData) {
    var currentOffset = offsetData.currentOffset,
        fromOffset = offsetData.fromOffset,
        toOffset = offsetData.toOffset;
    var offset = currentOffset;
    var newToOffset = toOffset;

    if (!loop) {
      offset = Math.min(maxCurrentOffset, Math.max(minCurrentOffset, offset));

      if (newToOffset !== null) {
        newToOffset = Math.min(maxCurrentOffset, Math.max(minCurrentOffset, newToOffset));
      }
    }

    var minOffset = offset;
    var maxOffset = offset;

    if (newToOffset !== null && fromOffset !== null) {
      minOffset = Math.min(offset, fromOffset, newToOffset);
      maxOffset = Math.max(offset, fromOffset, newToOffset);
    }

    return [minOffset, maxOffset];
  };

  var offsetMargin = React.useMemo(function () {
    if (['center', 'centerConstrained'].includes(align)) {
      return (1 - itemRatio) / (2 * itemRatio);
    }

    return 0;
  }, [align, itemRatio]);
  return {
    getLimitOffset: getLimitOffset,
    getLimitOffsetData: getLimitOffsetData,
    getMinMaxOffset: getMinMaxOffset,
    offsetMargin: offsetMargin
  };
}

var Hammer = typeof window !== 'undefined' ? __webpack_require__(50840) : undefined;
function useHammer(_ref) {
  var align = _ref.align,
      _ref$itemRatio = _ref.itemRatio,
      itemRatio = _ref$itemRatio === void 0 ? 1 : _ref$itemRatio,
      _ref$edgeSpaceRatio = _ref.edgeSpaceRatio,
      edgeSpaceRatio = _ref$edgeSpaceRatio === void 0 ? 0 : _ref$edgeSpaceRatio,
      loop = _ref.loop,
      disableSwipe = _ref.disableSwipe,
      childrenLength = _ref.childrenLength,
      setOffsetData = _ref.setOffsetData,
      onDrag = _ref.onDrag,
      onEnd = _ref.onEnd;
  var hammerRef = React.useRef(null);
  var hammerManager = React.useRef();
  var lastVelocityX = React.useRef(0);
  var baseProps = {
    align: align,
    loop: loop,
    itemRatio: itemRatio,
    edgeSpaceRatio: edgeSpaceRatio,
    childrenLength: childrenLength
  };

  var _getCurrentOffsetBoun = getCurrentOffsetBounds(baseProps),
      _getCurrentOffsetBoun2 = _slicedToArray(_getCurrentOffsetBoun, 2),
      minCurrentOffset = _getCurrentOffsetBoun2[0],
      maxCurrentOffset = _getCurrentOffsetBoun2[1];

  var _useOffset = useOffset(baseProps),
      getLimitOffsetData = _useOffset.getLimitOffsetData;

  var handlePan = React.useCallback(function (event) {
    onDrag === null || onDrag === void 0 ? void 0 : onDrag(event);
    setOffsetData(function (_ref2) {
      var _hammerRef$current$ge, _hammerRef$current;

      var fromOffset = _ref2.fromOffset,
          currentOffset = _ref2.currentOffset;

      if (fromOffset === null) {
        return {
          currentOffset: currentOffset,
          fromOffset: fromOffset,
          toOffset: null
        };
      }

      var _ref3 = (_hammerRef$current$ge = (_hammerRef$current = hammerRef.current) === null || _hammerRef$current === void 0 ? void 0 : _hammerRef$current.getBoundingClientRect()) !== null && _hammerRef$current$ge !== void 0 ? _hammerRef$current$ge : {},
          _ref3$width = _ref3.width,
          width = _ref3$width === void 0 ? 0 : _ref3$width;

      var deltaX = event.deltaX,
          velocityX = event.velocityX;
      var newOffset = fromOffset - deltaX / width / itemRatio;
      lastVelocityX.current = velocityX;
      return {
        currentOffset: newOffset,
        fromOffset: fromOffset,
        toOffset: null
      };
    });
  }, [itemRatio, onDrag, setOffsetData]);
  var handlePanEnd = React.useCallback(function (event) {
    onEnd === null || onEnd === void 0 ? void 0 : onEnd(event);
    setOffsetData(function (_ref4) {
      var fromOffset = _ref4.fromOffset,
          currentOffset = _ref4.currentOffset;

      if (fromOffset === null) {
        return {
          currentOffset: currentOffset,
          fromOffset: fromOffset,
          toOffset: null
        };
      }

      var deltaX = event.deltaX,
          overallVelocityX = event.overallVelocityX;
      var newOffset = Math.round(currentOffset);
      var direction = deltaX < 0 ? 'right' : 'left';

      if (Math.abs(lastVelocityX.current) > 0.5 || Math.abs(overallVelocityX) > 0.5) {
        newOffset = direction === 'left' ? Math.floor(currentOffset) : Math.ceil(currentOffset);
      }

      var offsetDelta;

      if (!loop) {
        if (currentOffset < minCurrentOffset) {
          offsetDelta = -Math.log(-currentOffset + minCurrentOffset + 1) / Math.log(8);
        } else if (currentOffset > maxCurrentOffset) {
          offsetDelta = Math.log(currentOffset - maxCurrentOffset + 1) / Math.log(8);
        }
      }

      lastVelocityX.current = 0;
      return getLimitOffsetData(currentOffset, newOffset, offsetDelta);
    });
  }, [getLimitOffsetData, loop, maxCurrentOffset, minCurrentOffset, onEnd, setOffsetData]);
  var handleHammer = React.useCallback(function (event) {
    var isScrolling = Math.abs(event.deltaY) > Math.abs(event.deltaX);

    if (isScrolling) {
      event.preventDefault();
      handlePanEnd(event);
      return;
    }

    switch (event.type) {
      case 'panstart':
        setOffsetData(function (_ref5) {
          var currentOffset = _ref5.currentOffset;
          return getLimitOffsetData(currentOffset, null);
        });
        break;

      case 'panmove':
        handlePan(event);
        break;

      case 'panend':
      case 'pancancel':
        handlePanEnd(event);
        break;
    }
  }, [getLimitOffsetData, handlePan, handlePanEnd, setOffsetData]);
  React.useEffect(function () {
    if (disableSwipe) return;

    if (hammerRef !== null && hammerRef !== void 0 && hammerRef.current) {
      hammerManager.current = new Hammer(hammerRef.current);
    }

    return function () {
      var _hammerManager$curren;

      (_hammerManager$curren = hammerManager.current) === null || _hammerManager$curren === void 0 ? void 0 : _hammerManager$curren.destroy();
      lastVelocityX.current = 0;
    };
  }, [disableSwipe]);
  React.useEffect(function () {
    var _hammerManager$curren2, _hammerManager$curren3;

    (_hammerManager$curren2 = hammerManager.current) === null || _hammerManager$curren2 === void 0 ? void 0 : _hammerManager$curren2.set({
      touchAction: 'pan-y'
    });
    (_hammerManager$curren3 = hammerManager.current) === null || _hammerManager$curren3 === void 0 ? void 0 : _hammerManager$curren3.on('panstart panmove panend pancancel', handleHammer);
    return function () {
      var _hammerManager$curren4;

      (_hammerManager$curren4 = hammerManager.current) === null || _hammerManager$curren4 === void 0 ? void 0 : _hammerManager$curren4.off('panstart panmove panend pancancel', handleHammer);
    };
  }, [handleHammer]);
  return {
    hammerRef: hammerRef
  };
}

function useAutoPlay(_ref) {
  var offset = _ref.offset,
      autoPlay = _ref.autoPlay,
      autoPlayInterval = _ref.autoPlayInterval,
      move = _ref.move;

  var _useState = React.useState(autoPlay),
      _useState2 = _slicedToArray(_useState, 2),
      isAutoPlay = _useState2[0],
      setIsAutoPlay = _useState2[1];

  var autoPlayRef = React.useRef(null);
  var cleanupAutoPlay = React.useCallback(function () {
    setIsAutoPlay(false);

    if (autoPlayRef.current) {
      window.clearInterval(autoPlayRef.current);
      autoPlayRef.current = null;
    }
  }, []);
  var setupAutoPlay = React.useCallback(function () {
    setIsAutoPlay(true);

    if (!autoPlayRef.current) {
      autoPlayRef.current = window.setInterval(function () {
        return move('right');
      }, autoPlayInterval);
    }
  }, [autoPlayInterval, move]);
  React.useEffect(function () {
    if (autoPlay) {
      setupAutoPlay();
    }

    return function () {
      return cleanupAutoPlay();
    };
  }, [offset, autoPlay, cleanupAutoPlay, setupAutoPlay]);
  return {
    isAutoPlay: isAutoPlay,
    cleanupAutoPlay: cleanupAutoPlay,
    setupAutoPlay: setupAutoPlay
  };
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$6() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function Carousel(props) {
  var _props$itemRatio = props.itemRatio,
      initialItemRatio = _props$itemRatio === void 0 ? 1 : _props$itemRatio,
      _props$edgeSpaceRatio = props.edgeSpaceRatio,
      edgeSpaceRatio = _props$edgeSpaceRatio === void 0 ? 0 : _props$edgeSpaceRatio,
      _props$duration = props.duration,
      initialDuration = _props$duration === void 0 ? 350 : _props$duration,
      _props$loop = props.loop,
      loop = _props$loop === void 0 ? false : _props$loop,
      _props$autoPlay = props.autoPlay,
      autoPlay = _props$autoPlay === void 0 ? false : _props$autoPlay,
      _props$autoPlayInterv = props.autoPlayInterval,
      autoPlayInterval = _props$autoPlayInterv === void 0 ? DEFAULT_AUTO_PLAY_INTERVAL : _props$autoPlayInterv,
      _props$align = props.align,
      align = _props$align === void 0 ? 'center' : _props$align,
      children = props.children,
      renderControl = props.renderControl,
      renderPagination = props.renderPagination,
      className = props.className,
      initialOffset = props.initialOffset,
      onOffsetChange = props.onOffsetChange,
      _props$disableSwipe = props.disableSwipe,
      disableSwipe = _props$disableSwipe === void 0 ? false : _props$disableSwipe,
      renderEdgeDecoration = props.renderEdgeDecoration,
      nodeRef = props.nodeRef,
      length = props.length,
      _props$preloadCount = props.preloadCount,
      preloadCount = _props$preloadCount === void 0 ? 0 : _props$preloadCount,
      onRowsRendered = props.onRowsRendered;

  var _useState = React.useState({
    // 현재 offset
    currentOffset: initialOffset !== null && initialOffset !== void 0 ? initialOffset : 0,
    // duration 시작 전 offset
    fromOffset: null,
    // duration 끝나고 최종적으로 변경될 offset
    toOffset: null
  }),
      _useState2 = _slicedToArray(_useState, 2),
      offsetData = _useState2[0],
      setOffsetData = _useState2[1];

  var _useState3 = React.useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      progressOffset = _useState4[0],
      setProgressOffset = _useState4[1];

  var _useState5 = React.useState(initialDuration),
      _useState6 = _slicedToArray(_useState5, 2),
      duration = _useState6[0],
      setDuration = _useState6[1];

  var currentOffset = offsetData.currentOffset,
      fromOffset = offsetData.fromOffset,
      toOffset = offsetData.toOffset;
  var childrenList = React__default['default'].Children.toArray(children);

  if (!loop && renderEdgeDecoration) {
    childrenList = [renderEdgeDecoration(0)].concat(_toConsumableArray(childrenList), [renderEdgeDecoration(childrenList.length + 1)]);
  }

  var childrenLength = length !== null && length !== void 0 ? length : childrenList.length;
  var itemRatio = initialItemRatio === 0 ? 1 : Math.min(initialItemRatio, 1);
  var visibleChildrenCount = 1 / itemRatio;
  var baseProps = {
    align: align,
    loop: loop,
    itemRatio: itemRatio,
    edgeSpaceRatio: edgeSpaceRatio,
    childrenLength: childrenLength
  };

  var _getCurrentOffsetBoun = getCurrentOffsetBounds(baseProps),
      _getCurrentOffsetBoun2 = _slicedToArray(_getCurrentOffsetBoun, 2),
      minCurrentOffset = _getCurrentOffsetBoun2[0],
      maxCurrentOffset = _getCurrentOffsetBoun2[1];

  var _useOffset = useOffset(baseProps),
      getLimitOffset = _useOffset.getLimitOffset,
      getLimitOffsetData = _useOffset.getLimitOffsetData,
      getMinMaxOffset = _useOffset.getMinMaxOffset,
      offsetMargin = _useOffset.offsetMargin;

  var centerOffset = loop ? (Math.round(currentOffset) % childrenLength + childrenLength) % childrenLength : Math.round(currentOffset);
  var move = React.useCallback(function (direction) {
    var delta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    setDuration(null);
    setOffsetData(function (_ref) {
      var currentOffset = _ref.currentOffset;
      var deltaOffset = Math.abs(delta) * (direction === 'right' ? 1 : -1);
      var newOffset = Math.round(currentOffset + deltaOffset);
      return getLimitOffsetData(currentOffset, newOffset);
    });
  }, [getLimitOffsetData]);

  var _useAutoPlay = useAutoPlay({
    offset: centerOffset,
    autoPlay: autoPlay,
    autoPlayInterval: autoPlayInterval,
    move: move
  }),
      isAutoPlay = _useAutoPlay.isAutoPlay,
      cleanupAutoPlay = _useAutoPlay.cleanupAutoPlay,
      setupAutoPlay = _useAutoPlay.setupAutoPlay;

  var isDragging = React.useRef(false);
  var handleDrag = React.useCallback(function () {
    isDragging.current = true;
    setDuration(null);

    if (isAutoPlay) {
      cleanupAutoPlay();
    }
  }, [cleanupAutoPlay, isAutoPlay]);
  var handleDragEnd = React.useCallback(function () {
    if (autoPlay) {
      setupAutoPlay();
    }

    setTimeout(function () {
      isDragging.current = false;
    });
  }, [autoPlay, setupAutoPlay]);

  var _useHammer = useHammer(_objectSpread2(_objectSpread2({}, baseProps), {}, {
    disableSwipe: disableSwipe,
    setOffsetData: setOffsetData,
    onDrag: handleDrag,
    onEnd: handleDragEnd
  })),
      hammerRef = _useHammer.hammerRef;

  var _getMinMaxOffset = getMinMaxOffset(offsetData),
      _getMinMaxOffset2 = _slicedToArray(_getMinMaxOffset, 2),
      minOffset = _getMinMaxOffset2[0],
      maxOffset = _getMinMaxOffset2[1];

  var baseOffset = minOffset - offsetMargin - preloadCount;
  var startIndex = Math.floor(baseOffset);
  var renderedItemCount = React.useMemo(function () {
    return Math.ceil(baseOffset + visibleChildrenCount + (maxOffset - minOffset) + 2 * preloadCount) - startIndex;
  }, [baseOffset, maxOffset, minOffset, startIndex, preloadCount, visibleChildrenCount]);
  var isOverflow = React.useCallback(function (offset) {
    return !loop && (offset < 0 || offset > childrenLength - 1);
  }, [childrenLength, loop]);
  var virtualChildren = React.useMemo(function () {
    if (onRowsRendered) {
      onRowsRendered(startIndex, startIndex + renderedItemCount - 1);
    }

    return Array.from({
      length: Math.ceil(renderedItemCount)
    }).map(function (_, renderedIndex) {
      var actualIndex = startIndex + renderedIndex;
      var index = (startIndex % childrenLength + childrenLength + renderedIndex) % childrenLength;
      return react.jsx(CarouselListItem, {
        key: index,
        css: /*#__PURE__*/react.css("width:", itemRatio * 100, "%;"),
        role: "group",
        "aria-roledescription": "slide",
        "aria-label": "".concat(index, " of ").concat(childrenLength),
        onClickCapture: function onClickCapture(e) {
          if (isDragging.current) {
            e.preventDefault();
            e.stopPropagation();
          }
        }
      }, !isOverflow(actualIndex) && childrenList[index]);
    });
  }, [renderedItemCount, startIndex, childrenLength, childrenList, itemRatio, isOverflow, onRowsRendered]);

  var set = function set(targetOffset) {
    var deltaOffset = currentOffset - targetOffset;
    var direction = deltaOffset <= 0 ? 'right' : 'left';
    move(direction, deltaOffset);
  };

  var getProgress = React.useCallback(function () {
    var offset = loop ? currentOffset : Math.min(maxCurrentOffset, Math.max(minCurrentOffset, currentOffset));
    var baseOffset = minOffset - offsetMargin;
    var progressOffset = (baseOffset - startIndex + (offset - minOffset)) * itemRatio;
    return progressOffset;
  }, [itemRatio, currentOffset, loop, minOffset, minCurrentOffset, maxCurrentOffset, offsetMargin, startIndex]);

  var handleTransitionEnd = function handleTransitionEnd() {
    if (onOffsetChange) {
      onOffsetChange(currentOffset);
    }

    setOffsetData(function (_ref2) {
      var currentOffset = _ref2.currentOffset;
      return {
        currentOffset: currentOffset,
        fromOffset: null,
        toOffset: null
      };
    });
    setDuration(null);
  };

  React.useEffect(function () {
    if (loop) {
      return;
    }

    setOffsetData(function (_ref3) {
      var currentOffset = _ref3.currentOffset,
          toOffset = _ref3.toOffset;
      return getLimitOffsetData(currentOffset, toOffset);
    });
  }, [align, getLimitOffsetData, loop]);
  React.useEffect(function () {
    var animationId = requestAnimationFrame(function () {
      if (toOffset === null) {
        return;
      }

      setDuration(initialDuration);
      setOffsetData(function (_ref4) {
        var toOffset = _ref4.toOffset,
            currentOffset = _ref4.currentOffset;
        return {
          currentOffset: toOffset !== null && toOffset !== void 0 ? toOffset : currentOffset,
          fromOffset: fromOffset,
          toOffset: toOffset
        };
      });
    });
    return function () {
      return cancelAnimationFrame(animationId);
    };
  }, [toOffset, currentOffset, fromOffset, initialDuration]);
  React.useLayoutEffect(function () {
    var progress = getProgress();
    setProgressOffset(progress);
  }, [currentOffset, toOffset, getProgress]);
  var controlProps = {
    prev: function prev() {
      return move('left');
    },
    next: function next() {
      return move('right');
    },
    set: set,
    offset: getLimitOffset(centerOffset),
    length: childrenLength,
    isLeftEnd: !loop && getLimitOffset(fromOffset !== null && fromOffset !== void 0 ? fromOffset : currentOffset) === minCurrentOffset,
    isRightEnd: !loop && getLimitOffset(fromOffset !== null && fromOffset !== void 0 ? fromOffset : currentOffset) === maxCurrentOffset
  };
  var paginationProps = {
    currentPage: Math.floor(currentOffset) % childrenLength + 1,
    maxPage: childrenLength,
    onClick: function onClick(index) {
      return set(index);
    }
  };
  return react.jsx(Container$2, {
    role: "region",
    "aria-roledescription": "carousel",
    className: className,
    ref: function ref(node) {
      if (nodeRef) {
        nodeRef(node);
      }
    }
  }, react.jsx(CarouselListWrapper, {
    ref: hammerRef
  }, react.jsx(CarouselList, {
    style: {
      transform: "translateX(".concat(progressOffset * -100, "%)"),
      transition: "".concat(duration ? "transform ".concat(duration, "ms") : '')
    },
    onTransitionEnd: handleTransitionEnd,
    "aria-live": autoPlay ? 'off' : 'polite'
  }, virtualChildren)), renderControl && renderControl(controlProps), renderPagination && react.jsx(Pagination, {
    css: renderPagination(paginationProps).props.variant === 'onDimmed' ? {
      top: "".concat(pxToRem(-18))
    } : undefined
  }, renderPagination(paginationProps)));
}

var Container$2 = _styled__default['default']("div", {
  target: "e1tym1gd4"
})( true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0);

var CarouselListWrapper = _styled__default['default']("div", {
  target: "e1tym1gd3"
})( true ? {
  name: "d3v9zr",
  styles: "overflow:hidden"
} : 0);

var CarouselList = _styled__default['default']("ul", {
  target: "e1tym1gd2"
})( true ? {
  name: "154jlx0",
  styles: "display:flex;flex-wrap:nowrap;align-items:stretch;min-height:100%;padding:0;margin:0"
} : 0);

var CarouselListItem = _styled__default['default']("li", {
  target: "e1tym1gd1"
})( true ? {
  name: "1dadcqx",
  styles: "flex:0 0 auto;-moz-user-select:-moz-none;-webkit-user-select:none;-ms-user-select:none;user-select:none;box-sizing:border-box;padding:0;margin:0;*{-webkit-user-drag:none;-khtml-user-drag:none;-moz-user-drag:none;-o-user-drag:none;user-drag:none;}"
} : 0);

var Pagination = _styled__default['default']("div", {
  target: "e1tym1gd0"
})("position:relative;top:", pxToRem(18), ";");

var _excluded$7 = ["size", "icon"];
function IconButton(_ref) {
  var _icon$size;

  var size = _ref.size,
      icon = _ref.icon,
      rest = _objectWithoutProperties(_ref, _excluded$7);

  return react.jsx(Button$1, _extends({}, rest, {
    size: size,
    css: cssBaseIconButton(size)
  }), react.jsx(Icon, {
    size: (_icon$size = icon.size) !== null && _icon$size !== void 0 ? _icon$size : 18,
    name: icon.name,
    fill: icon === null || icon === void 0 ? void 0 : icon.fill
  }));
}

var _excluded$6 = ["iconName", "position", "hidden", "variant", "className"];

var _templateObject, _templateObject2, _templateObject3;

function _EMOTION_STRINGIFIED_CSS_ERROR__$5() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

function cssButton(theme, variant) {
  switch (variant) {
    case 'basic':
      return /*#__PURE__*/react.css("border-radius:", pxToRem(24), ";background-color:", theme.content.base6, ";box-shadow:0 ", pxToRem(2), " ", pxToRem(5), " ", theme.shadow.basic, ";");

    case 'onContents':
      return /*#__PURE__*/react.css("border-radius:", pxToRem(24), ";background-color:", theme.dim.thin, ";");

    case 'list':
      return /*#__PURE__*/react.css("background-color:", theme.content.base6, ";border:", pxToRem(1), " solid ", theme.content.base4, ";border-radius:0;");
  }
}

function cssHoverButton(theme, variant) {
  switch (variant) {
    case 'basic':
      return HOVER(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n          background-color: ", ";\n      "])), theme.interactive.transparent);

    case 'onContents':
      return HOVER(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "])), theme.dim.basic);

    case 'list':
      return HOVER(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "])), theme.interactive.transparent);
  }
}

function cssFont(theme, variant) {
  switch (variant) {
    case 'basic':
      return theme.content.base1;

    case 'onContents':
      return theme.content.white;

    case 'list':
      return theme.content.base1;
  }
}

var _ref$4 =  true ? {
  name: "eivff4",
  styles: "display:none"
} : 0;

function CarouselControlButton(_ref2) {
  var iconName = _ref2.iconName,
      position = _ref2.position,
      _ref2$hidden = _ref2.hidden,
      hidden = _ref2$hidden === void 0 ? false : _ref2$hidden,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? 'basic' : _ref2$variant,
      className = _ref2.className,
      rest = _objectWithoutProperties(_ref2, _excluded$6);

  var theme = react.useTheme();
  return react.jsx("div", {
    css: [/*#__PURE__*/react.css("position:absolute;top:50%;transform:translate(-50%, -50%);left:", position === 'left' ? '0' : '100', "%;"), hidden && _ref$4],
    className: className
  }, react.jsx(IconButton, _extends({
    type: "button",
    size: 50,
    variant: "primary1",
    icon: {
      name: iconName,
      size: 24,
      fill: function fill(theme) {
        return cssFont(theme, variant);
      }
    },
    css: [/*#__PURE__*/react.css("width:", pxToRem(48), ";height:", pxToRem(48), ";display:flex;align-items:center;justify-content:center;"), cssButton(theme, variant), cssHoverButton(theme, variant)]
  }, rest)));
}

function CarouselControl(_ref) {
  var prev = _ref.prev,
      next = _ref.next,
      variant = _ref.variant,
      _ref$isLeftEnd = _ref.isLeftEnd,
      isLeftEnd = _ref$isLeftEnd === void 0 ? false : _ref$isLeftEnd,
      _ref$isRightEnd = _ref.isRightEnd,
      isRightEnd = _ref$isRightEnd === void 0 ? false : _ref$isRightEnd;
  return react.jsx(React__default['default'].Fragment, null, react.jsx(CarouselControlButton, {
    iconName: "chevron_left",
    position: "left",
    onClick: function onClick() {
      return prev();
    },
    "aria-label": "\uC774\uC804",
    variant: variant,
    hidden: isLeftEnd
  }), react.jsx(CarouselControlButton, {
    iconName: "chevron_right",
    position: "right",
    onClick: function onClick() {
      return next();
    },
    "aria-label": "\uB2E4\uC74C",
    variant: variant,
    hidden: isRightEnd
  }));
}

var _excluded$5 = ["contentRef", "children", "gradation", "gap", "fixed", "variant", "hiddenBreakpoints", "className", "contentClassName", "itemClassName", "buttonClassName"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$4() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$3 =  true ? {
  name: "1doeymb",
  styles: "@media(hover: hover){&:hover{z-index:1;}}"
} : 0;

var _ref2$1 =  true ? {
  name: "w8k1h1",
  styles: "scroll-snap-type:x mandatory;overflow:auto;-ms-overflow-style:none;scrollbar-width:none;&::-webkit-scrollbar{display:none;}"
} : 0;

var _ref3$1 =  true ? {
  name: "1442dl5",
  styles: "display:flex;margin:0;padding:0;overflow:hidden;&>li:last-of-type{margin-right:0;}"
} : 0;

var _ref4 =  true ? {
  name: "3q4ecs",
  styles: "position:relative;z-index:0"
} : 0;

var _ref5 =  true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0;

var CarouselScrollControl = React__default['default'].forwardRef(function (_ref6, ref) {
  var contentRef = _ref6.contentRef,
      children = _ref6.children,
      _ref6$gradation = _ref6.gradation,
      gradation = _ref6$gradation === void 0 ? true : _ref6$gradation,
      _ref6$gap = _ref6.gap,
      gap = _ref6$gap === void 0 ? 8 : _ref6$gap,
      _ref6$fixed = _ref6.fixed,
      fixed = _ref6$fixed === void 0 ? false : _ref6$fixed,
      _ref6$variant = _ref6.variant,
      variant = _ref6$variant === void 0 ? 'basic' : _ref6$variant,
      _ref6$hiddenBreakpoin = _ref6.hiddenBreakpoints,
      hiddenBreakpoints = _ref6$hiddenBreakpoin === void 0 ? ['mobile', 'tablet'] : _ref6$hiddenBreakpoin,
      className = _ref6.className,
      contentClassName = _ref6.contentClassName,
      itemClassName = _ref6.itemClassName,
      buttonClassName = _ref6.buttonClassName,
      rest = _objectWithoutProperties(_ref6, _excluded$5);

  var _useState = React.useState({
    startIdx: 0,
    endIdx: 0
  }),
      _useState2 = _slicedToArray(_useState, 2),
      fullVisibleItem = _useState2[0],
      setFullVisibleItem = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      hovered = _useState4[0],
      setHovered = _useState4[1];

  var animateRef = React.useRef(null);
  var carouselRef = React.useRef(null);
  var carouselItemRefs = React.useRef([]);
  var breakpoint = useResponsive().breakpoint;
  var isHidden = !!hiddenBreakpoints.find(function (hiddenBreakpoint) {
    return hiddenBreakpoint === breakpoint;
  });
  var theme = react.useTheme();
  var childrenCount = React__default['default'].Children.count(children);
  var updatePosition = React.useCallback(function () {
    var _startItemIdx, _endItemIdx;

    var carousel = carouselRef.current;
    if (!carousel) return;
    var carouselRect = carousel.getBoundingClientRect();
    var carouselStartX = carouselRect.left;
    var carouselEndX = carouselStartX + carouselRect.width;
    var startItemIdx;
    var endItemIdx;

    for (var i = 0; i < childrenCount; i += 1) {
      var item = carouselItemRefs.current[i];
      var itemRect = (item === null || item === void 0 ? void 0 : item.getBoundingClientRect()) || {
        left: 0,
        width: 0
      };
      var itemStartX = itemRect.left;
      var itemEndX = itemStartX + itemRect.width;
      var isFullVisibleItem = item && Math.floor(carouselStartX) <= Math.floor(itemStartX) && Math.floor(itemEndX) <= Math.floor(carouselEndX);

      if (isFullVisibleItem) {
        if (startItemIdx === undefined) {
          startItemIdx = i;
        }

        endItemIdx = i;
      }
    }

    setFullVisibleItem({
      startIdx: (_startItemIdx = startItemIdx) !== null && _startItemIdx !== void 0 ? _startItemIdx : 0,
      endIdx: (_endItemIdx = endItemIdx) !== null && _endItemIdx !== void 0 ? _endItemIdx : 0
    });
  }, [setFullVisibleItem, childrenCount]);
  var scrollToOffset = React.useCallback(function (targetOffset) {
    if (animateRef.current) {
      cancelAnimationFrame(animateRef.current);
    }

    var startTime = Date.now();
    var carousel = carouselRef.current;
    if (!carousel) return;
    var currentCarouselStartX = carousel.scrollLeft;
    var lastCarouselStartX = carousel.scrollWidth - carousel.offsetWidth;
    var nextCarouselStartX = Math.max(0, Math.min(lastCarouselStartX, targetOffset));

    var handleScroll = function handleScroll() {
      var elapsed = Date.now() - startTime;
      var progress = Math.min(elapsed / 350, 1);
      var carousel = carouselRef.current;

      if (carousel) {
        carousel.scrollLeft = currentCarouselStartX + (nextCarouselStartX - currentCarouselStartX) * eases.quadInOut(progress);
      }

      if (progress < 1) {
        animateRef.current = requestAnimationFrame(handleScroll);
      }
    };

    animateRef.current = requestAnimationFrame(handleScroll);
  }, []);
  var moveRight = React.useCallback(function (basis) {
    var startItemIdx = basis !== null && basis !== void 0 ? basis : fullVisibleItem.endIdx + 1;
    if (startItemIdx >= childrenCount) return;
    if (!carouselRef.current) return;
    var startItem = carouselItemRefs.current[startItemIdx];
    if (!startItem) return;
    var carouselWidth = carouselRef.current.offsetWidth;
    var endItemIdx = startItemIdx;
    var endItemOffsetRight = 0;

    while (endItemIdx < childrenCount) {
      var _item$offsetLeft, _item$offsetWidth;

      var item = carouselItemRefs.current[endItemIdx];
      var itemOffsetRight = ((_item$offsetLeft = item === null || item === void 0 ? void 0 : item.offsetLeft) !== null && _item$offsetLeft !== void 0 ? _item$offsetLeft : 0) + ((_item$offsetWidth = item === null || item === void 0 ? void 0 : item.offsetWidth) !== null && _item$offsetWidth !== void 0 ? _item$offsetWidth : 0);
      var carouselOffsetRight = startItem.offsetLeft + carouselWidth;
      var isNotFullVisibleItem = !item || carouselOffsetRight < itemOffsetRight;
      if (isNotFullVisibleItem || !item) break;
      endItemOffsetRight = (item === null || item === void 0 ? void 0 : item.offsetLeft) + (item === null || item === void 0 ? void 0 : item.offsetWidth);
      endItemIdx += 1;
    }

    endItemIdx -= 1;
    var carouselOffsetLeft = (startItem.offsetLeft + endItemOffsetRight) / 2 - carouselWidth / 2;
    scrollToOffset(carouselOffsetLeft);
    setFullVisibleItem({
      startIdx: startItemIdx,
      endIdx: endItemIdx
    });
  }, [fullVisibleItem, childrenCount, scrollToOffset]);
  var moveLeft = React.useCallback(function (basis) {
    var endItemIdx = basis !== null && basis !== void 0 ? basis : fullVisibleItem.startIdx - 1;
    if (endItemIdx < 0) return;
    if (!carouselRef.current) return;
    var endItem = carouselItemRefs.current[endItemIdx];
    if (!endItem) return;
    var endItemOffsetRight = endItem.offsetLeft + endItem.offsetWidth;
    var carouselWidth = carouselRef.current.offsetWidth;
    var startItemIdx = endItemIdx;
    var startItemOffsetLeft = 0;

    while (startItemIdx >= 0) {
      var item = carouselItemRefs.current[startItemIdx];

      var _carouselOffsetLeft = endItemOffsetRight - carouselWidth;

      var isNotFullVisibleItem = !item || item.offsetLeft < _carouselOffsetLeft;
      if (isNotFullVisibleItem || !item) break;
      startItemOffsetLeft = item.offsetLeft;
      startItemIdx -= 1;
    }

    startItemIdx += 1;
    var carouselOffsetLeft = (startItemOffsetLeft + endItemOffsetRight) / 2 - carouselWidth / 2;
    scrollToOffset(carouselOffsetLeft);
    setFullVisibleItem({
      startIdx: startItemIdx,
      endIdx: endItemIdx
    });
  }, [fullVisibleItem, scrollToOffset]);
  var scrollTo = React.useCallback(function (index) {
    if (index < fullVisibleItem.startIdx) {
      moveRight(index);
    } else if (index > fullVisibleItem.endIdx) {
      moveLeft(index);
    } else ;
  }, [fullVisibleItem, moveLeft, moveRight]);
  React.useImperativeHandle(ref, function () {
    return {
      scrollTo: scrollTo,
      moveLeft: moveLeft,
      moveRight: moveRight
    };
  });
  React.useEffect(function () {
    updatePosition();
    var resizeAnimationId = null;

    var handleResize = function handleResize() {
      if (resizeAnimationId) {
        cancelAnimationFrame(resizeAnimationId);
      }

      resizeAnimationId = requestAnimationFrame(function () {
        resizeAnimationId = null;
        updatePosition();
      });
    };

    var resizeObserver = null;
    var carousel = carouselRef.current;

    if (window.ResizeObserver && carousel) {
      resizeObserver = new ResizeObserver(handleResize);
      resizeObserver.observe(carousel);
    } else {
      window.addEventListener('resize', handleResize);
    }

    return function () {
      if (animateRef.current) {
        cancelAnimationFrame(animateRef.current);
      }

      if (resizeAnimationId) {
        cancelAnimationFrame(resizeAnimationId);
      }

      if (resizeObserver) {
        resizeObserver.disconnect();
      } else {
        window.removeEventListener('resize', handleResize);
      }
    };
  }, [updatePosition]);
  var isLeftEnd = fullVisibleItem.startIdx === 0;
  var isRightEnd = fullVisibleItem.endIdx === childrenCount - 1;
  return react.jsx("div", _extends({
    css: _ref5,
    onMouseEnter: function onMouseEnter() {
      return setHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHovered(false);
    },
    className: className
  }, rest), react.jsx("div", {
    css: _ref4
  }, react.jsx("ul", {
    onScroll: updatePosition,
    className: contentClassName,
    ref: function ref(node) {
      carouselRef.current = node;

      if (contentRef) {
        contentRef(node);
      }
    },
    css: [_ref3$1, isHidden && _ref2$1, !isRightEnd && gradation && /*#__PURE__*/react.css("&:after{content:'';position:absolute;top:0;right:-1px;width:100px;height:100%;background:", "linear-gradient(90deg, ".concat(hexToRgba(theme.background.base, 0), " 0%, ").concat(theme.background.base, " 100%)"), ";pointer-events:none;padding:0;margin:0;}")]
  }, React.Children.map(children, function (child, index) {
    return react.jsx("li", {
      className: itemClassName,
      css: /*#__PURE__*/react.css("margin:0 ", pxToRem(gap), " 0 0;padding:0;flex-shrink:0;scroll-snap-align:start;", MEDIA_QUERY.min('tablet', _ref$3), ";"),
      key: _typeof(child) === 'object' && child != null && 'key' in child ? child.key : undefined,
      ref: function ref(node) {
        carouselItemRefs.current[index] = node;
      }
    }, child);
  }))), (fixed || hovered) && react.jsx(React__default['default'].Fragment, null, react.jsx(CarouselControlButton, {
    iconName: "chevron_left",
    position: "left",
    onClick: function onClick() {
      return moveLeft();
    },
    "aria-label": "\uC774\uC804",
    hidden: isHidden || isLeftEnd,
    variant: variant,
    className: buttonClassName
  }), react.jsx(CarouselControlButton, {
    iconName: "chevron_right",
    position: "right",
    onClick: function onClick() {
      return moveRight();
    },
    "aria-label": "\uB2E4\uC74C",
    hidden: isHidden || isRightEnd,
    variant: variant,
    className: buttonClassName
  })));
});

var _excluded$4 = ["number", "variant"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$3() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$2 =  true ? {
  name: "tmxs11",
  styles: "position:relative;display:inline-block;font-size:0;line-height:1"
} : 0;

function Ranking(_ref2) {
  var number = _ref2.number,
      variant = _ref2.variant,
      props = _objectWithoutProperties(_ref2, _excluded$4);

  var theme = react.useTheme();
  return react.jsx("div", _extends({}, props, {
    css: _ref$2
  }), react.jsx("svg", {
    width: 26,
    height: 30,
    fill: "none"
  }, react.jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m13 24.25-13 5V0h26v29.25l-13-5Z",
    fill: function () {
      switch (variant) {
        case 'primary1':
          return hexToRgba(theme.content.primary1.basic, 0.86);

        case 'dim':
          return theme.dim.basic;

        default:
          return;
      }
    }()
  })), react.jsx("span", {
    css: /*#__PURE__*/react.css("position:absolute;top:", pxToRem(4), ";left:0;right:0;", FONT_STYLE.body3, ";font-weight:700;color:", theme.content.white, ";text-align:center;")
  }, number));
}

var _excluded$3 = ["component"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$2() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$1 =  true ? {
  name: "e0dnmk",
  styles: "cursor:pointer"
} : 0;

var _ref2 =  true ? {
  name: "ilqpfg",
  styles: "display:inline-flex;align-items:center;max-width:100%"
} : 0;

var _ref3 =  true ? {
  name: "dlv2hg",
  styles: "flex:1;display:flex;align-items:flex-start;flex-direction:column;min-width:0"
} : 0;

function SectionTitle(_ref4) {
  var className = _ref4.className,
      size = _ref4.size,
      title = _ref4.title,
      caption = _ref4.caption,
      badge = _ref4.badge,
      count = _ref4.count,
      moreButton = _ref4.moreButton,
      customButton = _ref4.customButton,
      hasArrow = _ref4.hasArrow,
      _onClick = _ref4.onClick;
  var theme = react.useTheme();
  var isMobile = useResponsive().breakpoint === 'mobile';

  var handleClickChild = function handleClickChild(e) {
    if (!_onClick) return;
    e.stopPropagation();

    _onClick(e);
  };

  return react.jsx("div", {
    className: className,
    onClick: function onClick() {
      if (!isMobile) return;
      _onClick === null || _onClick === void 0 ? void 0 : _onClick();
    },
    css: [/*#__PURE__*/react.css("display:flex;align-items:center;justify-content:space-between;width:100%;padding:", pxToRem(20), " 0;font-size:0;line-height:1;")]
  }, !!badge && react.jsx(CircleBadge, {
    type: "fill",
    variant: "primary2",
    size: 24,
    css: /*#__PURE__*/react.css("margin-right:", pxToRem(8), ";")
  }, badge), react.jsx("div", {
    css: _ref3
  }, react.jsx("div", {
    onClick: handleClickChild,
    css: [_ref2, _onClick && cssClickable]
  }, react.jsx("strong", {
    css: [/*#__PURE__*/react.css("overflow:hidden;display:inline-block;font-weight:700;color:", theme.content.base1, ";letter-spacing:", pxToRem(-0.3), ";white-space:nowrap;text-overflow:ellipsis;"), cssFontSize(size)]
  }, title), !!count && react.jsx("span", {
    css: [/*#__PURE__*/react.css("display:inline-block;margin-left:", pxToRem(6), ";", size === 'large' && FONT_STYLE.title2, ";", size === 'small' && FONT_STYLE.title3, ";font-weight:700;color:", theme.content.primary1.basic, ";letter-spacing:", pxToRem(-0.3), ";"), cssFontSize(size)]
  }, count)), caption && react.jsx("div", {
    onClick: function onClick(e) {
      if (!caption.onClick) return;
      e.stopPropagation();
      caption.onClick(e);
    },
    css: [/*#__PURE__*/react.css("display:inline-flex;align-items:center;max-width:100%;margin-top:", pxToRem(4), ";"), caption.onClick && cssClickable]
  }, react.jsx("span", {
    css: /*#__PURE__*/react.css("overflow:hidden;display:inline-block;", FONT_STYLE.subTitle2, ";font-weight:400;color:", theme.content.base1, ";letter-spacing:", pxToRem(-0.3), ";white-space:nowrap;text-overflow:ellipsis;")
  }, caption.text), caption.icon && react.jsx(Icon, {
    name: caption.icon,
    size: 18,
    css: /*#__PURE__*/react.css("margin-left:", pxToRem(2), ";color:", theme.content.base1, ";")
  }))), react.jsx("div", {
    css: /*#__PURE__*/react.css("display:flex;align-items:center;height:0;margin-left:", pxToRem(10), ";&:empty{margin-left:0;}")
  }, moreButton && react.jsx("button", {
    type: "button",
    onClick: handleClickChild,
    css: [/*#__PURE__*/react.css(RESET_BUTTON, " ", FONT_STYLE.subTitle1, " font-weight:700;color:", theme.content.primary1.basic, ";"), cssClickable]
  }, _typeof(moreButton) === 'object' && moreButton.text || '더보기'), customButton && function () {
    var component = customButton.component,
        props = _objectWithoutProperties(customButton, _excluded$3); // eslint-disable-next-line @typescript-eslint/no-explicit-any


    var CustomButton = component;
    return react.jsx(CustomButton, _extends({}, props, {
      size: 32,
      onClick: handleClickChild
    }));
  }(), hasArrow && react.jsx(Icon, {
    size: 24,
    name: "chevron_thick_right",
    fill: function fill(theme) {
      return theme.content.base1;
    },
    onClick: handleClickChild,
    css: _ref$1
  })));
}

var cssFontSize = function cssFontSize(size) {
  switch (size) {
    case 'large':
      return FONT_STYLE.title2;

    case 'small':
      return FONT_STYLE.title3;

    default:
      return;
  }
};

var cssClickable =  true ? {
  name: "1oqvtbd",
  styles: "cursor:pointer;@media(hover: hover){&:hover{opacity:.5;}}"
} : 0;

var _excluded$2 = ["multiple", "type", "accept", "onFileSelected", "onClick"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref =  true ? {
  name: "4zleql",
  styles: "display:block"
} : 0;

function ImageUploadButtonImpl(_ref2, ref) {
  var multiple = _ref2.multiple,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? 'button' : _ref2$type,
      _ref2$accept = _ref2.accept,
      accept = _ref2$accept === void 0 ? 'image/*' : _ref2$accept,
      onFileSelected = _ref2.onFileSelected,
      onButtonClick = _ref2.onClick,
      buttonProps = _objectWithoutProperties(_ref2, _excluded$2);

  var inputRef = React.useRef(null);
  var theme = react.useTheme();

  var handleClickButton = function handleClickButton(ev) {
    var _inputRef$current;

    (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.click();
    onButtonClick === null || onButtonClick === void 0 ? void 0 : onButtonClick(ev);
  };

  return react.jsx("button", _extends({
    ref: ref,
    onClick: handleClickButton,
    css: /*#__PURE__*/react.css(RESET_BUTTON, ";", FONT_STYLE.body3, ";width:", pxToRem(72), ";height:", pxToRem(72), ";font-weight:700;text-align:center;border-radius:", pxToRem(4), ";color:", theme.content.base1, ";border:", pxToRem(1), " solid ", theme.border, ";cursor:pointer;&:hover{background-color:", theme.interactive.transparent, ";}&:disabled{color:", theme.content.base3, ";pointer-events:none;background-color:", theme.content.base4, ";border:none;}"),
    type: type
  }, buttonProps), react.jsx("input", {
    hidden: true,
    ref: inputRef,
    type: "file",
    multiple: multiple,
    accept: accept,
    onChange: onFileSelected
  }), react.jsx(Icon, {
    size: 24,
    css: /*#__PURE__*/react.css("margin-bottom:", pxToRem(6.5), ";"),
    name: "camera"
  }), react.jsx("span", {
    css: _ref
  }, "\uC0AC\uC9C4 \uC62C\uB9AC\uAE30"));
}

var ImageUploadButton = React.memo(React.forwardRef(ImageUploadButtonImpl));

function ImageAttachedItem(_ref) {
  var imageUrl = _ref.imageUrl,
      onDelete = _ref.onDelete,
      _ref$deletable = _ref.deletable,
      deletable = _ref$deletable === void 0 ? true : _ref$deletable,
      className = _ref.className,
      alt = _ref.alt;
  var theme = react.useTheme();
  return react.jsx("figure", {
    className: className,
    css: /*#__PURE__*/react.css("width:", pxToRem(72), ";height:", pxToRem(72), ";display:inline-block;vertical-align:bottom;position:relative;overflow:hidden;&:after{position:absolute;content:\"\";top:0;left:0;right:0;bottom:0;border-radius:", pxToRem(4), ";border:", pxToRem(1), " solid ", theme.outline, ";}")
  }, react.jsx("img", {
    src: "".concat(imageUrl, "?w=72&h=72&c=c"),
    alt: alt,
    css: /*#__PURE__*/react.css("box-sizing:border-box;width:", pxToRem(72), ";height:", pxToRem(72), ";border-radius:", pxToRem(4), ";")
  }), deletable && react.jsx("button", {
    css: /*#__PURE__*/react.css(RESET_BUTTON, ";display:flex;z-index:3;align-items:center;justify-content:center;background-color:", theme.content.white, ";color:", theme.content.base1, ";position:absolute;top:", pxToRem(6), ";right:", pxToRem(6), ";cursor:pointer;width:", pxToRem(20), ";height:", pxToRem(20), ";border-radius:50%;&:hover{opacity:0.6;}"),
    onClick: onDelete
  }, react.jsx(Icon, {
    size: 24,
    name: "dismiss_circle"
  })));
}

function LinearProgressBar(_ref) {
  var total = _ref.total,
      variant = _ref.variant,
      currentStep = _ref.currentStep,
      width = _ref.width;
  var theme = react.useTheme();
  var progress = Math.max(Math.min(currentStep / total * 100, 100), 0);
  return react.jsx("div", {
    css: /*#__PURE__*/react.css("background-color:", theme.content.base5, ";width:", pxToRem(width), ";height:", pxToRem(6), ";margin-top:auto;margin-bottom:auto;")
  }, react.jsx(StyledDiv, {
    progress: progress,
    variant: variant
  }));
}

var StyledDiv = _styled__default['default']("div", {
  target: "e1o4cfgi0"
})("transform:scaleX(", function (_ref2) {
  var progress = _ref2.progress;
  return progress / 100;
}, ");transform-origin:center left;transition:transform 1.5s ease;background-color:", function (_ref3) {
  var theme = _ref3.theme,
      variant = _ref3.variant;
  return theme.content[variant].basic;
}, ";border-top-right-radius:", pxToRem(10), ";border-bottom-right-radius:", pxToRem(10), ";height:100%;transition-duration:0.2s;transition-timing-function:ease-in-out;");

/**
 * 세션 스토리지에 저장하는 스크롤 정보
 * scrollTop: 현재 화면 최상단 선까지의 scroll offset을 의미하며, useVirtualizedScroll에서 scrollTo를 통해 이동할 때 사용됩니다.
 * scrollEndItemIndex: 현재 화면 최하단에 위치한 row의 마지막 아이템 index를 의미하며, usePaged(Cursor)InfiniteList 에서 loading을 해지하고 초기 렌더링되는 아이템 개수(count)를 지정하는데에 사용됩니다.
 * */
var FETCH_STATUS = {
  LOADED: 'loaded',
  NON_LOAD: 'non-load'
};

var createScrollStorage = function createScrollStorage(tabId) {
  var sessionKey = "scroll-".concat(tabId);
  return {
    get: function get() {
      var scrollInfo = sessionStorage.getItem(sessionKey);
      return scrollInfo ? JSON.parse(scrollInfo) : undefined;
    },
    set: function set(value) {
      sessionStorage.setItem(sessionKey, value);
    },
    reset: function reset() {
      sessionStorage.removeItem(sessionKey);
    }
  };
};
/**
 * @param length
 * @returns length개의 null을 채운 배열
 */

var createNullArray = function createNullArray(length) {
  return Array.from({
    length: length
  }).map(function (_) {
    return null;
  });
};
/**
 * findPageByIndex
 * index보다 작으면서 가장 가까운 배열 요소의 index(page)를 찾아서 반환합니다.
 * @param {number[]} array 각 page의 offset이 담긴 배열
 * @param {number} index 찾고자 하는 아이템 index
 */

var findPageByIndex = function findPageByIndex(array, index) {
  var start = 0;
  var end = array.length - 1;

  while (start <= end) {
    var mid = Math.floor((start + end) / 2);
    var isLastItem = array.length - 1 === mid;
    var currValue = array[mid];
    var nextValue = isLastItem ? Number.MAX_SAFE_INTEGER : array[mid + 1];

    if (index < currValue) {
      end = mid - 1;
    } else if (currValue <= index && index < nextValue) {
      return mid;
    } else {
      start = mid + 1;
    }
  }

  return 0;
};

var _excluded$1 = ["page"];
var MIN_PAGE$1 = 1;
/**
 * info의 개수가 per보다 큰 경우, info를 per개씩 나누어 저장한 pageInfo를 리턴합니다.
 */

var formatPageInfo = function formatPageInfo(_ref) {
  var page = _ref.page,
      info = _ref.info,
      per = _ref.per;
  var itemStatus = info.itemStatus,
      items = info.items,
      hasNext = info.hasNext;
  var pageCount = Math.floor(items.length / per);
  var formattedPageInfo = {};
  Array.from({
    length: pageCount
  }).forEach(function (_, index) {
    var isLastPage = index === pageCount - 1;
    formattedPageInfo = _objectSpread2(_objectSpread2({}, formattedPageInfo), {}, _defineProperty({}, page + index, {
      itemStatus: itemStatus,
      items: items.slice(index * per, (index + 1) * per),
      hasNext: isLastPage ? hasNext : true
    }));
  });
  return formattedPageInfo;
};

var getInitialDataInfo = function getInitialDataInfo(initialData, per) {
  if (!initialData) return {};

  var page = initialData.page,
      pageInfo = _objectWithoutProperties(initialData, _excluded$1);

  return formatPageInfo({
    page: page,
    info: _objectSpread2({
      itemStatus: FETCH_STATUS.LOADED
    }, pageInfo),
    per: per
  });
};

function usePageInfo(_ref2) {
  var per = _ref2.per,
      tabId = _ref2.tabId,
      originalInitialData = _ref2.initialData;

  var _useState = React.useState(getInitialDataInfo(originalInitialData, per)),
      _useState2 = _slicedToArray(_useState, 2),
      pageInfo = _useState2[0],
      setPageInfo = _useState2[1];

  var maxPage = React.useRef(null);
  React.useEffect(function () {
    // TODO: 아래로 이동
    var actualMaxPage = maxPage.current;
    if (actualMaxPage == null) return;
    var isPageInfoAlreadyFiltered = Number(findLastKey__default['default'](pageInfo)) <= actualMaxPage;
    if (isPageInfoAlreadyFiltered) return;
    setPageInfo(function (pageInfo) {
      var pageList = Object.keys(pageInfo);
      var omittedPageList = pageList.filter(function (page) {
        return Number(page) > actualMaxPage;
      }).map(function (page) {
        return Number(page);
      });
      return omit__default['default'](pageInfo, omittedPageList);
    });
  }, [pageInfo]);
  var sessionScrollStorage = React.useMemo(function () {
    return createScrollStorage(tabId);
  }, [tabId]);
  var count = React.useMemo(function () {
    return Object.values(pageInfo).reduce(function (prev, _ref3) {
      var items = _ref3.items;
      return prev + items.length;
    }, 0);
  }, [pageInfo]);
  var getPageInfo = React.useCallback(function (page) {
    return pageInfo[page];
  }, [pageInfo]);
  var resetPageInfo = React.useCallback(function () {
    setPageInfo({});
  }, []);
  var addPageInfo = React.useCallback(function (_ref4) {
    var page = _ref4.page,
        info = _ref4.info;
    setPageInfo(function (pageInfo) {
      return _objectSpread2(_objectSpread2({}, pageInfo), {}, _defineProperty({}, page, info));
    });
  }, []);
  var getPageFromIndex = React.useCallback(function (index) {
    return Math.floor(index / per) + 1;
  }, [per]);
  var getInitialPageInfo = React.useCallback(function () {
    if (originalInitialData === null) return {};
    return getInitialDataInfo(originalInitialData, per);
  }, [originalInitialData, per]);
  var createNonLoadPageInfo = React.useCallback(function (itemCount) {
    return formatPageInfo({
      page: MIN_PAGE$1,
      info: {
        itemStatus: FETCH_STATUS.NON_LOAD,
        items: createNullArray(itemCount),
        hasNext: true
      },
      per: per
    });
  }, [per]);
  /**
   * 스크롤 복귀할 page index와 initialData의 마지막 page index를 비교한 후
   * 더 큰 page까지 non-load로 데이터를 채워 반환합니다.
   */

  var getInitialNonLoadPageInfo = React.useCallback(function () {
    var _originalInitialData$;

    var initialLastPage = (_originalInitialData$ = originalInitialData === null || originalInitialData === void 0 ? void 0 : originalInitialData.page) !== null && _originalInitialData$ !== void 0 ? _originalInitialData$ : 1;
    var scrollInfo = sessionScrollStorage.get();

    if (!(scrollInfo !== null && scrollInfo !== void 0 && scrollInfo.scrollEndItemIndex)) {
      return createNonLoadPageInfo(initialLastPage * per);
    }

    var scrollItemIndex = Number(scrollInfo.scrollEndItemIndex);
    var scrollPage = getPageFromIndex(scrollItemIndex);
    return createNonLoadPageInfo(Math.max(scrollPage, initialLastPage) * per);
  }, [originalInitialData, sessionScrollStorage, getPageFromIndex, createNonLoadPageInfo, per]);
  var initPageInfo = React.useCallback(function () {
    var initialPageInfo = getInitialPageInfo();
    var initialNonLoadPageInfo = getInitialNonLoadPageInfo();
    setPageInfo(_objectSpread2(_objectSpread2({}, initialNonLoadPageInfo), initialPageInfo));
  }, [getInitialNonLoadPageInfo, getInitialPageInfo]);
  return {
    maxPage: maxPage,
    count: count,
    getPageInfo: getPageInfo,
    addPageInfo: addPageInfo,
    resetPageInfo: resetPageInfo,
    initPageInfo: initPageInfo,
    getPageFromIndex: getPageFromIndex
  };
}

function useLoadingPageList() {
  var loadingPageList = React.useRef(new Set());
  var addLoadingPage = React.useCallback(function (newPage) {
    loadingPageList.current.add(newPage);
  }, []);
  var removeLoadingPage = React.useCallback(function (targetPage) {
    loadingPageList.current["delete"](targetPage);
  }, []);
  var isLoadingPage = React.useCallback(function (page) {
    return loadingPageList.current.has(page);
  }, []);
  return {
    addLoadingPage: addLoadingPage,
    removeLoadingPage: removeLoadingPage,
    isLoadingPage: isLoadingPage
  };
}

function usePagedInfiniteList(_ref) {
  var initialData = _ref.initialData,
      initialDataPending = _ref.initialDataPending,
      per = _ref.per,
      tabId = _ref.tabId,
      getItemList = _ref.getItemList;

  var _useState = React.useState(),
      _useState2 = _slicedToArray(_useState, 2),
      error = _useState2[0],
      setError = _useState2[1];

  var shouldInit = React.useRef(true);
  var tabIdChanged = useChanged(tabId);
  var initialDataChanged = useChanged(initialData, isEqual__default['default']);

  if (tabIdChanged || initialDataChanged) {
    shouldInit.current = true;
  }

  var _usePageInfo = usePageInfo({
    per: per,
    tabId: tabId,
    initialData: initialData
  }),
      maxPage = _usePageInfo.maxPage,
      count = _usePageInfo.count,
      getPageInfo = _usePageInfo.getPageInfo,
      addPageInfo = _usePageInfo.addPageInfo,
      initPageInfo = _usePageInfo.initPageInfo,
      getPageFromIndex = _usePageInfo.getPageFromIndex;

  var _useLoadingPageList = useLoadingPageList(),
      addLoadingPage = _useLoadingPageList.addLoadingPage,
      removeLoadingPage = _useLoadingPageList.removeLoadingPage,
      isLoadingPage = _useLoadingPageList.isLoadingPage;
  /**
   * @param page fetch 할 페이지
   * @param fetchStatus fetch하는 status(non-load/loaded)
   */


  var fetchPageItemList = React.useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2) {
      var page, _ref2$fetchStatus, fetchStatus, _yield$getItemList, _yield$getItemList$it, items, hasNext, _maxPage$current;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              page = _ref2.page, _ref2$fetchStatus = _ref2.fetchStatus, fetchStatus = _ref2$fetchStatus === void 0 ? FETCH_STATUS.LOADED : _ref2$fetchStatus;
              addPageInfo({
                page: page,
                info: {
                  itemStatus: FETCH_STATUS.NON_LOAD,
                  items: createNullArray(per),
                  hasNext: true
                }
              });

              if (!(fetchStatus === FETCH_STATUS.NON_LOAD)) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return");

            case 4:
              addLoadingPage(page);
              _context.prev = 5;
              _context.next = 8;
              return getItemList(page, per);

            case 8:
              _yield$getItemList = _context.sent;
              _yield$getItemList$it = _yield$getItemList.items;
              items = _yield$getItemList$it === void 0 ? [] : _yield$getItemList$it;
              hasNext = _yield$getItemList.hasNext;
              addPageInfo({
                page: page,
                info: {
                  itemStatus: FETCH_STATUS.LOADED,
                  items: items,
                  hasNext: hasNext
                }
              });

              if (hasNext === false || items.length < 1) {
                maxPage.current = Math.min((_maxPage$current = maxPage.current) !== null && _maxPage$current !== void 0 ? _maxPage$current : Number.MAX_SAFE_INTEGER, page);
              }

              if (page === (error === null || error === void 0 ? void 0 : error.errorPage)) {
                setError(undefined);
              }

              _context.next = 20;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](5);
              setError({
                error: _context.t0,
                errorPage: page
              });

            case 20:
              _context.prev = 20;
              removeLoadingPage(page);
              return _context.finish(20);

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 17, 20, 23]]);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), [addLoadingPage, addPageInfo, error === null || error === void 0 ? void 0 : error.errorPage, getItemList, maxPage, per, removeLoadingPage]);
  var handleLoadItemList = React.useCallback( /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref4) {
      var startItemIndex, _ref4$endItemIndex, endItemIndex, _ref4$fetchStatus, fetchStatus, startItemPage, endItemPage, pageCount;

      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              startItemIndex = _ref4.startItemIndex, _ref4$endItemIndex = _ref4.endItemIndex, endItemIndex = _ref4$endItemIndex === void 0 ? startItemIndex : _ref4$endItemIndex, _ref4$fetchStatus = _ref4.fetchStatus, fetchStatus = _ref4$fetchStatus === void 0 ? FETCH_STATUS.LOADED : _ref4$fetchStatus;

              if (!(startItemIndex > endItemIndex)) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return");

            case 3:
              startItemPage = getPageFromIndex(startItemIndex);
              endItemPage = getPageFromIndex(endItemIndex);
              pageCount = endItemPage - startItemPage + 1;
              Array.from({
                length: pageCount
              }).forEach(function (_, index) {
                var _getPageInfo;

                var page = index + startItemPage;
                var isPageAlreadyFetched = ((_getPageInfo = getPageInfo(page)) === null || _getPageInfo === void 0 ? void 0 : _getPageInfo.itemStatus) === FETCH_STATUS.LOADED;
                var isPageLoading = isLoadingPage(page);
                var isPageNotInRange = page < MIN_PAGE$1 || maxPage.current != null && page > maxPage.current;
                if (isPageAlreadyFetched || isPageLoading || isPageNotInRange) return;
                fetchPageItemList({
                  page: page,
                  fetchStatus: fetchStatus
                });
              });

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref5.apply(this, arguments);
    };
  }(), [fetchPageItemList, getPageFromIndex, getPageInfo, isLoadingPage, maxPage]);
  var handleReloadErrorPage = React.useCallback(function () {
    if (!error) return;
    fetchPageItemList({
      page: error.errorPage
    });
    setError(undefined);
  }, [error, fetchPageItemList]);
  var handleGetItem = React.useCallback(function (index) {
    var _getPageInfo2;

    var page = Math.ceil((index + 1) / per);
    var itemIndexInPage = index % per;
    return (_getPageInfo2 = getPageInfo(page)) === null || _getPageInfo2 === void 0 ? void 0 : _getPageInfo2.items[itemIndexInPage];
  }, [getPageInfo, per]);
  /**
   * 기존 데이터를 reset하고, initial 데이터와 현재 스크롤 위치에서의 데이터를 reFetching합니다.
   * 중간 데이터들은 전부 non-load로 처리합니다.
   */

  var handleReloadItemList = React.useCallback(function () {
    initPageInfo();
  }, [initPageInfo]);
  React.useEffect(function () {
    if (initialDataPending || !initialData || !shouldInit.current) return;
    initPageInfo();
    shouldInit.current = false;
  }, [initPageInfo, initialData, initialDataPending]);
  return {
    count: count,
    loadItemList: handleLoadItemList,
    reloadItemList: handleReloadItemList,
    reloadError: handleReloadErrorPage,
    getItem: handleGetItem,
    error: error === null || error === void 0 ? void 0 : error.error
  };
}

var MIN_PAGE = 0;

var getInitialCursorInfo = function getInitialCursorInfo(initialData) {
  if (initialData === null) return {};
  return _defineProperty({}, MIN_PAGE, _objectSpread2({
    itemStatus: FETCH_STATUS.LOADED,
    offset: 0,
    cursor: null
  }, initialData));
};

function useCursorInfo(_ref2) {
  var initialData = _ref2.initialData;

  var _useState = React.useState(getInitialCursorInfo(initialData)),
      _useState2 = _slicedToArray(_useState, 2),
      cursorInfo = _useState2[0],
      setCursorInfo = _useState2[1];

  var _useMemo = React.useMemo(function () {
    var _findLast;

    var lastCursorInfo = (_findLast = findLast__default['default'](cursorInfo)) !== null && _findLast !== void 0 ? _findLast : {
      offset: 0,
      items: [],
      nextCursor: null,
      itemStatus: FETCH_STATUS.NON_LOAD
    };
    var count = lastCursorInfo.offset + lastCursorInfo.items.length;
    var nextCursor = lastCursorInfo.nextCursor;
    var hasNext = !(lastCursorInfo.itemStatus === 'loaded' && nextCursor === null);
    return {
      count: count,
      nextCursor: nextCursor,
      hasNext: hasNext
    };
  }, [cursorInfo]),
      count = _useMemo.count,
      nextCursor = _useMemo.nextCursor,
      hasNext = _useMemo.hasNext;

  var lastPage = React.useMemo(function () {
    var _findLastKey;

    return Number((_findLastKey = findLastKey__default['default'](cursorInfo)) !== null && _findLastKey !== void 0 ? _findLastKey : 0);
  }, [cursorInfo]);
  var getCursorInfo = React.useCallback(function (page) {
    return cursorInfo[page];
  }, [cursorInfo]);
  var resetCursorInfo = React.useCallback(function () {
    setCursorInfo({});
  }, []);
  var addCursorInfo = React.useCallback(function (_ref3) {
    var page = _ref3.page,
        info = _ref3.info;
    var prevCursorInfo = cursorInfo[page - 1];
    var offset = prevCursorInfo ? prevCursorInfo.offset + prevCursorInfo.items.length : 0;
    setCursorInfo(function (cursorInfo) {
      return _objectSpread2(_objectSpread2({}, cursorInfo), {}, _defineProperty({}, page, _objectSpread2(_objectSpread2({}, info), {}, {
        offset: offset
      })));
    });
  }, [cursorInfo]);
  var getPageFromIndex = React.useCallback(function (index) {
    var offsetArray = [].concat(_toConsumableArray(Object.values(cursorInfo).map(function (_ref4) {
      var offset = _ref4.offset;
      return offset;
    })), [count]);
    var page = findPageByIndex(offsetArray, index);
    var isOverCount = page === size__default['default'](cursorInfo);
    if (isOverCount) return null;
    return page;
  }, [cursorInfo, count]);
  var removeCursorInfo = React.useCallback(function (page) {
    setCursorInfo(function (cursorInfo) {
      return omit__default['default'](cursorInfo, page);
    });
  }, []);
  var initCursorInfo = React.useCallback(function () {
    if (!initialData) return;
    var initialCursorInfo = getInitialCursorInfo(initialData);
    setCursorInfo(initialCursorInfo);
  }, [initialData]);
  return {
    nextCursor: nextCursor,
    count: count,
    lastPage: lastPage,
    hasNext: hasNext,
    getCursorInfo: getCursorInfo,
    addCursorInfo: addCursorInfo,
    removeCursorInfo: removeCursorInfo,
    resetCursorInfo: resetCursorInfo,
    initCursorInfo: initCursorInfo,
    getPageFromIndex: getPageFromIndex
  };
}

function usePagedCursorInfiniteList(_ref) {
  var initialData = _ref.initialData,
      initialDataPending = _ref.initialDataPending,
      per = _ref.per,
      tabId = _ref.tabId,
      getItemList = _ref.getItemList;

  var _useState = React.useState(),
      _useState2 = _slicedToArray(_useState, 2),
      error = _useState2[0],
      setError = _useState2[1];

  var _useState3 = React.useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      scrollTargetIndex = _useState4[0],
      setScrollTargetIndex = _useState4[1];

  var shouldInit = React.useRef(true);
  var tabIdChanged = useChanged(tabId);
  var initialDataChanged = useChanged(initialData, isEqual__default['default']);

  if (tabIdChanged || initialDataChanged) {
    shouldInit.current = true;
  }

  var sessionScrollStorage = React.useMemo(function () {
    return createScrollStorage(tabId);
  }, [tabId]);

  var _useCursorInfo = useCursorInfo({
    initialData: initialData
  }),
      targetCursor = _useCursorInfo.nextCursor,
      count = _useCursorInfo.count,
      lastPage = _useCursorInfo.lastPage,
      hasNext = _useCursorInfo.hasNext,
      getCursorInfo = _useCursorInfo.getCursorInfo,
      addCursorInfo = _useCursorInfo.addCursorInfo,
      removeCursorInfo = _useCursorInfo.removeCursorInfo,
      initCursorInfo = _useCursorInfo.initCursorInfo,
      getPageFromIndex = _useCursorInfo.getPageFromIndex;

  var _useLoadingPageList = useLoadingPageList(),
      addLoadingPage = _useLoadingPageList.addLoadingPage,
      removeLoadingPage = _useLoadingPageList.removeLoadingPage,
      isLoadingPage = _useLoadingPageList.isLoadingPage;

  var visibleCount = React.useMemo(function () {
    if (hasNext && scrollTargetIndex !== null) {
      return Math.max(count, scrollTargetIndex + 1);
    }

    return count;
  }, [count, hasNext, scrollTargetIndex]);
  var fetchCursorItemList = React.useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2) {
      var page, cursor, _yield$getItemList, _yield$getItemList$it, items, _hasNext, _nextCursor;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              page = _ref2.page, cursor = _ref2.cursor;

              if (!(!cursor || !initialData)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              addCursorInfo({
                page: page,
                info: {
                  itemStatus: FETCH_STATUS.NON_LOAD,
                  items: createNullArray(per !== null && per !== void 0 ? per : initialData.items.length),
                  hasNext: true,
                  nextCursor: null,
                  cursor: cursor
                }
              });
              addLoadingPage(page);
              _context.prev = 5;
              _context.next = 8;
              return getItemList(cursor, per);

            case 8:
              _yield$getItemList = _context.sent;
              _yield$getItemList$it = _yield$getItemList.items;
              items = _yield$getItemList$it === void 0 ? [] : _yield$getItemList$it;
              _hasNext = _yield$getItemList.hasNext;
              _nextCursor = _yield$getItemList.nextCursor;
              addCursorInfo({
                page: page,
                info: {
                  itemStatus: FETCH_STATUS.LOADED,
                  items: items,
                  hasNext: _hasNext,
                  nextCursor: _nextCursor,
                  cursor: cursor
                }
              });

              if ((error === null || error === void 0 ? void 0 : error.errorPage) === page) {
                setError(undefined);
              }

              _context.next = 20;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](5);
              setError({
                error: _context.t0,
                errorPage: page
              });

            case 20:
              _context.prev = 20;
              removeLoadingPage(page);
              return _context.finish(20);

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 17, 20, 23]]);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), [initialData, addCursorInfo, per, addLoadingPage, getItemList, error === null || error === void 0 ? void 0 : error.errorPage, removeLoadingPage]);
  var handleLoadItemList = React.useCallback( /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref4) {
      var endItemIndex, targetPage;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              endItemIndex = _ref4.endItemIndex;
              targetPage = lastPage + 1;

              if (!(!targetCursor || isLoadingPage(targetPage) || endItemIndex < count)) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt("return");

            case 4:
              fetchCursorItemList({
                page: targetPage,
                cursor: targetCursor
              });

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref5.apply(this, arguments);
    };
  }(), [count, fetchCursorItemList, isLoadingPage, lastPage, targetCursor]);
  var handleReloadErrorPage = React.useCallback(function () {
    var _cursorData$cursor;

    if (!error) return;
    setError(undefined);
    removeCursorInfo(error.errorPage);
    var cursorData = getCursorInfo(error.errorPage);
    var errorCursor = (_cursorData$cursor = cursorData === null || cursorData === void 0 ? void 0 : cursorData.cursor) !== null && _cursorData$cursor !== void 0 ? _cursorData$cursor : null;
    fetchCursorItemList({
      page: error.errorPage,
      cursor: errorCursor
    });
  }, [error, fetchCursorItemList, getCursorInfo, removeCursorInfo]);
  var handleGetItem = React.useCallback(function (index) {
    var page = getPageFromIndex(index);
    if (page === null) return null;
    var cursorInfo = getCursorInfo(page);
    if (!cursorInfo) return null;
    var itemIndexInPage = index - cursorInfo.offset;
    return cursorInfo.items[itemIndexInPage];
  }, [getCursorInfo, getPageFromIndex]);
  var initScrollTarget = React.useCallback(function () {
    var scrollInfo = sessionScrollStorage.get();

    if (!(scrollInfo !== null && scrollInfo !== void 0 && scrollInfo.scrollEndItemIndex)) {
      setScrollTargetIndex(0);
      return;
    }

    var scrollEndItemIndex = Number(scrollInfo.scrollEndItemIndex);
    setScrollTargetIndex(scrollEndItemIndex);
  }, [sessionScrollStorage]);
  var handleReloadItemList = React.useCallback(function () {
    initCursorInfo();
    initScrollTarget();
  }, [initCursorInfo, initScrollTarget]);
  React.useEffect(function () {
    if (!shouldInit.current || initialDataPending || !initialData) return;
    initCursorInfo();
    initScrollTarget();
    shouldInit.current = false;
  }, [initCursorInfo, initScrollTarget, initialData, initialDataPending]);
  return {
    count: visibleCount,
    loadItemList: handleLoadItemList,
    reloadItemList: handleReloadItemList,
    reloadError: handleReloadErrorPage,
    getItem: handleGetItem,
    error: error === null || error === void 0 ? void 0 : error.error
  };
}

var SCROLL_THROTTLE_MILLISECONDS = 500;

/**
 * useVirtualizedScroll
 * 페이지를 벗어날 때 스크롤 위치를 저장하고, 페이지 재접근 시 스크롤 위치를 복귀시키는 역할을 수행합니다.
 */
var useVirtualizedScroll = function useVirtualizedScroll(_ref) {
  var tabId = _ref.tabId,
      columnCount = _ref.columnCount,
      containerRef = _ref.containerRef,
      renderedRowList = _ref.renderedRowList,
      disableSaveScroll = _ref.disableSaveScroll;

  var _useState = React.useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      targetScrollTop = _useState2[0],
      setTargetScrollTop = _useState2[1];

  var scrollIntervalId = React.useRef(null);
  var scrollDone = React.useRef(false);
  var sessionScrollStorage = React.useMemo(function () {
    return createScrollStorage(tabId);
  }, [tabId]);
  /**
   * 현재 scroll 위치 정보를 sessionStorage에 저장합니다.
   */

  var saveScrollInfo = React.useCallback(function () {
    var _containerRef$current, _containerRef$current2, _renderedRowList$curr;

    if (!scrollDone.current || !containerRef.current || !renderedRowList.current || renderedRowList.current.length === 0 || disableSaveScroll) return;
    var offsetTop = (_containerRef$current = (_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.offsetTop) !== null && _containerRef$current !== void 0 ? _containerRef$current : 0;
    /** 화면 최상단에서부터 scrollTop */

    var scrollTop = document.documentElement.scrollTop;
    /** 현재 보이는 화면 "상단" 선 기준 VirtualizedList 컴포넌트 최상단에서부터의 scrollTop */

    var scrollTopFromStart = scrollTop - offsetTop;
    /** 현재 보이는 화면 "하단" 선 기준 VirtualizedList 컴포넌트 최상단에서부터의 scrollTop */

    var scrollBottomFromStart = scrollTopFromStart + window.innerHeight;
    var lastRenderedRow = renderedRowList.current[renderedRowList.current.length - 1];

    var _ref2 = (_renderedRowList$curr = renderedRowList.current.find(function (_ref3) {
      var offset = _ref3.offset,
          size = _ref3.size;
      return offset <= scrollBottomFromStart && scrollBottomFromStart < offset + size;
    })) !== null && _renderedRowList$curr !== void 0 ? _renderedRowList$curr : lastRenderedRow,
        visibleEndRowIndex = _ref2.index;
    /** 화면에 보이는 마지막 아이템 item */


    var endItemIndex = (visibleEndRowIndex + 1) * columnCount - 1;
    var scrollInfo = {
      scrollTop: scrollTop,
      scrollEndItemIndex: endItemIndex
    };

    var _containerRef$current3 = containerRef.current.getBoundingClientRect(),
        bottom = _containerRef$current3.bottom;

    var isScrollAfterList = bottom < 0;

    if (isScrollAfterList) {
      var prevScrollInfo = sessionScrollStorage.get();
      var prevEndItemIndex = prevScrollInfo === null || prevScrollInfo === void 0 ? void 0 : prevScrollInfo.scrollEndItemIndex;

      if (prevEndItemIndex) {
        scrollInfo.scrollEndItemIndex = Math.max(prevEndItemIndex, endItemIndex);
      }
    }

    sessionScrollStorage.set(JSON.stringify(scrollInfo));
  }, [columnCount, containerRef, disableSaveScroll, renderedRowList, sessionScrollStorage]);
  React.useEffect(function () {
    var scrollInfo = sessionScrollStorage.get();

    if ((scrollInfo === null || scrollInfo === void 0 ? void 0 : scrollInfo.scrollTop) == null) {
      scrollDone.current = true;
      return;
    }

    scrollDone.current = false;
    setTargetScrollTop(scrollInfo.scrollTop);
  }, [sessionScrollStorage]);
  React.useEffect(function () {
    if (scrollIntervalId.current) {
      clearInterval(scrollIntervalId.current);
    }

    if (scrollDone.current) return;
    var intervalId = setInterval(function () {
      if (targetScrollTop == null) return;
      var scrollTop = document.documentElement.scrollTop;

      if (scrollTop === targetScrollTop) {
        scrollDone.current = true;
        clearInterval(intervalId);
        return;
      }

      window.scrollTo({
        top: targetScrollTop
      });
    }, 10);
    scrollIntervalId.current = intervalId;
    return function () {
      clearInterval(intervalId);
    };
  }, [targetScrollTop]);
  React.useEffect(function () {
    var throttleSaveScrollInfo = throttle__default['default'](saveScrollInfo, SCROLL_THROTTLE_MILLISECONDS);
    window.addEventListener('scroll', throttleSaveScrollInfo);

    if (disableSaveScroll) {
      window.removeEventListener('scroll', throttleSaveScrollInfo);
    }

    return function () {
      window.removeEventListener('scroll', throttleSaveScrollInfo);
    };
  }, [saveScrollInfo, disableSaveScroll, sessionScrollStorage]);
};

var _excluded = ["initialBreakpoint", "grid", "tabId", "count", "loadItemList", "disableSaveScroll", "overscanHeight", "insertedItemList", "renderItem"];
var FAST_SCROLLING_VELOCITY = 4000; // (px/s)

var DEFAULT_OVERSCAN_HEIGHT = 500;
/**
 * Grid 컴포넌트는 autoHeight와 연동되지 않으므로,
 * List의 한 row당 grid만큼의 아이템을 가질 수 있도록 그리드 형태를 구현
 */

function VirtualizedList(_ref) {
  var _ref$initialBreakpoin = _ref.initialBreakpoint,
      initialBreakpoint = _ref$initialBreakpoin === void 0 ? 'desktop' : _ref$initialBreakpoin,
      grid = _ref.grid,
      tabId = _ref.tabId,
      count = _ref.count,
      loadItemList = _ref.loadItemList,
      _ref$disableSaveScrol = _ref.disableSaveScroll,
      disableSaveScroll = _ref$disableSaveScrol === void 0 ? false : _ref$disableSaveScrol,
      _ref$overscanHeight = _ref.overscanHeight,
      overscanHeight = _ref$overscanHeight === void 0 ? DEFAULT_OVERSCAN_HEIGHT : _ref$overscanHeight,
      _ref$insertedItemList = _ref.insertedItemList,
      insertedItemList = _ref$insertedItemList === void 0 ? [] : _ref$insertedItemList,
      renderItem = _ref.renderItem,
      props = _objectWithoutProperties(_ref, _excluded);

  var containerRef = React.useRef(null);
  var renderedRowList = React.useRef([]);
  var isFastScrolling = React.useRef(false);
  var breakpoint = useResponsive().breakpoint;
  var columnCount = React.useMemo(function () {
    return grid[breakpoint !== null && breakpoint !== void 0 ? breakpoint : initialBreakpoint];
  }, [breakpoint, grid, initialBreakpoint]);
  var itemRowCount = React.useMemo(function () {
    return Math.ceil(count / columnCount);
  }, [columnCount, count]);
  var insertedItemObject = React.useMemo(function () {
    return insertedItemList.reduce(function (prev, curr) {
      return _objectSpread2(_objectSpread2({}, prev), {}, _defineProperty({}, curr.rowIndex, curr));
    }, {});
  }, [insertedItemList]);
  var insertedItemRowCount = React.useMemo(function () {
    var _Object$keys$length;

    return (_Object$keys$length = Object.keys(insertedItemObject).length) !== null && _Object$keys$length !== void 0 ? _Object$keys$length : 0;
  }, [insertedItemObject]);
  useVirtualizedScroll({
    tabId: tabId,
    columnCount: columnCount,
    containerRef: containerRef,
    renderedRowList: renderedRowList,
    disableSaveScroll: disableSaveScroll
  });
  /**
   * grid개의 아이템을 포함한 index번째 row를 생성합니다.
   */

  var createRowContent = React.useCallback(function (rowIndex) {
    var hasInsertedItem = Object.keys(insertedItemObject).includes("".concat(rowIndex));

    if (hasInsertedItem) {
      return react.jsx(Row, null, insertedItemObject[rowIndex].component);
    } // 현재 rowIndex 보다 위에 존재하는 insertedItem의 개수


    var nowInsertedItemCount = Object.keys(insertedItemObject).filter(function (embedIndex) {
      return Number(embedIndex) < rowIndex;
    }).length;
    return react.jsx(Row, {
      columnCount: columnCount
    }, Array.from({
      length: columnCount
    }).map(function (_, columnIndex) {
      var index = columnCount * (rowIndex - nowInsertedItemCount) + columnIndex;
      var lastItemIndex = count - 1;
      if (index > lastItemIndex) return null;
      return react.jsx(React.Fragment, {
        key: "item".concat(index)
      }, renderItem(index, rowIndex, isFastScrolling.current));
    }));
  }, [insertedItemObject, columnCount, count, renderItem]);
  var fetchItemList = React.useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(renderedRowList, isFastScrolling) {
      var startRow, endRow, startItemIndex, endItemIndex;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(renderedRowList.length < 1)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              startRow = renderedRowList[0].index;
              endRow = renderedRowList[renderedRowList.length - 1].index;
              startItemIndex = startRow * columnCount;
              endItemIndex = (endRow + 1) * columnCount;
              loadItemList({
                startItemIndex: startItemIndex,
                endItemIndex: endItemIndex,
                fetchStatus: isFastScrolling ? FETCH_STATUS.NON_LOAD : FETCH_STATUS.LOADED
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [columnCount, loadItemList]);
  var handleItemsRendered = React.useCallback(function (items) {
    if (items.length < 1) return;
    renderedRowList.current = items;
    fetchItemList(items, isFastScrolling.current);
  }, [fetchItemList]);
  return react.jsx("div", {
    ref: containerRef
  }, react.jsx(reactVirtuoso.Virtuoso, _extends({}, props, {
    itemContent: createRowContent,
    totalCount: itemRowCount + insertedItemRowCount,
    useWindowScroll: true,
    itemsRendered: handleItemsRendered,
    initialItemCount: itemRowCount,
    scrollSeekConfiguration: {
      enter: function enter(velocity) {
        isFastScrolling.current = Math.abs(velocity) > FAST_SCROLLING_VELOCITY;
        return false;
      },
      exit: function exit(velocity) {
        isFastScrolling.current = Math.abs(velocity) > FAST_SCROLLING_VELOCITY;
        return false;
      }
    },
    isScrolling: function isScrolling(_isScrolling) {
      if (_isScrolling) return;
      fetchItemList(renderedRowList.current, false);
    },
    increaseViewportBy: {
      top: overscanHeight,
      bottom: overscanHeight
    }
  })));
}

var Row = _styled__default['default']("div", {
  target: "e1b6d19b0"
})("width:100%;display:flex;&>*{width:", function (_ref3) {
  var _ref3$columnCount = _ref3.columnCount,
      columnCount = _ref3$columnCount === void 0 ? 1 : _ref3$columnCount;
  return 100 / columnCount;
}, "%;}");

var TOOLTIP_MIN_WIDTH = 92;
var TOOLTIP_MIN_HEIGHT = 36;
var TOOLTIP_MARGIN = 8;
var ARROW_SIZE = {
  width: 14,
  height: 10
};
/** Placement는 화살표의 위치를 나타냅니다. */

var Tooltip = function Tooltip(_ref) {
  var _useNodeSize;

  var arrow = _ref.arrow,
      variant = _ref.variant,
      _ref$hasRoundBorder = _ref.hasRoundBorder,
      hasRoundBorder = _ref$hasRoundBorder === void 0 ? false : _ref$hasRoundBorder,
      _ref$isTwoLine = _ref.isTwoLine,
      isTwoLine = _ref$isTwoLine === void 0 ? false : _ref$isTwoLine,
      children = _ref.children,
      onClose = _ref.onClose;
  var options = {
    arrow: arrow,
    variant: variant
  };
  var placement = arrow.placement;
  var tooltipRef = React.useRef(null);
  var tooltipWidth = ((_useNodeSize = ui.useNodeSize(tooltipRef, [TOOLTIP_MIN_WIDTH, TOOLTIP_MIN_HEIGHT])) === null || _useNodeSize === void 0 ? void 0 : _useNodeSize[0]) || 0;
  var tooltipHeight = ui.useNodeHeight(tooltipRef) || 0; // arrow 방향에 따라 width || height 값을 넘겨줌

  var tooltipSize = placement === 'bottom' || placement === 'top' ? tooltipWidth : tooltipHeight;
  return react.jsx(Container$1, null, react.jsx(Content, {
    variant: variant,
    hasRoundBorder: hasRoundBorder,
    isTwoLine: isTwoLine,
    ref: tooltipRef
  }, children, onClose && react.jsx(CloseButton, {
    type: "button",
    size: 32,
    icon: {
      name: 'dismiss',
      size: 16
    },
    onClick: onClose,
    isTwoLine: isTwoLine,
    variant: "base1"
  })), react.jsx(ArrowContainer, {
    options: options,
    tooltipSize: tooltipSize
  }));
};

var Container$1 = _styled__default['default']("div", {
  target: "e1v1g41q3"
})(FONT_STYLE.body2, ";letter-spacing:", pxToRem(-0.3), ";position:relative;gap:", pxToRem(10), ";display:inline-block;");

var cssBackgroundColor = function cssBackgroundColor(theme, variant) {
  switch (variant) {
    case 'dark':
      return theme.layer.dark;

    case 'light':
      return theme.layer.light;
  }
};

var cssFontColor = function cssFontColor(theme, variant) {
  switch (variant) {
    case 'dark':
      return theme.content.white;

    case 'light':
      return theme.content.base1;
  }
};

var Content = _styled__default['default']("div", {
  target: "e1v1g41q2"
})("padding:", pxToRem(8), " ", pxToRem(12), ";border-radius:", function (_ref2) {
  var hasRoundBorder = _ref2.hasRoundBorder;
  return hasRoundBorder ? pxToRem(20) : pxToRem(4);
}, ";color:", function (_ref3) {
  var theme = _ref3.theme,
      variant = _ref3.variant;
  return cssFontColor(theme, variant);
}, ";background-color:", function (_ref4) {
  var theme = _ref4.theme,
      variant = _ref4.variant;
  return cssBackgroundColor(theme, variant);
}, ";align-items:", function (_ref5) {
  var isTwoLine = _ref5.isTwoLine;
  return isTwoLine ? 'flex-start' : 'center';
}, ";margin:auto;white-space:pre-line;display:flex;flex-direction:row;");

var CloseButton = /*#__PURE__*/_styled__default['default'](IconButton, {
  target: "e1v1g41q1"
})("margin-top:", function (_ref6) {
  var isTwoLine = _ref6.isTwoLine;
  return isTwoLine && "".concat(pxToRem(-6));
}, ";margin-right:", pxToRem(-8), ";cursor:pointer;");

var createArrowShape = function createArrowShape(theme, options) {
  var arrow = options.arrow,
      variant = options.variant;

  switch (arrow.placement) {
    case 'top':
      return /*#__PURE__*/react.css("border-bottom:", pxToRem(ARROW_SIZE.height), " solid ", cssBackgroundColor(theme, variant), ";border-left:", pxToRem(ARROW_SIZE.width / 2), " solid transparent;border-right:", pxToRem(ARROW_SIZE.width / 2), " solid transparent;");

    case 'left':
      return /*#__PURE__*/react.css("border-right:", pxToRem(ARROW_SIZE.height), " solid ", cssBackgroundColor(theme, variant), ";border-bottom:", pxToRem(ARROW_SIZE.width / 2), " solid transparent;border-top:", pxToRem(ARROW_SIZE.width / 2), " solid transparent;");

    case 'right':
      return /*#__PURE__*/react.css("border-left:", pxToRem(ARROW_SIZE.height), " solid ", cssBackgroundColor(theme, variant), ";border-bottom:", pxToRem(ARROW_SIZE.width / 2), " solid transparent;border-top:", pxToRem(ARROW_SIZE.width / 2), " solid transparent;");

    case 'bottom':
      return /*#__PURE__*/react.css("border-top:", pxToRem(ARROW_SIZE.height), " solid ", cssBackgroundColor(theme, variant), ";border-left:", pxToRem(ARROW_SIZE.width / 2), " solid transparent;border-right:", pxToRem(ARROW_SIZE.width / 2), " solid transparent;");
  }
};

var createArrowPlacement = function createArrowPlacement(tooltipSize, options) {
  var arrow = options.arrow;
  var placement = arrow.placement,
      align = arrow.align,
      alignLocation = arrow.alignLocation;
  var bottomHeight = placement === 'bottom' ? ARROW_SIZE.height : 0;
  var arrowLocation = align === 'center' ? 'left' : align;
  var arrowAlign = align !== 'center' && alignLocation ? Math.min(alignLocation, tooltipSize) : tooltipSize / 2 - TOOLTIP_MARGIN;

  switch (placement) {
    case 'top':
    case 'bottom':
      return /*#__PURE__*/react.css(placement, ":", pxToRem(-10 + bottomHeight), ";", arrowLocation, ":", pxToRem(arrowAlign), ";");

    case 'right':
    case 'left':
      return /*#__PURE__*/react.css("top:", pxToRem(arrowAlign), ";", placement, ":", pxToRem(-10), ";");
  }
};

var ArrowContainer = _styled__default['default']("div", {
  target: "e1v1g41q0"
})("width:", pxToRem(ARROW_SIZE.width), ";height:", pxToRem(ARROW_SIZE.height), ";&::after{content:'';position:absolute;", function (_ref7) {
  var theme = _ref7.theme,
      options = _ref7.options;
  return createArrowShape(theme, options);
}, " ", function (_ref8) {
  var tooltipSize = _ref8.tooltipSize,
      options = _ref8.options;
  return createArrowPlacement(tooltipSize, options);
}, ";}");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var Dropdown = function Dropdown(_ref) {
  var dropdownRef = _ref.dropdownRef,
      title = _ref.title,
      items = _ref.items,
      _onClick = _ref.onClick,
      onCloseDropdown = _ref.onCloseDropdown,
      onClose = _ref.onClose,
      _ref$selectedItemId = _ref.selectedItemId,
      selectedItemId = _ref$selectedItemId === void 0 ? -1 : _ref$selectedItemId,
      _ref$isPopupInMobile = _ref.isPopupInMobile,
      isPopupInMobile = _ref$isPopupInMobile === void 0 ? false : _ref$isPopupInMobile;
  var isMobile = useResponsive().breakpoint === 'mobile';
  var listItemRef = React.useRef(null);
  var listItemHeight = ui.useNodeHeight(listItemRef); // PC의 경우 최대 10.5개의 아이템 노출

  var maxDropdownHeight = React.useMemo(function () {
    return listItemHeight * 10.5;
  }, [listItemHeight]);
  var modalWidthProps = React.useMemo(function () {
    return isMobile && isPopupInMobile ? {
      width: 300,
      isPopupInMobile: true
    } : {
      width: 600
    };
  }, [isMobile, isPopupInMobile]);
  return react.jsx("div", {
    ref: dropdownRef,
    onClick: function onClick(e) {
      return onCloseDropdown(e);
    }
  }, isMobile ? react.jsx(Modal, _extends({}, modalWidthProps, {
    onBlur: onClose,
    header: {
      title: title,
      onClose: onClose
    }
  }), react.jsx(ListItemWrapper, null, items.map(function (item) {
    return react.jsx(Item, {
      size: "basic",
      key: item.id,
      onClick: function onClick() {
        return _onClick(item.id);
      },
      selected: item.id === selectedItemId
    }, item.value);
  }))) : react.jsx(Container, {
    maxDropdownHeight: maxDropdownHeight
  }, items.map(function (item) {
    return (// TODO: disabled 기능 추가
      react.jsx(Item, {
        size: "basic",
        key: item.id,
        onClick: function onClick() {
          return _onClick(item.id);
        },
        forwardedRef: listItemRef,
        selected: item.id === selectedItemId
      }, item.value)
    );
  })));
};

var Container = _styled__default['default']("div", {
  target: "e1gfnv092"
})("border-radius:", pxToRem(4), ";max-height:", function (_ref2) {
  var maxDropdownHeight = _ref2.maxDropdownHeight;
  return pxToRem(maxDropdownHeight);
}, ";overflow-y:auto;z-index:1;", function (_ref3) {
  var theme = _ref3.theme;
  return /*#__PURE__*/react.css("border:", pxToRem(1), " solid ", theme.content.base4, ";background-color:", theme.background.elevated, ";box-shadow:", theme.shadow.thin, ";");
}, ";");

var ListItemWrapper = _styled__default['default']("div", {
  target: "e1gfnv091"
})( true ? {
  name: "umwchj",
  styles: "overflow-y:auto"
} : 0);

var Item = /*#__PURE__*/_styled__default['default'](ListItem, {
  target: "e1gfnv090"
})( true ? {
  name: "1ud33u0",
  styles: "cursor:pointer;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;text-align:left;&:active{font-weight:700;}"
} : 0);

var SEARCH_TYPE = {
  TOTAL: 'total',
  STORE: 'store',
  EXPERT: 'expert_user'
};

__webpack_unused_export__ = ({
  enumerable: true,
  get: function () {
    return ui.BaseSticky;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function () {
    return ui.DEFAULT_STICKY_STATE;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function () {
    return ui.ScrollSticky;
  }
});
Object.defineProperty(exports, "Lei", ({
  enumerable: true,
  get: function () {
    return ui.Sticky;
  }
}));
__webpack_unused_export__ = ({
  enumerable: true,
  get: function () {
    return ui.StickyControlContext;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function () {
    return ui.StickyProvider;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function () {
    return ui.StickyValueContext;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function () {
    return ui.assertStickyParentPosition;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function () {
    return ui.getStickyChildStyle;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function () {
    return ui.getStickyContainerStyle;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function () {
    return ui.getUpdatedStickyState;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function () {
    return ui.hasStickyStateChanged;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function () {
    return ui.useBaseSticky;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function () {
    return ui.useGetStickyHeight;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function () {
    return ui.useNodeHeight;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function () {
    return ui.useScrollAppear;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function () {
    return ui.useScrollDirection;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function () {
    return ui.useSticky;
  }
});
__webpack_unused_export__ = ADDRESS;
exports.ANg = AnchorButton;
__webpack_unused_export__ = AnchorButtonWithIcon;
__webpack_unused_export__ = AppDownloadPopup;
__webpack_unused_export__ = AppDownloadPopupContainer;
exports.qEK = Avatar;
exports.sOZ = BREAK_POINT;
exports.Lam = BREAK_POINT_NAMES;
__webpack_unused_export__ = BUCKETPLACE_HOMEPAGE_URL;
exports.Mdh = BdsProvider;
__webpack_unused_export__ = Breadcrumb;
exports.zxk = Button$1;
exports.Ain = ButtonWithIcon;
exports.bdp = COLUMN_PRESET;
__webpack_unused_export__ = COPYRIGHT_TEXT;
__webpack_unused_export__ = Callout;
__webpack_unused_export__ = Carousel;
__webpack_unused_export__ = CarouselControl;
exports.SOM = CarouselControlButton;
exports.ffs = CarouselScrollControl;
__webpack_unused_export__ = Checkbox$1;
__webpack_unused_export__ = CheckboxWithText;
__webpack_unused_export__ = Chip;
__webpack_unused_export__ = CircleBadge;
__webpack_unused_export__ = CircleImage;
__webpack_unused_export__ = Column;
__webpack_unused_export__ = CompanyInfoContainer;
__webpack_unused_export__ = CompanyLink;
__webpack_unused_export__ = Container$4;
__webpack_unused_export__ = CounterHint;
__webpack_unused_export__ = DARK_THEME;
exports.SHs = DEFAULT_GAP;
__webpack_unused_export__ = Dim;
__webpack_unused_export__ = DimLoading;
exports.izJ = Divider$1;
exports.vkq = DividerListItem;
__webpack_unused_export__ = DotNotification;
__webpack_unused_export__ = Dropdown;
__webpack_unused_export__ = EMAIL;
exports.nn_ = EmptyPage;
__webpack_unused_export__ = ExtendedFab;
__webpack_unused_export__ = ExtendedFabWithIcon;
__webpack_unused_export__ = FETCH_STATUS;
__webpack_unused_export__ = FOCUS;
exports.rZ9 = FONT_STYLE;
__webpack_unused_export__ = Fab;
__webpack_unused_export__ = FileButton;
__webpack_unused_export__ = FileButtonWithIcon;
__webpack_unused_export__ = FillOutlineSelectChip;
__webpack_unused_export__ = FixedTab;
__webpack_unused_export__ = Footer;
__webpack_unused_export__ = FooterComponenet;
__webpack_unused_export__ = GLOBAL_IMPORT_FONT;
__webpack_unused_export__ = GLOBAL_IMPORT_ICON;
__webpack_unused_export__ = GLOBAL_STYLE;
__webpack_unused_export__ = GLOBAL_STYLE_FONT;
__webpack_unused_export__ = GLOBAL_STYLE_ICON;
exports.rjZ = Grid;
exports.P4e = GridItem;
__webpack_unused_export__ = HOVER;
__webpack_unused_export__ = Hint;
exports.JO$ = Icon;
__webpack_unused_export__ = IconFab;
__webpack_unused_export__ = IconNotification;
__webpack_unused_export__ = Image;
__webpack_unused_export__ = ImageAttachedItem;
__webpack_unused_export__ = ImageUploadButton;
__webpack_unused_export__ = IndicatorDots;
__webpack_unused_export__ = IndicatorNumber;
__webpack_unused_export__ = IndicatorNumberWithIcon;
__webpack_unused_export__ = Input$1;
__webpack_unused_export__ = InputChip;
__webpack_unused_export__ = InputWithCountHint;
exports.vu = InputWithHint;
__webpack_unused_export__ = InputWithThumbnail;
__webpack_unused_export__ = LIGHT_THEME;
__webpack_unused_export__ = LinearProgressBar;
__webpack_unused_export__ = ListItem;
__webpack_unused_export__ = Loading;
exports.PrW = MEDIA_QUERY;
__webpack_unused_export__ = MobileTopBanner;
exports.u_l = Modal;
__webpack_unused_export__ = MoreAnchor;
exports.W_F = Navigation;
__webpack_unused_export__ = NavigationBar;
__webpack_unused_export__ = NavigationDrawer;
__webpack_unused_export__ = NavigationRightButton;
__webpack_unused_export__ = NavigationSearch;
exports.ZiW = NavigationTopBanner;
__webpack_unused_export__ = NotSupportedBrowser;
__webpack_unused_export__ = NotificationType;
__webpack_unused_export__ = NumberNotification;
__webpack_unused_export__ = OPENING_HOUR;
exports.wbw = OhouseFooter;
__webpack_unused_export__ = OhouseSimpleFooter;
__webpack_unused_export__ = OutlineAnchorButton;
__webpack_unused_export__ = OutlineAnchorButtonWithIcon;
__webpack_unused_export__ = OutlineButton;
exports.BC7 = OutlineButtonWithIcon;
__webpack_unused_export__ = OutlineFileButton;
__webpack_unused_export__ = OutlineFileButtonWithIcon;
__webpack_unused_export__ = OutlineSelectChip;
__webpack_unused_export__ = PCTopBanner;
__webpack_unused_export__ = PHONE_NUMBER;
__webpack_unused_export__ = Pagination$1;
__webpack_unused_export__ = PillBadge;
__webpack_unused_export__ = Popper;
__webpack_unused_export__ = PrimaryRight;
__webpack_unused_export__ = RESET_BUTTON;
__webpack_unused_export__ = RESET_INPUT;
__webpack_unused_export__ = Radio;
__webpack_unused_export__ = RadioWithText;
__webpack_unused_export__ = Ranking;
exports.uxO = ResizeImage;
__webpack_unused_export__ = Responsive;
__webpack_unused_export__ = Row$1;
exports.VOb = SEARCH_TYPE;
exports.wVl = SHADOW_STYLE;
__webpack_unused_export__ = STORE_CATEGORIES;
__webpack_unused_export__ = Search;
__webpack_unused_export__ = SectionTitle;
exports.PhF = Select;
__webpack_unused_export__ = SelectButton;
exports.WKm = SelectChip;
__webpack_unused_export__ = SelectWithHint;
__webpack_unused_export__ = SimpleFooter;
exports.zRs = SquareBadge;
exports.DWR = StoreCategory;
exports.PgY = TOTAL_COLUMN;
exports.zY_ = TYPE_MAP;
__webpack_unused_export__ = Tab;
__webpack_unused_export__ = TabItem;
__webpack_unused_export__ = Table;
__webpack_unused_export__ = TableData;
__webpack_unused_export__ = TableHeader;
__webpack_unused_export__ = TableHeaderWithAction;
__webpack_unused_export__ = TableRow;
exports.Avr = TextButton;
__webpack_unused_export__ = TextButtonWithIcon;
__webpack_unused_export__ = Textarea;
__webpack_unused_export__ = TextareaWithCountHint;
__webpack_unused_export__ = TextareaWithHint;
__webpack_unused_export__ = TextareaWithThumbnail;
__webpack_unused_export__ = ThumbnailAnchor;
__webpack_unused_export__ = ThumbnailAnchorWithBadge;
__webpack_unused_export__ = Toggle;
exports.COr = ToggleButton;
__webpack_unused_export__ = Tooltip;
__webpack_unused_export__ = TopBannerContainer;
__webpack_unused_export__ = UploadDropdownContentButton;
__webpack_unused_export__ = UploadDropdownContentItem;
__webpack_unused_export__ = UserDropdownContentButton;
__webpack_unused_export__ = UserDropdownContentItem;
__webpack_unused_export__ = VirtualizedList;
__webpack_unused_export__ = createCachedFetch;
exports.xd5 = createOhouseFooterLinkSchema;
__webpack_unused_export__ = createOhouseSimpleFooterLinkSchema;
__webpack_unused_export__ = createScrollStorage;
__webpack_unused_export__ = cssDimmed;
__webpack_unused_export__ = cssFontWeight;
__webpack_unused_export__ = cssSize$2;
__webpack_unused_export__ = decomposeHangul;
__webpack_unused_export__ = getDeviceInfo;
__webpack_unused_export__ = getImageSrcSet;
__webpack_unused_export__ = getImageUrl;
__webpack_unused_export__ = getNearestSize;
__webpack_unused_export__ = getTextButtonWithIconOptions;
__webpack_unused_export__ = hexToRgba;
__webpack_unused_export__ = isHigherAppVersion;
__webpack_unused_export__ = omitKeys;
__webpack_unused_export__ = openPopup;
__webpack_unused_export__ = pickIfExists;
exports.Q1c = pxToRem;
exports.m4f = rgba;
__webpack_unused_export__ = safeAreaInset;
__webpack_unused_export__ = useAutoComplete;
__webpack_unused_export__ = useChanged;
__webpack_unused_export__ = useForkRef;
__webpack_unused_export__ = useIEDetector;
exports.QNF = useIsInApp;
__webpack_unused_export__ = useKakaoChat;
__webpack_unused_export__ = useMatchMedia;
__webpack_unused_export__ = useMedia;
__webpack_unused_export__ = useNodeSizeObserver;
__webpack_unused_export__ = usePagedCursorInfiniteList;
__webpack_unused_export__ = usePagedInfiniteList;
__webpack_unused_export__ = useResize;
exports.Fs8 = useResponsive;
exports.Ds_ = useSnackbar;
__webpack_unused_export__ = useWindowsOSDetector;


/***/ }),

/***/ 57322:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var React = __webpack_require__(67294);

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return n;
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var observerMap = new Map();
var RootIds = new WeakMap();
var rootId = 0;
var unsupportedValue = undefined;
/**
 * What should be the default behavior if the IntersectionObserver is unsupported?
 * Ideally the polyfill has been loaded, you can have the following happen:
 * - `undefined`: Throw an error
 * - `true` or `false`: Set the `inView` value to this regardless of intersection state
 * **/
function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
/**
 * Generate a unique ID for the root element
 * @param root
 */
function getRootId(root) {
  if (!root) return '0';
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */
function optionsToId(options) {
  return Object.keys(options).sort().filter(function (key) {
    return options[key] !== undefined;
  }).map(function (key) {
    return key + "_" + (key === 'root' ? getRootId(options.root) : options[key]);
  }).toString();
}
function createObserver(options) {
  // Create a unique ID for this observer instance, based on the root, root margin and threshold.
  var id = optionsToId(options);
  var instance = observerMap.get(id);
  if (!instance) {
    // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
    var elements = new Map();
    var thresholds;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var _elements$get;
        // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
        // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
        var inView = entry.isIntersecting && thresholds.some(function (threshold) {
          return entry.intersectionRatio >= threshold;
        });
        // @ts-ignore support IntersectionObserver v2
        if (options.trackVisibility && typeof entry.isVisible === 'undefined') {
          // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
          // @ts-ignore
          entry.isVisible = inView;
        }
        (_elements$get = elements.get(entry.target)) == null ? void 0 : _elements$get.forEach(function (callback) {
          callback(inView, entry);
        });
      });
    }, options);
    // Ensure we have a valid thresholds array. If not, use the threshold from the options
    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id: id,
      observer: observer,
      elements: elements
    };
    observerMap.set(id, instance);
  }
  return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */
function observe(element, callback, options, fallbackInView) {
  if (options === void 0) {
    options = {};
  }
  if (fallbackInView === void 0) {
    fallbackInView = unsupportedValue;
  }
  if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
    var bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return function () {
      // Nothing to cleanup
    };
  }
  // An observer with the same options can be reused, so lets use this fact
  var _createObserver = createObserver(options),
    id = _createObserver.id,
    observer = _createObserver.observer,
    elements = _createObserver.elements;
  // Register the callback listener for this element
  var callbacks = elements.get(element) || [];
  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }
  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    // Remove the callback from the callback list
    callbacks.splice(callbacks.indexOf(callback), 1);
    if (callbacks.length === 0) {
      // No more callback exists for element, so destroy it
      elements["delete"](element);
      observer.unobserve(element);
    }
    if (elements.size === 0) {
      // No more elements are being observer by this instance, so destroy it
      observer.disconnect();
      observerMap["delete"](id);
    }
  };
}

var _excluded = ["children", "as", "triggerOnce", "threshold", "root", "rootMargin", "onChange", "skip", "trackVisibility", "delay", "initialInView", "fallbackInView"];
function isPlainChildren(props) {
  return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */
var InView = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(InView, _React$Component);
  function InView(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.node = null;
    _this._unobserveCb = null;
    _this.handleNode = function (node) {
      if (_this.node) {
        // Clear the old observer, before we start observing a new element
        _this.unobserve();
        if (!node && !_this.props.triggerOnce && !_this.props.skip) {
          // Reset the state if we get a new node, and we aren't ignoring updates
          _this.setState({
            inView: !!_this.props.initialInView,
            entry: undefined
          });
        }
      }
      _this.node = node ? node : null;
      _this.observeNode();
    };
    _this.handleChange = function (inView, entry) {
      if (inView && _this.props.triggerOnce) {
        // If `triggerOnce` is true, we should stop observing the element.
        _this.unobserve();
      }
      if (!isPlainChildren(_this.props)) {
        // Store the current State, so we can pass it to the children in the next render update
        // There's no reason to update the state for plain children, since it's not used in the rendering.
        _this.setState({
          inView: inView,
          entry: entry
        });
      }
      if (_this.props.onChange) {
        // If the user is actively listening for onChange, always trigger it
        _this.props.onChange(inView, entry);
      }
    };
    _this.state = {
      inView: !!props.initialInView,
      entry: undefined
    };
    return _this;
  }
  var _proto = InView.prototype;
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    // If a IntersectionObserver option changed, reinit the observer
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unobserve();
    this.node = null;
  };
  _proto.observeNode = function observeNode() {
    if (!this.node || this.props.skip) return;
    var _this$props = this.props,
      threshold = _this$props.threshold,
      root = _this$props.root,
      rootMargin = _this$props.rootMargin,
      trackVisibility = _this$props.trackVisibility,
      delay = _this$props.delay,
      fallbackInView = _this$props.fallbackInView;
    this._unobserveCb = observe(this.node, this.handleChange, {
      threshold: threshold,
      root: root,
      rootMargin: rootMargin,
      // @ts-ignore
      trackVisibility: trackVisibility,
      // @ts-ignore
      delay: delay
    }, fallbackInView);
  };
  _proto.unobserve = function unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();
      this._unobserveCb = null;
    }
  };
  _proto.render = function render() {
    if (!isPlainChildren(this.props)) {
      var _this$state = this.state,
        inView = _this$state.inView,
        entry = _this$state.entry;
      return this.props.children({
        inView: inView,
        entry: entry,
        ref: this.handleNode
      });
    }
    var _this$props2 = this.props,
      children = _this$props2.children,
      as = _this$props2.as,
      props = _objectWithoutPropertiesLoose(_this$props2, _excluded);
    return React__namespace.createElement(as || 'div', _extends({
      ref: this.handleNode
    }, props), children);
  };
  return InView;
}(React__namespace.Component);

/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */
function useInView(_temp) {
  var _state$entry;
  var _ref = _temp === void 0 ? {} : _temp,
    threshold = _ref.threshold,
    delay = _ref.delay,
    trackVisibility = _ref.trackVisibility,
    rootMargin = _ref.rootMargin,
    root = _ref.root,
    triggerOnce = _ref.triggerOnce,
    skip = _ref.skip,
    initialInView = _ref.initialInView,
    fallbackInView = _ref.fallbackInView,
    onChange = _ref.onChange;
  var _React$useState = React__namespace.useState(null),
    ref = _React$useState[0],
    setRef = _React$useState[1];
  var callback = React__namespace.useRef();
  var _React$useState2 = React__namespace.useState({
      inView: !!initialInView,
      entry: undefined
    }),
    state = _React$useState2[0],
    setState = _React$useState2[1];
  // Store the onChange callback in a `ref`, so we can access the latest instance
  // inside the `useEffect`, but without triggering a rerender.
  callback.current = onChange;
  React__namespace.useEffect(function () {
    // Ensure we have node ref, and that we shouldn't skip observing
    if (skip || !ref) return;
    var unobserve;
    unobserve = observe(ref, function (inView, entry) {
      setState({
        inView: inView,
        entry: entry
      });
      if (callback.current) callback.current(inView, entry);
      if (entry.isIntersecting && triggerOnce && unobserve) {
        // If it should only trigger once, unobserve the element after it's inView
        unobserve();
        unobserve = undefined;
      }
    }, {
      root: root,
      rootMargin: rootMargin,
      threshold: threshold,
      // @ts-ignore
      trackVisibility: trackVisibility,
      // @ts-ignore
      delay: delay
    }, fallbackInView);
    return function () {
      if (unobserve) {
        unobserve();
      }
    };
  },
  // We break the rule here, because we aren't including the actual `threshold` variable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [
  // If the threshold is an array, convert it to a string, so it won't change between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  Array.isArray(threshold) ? threshold.toString() : threshold, ref, root, rootMargin, triggerOnce, skip, trackVisibility, fallbackInView, delay]);
  var entryTarget = (_state$entry = state.entry) == null ? void 0 : _state$entry.target;
  var previousEntryTarget = React__namespace.useRef();
  if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
    // If we don't have a node ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
    // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
    previousEntryTarget.current = entryTarget;
    setState({
      inView: !!initialInView,
      entry: undefined
    });
  }
  var result = [setRef, state.inView, state.entry];
  // Support object destructuring, by adding the specific values.
  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}

exports.InView = InView;
exports.defaultFallbackInView = defaultFallbackInView;
exports.observe = observe;
exports.useInView = useInView;
//# sourceMappingURL=react-intersection-observer.js.map


/***/ }),

/***/ 49374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Manager": function() { return /* reexport */ Manager; },
  "Popper": function() { return /* reexport */ Popper; },
  "Reference": function() { return /* reexport */ Reference; },
  "usePopper": function() { return /* reexport */ usePopper; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/react-popper/lib/esm/Manager.js

var ManagerReferenceNodeContext = react.createContext();
var ManagerReferenceNodeSetterContext = react.createContext();
function Manager(_ref) {
  var children = _ref.children;

  var _React$useState = react.useState(null),
      referenceNode = _React$useState[0],
      setReferenceNode = _React$useState[1];

  var hasUnmounted = react.useRef(false);
  react.useEffect(function () {
    return function () {
      hasUnmounted.current = true;
    };
  }, []);
  var handleSetReferenceNode = react.useCallback(function (node) {
    if (!hasUnmounted.current) {
      setReferenceNode(node);
    }
  }, []);
  return /*#__PURE__*/react.createElement(ManagerReferenceNodeContext.Provider, {
    value: referenceNode
  }, /*#__PURE__*/react.createElement(ManagerReferenceNodeSetterContext.Provider, {
    value: handleSetReferenceNode
  }, children));
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/react-popper/lib/esm/utils.js


/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === 'function') {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};
/**
 * Sets a ref using either a ref callback or a ref object
 */

var setRef = function setRef(ref, node) {
  // if its a function call it
  if (typeof ref === 'function') {
    return safeInvoke(ref, node);
  } // otherwise we should treat it as a ref object
  else if (ref != null) {
      ref.current = node;
    }
};
/**
 * Simple ponyfill for Object.fromEntries
 */

var fromEntries = function fromEntries(entries) {
  return entries.reduce(function (acc, _ref) {
    var key = _ref[0],
        value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
/**
 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
 */

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? react.useLayoutEffect : react.useEffect;
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/dom-utils/getWindow.js
function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/dom-utils/instanceOf.js


function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}


;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/utils/math.js
var math_max = Math.max;
var math_min = Math.min;
var round = Math.round;
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/utils/userAgent.js
function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/dom-utils/isLayoutViewport.js

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js




function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = isElement(element) ? getWindow(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js




function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js



function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js









function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js
 // Returns the layout rect of an element relative to its offsetParent. Layout
// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/dom-utils/getParentNode.js



function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js




function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js




/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/dom-utils/isTableElement.js

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js








function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/enums.js
var enums_top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [enums_top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var enums_placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/utils/orderModifiers.js
 // source: https://stackoverflow.com/questions/49875255

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/utils/debounce.js
function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/utils/mergeByName.js
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/createPopper.js














var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned
        // if one of the modifiers is invalid for any reason

        if (false) { var _getComputedStyle, marginTop, marginRight, marginBottom, marginLeft, flipModifier, modifiers; }

        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          if (false) {}

          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        var __debug_loops__ = 0;

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (false) {}

          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      if (false) {}

      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options = _ref3$options === void 0 ? {} : _ref3$options,
            effect = _ref3.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}
var createPopper = /*#__PURE__*/(/* unused pure expression or super */ null && (popperGenerator())); // eslint-disable-next-line import/no-unused-modules


;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/modifiers/eventListeners.js
 // eslint-disable-next-line import/no-unused-modules

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var eventListeners = ({
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
});
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/utils/getBasePlacement.js

function getBasePlacement(placement) {
  return placement.split('-')[0];
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/utils/getVariation.js
function getVariation(placement) {
  return placement.split('-')[1];
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js
function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/utils/computeOffsets.js




function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case enums_top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;

      default:
    }
  }

  return offsets;
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/modifiers/popperOffsets.js


function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_popperOffsets = ({
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
});
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/modifiers/computeStyles.js







 // eslint-disable-next-line import/no-unused-modules

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = enums_top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === enums_top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === enums_top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

  if (false) { var transitionProperty; }

  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_computeStyles = ({
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
});
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/modifiers/applyStyles.js

 // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function applyStyles_effect(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_applyStyles = ({
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: applyStyles_effect,
  requires: ['computeStyles']
});
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/modifiers/offset.js

 // eslint-disable-next-line import/no-unused-modules

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, enums_top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = enums_placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_offset = ({
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
});
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/utils/getOppositePlacement.js
var hash = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/utils/getOppositeVariationPlacement.js
var getOppositeVariationPlacement_hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return getOppositeVariationPlacement_hash[matched];
  });
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js




function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/dom-utils/getDocumentRect.js




 // Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = math_max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = math_max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle(body || html).direction === 'rtl') {
    x += math_max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/dom-utils/contains.js

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/utils/rectToClientRect.js
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js















function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = math_max(rect.top, accRect.top);
    accRect.right = math_min(rect.right, accRect.right);
    accRect.bottom = math_min(rect.bottom, accRect.bottom);
    accRect.left = math_max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/utils/getFreshSideObject.js
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/utils/mergePaddingObject.js

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/utils/expandToHashMap.js
function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/utils/detectOverflow.js








 // eslint-disable-next-line import/no-unused-modules

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [enums_top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/utils/computeAutoPlacement.js




function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? enums_placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements;

    if (false) {}
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/modifiers/flip.js






 // eslint-disable-next-line import/no-unused-modules

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [enums_top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : enums_top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_flip = ({
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
});
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/utils/getAltAxis.js
function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/utils/within.js

function within(min, value, max) {
  return math_max(min, math_min(value, max));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/modifiers/preventOverflow.js












function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? enums_top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = offset + overflow[mainSide];
    var max = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? math_min(min, tetherMin) : min, offset, tether ? math_max(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? enums_top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [enums_top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_preventOverflow = ({
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
});
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/modifiers/arrow.js









 // eslint-disable-next-line import/no-unused-modules

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? enums_top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function arrow_effect(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (false) {}

  if (!contains(state.elements.popper, arrowElement)) {
    if (false) {}

    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_arrow = ({
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: arrow_effect,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
});
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/modifiers/hide.js



function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [enums_top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_hide = ({
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
});
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@popperjs/core/lib/popper.js










var defaultModifiers = [eventListeners, modifiers_popperOffsets, modifiers_computeStyles, modifiers_applyStyles, modifiers_offset, modifiers_flip, modifiers_preventOverflow, modifiers_arrow, modifiers_hide];
var popper_createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules


// EXTERNAL MODULE: ./node_modules/react-fast-compare/index.js
var react_fast_compare = __webpack_require__(69590);
var react_fast_compare_default = /*#__PURE__*/__webpack_require__.n(react_fast_compare);
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/react-popper/lib/esm/usePopper.js





var EMPTY_MODIFIERS = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }

  var prevOptions = react.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute',
    modifiers: options.modifiers || EMPTY_MODIFIERS
  };

  var _React$useState = react.useState({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: '0',
        top: '0'
      },
      arrow: {
        position: 'absolute'
      }
    },
    attributes: {}
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var updateStateModifier = react.useMemo(function () {
    return {
      name: 'updateState',
      enabled: true,
      phase: 'write',
      fn: function fn(_ref) {
        var state = _ref.state;
        var elements = Object.keys(state.elements);
        react_dom.flushSync(function () {
          setState({
            styles: fromEntries(elements.map(function (element) {
              return [element, state.styles[element] || {}];
            })),
            attributes: fromEntries(elements.map(function (element) {
              return [element, state.attributes[element]];
            }))
          });
        });
      },
      requires: ['computeStyles']
    };
  }, []);
  var popperOptions = react.useMemo(function () {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: 'applyStyles',
        enabled: false
      }])
    };

    if (react_fast_compare_default()(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = react.useRef();
  useIsomorphicLayoutEffect(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function () {
    if (referenceElement == null || popperElement == null) {
      return;
    }

    var createPopper = options.createPopper || popper_createPopper;
    var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function () {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/react-popper/lib/esm/Popper.js





var NOOP = function NOOP() {
  return void 0;
};

var NOOP_PROMISE = function NOOP_PROMISE() {
  return Promise.resolve(null);
};

var Popper_EMPTY_MODIFIERS = [];
function Popper(_ref) {
  var _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
      _ref$strategy = _ref.strategy,
      strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy,
      _ref$modifiers = _ref.modifiers,
      modifiers = _ref$modifiers === void 0 ? Popper_EMPTY_MODIFIERS : _ref$modifiers,
      referenceElement = _ref.referenceElement,
      onFirstUpdate = _ref.onFirstUpdate,
      innerRef = _ref.innerRef,
      children = _ref.children;
  var referenceNode = react.useContext(ManagerReferenceNodeContext);

  var _React$useState = react.useState(null),
      popperElement = _React$useState[0],
      setPopperElement = _React$useState[1];

  var _React$useState2 = react.useState(null),
      arrowElement = _React$useState2[0],
      setArrowElement = _React$useState2[1];

  react.useEffect(function () {
    setRef(innerRef, popperElement);
  }, [innerRef, popperElement]);
  var options = react.useMemo(function () {
    return {
      placement: placement,
      strategy: strategy,
      onFirstUpdate: onFirstUpdate,
      modifiers: [].concat(modifiers, [{
        name: 'arrow',
        enabled: arrowElement != null,
        options: {
          element: arrowElement
        }
      }])
    };
  }, [placement, strategy, onFirstUpdate, modifiers, arrowElement]);

  var _usePopper = usePopper(referenceElement || referenceNode, popperElement, options),
      state = _usePopper.state,
      styles = _usePopper.styles,
      forceUpdate = _usePopper.forceUpdate,
      update = _usePopper.update;

  var childrenProps = react.useMemo(function () {
    return {
      ref: setPopperElement,
      style: styles.popper,
      placement: state ? state.placement : placement,
      hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
      isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
      arrowProps: {
        style: styles.arrow,
        ref: setArrowElement
      },
      forceUpdate: forceUpdate || NOOP,
      update: update || NOOP_PROMISE
    };
  }, [setPopperElement, setArrowElement, placement, state, styles, update, forceUpdate]);
  return unwrapArray(children)(childrenProps);
}
// EXTERNAL MODULE: ./node_modules/warning/warning.js
var warning = __webpack_require__(42473);
var warning_default = /*#__PURE__*/__webpack_require__.n(warning);
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/react-popper/lib/esm/Reference.js




function Reference(_ref) {
  var children = _ref.children,
      innerRef = _ref.innerRef;
  var setReferenceNode = react.useContext(ManagerReferenceNodeSetterContext);
  var refHandler = react.useCallback(function (node) {
    setRef(innerRef, node);
    safeInvoke(setReferenceNode, node);
  }, [innerRef, setReferenceNode]); // ran on unmount
  // eslint-disable-next-line react-hooks/exhaustive-deps

  react.useEffect(function () {
    return function () {
      return setRef(innerRef, null);
    };
  }, []);
  react.useEffect(function () {
    warning_default()(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
  }, [setReferenceNode]);
  return unwrapArray(children)({
    ref: refHandler
  });
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/react-popper/lib/esm/index.js
// Public components




 // Public types

/***/ }),

/***/ 20266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CSSTransition": function() { return /* reexport */ esm_CSSTransition; },
  "ReplaceTransition": function() { return /* reexport */ esm_ReplaceTransition; },
  "SwitchTransition": function() { return /* reexport */ esm_SwitchTransition; },
  "Transition": function() { return /* reexport */ esm_Transition; },
  "TransitionGroup": function() { return /* reexport */ esm_TransitionGroup; },
  "config": function() { return /* reexport */ config; }
});

;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@babel/runtime/helpers/esm/inheritsLoose.js

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/addClass.js + 1 modules
var esm_addClass = __webpack_require__(98544);
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/removeClass.js
var esm_removeClass = __webpack_require__(74277);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/react-transition-group/esm/config.js
/* harmony default export */ var config = ({
  disabled: false
});
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/react-transition-group/esm/TransitionGroupContext.js

/* harmony default export */ var TransitionGroupContext = (react.createContext(null));
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/react-transition-group/esm/utils/reflow.js
var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/react-transition-group/esm/Transition.js









var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) forceReflow(node);
        }

        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [react_dom.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : react_dom.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      react.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : react.cloneElement(react.Children.only(children), childProps))
    );
  };

  return Transition;
}(react.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes =  false ? 0 : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
/* harmony default export */ var esm_Transition = (Transition);
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/react-transition-group/esm/CSSTransition.js











var _addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0,esm_addClass/* default */.Z)(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0,esm_removeClass/* default */.Z)(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */


var CSSTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument[0],
          appearing = _this$resolveArgument[1];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };

    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument2[0],
          appearing = _this$resolveArgument2[1];

      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };

    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument3[0],
          appearing = _this$resolveArgument3[1];

      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };

    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument4[0];

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };

    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument5[0];

      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };

    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument6[0];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };

    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    var _this$getClassNames = this.getClassNames('enter'),
        doneClassName = _this$getClassNames.doneClassName;

    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is to force a repaint,
    // which is necessary in order to transition styles when adding a class name.


    if (phase === 'active') {
      if (node) forceReflow(node);
    }

    if (className) {
      this.appliedClasses[type][phase] = className;

      _addClass(node, className);
    }
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass(node, baseClassName);
    }

    if (activeClassName) {
      removeClass(node, activeClassName);
    }

    if (doneClassName) {
      removeClass(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        _ = _this$props.classNames,
        props = _objectWithoutPropertiesLoose(_this$props, ["classNames"]);

    return /*#__PURE__*/react.createElement(esm_Transition, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(react.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes =  false ? 0 : {};
/* harmony default export */ var esm_CSSTransition = (CSSTransition);
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/react-transition-group/esm/utils/ChildMapping.js

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0,react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0,react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0,react.isValidElement)(child)) return;
    var hasPrev = (key in prevChildMapping);
    var hasNext = (key in nextChildMapping);
    var prevChild = prevChildMapping[key];
    var isLeaving = (0,react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0,react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0,react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0,react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0,react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/react-transition-group/esm/TransitionGroup.js









var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_this)); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return /*#__PURE__*/react.createElement(TransitionGroupContext.Provider, {
        value: contextValue
      }, children);
    }

    return /*#__PURE__*/react.createElement(TransitionGroupContext.Provider, {
      value: contextValue
    }, /*#__PURE__*/react.createElement(Component, props, children));
  };

  return TransitionGroup;
}(react.Component);

TransitionGroup.propTypes =  false ? 0 : {};
TransitionGroup.defaultProps = defaultProps;
/* harmony default export */ var esm_TransitionGroup = (TransitionGroup);
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/react-transition-group/esm/ReplaceTransition.js






/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */

var ReplaceTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;
    var child = react.Children.toArray(children)[idx];
    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);

    if (this.props[handler]) {
      var maybeNode = child.props.nodeRef ? undefined : react_dom.findDOMNode(this);
      this.props[handler](maybeNode);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);

    var _React$Children$toArr = react.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return /*#__PURE__*/react.createElement(esm_TransitionGroup, props, inProp ? react.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : react.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(react.Component);

ReplaceTransition.propTypes =  false ? 0 : {};
/* harmony default export */ var esm_ReplaceTransition = (ReplaceTransition);
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/react-transition-group/esm/SwitchTransition.js


var _leaveRenders, _enterRenders;






function areChildrenDifferent(oldChildren, newChildren) {
  if (oldChildren === newChildren) return false;

  if (react.isValidElement(oldChildren) && react.isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) {
    return false;
  }

  return true;
}
/**
 * Enum of modes for SwitchTransition component
 * @enum { string }
 */


var modes = {
  out: 'out-in',
  in: 'in-out'
};

var callHook = function callHook(element, name, cb) {
  return function () {
    var _element$props;

    element.props[name] && (_element$props = element.props)[name].apply(_element$props, arguments);
    cb();
  };
};

var leaveRenders = (_leaveRenders = {}, _leaveRenders[modes.out] = function (_ref) {
  var current = _ref.current,
      changeState = _ref.changeState;
  return react.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(ENTERING, null);
    })
  });
}, _leaveRenders[modes.in] = function (_ref2) {
  var current = _ref2.current,
      changeState = _ref2.changeState,
      children = _ref2.children;
  return [current, react.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(ENTERING);
    })
  })];
}, _leaveRenders);
var enterRenders = (_enterRenders = {}, _enterRenders[modes.out] = function (_ref3) {
  var children = _ref3.children,
      changeState = _ref3.changeState;
  return react.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(ENTERED, react.cloneElement(children, {
        in: true
      }));
    })
  });
}, _enterRenders[modes.in] = function (_ref4) {
  var current = _ref4.current,
      children = _ref4.children,
      changeState = _ref4.changeState;
  return [react.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(ENTERED, react.cloneElement(children, {
        in: true
      }));
    })
  }), react.cloneElement(children, {
    in: true
  })];
}, _enterRenders);
/**
 * A transition component inspired by the [vue transition modes](https://vuejs.org/v2/guide/transitions.html#Transition-Modes).
 * You can use it when you want to control the render between state transitions.
 * Based on the selected mode and the child's key which is the `Transition` or `CSSTransition` component, the `SwitchTransition` makes a consistent transition between them.
 *
 * If the `out-in` mode is selected, the `SwitchTransition` waits until the old child leaves and then inserts a new child.
 * If the `in-out` mode is selected, the `SwitchTransition` inserts a new child first, waits for the new child to enter and then removes the old child.
 *
 * **Note**: If you want the animation to happen simultaneously
 * (that is, to have the old child removed and a new child inserted **at the same time**),
 * you should use
 * [`TransitionGroup`](https://reactcommunity.org/react-transition-group/transition-group)
 * instead.
 *
 * ```jsx
 * function App() {
 *  const [state, setState] = useState(false);
 *  return (
 *    <SwitchTransition>
 *      <CSSTransition
 *        key={state ? "Goodbye, world!" : "Hello, world!"}
 *        addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
 *        classNames='fade'
 *      >
 *        <button onClick={() => setState(state => !state)}>
 *          {state ? "Goodbye, world!" : "Hello, world!"}
 *        </button>
 *      </CSSTransition>
 *    </SwitchTransition>
 *  );
 * }
 * ```
 *
 * ```css
 * .fade-enter{
 *    opacity: 0;
 * }
 * .fade-exit{
 *    opacity: 1;
 * }
 * .fade-enter-active{
 *    opacity: 1;
 * }
 * .fade-exit-active{
 *    opacity: 0;
 * }
 * .fade-enter-active,
 * .fade-exit-active{
 *    transition: opacity 500ms;
 * }
 * ```
 */

var SwitchTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SwitchTransition, _React$Component);

  function SwitchTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      status: ENTERED,
      current: null
    };
    _this.appeared = false;

    _this.changeState = function (status, current) {
      if (current === void 0) {
        current = _this.state.current;
      }

      _this.setState({
        status: status,
        current: current
      });
    };

    return _this;
  }

  var _proto = SwitchTransition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  SwitchTransition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (props.children == null) {
      return {
        current: null
      };
    }

    if (state.status === ENTERING && props.mode === modes.in) {
      return {
        status: ENTERING
      };
    }

    if (state.current && areChildrenDifferent(state.current, props.children)) {
      return {
        status: EXITING
      };
    }

    return {
      current: react.cloneElement(props.children, {
        in: true
      })
    };
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        mode = _this$props.mode,
        _this$state = this.state,
        status = _this$state.status,
        current = _this$state.current;
    var data = {
      children: children,
      current: current,
      changeState: this.changeState,
      status: status
    };
    var component;

    switch (status) {
      case ENTERING:
        component = enterRenders[mode](data);
        break;

      case EXITING:
        component = leaveRenders[mode](data);
        break;

      case ENTERED:
        component = current;
    }

    return /*#__PURE__*/react.createElement(TransitionGroupContext.Provider, {
      value: {
        isMounting: !this.appeared
      }
    }, component);
  };

  return SwitchTransition;
}(react.Component);

SwitchTransition.propTypes =  false ? 0 : {};
SwitchTransition.defaultProps = {
  mode: modes.out
};
/* harmony default export */ var esm_SwitchTransition = (SwitchTransition);
;// CONCATENATED MODULE: ./node_modules/@bucketplace/design-system/node_modules/react-transition-group/esm/index.js







/***/ }),

/***/ 9710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "BaseSticky": function() { return /* reexport */ BaseSticky; },
  "Carousel": function() { return /* reexport */ Carousel; },
  "CoverResizeImage": function() { return /* reexport */ CoverResizeImage; },
  "DEFAULT_STICKY_STATE": function() { return /* reexport */ DEFAULT_STICKY_STATE; },
  "FocusTrapChild": function() { return /* reexport */ FocusTrapChild; },
  "FocusTrapContainer": function() { return /* reexport */ FocusTrapContainer; },
  "FocusTrapContext": function() { return /* reexport */ FocusTrapContext; },
  "IS_IOS": function() { return /* reexport */ IS_IOS; },
  "NATIVE_STICKY_NAME": function() { return /* reexport */ NATIVE_STICKY_NAME; },
  "ResizeImage": function() { return /* reexport */ ResizeImage; },
  "ResizeImageDiv": function() { return /* reexport */ ResizeImageDiv; },
  "STICKY_OPTIONS_KEYS": function() { return /* reexport */ STICKY_OPTIONS_KEYS; },
  "ScrollLock": function() { return /* reexport */ ScrollLock; },
  "ScrollSticky": function() { return /* reexport */ ScrollSticky; },
  "ScrollStickyCompat": function() { return /* reexport */ ScrollStickyCompat; },
  "Sticky": function() { return /* reexport */ Sticky; },
  "StickyCompat": function() { return /* reexport */ StickyCompat; },
  "StickyControlContext": function() { return /* reexport */ StickyControlContext; },
  "StickyProvider": function() { return /* reexport */ StickyProvider; },
  "StickyValueContext": function() { return /* reexport */ StickyValueContext; },
  "VirtualizedList": function() { return /* reexport */ VirtualizedList; },
  "assertStickyParentPosition": function() { return /* reexport */ assertStickyParentPosition; },
  "getImageUrl": function() { return /* reexport */ getImageUrl; },
  "getStickyChildStyle": function() { return /* reexport */ getStickyChildStyle; },
  "getStickyContainerStyle": function() { return /* reexport */ getStickyContainerStyle; },
  "getUpdatedStickyState": function() { return /* reexport */ getUpdatedStickyState; },
  "hasStickyStateChanged": function() { return /* reexport */ hasStickyStateChanged; },
  "useBaseSticky": function() { return /* reexport */ useBaseSticky; },
  "useExpandableView": function() { return /* reexport */ useExpandableView; },
  "useFocusTrapChild": function() { return /* reexport */ useFocusTrapChild; },
  "useForkRef": function() { return /* reexport */ useForkRef; },
  "useGetStickyHeight": function() { return /* reexport */ useGetStickyHeight; },
  "useHasObjectFit": function() { return /* reexport */ useHasObjectFit; },
  "useNodeHeight": function() { return /* reexport */ useNodeHeight; },
  "useNodeSize": function() { return /* reexport */ useNodeSize; },
  "usePagedCursorInfiniteList": function() { return /* reexport */ usePagedCursorInfiniteList; },
  "usePagedInfiniteList": function() { return /* reexport */ usePagedInfiniteList; },
  "usePixelRatio": function() { return /* reexport */ usePixelRatio; },
  "useScrollAppear": function() { return /* reexport */ useScrollAppear; },
  "useScrollDirection": function() { return /* reexport */ useScrollDirection; },
  "useSticky": function() { return /* reexport */ useSticky; },
  "useStickyHeight": function() { return /* reexport */ useStickyHeight; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js
var emotion_styled_browser_esm = __webpack_require__(37337);
// EXTERNAL MODULE: ./node_modules/@typed-decorators/autobind/dist/autobind.js
var autobind = __webpack_require__(9773);
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/utils/focus.js
function getFocusableNodes(element) {
    return Array.from(element.querySelectorAll('a:not([disabled]), button:not([disabled]), ' +
        'input[type=text]:not([disabled]), ' +
        '[tabindex]:not([disabled]):not([tabindex="-1"])'));
}
//# sourceMappingURL=focus.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/components/Carousel/Carousel.js
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





/**
 * Renders a carousel object which is used to cycle through multiple elements,
 * usually used for jumbotron and banners.
 *
 * It provides auto play, dragging in both mobile and PC,
 * ability to render controls, and wrapping at the border of the carousel.
 */
class Carousel extends react.PureComponent {
    constructor(props) {
        super(props);
        this.autoPlayTimer = null;
        this.touchStartPos = null;
        this.touchStartAt = 0;
        this.touchDelta = 0;
        this.touchTouches = [];
        this.touchTarget = null;
        this.touchScrolling = null;
        this.preventUntil = 0;
        this.node = null;
        this.listNode = null;
        this.listWrapNode = null;
        this.entryNodes = [];
        this.hadKeyEvent = false;
        this.state = {
            offset: props.initialOffset || 0,
            fromOffset: null,
            toOffset: null,
            offsetDelta: 0,
            animating: false,
            animatingDuration: '.35s',
            dragging: false,
            mainFocused: false,
            focused: false,
            focusVisible: false,
            autoPlaying: !!props.autoPlay,
        };
    }
    componentDidMount() {
        const { autoPlay } = this.props;
        this.toggleAutoPlayHandler(!!autoPlay);
        document.addEventListener('keydown', this.handleDocumentKeyDown, true);
        if (this.node != null) {
            this.node.addEventListener('touchstart', this.handleTouchStart, {
                passive: false,
            });
            this.node.addEventListener('touchmove', this.handleTouchMove, {
                passive: false,
            });
            this.node.addEventListener('focusin', this.handleMainFocusIn);
            this.node.addEventListener('focusout', this.handleMainFocusOut);
        }
        if (this.listNode != null) {
            this.listNode.addEventListener('focusin', this.handleFocusIn);
            this.listNode.addEventListener('focusout', this.handleFocusOut);
        }
    }
    componentDidUpdate() {
        const { autoPlay } = this.props;
        const { dragging } = this.state;
        // Disable auto play if it's dragging or autoPlay is disabled.
        this.toggleAutoPlayHandler(!!autoPlay && !dragging);
    }
    componentWillUnmount() {
        this.toggleAutoPlayHandler(false);
        document.removeEventListener('keydown', this.handleDocumentKeyDown, true);
        if (this.node != null) {
            this.node.removeEventListener('touchstart', this.handleTouchStart);
            this.node.removeEventListener('touchmove', this.handleTouchMove);
            this.node.removeEventListener('focusin', this.handleMainFocusIn);
            this.node.removeEventListener('focusout', this.handleMainFocusOut);
        }
        if (this.listNode != null) {
            this.listNode.removeEventListener('focusin', this.handleFocusIn);
            this.listNode.removeEventListener('focusout', this.handleFocusOut);
        }
    }
    setAutoPlaying(enabled) {
        this.setState({ autoPlaying: enabled });
        this.toggleAutoPlayHandler(enabled);
    }
    toggleAutoPlayHandler(enabled) {
        const { autoPlayInterval = 3000 } = this.props;
        if (enabled && this.autoPlayTimer == null) {
            this.autoPlayTimer = window.setInterval(this.next, autoPlayInterval);
        }
        else if (!enabled && this.autoPlayTimer != null) {
            clearInterval(this.autoPlayTimer);
            this.autoPlayTimer = null;
        }
    }
    handleTouchStart(e) {
        const { onInteract, disableSwipe, disableWrap } = this.props;
        const { offset } = this.state;
        const count = this.getLength();
        if (count <= 1) {
            // There's no point to perform dragging when count is lower than 2
            return;
        }
        if (disableSwipe) {
            return;
        }
        if (onInteract != null) {
            onInteract();
        }
        this.setState({ dragging: true });
        if (this.touchStartPos == null) {
            let newOffset = offset;
            if (disableWrap) {
                const bounds = this.getOffsetBounds();
                newOffset = Math.max(bounds[0], Math.min(bounds[1], newOffset));
            }
            this.touchStartPos = newOffset;
            this.touchStartAt = Date.now();
            this.touchScrolling = null;
            this.touchDelta = 0;
            if ('touches' in e) {
                this.touchTouches = Array.from(e.touches).map((touch) => ({
                    identifier: touch.identifier,
                    clientX: touch.clientX,
                    clientY: touch.clientY,
                }));
                // Attach touch events to the target.
                this.touchTarget = e.touches[0].target;
                this.touchTarget.addEventListener('touchmove', this.handleTouchMove);
                this.touchTarget.addEventListener('touchend', this.handleTouchEnd);
                this.touchTarget.addEventListener('touchcancel', this.handleTouchEnd);
                // Safari doesn't emit touchend in the touch target.
                window.addEventListener('touchend', this.handleTouchEnd);
                window.addEventListener('touchcancel', this.handleTouchEnd);
            }
            else {
                this.touchTouches = [
                    {
                        identifier: 0,
                        clientX: e.nativeEvent.clientX,
                        clientY: e.nativeEvent.clientY,
                    },
                ];
                // Attach touch events to the window.
                window.addEventListener('mousemove', this.handleTouchMove);
                window.addEventListener('mouseup', this.handleTouchEnd);
            }
            e.stopPropagation();
        }
    }
    handleTouchMove(e) {
        const { disableSwipe, disableWrap, childWidthRatio = 1 } = this.props;
        if (e.defaultPrevented)
            return;
        if (disableSwipe)
            return;
        if (this.node == null || this.touchStartPos == null)
            return;
        let touches = [];
        if ('touches' in e) {
            touches = Array.from(e.touches).map((v) => ({
                identifier: v.identifier,
                clientX: v.clientX,
                clientY: v.clientY,
            }));
        }
        else {
            touches = [
                {
                    identifier: 0,
                    clientX: e.clientX,
                    clientY: e.clientY,
                },
            ];
        }
        const { x: sumX, y: sumY, count } = touches
            .map((touch) => {
            const prev = this.touchTouches
                .find((v) => v.identifier === touch.identifier);
            if (prev == null)
                return null;
            return {
                x: touch.clientX - prev.clientX,
                y: touch.clientY - prev.clientY,
            };
        })
            .reduce((p, v) => (v != null
            ? ({ x: p.x + v.x, y: p.y + v.y, count: p.count + 1 })
            : p), { x: 0, y: 0, count: 0 });
        this.touchTouches = touches;
        if (count === 0)
            return;
        const diffX = sumX / count;
        const diffY = sumY / count;
        if ('touches' in e) {
            if (this.touchScrolling === null) {
                this.touchScrolling =
                    Math.abs(diffX) > Math.abs(diffY);
            }
            if (this.touchScrolling) {
                e.stopPropagation();
                e.preventDefault();
            }
            else {
                return;
            }
        }
        const { width } = this.node.getBoundingClientRect();
        this.touchDelta += diffX;
        const delta = this.touchDelta;
        let newOffset = this.touchStartPos - delta / width / childWidthRatio;
        let offsetDelta = 0;
        if (disableWrap) {
            const bounds = this.getOffsetBounds();
            // Apply offset bouncing effect if threshold is reached
            if (newOffset < bounds[0]) {
                offsetDelta = -Math.log(-newOffset + bounds[0] + 1) / Math.log(8);
            }
            else if (newOffset > bounds[1]) {
                offsetDelta = Math.log(newOffset - bounds[1] + 1) / Math.log(8);
            }
            newOffset = Math.max(bounds[0], Math.min(bounds[1], newOffset));
        }
        this.setState({
            offset: newOffset,
            offsetDelta,
            fromOffset: null,
            toOffset: null,
            animating: false,
            dragging: true,
        });
    }
    handleTouchEnd(e) {
        const { disableSwipe, childWidthRatio = 1, allowSwipeJump } = this.props;
        if (disableSwipe)
            return;
        if ('touches' in e && e.touches.length >= 1)
            return;
        if (this.node == null || this.touchStartPos == null)
            return;
        const { offset, dragging } = this.state;
        if (!dragging) {
            return;
        }
        const deltaX = this.touchDelta;
        const deltaTime = Date.now() - this.touchStartAt;
        let newOffset = Math.round(offset);
        const deltaOffset = newOffset - Math.round(this.touchStartPos);
        const { width } = this.node.getBoundingClientRect();
        const deltaValue = deltaX / deltaTime / width / childWidthRatio * 1000;
        let duration = '.35s';
        if (Math.abs(deltaValue) > 1) {
            const sign = deltaValue > 0 ? 1 : -1;
            let absDeltaValue = Math.abs(deltaValue);
            if (!allowSwipeJump) {
                absDeltaValue = 1;
            }
            const appliedDelta = Math.ceil(absDeltaValue / 3) * sign;
            if (Math.abs(deltaOffset) < Math.abs(appliedDelta)) {
                newOffset = Math.round(this.touchStartPos) - appliedDelta;
                duration = `${0.35 + Math.abs(appliedDelta) * 0.01}s cubic-bezier(.19,.18,.24,1)`;
            }
        }
        this.setState({ dragging: false });
        this.setOffset(newOffset, false, duration);
        // To prevent immediately firing click event, disable click event for
        // a short period if it moved far enough
        if (Math.abs(deltaX) > 5) {
            e.preventDefault();
            this.preventUntil = Date.now() + 200;
        }
        // Remove events if no more touches are left.
        if (!('touches' in e)) {
            this.touchStartPos = null;
            window.removeEventListener('mousemove', this.handleTouchMove);
            window.removeEventListener('mouseup', this.handleTouchEnd);
        }
        else if (e.touches.length === 0) {
            this.touchStartPos = null;
            if (this.touchTarget != null) {
                this.touchTarget.removeEventListener('touchmove', this.handleTouchMove);
                this.touchTarget.removeEventListener('touchend', this.handleTouchEnd);
                this.touchTarget.removeEventListener('touchcancel', this.handleTouchEnd);
            }
            window.removeEventListener('touchend', this.handleTouchEnd);
            window.removeEventListener('touchcancel', this.handleTouchEnd);
        }
    }
    handleClick(e) {
        if (Date.now() < this.preventUntil) {
            e.preventDefault();
            e.stopPropagation();
        }
    }
    handleDragStart(e) {
        e.preventDefault();
    }
    handleTransitionEnd() {
        const { autoPlay } = this.props;
        const { focused, toOffset, offset } = this.state;
        if (toOffset === offset) {
            this.setState({ fromOffset: null, toOffset: null, animating: false }, () => {
                if (focused && !autoPlay) {
                    // If we've had focus, set the focus to current node.
                    const { offset } = this.state;
                    this.focusNode(offset);
                }
            });
        }
    }
    handleMainFocusIn() {
        this.setState({ mainFocused: true });
        if (this.hadKeyEvent) {
            this.setState({ focusVisible: true });
        }
    }
    handleMainFocusOut() {
        this.setState({ mainFocused: false });
        const { toOffset } = this.state;
        if (toOffset == null) {
            this.setState({ focusVisible: false });
        }
    }
    handleFocusIn() {
        this.setState({ focused: true });
    }
    handleFocusOut() {
        this.setState({ focused: false });
    }
    handleKeyDown(e) {
        this.setState({ focusVisible: true });
        switch (e.keyCode) {
            case 37:
                // left
                this.prev();
                break;
            case 39:
                // right
                this.next();
                break;
            default:
        }
    }
    handleDocumentKeyDown() {
        this.hadKeyEvent = true;
        requestAnimationFrame(() => {
            this.hadKeyEvent = false;
        });
    }
    focusNode(offset) {
        const length = this.getLength();
        const newOffset = ((offset % length) + length) % length;
        const targetNode = this.entryNodes[newOffset];
        if (targetNode == null) {
            return;
        }
        const focusNodes = getFocusableNodes(targetNode);
        if (focusNodes.length > 0 && this.listWrapNode != null) {
            focusNodes[0].focus();
            this.listWrapNode.scrollLeft = 0;
        }
    }
    getLength() {
        const { children, length } = this.props;
        if (typeof children === 'function') {
            return length;
        }
        return react.Children.count(children);
    }
    getOffsetBounds() {
        const { childWidthRatio = 1, borderWidthRatio = 0, align = 'center', } = this.props;
        const length = this.getLength();
        if (align === 'center') {
            return [0, Math.max(0, length - 1)];
        }
        else if (align === 'left') {
            return [
                -borderWidthRatio,
                Math.max(0, length - 1 / childWidthRatio) + borderWidthRatio,
            ];
        }
        else if (align === 'centerConstrained') {
            const left = (1 / childWidthRatio - 1) / 2;
            return [
                left - borderWidthRatio,
                Math.max(0, length - 1 / childWidthRatio) + left + borderWidthRatio,
            ];
        }
        return [0, 0];
    }
    /**
     * Returns the "effective" bounds of the constrained layout. Effective bounds
     * is basically the meaningful bounds of the index.
     *
     * For example, if childWidthRatio is 1/2, and wrapping is disabled,
     * 0 and 1 position is effectively same, since 0 position can fully display
     * 1 position.
     *
     * The rightmost side is the same, length - 1, and length - 2 position
     * is redundant.
     *
     * If this redundant index is not resolved, the user have to press "next"
     * button twice to go to next page. Hence, this limits the bounds of the
     * min / max position. If the index is smaller / bigger than min / max,
     * it automatically changes to 0 / length - 1.
     *
     * @return {[number, number]} The min/max bounds of the offset.
     */
    getEffectiveBounds() {
        const { disableWrap, align, childWidthRatio = 1, } = this.props;
        const length = this.getLength();
        if (!disableWrap) {
            return [0, length - 1];
        }
        switch (align) {
            case 'centerConstrained':
                return [
                    Math.ceil((Math.floor(1 / childWidthRatio) - 1) / 2),
                    length - Math.ceil((Math.floor(1 / childWidthRatio) - 1) / 2) - 1,
                ];
            case 'left':
                return [
                    0,
                    length - Math.floor(1 / childWidthRatio),
                ];
            case 'center':
            default:
                return [0, length - 1];
        }
    }
    getEffectiveOffset(offset) {
        const { disableWrap } = this.props;
        if (disableWrap) {
            const bounds = this.getEffectiveBounds();
            return Math.max(bounds[0], Math.min(bounds[1], offset));
        }
        return offset;
    }
    setOffset(newOffset, wrap = true, inputDuration) {
        const { disableWrap, childWidthRatio = 1, animationDuration = '0.35s', } = this.props;
        const duration = inputDuration || animationDuration;
        const { focused, offset } = this.state;
        if (offset === newOffset) {
            // Bailout - do nothing if two offsets are same.
            return;
        }
        const length = this.getLength();
        this.setState((state) => {
            const wrappedOffset = wrap
                ? ((state.offset % length) + length) % length
                : state.offset;
            let fromOffset = wrappedOffset;
            let toOffset = typeof newOffset === 'function'
                ? newOffset(this.getEffectiveOffset(wrappedOffset))
                : newOffset;
            if (disableWrap) {
                const bounds = this.getOffsetBounds();
                fromOffset = Math.min(bounds[1], Math.max(bounds[0], fromOffset)) +
                    state.offsetDelta;
                const effectiveBounds = this.getEffectiveBounds();
                if (toOffset <= effectiveBounds[0])
                    toOffset = 0;
                if (toOffset >= effectiveBounds[1])
                    toOffset = length - 1;
            }
            // Optimization: If we're traveling too far distance, forcibly crop the
            // travel distance - otherwise the browser will draw too many nodes
            // at once.
            const travelDistance = Math.ceil(1 / childWidthRatio * 5);
            fromOffset = Math.max(toOffset - travelDistance, Math.min(toOffset + travelDistance, fromOffset));
            return {
                offset: fromOffset,
                fromOffset,
                toOffset,
                offsetDelta: state.offsetDelta,
                animating: false,
            };
        }, () => requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                const { onOffsetChange, autoPlay } = this.props;
                const { toOffset } = this.state;
                const wrappedOffset = (((toOffset ?? 0) % length) + length) % length;
                if (toOffset != null) {
                    if (focused && !autoPlay) {
                        // If we've had focus, set the focus to current node.
                        this.focusNode(wrappedOffset);
                    }
                    if (onOffsetChange != null) {
                        onOffsetChange(wrappedOffset);
                    }
                    this.setState((state) => ({
                        offset: state.toOffset,
                        offsetDelta: 0,
                        animating: true,
                        animatingDuration: duration,
                    }));
                }
            });
        }));
    }
    prev(duration) {
        const { autoPlay, autoPlayInterval } = this.props;
        if (autoPlay && this.autoPlayTimer != null) {
            clearInterval(this.autoPlayTimer);
            this.autoPlayTimer = null;
            this.autoPlayTimer = window.setInterval(this.next, autoPlayInterval || 3000);
        }
        this.setOffset((offset) => Math.round(offset - 1), false, duration);
    }
    next(duration) {
        const { autoPlay, autoPlayInterval } = this.props;
        if (autoPlay && this.autoPlayTimer != null) {
            clearInterval(this.autoPlayTimer);
            this.autoPlayTimer = null;
            this.autoPlayTimer = window.setInterval(this.next, autoPlayInterval || 3000);
        }
        this.setOffset((offset) => Math.round(offset + 1), false, duration);
    }
    handleOnMouseEnter() {
        const { autoPlay } = this.props;
        if (autoPlay) {
            this.setAutoPlaying(false);
        }
    }
    handleOnMouseLeave() {
        const { autoPlay } = this.props;
        if (autoPlay) {
            this.setAutoPlaying(true);
        }
    }
    render() {
        const { children, length, className, wrapperClassName, listClassName, entryClassName, nodeRef, renderControls, childWidthRatio = 1, childLookahead = 0, disableWrap, wrappedChildren, onRowsRendered, align = 'center', } = this.props;
        let { offset, toOffset } = this.state;
        const { fromOffset, offsetDelta, animating, animatingDuration, autoPlaying, mainFocused, focused, focusVisible } = this.state;
        let childrenRender;
        let childrenLength;
        if (typeof children === 'function') {
            childrenRender = children;
            childrenLength = length;
        }
        else {
            const childrenList = react.Children.toArray(children);
            childrenRender = (index) => childrenList[index];
            childrenLength = childrenList.length;
        }
        const rawOffset = offset;
        if (disableWrap) {
            const bounds = this.getOffsetBounds();
            offset = Math.min(bounds[1], Math.max(bounds[0], offset)) + offsetDelta;
            if (toOffset != null) {
                toOffset = Math.min(bounds[1], Math.max(bounds[0], toOffset));
            }
        }
        let minOffset = offset;
        let maxOffset = offset;
        if (toOffset != null && fromOffset != null) {
            minOffset = Math.min(offset, fromOffset, toOffset);
            maxOffset = Math.max(offset, fromOffset, toOffset);
        }
        // Determine the required nodes to render current offset.
        const centerOffset = disableWrap
            ? Math.round(rawOffset)
            : ((Math.round(rawOffset) % childrenLength) + childrenLength) %
                childrenLength;
        let baseOffset;
        if (align === 'center' || align === 'centerConstrained') {
            // Wrap the offset
            const offsetMargin = (1 - childWidthRatio) / (2 * childWidthRatio);
            baseOffset = minOffset - offsetMargin - childLookahead;
        }
        else {
            baseOffset = minOffset - childLookahead;
        }
        // How many nodes should be visible for given offset?
        const startIndex = Math.floor(baseOffset);
        const visibleCount = Math.ceil(baseOffset +
            1 / childWidthRatio +
            (maxOffset - minOffset) +
            childLookahead * 2) -
            startIndex;
        // Then.. how much should we move left?
        const leftOffset = (baseOffset - startIndex + (offset - minOffset) + childLookahead) *
            childWidthRatio;
        const effectiveBounds = this.getEffectiveBounds();
        const controlProps = {
            prev: this.prev,
            next: this.next,
            set: this.setOffset,
            offset: this.getEffectiveOffset(centerOffset),
            length: childrenLength,
            min: effectiveBounds[0],
            max: effectiveBounds[1],
            animating: animating || toOffset != null,
        };
        // onRowsRendered is called in render phase.
        // TODO Refactor this.
        if (onRowsRendered != null) {
            onRowsRendered(startIndex, startIndex + visibleCount - 1);
        }
        const nodes = [];
        for (let i = 0; i < visibleCount; ++i) {
            const actualIndex = startIndex + i;
            const index = ((startIndex % childrenLength) + childrenLength + i) % childrenLength;
            const epoch = Math.floor(((startIndex % childrenLength) + childrenLength + i) / childrenLength);
            const isWrapped = (actualIndex <= -1 || actualIndex >= childrenLength);
            nodes.push(react.createElement(CarouselListItem, { className: classnames_default()('carousel__list__entry', epoch !== 1 && disableWrap && 'wrapped', focused && 'focus', focusVisible && 'focus-visible', entryClassName), key: actualIndex, style: { width: `${childWidthRatio * 100}%` }, ref: (node) => {
                    this.entryNodes[index] = node;
                }, onMouseEnter: this.handleOnMouseEnter, onMouseLeave: this.handleOnMouseLeave, role: 'group', "aria-roledescription": 'slide', "aria-label": isWrapped && disableWrap
                    ? undefined
                    : (`${index + 1} of ${childrenLength}`) }, isWrapped && disableWrap
                // If disableWrap is true and epoch has exceeded, don't render
                // anything but leftmost / rightmost entry.
                ? ((actualIndex === -1 || actualIndex === childrenLength) &&
                    wrappedChildren != null && wrappedChildren(actualIndex))
                : childrenRender(index, actualIndex, controlProps)));
        }
        return (react.createElement(CarouselContainer, { className: classnames_default()((mainFocused || focused) && 'focus', focused && 'focus-entry', focusVisible && 'focus-visible', className), ref: (node) => {
                this.node = node;
                if (nodeRef != null) {
                    nodeRef(node);
                }
            }, role: 'region', "aria-roledescription": 'carousel' },
            react.createElement(CarouselListWrapper, { className: classnames_default()('carousel__list-wrap', wrapperClassName), ref: (node) => {
                    this.listWrapNode = node;
                } },
                react.createElement(CarouselList, { className: classnames_default()('carousel__list', listClassName), onTouchMove: () => { }, onTouchEnd: () => { }, onMouseDown: this.handleTouchStart, onClickCapture: this.handleClick, onDragStart: this.handleDragStart, onTransitionEnd: this.handleTransitionEnd, onKeyDown: this.handleKeyDown, "aria-live": autoPlaying ? 'off' : 'polite', ref: (node) => {
                        this.listNode = node;
                    }, style: {
                        transform: `translateX(${leftOffset * -100}%)`,
                        transition: animating
                            ? `transform ${animatingDuration}`
                            : '',
                    } }, nodes)),
            renderControls != null &&
                renderControls(controlProps)));
    }
}
__decorate([
    autobind/* autobind */.N
], Carousel.prototype, "handleTouchStart", null);
__decorate([
    autobind/* autobind */.N
], Carousel.prototype, "handleTouchMove", null);
__decorate([
    autobind/* autobind */.N
], Carousel.prototype, "handleTouchEnd", null);
__decorate([
    autobind/* autobind */.N
], Carousel.prototype, "handleClick", null);
__decorate([
    autobind/* autobind */.N
], Carousel.prototype, "handleDragStart", null);
__decorate([
    autobind/* autobind */.N
], Carousel.prototype, "handleTransitionEnd", null);
__decorate([
    autobind/* autobind */.N
], Carousel.prototype, "handleMainFocusIn", null);
__decorate([
    autobind/* autobind */.N
], Carousel.prototype, "handleMainFocusOut", null);
__decorate([
    autobind/* autobind */.N
], Carousel.prototype, "handleFocusIn", null);
__decorate([
    autobind/* autobind */.N
], Carousel.prototype, "handleFocusOut", null);
__decorate([
    autobind/* autobind */.N
], Carousel.prototype, "handleKeyDown", null);
__decorate([
    autobind/* autobind */.N
], Carousel.prototype, "handleDocumentKeyDown", null);
__decorate([
    autobind/* autobind */.N
], Carousel.prototype, "setOffset", null);
__decorate([
    autobind/* autobind */.N
], Carousel.prototype, "prev", null);
__decorate([
    autobind/* autobind */.N
], Carousel.prototype, "next", null);
__decorate([
    autobind/* autobind */.N
], Carousel.prototype, "handleOnMouseEnter", null);
__decorate([
    autobind/* autobind */.N
], Carousel.prototype, "handleOnMouseLeave", null);
const CarouselContainer = emotion_styled_browser_esm["default"].div `
  position: relative;
`;
const CarouselListWrapper = emotion_styled_browser_esm["default"].div `
  overflow: hidden;
`;
const CarouselList = emotion_styled_browser_esm["default"].div `
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
  min-height: 100%;
`;
const CarouselListItem = emotion_styled_browser_esm["default"].div `
  flex: 0 0 auto;
  -moz-user-select: -moz-none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  box-sizing: border-box;
`;
//# sourceMappingURL=Carousel.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/components/Carousel/index.js

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/components/VirtualizedList/VirtualizedList.js
var VirtualizedList_decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


function intersectRect(a, b) {
    const top = Math.max(a.top, b.top);
    const bottom = Math.min(a.bottom, b.bottom);
    const left = Math.max(a.left, b.left);
    const right = Math.min(a.right, b.right);
    const width = right - left;
    const height = bottom - top;
    return { top, bottom, left, right, width, height };
}
function getRootRect() {
    const html = document.documentElement;
    const { body } = document;
    const width = html.clientWidth || body.clientWidth;
    const height = html.clientHeight || body.clientHeight;
    return { top: 0, left: 0, right: width, bottom: height, width, height };
}
// Try to locate the position using getValue, count, targetValue.
// This should perform within O(log n).
function binarySearch(count, getValue, targetValue) {
    let min = 0;
    let max = count;
    while (min < max) {
        const mid = (min + max) >> 1;
        const value = getValue(mid);
        if (value < targetValue) {
            min = mid + 1;
        }
        else if (value > targetValue) {
            max = mid - 1;
        }
        else {
            return mid;
        }
    }
    return min;
}
function getWindowWidth() {
    return window.innerWidth ||
        document.documentElement.clientWidth ||
        document.getElementsByTagName('body')[0].clientWidth;
}
function getWindowHeight() {
    return window.innerHeight ||
        document.documentElement.clientHeight ||
        document.getElementsByTagName('body')[0].clientHeight;
}
// Size list becomes unbelivably large if the user goes down too much -
// 1000 items is about 5KB, if 'null' is considered.
// Obviously this is not acceptable to store into sessionStorage, therefore
// we need very simple compression to compact this down to few hundred bytes.
//
// - s (n) - set stripe (sizeStep), if set, each 'w' will write N more '0'
// - w (n) - write N
// - n (n) - write null N times
// For example, 's3w100w100w200n100' becomes...
// [100, 0, 0, 0, 100, 0, 0, 0, 200, 0, 0, 0, ... 100 null items]
function encodeRLE(input) {
    let sizeStep = 1;
    const result = [];
    // First, determine size step...
    {
        let i = 0;
        while (input[i] == null || input[i] === 0) {
            i += 1;
            if (i > input.length) {
                break;
            }
        }
        while (input[i + sizeStep] === 0) {
            sizeStep += 1;
        }
    }
    result.push(`s${sizeStep}`);
    // Then process the data.
    let nullSize = 0;
    for (let i = 0; i < input.length; i += 1) {
        if (input[i] == null) {
            nullSize += 1;
        }
        else {
            if (nullSize > 0) {
                result.push(`n${nullSize}`);
                nullSize = 0;
            }
            result.push(`w${input[i]}`);
            i += sizeStep - 1;
        }
    }
    if (nullSize > 0) {
        result.push(`n${nullSize}`);
        nullSize = 0;
    }
    return result.join('');
}
function decodeRLE(input) {
    let sizeStep = 1;
    const output = [];
    for (let i = 0; i < input.length; i += 1) {
        const char = input[i];
        // Try to digest parameter number
        let numBuffer = '';
        while (input[i + 1] >= '0' && input[i + 1] <= '9') {
            numBuffer += input[i + 1];
            i += 1;
        }
        const num = parseInt(numBuffer, 10) || 0;
        switch (char) {
            case 's':
                sizeStep = num;
                break;
            case 'n':
                for (let j = 0; j < num; j += 1) {
                    output.push(null);
                }
                break;
            case 'w':
                output.push(num);
                for (let j = 1; j < sizeStep; j += 1) {
                    output.push(0);
                }
                break;
            default:
        }
    }
    return output;
}
class VirtualizedList extends react.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            paddingTop: 0,
            paddingBottom: 0,
            startIndex: 0,
            endIndex: 24,
            tempDelta: 0,
            forceRecalculate: false,
            fastScrolling: false,
        };
        this.anchorIndex = 0;
        this.prevWindowWidth = 0;
        this.sizeList = [];
        this.sizeCount = 0;
        this.sizeSum = 0;
        this.sizeAccList = [];
        this.sizeInvalidated = null;
        this.sizeStep = null;
        this.sizeVersion = 0;
        this.prevScrollAt = 0;
        this.prevScrollPos = 0;
        this.tempDelta = 0;
        this.overridenCount = null;
        this.scrollRestore = null;
        this.scrollRestoreJump = false;
        this.scrollPending = false;
        this.resizePending = false;
        this.containerNode = null;
        this.itemLoadeds = [];
        this.itemNodes = [];
        this.itemRefs = [];
        this.resizeId = null;
        this.scrollId = null;
        this.scrollEndId = null;
        this.scrollStabilizeId = null;
        this.stabilizeId = null;
        this.beforeScrollRestoration = null;
        this.loadSaveData();
    }
    resetVirtualizedList() {
        const { tabId } = this.props;
        sessionStorage.removeItem(`vlist-data-${tabId}`);
        this.setState({
            paddingTop: 0,
            paddingBottom: 0,
            startIndex: 0,
            endIndex: 24,
            tempDelta: 0,
            forceRecalculate: false,
            fastScrolling: false,
        });
        this.scrollRestoreJump = false;
        window.scrollTo(0, 0);
    }
    loadSaveData() {
        const { tabId, disableRestore } = this.props;
        let value = null;
        try {
            value = JSON.parse(sessionStorage[`vlist-data-${tabId}`] || 'null');
        }
        catch (e) {
            // Do nothing if failed
        }
        this.overridenCount = null;
        if (value != null) {
            // Restore save data...
            if (getWindowWidth() === value.windowWidth) {
                this.sizeList = decodeRLE(value.sizeList);
                this.sizeInvalidated = 0;
                const { sum, count } = this.sizeList.reduce((p, v) => (v != null
                    ? { count: p.count + 1, sum: p.sum + v }
                    : p), { count: 0, sum: 0 });
                this.sizeSum = sum;
                this.sizeCount = count;
            }
            this.overridenCount = value.count;
            if (!disableRestore) {
                this.scrollRestore = {
                    pos: value.anchorPos,
                    offset: value.anchorOffset,
                };
            }
        }
    }
    saveSaveData(tabId) {
        if (tabId == null || this.containerNode == null) {
            return;
        }
        const { count } = this.props;
        const containerTop = this.containerNode.getBoundingClientRect().top;
        const anchorOffset = this.getAccPos(this.anchorIndex - 1) + containerTop;
        const value = {
            sizeList: encodeRLE(this.sizeList),
            windowWidth: getWindowWidth(),
            count,
            anchorPos: this.anchorIndex,
            anchorOffset,
        };
        try {
            sessionStorage[`vlist-data-${tabId}`] = JSON.stringify(value);
        }
        catch (e) {
            // Do nothing if failed
        }
    }
    updateSize(index, size) {
        const previousSize = this.getSize(index);
        if (previousSize === size) {
            return;
        }
        this.sizeVersion += 1;
        if (previousSize == null) {
            this.sizeCount += 1;
            this.sizeSum += size;
        }
        else {
            this.sizeSum += size - previousSize;
        }
        this.sizeList[index] = size;
        if (this.sizeInvalidated == null) {
            this.sizeInvalidated = index;
        }
        else {
            this.sizeInvalidated = Math.min(this.sizeInvalidated, index);
        }
    }
    getSizeLength() {
        return this.sizeList.length;
    }
    getSize(index) {
        const current = this.sizeList[index];
        return current;
    }
    getAverageSize() {
        return (this.sizeSum / this.sizeCount) || 100;
    }
    getSizeStep() {
        if (this.sizeStep == null) {
            this.sizeStep = 1;
            let i = 0;
            while (this.getSize(i) === 0 || this.getSize(i) == null) {
                i += 1;
                if (i > this.getSizeLength()) {
                    this.sizeStep = null;
                    return 1;
                }
            }
            while (this.getSize(this.sizeStep + i) === 0) {
                this.sizeStep += 1;
            }
            if (this.sizeStep >= this.getSizeLength()) {
                this.sizeStep = null;
                return 1;
            }
        }
        return this.sizeStep;
    }
    getAccPos(index) {
        const { length } = this.sizeAccList;
        if (index < 0) {
            return 0;
        }
        // Try to get direct value, otherwise get inferred value.
        if (length > index) {
            return this.sizeAccList[index];
        }
        const sizeStep = this.getSizeStep();
        const accSize = this.getAverageSize() * (Math.ceil(index / sizeStep) * sizeStep -
            Math.floor(length / sizeStep) * sizeStep);
        if (length === 0) {
            return accSize;
        }
        return this.sizeAccList[length - 1] + accSize;
    }
    recalculateAccSize() {
        if (this.sizeInvalidated == null) {
            return;
        }
        const startIndex = Math.min(this.sizeInvalidated || 0, this.sizeAccList.length);
        let prev = 0;
        if (startIndex > 0) {
            prev = this.sizeAccList[startIndex - 1];
        }
        const sizeStep = this.getSizeStep();
        for (let i = startIndex; i < this.getSizeLength(); i += 1) {
            let entrySize = this.getSize(i);
            if (entrySize == null) {
                entrySize = i % sizeStep === 0
                    ? this.getAverageSize() * sizeStep
                    : 0;
            }
            const current = prev + entrySize;
            this.sizeAccList[i] = current;
            prev = current;
        }
        // Remaining values can be inferred from
        // sizeAccList[size] + avg * (i - size), therefore it's a waste of
        // computation to pre-compute this values.
        this.sizeInvalidated = null;
    }
    recalculateSizeImpl() {
        if (this.containerNode == null) {
            return;
        }
        // Recalculate all visible nodes for now
        // TODO Calculate new nodes only
        const { count } = this.props;
        const { paddingTop, paddingBottom, startIndex, endIndex } = this.state;
        const maxIndex = Math.min(endIndex, count);
        let shouldAcceptNonLoaded = false;
        // If there's nothing in the size buffer, and there is not a single
        // loaded item, we must use currently loaded items to correctly approximate
        // current position.
        if (this.sizeList.length === 0) {
            let hasLoaded = false;
            for (let i = startIndex; i <= maxIndex; i += 1) {
                if (this.itemNodes[i] != null && this.itemLoadeds[i]) {
                    hasLoaded = true;
                    break;
                }
            }
            shouldAcceptNonLoaded = !hasLoaded;
        }
        // Size is calculated by 'how much it influences the total height' -
        // Therefore in a grid, only the leftmost one receives the height.
        // This is acheived by comparing using the node's top position.
        // +                  - Initial position -> padding top
        // +---+ +---+ +---+  - v 0th, 1st, 2nd
        // |   | |   | |   |  - |
        // +---+ +---+ +---+  - |
        // +---+              - v 3rd
        // |   |              - |
        // +---+              - |
        // +                  - v end
        // However, because it shifts the position (even though 0th influences
        // the height, 3rd gets the value), the position needs to be adjusted
        // as well. This can be acheived by memorizing first non-zero index.
        const containerRect = this.containerNode.getBoundingClientRect();
        let pos = containerRect.top + paddingTop;
        let currentNonZeroIndex = startIndex;
        for (let i = startIndex; i <= maxIndex; i += 1) {
            const node = this.itemNodes[i];
            if (node == null) {
                return;
            }
            const nodePos = node.getBoundingClientRect().top;
            const diff = Math.round(nodePos - pos);
            if (diff !== 0) {
                // Adjust the position if all non-zero indices are loaded.
                let isLoaded = true;
                for (let j = currentNonZeroIndex; j < i; j += 1) {
                    if (!this.itemLoadeds[j]) {
                        isLoaded = false;
                        break;
                    }
                }
                if (isLoaded || shouldAcceptNonLoaded) {
                    this.updateSize(currentNonZeroIndex, diff);
                    for (let j = currentNonZeroIndex + 1; j < i; j += 1) {
                        this.updateSize(j, 0);
                    }
                }
                currentNonZeroIndex = i;
            }
            pos = nodePos;
        }
        // Compare the bottom position of the container, then set the last index.
        const endPos = containerRect.bottom - paddingBottom;
        {
            let isEndLoaded = true;
            for (let j = currentNonZeroIndex; j <= maxIndex; j += 1) {
                if (!this.itemLoadeds[j]) {
                    isEndLoaded = false;
                    break;
                }
            }
            if (isEndLoaded) {
                this.updateSize(currentNonZeroIndex, Math.round(endPos - pos));
                for (let j = currentNonZeroIndex + 1; j <= maxIndex; j += 1) {
                    this.updateSize(j, 0);
                }
            }
        }
    }
    recalculateSize() {
        // Pick the anchor index and memorize its position
        const anchorPos = this.getAccPos(this.anchorIndex - 1);
        // Actually run the size calculation logic
        this.recalculateSizeImpl();
        // Try to locate the anchor node and move to it. This accounts for
        // resizing due to the layout changes - Howevver, we still need to
        // calculate the size of nodes that aren't rendered. To account
        // for this, we compare approximate accumulated sizes and scroll until
        // there.
        this.recalculateAccSize();
        if (anchorPos != null) {
            const nextAnchorPos = this.getAccPos(this.anchorIndex - 1);
            const deltaDiff = anchorPos - nextAnchorPos;
            this.tempDelta += deltaDiff;
        }
    }
    invalidateSize() {
        // Pick the anchor index and memorize its position
        const anchorPos = this.getAccPos(this.anchorIndex - 1);
        // Reset store...
        this.sizeList = [];
        this.sizeCount = 0;
        this.sizeSum = 0;
        this.sizeAccList = [];
        this.sizeInvalidated = null;
        this.sizeStep = null;
        // Actually run the size calculation logic
        this.recalculateSizeImpl();
        // Try to locate the anchor node and move to it. This accounts for
        // resizing due to the layout changes - Howevver, we still need to
        // calculate the size of nodes that aren't rendered. To account
        // for this, we compare approximate accumulated sizes and scroll until
        // there.
        this.recalculateAccSize();
        if (anchorPos != null) {
            const nextAnchorPos = this.getAccPos(this.anchorIndex - 1);
            const deltaDiff = anchorPos - nextAnchorPos;
            this.tempDelta += deltaDiff;
        }
    }
    getViewportIntersection() {
        // Calculate which portion of nodes are visible, and set the padding /
        // visible nodes according to it.
        // Since VirtualizedList lacks declared 'parent' container, the only way to
        // calculate visible offset is to try intersection with all parent nodes...
        if (this.containerNode == null) {
            throw new Error('containerNode is null');
        }
        let currentNode = this.containerNode;
        let currentRect = this.containerNode.getBoundingClientRect();
        while (currentNode != null) {
            const parentNode = currentNode.parentElement;
            if (parentNode === document.body ||
                parentNode === document.documentElement ||
                parentNode == null) {
                break;
            }
            const parentStyle = window.getComputedStyle(parentNode);
            if (parentStyle.overflow === 'auto' || parentStyle.overflow === 'scroll') {
                currentRect = intersectRect(currentRect, parentNode.getBoundingClientRect());
            }
            currentNode = parentNode;
        }
        currentRect = intersectRect(currentRect, getRootRect());
        // currentRect contains viewable area of the node - use this to calculate
        // total visible area of the node.
        return currentRect;
    }
    scrollToAnchor(pos, offset) {
        if (this.containerNode == null)
            return 0;
        const scrollY = window.scrollY || document.documentElement.scrollTop;
        const containerTop = this.containerNode.getBoundingClientRect().top;
        const anchorPos = this.getAccPos(pos - 1);
        const targetY = scrollY + containerTop +
            anchorPos - offset;
        window.scrollTo(0, targetY);
        return targetY;
    }
    recalculateViewport() {
        if (this.containerNode == null)
            return;
        this.recalculateAccSize();
        const containerTop = this.containerNode.getBoundingClientRect().top;
        let currentRect = this.getViewportIntersection();
        let scrollVelocity = 0;
        // If scrollRestore is specified, don't do any viewport bounds check.
        // Instead, render directly to the desired position, then set the scroll
        // position to there once it's rendered. (This shall be handled inside
        // componentDidUpdate, I think?)
        if (this.scrollRestore != null) {
            // We (should) have scroll restoration information in current stage,
            // as it's determined from accumulated size information, which is
            // (hopefully) provided from the saved data, or, augmented from first
            // few nodes. If it's augmented, it's still okay, since scroll correction
            // logic can continously adapt scroll position to the expected position.
            const anchorPos = this.getAccPos(this.scrollRestore.pos);
            const top = anchorPos + containerTop - this.scrollRestore.offset;
            const windowHeight = getWindowHeight();
            currentRect = {
                ...currentRect,
                top,
                bottom: top + windowHeight,
                height: windowHeight,
            };
            this.scrollPending = true;
            this.prevScrollAt = 0;
            // this.scrollToAnchor(this.scrollRestore.pos, this.scrollRestore.offset);
            // this.scrollRestore = null;
            this.scrollRestoreJump = true;
        }
        else {
            // Determine the current scrolling velocity using previous data.
            const scrollDiff = Date.now() - this.prevScrollAt;
            if (scrollDiff < 500) {
                scrollVelocity = this.prevScrollPos - containerTop;
            }
            this.prevScrollPos = containerTop;
            this.prevScrollAt = Date.now();
            // User is scrolling too fast; trigger fast scrolling mode.
            // TODO Unset this once the user slows down
            if (Math.abs(scrollVelocity / (scrollDiff / 1000)) > 4000) {
                const { fastScrolling } = this.state;
                if (!fastScrolling) {
                    this.setState({ fastScrolling: true });
                }
            }
        }
        // Translate viewable rect to scroll position including velocity and
        // overscanning.
        const { count, overscanHeight = 500 } = this.props;
        const maxCount = this.overridenCount != null
            ? Math.max(this.overridenCount, count)
            : count;
        const { tempDelta: committedTempDelta, startIndex: prevStartIndex, endIndex: prevEndIndex, } = this.state;
        const visibleTop = currentRect.top - containerTop - overscanHeight +
            committedTempDelta - this.tempDelta +
            (scrollVelocity < 0
                ? Math.max(-800, scrollVelocity * 1.5)
                : Math.min(800, scrollVelocity * 0.8));
        const visibleBottom = currentRect.bottom - containerTop + overscanHeight +
            committedTempDelta - this.tempDelta +
            (scrollVelocity > 0
                ? Math.min(800, scrollVelocity * 1.5)
                : Math.max(-800, scrollVelocity * 0.8));
        let visibleTopPos = binarySearch(count, (v) => this.getAccPos(v), visibleTop);
        let visibleBottomPos = binarySearch(count, (v) => this.getAccPos(v), visibleBottom);
        const sizeStep = this.getSizeStep();
        // Try to snap the position to cloest non-zero value.
        // This is necessary to prevent non-aligned position access, therefore
        // allowing the node to wrap and breaking the whole layout.
        visibleTopPos -= sizeStep;
        visibleTopPos = Math.floor(visibleTopPos / sizeStep) * sizeStep;
        // Find the next non-zero value for bottom, and navigate to its end...
        visibleBottomPos += sizeStep * 2;
        visibleBottomPos = Math.ceil(visibleBottomPos / sizeStep) * sizeStep - 1;
        visibleTopPos = Math.max(0, visibleTopPos);
        visibleBottomPos = Math.min(count, visibleBottomPos);
        // Calculate anchor index separately...
        const anchorTop = currentRect.top - containerTop +
            committedTempDelta - this.tempDelta;
        this.anchorIndex =
            Math.ceil(binarySearch(count, (v) => this.getAccPos(v), anchorTop) /
                sizeStep) * sizeStep;
        const { onRowsRendered } = this.props;
        const paddingTop = Math.round(this.getAccPos(visibleTopPos - 1));
        const paddingBottom = Math.round(this.getAccPos(maxCount) -
            this.getAccPos(visibleBottomPos));
        if (onRowsRendered != null &&
            !this.resizePending &&
            (prevStartIndex !== visibleTopPos ||
                prevEndIndex !== visibleBottomPos)) {
            onRowsRendered(visibleTopPos, visibleBottomPos);
        }
        let shouldForceRecalculate = false;
        for (let i = visibleTopPos; i < prevStartIndex; i += 1) {
            if (this.getSize(i) == null) {
                shouldForceRecalculate = true;
                break;
            }
        }
        this.setState({
            startIndex: visibleTopPos,
            endIndex: visibleBottomPos,
            paddingTop,
            paddingBottom,
            tempDelta: this.tempDelta,
            forceRecalculate: shouldForceRecalculate,
        });
    }
    commitTempDelta() {
        if (this.tempDelta === 0) {
            return;
        }
        const delta = this.tempDelta;
        const scrollY = window.scrollY || document.documentElement.scrollTop;
        this.tempDelta = 0;
        window.scrollTo(0, scrollY - delta);
    }
    attachListeners() {
        this.prevWindowWidth = document.documentElement.clientWidth;
        if ('scrollRestoration' in history) {
            this.beforeScrollRestoration = history.scrollRestoration;
            history.scrollRestoration = 'manual';
        }
        window.addEventListener('unload', this.handleUnload);
        window.addEventListener('resize', this.handleResize, true);
        document.addEventListener('scroll', this.handleScroll, true);
    }
    detachListeners() {
        if ('scrollRestoration' in history &&
            this.beforeScrollRestoration != null) {
            history.scrollRestoration = this.beforeScrollRestoration;
        }
        window.removeEventListener('unload', this.handleUnload);
        window.removeEventListener('resize', this.handleResize, true);
        document.removeEventListener('scroll', this.handleScroll, true);
    }
    componentDidMount() {
        this.recalculateSize();
        this.recalculateViewport();
        this.attachListeners();
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { tabId } = this.props;
        if (prevProps.tabId !== tabId) {
            this.saveSaveData(prevProps.tabId);
        }
        return null;
    }
    componentDidUpdate(prevProps) {
        const { tabId } = this.props;
        const { forceRecalculate } = this.state;
        if (tabId != null && prevProps.tabId !== tabId) {
            this.invalidateSize();
            this.loadSaveData();
            this.recalculateViewport();
            this.tempDelta = 0;
        }
        else {
            if (this.resizePending) {
                return;
            }
            if (this.scrollRestoreJump && this.scrollRestore != null) {
                this.scrollToAnchor(this.scrollRestore.pos, this.scrollRestore.offset);
                this.scrollRestoreJump = false;
                this.scrollRestore = null;
                this.overridenCount = null;
                return;
            }
            if (forceRecalculate) {
                this.recalculateSize();
                this.recalculateViewport();
            }
            else if (this.stabilizeId == null) {
                this.stabilizeId = requestAnimationFrame(() => {
                    this.stabilizeId = requestAnimationFrame(() => {
                        this.stabilizeId = null;
                        this.recalculateSize();
                        if (!this.scrollPending) {
                            this.recalculateViewport();
                        }
                    });
                });
            }
        }
    }
    componentWillUnmount() {
        const { tabId } = this.props;
        this.saveSaveData(tabId);
        this.detachListeners();
        if (this.resizeId != null) {
            cancelAnimationFrame(this.resizeId);
        }
        if (this.scrollId != null) {
            window.clearTimeout(this.scrollId);
        }
        if (this.scrollEndId != null) {
            window.clearTimeout(this.scrollEndId);
        }
        if (this.stabilizeId != null) {
            cancelAnimationFrame(this.stabilizeId);
        }
        if (this.scrollStabilizeId != null) {
            cancelAnimationFrame(this.scrollStabilizeId);
        }
    }
    handleScroll() {
        if (this.resizePending) {
            return;
        }
        this.scrollPending = true;
        if (this.scrollEndId != null) {
            window.clearTimeout(this.scrollEndId);
            this.scrollEndId = null;
        }
        if (this.scrollId != null) {
            return;
        }
        this.scrollId = window.setTimeout(() => {
            this.scrollId = null;
            if (this.scrollStabilizeId != null) {
                return;
            }
            this.scrollStabilizeId = requestAnimationFrame(() => {
                this.scrollStabilizeId = null;
                if (this.scrollEndId != null) {
                    window.clearTimeout(this.scrollEndId);
                }
                if (this.resizePending) {
                    return;
                }
                this.scrollEndId = window.setTimeout(this.handleScrollEnd, 200);
                this.recalculateViewport();
            });
        }, 50);
    }
    handleScrollEnd() {
        this.scrollEndId = null;
        this.scrollPending = false;
        this.setState({ fastScrolling: false, forceRecalculate: false });
        if (this.resizePending) {
            return;
        }
        this.commitTempDelta();
        this.recalculateViewport();
    }
    handleResize() {
        // We need to invalidate entire size data!
        if (this.resizeId == null) {
            this.resizePending = true;
            this.resizeId = requestAnimationFrame(() => {
                this.resizeId = null;
                const currentWidth = document.documentElement.clientWidth;
                if (currentWidth !== this.prevWindowWidth) {
                    this.invalidateSize();
                }
                this.recalculateViewport();
                this.prevWindowWidth = currentWidth;
                this.resizePending = false;
            });
        }
    }
    handleUnload() {
        const { tabId } = this.props;
        this.saveSaveData(tabId);
    }
    getStyle() {
        const { style } = this.props;
        const { paddingTop, paddingBottom, tempDelta } = this.state;
        return {
            ...style || {},
            paddingTop: `${paddingTop}px`,
            paddingBottom: `${paddingBottom}px`,
            transform: tempDelta != null
                ? `translateY(${tempDelta}px)`
                : undefined,
        };
    }
    renderItems() {
        const { count, innerClassName, innerStyle, renderItem, isLoaded } = this.props;
        const { startIndex, endIndex, fastScrolling } = this.state;
        const maxIndex = Math.min(endIndex, count - 1);
        const output = [];
        for (let i = startIndex; i <= maxIndex; i += 1) {
            // TODO Store ref functions and reuse them for the sake of optimization
            let ref = this.itemRefs[i];
            if (ref == null) {
                ref = this.itemRefs[i] = (node) => {
                    this.itemNodes[i] = node;
                };
            }
            const itemLoaded = isLoaded != null ? isLoaded(i) : true;
            this.itemLoadeds[i] = itemLoaded;
            let style = innerStyle;
            if (!itemLoaded && this.getSizeLength() > i) {
                const sizeStep = this.getSizeStep();
                const inferredHeight = this.getSize(Math.floor(i / sizeStep) * sizeStep);
                style = { ...(innerStyle || {}), height: `${inferredHeight}px` };
            }
            output.push(react.createElement("div", { className: innerClassName, ref: ref, style: style, key: i }, renderItem({ index: i, fastScrolling })));
        }
        return output;
    }
    render() {
        const { className } = this.props;
        return (react.createElement("div", { className: className, style: this.getStyle(), ref: (node) => {
                this.containerNode = node;
            } }, this.renderItems()));
    }
}
VirtualizedList_decorate([
    autobind/* autobind */.N
], VirtualizedList.prototype, "resetVirtualizedList", null);
VirtualizedList_decorate([
    autobind/* autobind */.N
], VirtualizedList.prototype, "handleScroll", null);
VirtualizedList_decorate([
    autobind/* autobind */.N
], VirtualizedList.prototype, "handleScrollEnd", null);
VirtualizedList_decorate([
    autobind/* autobind */.N
], VirtualizedList.prototype, "handleResize", null);
VirtualizedList_decorate([
    autobind/* autobind */.N
], VirtualizedList.prototype, "handleUnload", null);
//# sourceMappingURL=VirtualizedList.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/components/VirtualizedList/index.js

//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/querystring/index.js
var querystring = __webpack_require__(17673);
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/components/ResizeImage/getImageUrl.js

const IMAGE_SIZES = [
    36,
    72,
    144,
    180,
    256,
    360,
    480,
    512,
    640,
    720,
    850,
    960,
    1024,
    1280,
    1360,
    1440,
    1536,
    1700,
    1920,
    2048,
    2560,
];
/**
 * Returns nearest image resize width for the given width.
 * @param {number} width The given width.
 * @return {number} The image width.
 */
function getNearestWidth(width) {
    for (let i = 0; i < IMAGE_SIZES.length; ++i) {
        if (IMAGE_SIZES[i] >= width) {
            return IMAGE_SIZES[i];
        }
    }
    return IMAGE_SIZES[IMAGE_SIZES.length - 1];
}
const IMAGE_OHOUSE_LEGACY_PATTERN = /^https?:\/\/image\.ohou\.se\/image\/(?:central_crop|resize)\/([^/]+)\/([^/]+)\/.+\/.*$/;
const IMAGE_OHOUSE_PATTERN = /^https?:\/\/image\.ohou\.se\/i\/([^/]+)\/([^?]+)(?:\?.*)?$/;
const S3_LOCAL_PATTERN = /^https?:\/\/s3-ap-northeast-1\.amazonaws\.com\/([^/]+)\/([^?]+)(?:\?.*)?$/;
const S3_GLOBAL_PATTERN = /^https?:\/\/([^.]+)\.(?:s3\.amazonaws\.com|cloudfront\.net)\/([^?]+)(?:\?.*)?$/;
const IMAGE_PREFIX = 'https://image.ohou.se';
/**
 * Returns the resized image URL for the given image. It can convert server-
 * converted image URL, or raw S3 image URL.
 * @param {string} src The original image URL.
 * @param {number} width The image width to use.
 * @param {number} aspect The aspect ratio for height - provide null to retain
 *   original width.
 * @param {number} quality The quality of the image.
 * @return {string} The resized image URL.
 */
function getImageUrl(src, width, height, mode, quality, webp, gif) {
    let path;
    let match;
    const alignWidth = width != null ? getNearestWidth(width) : null;
    const alignHeight = height != null ? getNearestWidth(height) : height;
    if (!src) {
        return undefined;
    }
    if (match = IMAGE_OHOUSE_LEGACY_PATTERN.exec(src), match != null) {
        path = `${match[1]}/${match[2].replace(/-/g, '/')}`;
    }
    else if (match = IMAGE_OHOUSE_PATTERN.exec(src), match != null) {
        path = `${match[1]}/${match[2]}`;
    }
    else if (match = S3_LOCAL_PATTERN.exec(src), match != null) {
        path = `${match[1]}/${match[2]}`;
    }
    else if (match = S3_GLOBAL_PATTERN.exec(src), match != null) {
        // eslint-disable-next-line prefer-destructuring
        let bucketName = match[1];
        // Change old bucket name to new name
        if (bucketName === 'd224jl0o7z9gbn' || bucketName === 'd12gkpu9h0k5iq') {
            bucketName = 'bucketplace-v2-development';
        }
        path = `${bucketName}/${match[2]}`;
    }
    else {
        return src;
    }
    const url = `${IMAGE_PREFIX}/i/${path}?`;
    const query = {};
    if (alignWidth != null)
        query.w = String(alignWidth);
    if (alignHeight != null)
        query.h = String(alignHeight);
    if (mode != null)
        query.c = String(mode);
    if (quality != null)
        query.q = String(quality);
    if (webp)
        query.webp = '1';
    if (gif)
        query.gif = '1';
    return url + querystring.stringify(query);
}
function getImageUrlSingleAxis(src, width, aspect, quality, useHeight, webp, gif) {
    if (aspect != null) {
        if (useHeight) {
            return getImageUrl(src, width * aspect, width, 'c', quality, webp, gif);
        }
        return getImageUrl(src, width, width * aspect, 'c', quality, webp, gif);
    }
    if (useHeight) {
        return getImageUrl(src, undefined, width, undefined, quality, webp, gif);
    }
    return getImageUrl(src, width, undefined, undefined, quality, webp, gif);
}
//# sourceMappingURL=getImageUrl.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/components/ResizeImage/useNodeSize.js

let disableSSR = false;
function useNodeSize(ref, defaultSize = [240, 240]) {
    const [size, setSize] = (0,react.useState)(null);
    const handleRecalculate = (0,react.useCallback)(() => {
        const node = ref.current;
        if (node == null)
            return;
        const nodeSize = [node.clientWidth, node.clientHeight];
        setSize((size) => {
            if (size == null || nodeSize[0] > size[0] || nodeSize[1] > size[1]) {
                return [
                    Math.max(nodeSize[0], defaultSize[0]),
                    Math.max(nodeSize[1], defaultSize[1]),
                ];
            }
            return size;
        });
    }, [ref]);
    (0,react.useEffect)(() => {
        let initId = requestAnimationFrame(() => {
            initId = null;
            disableSSR = true;
            handleRecalculate();
        });
        let recalcTimeoutId = null;
        const handleResize = () => {
            if (recalcTimeoutId != null) {
                window.clearTimeout(recalcTimeoutId);
            }
            recalcTimeoutId = window.setTimeout(() => {
                recalcTimeoutId = null;
                handleRecalculate();
            }, 500);
        };
        let resizeObserver = null;
        const targetNode = ref.current;
        if (window.ResizeObserver != null && targetNode != null) {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(targetNode);
        }
        else {
            window.addEventListener('resize', handleResize);
        }
        return () => {
            if (initId != null)
                cancelAnimationFrame(initId);
            if (recalcTimeoutId != null) {
                window.clearTimeout(recalcTimeoutId);
            }
            if (resizeObserver != null) {
                resizeObserver.disconnect();
            }
            else {
                window.removeEventListener('resize', handleResize);
            }
        };
    }, [ref, handleRecalculate]);
    if (!disableSSR && size == null)
        return defaultSize;
    return size;
}
//# sourceMappingURL=useNodeSize.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/components/ResizeImage/ResizeImage.js



function ResizeImageImpl(props) {
    const { src, width, maxWidth, aspect, quality, useHeight, gif = false, ...otherProps } = props;
    const nodeRef = (0,react.useRef)(null);
    const actualSize = useNodeSize(nodeRef, width != null ? [width, width] : undefined);
    function getUrl(multiplier = 1, useWebp = false) {
        if (actualSize == null)
            return undefined;
        const nextSize = actualSize.map((v) => {
            const value = v * multiplier;
            if (maxWidth != null && maxWidth < value)
                return maxWidth;
            return value;
        });
        if (useHeight) {
            return getImageUrlSingleAxis(src, nextSize[1], aspect, quality, true, useWebp, gif);
        }
        return getImageUrlSingleAxis(src, nextSize[0], aspect, quality, false, useWebp, gif);
    }
    const isGifFile = (0,react.useMemo)(() => (src?.indexOf('.gif') > -1 && gif), [src, gif]);
    const imageUrl = getUrl(1);
    const srcSet = actualSize != null && src != null
        ? [1.5, 2, 3].map((size) => `${getUrl(size)} ${size}x`).join(',')
        : undefined;
    const webpImageUrl = getUrl(1, true);
    const webpSrcSet = actualSize != null && src != null
        ? [1.5, 2, 3].map((size) => `${getUrl(size, true)} ${size}x`).join(',')
        : undefined;
    return (react.createElement("picture", null,
        !isGifFile && (react.createElement("source", { src: webpImageUrl, srcSet: webpSrcSet, type: 'image/webp' })),
        react.createElement("img", Object.assign({}, otherProps, { src: imageUrl, srcSet: srcSet, ref: nodeRef }))));
}
const ResizeImage = react.memo(ResizeImageImpl);
//# sourceMappingURL=ResizeImage.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/components/ResizeImage/usePixelRatio.js

function usePixelRatio() {
    const [pixelRatio, setPixelRatio] = (0,react.useState)(1);
    (0,react.useEffect)(() => {
        let mediaQuery = null;
        const handleUpdate = () => {
            setPixelRatio(window.devicePixelRatio);
            if (mediaQuery != null) {
                mediaQuery.removeListener(handleUpdate);
            }
            mediaQuery =
                window.matchMedia(`(resolution: ${window.devicePixelRatio}dppx)`);
            mediaQuery.addListener(handleUpdate);
        };
        handleUpdate();
        return () => {
            if (mediaQuery != null) {
                mediaQuery.removeListener(handleUpdate);
            }
        };
    }, []);
    return pixelRatio;
}
//# sourceMappingURL=usePixelRatio.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/components/ResizeImage/ResizeImageDiv.js




function ResizeImageDivImpl(props) {
    const { src, width, maxWidth, aspect, quality, useHeight, style, ...otherProps } = props;
    const nodeRef = (0,react.useRef)(null);
    const pixelRatio = usePixelRatio();
    const actualSize = useNodeSize(nodeRef, width != null ? [width, width] : undefined);
    function getUrl(multiplier = 1) {
        if (actualSize == null)
            return undefined;
        const nextSize = actualSize.map((v) => {
            const value = v * multiplier;
            if (maxWidth != null && maxWidth < value)
                return maxWidth;
            return value;
        });
        if (useHeight) {
            return getImageUrlSingleAxis(src, nextSize[1], aspect, quality, true);
        }
        return getImageUrlSingleAxis(src, nextSize[0], aspect, quality, false);
    }
    const imageUrl = getUrl(pixelRatio);
    return (react.createElement("div", Object.assign({}, otherProps, { ref: nodeRef, style: imageUrl != null
            ? {
                ...style,
                backgroundImage: `url(${imageUrl})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
            }
            : style })));
}
const ResizeImageDiv = react.memo(ResizeImageDivImpl);
//# sourceMappingURL=ResizeImageDiv.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/components/ResizeImage/useHasObjectFit.js

let isChecked = false;
let isSupported = true;
function useHasObjectFit() {
    const [isEnabled, setEnabled] = (0,react.useState)(isSupported);
    (0,react.useEffect)(() => {
        if (!isChecked) {
            const image = new Image();
            isChecked = true;
            isSupported = 'object-position' in image.style;
        }
        setEnabled(isSupported);
    }, []);
    return isEnabled;
}
//# sourceMappingURL=useHasObjectFit.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/components/ResizeImage/CoverResizeImage.js





function calculateBounds(width, height, containerWidth, containerHeight) {
    const imageRatio = width / height;
    const containerRatio = containerWidth / containerHeight;
    if (imageRatio > containerRatio) {
        const heightPercent = containerRatio / imageRatio;
        return [0, (1 - heightPercent) / 2, 1, heightPercent];
    }
    const widthPercent = imageRatio / containerRatio;
    return [(1 - widthPercent) / 2, 0, widthPercent, 1];
}
function CoverResizeImage(props) {
    const { src, size, maxSize, quality, focus, fit = 'cover', className, style, innerClassName, innerStyle, children, } = props;
    const nodeRef = (0,react.useRef)(null);
    const imageRef = (0,react.useRef)(null);
    const pixelRatio = usePixelRatio();
    const hasObjectFit = useHasObjectFit();
    const actualSize = useNodeSize(nodeRef, size);
    const [imageSize, setImageSize] = (0,react.useState)([1, 1]);
    function getUrl(multiplier = 1) {
        if (actualSize == null)
            return undefined;
        const nextSize = actualSize.map((v, i) => {
            const value = v * multiplier;
            if (maxSize != null && maxSize[i] < value)
                return maxSize[i];
            return value;
        });
        return getImageUrl(src, nextSize[0], nextSize[1], 'o', quality);
    }
    const imageUrl = getUrl(1);
    const srcSet = actualSize != null && src != null
        ? [1.5, 2, 3].map((size) => `${getUrl(size)} ${size}x`).join(',')
        : undefined;
    const handleImageLoad = (0,react.useCallback)(() => {
        const image = imageRef.current;
        if (image == null)
            return;
        setImageSize([image.naturalWidth, image.naturalHeight]);
    }, []);
    (0,react.useEffect)(() => {
        if (hasObjectFit)
            return;
        const url = getUrl(pixelRatio);
        if (url == null)
            return;
        const image = new Image();
        image.onloadedmetadata = () => {
            setImageSize([image.naturalWidth, image.naturalHeight]);
        };
        image.onload = () => {
            setImageSize([image.naturalWidth, image.naturalHeight]);
        };
        image.src = url;
        return () => {
            image.src = '';
        };
    }, [imageUrl, hasObjectFit, pixelRatio]);
    return (react.createElement("div", { ref: nodeRef, className: className, style: {
            position: 'relative',
            ...(style ?? {}),
        } },
        hasObjectFit ? (react.createElement("img", { className: innerClassName, src: imageUrl, srcSet: srcSet, onLoadedMetadata: handleImageLoad, onLoad: handleImageLoad, ref: imageRef, style: {
                position: 'absolute',
                top: '0',
                left: '0',
                width: '100%',
                height: '100%',
                objectFit: fit,
                objectPosition: focus != null
                    ? `${focus[0] * 100}% ${focus[1] * 100}%`
                    : 'center center',
                ...(innerStyle ?? {}),
            } })) : (react.createElement("div", { className: innerClassName, style: {
                position: 'absolute',
                top: '0',
                left: '0',
                width: '100%',
                height: '100%',
                backgroundImage: `url(${getUrl(pixelRatio)})`,
                backgroundSize: fit,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: focus != null
                    ? `${focus[0] * 100}% ${focus[1] * 100}%`
                    : 'center center',
                ...(innerStyle ?? {}),
            } })),
        typeof children === 'function'
            ? children({
                width: imageSize[0],
                height: imageSize[1],
                containerWidth: actualSize != null ? actualSize[0] : 0,
                containerHeight: actualSize != null ? actualSize[1] : 0,
                bounds: calculateBounds(imageSize[0], imageSize[1], actualSize != null ? actualSize[0] : 0, actualSize != null ? actualSize[1] : 0),
            })
            : children));
}
//# sourceMappingURL=CoverResizeImage.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/components/ResizeImage/index.js







//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/components/ScrollLock/ScrollLock.js

let refCount = 0;
let refTopOffset = 0;
class ScrollLock extends react.PureComponent {
    constructor() {
        super(...arguments);
        this.isIos = false;
        this.currentRef = null;
    }
    enable() {
        refCount += 1;
        this.currentRef = {
            getElement: () => (this.props?.getElement != null
                ? this.props?.getElement()
                : null),
        };
        if (refCount === 1) {
            const documentWidth = document.documentElement.clientWidth;
            const windowWidth = window.innerWidth;
            const scrollBarWidth = windowWidth - documentWidth;
            document.body.style.paddingRight = `${scrollBarWidth}px`;
            document.body.style.overflow = 'hidden';
            // Implement scroll prevention specially for iOS devices
            if (this.isIos) {
                refTopOffset = window.scrollY;
                const html = document.querySelector('html');
                if (html) {
                    html.style.height = `${window.innerHeight - 1}px`;
                }
                document.body.style.position = 'fixed';
                document.body.style.top = `-${refTopOffset}px`;
                document.body.style.left = '0';
                document.body.style.right = '0';
            }
        }
    }
    disable() {
        refCount -= 1;
        if (refCount === 0) {
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
            if (this.isIos) {
                document.body.style.position = 'static';
                window.scrollTo(0, refTopOffset);
            }
        }
    }
    componentDidMount() {
        const { enabled } = this.props;
        this.isIos = !!navigator.userAgent.match(/iPad|iPhone|iPod/gi);
        if (enabled) {
            this.enable();
        }
    }
    componentDidUpdate(prevProps) {
        const { enabled } = this.props;
        if (enabled !== prevProps.enabled) {
            if (enabled) {
                this.enable();
            }
            else {
                this.disable();
            }
        }
    }
    componentWillUnmount() {
        const { enabled } = this.props;
        if (enabled) {
            this.disable();
        }
    }
    render() {
        return null;
    }
}
//# sourceMappingURL=ScrollLock.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/components/ScrollLock/index.js

//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/components/FocusTrap/FocusTrapContext.js

const FocusTrapContext = react.createContext({
    register: () => { },
    unregister: () => { },
});
//# sourceMappingURL=FocusTrapContext.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/components/FocusTrap/FocusTrapChild.js
/* eslint-disable react/no-find-dom-node */



// This needs to use findDOMNode() to emulate FocusTrap's behavior, and
// findDOMNode() requires React.Component.
class FocusTrapChildImpl extends react.PureComponent {
    constructor(props) {
        super(props);
        this.prevElem = null;
    }
    componentDidMount() {
        const { register } = this.props;
        const elem = (0,react_dom.findDOMNode)(this);
        if (elem instanceof HTMLElement) {
            this.prevElem = elem;
            register(elem);
        }
    }
    componentDidUpdate() {
        const { register, unregister } = this.props;
        const elem = (0,react_dom.findDOMNode)(this);
        if (elem instanceof HTMLElement && elem !== this.prevElem) {
            if (this.prevElem != null) {
                unregister(this.prevElem);
            }
            this.prevElem = elem;
            register(elem);
        }
    }
    componentWillUnmount() {
        const { unregister } = this.props;
        if (this.prevElem != null) {
            unregister(this.prevElem);
            this.prevElem = null;
        }
    }
    render() {
        const { children } = this.props;
        return (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        react.createElement(react.Fragment, null, children));
    }
}
function FocusTrapChild(props) {
    const context = (0,react.useContext)(FocusTrapContext);
    return (react.createElement(FocusTrapChildImpl, Object.assign({}, props, context)));
}
//# sourceMappingURL=FocusTrapChild.js.map
// EXTERNAL MODULE: ./node_modules/focus-trap-react/dist/focus-trap-react.js
var focus_trap_react = __webpack_require__(54483);
var focus_trap_react_default = /*#__PURE__*/__webpack_require__.n(focus_trap_react);
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/components/FocusTrap/FocusTrapContainer.js



function FocusTrapContainer(props) {
    const [containerElements, setElements] = (0,react.useState)([]);
    const register = (0,react.useCallback)((elem) => {
        setElements((prev) => {
            if (prev.includes(elem))
                return prev;
            return [...prev, elem];
        });
    }, []);
    const unregister = (0,react.useCallback)((elem) => {
        setElements((prev) => prev.filter((v) => v !== elem));
    }, []);
    const contextValue = (0,react.useMemo)(() => ({
        register,
        unregister,
    }), [register, unregister]);
    return (react.createElement(FocusTrapContext.Provider, { value: contextValue },
        react.createElement((focus_trap_react_default()), Object.assign({}, props, { containerElements: [
                // eslint-disable-next-line react/destructuring-assignment
                ...(props.containerElements ?? []),
                ...containerElements,
            ] }))));
}
//# sourceMappingURL=FocusTrapContainer.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/components/FocusTrap/useFocusTrapChild.js


function useFocusTrapChild(ref) {
    const context = (0,react.useContext)(FocusTrapContext);
    const prevRef = (0,react.useRef)(null);
    (0,react.useEffect)(() => {
        if (ref.current !== prevRef.current) {
            if (prevRef.current != null) {
                context.unregister(prevRef.current);
            }
            if (ref.current != null) {
                context.register(ref.current);
            }
            prevRef.current = ref.current;
        }
    });
    (0,react.useEffect)(() => {
        return () => {
            if (prevRef.current != null) {
                context.unregister(prevRef.current);
            }
        };
    }, []);
}
//# sourceMappingURL=useFocusTrapChild.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/components/FocusTrap/index.js




//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/hooks/useForkRef.js

function useForkRef(...refs) {
    return (0,react.useCallback)((v) => refs.forEach((ref) => {
        if (typeof ref === 'function') {
            ref(v);
        }
        else if (ref != null) {
            ref.current = v;
        }
    }), refs);
}
//# sourceMappingURL=useForkRef.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/utils/object.js
function mapArrayToObject(input, getKey = (_, index) => index, ignoreUndefinedOrNull = false) {
    return input.reduce((res, elem, index) => {
        const key = getKey(elem, index);
        if (ignoreUndefinedOrNull && key == null) {
            return res;
        }
        res[key] = elem;
        return res;
    }, {});
}
function groupBy(input, getKey = (_, index) => index) {
    return input.reduce((res, elem, index) => {
        const key = getKey(elem, index);
        res[key] = [...(res[key] ?? []), elem];
        return res;
    }, {});
}
function mapValues(input, mapper, target = {}) {
    return Object.entries(input)
        .reduce((target, [key, value]) => {
        const [newKey, newValue] = mapper(key, value, input);
        target[newKey] = newValue;
        return target;
    }, target);
}
function filterKeys(input, filter, target = {}) {
    return Object.entries(input)
        .reduce((res, [key, value]) => {
        const flag = filter(key, value, input);
        if (flag) {
            res[key] = value;
        }
        return res;
    }, target);
}
function omitKeys(object, keys) {
    return Object.keys(object)
        .filter((key) => !keys.includes(key))
        .reduce((merge, key) => {
        const rKey = key;
        merge[rKey] = object[rKey];
        return merge;
    }, {});
}
function shallowEqual(a, b) {
    if (a == null || b == null) {
        return a === b;
    }
    if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length) {
            return false;
        }
        return a.every((e, i) => e === b[i]);
    }
    if (typeof a === 'object' && typeof b === 'object') {
        const keysA = Object.keys(a);
        const keysB = Object.keys(b);
        if (keysA.length !== keysB.length) {
            return false;
        }
        // @ts-ignore
        return keysA.every((keyA, i) => keysB[i] === keyA && a[keyA] === b[keyA]);
    }
    return a === b;
}
function map(input, map) {
    const output = {};
    for (const key in input) {
        if (Object.prototype.hasOwnProperty.call(input, key)) {
            output[key] = map(input[key], key);
        }
    }
    return output;
}
//# sourceMappingURL=object.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/components/Sticky/utils.js
/**
 * IE11 tends to calculate numbers with very bad precision.
 * (For example, 1 + 2 becomes 2.99999999475, etc)
 * We try to fix this problem using Math.round, but it allows 0.25 precision.
 */
function quantizeSize(size) {
    return Math.round(size * 4) / 4;
}
//# sourceMappingURL=utils.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/components/Sticky/stickyEmulation.js

const NATIVE_STICKY_NAME = (() => {
    if (typeof window === 'undefined') {
        return false;
    }
    const node = document.createElement('div');
    const result = ['', '-webkit-', '-moz-', '-ms-'].find((prefix) => {
        try {
            node.style.position = `${prefix}sticky`;
        }
        catch (e) {
            // Do nothing
        }
        return node.style.position !== '';
    });
    if (result == null)
        return false;
    return `${result}sticky`;
})();
const IS_IOS = (() => {
    if (typeof window === 'undefined') {
        return false;
    }
    return /ios|iphone|ipad/i.test(navigator.userAgent);
})();
const DEFAULT_STICKY_STATE = {
    disabled: true,
    emulatedDisabled: true,
    bottom: false,
    isAbsolute: false,
    isNativeSticky: false,
    offset: 0,
    emulatedOffset: 0,
    height: null,
    width: null,
    beginY: 0,
};
const STICKY_OPTIONS_KEYS = [
    'type',
    'shouldInfluenceScroll',
    'direction',
    'offset',
    'offsetRange',
    'disableNativeSticky',
    'disableBottom',
    'disableHeight',
    'disabled',
    'iosWorkaround',
    'alwaysStick',
    'fit',
    'fitHeight',
    'transition',
    'zIndex',
];
function getStickyContainerStyle(state, options) {
    if (state.disabled) {
        return {};
    }
    if (state.isNativeSticky) {
        return {
            position: NATIVE_STICKY_NAME,
            [options.direction]: `${state.offset}px`,
            transform: 'scaleZ(0px)',
            transition: `${options.transition || 0.1}s ${options.direction}`,
            zIndex: options.zIndex,
        };
    }
    if (state.emulatedDisabled || options.disableHeight) {
        return {};
    }
    return {
        height: `${state.height}px`,
    };
}
function getStickyChildStyle(state, options) {
    if (state.disabled) {
        return {};
    }
    if (state.isNativeSticky) {
        return {
            position: 'relative',
            height: options.fitHeight ? `${state.height}px` : undefined,
            boxSizing: options.fitHeight ? 'border-box' : undefined,
        };
    }
    if (state.emulatedDisabled) {
        const style = {
            position: 'relative',
            zIndex: options.zIndex,
            height: options.fitHeight ? `${state.height}px` : undefined,
            boxSizing: options.fitHeight ? 'border-box' : undefined,
        };
        return style;
    }
    const style = {
        position: state.isAbsolute || state.bottom ? 'absolute' : 'fixed',
        transform: 'scaleZ(0px)',
        height: options.fitHeight ? `${state.height}px` : undefined,
        boxSizing: options.fitHeight ? 'border-box' : undefined,
        transition: `${options.transition || 0.1}s ${options.direction}`,
        zIndex: options.zIndex,
    };
    if (state.bottom) {
        style[options.direction === 'top' ? 'bottom' : 'top'] = '0px';
    }
    else {
        style[options.direction] = `${state.emulatedOffset}px`;
    }
    if (options.fit) {
        style.left = '0px';
        style.right = '0px';
    }
    else {
        style.width = `${state.width}px`;
    }
    return style;
}
function getUpdatedStickyState(options, containerElem, childElem) {
    // Check if both elements are available
    if (containerElem == null || childElem == null) {
        return DEFAULT_STICKY_STATE;
    }
    // Check if the container is visible. If it's not shown, there's no need to
    // calculate floating state.
    const containerElemParent = containerElem.parentElement;
    if (containerElem.offsetParent == null || containerElemParent == null) {
        return DEFAULT_STICKY_STATE;
    }
    // If disabled, don't do anything.
    if (options.disabled) {
        return DEFAULT_STICKY_STATE;
    }
    const windowHeight = window.innerHeight;
    let emulatedDisabled;
    let bottom;
    let height = null;
    const childRect = childElem.getBoundingClientRect();
    const containerRect = containerElem.getBoundingClientRect();
    const { top: containerTop, bottom: containerBottom, } = containerRect;
    // Math.round is for avoiding precision issues
    // (we don't need subpixel accuracy)
    const beginY = Math.round(containerTop +
        (window.scrollY || document.documentElement.scrollTop));
    const containerWidth = containerRect.right - containerRect.left;
    if (options.direction === 'bottom') {
        emulatedDisabled = !options.alwaysStick &&
            containerBottom - options.offset < windowHeight;
        bottom = false;
    }
    else {
        // Defaults to top
        const { bottom: parentBottom, } = containerElemParent.getBoundingClientRect();
        emulatedDisabled = !options.alwaysStick &&
            containerTop - options.offset > 0;
        if (options.fitHeight) {
            const bottomDiff = Math.max(0, windowHeight - parentBottom);
            height = quantizeSize(Math.min(parentBottom - containerTop, windowHeight - options.offset - bottomDiff));
            const style = window.getComputedStyle(childElem);
            const minHeight = parseInt(style.minHeight, 10);
            bottom =
                !options.disableBottom &&
                    Math.max(height, minHeight) + options.offset > parentBottom;
        }
        else {
            const childHeight = childRect.bottom - childRect.top;
            bottom =
                !options.disableBottom &&
                    childHeight + options.offset > parentBottom;
        }
    }
    const isIosWorkaround = options.iosWorkaround && IS_IOS;
    const isNative = !isIosWorkaround &&
        !options.disableNativeSticky && NATIVE_STICKY_NAME;
    if (!options.fitHeight) {
        // eslint-disable-next-line prefer-destructuring
        height = quantizeSize(childRect.height);
    }
    if (isNative) {
        return {
            disabled: false,
            bottom,
            emulatedDisabled,
            offset: options.offset,
            emulatedOffset: quantizeSize(options.offset),
            height,
            width: null,
            isAbsolute: false,
            isNativeSticky: true,
            beginY,
        };
    }
    const containerStyle = getComputedStyle(containerElem);
    const width = quantizeSize(containerWidth -
        parseFloat(containerStyle.paddingLeft) -
        parseFloat(containerStyle.paddingRight));
    if (isIosWorkaround) {
        // Run iOS workaround routine. ...
        const offsetDiff = containerElemParent.getBoundingClientRect().top -
            document.body.getBoundingClientRect().top;
        return {
            disabled: false,
            bottom,
            emulatedDisabled,
            offset: options.offset,
            emulatedOffset: quantizeSize(options.offset + window.scrollY - offsetDiff),
            height,
            width,
            isAbsolute: true,
            isNativeSticky: false,
            beginY,
        };
    }
    return {
        disabled: false,
        bottom,
        emulatedDisabled,
        offset: options.offset,
        emulatedOffset: quantizeSize(options.offset),
        height,
        width,
        isAbsolute: false,
        isNativeSticky: false,
        beginY,
    };
}
function hasStickyStateChanged(prevState, nextState) {
    let key;
    for (key in nextState) {
        if (nextState[key] !== prevState[key]) {
            return true;
        }
    }
    return false;
}
function assertStickyParentPosition(options, containerElem) {
    // Do nothing in production mode
    if (true) {
        return;
    }
    if (options.disableNativeSticky && options.disableBottom) {
        return;
    }
    if (containerElem == null) {
        return;
    }
    // Check if the container is visible. If it's not shown, do nothing.
    const containerElemParent = containerElem.parentElement;
    if (containerElem.offsetParent == null || containerElemParent == null) {
        return;
    }
    // Retrieve style info...
    const styleInfo = window.getComputedStyle(containerElemParent);
    if (!['relative', 'absolute'].includes(styleInfo.position)) {
        throw new Error('Container node\'s parent must be set to ' +
            'position: relative or absolute to ' +
            'emulate native sticky\'s behavior. ' +
            'set disableNativeSticky and disableBottom if you want to avoid ' +
            'native sticky behavior (sticking at the bottom of parent node)');
    }
}
//# sourceMappingURL=stickyEmulation.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/components/Sticky/useBaseSticky.js


function useBaseSticky(state, onChange, options, containerRef, childRef) {
    const stateRef = (0,react.useRef)(state);
    stateRef.current = state;
    const optionsRef = (0,react.useRef)(options);
    optionsRef.current = options;
    (0,react.useEffect)(() => {
        assertStickyParentPosition(options, containerRef.current);
    }, []);
    (0,react.useEffect)(() => {
        let timerId = null;
        const update = () => {
            timerId = null;
            const nextState = getUpdatedStickyState(optionsRef.current, containerRef.current, childRef.current);
            if (hasStickyStateChanged(stateRef.current, nextState)) {
                onChange(nextState);
            }
        };
        const scheduleUpdate = () => {
            if (timerId != null) {
                cancelAnimationFrame(timerId);
            }
            timerId = requestAnimationFrame(update);
        };
        window.addEventListener('scroll', scheduleUpdate);
        window.addEventListener('resize', scheduleUpdate);
        return () => {
            if (timerId != null) {
                cancelAnimationFrame(timerId);
            }
            window.removeEventListener('scroll', scheduleUpdate);
            window.removeEventListener('resize', scheduleUpdate);
        };
    }, [onChange]);
    (0,react.useEffect)(() => {
        const nextState = getUpdatedStickyState(optionsRef.current, containerRef.current, childRef.current);
        if (hasStickyStateChanged(stateRef.current, nextState)) {
            onChange(nextState);
        }
    }, [options, onChange]);
}
//# sourceMappingURL=useBaseSticky.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/components/Sticky/BaseSticky.js





function BaseSticky(props) {
    const { containerClassName, containerStyle, containerRef, forwardRef, style, ...restProps } = omitKeys(props, STICKY_OPTIONS_KEYS);
    const containerStickyRef = (0,react.useRef)(null);
    const containerForkRef = useForkRef(containerRef, containerStickyRef);
    const childStickyRef = (0,react.useRef)(null);
    const childForkRef = useForkRef(forwardRef, childStickyRef);
    const [stickyState, setStickyState] = (0,react.useState)(DEFAULT_STICKY_STATE);
    useBaseSticky(stickyState, setStickyState, props, containerStickyRef, childStickyRef);
    return (react.createElement("div", { className: containerClassName, style: {
            ...getStickyContainerStyle(stickyState, props),
            ...containerStyle || {},
        }, ref: containerForkRef },
        react.createElement("div", Object.assign({}, restProps, { style: {
                ...getStickyChildStyle(stickyState, props),
                ...style || {},
            }, ref: childForkRef }))));
}
//# sourceMappingURL=BaseSticky.js.map
// EXTERNAL MODULE: ./node_modules/use-context-selector/dist/index.modern.js
var index_modern = __webpack_require__(44682);
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/components/Sticky/StickyContext.js

const StickyValueContext = (0,index_modern/* createContext */.kr)(null);
const StickyControlContext = (0,index_modern/* createContext */.kr)(null);
//# sourceMappingURL=StickyContext.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/components/Sticky/useSticky.js

// eslint-disable-next-line @typescript-eslint/camelcase






function useSticky(options, containerRef, childRef, initialState = DEFAULT_STICKY_STATE) {
    const stickyControlContext = (0,index_modern/* useContext */.qp)(StickyControlContext);
    if (stickyControlContext == null) {
        throw new Error('StickyContext is not provided');
    }
    const stickyIdRef = (0,react.useRef)(null);
    const stickyId = stickyIdRef.current || stickyControlContext.register();
    stickyIdRef.current = stickyId;
    const [state, setState] = (0,react.useState)(initialState);
    const itemState = (0,index_modern/* useContextSelector */.Sz)(StickyValueContext, (context) => {
        if (context == null) {
            return null;
        }
        return context.entries[stickyId];
    });
    const handleUpdate = (0,react.useCallback)((state) => {
        (0,react_dom.unstable_batchedUpdates)(() => {
            stickyControlContext.update(stickyId, containerRef, options, state);
            setState(state);
        });
    }, [
        stickyControlContext.update,
        stickyId,
        containerRef,
        options,
        setState,
    ]);
    const augmentedOptions = (0,react.useMemo)(() => ({
        ...options,
        offset: quantizeSize(((itemState && itemState.accumulatedOffset) || 0) + options.offset),
    }), [options, itemState && itemState.accumulatedOffset]);
    useBaseSticky(state, handleUpdate, augmentedOptions, containerRef, childRef);
    (0,react.useEffect)(() => {
        // Unregister on unmount
        return () => {
            stickyControlContext.unregister(stickyId);
        };
    }, [stickyId]);
    return state;
}
//# sourceMappingURL=useSticky.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/components/Sticky/Sticky.js






function Sticky(props) {
    const { containerClassName, containerStyle, containerRef, forwardRef, style, initialState, ...restProps } = omitKeys(props, STICKY_OPTIONS_KEYS);
    const containerStickyRef = (0,react.useRef)(null);
    const containerForkRef = useForkRef(containerRef, containerStickyRef);
    const childStickyRef = (0,react.useRef)(null);
    const childForkRef = useForkRef(forwardRef, childStickyRef);
    const stickyState = useSticky(props, containerStickyRef, childStickyRef, initialState);
    return (react.createElement("div", { className: classnames_default()('sticky-container', containerClassName), style: {
            ...getStickyContainerStyle(stickyState, props),
            ...containerStyle || {},
        }, ref: containerForkRef },
        react.createElement("div", Object.assign({}, restProps, { style: {
                ...getStickyChildStyle(stickyState, props),
                ...style || {},
            }, ref: childForkRef }))));
}
//# sourceMappingURL=Sticky.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/components/Sticky/useNodeHeight.js

function useNodeHeight(childRef, initialHeight = 0, 
/**
 * Whether to disable useNodeHeight hook. This is provided to optimize
 * useless updates when the results are not used due to responsive design, etc
 */
disabled = false) {
    const [height, setHeight] = (0,react.useState)(initialHeight);
    (0,react.useEffect)(() => {
        if (disabled)
            return;
        const childElem = childRef.current;
        if (childElem == null)
            return;
        let timerId = null;
        const update = () => {
            timerId = null;
            const rect = childElem.getBoundingClientRect();
            const newHeight = rect.bottom - rect.top;
            if (newHeight !== height) {
                setHeight(newHeight);
            }
        };
        const scheduleUpdate = () => {
            if (timerId != null) {
                cancelAnimationFrame(timerId);
            }
            timerId = requestAnimationFrame(update);
        };
        window.addEventListener('resize', scheduleUpdate);
        update();
        return () => {
            if (timerId != null) {
                cancelAnimationFrame(timerId);
            }
            window.removeEventListener('resize', scheduleUpdate);
        };
    });
    return height;
}
//# sourceMappingURL=useNodeHeight.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/hooks/useScrollDirection.js

function useScrollDirection(threshold = 10, disabled = false) {
    const [state, setState] = (0,react.useState)('down');
    (0,react.useEffect)(() => {
        if (disabled)
            return;
        let lastScroll = window.pageYOffset || document.documentElement.scrollTop;
        let timerId = null;
        const handleUpdate = () => {
            timerId = null;
            const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
            if (Math.abs(lastScroll - currentScroll) > threshold) {
                const delta = currentScroll - lastScroll;
                lastScroll = currentScroll;
                setState(delta > 0 ? 'down' : 'up');
            }
        };
        const handleScroll = () => {
            if (timerId != null) {
                cancelAnimationFrame(timerId);
            }
            timerId = requestAnimationFrame(handleUpdate);
        };
        document.addEventListener('scroll', handleScroll, { passive: true });
        return () => {
            if (timerId != null) {
                cancelAnimationFrame(timerId);
            }
            document.removeEventListener('scroll', handleScroll);
        };
    }, [disabled, threshold]);
    return state;
}
//# sourceMappingURL=useScrollDirection.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/components/Sticky/useScrollAppear.js



function useScrollAppear(childRef, options = {}) {
    const { offset = 0, threshold = 10, initialHeight = 0, disabled = false, } = options;
    const scrollDir = useScrollDirection(threshold, disabled);
    const height = useNodeHeight(childRef, initialHeight, disabled);
    const result = (0,react.useMemo)(() => ({
        offset: scrollDir === 'down' ? -height : offset,
        offsetRange: [-height, offset],
    }), [scrollDir, height, offset]);
    return result;
}
//# sourceMappingURL=useScrollAppear.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/components/Sticky/ScrollSticky.js




function ScrollSticky(props) {
    const { initialHeight, threshold, offset, disabled, forwardRef, ...restProps } = props;
    const childStickyRef = (0,react.useRef)(null);
    const childForkRef = useForkRef(forwardRef, childStickyRef);
    const offsets = useScrollAppear(childStickyRef, { offset, threshold, initialHeight, disabled });
    return (react.createElement(Sticky, Object.assign({}, restProps, offsets, { forwardRef: childForkRef })));
}
//# sourceMappingURL=ScrollSticky.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/components/Sticky/StickyProvider.js


const STICKY_ENTRY_STATE_KEYS = [
    'disabled',
    'emulatedDisabled',
    'height',
    'bottom',
    'beginY',
];
const DIRECTIONS = ['top', 'bottom'];
function StickyProvider(props) {
    const { children } = props;
    const [entries, setEntries] = (0,react.useState)({});
    const entriesRef = (0,react.useRef)(entries);
    entriesRef.current = entries;
    const shouldSortEntriesRef = (0,react.useRef)(false);
    const entriesOrderRef = (0,react.useRef)({
        top: { ids: [], parentIndices: [] },
        bottom: { ids: [], parentIndices: [] },
    });
    const updateEntries = (0,react.useCallback)((getState) => {
        return setEntries((prevState) => {
            // top/bottom sticky objects are unrelated with each other. Therefore
            // run entire routine for each direction.
            const nextState = getState(prevState);
            if (nextState === prevState) {
                return prevState;
            }
            const entriesMap = nextState;
            const resultSet = { ...nextState };
            DIRECTIONS.forEach((direction) => {
                const orders = entriesOrderRef.current[direction];
                if (shouldSortEntriesRef.current) {
                    // Sort the sticky entries according to the DOM order.
                    // ... This can be done relatively easily IF we had shared className,
                    // or attribute available to search using querySelectorAll().
                    // However, we can't determine that's the case - this can be provided
                    // with HTMLElement - no other requirements are specified - therefore
                    // we have to handle every case.
                    // Therefore... we must implement graph traversal.
                    // - The sorting algorithm doesn't need to be implemented, as
                    //   array.sort() can receive comparator function.
                    // - While sorthing through array.sort(), comparator function gets
                    //   called O(n log n) times. Since we can assume that sticky nodes
                    //   exist on the screen AT MOST 10, this is pretty much negligble.
                    // - The comparator function should just call
                    //   'compareDocumentPosition()' method to compare the position
                    //   between two elements.
                    // Note that .sort() method is mutable.
                    // NOTE: This routine will not work properly if the sticky element is
                    // between multiple document, for example, iframes, or window.open().
                    // Since we can assume that this will not happen, we can ignore this.
                    // However this is pretty trivial to resolve since we just need to
                    // attach new StickyProvider onto the new document's elements.
                    const dirEntries = Object.keys(entriesMap)
                        .map((key) => entriesMap[key])
                        .filter((item) => item.direction === direction);
                    const orderedItems = dirEntries.sort((a, b) => {
                        const aElem = a.ref.current;
                        const bElem = b.ref.current;
                        if (aElem == null)
                            return 1;
                        if (bElem == null)
                            return -1;
                        const compareResult = aElem.compareDocumentPosition(bElem);
                        if (compareResult & Node.DOCUMENT_POSITION_FOLLOWING) {
                            return -1;
                        }
                        if (compareResult & Node.DOCUMENT_POSITION_PRECEDING) {
                            return 1;
                        }
                        return 0;
                    });
                    let ids = orderedItems.map((v) => v.id);
                    // Flip the list if the direction is bottom.
                    if (direction === 'bottom') {
                        ids = ids.reverse();
                    }
                    // Determine the Sticky dependency graph parent indices. Since the
                    // 'orders.ids' already stores sorted IDs, we can use that to quickly
                    // derive parent indices.
                    // NOTE: While it should be possible to determine parent IDs and order
                    // at the same time, the logic is already mind-boggling at this
                    // point. To avoid making this difficult, sorting -> backreferencing
                    // can be applied to quickly determine the parents of the Sticky node.
                    const parentIndices = [];
                    for (let i = 0; i < ids.length; i += 1) {
                        const item = entriesMap[ids[i]];
                        if (item == null)
                            continue;
                        const itemElem = item.ref.current;
                        if (itemElem == null)
                            continue;
                        // For each node, determine the "parent" node, excluding the
                        // siblings.
                        // Due to this nested loop, the time complexity would be
                        // O(n^2 log m). Still, this is acceptable as n is already too
                        // small.
                        let targetIndex = -1;
                        for (let j = i - 1; j >= 0; j -= 1) {
                            const target = entriesMap[ids[j]];
                            if (target == null)
                                continue;
                            const targetElem = target.ref.current;
                            if (targetElem == null)
                                continue;
                            const targetParentElem = targetElem.parentElement;
                            if (targetParentElem == null)
                                continue;
                            // Check if the target:
                            // - "has no bottom" therefore it should always stick regardless
                            //   of DOM node hierarchy
                            // - 's parent element contains itemElem. When this is true,
                            //   target element is on the top/bottom of the item element -
                            //   which means that the offset should use data from there.
                            //
                            // Let's skip "disableBottom" for now - the "contains" logic
                            // works like this:
                            //
                            // 1. In the following case, B should be below A since
                            //    A will always be visible while looking at B.
                            // div
                            //  +------+------------+
                            //        A             B
                            //
                            // 2. It doesn't matter if B is below some node too.
                            // div
                            //  +------+------------+
                            //         A           div
                            //                      +--------+
                            //                               B
                            //
                            // 3. HOWEVER, if A is below some node, it should not stick
                            //    with each other, as A and B will never intersect, since
                            //    the Sticky's scope only expand's to its parent element.
                            //
                            // div
                            //  +------+------------+
                            //        div           B
                            //         +
                            //         A
                            //
                            // For these cases, A.parentElement.contains(B) should check
                            // all these (as the nodes are already ordered at this point)
                            // and return the correct result. Therefore, we're just
                            // only relying on this logic.
                            // NOTE: This WILL break if the code uses
                            // flex-direction: row-reverse or something like that. We hope
                            // that will never happen...
                            if (target.disableBottom ||
                                targetParentElem.contains(itemElem)) {
                                // Found an adequate item, set the index and break
                                targetIndex = j;
                                break;
                            }
                        }
                        parentIndices[i] = targetIndex;
                    }
                    orders.ids = ids;
                    orders.parentIndices = parentIndices;
                    entriesOrderRef.current[direction] = orders;
                }
                // Determine the new accumulatedOffset...
                const accumulatedOffsets = [];
                const accumulatedOffsetRanges = [];
                orders.ids.forEach((key, order) => {
                    const parentIndex = orders.parentIndices[order];
                    const parentOffset = parentIndex === -1 ? 0 : accumulatedOffsets[parentIndex];
                    const parentOffsetRange = parentIndex === -1 ? [0, 0] : accumulatedOffsetRanges[parentIndex];
                    const item = entriesMap[key];
                    if (item == null || parentIndex == null)
                        return;
                    if (item.accumulatedOffset !== parentOffset ||
                        item.order !== order) {
                        resultSet[key] = {
                            ...item,
                            accumulatedOffset: parentOffset,
                            accumulatedOffsetRange: parentOffsetRange,
                            order,
                        };
                    }
                    if (!item.disabled && !item.bottom) {
                        accumulatedOffsets[order] =
                            parentOffset + item.offset + (item.height ?? 0);
                        accumulatedOffsetRanges[order] = [
                            parentOffsetRange[0] + (item.height ?? 0) +
                                (item.offsetRange?.[0] ?? item.offset),
                            parentOffsetRange[1] + (item.height ?? 0) +
                                (item.offsetRange?.[1] ?? item.offset),
                        ];
                    }
                    else {
                        accumulatedOffsets[order] = parentOffset;
                        accumulatedOffsetRanges[order] = parentOffsetRange;
                    }
                });
            });
            shouldSortEntriesRef.current = false;
            return resultSet;
        });
    }, []);
    const handleRegister = (0,react.useCallback)(() => {
        shouldSortEntriesRef.current = true;
        // Assign a random ID
        // NOTE: This is NOT deterministic and therefore there can be
        // inconsistencies between the server and the client while doing SSR.
        // However, this ID is never exposed outside React state and therefore
        // there won't be any discrepancies in the resulting HTML itself.
        return String((Math.random() * 0x7FFFFFFF) | 0);
    }, [setEntries]);
    const handleUpdate = (0,react.useCallback)((id, containerRef, options, state) => {
        updateEntries((prevState) => {
            // Check if the related state has changed so that we have to recalculate
            // the accumulatedOffset of sibling states.
            let prevItem = prevState[id];
            if (prevItem == null) {
                // New item has appended
                shouldSortEntriesRef.current = true;
                prevItem = {
                    id,
                    type: undefined,
                    shouldInfluenceScroll: true,
                    direction: null,
                    disabled: true,
                    emulatedDisabled: true,
                    disableBottom: false,
                    bottom: false,
                    height: 0,
                    offset: 0,
                    accumulatedOffset: 0,
                    accumulatedOffsetRange: [0, 0],
                    beginY: 0,
                    ref: containerRef,
                    order: 0,
                };
            }
            const hasChanged = STICKY_ENTRY_STATE_KEYS.some((key) => prevItem[key] !== state[key]) ||
                prevItem.direction !== options.direction ||
                prevItem.offset !== options.offset ||
                prevItem.disableBottom !== options.disableBottom ||
                prevItem.type !== options.type ||
                prevItem.shouldInfluenceScroll !==
                    (options.shouldInfluenceScroll ?? true);
            // offsetRange is omitted from diff calculation, as it can trigger
            // unnecessary updates
            if (!hasChanged) {
                // Nothing has changed; do nothing
                return prevState;
            }
            if (prevItem.direction !== options.direction) {
                // The sticky's direction has changed - re-sort the set
                shouldSortEntriesRef.current = true;
            }
            // Overwrite the related value
            return {
                ...prevState,
                [id]: {
                    ...prevItem,
                    direction: options.direction,
                    disabled: state.disabled,
                    emulatedDisabled: state.emulatedDisabled,
                    height: state.height,
                    bottom: state.bottom,
                    beginY: state.beginY,
                    offset: options.offset,
                    offsetRange: options.offsetRange,
                    disableBottom: options.disableBottom,
                    type: options.type,
                    shouldInfluenceScroll: options.shouldInfluenceScroll ?? true,
                },
            };
        });
    }, [updateEntries]);
    const handleUnregister = (0,react.useCallback)((id) => {
        shouldSortEntriesRef.current = true;
        updateEntries((prevState) => {
            const newState = { ...prevState };
            delete newState[id];
            return newState;
        });
    }, [updateEntries]);
    const handleGetState = (0,react.useCallback)(() => {
        return { entries: entriesRef.current };
    }, []);
    const controlValue = (0,react.useMemo)(() => ({
        register: handleRegister,
        update: handleUpdate,
        unregister: handleUnregister,
        getState: handleGetState,
    }), [handleRegister, handleUpdate, handleUnregister, handleGetState]);
    return (react.createElement(StickyControlContext.Provider, { value: controlValue },
        react.createElement(StickyValueContext.Provider, { value: { entries } }, children)));
}
//# sourceMappingURL=StickyProvider.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/components/Sticky/useGetStickyHeight.js



function useGetStickyHeight(direction = 'top') {
    const stickyControlContext = (0,index_modern/* useContext */.qp)(StickyControlContext);
    if (stickyControlContext == null) {
        throw new Error('StickyContext is not provided');
    }
    // TODO: This will be inaccurate if there are non-overlapping
    // sticky on the document. The difference will be minor if there aren't
    // too much of them, however, to correctly implement that, we basically have
    // to rewrite sticky emulation here. Because of this, I'm leaving this as-is,
    // yet, to allow future updates without breaking change, this accepts targetY
    // as the target position of the document. This can be implemented later,
    // and the upgrade path would be simple enough.
    return (0,react.useCallback)((targetY, filterEntry) => {
        const { entries } = stickyControlContext.getState();
        const entryList = Object.keys(entries)
            .map((key) => entries[key])
            .filter((entry) => {
            if (entry.direction !== direction)
                return false;
            if (!entry.shouldInfluenceScroll)
                return false;
            if (filterEntry != null && !filterEntry(entry))
                return false;
            return true;
        });
        const height = entryList.reduce((prev, entry) => {
            if (entry.disabled)
                return prev;
            if (entry.beginY > targetY) {
                return prev;
            }
            const maxOffset = entry.offsetRange != null ? entry.offsetRange[1] : entry.offset;
            return prev + maxOffset + (entry.height || 0);
        }, 0);
        return height;
    }, [stickyControlContext, direction]);
}
//# sourceMappingURL=useGetStickyHeight.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/components/Sticky/useStickyHeight.js





function useStickyHeight(ref, direction = 'top') {
    const stickyControlContext = (0,index_modern/* useContext */.qp)(StickyControlContext);
    if (stickyControlContext == null) {
        throw new Error('StickyContext is not provided');
    }
    const stickyIdRef = (0,react.useRef)(null);
    const stickyId = stickyIdRef.current || stickyControlContext.register();
    stickyIdRef.current = stickyId;
    const itemState = (0,index_modern/* useContextSelector */.Sz)(StickyValueContext, (context) => {
        if (context == null) {
            return null;
        }
        return context.entries[stickyId];
    });
    (0,react.useEffect)(() => {
        stickyControlContext.update(stickyId, ref, {
            shouldInfluenceScroll: false,
            direction,
            offset: 0,
        }, DEFAULT_STICKY_STATE);
    }, [stickyControlContext.update, stickyId, ref, direction]);
    (0,react.useEffect)(() => {
        // Unregister on unmount
        return () => {
            stickyControlContext.unregister(stickyId);
        };
    }, [stickyId]);
    return {
        min: quantizeSize(itemState?.accumulatedOffsetRange?.[0] ?? 0),
        max: quantizeSize(itemState?.accumulatedOffsetRange?.[1] ?? 0),
        current: quantizeSize(itemState?.accumulatedOffset ?? 0),
    };
}
//# sourceMappingURL=useStickyHeight.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/components/Sticky/StickyCompat.js






/**
 * The compatibility component for older versions of Sticky. This is provided
 * because there are more than 60 instances of Sticky in the codebase, and it is
 * not possible to convert them one by one.
 * However, please do note that this only tries to match the observed behavior
 * in the ohou.se-client.
 *
 * Furthermore, offset functions, for example, offset={() => {}} is omitted
 * because it is fundamentally incompatible from current Sticky design, and it
 * is not possible to make escape hatch for it.
 * Instead, we provide ScrollStickyCompat for exactly this purpose, so please
 * use that instead.
 * @deprecated Please convert this to Sticky, as this is only provided for
 *   compatibility reasons.
 */
function StickyCompat(props) {
    const { className, enabledClassName, innerClassName, children, containerRef, innerRef, onEnabledChange, containerStyle, style, initialState, ...restProps } = omitKeys(props, STICKY_OPTIONS_KEYS);
    const containerStickyRef = (0,react.useRef)(null);
    const containerForkRef = useForkRef(containerRef, containerStickyRef);
    const childStickyRef = (0,react.useRef)(null);
    const childForkRef = useForkRef(innerRef, childStickyRef);
    // disabled can receive both function and boolean; defer it if it's function
    const { disabled: disabledProp } = props;
    const [disabledState, setDisabled] = (0,react.useState)(true);
    const disabled = 
    // eslint-disable-next-line react/destructuring-assignment
    typeof disabledProp === 'function' ? disabledState : disabledProp;
    const stickyOptions = { ...props, disabled };
    const stickyState = useSticky(stickyOptions, containerStickyRef, childStickyRef, initialState);
    (0,react.useEffect)(() => {
        if (onEnabledChange != null) {
            onEnabledChange(stickyState.emulatedDisabled);
        }
    }, [onEnabledChange, stickyState.emulatedDisabled]);
    (0,react.useEffect)(() => {
        if (typeof disabledProp === 'function') {
            setDisabled(disabledProp());
        }
    }, [disabledProp]);
    return (react.createElement("div", { className: classnames_default()('sticky-container', !stickyState.emulatedDisabled && enabledClassName, className), style: {
            ...getStickyContainerStyle(stickyState, stickyOptions),
            ...containerStyle || {},
        }, ref: containerForkRef },
        react.createElement("div", Object.assign({}, restProps, { className: classnames_default()('sticky-child', innerClassName), style: {
                ...getStickyChildStyle(stickyState, stickyOptions),
                ...style || {},
            }, ref: childForkRef }), children)));
}
//# sourceMappingURL=StickyCompat.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/components/Sticky/ScrollStickyCompat.js




/**
 * The compatibility component for older versions of Sticky, with the scroll-to-
 * appear feature.
 * @deprecated Please convert this to Sticky, as this is only provided for
 *   compatibility reasons.
 */
function ScrollStickyCompat(props) {
    const { innerRef, offset, threshold, initialHeight, ...restProps } = props;
    const childStickyRef = (0,react.useRef)(null);
    const childForkRef = useForkRef(innerRef, childStickyRef);
    const offsets = useScrollAppear(childStickyRef, { offset, threshold, initialHeight });
    return (react.createElement(StickyCompat, Object.assign({}, restProps, offsets, { innerRef: childForkRef })));
}
//# sourceMappingURL=ScrollStickyCompat.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/components/Sticky/index.js














//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/components/index.js






//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/hooks/useChanged.js

/**
 * Determines if the given value has changed.
 * @param {any} value The value to compare against.
 * @param {function} isEqual The checking mechanism. Defaults to shallow equal.
 * @return {boolean} Whether if the value has changed.
 */
function useChanged(value, isEqual = (a, b) => a === b) {
    const prevValueRef = (0,react.useRef)();
    if (prevValueRef.current == null) {
        prevValueRef.current = { value };
        return false;
    }
    const prevValue = prevValueRef.current.value;
    const changed = !isEqual(prevValue, value);
    prevValueRef.current.value = value;
    return changed;
}
//# sourceMappingURL=useChanged.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/hooks/usePagedInfiniteList.js


function insertChunk(list, item) {
    const output = [];
    let currentPos = 0;
    let currentOffset = 0;
    // 1. Traverse until the target offset is reached. If target offset is
    // reached, we have to slice the chunk to fit the new entry.
    //             v cut
    // ----####------#######
    //             #####
    while (currentPos < list.length) {
        const chunk = list[currentPos];
        // NOTE There is an invariant property: List of chunks must be continious.
        // That is, while we allow 'empty' chunks, there must be 'empty' chunk
        // explaining the count and offset of the chunk. There must be no 'gaps',
        // i.e. sudden jump of offset.
        if (chunk.count + chunk.offset >= item.offset) {
            if (chunk.offset >= item.offset) {
                // It immediately reaches threshold at the beginning - don't
                // insert anything.
                break;
            }
            const remaining = item.offset - chunk.offset;
            // Slice the output to meet the criteria.
            currentOffset = chunk.offset + remaining;
            if (chunk.type === 'page') {
                output.push({
                    ...chunk,
                    count: remaining,
                    items: chunk.items.slice(0, remaining),
                });
            }
            else {
                output.push({
                    ...chunk,
                    count: remaining,
                });
            }
            break;
        }
        // It does not reach any threshold; just output them.
        output.push(chunk);
        currentPos += 1;
        currentOffset = chunk.offset + chunk.count;
    }
    // 1-2. If it hasn't reached any threshold yet, insert a empty chunk to
    // reach the target offset.
    if (currentOffset !== item.offset) {
        output.push({
            type: 'empty',
            offset: currentOffset,
            count: item.offset - currentOffset,
        });
    }
    // 2. Insert the new item to the output.
    output.push(item);
    // 3. Insert the remaining chunks, while slicing / skipping when
    // necessary.
    const exitOffset = item.offset + item.count;
    for (; currentPos < list.length; currentPos += 1) {
        const chunk = list[currentPos];
        if (chunk.offset < exitOffset) {
            if (chunk.offset + chunk.count <= exitOffset) {
                // It immediately reaches threshold at the beginning - don't
                // insert anything.
                continue;
            }
            const remaining = exitOffset - chunk.offset;
            // Slice the output to meet the criteria.
            if (chunk.type === 'page') {
                output.push({
                    ...chunk,
                    offset: exitOffset,
                    count: chunk.count - remaining,
                    items: chunk.items.slice(remaining),
                });
            }
            else {
                output.push({
                    ...chunk,
                    offset: exitOffset,
                    count: chunk.count - remaining,
                });
            }
            continue;
        }
        // It does not reach any threshold; just output them.
        output.push(chunk);
    }
    return output;
}
function mapHintChunks(chunks) {
    // eslint-disable-next-line array-callback-return
    return chunks.map((v) => {
        // eslint-disable-next-line default-case
        switch (v.type) {
            case 'page':
                return { type: 'page', page: v.page, count: v.count };
            case 'empty':
                return { type: 'empty', count: v.count };
        }
    });
}
function getChunkIndex(chunks, offset) {
    // Run a binary search to find the right chunk.
    let minPos = 0;
    let maxPos = chunks.length - 1;
    while (minPos <= maxPos) {
        const middle = (minPos + maxPos) >> 1;
        const middleItem = chunks[middle];
        if (middleItem.offset > offset) {
            maxPos = middle - 1;
        }
        else if (middleItem.offset + middleItem.count <= offset) {
            minPos = middle + 1;
        }
        else {
            // Found the right item.
            return middle;
        }
    }
    return -1;
}
function getLoadablePage(state, per, totalCount, targetStartIndex, targetEndIndex) {
    // Determine which page to load. This can be determined using:
    // 1. Using nearest loaded page. This can be used when nearest page is
    //    not far enough (<20 items)
    // 2. Using hint chunks. This can be used when hint chunks covers that
    //    range.
    // 3. Using heuristics. Since we can *usually* assume that pages are divided
    //    by 'per' count, we can skip from nearest loaded page.
    // Note that load request doesn't have to cover all items between
    // startIndex and endIndex - it's fine to load just a part of it -
    // loadMore will be triggered again anyway.
    // Note that endIndex is inclusive; [0, 0] means 0th item must be loaded.
    const startIndex = Math.max(0, targetStartIndex);
    let endIndex = targetEndIndex;
    if (totalCount != null) {
        endIndex = Math.min(endIndex, totalCount - 1);
    }
    if (state.totalCount != null) {
        endIndex = Math.min(endIndex, state.totalCount - 1);
    }
    if ((totalCount != null && startIndex > totalCount) ||
        (state.totalCount != null && startIndex > state.totalCount)) {
        return null;
    }
    let lastOffset = startIndex;
    // Retrieve the first page to load. If there is no page left to load,
    // do nothing.
    let chunkIndex = getChunkIndex(state.chunks, startIndex);
    let chunkPage = null;
    let chunkOffset = null;
    // Scroll until the end is reached.
    if (chunkIndex !== -1) {
        while (chunkIndex < state.chunks.length && lastOffset <= endIndex) {
            const chunkItem = state.chunks[chunkIndex];
            // Empty item immediately fails the test.
            if (chunkItem.type === 'empty') {
                // This assumes that 'empty' chunk item is not consecutive.
                // Determine which page to load. It can:
                // 1. Snap to the start of empty chunk (or end of page chunk)
                // 2. Snap to the end of empty chunk (or start of page chunk)
                // 3. Snap to neither
                // For 1 or 2 to succeed, it must be within 'per' range.
                //
                // |-per-............-per-|
                // |...---here---.........|
                //
                // For the above case, it'll snap to start of chunk because it's
                // within 'per' radius.
                //
                // |-per-............-per-|
                // |.....---here---.......|
                //
                // This does not snap, therefore heuristics will be used. (Note, this
                // may generate fragmentation or other data integrity errors)
                const prevItem = state.chunks[chunkIndex - 1];
                const nextItem = state.chunks[chunkIndex + 1];
                // Check leftmost
                if (prevItem != null && prevItem.type === 'page' &&
                    startIndex <= chunkItem.offset + per) {
                    chunkPage = prevItem.page + 1;
                    chunkOffset = chunkItem.offset;
                    break;
                }
                // Check rightmost
                if (nextItem != null && nextItem.type === 'page' &&
                    endIndex >= chunkItem.offset + chunkItem.count - per) {
                    chunkPage = nextItem.page - 1;
                    chunkOffset = chunkItem.offset + chunkItem.count - per;
                    break;
                }
                // Nothing matches; use heuristics
                lastOffset = Math.max(startIndex, chunkItem.offset);
                break;
            }
            else if (chunkItem.type === 'page' &&
                chunkIndex === state.chunks.length - 1) {
                // Last page has reached; since startIndex already intersects with
                // the pages, just load next page.
                chunkPage = chunkItem.page + 1;
                chunkOffset = chunkItem.offset + chunkItem.count;
            }
            lastOffset = chunkItem.offset + chunkItem.count;
            chunkIndex += 1;
        }
    }
    else {
        // Nothing matched! ... If last chunk is page chunk, and startIndex is
        // within bounds, use that.
        const lastItem = state.chunks[state.chunks.length - 1];
        if (lastItem != null && lastItem.type === 'page' &&
            endIndex <= lastItem.offset + lastItem.count + per) {
            chunkPage = lastItem.page + 1;
            chunkOffset = lastItem.offset + lastItem.count;
        }
    }
    if (lastOffset > endIndex) {
        return null;
    }
    // Check if page number is determined yet...
    if (chunkPage == null || chunkOffset == null) {
        // It still didn't match. It can use hint information to resurrect
        // the given page, or if even that doesn't exist, heuristics can be used.
        // While we store hint chunks, heuristics are pretty reliable for now -
        // there is no need for hint chunk implementation for yet.
        chunkPage = Math.floor(lastOffset / per) + 1;
        chunkOffset = (chunkPage - 1) * per;
    }
    return { page: chunkPage, offset: chunkOffset };
}
function initPagedInfiniteListState(chunk) {
    if (chunk != null) {
        const chunks = insertChunk([], {
            type: 'page',
            page: chunk.page,
            offset: chunk.offset ?? 0,
            count: chunk.items.length,
            items: chunk.items,
        });
        const hasNext = chunk.hasNext != null
            ? chunk.hasNext
            : chunk.items.length > 0;
        const afterOffset = (chunk.offset ?? 0) + chunk.items.length;
        return {
            chunks,
            hintChunks: mapHintChunks(chunks),
            count: afterOffset,
            scrolledCount: null,
            totalCount: !hasNext ? afterOffset : null,
            epoch: 0,
            error: null,
        };
    }
    return {
        chunks: [],
        hintChunks: [],
        count: 0,
        scrolledCount: null,
        totalCount: null,
        epoch: 0,
        error: null,
    };
}
function pagedInfiniteListReducer(state, action) {
    // eslint-disable-next-line default-case
    switch (action.type) {
        case 'load': {
            // Try to insert the chunk information at the designated offset.
            // If there is any empty space between chunks, insert 'empty' chunk
            // between it.
            // If target offset is already occupied, overwrite over the chunk.
            // TODO Remove any duplicate items if possible to do so
            const { offset, page, items, hasNext } = action.item;
            const targetOffset = action.targetOffset != null
                ? action.targetOffset
                : offset;
            const outputChunks = insertChunk(state.chunks, {
                type: 'page',
                page,
                offset: targetOffset ?? 0,
                count: items.length,
                items,
            });
            const lastChunk = outputChunks[outputChunks.length - 1];
            let nextTotalCount = state.totalCount;
            if (hasNext != null ? !hasNext : items.length === 0) {
                const offset = lastChunk.offset + lastChunk.count;
                nextTotalCount = nextTotalCount != null
                    ? Math.min(nextTotalCount, offset)
                    : offset;
            }
            return {
                ...state,
                chunks: outputChunks,
                hintChunks: mapHintChunks(outputChunks),
                count: lastChunk.offset + lastChunk.count,
                totalCount: nextTotalCount,
                epoch: action.isAsync ? state.epoch + 1 : state.epoch,
            };
        }
        case 'end': {
            return {
                ...state,
                totalCount: state.totalCount != null
                    ? Math.min(state.totalCount, action.offset)
                    : action.offset,
                epoch: action.isAsync ? state.epoch + 1 : state.epoch,
            };
        }
        case 'setHint': {
            return {
                ...state,
                hintChunks: action.hintChunks,
                scrolledCount: action.scrolledCount,
            };
        }
        case 'reset': {
            return initPagedInfiniteListState();
        }
        case 'error': {
            return { ...state, error: action.error };
        }
        case 'clearError': {
            return { ...state, error: null };
        }
    }
}
function usePagedInfiniteList(tabId, pending, loadMore, getInitialData, per, loadThreshold = 5, 
/**
 * The absolute total count of the items passed from the server. The client
 * will not request any more pages further from this.
 * Note this can be omitted - most pages don't even have totalCount value.
 * When this is omitted, it may send additional requests and therefore
 * a placeholder 'flicker' might be visible when the end of the list is
 * reached.
 */
totalCount) {
    // TODO Reload when location changes
    const initialDataFilled = (0,react.useRef)(false);
    const initialRendered = (0,react.useRef)(false);
    const innerPending = (0,react.useRef)(false);
    const locationChanged = useChanged(tabId);
    const changedEpoch = (0,react.useRef)(0);
    const stateEpoch = (0,react.useRef)(0);
    const displayedRef = (0,react.useRef)([0, 0]);
    const mountedRef = (0,react.useRef)(true);
    const [state, dispatch] = (0,react.useReducer)(pagedInfiniteListReducer, undefined, () => initPagedInfiniteListState(getInitialData()));
    const stateRef = (0,react.useRef)(state);
    stateRef.current = state;
    if (locationChanged) {
        changedEpoch.current += 1;
        innerPending.current = false;
    }
    // Unmount handler
    (0,react.useEffect)(() => {
        return () => {
            mountedRef.current = false;
        };
    }, []);
    (0,react.useEffect)(() => {
        if (changedEpoch.current > 0) {
            dispatch({ type: 'reset' });
            initialDataFilled.current = false;
            initialRendered.current = false;
        }
        if (tabId != null) {
            // Reload hint data, if available.
            let value;
            try {
                value = JSON.parse(sessionStorage[`plist-hint-${tabId}`] || 'null');
            }
            catch (e) {
                // Do nothing if failed
            }
            if (value != null) {
                dispatch({
                    type: 'setHint',
                    hintChunks: value.hintChunks,
                    scrolledCount: value.scrolledCount,
                });
            }
        }
    }, [changedEpoch.current, tabId]);
    (0,react.useEffect)(() => {
        const prevEpoch = stateEpoch.current;
        if (stateEpoch.current !== state.epoch) {
            stateEpoch.current = state.epoch;
            if (prevEpoch < state.epoch && tabId != null) {
                const timerId = window.setTimeout(() => {
                    try {
                        sessionStorage[`plist-hint-${tabId}`] = JSON.stringify({
                            hintChunks: state.hintChunks,
                            scrolledCount: state.count,
                        });
                    }
                    catch (e) {
                        // Do nothing if failed
                    }
                }, 200);
                return () => window.clearTimeout(timerId);
            }
        }
    }, [state.epoch, tabId, state]);
    const handleGetItem = (0,react.useMemo)(() => {
        // To avoid running binary search every time an item lookup is needed, we
        // memoize last index of the item. This can reduce time complexity from
        // O(m log n) to O(m + log n), with space complexity of O(1).
        let currentItem = null;
        return (index) => {
            // If the index is out of bounds, return null immediately.
            if (index < 0 || index >= state.count) {
                return null;
            }
            // If the index is already within bounds, return the item.
            if (currentItem != null &&
                currentItem.offset <= index &&
                currentItem.offset + currentItem.count > index) {
                if (currentItem.type === 'page') {
                    return currentItem.items[index - currentItem.offset];
                }
                return null;
            }
            // Run a binary search to find the right chunk.
            const chunkIndex = getChunkIndex(state.chunks, index);
            if (chunkIndex === -1) {
                return null;
            }
            currentItem = state.chunks[chunkIndex];
            if (currentItem.type === 'page') {
                return currentItem.items[index - currentItem.offset];
            }
            return null;
        };
    }, [state]);
    const handleLoadMore = (0,react.useCallback)(async (startIndex, endIndex) => {
        // Reset the currently displayed index.
        displayedRef.current = [startIndex, endIndex];
        if (innerPending.current || pending || !initialDataFilled.current ||
            stateRef.current.error != null) {
            return;
        }
        let nextPage;
        const currentEpoch = changedEpoch.current;
        // Lock
        innerPending.current = true;
        do {
            if (!mountedRef.current ||
                stateRef.current.error != null ||
                changedEpoch.current !== currentEpoch) {
                break;
            }
            const [start, end] = displayedRef.current;
            nextPage =
                getLoadablePage(stateRef.current, per, totalCount, start, end + 1);
            // Digest remaining...
            // If there are anything to load, perform loading.
            if (nextPage == null) {
                break;
            }
            try {
                const result = await loadMore(nextPage.page);
                if (changedEpoch.current !== currentEpoch) {
                    break;
                }
                dispatch({
                    type: 'load',
                    item: {
                        ...result,
                        offset: result.offset || nextPage.offset,
                    },
                    isAsync: true,
                });
            }
            catch (e) {
                const error = e;
                // Handle error
                console.error(`${error.toString()}\n${error.stack}`);
                dispatch({ type: 'error', error });
            }
        } while (nextPage != null);
        // Unlock
        innerPending.current = false;
    }, [pending, loadMore, handleGetItem]);
    (0,react.useEffect)(() => {
        if (!pending) {
            if (!initialDataFilled.current) {
                const chunk = getInitialData();
                if (chunk != null) {
                    if (chunk.items.length === 0) {
                        dispatch({
                            type: 'end',
                            offset: chunk.offset ?? 0,
                            isAsync: true,
                        });
                    }
                    else {
                        dispatch({ type: 'load', item: chunk });
                    }
                    initialDataFilled.current = true;
                }
                else {
                    initialDataFilled.current = true;
                    initialRendered.current = true;
                    handleLoadMore(displayedRef.current[0], displayedRef.current[1]);
                }
            }
            else if (!initialRendered.current) {
                initialRendered.current = true;
                handleLoadMore(displayedRef.current[0], displayedRef.current[1]);
            }
        }
    }, [pending, getInitialData, handleLoadMore]);
    const handleRowsRendered = (0,react.useCallback)((startIndex, endIndex) => {
        handleLoadMore(startIndex - loadThreshold, endIndex + loadThreshold);
    }, [loadThreshold, handleLoadMore]);
    const reloadData = (0,react.useCallback)(async () => {
        changedEpoch.current += 1;
        dispatch({ type: 'reset' });
        await handleLoadMore(0, 1);
    }, [handleLoadMore]);
    const handleClearError = (0,react.useCallback)(() => {
        dispatch({ type: 'clearError' });
        handleLoadMore(displayedRef.current[0], displayedRef.current[1]);
    }, [handleLoadMore]);
    const count = Math.max([state.count + per, state.totalCount, totalCount]
        .reduce((p, v) => (v == null ? p : Math.min(v, p)), Infinity), state.scrolledCount ?? 0);
    const loadedCount = state.count;
    return {
        state,
        count: state.error != null ? loadedCount : count,
        loadedCount,
        getItem: handleGetItem,
        loadMore: handleLoadMore,
        handleRowsRendered,
        error: state.error,
        reloadData,
        clearError: handleClearError,
    };
}
//# sourceMappingURL=usePagedInfiniteList.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/hooks/usePagedCursorInfiniteList.js


function usePagedCursorInfiniteList_insertChunk(list, item, direction) {
    const output = [];
    let outputIndex = 0;
    let currentPos = 0;
    let currentOffset = 0;
    // 1. Traverse until the target offset is reached. If target offset is
    // reached, we have to slice the chunk to fit the new entry.
    //             v cut
    // ----####------#######
    //             #####
    while (currentPos < list.length) {
        const chunk = list[currentPos];
        // NOTE There is an invariant property: List of chunks must be continious.
        // That is, while we allow 'empty' chunks, there must be 'empty' chunk
        // explaining the count and offset of the chunk. There must be no 'gaps',
        // i.e. sudden jump of offset.
        if (chunk.count + chunk.offset >= item.offset) {
            if (chunk.offset >= item.offset) {
                // It immediately reaches threshold at the beginning - don't
                // insert anything.
                break;
            }
            const remaining = item.offset - chunk.offset;
            // Slice the output to meet the criteria.
            currentOffset = chunk.offset + remaining;
            if (chunk.type === 'page') {
                output.push({
                    ...chunk,
                    count: remaining,
                    items: chunk.items.slice(0, remaining),
                });
            }
            else {
                output.push({
                    ...chunk,
                    count: remaining,
                });
            }
            break;
        }
        // It does not reach any threshold; just output them.
        output.push(chunk);
        currentPos += 1;
        currentOffset = chunk.offset + chunk.count;
    }
    // 1-2. If it hasn't reached any threshold yet, insert a empty chunk to
    // reach the target offset.
    if (currentOffset !== item.offset) {
        output.push({
            type: 'empty',
            offset: currentOffset,
            count: item.offset - currentOffset,
        });
    }
    // 2. Insert the new item to the output.
    output.push(item);
    outputIndex = output.length;
    // 3. Insert the remaining chunks, while slicing / skipping when
    // necessary.
    const exitOffset = item.offset + item.count;
    for (; currentPos < list.length; currentPos += 1) {
        const chunk = list[currentPos];
        if (chunk.offset < exitOffset) {
            if (chunk.offset + chunk.count <= exitOffset) {
                // It immediately reaches threshold at the beginning - don't
                // insert anything.
                continue;
            }
            const remaining = exitOffset - chunk.offset;
            // Slice the output to meet the criteria.
            if (chunk.type === 'page') {
                output.push({
                    ...chunk,
                    offset: exitOffset,
                    count: chunk.count - remaining,
                    items: chunk.items.slice(remaining),
                });
            }
            else {
                output.push({
                    ...chunk,
                    offset: exitOffset,
                    count: chunk.count - remaining,
                });
            }
            continue;
        }
        // It does not reach any threshold; just output them.
        output.push(chunk);
    }
    // 4. If the item was empty and it can be merged, try to merge it.
    if (item.type === 'page' && item.count === 0) {
        if (direction === 'next') {
            // 4-2. If the direction is next, and the previous item is a 'page' type,
            // Remove current chunk and replace the nextCursor.
            const prevItem = output[outputIndex - 1];
            if (prevItem?.type === 'page') {
                output[outputIndex - 1] = {
                    ...prevItem,
                    nextCursor: item.nextCursor,
                };
                output.splice(outputIndex, 1);
            }
        }
        else if (direction === 'prev') {
            // 4-2. If the direction is prev, and the next item is a 'page' type,
            // Remove current chunk and replace the prevCursor.
            const nextItem = output[outputIndex + 1];
            if (nextItem?.type === 'page') {
                output[outputIndex + 1] = {
                    ...nextItem,
                    prevCursor: item.prevCursor,
                };
                output.splice(outputIndex, 1);
            }
        }
    }
    return output;
}
function usePagedCursorInfiniteList_mapHintChunks(chunks) {
    // eslint-disable-next-line array-callback-return
    return chunks.map((v) => {
        // eslint-disable-next-line default-case
        switch (v.type) {
            case 'page':
                return {
                    type: 'page',
                    nextCursor: v.nextCursor,
                    prevCursor: v.prevCursor,
                    count: v.count,
                    offset: v.offset,
                };
            case 'empty':
                return { type: 'empty', count: v.count, offset: v.offset };
        }
    });
}
function usePagedCursorInfiniteList_getChunkIndex(chunks, offset) {
    // Run a binary search to find the right chunk.
    let minPos = 0;
    let maxPos = chunks.length - 1;
    while (minPos <= maxPos) {
        const middle = (minPos + maxPos) >> 1;
        const middleItem = chunks[middle];
        if (middleItem.offset > offset) {
            maxPos = middle - 1;
        }
        else if (middleItem.offset + middleItem.count <= offset) {
            minPos = middle + 1;
        }
        else {
            // Found the right item.
            return middle;
        }
    }
    return -1;
}
function getLoadablePageImpl(chunks, per, 
// How many consecutive page loading is allowed?
loadThreshold, startIndex, endIndex) {
    let lastOffset = startIndex;
    const perThreshold = per * loadThreshold;
    // Retrieve the first page to load. If there is no page left to load,
    // do nothing.
    let chunkIndex = usePagedCursorInfiniteList_getChunkIndex(chunks, startIndex);
    let chunkLoadable = null;
    // Scroll until the end is reached.
    if (chunkIndex !== -1) {
        while (chunkIndex < chunks.length && lastOffset <= endIndex) {
            const chunkItem = chunks[chunkIndex];
            // Empty item immediately fails the test.
            if (chunkItem.type === 'empty') {
                // This assumes that 'empty' chunk item is not consecutive.
                // Determine which page to load. It can:
                // 1. Snap to the start of empty chunk (or end of page chunk)
                // 2. Snap to the end of empty chunk (or start of page chunk)
                // 3. Snap to neither
                // For 1 or 2 to succeed, it must be within 'per' range.
                //
                // |-per-............-per-|
                // |...---here---.........|
                //
                // For the above case, it'll snap to start of chunk because it's
                // within 'per' radius.
                //
                // |-per-............-per-|
                // |.....---here---.......|
                //
                // This does not snap, therefore heuristics will be used. (Note, this
                // may generate fragmentation or other data integrity errors)
                const prevItem = chunks[chunkIndex - 1];
                const nextItem = chunks[chunkIndex + 1];
                // Check leftmost
                if (prevItem != null && prevItem.type === 'page' &&
                    startIndex <= chunkItem.offset + perThreshold) {
                    chunkLoadable = {
                        direction: 'next',
                        cursor: prevItem.nextCursor,
                        offset: chunkItem.offset,
                        per,
                    };
                    break;
                }
                // Load from the beginning
                if (prevItem == null &&
                    startIndex <= chunkItem.offset + perThreshold) {
                    chunkLoadable = {
                        direction: 'next',
                        cursor: null,
                        offset: chunkItem.offset,
                        per,
                    };
                    break;
                }
                // Check rightmost
                if (nextItem != null && nextItem.type === 'page' &&
                    nextItem.prevCursor != null &&
                    endIndex >= chunkItem.offset + chunkItem.count - perThreshold) {
                    chunkLoadable = {
                        direction: 'prev',
                        cursor: nextItem.prevCursor,
                        offset: chunkItem.offset + chunkItem.count - per,
                        per,
                    };
                    break;
                }
                // Nothing matches; use heuristics
                lastOffset = Math.max(startIndex, chunkItem.offset);
                break;
            }
            else if (chunkItem.type === 'page' &&
                chunkIndex === chunks.length - 1) {
                // Last page has reached; since startIndex already intersects with
                // the pages, just load next page.
                chunkLoadable = {
                    direction: 'next',
                    cursor: chunkItem.nextCursor,
                    offset: chunkItem.offset + chunkItem.count,
                    per,
                };
            }
            lastOffset = chunkItem.offset + chunkItem.count;
            chunkIndex += 1;
        }
    }
    else {
        // Nothing matched! ... If last chunk is page chunk, and startIndex is
        // within bounds, use that.
        const lastItem = chunks[chunks.length - 1];
        if (lastItem != null && lastItem.type === 'page' &&
            endIndex <= lastItem.offset + lastItem.count + perThreshold) {
            chunkLoadable = {
                direction: 'next',
                cursor: lastItem.nextCursor,
                offset: lastItem.offset + lastItem.count,
                per,
            };
        }
    }
    if (lastOffset > endIndex) {
        return null;
    }
    return chunkLoadable;
}
function usePagedCursorInfiniteList_getLoadablePage(state, per, totalCount, targetStartIndex, targetEndIndex) {
    // Determine which page to load. This can be determined using:
    // 1. Using nearest loaded page. This can be used when nearest page is
    //    not far enough (<20 items)
    // 2. Using hint chunks. This can be used when hint chunks covers that
    //    range.
    // 3. Using heuristics. Since we can *usually* assume that pages are divided
    //    by 'per' count, we can skip from nearest loaded page.
    // Note that load request doesn't have to cover all items between
    // startIndex and endIndex - it's fine to load just a part of it -
    // loadMore will be triggered again anyway.
    // Note that endIndex is inclusive; [0, 0] means 0th item must be loaded.
    const startIndex = Math.max(0, targetStartIndex);
    let endIndex = targetEndIndex;
    if (totalCount != null) {
        endIndex = Math.min(endIndex, totalCount - 1);
    }
    if (state.totalCount != null) {
        endIndex = Math.min(endIndex, state.totalCount - 1);
    }
    if ((totalCount != null && startIndex > totalCount) ||
        (state.totalCount != null && startIndex > state.totalCount)) {
        return null;
    }
    const mainLoadable = getLoadablePageImpl(state.chunks, per, 3, startIndex, endIndex);
    if (mainLoadable != null)
        return mainLoadable;
    const hintLoadable = getLoadablePageImpl(state.hintChunks, per, Infinity, startIndex, endIndex);
    if (hintLoadable != null)
        return hintLoadable;
    // Ran out of things to do; Use heuristics maybe?
    // If we have absolutely nothing in the chunks, just load the first page.
    if (state.chunks.length === 0) {
        return {
            cursor: null,
            direction: 'next',
            offset: 0,
            per,
        };
    }
    // In cursor based pagination, this is the only thing we can do - try it
    // again in main chunks state.
    const mainSecondLoadable = getLoadablePageImpl(state.chunks, per, Infinity, startIndex, endIndex);
    if (mainSecondLoadable != null)
        return hintLoadable;
    return null;
}
function usePagedCursorInfiniteList_initPagedInfiniteListState(chunk) {
    if (chunk != null) {
        const chunks = usePagedCursorInfiniteList_insertChunk([], {
            type: 'page',
            prevCursor: chunk.prevCursor,
            nextCursor: chunk.nextCursor,
            offset: chunk.offset ?? 0,
            count: chunk.items.length,
            items: chunk.items,
        });
        const hasNext = chunk.hasNext != null
            ? chunk.hasNext
            : chunk.items.length > 0;
        const afterOffset = (chunk.offset ?? 0) + chunk.items.length;
        return {
            chunks,
            hintChunks: usePagedCursorInfiniteList_mapHintChunks(chunks),
            count: (chunk.offset ?? 0) + chunk.items.length,
            scrolledCount: null,
            totalCount: !hasNext ? afterOffset : null,
            epoch: 0,
            error: null,
        };
    }
    return {
        chunks: [],
        hintChunks: [],
        count: 0,
        scrolledCount: null,
        totalCount: null,
        epoch: 0,
        error: null,
    };
}
function usePagedCursorInfiniteList_pagedInfiniteListReducer(state, action) {
    // eslint-disable-next-line default-case
    switch (action.type) {
        case 'load': {
            // Try to insert the chunk information at the designated offset.
            // If there is any empty space between chunks, insert 'empty' chunk
            // between it.
            // If target offset is already occupied, overwrite over the chunk.
            // TODO Remove any duplicate items if possible to do so
            const { offset, nextCursor, prevCursor, items, hasNext } = action.item;
            const targetOffset = action.targetOffset != null
                ? action.targetOffset
                : offset;
            const outputChunks = usePagedCursorInfiniteList_insertChunk(state.chunks, {
                type: 'page',
                nextCursor,
                prevCursor,
                offset: targetOffset ?? 0,
                count: items.length,
                items,
            }, action.direction);
            const lastChunk = outputChunks[outputChunks.length - 1];
            let nextTotalCount = state.totalCount;
            if (hasNext != null ? !hasNext : items.length === 0) {
                const offset = lastChunk.offset + lastChunk.count;
                nextTotalCount = nextTotalCount != null
                    ? Math.min(nextTotalCount, offset)
                    : offset;
            }
            return {
                ...state,
                chunks: outputChunks,
                hintChunks: usePagedCursorInfiniteList_mapHintChunks(outputChunks),
                count: lastChunk.offset + lastChunk.count,
                totalCount: nextTotalCount,
                epoch: action.isAsync ? state.epoch + 1 : state.epoch,
            };
        }
        case 'end': {
            return {
                ...state,
                totalCount: state.totalCount != null
                    ? Math.min(state.totalCount, action.offset)
                    : action.offset,
                epoch: action.isAsync ? state.epoch + 1 : state.epoch,
            };
        }
        case 'setHint': {
            return {
                ...state,
                hintChunks: action.hintChunks,
                scrolledCount: action.scrolledCount,
            };
        }
        case 'reset': {
            return usePagedCursorInfiniteList_initPagedInfiniteListState();
        }
        case 'error': {
            return { ...state, error: action.error };
        }
        case 'clearError': {
            return { ...state, error: null };
        }
    }
}
function usePagedCursorInfiniteList(tabId, pending, loadMore, getInitialData, per, loadThreshold = 5, 
/**
 * The absolute total count of the items passed from the server. The client
 * will not request any more pages further from this.
 * Note this can be omitted - most pages don't even have totalCount value.
 * When this is omitted, it may send additional requests and therefore
 * a placeholder 'flicker' might be visible when the end of the list is
 * reached.
 */
totalCount) {
    // TODO Reload when location changes
    const initialDataFilled = (0,react.useRef)(false);
    const initialRendered = (0,react.useRef)(false);
    const innerPending = (0,react.useRef)(false);
    const locationChanged = useChanged(tabId);
    const changedEpoch = (0,react.useRef)(0);
    const stateEpoch = (0,react.useRef)(0);
    const displayedRef = (0,react.useRef)([0, 0]);
    const mountedRef = (0,react.useRef)(true);
    const [state, dispatch] = (0,react.useReducer)(usePagedCursorInfiniteList_pagedInfiniteListReducer, undefined, () => usePagedCursorInfiniteList_initPagedInfiniteListState(getInitialData()));
    const stateRef = (0,react.useRef)(state);
    stateRef.current = state;
    if (locationChanged) {
        changedEpoch.current += 1;
        innerPending.current = false;
    }
    // Unmount handler
    (0,react.useEffect)(() => {
        return () => {
            mountedRef.current = false;
        };
    }, []);
    (0,react.useEffect)(() => {
        if (changedEpoch.current > 0) {
            dispatch({ type: 'reset' });
            initialDataFilled.current = false;
            initialRendered.current = false;
        }
        if (tabId != null) {
            // Reload hint data, if available.
            let value;
            try {
                value = JSON.parse(sessionStorage[`plist-hint-${tabId}`] || 'null');
            }
            catch (e) {
                // Do nothing if failed
            }
            if (value != null) {
                dispatch({
                    type: 'setHint',
                    hintChunks: value.hintChunks,
                    scrolledCount: value.scrolledCount,
                });
            }
        }
    }, [changedEpoch.current, tabId]);
    (0,react.useEffect)(() => {
        const prevEpoch = stateEpoch.current;
        if (stateEpoch.current !== state.epoch) {
            stateEpoch.current = state.epoch;
            if (prevEpoch < state.epoch && tabId != null) {
                const timerId = window.setTimeout(() => {
                    try {
                        sessionStorage[`plist-hint-${tabId}`] = JSON.stringify({
                            hintChunks: state.hintChunks,
                            scrolledCount: state.count,
                        });
                    }
                    catch (e) {
                        // Do nothing if failed
                    }
                }, 200);
                return () => window.clearTimeout(timerId);
            }
        }
    }, [state.epoch, tabId, state]);
    const handleGetItem = (0,react.useMemo)(() => {
        // To avoid running binary search every time an item lookup is needed, we
        // memoize last index of the item. This can reduce time complexity from
        // O(m log n) to O(m + log n), with space complexity of O(1).
        let currentItem = null;
        return (index) => {
            // If the index is out of bounds, return null immediately.
            if (index < 0 || index >= state.count) {
                return null;
            }
            // If the index is already within bounds, return the item.
            if (currentItem != null &&
                currentItem.offset <= index &&
                currentItem.offset + currentItem.count > index) {
                if (currentItem.type === 'page') {
                    return currentItem.items[index - currentItem.offset];
                }
                return null;
            }
            // Run a binary search to find the right chunk.
            const chunkIndex = usePagedCursorInfiniteList_getChunkIndex(state.chunks, index);
            if (chunkIndex === -1) {
                return null;
            }
            currentItem = state.chunks[chunkIndex];
            if (currentItem.type === 'page') {
                return currentItem.items[index - currentItem.offset];
            }
            return null;
        };
    }, [state]);
    const handleLoadMore = (0,react.useCallback)(async (startIndex, endIndex) => {
        // Reset the currently displayed index.
        displayedRef.current = [startIndex, endIndex];
        if (innerPending.current || pending || !initialDataFilled.current ||
            stateRef.current.error != null) {
            return;
        }
        let nextPage;
        const currentEpoch = changedEpoch.current;
        // Lock
        innerPending.current = true;
        do {
            if (!mountedRef.current ||
                stateRef.current.error != null ||
                changedEpoch.current !== currentEpoch) {
                break;
            }
            const [start, end] = displayedRef.current;
            nextPage =
                usePagedCursorInfiniteList_getLoadablePage(stateRef.current, per, totalCount, start, end + 1);
            // Digest remaining...
            // If there are anything to load, perform loading.
            if (nextPage == null) {
                break;
            }
            try {
                const result = await loadMore(nextPage);
                if (changedEpoch.current !== currentEpoch) {
                    break;
                }
                dispatch({
                    type: 'load',
                    item: {
                        ...result,
                        offset: result.offset || nextPage.offset,
                    },
                    isAsync: true,
                    direction: nextPage.direction,
                });
            }
            catch (e) {
                const error = e;
                // Handle error
                console.error(`${error.toString()}\n${error.stack}`);
                dispatch({ type: 'error', error });
            }
        } while (nextPage != null);
        // Unlock
        innerPending.current = false;
    }, [pending, loadMore, handleGetItem]);
    (0,react.useEffect)(() => {
        if (!pending) {
            if (!initialDataFilled.current) {
                const chunk = getInitialData();
                if (chunk != null) {
                    if (chunk.items.length === 0) {
                        dispatch({
                            type: 'end',
                            offset: chunk.offset ?? 0,
                            isAsync: true,
                        });
                    }
                    else {
                        dispatch({ type: 'load', item: chunk });
                    }
                }
                initialDataFilled.current = true;
            }
            else if (!initialRendered.current) {
                initialRendered.current = true;
                handleLoadMore(displayedRef.current[0], displayedRef.current[1]);
            }
        }
    }, [pending, getInitialData, handleLoadMore]);
    const handleRowsRendered = (0,react.useCallback)((startIndex, endIndex) => {
        handleLoadMore(startIndex - loadThreshold, endIndex + loadThreshold);
    }, [loadThreshold, handleLoadMore]);
    const reloadData = (0,react.useCallback)(async () => {
        dispatch({ type: 'reset' });
        await handleLoadMore(0, 1);
    }, [handleLoadMore]);
    const handleClearError = (0,react.useCallback)(() => {
        dispatch({ type: 'clearError' });
        handleLoadMore(displayedRef.current[0], displayedRef.current[1]);
    }, [handleLoadMore]);
    const count = Math.max([state.count + per, state.totalCount, totalCount]
        .reduce((p, v) => (v == null ? p : Math.min(v, p)), Infinity), state.scrolledCount ?? 0);
    const loadedCount = state.count;
    return {
        state,
        count: state.error != null ? loadedCount : count,
        loadedCount,
        getItem: handleGetItem,
        loadMore: handleLoadMore,
        handleRowsRendered,
        error: state.error,
        reloadData,
        clearError: handleClearError,
    };
}
//# sourceMappingURL=usePagedCursorInfiniteList.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/hooks/useExpandableView.js

const useExpandableView = ({ ref, }) => {
    const [isWidthOverflowed, setIsWidthOverflowed] = (0,react.useState)(false);
    const [isHeightOverflowed, setIsHeightOverflowed] = (0,react.useState)(false);
    const handleResize = (0,react.useCallback)(() => {
        if (ref.current != null) {
            const { offsetWidth, scrollWidth, offsetHeight, scrollHeight, } = ref.current;
            setIsWidthOverflowed(offsetWidth < scrollWidth);
            setIsHeightOverflowed(offsetHeight < scrollHeight);
        }
    }, [ref]);
    (0,react.useEffect)(() => {
        handleResize();
        document.addEventListener('resize', handleResize);
        return () => {
            document.removeEventListener('resize', handleResize);
        };
    }, [ref]);
    return {
        isWidthOverflowed,
        isHeightOverflowed,
    };
};
//# sourceMappingURL=useExpandableView.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/hooks/index.js





//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@bucketplace/ui/lib-esm/index.js


//# sourceMappingURL=index.js.map

/***/ }),

/***/ 16675:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
__webpack_unused_export__ = ({value:!0});var e=__webpack_require__(70655),n=__webpack_require__(67294),t=__webpack_require__(5061),i=__webpack_require__(17673),r=__webpack_require__(85893),o=__webpack_require__(73935),a=__webpack_require__(37337);function s(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}function c(e){if(e&&e.__esModule)return e;var n=Object.create(null);return e&&Object.keys(e).forEach((function(t){if("default"!==t){var i=Object.getOwnPropertyDescriptor(e,t);Object.defineProperty(n,t,i.get?i:{enumerable:!0,get:function(){return e[t]}})}})),n.default=e,Object.freeze(n)}var l,d,u,p,m,f,g,v=s(n),h=c(i),x=s(o),b=s(a),_={},y=function(n){var t=n.experimentKey,i=n.visitorId,r=n.platform,o=void 0===r?"web":r,a=n.platformVersion,s=void 0===a?null:a,c=n.isProd;return e.__awaiter(void 0,void 0,void 0,(function(){var n,r,a;return e.__generator(this,(function(l){switch(l.label){case 0:return(n="".concat(i,"::").concat(t,"::").concat(o,"::").concat(s))in _?[4,_[n]]:[3,2];case 1:return[2,{items:l.sent(),cacheHit:!0}];case 2:return r="".concat(c?"https://ab-split.datahou.se/v2":"https://ab-split.stage.datahou.se/v2","/").concat(i,"?experiment_id=").concat(t,"&platform=").concat(o),s&&(r+="&platform_version=".concat(s)),a=function(){return e.__awaiter(void 0,void 0,void 0,(function(){var n,t,i;return e.__generator(this,(function(e){switch(e.label){case 0:return e.trys.push([0,3,,4]),[4,fetch(r,{credentials:"same-origin",headers:{Accept:"application/json","Content-Type":"application/json"}})];case 1:return[4,(n=e.sent()).json()];case 2:return t=e.sent(),n.ok?[2,t]:[2,[]];case 3:return i=e.sent(),console.error(i),[2,[]];case 4:return[2]}}))}))},_[n]=a(),[4,_[n]];case 3:return[2,{items:l.sent(),cacheHit:!1}]}}))}))},w=function(e){switch(e){case"Android":return"aos";case"iOS":return"ios";case"mWebIOS":case"mWebAndroid":return"mweb";default:return"web"}},j=function(n){var i=n.experimentKey,r=n.type,o=void 0===r?"AB":r,a=n.platform,s=void 0===a?"web":a,c=n.platformVersion,l=n.visitorId,d=void 0===l?null:l,u=n.isProd,p=void 0!==u&&u;return e.__awaiter(void 0,void 0,void 0,(function(){var n,r,a,l,u,m,f,g,v,h,x;return e.__generator(this,(function(b){switch(b.label){case 0:if(n=d,null!=d)return[3,4];b.label=1;case 1:return b.trys.push([1,3,,4]),[4,t.waitForInit()];case 2:return b.sent(),n=t.getPageVariable("uuid")||t.getPageVariable("visitor_id"),[3,4];case 3:return b.sent(),[3,4];case 4:return[4,y({experimentKey:i,visitorId:n,platform:s,platformVersion:c,isProd:p})];case 5:return r=b.sent(),a=r.items,l=r.cacheHit,(null==(u=a.find((function(e){return e.type===o})))?void 0:u.experiment_type)&&(m=u.experiment_name,f=u.experiment_type,g=u.type,v=u.version,h=u.visitor_id,x={experimentKey:i,version:v,group:f,visitorId:h,platform:s,platformVersion:c,isProd:p},function(e){try{var n=JSON.parse(localStorage.getItem("bucket_xpc_log"));null==n?n=[e]:n.unshift(e),n.length>100&&(n=n.slice(-100)),localStorage.setItem("bucket_xpc_log",JSON.stringify(n))}catch(e){}}(e.__assign(e.__assign({},x),{experimentName:m,type:g,cacheHit:l,accessTime:Date.now()})),l||function(n){var t=n.experimentKey,i=n.version,r=n.group,o=n.visitorId,a=n.platform,s=void 0===a?"web":a,c=n.platformVersion,l=void 0===c?null:c,d=n.isProd;e.__awaiter(void 0,void 0,void 0,(function(){var n;return e.__generator(this,(function(e){switch(e.label){case 0:n=JSON.stringify({experiment_id:t.toString(),experiment_version:i.toString(),platform:s,platform_version:l,variation_group:r,key:o}),e.label=1;case 1:return e.trys.push([1,3,,4]),[4,fetch(d?"https://ab-log.datahou.se/log":"https://ab-log.stage.datahou.se/log",{method:"POST",headers:{"Content-Type":"application/json"},body:n})];case 2:case 3:return e.sent(),[3,4];case 4:return[2]}}))}))}(x)),[2,null==u?void 0:u.experiment_type]}}))}))},k=[{id:1,label:"실험 타입",value:"type",width:"8%"},{id:2,label:"실험 제목",value:"experimentName",width:"39%"},{id:3,label:"실험 키",value:"experimentKey",width:"10%"},{id:4,label:"결과 그룹",value:"group",width:"8%"},{id:5,label:"시간",value:"accessTime",width:"35%"}],O=function(n){var t=n.logList,i=n.selectedLog,o=n.setSelectedLog,a=i?"".concat(i.type,"::").concat(i.experimentKey,"::").concat(i.accessTime,"::").concat(i.cacheHit):"";return r.jsxs(T,{children:[r.jsx("colgroup",{children:k.map((function(e){var n=e.width,t=e.id;return r.jsx("col",{width:n},t)}))}),r.jsx(S,{children:r.jsx("tr",{children:k.map((function(e){var n=e.label,t=e.id;return r.jsx(L,{children:n},t)}))})}),r.jsx("tbody",{children:t.map((function(n){var t=function(n){return e.__assign(e.__assign({},n),{accessTime:new Date(n.accessTime).toLocaleString()})}(n),i="".concat(n.type,"::").concat(n.experimentKey,"::").concat(n.accessTime,"::").concat(n.cacheHit);return r.jsx(C,e.__assign({onClick:function(){return o(n)},active:a===i},{children:k.map((function(e){var n=e.value,i=e.id;return r.jsx(I,{children:t[n]},i)}))}),i)}))})]})},T=b.default.table(l||(l=e.__makeTemplateObject(["\n  width: 100%;\n  position: relative;\n"],["\n  width: 100%;\n  position: relative;\n"]))),S=b.default.thead(d||(d=e.__makeTemplateObject(["\n  position: sticky;\n  top: 0;\n  background-color: white;\n"],["\n  position: sticky;\n  top: 0;\n  background-color: white;\n"]))),L=b.default.th(u||(u=e.__makeTemplateObject(["\n  padding: 5px;\n"],["\n  padding: 5px;\n"]))),C=b.default.tr(p||(p=e.__makeTemplateObject(["\n  cursor: pointer;\n  background-color: #75bdff;\n  ","\n"],["\n  cursor: pointer;\n  background-color: #75bdff;\n  ","\n"])),(function(e){return!e.active&&"\n    background-color: #e9f4fa;\n    &:nth-of-type(2n) {\n      background-color: #f3f3f3;\n    }\n  "})),I=b.default.td(m||(m=e.__makeTemplateObject(["\n  padding: 5px;\n"],["\n  padding: 5px;\n"]))),P=function(e){var n=e.selectedLog;return r.jsx("div",{children:Object.keys(n).map((function(e){return r.jsxs(v.default.Fragment,{children:[r.jsx(E,{children:e}),r.jsx(A,{children:"".concat(n[e])})]},e)}))})},E=b.default.div(f||(f=e.__makeTemplateObject(["\n  padding: 5px 5px 0;\n  border-bottom: 1px dashed gray;\n  font-weight: bold;\n"],["\n  padding: 5px 5px 0;\n  border-bottom: 1px dashed gray;\n  font-weight: bold;\n"]))),A=b.default.div(g||(g=e.__makeTemplateObject(["\n  padding: 5px;\n  margin-left: 10px;\n"],["\n  padding: 5px;\n  margin-left: 10px;\n"])));var V,K,q,D,z,N,H,J,M=function(){var t=function(e,t){void 0===t&&(t=!1);var i=n.useState(t),r=i[0],o=i[1];return n.useEffect((function(){var n=window.matchMedia(e),t=function(){o(n.matches)};return t(),n.addListener(t),function(){n.removeListener(t)}}),[e]),r}("(max-width: 767px)"),i=function(){var e=n.useState([]),t=e[0],i=e[1],r=n.useCallback((function(e){var n,t=null===(n=e.detail)||void 0===n?void 0:n.value;null!=t&&i(t)}),[]),o=n.useCallback((function(){localStorage.removeItem("bucket_xpc_log"),i([])}),[]);return n.useEffect((function(){var e=JSON.parse(localStorage.getItem("bucket_xpc_log"));return null!=e&&i(e),document.addEventListener("xpcLogDataInserted",r,!1),function(){document.removeEventListener("xpcLogDataInserted",r)}}),[]),{logList:t,deleteLogAll:o}}(),o=i.logList,a=i.deleteLogAll,s=n.useState(),c=s[0],l=s[1],d=function(e,t){var i=n.useRef(null),r=n.useState(!1),o=r[0],a=r[1],s=n.useState(e),c=s[0],l=s[1],d=function(){a(!1)},u=n.useCallback((function(e){var n,r;if(o)if("bottom"!==t){var a=null===(r=null==i?void 0:i.current)||void 0===r?void 0:r.getBoundingClientRect().right;(a||0===a)&&l(a-e.clientX)}else{var s=(null===(n=null==i?void 0:i.current)||void 0===n?void 0:n.getBoundingClientRect().bottom)||0;l(s-e.clientY)}}),[o]);return n.useEffect((function(){return window.addEventListener("mousemove",u),window.addEventListener("mouseup",d),function(){window.removeEventListener("mousemove",u),window.removeEventListener("mouseup",d)}}),[u,d]),[i,function(){a(!0)},c]}(300,"bottom"),u=d[0],p=d[1],m=d[2],f=n.useState(!0),g=f[0],v=f[1];return o?r.jsxs(R,e.__assign({height:m,isOpen:g,ref:u},{children:[!t&&r.jsx(B,{onMouseDown:p}),r.jsxs(F,{children:[r.jsx($,e.__assign({type:"button",onClick:a},{children:"모두 삭제"})),t&&r.jsx(W,e.__assign({onClick:function(){v((function(e){return!e}))}},{children:g?"🔻":"🔺"}))]}),!(t&&!g)&&r.jsxs(X,{children:[r.jsx(Y,{children:r.jsx(O,{logList:o,selectedLog:c,setSelectedLog:l})}),r.jsx(G,{children:c?r.jsx(P,{selectedLog:c}):r.jsx("div",{children:"자세한 정보를 보시려면 왼쪽 리스트에서 로그를 선택해주세요."})})]})]})):r.jsx("div",{children:"loading..."})},R=b.default.div(V||(V=e.__makeTemplateObject(["\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  box-sizing: content-box;\n  width: 100%;\n  background-color: white;\n  z-index: 10000;\n  border-top: 5px solid lightgray;\n  height: ","px;\n  @media(max-width: 767px) {\n    height: "," !important;\n    transition: height .3s ease-in-out;\n  }\n"],["\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  box-sizing: content-box;\n  width: 100%;\n  background-color: white;\n  z-index: 10000;\n  border-top: 5px solid lightgray;\n  height: ","px;\n  @media(max-width: 767px) {\n    height: "," !important;\n    transition: height .3s ease-in-out;\n  }\n"])),(function(e){return e.height}),(function(e){return e.isOpen?"80%":"50px"})),B=b.default.div(K||(K=e.__makeTemplateObject(["\n  position: absolute; \n  top: -4px;\n  right: 0;\n  width: 100%;\n  height: 4px;\n  background: #C2C7CC;\n  cursor: row-resize;\n  &:hover, \n  &:active {\n    background: #35C5F0;\n  }\n  @media (max-width: 767px) {\n    display: none;\n  }\n"],["\n  position: absolute; \n  top: -4px;\n  right: 0;\n  width: 100%;\n  height: 4px;\n  background: #C2C7CC;\n  cursor: row-resize;\n  &:hover, \n  &:active {\n    background: #35C5F0;\n  }\n  @media (max-width: 767px) {\n    display: none;\n  }\n"]))),F=b.default.div(q||(q=e.__makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  height: 30px;\n  border-bottom: 1px solid lightgray;\n  display: flex;\n  align-items: center;\n"],["\n  position: relative;\n  width: 100%;\n  height: 30px;\n  border-bottom: 1px solid lightgray;\n  display: flex;\n  align-items: center;\n"]))),W=b.default.div(D||(D=e.__makeTemplateObject(["\n  position: absolute;\n  width: 100%;\n  text-align: center;\n  cursor: pointer;\n"],["\n  position: absolute;\n  width: 100%;\n  text-align: center;\n  cursor: pointer;\n"]))),X=b.default.div(z||(z=e.__makeTemplateObject(["\n  width: 100%;\n  height: calc(100% - 30px);\n  padding-bottom: 10px;\n  display: flex;\n  @media (max-width: 767px) {\n    flex-direction: column;\n  }\n"],["\n  width: 100%;\n  height: calc(100% - 30px);\n  padding-bottom: 10px;\n  display: flex;\n  @media (max-width: 767px) {\n    flex-direction: column;\n  }\n"]))),Y=b.default.div(N||(N=e.__makeTemplateObject(["\n  flex: 5;\n  overflow-y: scroll;\n"],["\n  flex: 5;\n  overflow-y: scroll;\n"]))),$=b.default.button(H||(H=e.__makeTemplateObject(["\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n"],["\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n"]))),G=b.default.div(J||(J=e.__makeTemplateObject(["\n  flex: 1;\n  min-width: 300px;\n  overflow-y: scroll;\n  padding: 10px;\n  @media (max-width: 767px) {\n    border-top: 2px solid lightgray;\n    flex: 5;\n  }\n"],["\n  flex: 1;\n  min-width: 300px;\n  overflow-y: scroll;\n  padding: 10px;\n  @media (max-width: 767px) {\n    border-top: 2px solid lightgray;\n    flex: 5;\n  }\n"]))),Q=function(){if("true"===h.parse(location.search.slice(1)).bucket_xpc_debug){var e,n=localStorage.setItem;localStorage.setItem=function(e,t){var i=new CustomEvent("xpcLogDataInserted",{detail:{key:"bucket_xpc_log",value:JSON.parse(t)}});"bucket_xpc_log"===e&&document.dispatchEvent(i),n.apply(this,[e,t])},(e=document.createElement("div")).id="xpc-debug-tool",e&&x.default.render(r.jsx(M,{}),e),document.body.appendChild(e)}};__webpack_unused_export__=w,__webpack_unused_export__=j,__webpack_unused_export__=function(){"undefined"!=typeof window&&Q()},exports.XB=function(t){var i=t.isDisabled,r=void 0!==i&&i,o=t.type,a=void 0===o?"AB":o,s=t.onRequestEnd,c=t.isProd,l=t.platform,d=t.platformVersion,u=t.experimentKey,p=t.visitorId,m=n.useState((function(){return{experimentType:void 0,pending:!r,error:void 0}})),f=m[0],g=m[1],v=n.useRef(0);return n.useEffect((function(){var n=function(){var e=h.parse(location.search.slice(1)),n=null,t=null,i=!1;try{i=!!sessionStorage.os_type}catch(e){}if(null!=e.os_type&&""!==e.os_type){n=e.os_type,t=e.version;try{sessionStorage.os_type=e.os_type,sessionStorage.os_version=e.version}catch(e){}}else i?(n=sessionStorage.os_type,t=sessionStorage.os_version):"MacIntel"===navigator.platform&&navigator.maxTouchPoints>1||/iPhone|iPad|iPod/.test(navigator.userAgent)?n="mWebIOS":/Android/.test(navigator.userAgent)&&(n="mWebAndroid");return{osType:n,osVersion:t}}(),t=n.osType,i=n.osVersion,o=null!=l?l:w(t),m=null!=d?d:i,f=++v.current;r?g({experimentType:void 0,pending:!1,error:void 0}):e.__awaiter(void 0,void 0,void 0,(function(){var n,t,i,r;return e.__generator(this,(function(l){switch(l.label){case 0:return l.trys.push([0,2,,3]),g((function(n){return e.__assign(e.__assign({},n),{pending:!0})})),i=null!=c?c:/ohou\.se$/.test(location.host),[4,j({type:a,platform:o,platformVersion:m,isProd:i,experimentKey:u,visitorId:p})];case 1:return n=l.sent(),[3,3];case 2:return r=l.sent(),t=r,[3,3];case 3:return f===v.current&&(g((function(i){return e.__assign(e.__assign({},i),{experimentType:null!=n?n:void 0,pending:!1,error:t})})),null==s||s()),[2]}}))}))}),[r,a,s,c,l,d,u,p]),f};


/***/ }),

/***/ 84683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ emotion_cache_browser_esm; }
});

;// CONCATENATED MODULE: ./node_modules/@emotion/cache/node_modules/@emotion/sheet/dist/emotion-sheet.browser.esm.js
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (false) { var isImportRule; }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (false) {}
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if (false) {}
  };

  return StyleSheet;
}();



;// CONCATENATED MODULE: ./node_modules/stylis/src/Utility.js
/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs

/**
 * @param {number}
 * @return {string}
 */
var Utility_from = String.fromCharCode

/**
 * @param {object}
 * @return {object}
 */
var Utility_assign = Object.assign

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return (((((((length << 2) ^ Utility_charat(value, 0)) << 2) ^ Utility_charat(value, 1)) << 2) ^ Utility_charat(value, 2)) << 2) ^ Utility_charat(value, 3)
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function Utility_charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function Utility_substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function Utility_strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function Utility_sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function Utility_append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function Utility_combine (array, callback) {
	return array.map(callback).join('')
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Tokenizer.js


var line = 1
var column = 1
var Tokenizer_length = 0
var position = 0
var character = 0
var characters = ''

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function copy (root, props) {
	return Utility_assign(node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function Tokenizer_char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? Utility_charat(characters, --position) : 0

	if (column--, character === 10)
		column = 1, line--

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < Tokenizer_length ? Utility_charat(characters, position++) : 0

	if (column++, character === 10)
		column = 1, line++

	return character
}

/**
 * @return {number}
 */
function peek () {
	return Utility_charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return Utility_substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, Tokenizer_length = Utility_strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {string} value
 * @return {string[]}
 */
function Tokenizer_tokenize (value) {
	return dealloc(tokenizer(alloc(value)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next()
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {string[]} children
 * @return {string[]}
 */
function tokenizer (children) {
	while (next())
		switch (token(character)) {
			case 0: append(identifier(position - 1), children)
				break
			case 2: append(delimit(character), children)
				break
			default: append(from(character), children)
		}

	return children
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character)
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type)
				break
			// \
			case 92:
				next()
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + Utility_from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next()

	return slice(index, position)
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Enum.js
var MS = '-ms-'
var MOZ = '-moz-'
var WEBKIT = '-webkit-'

var COMMENT = 'comm'
var Enum_RULESET = 'rule'
var DECLARATION = 'decl'

var PAGE = '@page'
var MEDIA = '@media'
var IMPORT = '@import'
var CHARSET = '@charset'
var VIEWPORT = '@viewport'
var SUPPORTS = '@supports'
var DOCUMENT = '@document'
var NAMESPACE = '@namespace'
var KEYFRAMES = '@keyframes'
var FONT_FACE = '@font-face'
var COUNTER_STYLE = '@counter-style'
var FONT_FEATURE_VALUES = '@font-feature-values'

;// CONCATENATED MODULE: ./node_modules/stylis/src/Serializer.js



/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize (children, callback) {
	var output = ''
	var length = Utility_sizeof(children)

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || ''

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case IMPORT: case DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case KEYFRAMES: return element.return = element.value + '{' + serialize(element.children, callback) + '}'
		case Enum_RULESET: element.value = element.props.join(',')
	}

	return Utility_strlen(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Prefixer.js



/**
 * @param {string} value
 * @param {number} length
 * @return {string}
 */
function prefix (value, length) {
	switch (hash(value, length)) {
		// color-adjust
		case 5103:
			return WEBKIT + 'print-' + value + value
		// animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
		case 5737: case 4201: case 3177: case 3433: case 1641: case 4457: case 2921:
		// text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
		case 5572: case 6356: case 5844: case 3191: case 6645: case 3005:
		// mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
		case 6391: case 5879: case 5623: case 6135: case 4599: case 4855:
		// background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
		case 4215: case 6389: case 5109: case 5365: case 5621: case 3829:
			return WEBKIT + value + value
		// appearance, user-select, transform, hyphens, text-size-adjust
		case 5349: case 4246: case 4810: case 6968: case 2756:
			return WEBKIT + value + MOZ + value + MS + value + value
		// flex, flex-direction
		case 6828: case 4268:
			return WEBKIT + value + MS + value + value
		// order
		case 6165:
			return WEBKIT + value + MS + 'flex-' + value + value
		// align-items
		case 5187:
			return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value
		// align-self
		case 5443:
			return WEBKIT + value + MS + 'flex-item-' + replace(value, /flex-|-self/, '') + value
		// align-content
		case 4675:
			return WEBKIT + value + MS + 'flex-line-pack' + replace(value, /align-content|flex-|-self/, '') + value
		// flex-shrink
		case 5548:
			return WEBKIT + value + MS + replace(value, 'shrink', 'negative') + value
		// flex-basis
		case 5292:
			return WEBKIT + value + MS + replace(value, 'basis', 'preferred-size') + value
		// flex-grow
		case 6060:
			return WEBKIT + 'box-' + replace(value, '-grow', '') + WEBKIT + value + MS + replace(value, 'grow', 'positive') + value
		// transition
		case 4554:
			return WEBKIT + replace(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value
		// cursor
		case 6187:
			return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value
		// background, background-image
		case 5495: case 3959:
			return replace(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1')
		// justify-content
		case 4968:
			return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT + value + value
		// (margin|padding)-inline-(start|end)
		case 4095: case 3583: case 4068: case 2532:
			return replace(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value
		// (min|max)?(width|height|inline-size|block-size)
		case 8116: case 7059: case 5753: case 5535:
		case 5445: case 5701: case 4933: case 4677:
		case 5533: case 5789: case 5021: case 4765:
			// stretch, max-content, min-content, fill-available
			if (Utility_strlen(value) - 1 - length > 6)
				switch (Utility_charat(value, length + 1)) {
					// (m)ax-content, (m)in-content
					case 109:
						// -
						if (Utility_charat(value, length + 4) !== 45)
							break
					// (f)ill-available, (f)it-content
					case 102:
						return replace(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (Utility_charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value
					// (s)tretch
					case 115:
						return ~indexof(value, 'stretch') ? prefix(replace(value, 'stretch', 'fill-available'), length) + value : value
				}
			break
		// position: sticky
		case 4949:
			// (s)ticky?
			if (Utility_charat(value, length + 1) !== 115)
				break
		// display: (flex|inline-flex)
		case 6444:
			switch (Utility_charat(value, Utility_strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
				// stic(k)y
				case 107:
					return replace(value, ':', ':' + WEBKIT) + value
				// (inline-)?fl(e)x
				case 101:
					return replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + WEBKIT + (Utility_charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value
			}
			break
		// writing-mode
		case 5936:
			switch (Utility_charat(value, length + 11)) {
				// vertical-l(r)
				case 114:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value
				// vertical-r(l)
				case 108:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value
				// horizontal(-)tb
				case 45:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value
			}

			return WEBKIT + value + MS + value + value
	}

	return value
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Middleware.js






/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = Utility_sizeof(collection)

	return function (element, index, children, callback) {
		var output = ''

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || ''

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element)
	}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */
function prefixer (element, index, children, callback) {
	if (element.length > -1)
		if (!element.return)
			switch (element.type) {
				case DECLARATION: element.return = prefix(element.value, element.length)
					break
				case KEYFRAMES:
					return serialize([copy(element, {value: replace(element.value, '@', '@' + WEBKIT)})], callback)
				case Enum_RULESET:
					if (element.length)
						return Utility_combine(element.props, function (value) {
							switch (match(value, /(::plac\w+|:read-\w+)/)) {
								// :read-(only|write)
								case ':read-only': case ':read-write':
									return serialize([copy(element, {props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]})], callback)
								// :placeholder
								case '::placeholder':
									return serialize([
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]})
									], callback)
							}

							return ''
						})
			}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 */
function namespace (element) {
	switch (element.type) {
		case RULESET:
			element.props = element.props.map(function (value) {
				return combine(tokenize(value), function (value, index, children) {
					switch (charat(value, 0)) {
						// \f
						case 12:
							return substr(value, 1, strlen(value))
						// \0 ( + > ~
						case 0: case 40: case 43: case 62: case 126:
							return value
						// :
						case 58:
							if (children[++index] === 'global')
								children[index] = '', children[++index] = '\f' + substr(children[index], index = 1, -1)
						// \s
						case 32:
							return index === 1 ? '' : value
						default:
							switch (index) {
								case 0: element = value
									return sizeof(children) > 1 ? '' : value
								case index = sizeof(children) - 1: case 2:
									return index === 2 ? value + element + element : value + element
								default:
									return value
							}
					}
				})
			})
	}
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Parser.js




/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0
	var offset = 0
	var length = pseudo
	var atrule = 0
	var property = 0
	var previous = 0
	var variable = 1
	var scanning = 1
	var ampersand = 1
	var character = 0
	var type = ''
	var props = rules
	var children = rulesets
	var reference = rule
	var characters = type

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && characters.charCodeAt(length - 1) == 58) {
					if (indexof(characters += replace(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character)
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous)
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7)
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						Utility_append(comment(commenter(next(), caret()), root, parent), declarations)
						break
					default:
						characters += '/'
				}
				break
			// {
			case 123 * variable:
				points[index++] = Utility_strlen(characters) * ampersand
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0
					// ;
					case 59 + offset:
						if (property > 0 && (Utility_strlen(characters) - length))
							Utility_append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations)
						break
					// @ ;
					case 59: characters += ';'
					// { rule/at-rule
					default:
						Utility_append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets)

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children)
							else
								switch (atrule) {
									// d m s
									case 100: case 109: case 115:
										parse(value, reference, reference, rule && Utility_append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children)
										break
									default:
										parse(characters, reference, reference, reference, [''], children, 0, points, children)
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo
				break
			// :
			case 58:
				length = 1 + Utility_strlen(characters), property = previous
			default:
				if (variable < 1)
					if (character == 123)
						--variable
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += Utility_from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1)
						break
					// ,
					case 44:
						points[index++] = (Utility_strlen(characters) - 1) * ampersand, ampersand = 1
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next())

						atrule = peek(), offset = length = Utility_strlen(type = characters += identifier(caret())), character++
						break
					// -
					case 45:
						if (previous === 45 && Utility_strlen(characters) == 2)
							variable = 0
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1
	var rule = offset === 0 ? rules : ['']
	var size = Utility_sizeof(rule)

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = Utility_substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : replace(y, /&\f/g, rule[x])))
				props[k++] = z

	return node(value, root, parent, offset === 0 ? Enum_RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node(value, root, parent, COMMENT, Utility_from(Tokenizer_char()), Utility_substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node(value, root, parent, DECLARATION, Utility_substr(value, 0, length), Utility_substr(value, length + 1, -1), length)
}

;// CONCATENATED MODULE: ./node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js





var last = function last(arr) {
  return arr.length ? arr[arr.length - 1] : null;
}; // based on https://github.com/thysultan/stylis.js/blob/e6843c373ebcbbfade25ebcc23f540ed8508da0a/src/Tokenizer.js#L239-L244


var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += Utility_from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return !!element && element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule') return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses && cache.compat !== true) {
      var prevElement = index > 0 ? children[index - 1] : null;

      if (prevElement && isIgnoringComment(last(prevElement.children))) {
        return;
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

var defaultStylisPlugins = [prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (false) {}

  if ( key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if (false) {}

  var inserted = {}; // $FlowFixMe

  var container;
  var nodesToHydrate = [];

  {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (false) {}

  {
    var currentSheet;
    var finalizingPlugins = [stringify,  false ? 0 : rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (false) {}

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

/* harmony default export */ var emotion_cache_browser_esm = (createCache);


/***/ }),

/***/ 62506:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

/* harmony default export */ __webpack_exports__["Z"] = (murmur2);


/***/ }),

/***/ 67866:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (memoize);


/***/ }),

/***/ 65706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ CacheProvider; },
  "E": function() { return /* binding */ Emotion; },
  "T": function() { return /* binding */ ThemeContext; },
  "_": function() { return /* binding */ __unsafe_useEmotionCache; },
  "a": function() { return /* binding */ ThemeProvider; },
  "b": function() { return /* binding */ withTheme; },
  "c": function() { return /* binding */ createEmotionProps; },
  "h": function() { return /* binding */ emotion_element_699e6908_browser_esm_hasOwnProperty; },
  "u": function() { return /* binding */ useTheme; },
  "w": function() { return /* binding */ withEmotionCache; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js + 8 modules
var emotion_cache_browser_esm = __webpack_require__(84683);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
;// CONCATENATED MODULE: ./node_modules/@emotion/weak-memoize/dist/weak-memoize.browser.esm.js
var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

/* harmony default export */ var weak_memoize_browser_esm = (weakMemoize);

// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ./node_modules/@emotion/react/_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js


// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks

var hoistNonReactStatics = (function (targetComponent, sourceComponent) {
  return hoist_non_react_statics_cjs_default()(targetComponent, sourceComponent);
});

/* harmony default export */ var emotion_react_isolated_hnrs_browser_esm = (hoistNonReactStatics);

// EXTERNAL MODULE: ./node_modules/@emotion/react/node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var emotion_utils_browser_esm = __webpack_require__(67728);
// EXTERNAL MODULE: ./node_modules/@emotion/react/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js
var emotion_serialize_browser_esm = __webpack_require__(78202);
;// CONCATENATED MODULE: ./node_modules/@emotion/react/dist/emotion-element-699e6908.browser.esm.js








var emotion_element_699e6908_browser_esm_hasOwnProperty = {}.hasOwnProperty;

var EmotionCacheContext = /* #__PURE__ */(0,react.createContext)( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */(0,emotion_cache_browser_esm/* default */.Z)({
  key: 'css'
}) : null);

if (false) {}

var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
  return (0,react.useContext)(EmotionCacheContext);
};

var withEmotionCache = function withEmotionCache(func) {
  // $FlowFixMe
  return /*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
    // the cache will never be null in the browser
    var cache = (0,react.useContext)(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

var ThemeContext = /* #__PURE__ */(0,react.createContext)({});

if (false) {}

var useTheme = function useTheme() {
  return (0,react.useContext)(ThemeContext);
};

var getTheme = function getTheme(outerTheme, theme) {
  if (typeof theme === 'function') {
    var mergedTheme = theme(outerTheme);

    if (false) {}

    return mergedTheme;
  }

  if (false) {}

  return (0,esm_extends/* default */.Z)({}, outerTheme, theme);
};

var createCacheWithTheme = /* #__PURE__ */weak_memoize_browser_esm(function (outerTheme) {
  return weak_memoize_browser_esm(function (theme) {
    return getTheme(outerTheme, theme);
  });
});
var ThemeProvider = function ThemeProvider(props) {
  var theme = (0,react.useContext)(ThemeContext);

  if (props.theme !== theme) {
    theme = createCacheWithTheme(theme)(props.theme);
  }

  return /*#__PURE__*/(0,react.createElement)(ThemeContext.Provider, {
    value: theme
  }, props.children);
};
function withTheme(Component) {
  var componentName = Component.displayName || Component.name || 'Component';

  var render = function render(props, ref) {
    var theme = (0,react.useContext)(ThemeContext);
    return /*#__PURE__*/(0,react.createElement)(Component, (0,esm_extends/* default */.Z)({
      theme: theme,
      ref: ref
    }, props));
  }; // $FlowFixMe


  var WithTheme = /*#__PURE__*/(0,react.forwardRef)(render);
  WithTheme.displayName = "WithTheme(" + componentName + ")";
  return emotion_react_isolated_hnrs_browser_esm(WithTheme, Component);
}

var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
  // V8
  var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);

  if (match) {
    // The match may be something like 'Object.createEmotionProps'
    var parts = match[1].split('.');
    return parts[parts.length - 1];
  } // Safari / Firefox


  match = /^([A-Za-z0-9$.]+)@/.exec(line);
  if (match) return match[1];
  return undefined;
};

var internalReactFunctionNames = /* #__PURE__ */new Set(['renderWithHooks', 'processChild', 'finishClassComponent', 'renderToString']); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
  if (!stackTrace) return undefined;
  var lines = stackTrace.split('\n');

  for (var i = 0; i < lines.length; i++) {
    var functionName = getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"

    if (!functionName) continue; // If we reach one of these, we have gone too far and should quit

    if (internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
    // uppercase letter

    if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
  }

  return undefined;
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (false) {}

  var newProps = {};

  for (var key in props) {
    if (emotion_element_699e6908_browser_esm_hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
  // the label hasn't already been computed

  if (false) { var label; }

  return newProps;
};

var Noop = function Noop() {
  return null;
};

var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var type = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = (0,emotion_utils_browser_esm/* getRegisteredStyles */.f)(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = (0,emotion_serialize_browser_esm/* serializeStyles */.O)(registeredStyles, undefined, (0,react.useContext)(ThemeContext));

  if (false) { var labelFromStack; }

  var rules = (0,emotion_utils_browser_esm/* insertStyles */.M)(cache, serialized, typeof type === 'string');
  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (emotion_element_699e6908_browser_esm_hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && ( true || 0)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  var ele = /*#__PURE__*/(0,react.createElement)(type, newProps);
  var possiblyStyleElement = /*#__PURE__*/(0,react.createElement)(Noop, null);


  return /*#__PURE__*/(0,react.createElement)(react.Fragment, null, possiblyStyleElement, ele);
});

if (false) {}




/***/ }),

/***/ 75213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CacheProvider": function() { return /* reexport */ emotion_element_699e6908_browser_esm.C; },
  "ClassNames": function() { return /* binding */ ClassNames; },
  "Global": function() { return /* binding */ Global; },
  "ThemeContext": function() { return /* reexport */ emotion_element_699e6908_browser_esm.T; },
  "ThemeProvider": function() { return /* reexport */ emotion_element_699e6908_browser_esm.a; },
  "__unsafe_useEmotionCache": function() { return /* reexport */ emotion_element_699e6908_browser_esm._; },
  "createElement": function() { return /* binding */ jsx; },
  "css": function() { return /* binding */ css; },
  "jsx": function() { return /* binding */ jsx; },
  "keyframes": function() { return /* binding */ keyframes; },
  "useTheme": function() { return /* reexport */ emotion_element_699e6908_browser_esm.u; },
  "withEmotionCache": function() { return /* reexport */ emotion_element_699e6908_browser_esm.w; },
  "withTheme": function() { return /* reexport */ emotion_element_699e6908_browser_esm.b; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js + 8 modules
var emotion_cache_browser_esm = __webpack_require__(84683);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-699e6908.browser.esm.js + 2 modules
var emotion_element_699e6908_browser_esm = __webpack_require__(65706);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
// EXTERNAL MODULE: ./node_modules/@emotion/react/node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var emotion_utils_browser_esm = __webpack_require__(67728);
// EXTERNAL MODULE: ./node_modules/@emotion/react/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js
var emotion_serialize_browser_esm = __webpack_require__(78202);
;// CONCATENATED MODULE: ./node_modules/@emotion/react/node_modules/@emotion/sheet/dist/emotion-sheet.browser.esm.js
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (false) { var isImportRule; }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (false) {}
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if (false) {}
  };

  return StyleSheet;
}();



;// CONCATENATED MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js












var pkg = {
	name: "@emotion/react",
	version: "11.7.1",
	main: "dist/emotion-react.cjs.js",
	module: "dist/emotion-react.esm.js",
	browser: {
		"./dist/emotion-react.cjs.js": "./dist/emotion-react.browser.cjs.js",
		"./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
	},
	types: "types/index.d.ts",
	files: [
		"src",
		"dist",
		"jsx-runtime",
		"jsx-dev-runtime",
		"_isolated-hnrs",
		"types/*.d.ts",
		"macro.js",
		"macro.d.ts",
		"macro.js.flow"
	],
	sideEffects: false,
	author: "mitchellhamilton <mitchell@mitchellhamilton.me>",
	license: "MIT",
	scripts: {
		"test:typescript": "dtslint types"
	},
	dependencies: {
		"@babel/runtime": "^7.13.10",
		"@emotion/cache": "^11.7.1",
		"@emotion/serialize": "^1.0.2",
		"@emotion/sheet": "^1.1.0",
		"@emotion/utils": "^1.0.0",
		"@emotion/weak-memoize": "^0.2.5",
		"hoist-non-react-statics": "^3.3.1"
	},
	peerDependencies: {
		"@babel/core": "^7.0.0",
		react: ">=16.8.0"
	},
	peerDependenciesMeta: {
		"@babel/core": {
			optional: true
		},
		"@types/react": {
			optional: true
		}
	},
	devDependencies: {
		"@babel/core": "^7.13.10",
		"@emotion/css": "11.7.1",
		"@emotion/css-prettifier": "1.0.1",
		"@emotion/server": "11.4.0",
		"@emotion/styled": "11.6.0",
		"@types/react": "^16.9.11",
		dtslint: "^0.3.0",
		"html-tag-names": "^1.1.2",
		react: "16.14.0",
		"svg-tag-names": "^1.1.1"
	},
	repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
	publishConfig: {
		access: "public"
	},
	"umd:main": "dist/emotion-react.umd.min.js",
	preconstruct: {
		entrypoints: [
			"./index.js",
			"./jsx-runtime.js",
			"./jsx-dev-runtime.js",
			"./_isolated-hnrs.js"
		],
		umdName: "emotionReact"
	}
};

var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !emotion_element_699e6908_browser_esm.h.call(props, 'css')) {
    // $FlowFixMe
    return react.createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = emotion_element_699e6908_browser_esm.E;
  createElementArgArray[1] = (0,emotion_element_699e6908_browser_esm.c)(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return react.createElement.apply(null, createElementArgArray);
};

var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag

var Global = /* #__PURE__ */(0,emotion_element_699e6908_browser_esm.w)(function (props, cache) {
  if (false) {}

  var styles = props.styles;
  var serialized = (0,emotion_serialize_browser_esm/* serializeStyles */.O)([styles], undefined, (0,react.useContext)(emotion_element_699e6908_browser_esm.T));
  // but it is based on a constant that will never change at runtime
  // it's effectively like having two implementations and switching them out
  // so it's not actually breaking anything


  var sheetRef = (0,react.useRef)();
  (0,react.useLayoutEffect)(function () {
    var key = cache.key + "-global";
    var sheet = new StyleSheet({
      key: key,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false; // $FlowFixMe

    var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");

    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }

    if (node !== null) {
      rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

      node.setAttribute('data-emotion', key);
      sheet.hydrate([node]);
    }

    sheetRef.current = [sheet, rehydrating];
    return function () {
      sheet.flush();
    };
  }, [cache]);
  (0,react.useLayoutEffect)(function () {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0],
        rehydrating = sheetRefCurrent[1];

    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }

    if (serialized.next !== undefined) {
      // insert keyframes
      (0,emotion_utils_browser_esm/* insertStyles */.M)(cache, serialized.next, true);
    }

    if (sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }

    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
});

if (false) {}

function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return (0,emotion_serialize_browser_esm/* serializeStyles */.O)(args);
}

var keyframes = function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            if (false) {}

            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = (0,emotion_utils_browser_esm/* getRegisteredStyles */.f)(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var Noop = function Noop() {
  return null;
};

var ClassNames = /* #__PURE__ */(0,emotion_element_699e6908_browser_esm.w)(function (props, cache) {
  var hasRendered = false;

  var css = function css() {
    if (hasRendered && "production" !== 'production') {}

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = (0,emotion_serialize_browser_esm/* serializeStyles */.O)(args, cache.registered);

    {
      (0,emotion_utils_browser_esm/* insertStyles */.M)(cache, serialized, false);
    }

    return cache.key + "-" + serialized.name;
  };

  var cx = function cx() {
    if (hasRendered && "production" !== 'production') {}

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return merge(cache.registered, css, classnames(args));
  };

  var content = {
    css: css,
    cx: cx,
    theme: (0,react.useContext)(emotion_element_699e6908_browser_esm.T)
  };
  var ele = props.children(content);
  hasRendered = true;
  var possiblyStyleElement = /*#__PURE__*/(0,react.createElement)(Noop, null);


  return /*#__PURE__*/(0,react.createElement)(react.Fragment, null, possiblyStyleElement, ele);
});

if (false) {}

if (false) { var globalKey, globalContext, isJest, isBrowser; }




/***/ }),

/***/ 35944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BX": function() { return /* binding */ jsxs; },
/* harmony export */   "HY": function() { return /* binding */ Fragment; },
/* harmony export */   "tZ": function() { return /* binding */ jsx; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_cache__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84683);
/* harmony import */ var _dist_emotion_element_699e6908_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65706);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8679);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _emotion_serialize__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78202);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);











var Fragment = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment;
function jsx(type, props, key) {
  if (!_dist_emotion_element_699e6908_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.h.call(props, 'css')) {
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(type, props, key);
  }

  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_dist_emotion_element_699e6908_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.E, (0,_dist_emotion_element_699e6908_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.c)(type, props), key);
}
function jsxs(type, props, key) {
  if (!_dist_emotion_element_699e6908_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.h.call(props, 'css')) {
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(type, props, key);
  }

  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_dist_emotion_element_699e6908_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.E, (0,_dist_emotion_element_699e6908_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.c)(type, props), key);
}




/***/ }),

/***/ 78202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ serializeStyles; }
/* harmony export */ });
/* harmony import */ var _emotion_hash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62506);
/* harmony import */ var _emotion_unitless__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40351);
/* harmony import */ var _emotion_memoize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67866);




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */(0,_emotion_memoize__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (_emotion_unitless__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) { var hyphenatedCache, hyphenPattern, msPattern, oldProcessStyleValue, contentValues, contentValuePattern; }

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {}

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {}

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (false) {}

        break;
      }

    case 'string':
      if (false) { var replaced, matched; }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {}

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {}

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (false) {} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (false) {}

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (false) {}

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {} // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = (0,_emotion_hash__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(styles) + identifierName;

  if (false) {}

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};




/***/ }),

/***/ 67728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ insertStyles; },
/* harmony export */   "f": function() { return /* binding */ getRegisteredStyles; }
/* harmony export */ });
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false ) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};




/***/ }),

/***/ 7329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ emotion_styled_base_browser_esm; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/memoize/dist/emotion-memoize.browser.esm.js
var emotion_memoize_browser_esm = __webpack_require__(67866);
;// CONCATENATED MODULE: ./node_modules/@emotion/styled/node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.browser.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */(0,emotion_memoize_browser_esm/* default */.Z)(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/* harmony default export */ var emotion_is_prop_valid_browser_esm = (isPropValid);

// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-699e6908.browser.esm.js + 2 modules
var emotion_element_699e6908_browser_esm = __webpack_require__(65706);
;// CONCATENATED MODULE: ./node_modules/@emotion/styled/node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false ) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};



// EXTERNAL MODULE: ./node_modules/@emotion/styled/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js
var emotion_serialize_browser_esm = __webpack_require__(68827);
;// CONCATENATED MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js







var testOmitPropsOnStringTag = emotion_is_prop_valid_browser_esm;

var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
  return key !== 'theme';
};

var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
  return typeof tag === 'string' && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
  var shouldForwardProp;

  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function (propName) {
      return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }

  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }

  return shouldForwardProp;
};

var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";

var Noop = function Noop() {
  return null;
};

var createStyled = function createStyled(tag, options) {
  if (false) {}

  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  var identifierName;
  var targetClassName;

  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
  }

  var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  return function () {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }

    if (args[0] == null || args[0].raw === undefined) {
      styles.push.apply(styles, args);
    } else {
      if (false) {}

      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;

      for (; i < len; i++) {
        if (false) {}

        styles.push(args[i], args[0][i]);
      }
    } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class


    var Styled = (0,emotion_element_699e6908_browser_esm.w)(function (props, cache, ref) {
      var finalTag = shouldUseAs && props.as || baseTag;
      var className = '';
      var classInterpolations = [];
      var mergedProps = props;

      if (props.theme == null) {
        mergedProps = {};

        for (var key in props) {
          mergedProps[key] = props[key];
        }

        mergedProps.theme = (0,react.useContext)(emotion_element_699e6908_browser_esm.T);
      }

      if (typeof props.className === 'string') {
        className = getRegisteredStyles(cache.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }

      var serialized = (0,emotion_serialize_browser_esm/* serializeStyles */.O)(styles.concat(classInterpolations), cache.registered, mergedProps);
      var rules = insertStyles(cache, serialized, typeof finalTag === 'string');
      className += cache.key + "-" + serialized.name;

      if (targetClassName !== undefined) {
        className += " " + targetClassName;
      }

      var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(finalTag) : defaultShouldForwardProp;
      var newProps = {};

      for (var _key in props) {
        if (shouldUseAs && _key === 'as') continue;

        if ( // $FlowFixMe
        finalShouldForwardProp(_key)) {
          newProps[_key] = props[_key];
        }
      }

      newProps.className = className;
      newProps.ref = ref;
      var ele = /*#__PURE__*/(0,react.createElement)(finalTag, newProps);
      var possiblyStyleElement = /*#__PURE__*/(0,react.createElement)(Noop, null);


      return /*#__PURE__*/(0,react.createElement)(react.Fragment, null, possiblyStyleElement, ele);
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && "production" !== 'production') {} // $FlowFixMe: coerce undefined to string


        return "." + targetClassName;
      }
    });

    Styled.withComponent = function (nextTag, nextOptions) {
      return createStyled(nextTag, (0,esm_extends/* default */.Z)({}, options, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      })).apply(void 0, styles);
    };

    return Styled;
  };
};

/* harmony default export */ var emotion_styled_base_browser_esm = (createStyled);


/***/ }),

/***/ 37337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _base_dist_emotion_styled_base_browser_esm_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7329);
/* harmony import */ var _emotion_serialize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68827);








var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

var newStyled = _base_dist_emotion_styled_base_browser_esm_js__WEBPACK_IMPORTED_MODULE_1__["default"].bind();
tags.forEach(function (tagName) {
  // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
  newStyled[tagName] = newStyled(tagName);
});

/* harmony default export */ __webpack_exports__["default"] = (newStyled);


/***/ }),

/***/ 68827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ serializeStyles; }
/* harmony export */ });
/* harmony import */ var _emotion_hash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62506);
/* harmony import */ var _emotion_unitless__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40351);
/* harmony import */ var _emotion_memoize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67866);




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */(0,_emotion_memoize__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (_emotion_unitless__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) { var hyphenatedCache, hyphenPattern, msPattern, oldProcessStyleValue, contentValues, contentValuePattern; }

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {}

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {}

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (false) {}

        break;
      }

    case 'string':
      if (false) { var replaced, matched; }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {}

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {}

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (false) {} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (false) {}

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (false) {}

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {} // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = (0,_emotion_hash__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(styles) + identifierName;

  if (false) {}

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};




/***/ }),

/***/ 40351:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["Z"] = (unitlessKeys);


/***/ }),

/***/ 9773:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
function autobind(_target, name, descriptor) {
    var enumerable = descriptor.enumerable, configurable = descriptor.configurable, value = descriptor.value;
    var boundMethod = Symbol("boundMethod." + name);
    return {
        enumerable: enumerable,
        configurable: configurable,
        get: function () {
            return this[boundMethod] || (this[boundMethod] = value.bind(this));
        },
        set: function (value) {
            Object.defineProperty(this, name, {
                writable: true,
                enumerable: true,
                configurable: true,
                value: value,
            });
        },
    };
}
exports.N = autobind;
//# sourceMappingURL=autobind.js.map

/***/ }),

/***/ 63367:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (factory) {
   true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) :
  0;
}((function () { 'use strict';

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _superPropBase(object, property) {
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
      object = _getPrototypeOf(object);
      if (object === null) break;
    }

    return object;
  }

  function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
      _get = Reflect.get;
    } else {
      _get = function _get(target, property, receiver) {
        var base = _superPropBase(target, property);

        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);

        if (desc.get) {
          return desc.get.call(receiver);
        }

        return desc.value;
      };
    }

    return _get(target, property, receiver || target);
  }

  var Emitter = /*#__PURE__*/function () {
    function Emitter() {
      _classCallCheck(this, Emitter);

      Object.defineProperty(this, 'listeners', {
        value: {},
        writable: true,
        configurable: true
      });
    }

    _createClass(Emitter, [{
      key: "addEventListener",
      value: function addEventListener(type, callback, options) {
        if (!(type in this.listeners)) {
          this.listeners[type] = [];
        }

        this.listeners[type].push({
          callback: callback,
          options: options
        });
      }
    }, {
      key: "removeEventListener",
      value: function removeEventListener(type, callback) {
        if (!(type in this.listeners)) {
          return;
        }

        var stack = this.listeners[type];

        for (var i = 0, l = stack.length; i < l; i++) {
          if (stack[i].callback === callback) {
            stack.splice(i, 1);
            return;
          }
        }
      }
    }, {
      key: "dispatchEvent",
      value: function dispatchEvent(event) {
        if (!(event.type in this.listeners)) {
          return;
        }

        var stack = this.listeners[event.type];
        var stackToCall = stack.slice();

        for (var i = 0, l = stackToCall.length; i < l; i++) {
          var listener = stackToCall[i];

          try {
            listener.callback.call(this, event);
          } catch (e) {
            Promise.resolve().then(function () {
              throw e;
            });
          }

          if (listener.options && listener.options.once) {
            this.removeEventListener(event.type, listener.callback);
          }
        }

        return !event.defaultPrevented;
      }
    }]);

    return Emitter;
  }();

  var AbortSignal = /*#__PURE__*/function (_Emitter) {
    _inherits(AbortSignal, _Emitter);

    var _super = _createSuper(AbortSignal);

    function AbortSignal() {
      var _this;

      _classCallCheck(this, AbortSignal);

      _this = _super.call(this); // Some versions of babel does not transpile super() correctly for IE <= 10, if the parent
      // constructor has failed to run, then "this.listeners" will still be undefined and then we call
      // the parent constructor directly instead as a workaround. For general details, see babel bug:
      // https://github.com/babel/babel/issues/3041
      // This hack was added as a fix for the issue described here:
      // https://github.com/Financial-Times/polyfill-library/pull/59#issuecomment-477558042

      if (!_this.listeners) {
        Emitter.call(_assertThisInitialized(_this));
      } // Compared to assignment, Object.defineProperty makes properties non-enumerable by default and
      // we want Object.keys(new AbortController().signal) to be [] for compat with the native impl


      Object.defineProperty(_assertThisInitialized(_this), 'aborted', {
        value: false,
        writable: true,
        configurable: true
      });
      Object.defineProperty(_assertThisInitialized(_this), 'onabort', {
        value: null,
        writable: true,
        configurable: true
      });
      return _this;
    }

    _createClass(AbortSignal, [{
      key: "toString",
      value: function toString() {
        return '[object AbortSignal]';
      }
    }, {
      key: "dispatchEvent",
      value: function dispatchEvent(event) {
        if (event.type === 'abort') {
          this.aborted = true;

          if (typeof this.onabort === 'function') {
            this.onabort.call(this, event);
          }
        }

        _get(_getPrototypeOf(AbortSignal.prototype), "dispatchEvent", this).call(this, event);
      }
    }]);

    return AbortSignal;
  }(Emitter);
  var AbortController = /*#__PURE__*/function () {
    function AbortController() {
      _classCallCheck(this, AbortController);

      // Compared to assignment, Object.defineProperty makes properties non-enumerable by default and
      // we want Object.keys(new AbortController()) to be [] for compat with the native impl
      Object.defineProperty(this, 'signal', {
        value: new AbortSignal(),
        writable: true,
        configurable: true
      });
    }

    _createClass(AbortController, [{
      key: "abort",
      value: function abort() {
        var event;

        try {
          event = new Event('abort');
        } catch (e) {
          if (typeof document !== 'undefined') {
            if (!document.createEvent) {
              // For Internet Explorer 8:
              event = document.createEventObject();
              event.type = 'abort';
            } else {
              // For Internet Explorer 11:
              event = document.createEvent('Event');
              event.initEvent('abort', false, false);
            }
          } else {
            // Fallback where document isn't available:
            event = {
              type: 'abort',
              bubbles: false,
              cancelable: false
            };
          }
        }

        this.signal.dispatchEvent(event);
      }
    }, {
      key: "toString",
      value: function toString() {
        return '[object AbortController]';
      }
    }]);

    return AbortController;
  }();

  if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
    // These are necessary to make sure that we get correct output for:
    // Object.prototype.toString.call(new AbortController())
    AbortController.prototype[Symbol.toStringTag] = 'AbortController';
    AbortSignal.prototype[Symbol.toStringTag] = 'AbortSignal';
  }

  function polyfillNeeded(self) {
    if (self.__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL) {
      console.log('__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL=true is set, will force install polyfill');
      return true;
    } // Note that the "unfetch" minimal fetch polyfill defines fetch() without
    // defining window.Request, and this polyfill need to work on top of unfetch
    // so the below feature detection needs the !self.AbortController part.
    // The Request.prototype check is also needed because Safari versions 11.1.2
    // up to and including 12.1.x has a window.AbortController present but still
    // does NOT correctly implement abortable fetch:
    // https://bugs.webkit.org/show_bug.cgi?id=174980#c2


    return typeof self.Request === 'function' && !self.Request.prototype.hasOwnProperty('signal') || !self.AbortController;
  }

  /**
   * Note: the "fetch.Request" default value is available for fetch imported from
   * the "node-fetch" package and not in browsers. This is OK since browsers
   * will be importing umd-polyfill.js from that path "self" is passed the
   * decorator so the default value will not be used (because browsers that define
   * fetch also has Request). One quirky setup where self.fetch exists but
   * self.Request does not is when the "unfetch" minimal fetch polyfill is used
   * on top of IE11; for this case the browser will try to use the fetch.Request
   * default value which in turn will be undefined but then then "if (Request)"
   * will ensure that you get a patched fetch but still no Request (as expected).
   * @param {fetch, Request = fetch.Request}
   * @returns {fetch: abortableFetch, Request: AbortableRequest}
   */

  function abortableFetchDecorator(patchTargets) {
    if ('function' === typeof patchTargets) {
      patchTargets = {
        fetch: patchTargets
      };
    }

    var _patchTargets = patchTargets,
        fetch = _patchTargets.fetch,
        _patchTargets$Request = _patchTargets.Request,
        NativeRequest = _patchTargets$Request === void 0 ? fetch.Request : _patchTargets$Request,
        NativeAbortController = _patchTargets.AbortController,
        _patchTargets$__FORCE = _patchTargets.__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL,
        __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL = _patchTargets$__FORCE === void 0 ? false : _patchTargets$__FORCE;

    if (!polyfillNeeded({
      fetch: fetch,
      Request: NativeRequest,
      AbortController: NativeAbortController,
      __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL: __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL
    })) {
      return {
        fetch: fetch,
        Request: Request
      };
    }

    var Request = NativeRequest; // Note that the "unfetch" minimal fetch polyfill defines fetch() without
    // defining window.Request, and this polyfill need to work on top of unfetch
    // hence we only patch it if it's available. Also we don't patch it if signal
    // is already available on the Request prototype because in this case support
    // is present and the patching below can cause a crash since it assigns to
    // request.signal which is technically a read-only property. This latter error
    // happens when you run the main5.js node-fetch example in the repo
    // "abortcontroller-polyfill-examples". The exact error is:
    //   request.signal = init.signal;
    //   ^
    // TypeError: Cannot set property signal of #<Request> which has only a getter

    if (Request && !Request.prototype.hasOwnProperty('signal') || __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL) {
      Request = function Request(input, init) {
        var signal;

        if (init && init.signal) {
          signal = init.signal; // Never pass init.signal to the native Request implementation when the polyfill has
          // been installed because if we're running on top of a browser with a
          // working native AbortController (i.e. the polyfill was installed due to
          // __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL being set), then passing our
          // fake AbortSignal to the native fetch will trigger:
          // TypeError: Failed to construct 'Request': member signal is not of type AbortSignal.

          delete init.signal;
        }

        var request = new NativeRequest(input, init);

        if (signal) {
          Object.defineProperty(request, 'signal', {
            writable: false,
            enumerable: false,
            configurable: true,
            value: signal
          });
        }

        return request;
      };

      Request.prototype = NativeRequest.prototype;
    }

    var realFetch = fetch;

    var abortableFetch = function abortableFetch(input, init) {
      var signal = Request && Request.prototype.isPrototypeOf(input) ? input.signal : init ? init.signal : undefined;

      if (signal) {
        var abortError;

        try {
          abortError = new DOMException('Aborted', 'AbortError');
        } catch (err) {
          // IE 11 does not support calling the DOMException constructor, use a
          // regular error object on it instead.
          abortError = new Error('Aborted');
          abortError.name = 'AbortError';
        } // Return early if already aborted, thus avoiding making an HTTP request


        if (signal.aborted) {
          return Promise.reject(abortError);
        } // Turn an event into a promise, reject it once `abort` is dispatched


        var cancellation = new Promise(function (_, reject) {
          signal.addEventListener('abort', function () {
            return reject(abortError);
          }, {
            once: true
          });
        });

        if (init && init.signal) {
          // Never pass .signal to the native implementation when the polyfill has
          // been installed because if we're running on top of a browser with a
          // working native AbortController (i.e. the polyfill was installed due to
          // __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL being set), then passing our
          // fake AbortSignal to the native fetch will trigger:
          // TypeError: Failed to execute 'fetch' on 'Window': member signal is not of type AbortSignal.
          delete init.signal;
        } // Return the fastest promise (don't need to wait for request to finish)


        return Promise.race([cancellation, realFetch(input, init)]);
      }

      return realFetch(input, init);
    };

    return {
      fetch: abortableFetch,
      Request: Request
    };
  }

  (function (self) {

    if (!polyfillNeeded(self)) {
      return;
    }

    if (!self.fetch) {
      console.warn('fetch() is not available, cannot install abortcontroller-polyfill');
      return;
    }

    var _abortableFetch = abortableFetchDecorator(self),
        fetch = _abortableFetch.fetch,
        Request = _abortableFetch.Request;

    self.fetch = fetch;
    self.Request = Request;
    Object.defineProperty(self, 'AbortController', {
      writable: true,
      enumerable: false,
      configurable: true,
      value: AbortController
    });
    Object.defineProperty(self, 'AbortSignal', {
      writable: true,
      enumerable: false,
      configurable: true,
      value: AbortSignal
    });
  })(typeof self !== 'undefined' ? self : __webpack_require__.g);

})));


/***/ }),

/***/ 9669:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(51609);

/***/ }),

/***/ 55448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var settle = __webpack_require__(36026);
var cookies = __webpack_require__(4372);
var buildURL = __webpack_require__(15327);
var buildFullPath = __webpack_require__(94097);
var parseHeaders = __webpack_require__(84109);
var isURLSameOrigin = __webpack_require__(67985);
var createError = __webpack_require__(85061);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 51609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var bind = __webpack_require__(91849);
var Axios = __webpack_require__(30321);
var mergeConfig = __webpack_require__(47185);
var defaults = __webpack_require__(45655);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(65263);
axios.CancelToken = __webpack_require__(14972);
axios.isCancel = __webpack_require__(26502);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(8713);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(16268);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ 65263:
/***/ (function(module) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ 14972:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(65263);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 26502:
/***/ (function(module) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 30321:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var buildURL = __webpack_require__(15327);
var InterceptorManager = __webpack_require__(80782);
var dispatchRequest = __webpack_require__(13572);
var mergeConfig = __webpack_require__(47185);
var validator = __webpack_require__(54875);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ 80782:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 94097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(91793);
var combineURLs = __webpack_require__(7303);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ 85061:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(80481);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ 13572:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var transformData = __webpack_require__(18527);
var isCancel = __webpack_require__(26502);
var defaults = __webpack_require__(45655);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 80481:
/***/ (function(module) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),

/***/ 47185:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, mergeDeepProperties);

  return config;
};


/***/ }),

/***/ 36026:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(85061);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ 18527:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var defaults = __webpack_require__(45655);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),

/***/ 45655:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(34155);


var utils = __webpack_require__(64867);
var normalizeHeaderName = __webpack_require__(16016);
var enhanceError = __webpack_require__(80481);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(55448);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(55448);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ 91849:
/***/ (function(module) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ 15327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ 7303:
/***/ (function(module) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ 4372:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ 91793:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 16268:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};


/***/ }),

/***/ 67985:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ 16016:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 84109:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ 8713:
/***/ (function(module) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 54875:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var pkg = __webpack_require__(88593);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};
var currentVerArr = pkg.version.split('.');

/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */
function isOlderVersion(version, thanVersion) {
  var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
  var destVer = version.split('.');
  for (var i = 0; i < 3; i++) {
    if (pkgVersionArr[i] > destVer[i]) {
      return true;
    } else if (pkgVersionArr[i] < destVer[i]) {
      return false;
    }
  }
  return false;
}

/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  var isDeprecated = version && isOlderVersion(version);

  function formatMessage(opt, desc) {
    return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed in ' + version));
    }

    if (isDeprecated && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

module.exports = {
  isOlderVersion: isOlderVersion,
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ 64867:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(91849);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};


/***/ }),

/***/ 94184:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 98544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ addClass; }
});

;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/hasClass.js
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/addClass.js

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}

/***/ }),

/***/ 74277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ removeClass; }
/* harmony export */ });
function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}

/***/ }),

/***/ 2401:
/***/ (function(module) {

function backInOut(t) {
  var s = 1.70158 * 1.525
  if ((t *= 2) < 1)
    return 0.5 * (t * t * ((s + 1) * t - s))
  return 0.5 * ((t -= 2) * t * ((s + 1) * t + s) + 2)
}

module.exports = backInOut

/***/ }),

/***/ 84990:
/***/ (function(module) {

function backIn(t) {
  var s = 1.70158
  return t * t * ((s + 1) * t - s)
}

module.exports = backIn

/***/ }),

/***/ 61966:
/***/ (function(module) {

function backOut(t) {
  var s = 1.70158
  return --t * t * ((s + 1) * t + s) + 1
}

module.exports = backOut

/***/ }),

/***/ 1859:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var bounceOut = __webpack_require__(97034)

function bounceInOut(t) {
  return t < 0.5
    ? 0.5 * (1.0 - bounceOut(1.0 - t * 2.0))
    : 0.5 * bounceOut(t * 2.0 - 1.0) + 0.5
}

module.exports = bounceInOut

/***/ }),

/***/ 12902:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var bounceOut = __webpack_require__(97034)

function bounceIn(t) {
  return 1.0 - bounceOut(1.0 - t)
}

module.exports = bounceIn

/***/ }),

/***/ 97034:
/***/ (function(module) {

function bounceOut(t) {
  var a = 4.0 / 11.0
  var b = 8.0 / 11.0
  var c = 9.0 / 10.0

  var ca = 4356.0 / 361.0
  var cb = 35442.0 / 1805.0
  var cc = 16061.0 / 1805.0

  var t2 = t * t

  return t < a
    ? 7.5625 * t2
    : t < b
      ? 9.075 * t2 - 9.9 * t + 3.4
      : t < c
        ? ca * t2 - cb * t + cc
        : 10.8 * t * t - 20.52 * t + 10.72
}

module.exports = bounceOut

/***/ }),

/***/ 56649:
/***/ (function(module) {

function circInOut(t) {
  if ((t *= 2) < 1) return -0.5 * (Math.sqrt(1 - t * t) - 1)
  return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1)
}

module.exports = circInOut

/***/ }),

/***/ 77066:
/***/ (function(module) {

function circIn(t) {
  return 1.0 - Math.sqrt(1.0 - t * t)
}

module.exports = circIn

/***/ }),

/***/ 85754:
/***/ (function(module) {

function circOut(t) {
  return Math.sqrt(1 - ( --t * t ))
}

module.exports = circOut

/***/ }),

/***/ 95383:
/***/ (function(module) {

function cubicInOut(t) {
  return t < 0.5
    ? 4.0 * t * t * t
    : 0.5 * Math.pow(2.0 * t - 2.0, 3.0) + 1.0
}

module.exports = cubicInOut

/***/ }),

/***/ 24549:
/***/ (function(module) {

function cubicIn(t) {
  return t * t * t
}

module.exports = cubicIn

/***/ }),

/***/ 2038:
/***/ (function(module) {

function cubicOut(t) {
  var f = t - 1.0
  return f * f * f + 1.0
}

module.exports = cubicOut

/***/ }),

/***/ 83684:
/***/ (function(module) {

function elasticInOut(t) {
  return t < 0.5
    ? 0.5 * Math.sin(+13.0 * Math.PI/2 * 2.0 * t) * Math.pow(2.0, 10.0 * (2.0 * t - 1.0))
    : 0.5 * Math.sin(-13.0 * Math.PI/2 * ((2.0 * t - 1.0) + 1.0)) * Math.pow(2.0, -10.0 * (2.0 * t - 1.0)) + 1.0
}

module.exports = elasticInOut

/***/ }),

/***/ 61767:
/***/ (function(module) {

function elasticIn(t) {
  return Math.sin(13.0 * t * Math.PI/2) * Math.pow(2.0, 10.0 * (t - 1.0))
}

module.exports = elasticIn

/***/ }),

/***/ 79562:
/***/ (function(module) {

function elasticOut(t) {
  return Math.sin(-13.0 * (t + 1.0) * Math.PI/2) * Math.pow(2.0, -10.0 * t) + 1.0
}

module.exports = elasticOut

/***/ }),

/***/ 82102:
/***/ (function(module) {

function expoInOut(t) {
  return (t === 0.0 || t === 1.0)
    ? t
    : t < 0.5
      ? +0.5 * Math.pow(2.0, (20.0 * t) - 10.0)
      : -0.5 * Math.pow(2.0, 10.0 - (t * 20.0)) + 1.0
}

module.exports = expoInOut

/***/ }),

/***/ 23618:
/***/ (function(module) {

function expoIn(t) {
  return t === 0.0 ? t : Math.pow(2.0, 10.0 * (t - 1.0))
}

module.exports = expoIn

/***/ }),

/***/ 23745:
/***/ (function(module) {

function expoOut(t) {
  return t === 1.0 ? t : 1.0 - Math.pow(2.0, -10.0 * t)
}

module.exports = expoOut

/***/ }),

/***/ 14967:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = {
	'backInOut': __webpack_require__(2401),
	'backIn': __webpack_require__(84990),
	'backOut': __webpack_require__(61966),
	'bounceInOut': __webpack_require__(1859),
	'bounceIn': __webpack_require__(12902),
	'bounceOut': __webpack_require__(97034),
	'circInOut': __webpack_require__(56649),
	'circIn': __webpack_require__(77066),
	'circOut': __webpack_require__(85754),
	'cubicInOut': __webpack_require__(95383),
	'cubicIn': __webpack_require__(24549),
	'cubicOut': __webpack_require__(2038),
	'elasticInOut': __webpack_require__(83684),
	'elasticIn': __webpack_require__(61767),
	'elasticOut': __webpack_require__(79562),
	'expoInOut': __webpack_require__(82102),
	'expoIn': __webpack_require__(23618),
	'expoOut': __webpack_require__(23745),
	'linear': __webpack_require__(70890),
	'quadInOut': __webpack_require__(80908),
	'quadIn': __webpack_require__(36992),
	'quadOut': __webpack_require__(72057),
	'quartInOut': __webpack_require__(75623),
	'quartIn': __webpack_require__(76956),
	'quartOut': __webpack_require__(67315),
	'quintInOut': __webpack_require__(93565),
	'quintIn': __webpack_require__(93433),
	'quintOut': __webpack_require__(26664),
	'sineInOut': __webpack_require__(7104),
	'sineIn': __webpack_require__(64214),
	'sineOut': __webpack_require__(6817)
}

/***/ }),

/***/ 70890:
/***/ (function(module) {

function linear(t) {
  return t
}

module.exports = linear

/***/ }),

/***/ 80908:
/***/ (function(module) {

function quadInOut(t) {
    t /= 0.5
    if (t < 1) return 0.5*t*t
    t--
    return -0.5 * (t*(t-2) - 1)
}

module.exports = quadInOut

/***/ }),

/***/ 36992:
/***/ (function(module) {

function quadIn(t) {
  return t * t
}

module.exports = quadIn

/***/ }),

/***/ 72057:
/***/ (function(module) {

function quadOut(t) {
  return -t * (t - 2.0)
}

module.exports = quadOut

/***/ }),

/***/ 75623:
/***/ (function(module) {

function quarticInOut(t) {
  return t < 0.5
    ? +8.0 * Math.pow(t, 4.0)
    : -8.0 * Math.pow(t - 1.0, 4.0) + 1.0
}

module.exports = quarticInOut

/***/ }),

/***/ 76956:
/***/ (function(module) {

function quarticIn(t) {
  return Math.pow(t, 4.0)
}

module.exports = quarticIn

/***/ }),

/***/ 67315:
/***/ (function(module) {

function quarticOut(t) {
  return Math.pow(t - 1.0, 3.0) * (1.0 - t) + 1.0
}

module.exports = quarticOut

/***/ }),

/***/ 93565:
/***/ (function(module) {

function qinticInOut(t) {
    if ( ( t *= 2 ) < 1 ) return 0.5 * t * t * t * t * t
    return 0.5 * ( ( t -= 2 ) * t * t * t * t + 2 )
}

module.exports = qinticInOut

/***/ }),

/***/ 93433:
/***/ (function(module) {

function qinticIn(t) {
  return t * t * t * t * t
}

module.exports = qinticIn

/***/ }),

/***/ 26664:
/***/ (function(module) {

function qinticOut(t) {
  return --t * t * t * t * t + 1
}

module.exports = qinticOut

/***/ }),

/***/ 7104:
/***/ (function(module) {

function sineInOut(t) {
  return -0.5 * (Math.cos(Math.PI*t) - 1)
}

module.exports = sineInOut

/***/ }),

/***/ 64214:
/***/ (function(module) {

function sineIn (t) {
  var v = Math.cos(t * Math.PI * 0.5)
  if (Math.abs(v) < 1e-14) return 1
  else return 1 - v
}

module.exports = sineIn


/***/ }),

/***/ 6817:
/***/ (function(module) {

function sineOut(t) {
  return Math.sin(t * Math.PI/2)
}

module.exports = sineOut

/***/ }),

/***/ 54483:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var React = __webpack_require__(67294);

var ReactDOM = __webpack_require__(73935);

var PropTypes = __webpack_require__(45697);

var _require = __webpack_require__(36959),
    createFocusTrap = _require.createFocusTrap; // TODO: These issues are related to older React features which we'll likely need
//  to fix in order to move the code forward to the next major version of React.
//  @see https://github.com/davidtheclark/focus-trap-react/issues/77

/* eslint-disable react/no-find-dom-node */


var FocusTrap = /*#__PURE__*/function (_React$Component) {
  _inherits(FocusTrap, _React$Component);

  var _super = _createSuper(FocusTrap);

  function FocusTrap(props) {
    var _this;

    _classCallCheck(this, FocusTrap);

    _this = _super.call(this, props); // We need to hijack the returnFocusOnDeactivate option,
    // because React can move focus into the element before we arrived at
    // this lifecycle hook (e.g. with autoFocus inputs). So the component
    // captures the previouslyFocusedElement in componentWillMount,
    // then (optionally) returns focus to it in componentWillUnmount.

    _this.tailoredFocusTrapOptions = {
      returnFocusOnDeactivate: false
    }; // because of the above, we maintain our own flag for this option, and
    //  default it to `true` because that's focus-trap's default

    _this.returnFocusOnDeactivate = true;
    var focusTrapOptions = props.focusTrapOptions;

    for (var optionName in focusTrapOptions) {
      if (!Object.prototype.hasOwnProperty.call(focusTrapOptions, optionName)) {
        continue;
      }

      if (optionName === 'returnFocusOnDeactivate') {
        _this.returnFocusOnDeactivate = !!focusTrapOptions[optionName];
        continue;
      }

      if (optionName === 'onPostDeactivate') {
        _this.onPostDeactivate = focusTrapOptions[optionName];
        continue;
      }

      _this.tailoredFocusTrapOptions[optionName] = focusTrapOptions[optionName];
    } // elements from which to create the focus trap on mount; if a child is used
    //  instead of the `containerElements` prop, we'll get the child's related
    //  element when the trap renders and then is declared 'mounted'


    _this.focusTrapElements = props.containerElements || []; // now we remember what the currently focused element is, not relying on focus-trap

    _this.updatePreviousElement();

    return _this;
  }
  /**
   * Gets the configured document.
   * @returns {Document|undefined} Configured document, falling back to the main
   *  document, if it exists. During SSR, `undefined` is returned since the
   *  document doesn't exist.
   */


  _createClass(FocusTrap, [{
    key: "getDocument",
    value: function getDocument() {
      // SSR: careful to check if `document` exists before accessing it as a variable
      return this.props.focusTrapOptions.document || (typeof document !== 'undefined' ? document : undefined);
    } // TODO: Need more test coverage for this function

  }, {
    key: "getNodeForOption",
    value: function getNodeForOption(optionName) {
      var optionValue = this.tailoredFocusTrapOptions[optionName];

      if (!optionValue) {
        return null;
      }

      var node = optionValue;

      if (typeof optionValue === 'string') {
        var _this$getDocument;

        node = (_this$getDocument = this.getDocument()) === null || _this$getDocument === void 0 ? void 0 : _this$getDocument.querySelector(optionValue);

        if (!node) {
          throw new Error("`".concat(optionName, "` refers to no known node"));
        }
      }

      if (typeof optionValue === 'function') {
        node = optionValue();

        if (!node) {
          throw new Error("`".concat(optionName, "` did not return a node"));
        }
      }

      return node;
    }
  }, {
    key: "getReturnFocusNode",
    value: function getReturnFocusNode() {
      var node = this.getNodeForOption('setReturnFocus');
      return node ? node : this.previouslyFocusedElement;
    }
    /** Update the previously focused element with the currently focused element. */

  }, {
    key: "updatePreviousElement",
    value: function updatePreviousElement() {
      var currentDocument = this.getDocument();

      if (currentDocument) {
        this.previouslyFocusedElement = currentDocument.activeElement;
      }
    }
  }, {
    key: "deactivateTrap",
    value: function deactivateTrap() {
      var _this2 = this;

      var _this$tailoredFocusTr = this.tailoredFocusTrapOptions,
          checkCanReturnFocus = _this$tailoredFocusTr.checkCanReturnFocus,
          _this$tailoredFocusTr2 = _this$tailoredFocusTr.preventScroll,
          preventScroll = _this$tailoredFocusTr2 === void 0 ? false : _this$tailoredFocusTr2;

      if (this.focusTrap) {
        // NOTE: we never let the trap return the focus since we do that ourselves
        this.focusTrap.deactivate({
          returnFocus: false
        });
      }

      var finishDeactivation = function finishDeactivation() {
        var returnFocusNode = _this2.getReturnFocusNode();

        var canReturnFocus = (returnFocusNode === null || returnFocusNode === void 0 ? void 0 : returnFocusNode.focus) && _this2.returnFocusOnDeactivate;

        if (canReturnFocus) {
          /** Returns focus to the element that had focus when the trap was activated. */
          returnFocusNode.focus({
            preventScroll: preventScroll
          });
        }

        if (_this2.onPostDeactivate) {
          _this2.onPostDeactivate.call(null); // don't call it in context of "this"

        }
      };

      if (checkCanReturnFocus) {
        checkCanReturnFocus(this.getReturnFocusNode()).then(finishDeactivation, finishDeactivation);
      } else {
        finishDeactivation();
      }
    }
  }, {
    key: "setupFocusTrap",
    value: function setupFocusTrap() {
      if (!this.focusTrap) {
        var focusTrapElementDOMNodes = this.focusTrapElements.map( // NOTE: `findDOMNode()` does not support CSS selectors; it'll just return
        //  a new text node with the text wrapped in it instead of treating the
        //  string as a selector and resolving it to a node in the DOM
        ReactDOM.findDOMNode);
        var nodesExist = focusTrapElementDOMNodes.some(Boolean);

        if (nodesExist) {
          // eslint-disable-next-line react/prop-types -- _createFocusTrap is an internal prop
          this.focusTrap = this.props._createFocusTrap(focusTrapElementDOMNodes, this.tailoredFocusTrapOptions);

          if (this.props.active) {
            this.focusTrap.activate();
          }

          if (this.props.paused) {
            this.focusTrap.pause();
          }
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.active) {
        this.setupFocusTrap();
      } // else, wait for later activation in case the `focusTrapOptions` will be updated
      //  again before the trap is activated (e.g. if waiting to know what the document
      //  object will be, so the Trap must be rendered, but the consumer is waiting to
      //  activate until they have obtained the document from a ref)
      //  @see https://github.com/focus-trap/focus-trap-react/issues/539

    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.focusTrap) {
        if (prevProps.containerElements !== this.props.containerElements) {
          this.focusTrap.updateContainerElements(this.props.containerElements);
        }

        var hasActivated = !prevProps.active && this.props.active;
        var hasDeactivated = prevProps.active && !this.props.active;
        var hasPaused = !prevProps.paused && this.props.paused;
        var hasUnpaused = prevProps.paused && !this.props.paused;

        if (hasActivated) {
          this.updatePreviousElement();
          this.focusTrap.activate();
        }

        if (hasDeactivated) {
          this.deactivateTrap();
          return; // un/pause does nothing on an inactive trap
        }

        if (hasPaused) {
          this.focusTrap.pause();
        }

        if (hasUnpaused) {
          this.focusTrap.unpause();
        }
      } else {
        // NOTE: if we're in `componentDidUpdate` and we don't have a trap yet,
        //  it either means it shouldn't be active, or it should be but none of
        //  of given `containerElements` were present in the DOM the last time
        //  we tried to create the trap
        if (prevProps.containerElements !== this.props.containerElements) {
          this.focusTrapElements = this.props.containerElements;
        } // don't create the trap unless it should be active in case the consumer
        //  is still updating `focusTrapOptions`
        //  @see https://github.com/focus-trap/focus-trap-react/issues/539


        if (this.props.active) {
          this.updatePreviousElement();
          this.setupFocusTrap();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.deactivateTrap();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var child = this.props.children ? React.Children.only(this.props.children) : undefined;

      if (child) {
        if (child.type && child.type === React.Fragment) {
          throw new Error('A focus-trap cannot use a Fragment as its child container. Try replacing it with a <div> element.');
        }

        var composedRefCallback = function composedRefCallback(element) {
          var containerElements = _this3.props.containerElements;

          if (child) {
            if (typeof child.ref === 'function') {
              child.ref(element);
            } else if (child.ref) {
              child.ref.current = element;
            }
          }

          _this3.focusTrapElements = containerElements ? containerElements : [element];
        };

        var childWithRef = React.cloneElement(child, {
          ref: composedRefCallback
        });
        return childWithRef;
      }

      return null;
    }
  }]);

  return FocusTrap;
}(React.Component); // support server-side rendering where `Element` will not be defined


var ElementType = typeof Element === 'undefined' ? Function : Element;
FocusTrap.propTypes = {
  active: PropTypes.bool,
  paused: PropTypes.bool,
  focusTrapOptions: PropTypes.shape({
    document: PropTypes.object,
    onActivate: PropTypes.func,
    onPostActivate: PropTypes.func,
    checkCanFocusTrap: PropTypes.func,
    onDeactivate: PropTypes.func,
    onPostDeactivate: PropTypes.func,
    checkCanReturnFocus: PropTypes.func,
    initialFocus: PropTypes.oneOfType([PropTypes.instanceOf(ElementType), PropTypes.string, PropTypes.func, PropTypes.bool]),
    fallbackFocus: PropTypes.oneOfType([PropTypes.instanceOf(ElementType), PropTypes.string, PropTypes.func]),
    escapeDeactivates: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    clickOutsideDeactivates: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    returnFocusOnDeactivate: PropTypes.bool,
    setReturnFocus: PropTypes.oneOfType([PropTypes.instanceOf(ElementType), PropTypes.string, PropTypes.func]),
    allowOutsideClick: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    preventScroll: PropTypes.bool
  }),
  containerElements: PropTypes.arrayOf(PropTypes.instanceOf(ElementType)),
  children: PropTypes.oneOfType([PropTypes.element, // React element
  PropTypes.instanceOf(ElementType) // DOM element
  ]) // NOTE: _createFocusTrap is internal, for testing purposes only, so we don't
  //  specify it here. It's expected to be set to the function returned from
  //  require('focus-trap'), or one with a compatible interface.

};
FocusTrap.defaultProps = {
  active: true,
  paused: false,
  focusTrapOptions: {},
  _createFocusTrap: createFocusTrap
};
module.exports = FocusTrap;

/***/ }),

/***/ 36959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "createFocusTrap": function() { return /* binding */ createFocusTrap; }
});

;// CONCATENATED MODULE: ./node_modules/tabbable/dist/index.esm.js
/*!
* tabbable 5.2.1
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var candidateSelectors = ['input', 'select', 'textarea', 'a[href]', 'button', '[tabindex]', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])', 'details>summary:first-of-type', 'details'];
var candidateSelector = /* #__PURE__ */candidateSelectors.join(',');
var matches = typeof Element === 'undefined' ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;

var getCandidates = function getCandidates(el, includeContainer, filter) {
  var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));

  if (includeContainer && matches.call(el, candidateSelector)) {
    candidates.unshift(el);
  }

  candidates = candidates.filter(filter);
  return candidates;
};

var isContentEditable = function isContentEditable(node) {
  return node.contentEditable === 'true';
};

var getTabindex = function getTabindex(node) {
  var tabindexAttr = parseInt(node.getAttribute('tabindex'), 10);

  if (!isNaN(tabindexAttr)) {
    return tabindexAttr;
  } // Browsers do not return `tabIndex` correctly for contentEditable nodes;
  // so if they don't have a tabindex attribute specifically set, assume it's 0.


  if (isContentEditable(node)) {
    return 0;
  } // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
  //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
  //  yet they are still part of the regular tab order; in FF, they get a default
  //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
  //  order, consider their tab index to be 0.


  if ((node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) {
    return 0;
  }

  return node.tabIndex;
};

var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};

var isInput = function isInput(node) {
  return node.tagName === 'INPUT';
};

var isHiddenInput = function isHiddenInput(node) {
  return isInput(node) && node.type === 'hidden';
};

var isDetailsWithSummary = function isDetailsWithSummary(node) {
  var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function (child) {
    return child.tagName === 'SUMMARY';
  });
  return r;
};

var getCheckedRadio = function getCheckedRadio(nodes, form) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked && nodes[i].form === form) {
      return nodes[i];
    }
  }
};

var isTabbableRadio = function isTabbableRadio(node) {
  if (!node.name) {
    return true;
  }

  var radioScope = node.form || node.ownerDocument;

  var queryRadios = function queryRadios(name) {
    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
  };

  var radioSet;

  if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') {
    radioSet = queryRadios(window.CSS.escape(node.name));
  } else {
    try {
      radioSet = queryRadios(node.name);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
      return false;
    }
  }

  var checked = getCheckedRadio(radioSet, node.form);
  return !checked || checked === node;
};

var isRadio = function isRadio(node) {
  return isInput(node) && node.type === 'radio';
};

var isNonTabbableRadio = function isNonTabbableRadio(node) {
  return isRadio(node) && !isTabbableRadio(node);
};

var isHidden = function isHidden(node, displayCheck) {
  if (getComputedStyle(node).visibility === 'hidden') {
    return true;
  }

  var isDirectSummary = matches.call(node, 'details>summary:first-of-type');
  var nodeUnderDetails = isDirectSummary ? node.parentElement : node;

  if (matches.call(nodeUnderDetails, 'details:not([open]) *')) {
    return true;
  }

  if (!displayCheck || displayCheck === 'full') {
    while (node) {
      if (getComputedStyle(node).display === 'none') {
        return true;
      }

      node = node.parentElement;
    }
  } else if (displayCheck === 'non-zero-area') {
    var _node$getBoundingClie = node.getBoundingClientRect(),
        width = _node$getBoundingClie.width,
        height = _node$getBoundingClie.height;

    return width === 0 && height === 0;
  }

  return false;
}; // form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset


var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
  if (isInput(node) || node.tagName === 'SELECT' || node.tagName === 'TEXTAREA' || node.tagName === 'BUTTON') {
    var parentNode = node.parentElement;

    while (parentNode) {
      if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
        // look for the first <legend> as an immediate child of the disabled
        //  <fieldset>: if the node is in that legend, it'll be enabled even
        //  though the fieldset is disabled; otherwise, the node is in a
        //  secondary/subsequent legend, or somewhere else within the fieldset
        //  (however deep nested) and it'll be disabled
        for (var i = 0; i < parentNode.children.length; i++) {
          var child = parentNode.children.item(i);

          if (child.tagName === 'LEGEND') {
            if (child.contains(node)) {
              return false;
            } // the node isn't in the first legend (in doc order), so no matter
            //  where it is now, it'll be disabled


            return true;
          }
        } // the node isn't in a legend, so no matter where it is now, it'll be disabled


        return true;
      }

      parentNode = parentNode.parentElement;
    }
  } // else, node's tabbable/focusable state should not be affected by a fieldset's
  //  enabled/disabled state


  return false;
};

var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
  if (node.disabled || isHiddenInput(node) || isHidden(node, options.displayCheck) || // For a details element with a summary, the summary element gets the focus
  isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
    return false;
  }

  return true;
};

var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
  if (!isNodeMatchingSelectorFocusable(options, node) || isNonTabbableRadio(node) || getTabindex(node) < 0) {
    return false;
  }

  return true;
};

var tabbable = function tabbable(el, options) {
  options = options || {};
  var regularTabbables = [];
  var orderedTabbables = [];
  var candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
  candidates.forEach(function (candidate, i) {
    var candidateTabindex = getTabindex(candidate);

    if (candidateTabindex === 0) {
      regularTabbables.push(candidate);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        node: candidate
      });
    }
  });
  var tabbableNodes = orderedTabbables.sort(sortOrderedTabbables).map(function (a) {
    return a.node;
  }).concat(regularTabbables);
  return tabbableNodes;
};

var focusable = function focusable(el, options) {
  options = options || {};
  var candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
  return candidates;
};

var isTabbable = function isTabbable(node, options) {
  options = options || {};

  if (!node) {
    throw new Error('No node provided');
  }

  if (matches.call(node, candidateSelector) === false) {
    return false;
  }

  return isNodeMatchingSelectorTabbable(options, node);
};

var focusableCandidateSelector = /* #__PURE__ */candidateSelectors.concat('iframe').join(',');

var isFocusable = function isFocusable(node, options) {
  options = options || {};

  if (!node) {
    throw new Error('No node provided');
  }

  if (matches.call(node, focusableCandidateSelector) === false) {
    return false;
  }

  return isNodeMatchingSelectorFocusable(options, node);
};


//# sourceMappingURL=index.esm.js.map

;// CONCATENATED MODULE: ./node_modules/focus-trap/dist/focus-trap.esm.js
/*!
* focus-trap 6.7.2
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var activeFocusTraps = function () {
  var trapQueue = [];
  return {
    activateTrap: function activateTrap(trap) {
      if (trapQueue.length > 0) {
        var activeTrap = trapQueue[trapQueue.length - 1];

        if (activeTrap !== trap) {
          activeTrap.pause();
        }
      }

      var trapIndex = trapQueue.indexOf(trap);

      if (trapIndex === -1) {
        trapQueue.push(trap);
      } else {
        // move this existing trap to the front of the queue
        trapQueue.splice(trapIndex, 1);
        trapQueue.push(trap);
      }
    },
    deactivateTrap: function deactivateTrap(trap) {
      var trapIndex = trapQueue.indexOf(trap);

      if (trapIndex !== -1) {
        trapQueue.splice(trapIndex, 1);
      }

      if (trapQueue.length > 0) {
        trapQueue[trapQueue.length - 1].unpause();
      }
    }
  };
}();

var isSelectableInput = function isSelectableInput(node) {
  return node.tagName && node.tagName.toLowerCase() === 'input' && typeof node.select === 'function';
};

var isEscapeEvent = function isEscapeEvent(e) {
  return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
};

var isTabEvent = function isTabEvent(e) {
  return e.key === 'Tab' || e.keyCode === 9;
};

var delay = function delay(fn) {
  return setTimeout(fn, 0);
}; // Array.find/findIndex() are not supported on IE; this replicates enough
//  of Array.findIndex() for our needs


var findIndex = function findIndex(arr, fn) {
  var idx = -1;
  arr.every(function (value, i) {
    if (fn(value)) {
      idx = i;
      return false; // break
    }

    return true; // next
  });
  return idx;
};
/**
 * Get an option's value when it could be a plain value, or a handler that provides
 *  the value.
 * @param {*} value Option's value to check.
 * @param {...*} [params] Any parameters to pass to the handler, if `value` is a function.
 * @returns {*} The `value`, or the handler's returned value.
 */


var valueOrHandler = function valueOrHandler(value) {
  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }

  return typeof value === 'function' ? value.apply(void 0, params) : value;
};

var getActualTarget = function getActualTarget(event) {
  // NOTE: If the trap is _inside_ a shadow DOM, event.target will always be the
  //  shadow host. However, event.target.composedPath() will be an array of
  //  nodes "clicked" from inner-most (the actual element inside the shadow) to
  //  outer-most (the host HTML document). If we have access to composedPath(),
  //  then use its first element; otherwise, fall back to event.target (and
  //  this only works for an _open_ shadow DOM; otherwise,
  //  composedPath()[0] === event.target always).
  return event.target.shadowRoot && typeof event.composedPath === 'function' ? event.composedPath()[0] : event.target;
};

var createFocusTrap = function createFocusTrap(elements, userOptions) {
  // SSR: a live trap shouldn't be created in this type of environment so this
  //  should be safe code to execute if the `document` option isn't specified
  var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;

  var config = _objectSpread2({
    returnFocusOnDeactivate: true,
    escapeDeactivates: true,
    delayInitialFocus: true
  }, userOptions);

  var state = {
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying the first and last tabbable nodes in all containers/groups in
    //  the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{ container: HTMLElement, firstTabbableNode: HTMLElement|null, lastTabbableNode: HTMLElement|null }>}
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: false,
    paused: false,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: undefined
  };
  var trap; // eslint-disable-line prefer-const -- some private functions reference it, and its methods reference private functions, so we must declare here and define later

  var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
    return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
  };

  var containersContain = function containersContain(element) {
    return !!(element && state.containers.some(function (container) {
      return container.contains(element);
    }));
  };
  /**
   * Gets the node for the given option, which is expected to be an option that
   *  can be either a DOM node, a string that is a selector to get a node, `false`
   *  (if a node is explicitly NOT given), or a function that returns any of these
   *  values.
   * @param {string} optionName
   * @returns {undefined | false | HTMLElement | SVGElement} Returns
   *  `undefined` if the option is not specified; `false` if the option
   *  resolved to `false` (node explicitly not given); otherwise, the resolved
   *  DOM node.
   * @throws {Error} If the option is set, not `false`, and is not, or does not
   *  resolve to a node.
   */


  var getNodeForOption = function getNodeForOption(optionName) {
    var optionValue = config[optionName];

    if (typeof optionValue === 'function') {
      for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        params[_key2 - 1] = arguments[_key2];
      }

      optionValue = optionValue.apply(void 0, params);
    }

    if (!optionValue) {
      if (optionValue === undefined || optionValue === false) {
        return optionValue;
      } // else, empty string (invalid), null (invalid), 0 (invalid)


      throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
    }

    var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point

    if (typeof optionValue === 'string') {
      node = doc.querySelector(optionValue); // resolve to node, or null if fails

      if (!node) {
        throw new Error("`".concat(optionName, "` as selector refers to no known node"));
      }
    }

    return node;
  };

  var getInitialFocusNode = function getInitialFocusNode() {
    var node = getNodeForOption('initialFocus'); // false explicitly indicates we want no initialFocus at all

    if (node === false) {
      return false;
    }

    if (node === undefined) {
      // option not specified: use fallback options
      if (containersContain(doc.activeElement)) {
        node = doc.activeElement;
      } else {
        var firstTabbableGroup = state.tabbableGroups[0];
        var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode; // NOTE: `fallbackFocus` option function cannot return `false` (not supported)

        node = firstTabbableNode || getNodeForOption('fallbackFocus');
      }
    }

    if (!node) {
      throw new Error('Your focus-trap needs to have at least one focusable element');
    }

    return node;
  };

  var updateTabbableNodes = function updateTabbableNodes() {
    state.tabbableGroups = state.containers.map(function (container) {
      var tabbableNodes = tabbable(container);

      if (tabbableNodes.length > 0) {
        return {
          container: container,
          firstTabbableNode: tabbableNodes[0],
          lastTabbableNode: tabbableNodes[tabbableNodes.length - 1]
        };
      }

      return undefined;
    }).filter(function (group) {
      return !!group;
    }); // remove groups with no tabbable nodes
    // throw if no groups have tabbable nodes and we don't have a fallback focus node either

    if (state.tabbableGroups.length <= 0 && !getNodeForOption('fallbackFocus') // returning false not supported for this option
    ) {
      throw new Error('Your focus-trap must have at least one container with at least one tabbable node in it at all times');
    }
  };

  var tryFocus = function tryFocus(node) {
    if (node === false) {
      return;
    }

    if (node === doc.activeElement) {
      return;
    }

    if (!node || !node.focus) {
      tryFocus(getInitialFocusNode());
      return;
    }

    node.focus({
      preventScroll: !!config.preventScroll
    });
    state.mostRecentlyFocusedNode = node;

    if (isSelectableInput(node)) {
      node.select();
    }
  };

  var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
    var node = getNodeForOption('setReturnFocus', previousActiveElement);
    return node ? node : node === false ? false : previousActiveElement;
  }; // This needs to be done on mousedown and touchstart instead of click
  // so that it precedes the focus event.


  var checkPointerDown = function checkPointerDown(e) {
    var target = getActualTarget(e);

    if (containersContain(target)) {
      // allow the click since it ocurred inside the trap
      return;
    }

    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      // immediately deactivate the trap
      trap.deactivate({
        // if, on deactivation, we should return focus to the node originally-focused
        //  when the trap was activated (or the configured `setReturnFocus` node),
        //  then assume it's also OK to return focus to the outside node that was
        //  just clicked, causing deactivation, as long as that node is focusable;
        //  if it isn't focusable, then return focus to the original node focused
        //  on activation (or the configured `setReturnFocus` node)
        // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
        //  which will result in the outside click setting focus to the node
        //  that was clicked, whether it's focusable or not; by setting
        //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
        //  on activation (or the configured `setReturnFocus` node)
        returnFocus: config.returnFocusOnDeactivate && !isFocusable(target)
      });
      return;
    } // This is needed for mobile devices.
    // (If we'll only let `click` events through,
    // then on mobile they will be blocked anyways if `touchstart` is blocked.)


    if (valueOrHandler(config.allowOutsideClick, e)) {
      // allow the click outside the trap to take place
      return;
    } // otherwise, prevent the click


    e.preventDefault();
  }; // In case focus escapes the trap for some strange reason, pull it back in.


  var checkFocusIn = function checkFocusIn(e) {
    var target = getActualTarget(e);
    var targetContained = containersContain(target); // In Firefox when you Tab out of an iframe the Document is briefly focused.

    if (targetContained || target instanceof Document) {
      if (targetContained) {
        state.mostRecentlyFocusedNode = target;
      }
    } else {
      // escaped! pull it back in to where it just left
      e.stopImmediatePropagation();
      tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
    }
  }; // Hijack Tab events on the first and last focusable nodes of the trap,
  // in order to prevent focus from escaping. If it escapes for even a
  // moment it can end up scrolling the page and causing confusion so we
  // kind of need to capture the action at the keydown phase.


  var checkTab = function checkTab(e) {
    var target = getActualTarget(e);
    updateTabbableNodes();
    var destinationNode = null;

    if (state.tabbableGroups.length > 0) {
      // make sure the target is actually contained in a group
      // NOTE: the target may also be the container itself if it's focusable
      //  with tabIndex='-1' and was given initial focus
      var containerIndex = findIndex(state.tabbableGroups, function (_ref) {
        var container = _ref.container;
        return container.contains(target);
      });

      if (containerIndex < 0) {
        // target not found in any group: quite possible focus has escaped the trap,
        //  so bring it back in to...
        if (e.shiftKey) {
          // ...the last node in the last group
          destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
        } else {
          // ...the first node in the first group
          destinationNode = state.tabbableGroups[0].firstTabbableNode;
        }
      } else if (e.shiftKey) {
        // REVERSE
        // is the target the first tabbable node in a group?
        var startOfGroupIndex = findIndex(state.tabbableGroups, function (_ref2) {
          var firstTabbableNode = _ref2.firstTabbableNode;
          return target === firstTabbableNode;
        });

        if (startOfGroupIndex < 0 && (state.tabbableGroups[containerIndex].container === target || isFocusable(target) && !isTabbable(target))) {
          // an exception case where the target is either the container itself, or
          //  a non-tabbable node that was given focus (i.e. tabindex is negative
          //  and user clicked on it or node was programmatically given focus), in which
          //  case, we should handle shift+tab as if focus were on the container's
          //  first tabbable node, and go to the last tabbable node of the LAST group
          startOfGroupIndex = containerIndex;
        }

        if (startOfGroupIndex >= 0) {
          // YES: then shift+tab should go to the last tabbable node in the
          //  previous group (and wrap around to the last tabbable node of
          //  the LAST group if it's the first tabbable node of the FIRST group)
          var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
          var destinationGroup = state.tabbableGroups[destinationGroupIndex];
          destinationNode = destinationGroup.lastTabbableNode;
        }
      } else {
        // FORWARD
        // is the target the last tabbable node in a group?
        var lastOfGroupIndex = findIndex(state.tabbableGroups, function (_ref3) {
          var lastTabbableNode = _ref3.lastTabbableNode;
          return target === lastTabbableNode;
        });

        if (lastOfGroupIndex < 0 && (state.tabbableGroups[containerIndex].container === target || isFocusable(target) && !isTabbable(target))) {
          // an exception case where the target is the container itself, or
          //  a non-tabbable node that was given focus (i.e. tabindex is negative
          //  and user clicked on it or node was programmatically given focus), in which
          //  case, we should handle tab as if focus were on the container's
          //  last tabbable node, and go to the first tabbable node of the FIRST group
          lastOfGroupIndex = containerIndex;
        }

        if (lastOfGroupIndex >= 0) {
          // YES: then tab should go to the first tabbable node in the next
          //  group (and wrap around to the first tabbable node of the FIRST
          //  group if it's the last tabbable node of the LAST group)
          var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;

          var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
          destinationNode = _destinationGroup.firstTabbableNode;
        }
      }
    } else {
      // NOTE: the fallbackFocus option does not support returning false to opt-out
      destinationNode = getNodeForOption('fallbackFocus');
    }

    if (destinationNode) {
      e.preventDefault();
      tryFocus(destinationNode);
    } // else, let the browser take care of [shift+]tab and move the focus

  };

  var checkKey = function checkKey(e) {
    if (isEscapeEvent(e) && valueOrHandler(config.escapeDeactivates, e) !== false) {
      e.preventDefault();
      trap.deactivate();
      return;
    }

    if (isTabEvent(e)) {
      checkTab(e);
      return;
    }
  };

  var checkClick = function checkClick(e) {
    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      return;
    }

    var target = getActualTarget(e);

    if (containersContain(target)) {
      return;
    }

    if (valueOrHandler(config.allowOutsideClick, e)) {
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();
  }; //
  // EVENT LISTENERS
  //


  var addListeners = function addListeners() {
    if (!state.active) {
      return;
    } // There can be only one listening focus trap at a time


    activeFocusTraps.activateTrap(trap); // Delay ensures that the focused element doesn't capture the event
    // that caused the focus trap activation.

    state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function () {
      tryFocus(getInitialFocusNode());
    }) : tryFocus(getInitialFocusNode());
    doc.addEventListener('focusin', checkFocusIn, true);
    doc.addEventListener('mousedown', checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener('touchstart', checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener('click', checkClick, {
      capture: true,
      passive: false
    });
    doc.addEventListener('keydown', checkKey, {
      capture: true,
      passive: false
    });
    return trap;
  };

  var removeListeners = function removeListeners() {
    if (!state.active) {
      return;
    }

    doc.removeEventListener('focusin', checkFocusIn, true);
    doc.removeEventListener('mousedown', checkPointerDown, true);
    doc.removeEventListener('touchstart', checkPointerDown, true);
    doc.removeEventListener('click', checkClick, true);
    doc.removeEventListener('keydown', checkKey, true);
    return trap;
  }; //
  // TRAP DEFINITION
  //


  trap = {
    activate: function activate(activateOptions) {
      if (state.active) {
        return this;
      }

      var onActivate = getOption(activateOptions, 'onActivate');
      var onPostActivate = getOption(activateOptions, 'onPostActivate');
      var checkCanFocusTrap = getOption(activateOptions, 'checkCanFocusTrap');

      if (!checkCanFocusTrap) {
        updateTabbableNodes();
      }

      state.active = true;
      state.paused = false;
      state.nodeFocusedBeforeActivation = doc.activeElement;

      if (onActivate) {
        onActivate();
      }

      var finishActivation = function finishActivation() {
        if (checkCanFocusTrap) {
          updateTabbableNodes();
        }

        addListeners();

        if (onPostActivate) {
          onPostActivate();
        }
      };

      if (checkCanFocusTrap) {
        checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
        return this;
      }

      finishActivation();
      return this;
    },
    deactivate: function deactivate(deactivateOptions) {
      if (!state.active) {
        return this;
      }

      clearTimeout(state.delayInitialFocusTimer); // noop if undefined

      state.delayInitialFocusTimer = undefined;
      removeListeners();
      state.active = false;
      state.paused = false;
      activeFocusTraps.deactivateTrap(trap);
      var onDeactivate = getOption(deactivateOptions, 'onDeactivate');
      var onPostDeactivate = getOption(deactivateOptions, 'onPostDeactivate');
      var checkCanReturnFocus = getOption(deactivateOptions, 'checkCanReturnFocus');

      if (onDeactivate) {
        onDeactivate();
      }

      var returnFocus = getOption(deactivateOptions, 'returnFocus', 'returnFocusOnDeactivate');

      var finishDeactivation = function finishDeactivation() {
        delay(function () {
          if (returnFocus) {
            tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
          }

          if (onPostDeactivate) {
            onPostDeactivate();
          }
        });
      };

      if (returnFocus && checkCanReturnFocus) {
        checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
        return this;
      }

      finishDeactivation();
      return this;
    },
    pause: function pause() {
      if (state.paused || !state.active) {
        return this;
      }

      state.paused = true;
      removeListeners();
      return this;
    },
    unpause: function unpause() {
      if (!state.paused || !state.active) {
        return this;
      }

      state.paused = false;
      updateTabbableNodes();
      addListeners();
      return this;
    },
    updateContainerElements: function updateContainerElements(containerElements) {
      var elementsAsArray = [].concat(containerElements).filter(Boolean);
      state.containers = elementsAsArray.map(function (element) {
        return typeof element === 'string' ? doc.querySelector(element) : element;
      });

      if (state.active) {
        updateTabbableNodes();
      }

      return this;
    }
  }; // initialize container elements

  trap.updateContainerElements(elements);
  return trap;
};


//# sourceMappingURL=focus-trap.esm.js.map


/***/ }),

/***/ 50840:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else {}

})(window, document, 'Hammer');


/***/ }),

/***/ 8679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(59864);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 56264:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;// =========
// = humps =
// =========
// Underscore-to-camelCase converter (and vice versa)
// for strings and object keys

// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.


;(function(global) {

  var _processKeys = function(convert, obj, options) {
    if(!_isObject(obj) || _isDate(obj) || _isRegExp(obj) || _isBoolean(obj) || _isFunction(obj)) {
      return obj;
    }

    var output,
        i = 0,
        l = 0;

    if(_isArray(obj)) {
      output = [];
      for(l=obj.length; i<l; i++) {
        output.push(_processKeys(convert, obj[i], options));
      }
    }
    else {
      output = {};
      for(var key in obj) {
        if(Object.prototype.hasOwnProperty.call(obj, key)) {
          output[convert(key, options)] = _processKeys(convert, obj[key], options);
        }
      }
    }
    return output;
  };

  // String conversion methods

  var separateWords = function(string, options) {
    options = options || {};
    var separator = options.separator || '_';
    var split = options.split || /(?=[A-Z])/;

    return string.split(split).join(separator);
  };

  var camelize = function(string) {
    if (_isNumerical(string)) {
      return string;
    }
    string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
      return chr ? chr.toUpperCase() : '';
    });
    // Ensure 1st char is always lowercase
    return string.substr(0, 1).toLowerCase() + string.substr(1);
  };

  var pascalize = function(string) {
    var camelized = camelize(string);
    // Ensure 1st char is always uppercase
    return camelized.substr(0, 1).toUpperCase() + camelized.substr(1);
  };

  var decamelize = function(string, options) {
    return separateWords(string, options).toLowerCase();
  };

  // Utilities
  // Taken from Underscore.js

  var toString = Object.prototype.toString;

  var _isFunction = function(obj) {
    return typeof(obj) === 'function';
  };
  var _isObject = function(obj) {
    return obj === Object(obj);
  };
  var _isArray = function(obj) {
    return toString.call(obj) == '[object Array]';
  };
  var _isDate = function(obj) {
    return toString.call(obj) == '[object Date]';
  };
  var _isRegExp = function(obj) {
    return toString.call(obj) == '[object RegExp]';
  };
  var _isBoolean = function(obj) {
    return toString.call(obj) == '[object Boolean]';
  };

  // Performant way to determine if obj coerces to a number
  var _isNumerical = function(obj) {
    obj = obj - 0;
    return obj === obj;
  };

  // Sets up function which handles processing keys
  // allowing the convert function to be modified by a callback
  var _processor = function(convert, options) {
    var callback = options && 'process' in options ? options.process : options;

    if(typeof(callback) !== 'function') {
      return convert;
    }

    return function(string, options) {
      return callback(string, convert, options);
    }
  };

  var humps = {
    camelize: camelize,
    decamelize: decamelize,
    pascalize: pascalize,
    depascalize: decamelize,
    camelizeKeys: function(object, options) {
      return _processKeys(_processor(camelize, options), object);
    },
    decamelizeKeys: function(object, options) {
      return _processKeys(_processor(decamelize, options), object, options);
    },
    pascalizeKeys: function(object, options) {
      return _processKeys(_processor(pascalize, options), object);
    },
    depascalizeKeys: function () {
      return this.decamelizeKeys.apply(this, arguments);
    }
  };

  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (humps),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}

})(this);


/***/ }),

/***/ 18552:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 1989:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(51789),
    hashDelete = __webpack_require__(80401),
    hashGet = __webpack_require__(57667),
    hashHas = __webpack_require__(21327),
    hashSet = __webpack_require__(81866);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 38407:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(27040),
    listCacheDelete = __webpack_require__(14125),
    listCacheGet = __webpack_require__(82117),
    listCacheHas = __webpack_require__(67518),
    listCacheSet = __webpack_require__(54705);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 57071:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 83369:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(24785),
    mapCacheDelete = __webpack_require__(11285),
    mapCacheGet = __webpack_require__(96000),
    mapCacheHas = __webpack_require__(49916),
    mapCacheSet = __webpack_require__(95265);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 53818:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 58525:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 88668:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(83369),
    setCacheAdd = __webpack_require__(90619),
    setCacheHas = __webpack_require__(72385);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 46384:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407),
    stackClear = __webpack_require__(37465),
    stackDelete = __webpack_require__(63779),
    stackGet = __webpack_require__(67599),
    stackHas = __webpack_require__(44758),
    stackSet = __webpack_require__(34309);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 62705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 11149:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 70577:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 96874:
/***/ (function(module) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ 77412:
/***/ (function(module) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),

/***/ 34963:
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 14636:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(22545),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(44144),
    isIndex = __webpack_require__(65776),
    isTypedArray = __webpack_require__(36719);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 29932:
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 62488:
/***/ (function(module) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 82908:
/***/ (function(module) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ 48983:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseProperty = __webpack_require__(40371);

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = baseProperty('length');

module.exports = asciiSize;


/***/ }),

/***/ 34865:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(89465),
    eq = __webpack_require__(77813);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ 18470:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(77813);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 44037:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(98363),
    keys = __webpack_require__(3674);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),

/***/ 63886:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(98363),
    keysIn = __webpack_require__(81704);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),

/***/ 89465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var defineProperty = __webpack_require__(38777);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ 85990:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(46384),
    arrayEach = __webpack_require__(77412),
    assignValue = __webpack_require__(34865),
    baseAssign = __webpack_require__(44037),
    baseAssignIn = __webpack_require__(63886),
    cloneBuffer = __webpack_require__(64626),
    copyArray = __webpack_require__(278),
    copySymbols = __webpack_require__(18805),
    copySymbolsIn = __webpack_require__(1911),
    getAllKeys = __webpack_require__(58234),
    getAllKeysIn = __webpack_require__(46904),
    getTag = __webpack_require__(64160),
    initCloneArray = __webpack_require__(43824),
    initCloneByTag = __webpack_require__(29148),
    initCloneObject = __webpack_require__(38517),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(44144),
    isMap = __webpack_require__(56688),
    isObject = __webpack_require__(13218),
    isSet = __webpack_require__(72928),
    keys = __webpack_require__(3674),
    keysIn = __webpack_require__(81704);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),

/***/ 3118:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ 41848:
/***/ (function(module) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),

/***/ 35744:
/***/ (function(module) {

/**
 * The base implementation of methods like `_.findKey` and `_.findLastKey`,
 * without support for iteratee shorthands, which iterates over `collection`
 * using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the found element or its key, else `undefined`.
 */
function baseFindKey(collection, predicate, eachFunc) {
  var result;
  eachFunc(collection, function(value, key, collection) {
    if (predicate(value, key, collection)) {
      result = key;
      return false;
    }
  });
  return result;
}

module.exports = baseFindKey;


/***/ }),

/***/ 21078:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(62488),
    isFlattenable = __webpack_require__(37285);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),

/***/ 44370:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseForRight = __webpack_require__(27473),
    keys = __webpack_require__(3674);

/**
 * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwnRight(object, iteratee) {
  return object && baseForRight(object, iteratee, keys);
}

module.exports = baseForOwnRight;


/***/ }),

/***/ 27473:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createBaseFor = __webpack_require__(25063);

/**
 * This function is like `baseFor` except that it iterates over properties
 * in the opposite order.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseForRight = createBaseFor(true);

module.exports = baseForRight;


/***/ }),

/***/ 97786:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(71811),
    toKey = __webpack_require__(40327);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 68866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(62488),
    isArray = __webpack_require__(1469);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 44239:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    getRawTag = __webpack_require__(89607),
    objectToString = __webpack_require__(2333);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 13:
/***/ (function(module) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ 9454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 90939:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(2492),
    isObjectLike = __webpack_require__(37005);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ 2492:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(46384),
    equalArrays = __webpack_require__(67114),
    equalByTag = __webpack_require__(18351),
    equalObjects = __webpack_require__(16096),
    getTag = __webpack_require__(64160),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(44144),
    isTypedArray = __webpack_require__(36719);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ 25588:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getTag = __webpack_require__(64160),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),

/***/ 2958:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(46384),
    baseIsEqual = __webpack_require__(90939);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ 28458:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(23560),
    isMasked = __webpack_require__(15346),
    isObject = __webpack_require__(13218),
    toSource = __webpack_require__(80346);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 29221:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getTag = __webpack_require__(64160),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),

/***/ 38749:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isLength = __webpack_require__(41780),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 67206:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMatches = __webpack_require__(91573),
    baseMatchesProperty = __webpack_require__(16432),
    identity = __webpack_require__(6557),
    isArray = __webpack_require__(1469),
    property = __webpack_require__(39601);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ 280:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(25726),
    nativeKeys = __webpack_require__(86916);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 10313:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218),
    isPrototype = __webpack_require__(25726),
    nativeKeysIn = __webpack_require__(33498);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),

/***/ 91573:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(2958),
    getMatchData = __webpack_require__(1499),
    matchesStrictComparable = __webpack_require__(42634);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ 16432:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(90939),
    get = __webpack_require__(27361),
    hasIn = __webpack_require__(79095),
    isKey = __webpack_require__(15403),
    isStrictComparable = __webpack_require__(89162),
    matchesStrictComparable = __webpack_require__(42634),
    toKey = __webpack_require__(40327);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ 40371:
/***/ (function(module) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ 79152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97786);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ 56560:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var constant = __webpack_require__(75703),
    defineProperty = __webpack_require__(38777),
    identity = __webpack_require__(6557);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ 14259:
/***/ (function(module) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),

/***/ 22545:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 80531:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    arrayMap = __webpack_require__(29932),
    isArray = __webpack_require__(1469),
    isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 27561:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(67990);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 7518:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 57406:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(71811),
    last = __webpack_require__(10928),
    parent = __webpack_require__(40292),
    toKey = __webpack_require__(40327);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),

/***/ 74757:
/***/ (function(module) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 71811:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(1469),
    isKey = __webpack_require__(15403),
    stringToPath = __webpack_require__(55514),
    toString = __webpack_require__(79833);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 74318:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Uint8Array = __webpack_require__(11149);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ 64626:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(55639);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;


/***/ }),

/***/ 57157:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(74318);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),

/***/ 93147:
/***/ (function(module) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),

/***/ 40419:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),

/***/ 77133:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(74318);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ 278:
/***/ (function(module) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ 98363:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignValue = __webpack_require__(34865),
    baseAssignValue = __webpack_require__(89465);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ 18805:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(98363),
    getSymbols = __webpack_require__(99551);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),

/***/ 1911:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(98363),
    getSymbolsIn = __webpack_require__(51442);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),

/***/ 14429:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 25063:
/***/ (function(module) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ 67740:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIteratee = __webpack_require__(67206),
    isArrayLike = __webpack_require__(98612),
    keys = __webpack_require__(3674);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),

/***/ 60696:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPlainObject = __webpack_require__(68630);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),

/***/ 38777:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ 67114:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(88668),
    arraySome = __webpack_require__(82908),
    cacheHas = __webpack_require__(74757);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ 18351:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    Uint8Array = __webpack_require__(11149),
    eq = __webpack_require__(77813),
    equalArrays = __webpack_require__(67114),
    mapToArray = __webpack_require__(68776),
    setToArray = __webpack_require__(21814);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ 16096:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getAllKeys = __webpack_require__(58234);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ 99021:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var flatten = __webpack_require__(85564),
    overRest = __webpack_require__(45357),
    setToString = __webpack_require__(30061);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),

/***/ 31957:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 58234:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(68866),
    getSymbols = __webpack_require__(99551),
    keys = __webpack_require__(3674);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 46904:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(68866),
    getSymbolsIn = __webpack_require__(51442),
    keysIn = __webpack_require__(81704);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),

/***/ 45050:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(37019);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 1499:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(89162),
    keys = __webpack_require__(3674);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ 10852:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(28458),
    getValue = __webpack_require__(47801);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 85924:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(5569);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ 89607:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 99551:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(34963),
    stubArray = __webpack_require__(70479);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 51442:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(62488),
    getPrototype = __webpack_require__(85924),
    getSymbols = __webpack_require__(99551),
    stubArray = __webpack_require__(70479);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),

/***/ 64160:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(18552),
    Map = __webpack_require__(57071),
    Promise = __webpack_require__(53818),
    Set = __webpack_require__(58525),
    WeakMap = __webpack_require__(70577),
    baseGetTag = __webpack_require__(44239),
    toSource = __webpack_require__(80346);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 47801:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 222:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(71811),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469),
    isIndex = __webpack_require__(65776),
    isLength = __webpack_require__(41780),
    toKey = __webpack_require__(40327);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ 62689:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),

/***/ 51789:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 80401:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 57667:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 21327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 81866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 43824:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),

/***/ 29148:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(74318),
    cloneDataView = __webpack_require__(57157),
    cloneRegExp = __webpack_require__(93147),
    cloneSymbol = __webpack_require__(40419),
    cloneTypedArray = __webpack_require__(77133);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),

/***/ 38517:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseCreate = __webpack_require__(3118),
    getPrototype = __webpack_require__(85924),
    isPrototype = __webpack_require__(25726);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ 37285:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),

/***/ 65776:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 15403:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(1469),
    isSymbol = __webpack_require__(33448);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 37019:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 15346:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(14429);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 25726:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 89162:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ 27040:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 14125:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 82117:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 67518:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 54705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 24785:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(1989),
    ListCache = __webpack_require__(38407),
    Map = __webpack_require__(57071);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 11285:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 96000:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 49916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 95265:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 68776:
/***/ (function(module) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ 42634:
/***/ (function(module) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ 24523:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoize = __webpack_require__(88306);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 94536:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 86916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(5569);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 33498:
/***/ (function(module) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ 31167:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(31957);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 2333:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 5569:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 45357:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var apply = __webpack_require__(96874);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ 40292:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97786),
    baseSlice = __webpack_require__(14259);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),

/***/ 55639:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(31957);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 90619:
/***/ (function(module) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 72385:
/***/ (function(module) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 21814:
/***/ (function(module) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 30061:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSetToString = __webpack_require__(56560),
    shortOut = __webpack_require__(21275);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ 21275:
/***/ (function(module) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ 37465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 63779:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 67599:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 44758:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 34309:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407),
    Map = __webpack_require__(57071),
    MapCache = __webpack_require__(83369);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 88016:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var asciiSize = __webpack_require__(48983),
    hasUnicode = __webpack_require__(62689),
    unicodeSize = __webpack_require__(21903);

/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
  return hasUnicode(string)
    ? unicodeSize(string)
    : asciiSize(string);
}

module.exports = stringSize;


/***/ }),

/***/ 55514:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(24523);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 40327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 80346:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 67990:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 21903:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
function unicodeSize(string) {
  var result = reUnicode.lastIndex = 0;
  while (reUnicode.test(string)) {
    ++result;
  }
  return result;
}

module.exports = unicodeSize;


/***/ }),

/***/ 75703:
/***/ (function(module) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ 23279:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218),
    now = __webpack_require__(7771),
    toNumber = __webpack_require__(14841);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 77813:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 30988:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createFind = __webpack_require__(67740),
    findLastIndex = __webpack_require__(7436);

/**
 * This method is like `_.find` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=collection.length-1] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * _.findLast([1, 2, 3, 4], function(n) {
 *   return n % 2 == 1;
 * });
 * // => 3
 */
var findLast = createFind(findLastIndex);

module.exports = findLast;


/***/ }),

/***/ 7436:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(41848),
    baseIteratee = __webpack_require__(67206),
    toInteger = __webpack_require__(40554);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */
function findLastIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = length - 1;
  if (fromIndex !== undefined) {
    index = toInteger(fromIndex);
    index = fromIndex < 0
      ? nativeMax(length + index, 0)
      : nativeMin(index, length - 1);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index, true);
}

module.exports = findLastIndex;


/***/ }),

/***/ 31691:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFindKey = __webpack_require__(35744),
    baseForOwnRight = __webpack_require__(44370),
    baseIteratee = __webpack_require__(67206);

/**
 * This method is like `_.findKey` except that it iterates over elements of
 * a collection in the opposite order.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {string|undefined} Returns the key of the matched element,
 *  else `undefined`.
 * @example
 *
 * var users = {
 *   'barney':  { 'age': 36, 'active': true },
 *   'fred':    { 'age': 40, 'active': false },
 *   'pebbles': { 'age': 1,  'active': true }
 * };
 *
 * _.findLastKey(users, function(o) { return o.age < 40; });
 * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastKey(users, { 'age': 36, 'active': true });
 * // => 'barney'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastKey(users, ['active', false]);
 * // => 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastKey(users, 'active');
 * // => 'pebbles'
 */
function findLastKey(object, predicate) {
  return baseFindKey(object, baseIteratee(predicate, 3), baseForOwnRight);
}

module.exports = findLastKey;


/***/ }),

/***/ 85564:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFlatten = __webpack_require__(21078);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),

/***/ 27361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97786);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 79095:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseHasIn = __webpack_require__(13),
    hasPath = __webpack_require__(222);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ 6557:
/***/ (function(module) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 35694:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(9454),
    isObjectLike = __webpack_require__(37005);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 1469:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 98612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(23560),
    isLength = __webpack_require__(41780);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 44144:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(55639),
    stubFalse = __webpack_require__(95062);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 18446:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(90939);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),

/***/ 23560:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObject = __webpack_require__(13218);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 41780:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 56688:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMap = __webpack_require__(25588),
    baseUnary = __webpack_require__(7518),
    nodeUtil = __webpack_require__(31167);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),

/***/ 13218:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 37005:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 68630:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    getPrototype = __webpack_require__(85924),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ 72928:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsSet = __webpack_require__(29221),
    baseUnary = __webpack_require__(7518),
    nodeUtil = __webpack_require__(31167);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),

/***/ 47037:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isArray = __webpack_require__(1469),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),

/***/ 33448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 36719:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(38749),
    baseUnary = __webpack_require__(7518),
    nodeUtil = __webpack_require__(31167);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 3674:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(14636),
    baseKeys = __webpack_require__(280),
    isArrayLike = __webpack_require__(98612);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 81704:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(14636),
    baseKeysIn = __webpack_require__(10313),
    isArrayLike = __webpack_require__(98612);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),

/***/ 10928:
/***/ (function(module) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),

/***/ 96486:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));


/***/ }),

/***/ 88306:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(83369);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 7771:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 57557:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(29932),
    baseClone = __webpack_require__(85990),
    baseUnset = __webpack_require__(57406),
    castPath = __webpack_require__(71811),
    copyObject = __webpack_require__(98363),
    customOmitClone = __webpack_require__(60696),
    flatRest = __webpack_require__(99021),
    getAllKeysIn = __webpack_require__(46904);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),

/***/ 39601:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseProperty = __webpack_require__(40371),
    basePropertyDeep = __webpack_require__(79152),
    isKey = __webpack_require__(15403),
    toKey = __webpack_require__(40327);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ 84238:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseKeys = __webpack_require__(280),
    getTag = __webpack_require__(64160),
    isArrayLike = __webpack_require__(98612),
    isString = __webpack_require__(47037),
    stringSize = __webpack_require__(88016);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */
function size(collection) {
  if (collection == null) {
    return 0;
  }
  if (isArrayLike(collection)) {
    return isString(collection) ? stringSize(collection) : collection.length;
  }
  var tag = getTag(collection);
  if (tag == mapTag || tag == setTag) {
    return collection.size;
  }
  return baseKeys(collection).length;
}

module.exports = size;


/***/ }),

/***/ 70479:
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 95062:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 23493:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var debounce = __webpack_require__(23279),
    isObject = __webpack_require__(13218);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),

/***/ 18601:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toNumber = __webpack_require__(14841);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),

/***/ 40554:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toFinite = __webpack_require__(18601);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),

/***/ 14841:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(27561),
    isObject = __webpack_require__(13218),
    isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 79833:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(80531);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 7544:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(22741)


/***/ }),

/***/ 44019:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath = (/* unused pure expression or super */ null && ( false || ''));

function getDomainLocale(path, locale, locales, domainLocales) {
  if (false) { var finalLocale, proto, domain, target, detectDomainLocale, normalizeLocalePath; } else {
    return false;
  }
}

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 7942:
/***/ (function(module, exports, __webpack_require__) {

"client";
"use strict";

var _slicedToArray = __webpack_require__(85696);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _object_without_properties_loose = (__webpack_require__(17273)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

var _router = __webpack_require__(64957);

var _addLocale = __webpack_require__(57995);

var _routerContext = __webpack_require__(30647);

var _appRouterContext = __webpack_require__(51992);

var _useIntersection = __webpack_require__(90639);

var _getDomainLocale = __webpack_require__(44019);

var _addBasePath = __webpack_require__(70227);

'client';
var prefetched = {};

function prefetch(router, href, as, options) {
  if ( false || !router) return;
  if (!(0, _router).isLocalURL(href)) return; // Prefetch the JSON page if asked (only in the client)
  // We need to handle a prefetch error here since we may be
  // loading with priority which can reject but we don't
  // want to force navigation since this is only a prefetch

  Promise.resolve(router.prefetch(href, as, options))["catch"](function (err) {
    if (false) {}
  });
  var curLocale = options && typeof options.locale !== 'undefined' ? options.locale : router && router.locale; // Join on an invalid URI character

  prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')] = true;
}

function isModifiedEvent(event) {
  var target = event.currentTarget.target;
  return target && target !== '_self' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}

function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
  var nodeName = e.currentTarget.nodeName; // anchors inside an svg have a lowercase nodeName

  var isAnchorNodeName = nodeName.toUpperCase() === 'A';

  if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
    // ignore click for browser’s default behavior
    return;
  }

  e.preventDefault();

  var navigate = function navigate() {
    // If the router is an NextRouter instance it will have `beforePopState`
    if ('beforePopState' in router) {
      router[replace ? 'replace' : 'push'](href, as, {
        shallow: shallow,
        locale: locale,
        scroll: scroll
      });
    } else {
      // If `beforePopState` doesn't exist on the router it's the AppRouter.
      var method = replace ? 'replace' : 'push';
      router[method](href, {
        forceOptimisticNavigation: !prefetchEnabled
      });
    }
  };

  if (isAppRouter) {
    // @ts-expect-error startTransition exists.
    _react["default"].startTransition(navigate);
  } else {
    navigate();
  }
}

var Link = /*#__PURE__*/_react["default"].forwardRef(function LinkComponent(props, forwardedRef) {
  if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }

  var children;

  var hrefProp = props.href,
      asProp = props.as,
      childrenProp = props.children,
      prefetchProp = props.prefetch,
      passHref = props.passHref,
      replace = props.replace,
      shallow = props.shallow,
      scroll = props.scroll,
      locale = props.locale,
      _onClick = props.onClick,
      _onMouseEnter = props.onMouseEnter,
      _onTouchStart = props.onTouchStart,
      _props$legacyBehavior = props.legacyBehavior,
      legacyBehavior = _props$legacyBehavior === void 0 ? Boolean(false) !== true : _props$legacyBehavior,
      restProps = _object_without_properties_loose(props, ["href", "as", "children", "prefetch", "passHref", "replace", "shallow", "scroll", "locale", "onClick", "onMouseEnter", "onTouchStart", "legacyBehavior"]);

  children = childrenProp;

  if (legacyBehavior && (typeof children === 'string' || typeof children === 'number')) {
    children = /*#__PURE__*/_react["default"].createElement("a", null, children);
  }

  var p = prefetchProp !== false;

  var router = _react["default"].useContext(_routerContext.RouterContext); // TODO-APP: type error. Remove `as any`


  var appRouter = _react["default"].useContext(_appRouterContext.AppRouterContext);

  if (appRouter) {
    router = appRouter;
  }

  var _react$default$useMem = _react["default"].useMemo(function () {
    var _resolveHref = (0, _router).resolveHref(router, hrefProp, true),
        _resolveHref2 = _slicedToArray(_resolveHref, 2),
        resolvedHref = _resolveHref2[0],
        resolvedAs = _resolveHref2[1];

    return {
      href: resolvedHref,
      as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
    };
  }, [router, hrefProp, asProp]),
      href = _react$default$useMem.href,
      as = _react$default$useMem.as;

  var previousHref = _react["default"].useRef(href);

  var previousAs = _react["default"].useRef(as); // This will return the first child, if multiple are provided it will throw an error


  var child;

  if (legacyBehavior) {
    if (false) {} else {
      child = _react["default"].Children.only(children);
    }
  }

  var childRef = legacyBehavior ? child && typeof child === 'object' && child.ref : forwardedRef;

  var _useIntersection2 = (0, _useIntersection).useIntersection({
    rootMargin: '200px'
  }),
      _useIntersection3 = _slicedToArray(_useIntersection2, 3),
      setIntersectionRef = _useIntersection3[0],
      isVisible = _useIntersection3[1],
      resetVisible = _useIntersection3[2];

  var setRef = _react["default"].useCallback(function (el) {
    // Before the link getting observed, check if visible state need to be reset
    if (previousAs.current !== as || previousHref.current !== href) {
      resetVisible();
      previousAs.current = as;
      previousHref.current = href;
    }

    setIntersectionRef(el);

    if (childRef) {
      if (typeof childRef === 'function') childRef(el);else if (typeof childRef === 'object') {
        childRef.current = el;
      }
    }
  }, [as, childRef, href, resetVisible, setIntersectionRef]);

  _react["default"].useEffect(function () {
    var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
    var curLocale = typeof locale !== 'undefined' ? locale : router && router.locale;
    var isPrefetched = prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')];

    if (shouldPrefetch && !isPrefetched) {
      prefetch(router, href, as, {
        locale: curLocale
      });
    }
  }, [as, href, isVisible, locale, p, router]);

  var childProps = {
    ref: setRef,
    onClick: function onClick(e) {
      if (false) {}

      if (!legacyBehavior && typeof _onClick === 'function') {
        _onClick(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onClick === 'function') {
        child.props.onClick(e);
      }

      if (!e.defaultPrevented) {
        linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
      }
    },
    onMouseEnter: function onMouseEnter(e) {
      if (!legacyBehavior && typeof _onMouseEnter === 'function') {
        _onMouseEnter(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onMouseEnter === 'function') {
        child.props.onMouseEnter(e);
      } // Check for not prefetch disabled in page using appRouter


      if (!(!p && appRouter)) {
        if ((0, _router).isLocalURL(href)) {
          prefetch(router, href, as, {
            priority: true
          });
        }
      }
    },
    onTouchStart: function onTouchStart(e) {
      if (!legacyBehavior && typeof _onTouchStart === 'function') {
        _onTouchStart(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onTouchStart === 'function') {
        child.props.onTouchStart(e);
      } // Check for not prefetch disabled in page using appRouter


      if (!(!p && appRouter)) {
        if ((0, _router).isLocalURL(href)) {
          prefetch(router, href, as, {
            priority: true
          });
        }
      }
    }
  }; // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
  // defined, we specify the current 'href', so that repetition is not needed by the user

  if (!legacyBehavior || passHref || child.type === 'a' && !('href' in child.props)) {
    var curLocale = typeof locale !== 'undefined' ? locale : router && router.locale; // we only render domain locales if we are currently on a domain locale
    // so that locale links are still visitable in development/preview envs

    var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
    childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
  }

  return legacyBehavior ? /*#__PURE__*/_react["default"].cloneElement(child, childProps) : /*#__PURE__*/_react["default"].createElement("a", Object.assign({}, restProps, childProps), children);
});

var _default = Link;
exports["default"] = _default;

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 90639:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__(85696);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useIntersection = useIntersection;

var _react = __webpack_require__(67294);

var _requestIdleCallback = __webpack_require__(26286);

var hasIntersectionObserver = typeof IntersectionObserver === 'function';
var observers = new Map();
var idList = [];

function createObserver(options) {
  var id = {
    root: options.root || null,
    margin: options.rootMargin || ''
  };
  var existing = idList.find(function (obj) {
    return obj.root === id.root && obj.margin === id.margin;
  });
  var instance;

  if (existing) {
    instance = observers.get(existing);

    if (instance) {
      return instance;
    }
  }

  var elements = new Map();
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var callback = elements.get(entry.target);
      var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;

      if (callback && isVisible) {
        callback(isVisible);
      }
    });
  }, options);
  instance = {
    id: id,
    observer: observer,
    elements: elements
  };
  idList.push(id);
  observers.set(id, instance);
  return instance;
}

function observe(element, callback, options) {
  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements;

  elements.set(element, callback);
  observer.observe(element);
  return function unobserve() {
    elements["delete"](element);
    observer.unobserve(element); // Destroy observer when there's nothing left to watch:

    if (elements.size === 0) {
      observer.disconnect();
      observers["delete"](id);
      var index = idList.findIndex(function (obj) {
        return obj.root === id.root && obj.margin === id.margin;
      });

      if (index > -1) {
        idList.splice(index, 1);
      }
    }
  };
}

function useIntersection(_ref) {
  var rootRef = _ref.rootRef,
      rootMargin = _ref.rootMargin,
      disabled = _ref.disabled;
  var isDisabled = disabled || !hasIntersectionObserver;

  var _useState = (0, _react).useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = (0, _react).useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      element = _useState4[0],
      setElement = _useState4[1];

  (0, _react).useEffect(function () {
    if (hasIntersectionObserver) {
      if (isDisabled || visible) return;

      if (element && element.tagName) {
        var unobserve = observe(element, function (isVisible) {
          return isVisible && setVisible(isVisible);
        }, {
          root: rootRef == null ? void 0 : rootRef.current,
          rootMargin: rootMargin
        });
        return unobserve;
      }
    } else {
      if (!visible) {
        var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function () {
          return setVisible(true);
        });
        return function () {
          return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
        };
      }
    }
  }, [element, isDisabled, rootMargin, rootRef, visible]);
  var resetVisible = (0, _react).useCallback(function () {
    setVisible(false);
  }, []);
  return [setElement, visible, resetVisible];
}

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 22741:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__(33227);

var _createClass = __webpack_require__(88361);

var _inherits = __webpack_require__(85971);

var _possibleConstructorReturn = __webpack_require__(52715);

var _getPrototypeOf = __webpack_require__(91193);

var _regeneratorRuntime = __webpack_require__(87794);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "AppInitialProps", ({
  enumerable: true,
  get: function get() {
    return _utils.AppInitialProps;
  }
}));
Object.defineProperty(exports, "NextWebVitalsMetric", ({
  enumerable: true,
  get: function get() {
    return _utils.NextWebVitalsMetric;
  }
}));
Object.defineProperty(exports, "AppType", ({
  enumerable: true,
  get: function get() {
    return _utils.AppType;
  }
}));
exports["default"] = void 0;

var _async_to_generator = (__webpack_require__(60932)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

var _utils = __webpack_require__(99475);

function appGetInitialProps(_) {
  return _appGetInitialProps.apply(this, arguments);
}

function _appGetInitialProps() {
  _appGetInitialProps =
  /**
  * `App` component is used for initialize of pages. It allows for overwriting and full control of the `page` initialization.
  * This allows for keeping state between navigation, custom error handling, injecting additional data.
  */
  _async_to_generator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var Component, ctx, pageProps;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            Component = _ref.Component, ctx = _ref.ctx;
            _context.next = 3;
            return (0, _utils).loadGetInitialProps(Component, ctx);

          case 3:
            pageProps = _context.sent;
            return _context.abrupt("return", {
              pageProps: pageProps
            });

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _appGetInitialProps.apply(this, arguments);
}

var _Component;

var App = /*#__PURE__*/function (_Component2) {
  _inherits(App, _Component2);

  var _super = _createSuper(App);

  function App() {
    _classCallCheck(this, App);

    return _super.apply(this, arguments);
  }

  _createClass(App, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          Component = _this$props.Component,
          pageProps = _this$props.pageProps;
      return /*#__PURE__*/_react["default"].createElement(Component, Object.assign({}, pageProps));
    }
  }]);

  return App;
}(_Component = _react["default"].Component);

App.origGetInitialProps = appGetInitialProps;
App.getInitialProps = appGetInitialProps;
exports["default"] = App;

/***/ }),

/***/ 78000:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.AmpStateContext = void 0;

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

var AmpStateContext = _react["default"].createContext({});

exports.AmpStateContext = AmpStateContext;

if (false) {}

/***/ }),

/***/ 9470:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isInAmpMode = isInAmpMode;

function isInAmpMode() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$ampFirst = _ref.ampFirst,
      ampFirst = _ref$ampFirst === void 0 ? false : _ref$ampFirst,
      _ref$hybrid = _ref.hybrid,
      hybrid = _ref$hybrid === void 0 ? false : _ref$hybrid,
      _ref$hasQuery = _ref.hasQuery,
      hasQuery = _ref$hasQuery === void 0 ? false : _ref$hasQuery;

  return ampFirst || hybrid && hasQuery;
}

/***/ }),

/***/ 51992:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

var AppRouterContext = _react["default"].createContext(null);

exports.AppRouterContext = AppRouterContext;

var LayoutRouterContext = _react["default"].createContext(null);

exports.LayoutRouterContext = LayoutRouterContext;

var GlobalLayoutRouterContext = _react["default"].createContext(null);

exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;

var TemplateContext = _react["default"].createContext(null);

exports.TemplateContext = TemplateContext;

if (false) {}

/***/ }),

/***/ 72717:
/***/ (function(module, exports, __webpack_require__) {

"client";
"use strict";

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.defaultHead = defaultHead;
exports["default"] = void 0;

var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);

var _react = _interop_require_wildcard(__webpack_require__(67294));

var _sideEffect = _interop_require_default(__webpack_require__(11585));

var _ampContext = __webpack_require__(78000);

var _headManagerContext = __webpack_require__(15850);

var _ampMode = __webpack_require__(9470);

var _utils = __webpack_require__(99475);

'client';

function defaultHead() {
  var inAmpMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var head = [/*#__PURE__*/_react["default"].createElement("meta", {
    charSet: "utf-8"
  })];

  if (!inAmpMode) {
    head.push( /*#__PURE__*/_react["default"].createElement("meta", {
      name: "viewport",
      content: "width=device-width"
    }));
  }

  return head;
}

function onlyReactElement(list, child) {
  // React children can be "string" or "number" in this case we ignore them for backwards compat
  if (typeof child === 'string' || typeof child === 'number') {
    return list;
  } // Adds support for React.Fragment


  if (child.type === _react["default"].Fragment) {
    return list.concat(_react["default"].Children.toArray(child.props.children).reduce(function (fragmentList, fragmentChild) {
      if (typeof fragmentChild === 'string' || typeof fragmentChild === 'number') {
        return fragmentList;
      }

      return fragmentList.concat(fragmentChild);
    }, []));
  }

  return list.concat(child);
}

var METATYPES = ['name', 'httpEquiv', 'charSet', 'itemProp'];
/*
 returns a function for filtering head child elements
 which shouldn't be duplicated, like <title/>
 Also adds support for deduplicated `key` properties
*/

function unique() {
  var keys = new Set();
  var tags = new Set();
  var metaTypes = new Set();
  var metaCategories = {};
  return function (h) {
    var isUnique = true;
    var hasKey = false;

    if (h.key && typeof h.key !== 'number' && h.key.indexOf('$') > 0) {
      hasKey = true;
      var key = h.key.slice(h.key.indexOf('$') + 1);

      if (keys.has(key)) {
        isUnique = false;
      } else {
        keys.add(key);
      }
    } // eslint-disable-next-line default-case


    switch (h.type) {
      case 'title':
      case 'base':
        if (tags.has(h.type)) {
          isUnique = false;
        } else {
          tags.add(h.type);
        }

        break;

      case 'meta':
        for (var i = 0, len = METATYPES.length; i < len; i++) {
          var metatype = METATYPES[i];
          if (!h.props.hasOwnProperty(metatype)) continue;

          if (metatype === 'charSet') {
            if (metaTypes.has(metatype)) {
              isUnique = false;
            } else {
              metaTypes.add(metatype);
            }
          } else {
            var category = h.props[metatype];
            var categories = metaCategories[metatype] || new Set();

            if ((metatype !== 'name' || !hasKey) && categories.has(category)) {
              isUnique = false;
            } else {
              categories.add(category);
              metaCategories[metatype] = categories;
            }
          }
        }

        break;
    }

    return isUnique;
  };
}
/**
 *
 * @param headChildrenElements List of children of <Head>
 */


function reduceComponents(headChildrenElements, props) {
  var inAmpMode = props.inAmpMode;
  return headChildrenElements.reduce(onlyReactElement, []).reverse().concat(defaultHead(inAmpMode).reverse()).filter(unique()).reverse().map(function (c, i) {
    var key = c.key || i;

    if ( true && !inAmpMode) {
      if (c.type === 'link' && c.props['href'] && // TODO(prateekbh@): Replace this with const from `constants` when the tree shaking works.
      ['https://fonts.googleapis.com/css', 'https://use.typekit.net/'].some(function (url) {
        return c.props['href'].startsWith(url);
      })) {
        var newProps = _extends({}, c.props || {});

        newProps['data-href'] = newProps['href'];
        newProps['href'] = undefined; // Add this attribute to make it easy to identify optimized tags

        newProps['data-optimized-fonts'] = true;
        return /*#__PURE__*/_react["default"].cloneElement(c, newProps);
      }
    }

    if (false) { var srcMessage; }

    return /*#__PURE__*/_react["default"].cloneElement(c, {
      key: key
    });
  });
}
/**
 * This component injects elements to `<head>` of your page.
 * To avoid duplicated `tags` in `<head>` you can use the `key` property, which will make sure every tag is only rendered once.
 */


function Head(_ref) {
  var children = _ref.children;
  var ampState = (0, _react).useContext(_ampContext.AmpStateContext);
  var headManager = (0, _react).useContext(_headManagerContext.HeadManagerContext);
  return /*#__PURE__*/_react["default"].createElement(_sideEffect["default"], {
    reduceComponentsToState: reduceComponents,
    headManager: headManager,
    inAmpMode: (0, _ampMode).isInAmpMode(ampState)
  }, children);
}

var _default = Head;
exports["default"] = _default;

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 11585:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = SideEffect;

var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);

var _react = _interop_require_wildcard(__webpack_require__(67294));

function SideEffect(props) {
  var headManager = props.headManager,
      reduceComponentsToState = props.reduceComponentsToState;

  function emitChange() {
    if (headManager && headManager.mountedInstances) {
      var headElements = _react.Children.toArray(Array.from(headManager.mountedInstances).filter(Boolean));

      headManager.updateHead(reduceComponentsToState(headElements, props));
    }
  }

  if (isServer) {
    var ref;
    headManager == null ? void 0 : (ref = headManager.mountedInstances) == null ? void 0 : ref.add(props.children);
    emitChange();
  }

  useClientOnlyLayoutEffect(function () {
    var ref1;
    headManager == null ? void 0 : (ref1 = headManager.mountedInstances) == null ? void 0 : ref1.add(props.children);
    return function () {
      var ref;
      headManager == null ? void 0 : (ref = headManager.mountedInstances) == null ? void 0 : ref["delete"](props.children);
    };
  }); // We need to call `updateHead` method whenever the `SideEffect` is trigger in all
  // life-cycles: mount, update, unmount. However, if there are multiple `SideEffect`s
  // being rendered, we only trigger the method from the last one.
  // This is ensured by keeping the last unflushed `updateHead` in the `_pendingUpdate`
  // singleton in the layout effect pass, and actually trigger it in the effect pass.

  useClientOnlyLayoutEffect(function () {
    if (headManager) {
      headManager._pendingUpdate = emitChange;
    }

    return function () {
      if (headManager) {
        headManager._pendingUpdate = emitChange;
      }
    };
  });
  useClientOnlyEffect(function () {
    if (headManager && headManager._pendingUpdate) {
      headManager._pendingUpdate();

      headManager._pendingUpdate = null;
    }

    return function () {
      if (headManager && headManager._pendingUpdate) {
        headManager._pendingUpdate();

        headManager._pendingUpdate = null;
      }
    };
  });
  return null;
}

var isServer = false;
var useClientOnlyLayoutEffect = isServer ? function () {} : _react.useLayoutEffect;
var useClientOnlyEffect = isServer ? function () {} : _react.useEffect;

/***/ }),

/***/ 76129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ fetcher; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50029);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56264);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(humps__WEBPACK_IMPORTED_MODULE_1__);



var fetcher = /*#__PURE__*/function () {
  var _ref = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(url) {
    var res, json;
    return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch(url);

          case 2:
            res = _context.sent;
            _context.next = 5;
            return res.json();

          case 5:
            json = _context.sent;
            return _context.abrupt("return", (0,humps__WEBPACK_IMPORTED_MODULE_1__.camelizeKeys)(json));

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetcher(_x) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),

/***/ 11399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LQ": function() { return /* binding */ shareKakao; },
/* harmony export */   "cW": function() { return /* binding */ ANDROID_VERSION_ERROR_NAME; }
/* harmony export */ });
/* unused harmony export fetchKakaoAPI */
/* harmony import */ var common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24911);
/* harmony import */ var _utils_OSVersion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14063);


var KAKAO_API_SRC = '//developers.kakao.com/sdk/js/kakao.min.js';
var KAKAO_AUTH_TOKEN = "3019c756ec77dd7e0a24e56d9d784f77";
var ANDROID_VERSION_ERROR_NAME = 'Android Version Error';

var isKakaoShareVersionOkay = function isKakaoShareVersionOkay(current) {
  var versionArr = current.split('.');
  var targetVersionArr = common__WEBPACK_IMPORTED_MODULE_0__/* .ANDROID_KAKAO_SHARE_VERSION.split */ .Cl.split('.');
  if (versionArr.length !== targetVersionArr.length) return false;

  for (var i = 0; i < versionArr.length; i++) {
    var version = Number(versionArr[i]);
    var targetVersion = Number(targetVersionArr[i]);
    if (isNaN(version) || isNaN(targetVersion)) return false;
    if (version > targetVersion) return true;
  }

  return current === common__WEBPACK_IMPORTED_MODULE_0__/* .ANDROID_KAKAO_SHARE_VERSION */ .Cl;
};

var shareKakao = function shareKakao(_ref) {
  var templateId = _ref.templateId,
      templateArgs = _ref.templateArgs,
      onFail = _ref.onFail;
  fetchKakaoAPI().then(function () {
    var osInfo = (0,_utils_OSVersion__WEBPACK_IMPORTED_MODULE_1__/* .getAppOsInfo */ .Z)();
    var isAndroidOldVersion = osInfo.osType === 'Android' && !isKakaoShareVersionOkay(osInfo.osVersion);

    if (isAndroidOldVersion) {
      var versionError = new Error('Android version Error');
      versionError.name = ANDROID_VERSION_ERROR_NAME;
      throw versionError;
    }

    Kakao.Link.sendCustom({
      templateId: templateId,
      templateArgs: templateArgs
    });
  })["catch"](function (error) {
    onFail(error);
  });
};
var kakaoAPILoading = null;
var initialized = false;
var fetchKakaoAPI = function fetchKakaoAPI() {
  if (window.Kakao != null) {
    if (!initialized) {
      try {
        Kakao.init(KAKAO_AUTH_TOKEN);
      } catch (e) {//
      }

      initialized = true;
    }

    return Promise.resolve(window.Kakao);
  } else if (kakaoAPILoading != null) {
    return kakaoAPILoading;
  }

  kakaoAPILoading = new Promise(function (resolve) {
    // Load the script from daum...
    var script = document.createElement('script');
    script.addEventListener('load', function () {
      var _ref2 = window,
          Kakao = _ref2.Kakao;
      Kakao.init(KAKAO_AUTH_TOKEN);
      initialized = true;
      resolve(Kakao);
    });
    script.src = KAKAO_API_SRC;
    document.body.appendChild(script);
  });
  return kakaoAPILoading;
};

/***/ }),

/***/ 24911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Cl": function() { return /* reexport */ ANDROID_KAKAO_SHARE_VERSION; },
  "Ro": function() { return /* reexport */ CONTENT_HOST; },
  "hE": function() { return /* reexport */ EVENT_HOST; },
  "al": function() { return /* reexport */ O2O_HOST; },
  "K2": function() { return /* reexport */ OHS_HOST; },
  "s2": function() { return /* reexport */ ONE_DAY; },
  "dV": function() { return /* reexport */ ONE_HOUR; },
  "yR": function() { return /* reexport */ ONE_MINUTE; },
  "WT": function() { return /* reexport */ ONE_SECOND; },
  "df": function() { return /* reexport */ PARTNERS_HOST; },
  "Xt": function() { return /* reexport */ PRO_HOST; },
  "pN": function() { return /* reexport */ REDIRECT_PATH; },
  "O0": function() { return /* reexport */ SIGN_IN_URL; },
  "PH": function() { return /* reexport */ STORE_HOST; },
  "XK": function() { return /* reexport */ ZINDEX; }
});

// UNUSED EXPORTS: API_GATEWAY_HOST, EVENT_SELF_HOST, EVENT_SELF_PORT

;// CONCATENATED MODULE: ./src/common/url.ts
var EVENT_SELF_PORT =  false ? 0 : '';
var OHS_HOST = "https://ohou.se" || 0;
var EVENT_HOST = "https://events.ohou.se" || 0;
var STORE_HOST = "https://store.ohou.se" || 0;
var O2O_HOST = "https://o2o.ohou.se" || 0;
var PRO_HOST = "https://pro.ohou.se" || 0;
var CONTENT_HOST = "https://contents.ohou.se" || 0;
var PARTNERS_HOST = 'https://partners.ohou.se';
var EVENT_SELF_HOST =  false ? 0 // in production, we need to use localhost as a host to prevent long network hops
: "http://localhost".concat(EVENT_SELF_PORT !== '' ? ":".concat(EVENT_SELF_PORT) : '');
var API_GATEWAY_HOST = (/* unused pure expression or super */ null && ("https://api.ohou.se" || 0));
var SIGN_IN_URL = "".concat(OHS_HOST, "/users/sign_in?redirect_to=/events");
;// CONCATENATED MODULE: ./src/common/constants.ts
var ANDROID_KAKAO_SHARE_VERSION = '9.64.1';
var REDIRECT_PATH = '/promotions/o-season-week';
var ONE_SECOND = 1000;
var ONE_MINUTE = 60 * ONE_SECOND;
var ONE_HOUR = 60 * ONE_MINUTE;
var ONE_DAY = 24 * ONE_HOUR;
var ZINDEX = {
  TAB: 100,
  MODAL: 1300
};
;// CONCATENATED MODULE: ./src/common/index.ts



/***/ }),

/***/ 35507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ Error; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7329);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41149);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24911);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);







var Error = function Error(_ref) {
  var statusCode = _ref.statusCode;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(Container, {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Title, {
      children: statusCode || 'ERROR'
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(SubTitle, {
      children: "\uC8C4\uC1A1\uD569\uB2C8\uB2E4. \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4."
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(Content, {
      children: ["\uC694\uCCAD\uD558\uC2E0 \uD398\uC774\uC9C0\uB97C \uCC98\uB9AC\uD558\uB294 \uB3C4\uC911 \uC608\uAE30\uCE58 \uBABB\uD55C \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4.", (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("br", {}), "\uC11C\uBE44\uC2A4 \uC774\uC6A9\uC5D0 \uBD88\uD3B8\uC744 \uB4DC\uB824 \uB300\uB2E8\uD788 \uC8C4\uC1A1\uD569\uB2C8\uB2E4. \uCD5C\uB300\uD55C \uBE68\uB9AC \uBB38\uC81C\uB97C \uD574\uACB0\uD558\uB3C4\uB85D \uD558\uACA0\uC2B5\uB2C8\uB2E4."]
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
      href: _common__WEBPACK_IMPORTED_MODULE_3__/* .EVENT_HOST */ .hE,
      passHref: true,
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Anchor, {
        children: "\uC774\uBCA4\uD2B8 \uD648\uC73C\uB85C \uB3CC\uC544\uAC00\uAE30"
      })
    })]
  });
};

var Container = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__["default"])("div",  true ? {
  target: "ec7l3nb4"
} : 0)("text-align:center;padding:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q1c)(40), ";", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__/* .MEDIA_QUERY.max */ .PrW.max('mobile', "\n    padding: ".concat((0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q1c)(20), ";\n  ")), ";" + ( true ? "" : 0));

var Title = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__["default"])("h1",  true ? {
  target: "ec7l3nb3"
} : 0)("color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.content.primary1.basic;
}, ";font-size:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q1c)(100), ";font-weight:600;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__/* .MEDIA_QUERY.max */ .PrW.max('mobile', "\n    font-size: ".concat((0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q1c)(70), ";\n  ")), ";" + ( true ? "" : 0));

var SubTitle = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__["default"])("h2",  true ? {
  target: "ec7l3nb2"
} : 0)("font-size:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q1c)(24), ";font-weight:400;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__/* .MEDIA_QUERY.max */ .PrW.max('mobile', "\n    font-size: ".concat((0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q1c)(16), ";\n  ")), ";" + ( true ? "" : 0));

var Content = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__["default"])("p",  true ? {
  target: "ec7l3nb1"
} : 0)("font-size:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q1c)(16), ";margin:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q1c)(30), " 0;", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__/* .MEDIA_QUERY.max */ .PrW.max('mobile', "\n    font-size: ".concat((0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q1c)(14), ";\n  ")), ";" + ( true ? "" : 0));

var Anchor = (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__["default"])("a",  true ? {
  target: "ec7l3nb0"
} : 0)("display:flex;align-items:center;justify-content:center;margin:0 auto;background-color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.content.primary1.basic;
}, ";width:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q1c)(200), ";height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q1c)(50), ";border-radius:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q1c)(10), ";color:#FFFFFF;font-size:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q1c)(18), ";line-height:", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q1c)(27), ";cursor:pointer;box-shadow:0 ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q1c)(5), " ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q1c)(5), " 0 rgb(0 0 0 / 20%);&:hover{transform:translate(0, ", (0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q1c)(5), ");box-shadow:none;}", _bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__/* .MEDIA_QUERY.max */ .PrW.max('mobile', "\n    width: ".concat((0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q1c)(150), ";\n    height: ").concat((0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q1c)(38), ";\n    border-radius: ").concat((0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q1c)(7), ";\n    font-size: ").concat((0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q1c)(14), ";\n    line-height: ").concat((0,_bucketplace_design_system__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q1c)(21), ";\n  ")), ";" + ( true ? "" : 0));

/***/ }),

/***/ 59989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X_": function() { return /* reexport */ CONTENTS_EXPERIMENT_TYPE; },
  "Ar": function() { return /* reexport */ Layout; },
  "Xg": function() { return /* reexport */ PageLayout; },
  "jf": function() { return /* reexport */ SuperLink; }
});

// UNUSED EXPORTS: CONTENTS_EXPERIMENT_KEY, DefaultHead, FooterContainer, Header, HeaderContainer

// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 2 modules
var emotion_styled_base_browser_esm = __webpack_require__(7329);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@bucketplace/design-system/dist/index.js
var dist = __webpack_require__(41149);
// EXTERNAL MODULE: ./src/common/index.ts + 2 modules
var common = __webpack_require__(24911);
// EXTERNAL MODULE: ./src/utils/index.ts + 7 modules
var utils = __webpack_require__(90130);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./src/components/Layout/FooterContainer.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var FooterContainer = function FooterContainer(_ref) {
  var footerRef = _ref.footerRef;
  if ((0,utils/* isInApp */.Z0)()) return null;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container, {
    ref: footerRef,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* OhouseFooter */.wbw, {
      ohouseFooterLinks: (0,dist/* createOhouseFooterLinkSchema */.xd5)({
        ohs: common/* OHS_HOST */.K2,
        pro: common/* PRO_HOST */.Xt
      })
    })
  });
};

var Container = (0,emotion_styled_base_browser_esm["default"])("div",  true ? {
  target: "e1weh65o0"
} : 0)( true ? {
  name: "1lzs13d",
  styles: "position:absolute;bottom:0;width:100%"
} : 0);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/provider/index.ts + 5 modules
var provider = __webpack_require__(52437);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/Link/SuperLink.tsx


var _excluded = ["href", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var SuperLink = function SuperLink(_ref) {
  var href = _ref.href,
      children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
    href: href || '',
    passHref: true,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", _objectSpread(_objectSpread({
      href: href
    }, props), {}, {
      children: children
    }))
  });
};
;// CONCATENATED MODULE: ./src/components/Layout/Header.tsx


function Header_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Header_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Header_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Header_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var Header = function Header(_ref) {
  var navigationMenu = _ref.navigationMenu,
      experiments = _ref.experiments;

  var _useUserContext = (0,provider/* useUserContext */.SE)(),
      userInfo = _useUserContext.userInfo,
      pcBanner = _useUserContext.pcBanner,
      signOut = _useUserContext.signOut;

  var router = (0,next_router.useRouter)();
  var pathname = router.pathname,
      query = router.query;
  var search = "?".concat((0,utils/* getQueryString */.Wz)(query));
  var navigationProps = (0,utils/* getNavigationProps */.gk)({
    navigationMenu: navigationMenu,
    router: router,
    userInfo: userInfo,
    signOut: signOut,
    experiments: experiments
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [pcBanner && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* NavigationTopBanner */.ZiW, {
      location: {
        pathname: pathname,
        search: search
      },
      pcContentList: pcBanner,
      linkComponent: SuperLink,
      onAppOpen: utils/* handleOpenApp */.Qe,
      onLog: utils/* handleLog */.mT,
      isUserLoggedIn: !!userInfo.user
    }), !(0,utils/* isInApp */.Z0)() && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Navigation */.W_F, Header_objectSpread({}, navigationProps))]
  });
};
// EXTERNAL MODULE: ./node_modules/@bucketplace/xpc-sdk/dist/index.js
var xpc_sdk_dist = __webpack_require__(16675);
// EXTERNAL MODULE: ./src/hooks/Navigation/index.ts + 5 modules
var Navigation = __webpack_require__(39411);
;// CONCATENATED MODULE: ./src/components/Layout/HeaderContainer.tsx






var CONTENTS_EXPERIMENT_KEY = 641;
var CONTENTS_EXPERIMENT_TYPE = {
  LEGACY: 'A',
  NEW: 'B'
};
var HeaderContainer = function HeaderContainer() {
  var router = (0,next_router.useRouter)();

  var _useExperimentType = (0,xpc_sdk_dist/* useExperimentType */.XB)({
    experimentKey: CONTENTS_EXPERIMENT_KEY,
    type: 'AB'
  }),
      _useExperimentType$ex = _useExperimentType.experimentType,
      contentsRenewalExperimentType = _useExperimentType$ex === void 0 ? CONTENTS_EXPERIMENT_TYPE.LEGACY : _useExperimentType$ex;

  var experiments = {
    contents: contentsRenewalExperimentType
  };

  var _useNavigationMenu = (0,Navigation/* useNavigationMenu */.N1)(router.pathname, experiments),
      navigationMenu = _useNavigationMenu.data,
      error = _useNavigationMenu.error;

  if (error || !navigationMenu) return null;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header, {
    navigationMenu: navigationMenu,
    experiments: experiments
  });
};
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./src/utils/Navigation/index.ts + 8 modules
var utils_Navigation = __webpack_require__(89897);
;// CONCATENATED MODULE: ./src/components/Layout/DefaultHead.tsx




var DefaultHead = /*#__PURE__*/(0,react.memo)(function () {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
      children: "\uC624\uB298\uC758\uC9D1 \uC774\uBCA4\uD2B8"
    }, "head-title"), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
      charSet: "utf-8",
      lang: "ko"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
      name: "naver-site-verification",
      content: "6ca7ff6f5a2c14babde6ac5aec0171afa0b76049"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
      name: "viewport",
      content: "width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0,viewport-fit=cover"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
      rel: "icon",
      href: "/favicon.ico"
    })]
  });
});
;// CONCATENATED MODULE: ./src/components/Layout/Layout.tsx









var Layout = function Layout(_ref) {
  var children = _ref.children;

  var _useUserContext = (0,provider/* useUserContext */.SE)(),
      userInfo = _useUserContext.userInfo;

  var isClientSide = true;
  (0,react.useEffect)(function () {
    if (!isClientSide || !userInfo) return;
    (0,utils_Navigation/* runMarketingHeaderScript */.Ht)(userInfo === null || userInfo === void 0 ? void 0 : userInfo.user);
    (0,utils_Navigation/* runMarketingFooterScript */.d4)(userInfo === null || userInfo === void 0 ? void 0 : userInfo.user);
  }, [userInfo, isClientSide]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultHead, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((head_default()), {
      children: (0,utils_Navigation/* getMarketingHeaderScript */.JM)(userInfo)
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((script_default()), {
      type: "application/ld+json",
      children: {
        '@context': 'http://schema.org',
        '@type': 'Organization',
        'name': '오늘의집',
        'url': 'https://ohou.se',
        'sameAs': ['https://www.instagram.com/todayhouse/?hl=ko', 'https://www.facebook.com/interiortoday', 'https://m.post.naver.com/my.nhn?memberNo=202156', 'https://itunes.apple.com/kr/app/id1008236892', 'https://play.google.com/store/apps/details?id=net.bucketplace&hl=ko', 'https://www.youtube.com/channel/UCBKtitA1RwY7F32rCniV1dA/featured']
      }
    }, "json-script"), children, (0,utils_Navigation/* getMarketingFooterScript */.hA)()]
  });
};
;// CONCATENATED MODULE: ./node_modules/clsx/dist/clsx.m.js
function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

/* harmony default export */ function clsx_m() {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x
			}
		}
	}
	return str;
}

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js




function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function isNum(v) {
  return typeof v === 'number' && !isNaN(v);
}
function isBool(v) {
  return typeof v === 'boolean';
}
function isStr(v) {
  return typeof v === 'string';
}
function isFn(v) {
  return typeof v === 'function';
}
function parseClassName(v) {
  return isStr(v) || isFn(v) ? v : null;
}
function isToastIdValid(toastId) {
  return toastId === 0 || toastId;
}
function getAutoCloseDelay(toastAutoClose, containerAutoClose) {
  return toastAutoClose === false || isNum(toastAutoClose) && toastAutoClose > 0 ? toastAutoClose : containerAutoClose;
}
var canUseDom = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function canBeRendered(content) {
  return (0,react.isValidElement)(content) || isStr(content) || isFn(content) || isNum(content);
}

var POSITION = {
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
  TOP_CENTER: 'top-center',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right',
  BOTTOM_CENTER: 'bottom-center'
};
var TYPE = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  DEFAULT: 'default',
  DARK: 'dark'
};

/**
 * Used to collapse toast after exit animation
 */
function collapseToast(node, done, duration
/* COLLAPSE_DURATION */
) {
  if (duration === void 0) {
    duration = 300;
  }

  var height = node.scrollHeight;
  var style = node.style;
  requestAnimationFrame(function () {
    style.minHeight = 'initial';
    style.height = height + 'px';
    style.transition = "all " + duration + "ms";
    requestAnimationFrame(function () {
      style.height = '0';
      style.padding = '0';
      style.margin = '0';
      setTimeout(done, duration);
    });
  });
}

/**
 * Css animation that just work.
 * You could use animate.css for instance
 *
 *
 * ```
 * cssTransition({
 *   enter: "animate__animated animate__bounceIn",
 *   exit: "animate__animated animate__bounceOut"
 * })
 * ```
 *
 */

function cssTransition(_ref) {
  var enter = _ref.enter,
      exit = _ref.exit,
      _ref$appendPosition = _ref.appendPosition,
      appendPosition = _ref$appendPosition === void 0 ? false : _ref$appendPosition,
      _ref$collapse = _ref.collapse,
      collapse = _ref$collapse === void 0 ? true : _ref$collapse,
      _ref$collapseDuration = _ref.collapseDuration,
      collapseDuration = _ref$collapseDuration === void 0 ? 300 : _ref$collapseDuration;
  return function ToastTransition(_ref2) {
    var children = _ref2.children,
        position = _ref2.position,
        preventExitTransition = _ref2.preventExitTransition,
        done = _ref2.done,
        nodeRef = _ref2.nodeRef,
        isIn = _ref2.isIn;
    var enterClassName = appendPosition ? enter + "--" + position : enter;
    var exitClassName = appendPosition ? exit + "--" + position : exit;
    var baseClassName = (0,react.useRef)();
    var animationStep = (0,react.useRef)(0
    /* Enter */
    );
    (0,react.useLayoutEffect)(function () {
      onEnter();
    }, []);
    (0,react.useEffect)(function () {
      if (!isIn) preventExitTransition ? onExited() : onExit();
    }, [isIn]);

    function onEnter() {
      var node = nodeRef.current;
      baseClassName.current = node.className;
      node.className += " " + enterClassName;
      node.addEventListener('animationend', onEntered);
    }

    function onEntered() {
      var node = nodeRef.current;
      node.removeEventListener('animationend', onEntered);

      if (animationStep.current === 0
      /* Enter */
      ) {
          node.className = baseClassName.current;
        }
    }

    function onExit() {
      animationStep.current = 1
      /* Exit */
      ;
      var node = nodeRef.current;
      node.className += " " + exitClassName;
      node.addEventListener('animationend', onExited);
    }

    function onExited() {
      var node = nodeRef.current;
      node.removeEventListener('animationend', onExited);
      collapse ? collapseToast(node, done, collapseDuration) : done();
    }

    return react.createElement(react.Fragment, null, children);
  };
}

var eventManager = {
  list: /*#__PURE__*/new Map(),
  emitQueue: /*#__PURE__*/new Map(),
  on: function on(event, callback) {
    this.list.has(event) || this.list.set(event, []);
    this.list.get(event).push(callback);
    return this;
  },
  off: function off(event, callback) {
    if (callback) {
      var cb = this.list.get(event).filter(function (cb) {
        return cb !== callback;
      });
      this.list.set(event, cb);
      return this;
    }

    this.list["delete"](event);
    return this;
  },
  cancelEmit: function cancelEmit(event) {
    var timers = this.emitQueue.get(event);

    if (timers) {
      timers.forEach(clearTimeout);
      this.emitQueue["delete"](event);
    }

    return this;
  },

  /**
   * Enqueue the event at the end of the call stack
   * Doing so let the user call toast as follow:
   * toast('1')
   * toast('2')
   * toast('3')
   * Without setTimemout the code above will not work
   */
  emit: function emit(event) {
    var _this = this;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    this.list.has(event) && this.list.get(event).forEach(function (callback) {
      var timer = setTimeout(function () {
        // @ts-ignore
        callback.apply(void 0, args);
      }, 0);
      _this.emitQueue.has(event) || _this.emitQueue.set(event, []);

      _this.emitQueue.get(event).push(timer);
    });
  }
};

/**
 * `useKeeper` is a helper around `useRef`.
 *
 * You don't need to access the `.current`property to get the value
 * If refresh is set to true. The ref will be updated every render
 */

function useKeeper(arg, refresh) {
  if (refresh === void 0) {
    refresh = false;
  }

  var ref = (0,react.useRef)(arg);
  (0,react.useEffect)(function () {
    if (refresh) ref.current = arg;
  });
  return ref.current;
}

function reducer(state, action) {
  switch (action.type) {
    case 0
    /* ADD */
    :
      return [].concat(state, [action.toastId]).filter(function (id) {
        return id !== action.staleId;
      });

    case 1
    /* REMOVE */
    :
      return isToastIdValid(action.toastId) ? state.filter(function (id) {
        return id !== action.toastId;
      }) : [];
  }
}

function useToastContainer(props) {
  var _useReducer = (0,react.useReducer)(function (x) {
    return x + 1;
  }, 0),
      forceUpdate = _useReducer[1];

  var _useReducer2 = (0,react.useReducer)(reducer, []),
      toast = _useReducer2[0],
      dispatch = _useReducer2[1];

  var containerRef = (0,react.useRef)(null);
  var toastCount = useKeeper(0);
  var queue = useKeeper([]);
  var collection = useKeeper({});
  var instance = useKeeper({
    toastKey: 1,
    displayedToast: 0,
    props: props,
    containerId: null,
    isToastActive: isToastActive,
    getToast: function getToast(id) {
      return collection[id] || null;
    }
  });
  (0,react.useEffect)(function () {
    instance.containerId = props.containerId;
    eventManager.cancelEmit(3
    /* WillUnmount */
    ).on(0
    /* Show */
    , buildToast).on(1
    /* Clear */
    , function (toastId) {
      return containerRef.current && removeToast(toastId);
    }).on(5
    /* ClearWaitingQueue */
    , clearWaitingQueue).emit(2
    /* DidMount */
    , instance);
    return function () {
      return eventManager.emit(3
      /* WillUnmount */
      , instance);
    };
  }, []);
  (0,react.useEffect)(function () {
    instance.isToastActive = isToastActive;
    instance.displayedToast = toast.length;
    eventManager.emit(4
    /* Change */
    , toast.length, props.containerId);
  }, [toast]);
  (0,react.useEffect)(function () {
    instance.props = props;
  });

  function isToastActive(id) {
    return toast.indexOf(id) !== -1;
  }

  function clearWaitingQueue(_ref) {
    var containerId = _ref.containerId;
    var limit = instance.props.limit;

    if (limit && (!containerId || instance.containerId === containerId)) {
      toastCount -= queue.length;
      queue = [];
    }
  }

  function removeToast(toastId) {
    dispatch({
      type: 1
      /* REMOVE */
      ,
      toastId: toastId
    });
  }

  function dequeueToast() {
    var _queue$shift = queue.shift(),
        toastContent = _queue$shift.toastContent,
        toastProps = _queue$shift.toastProps,
        staleId = _queue$shift.staleId;

    appendToast(toastContent, toastProps, staleId);
  }
  /**
   * check if a container is attached to the dom
   * check for multi-container, build only if associated
   * check for duplicate toastId if no update
   */


  function isNotValid(_ref2) {
    var containerId = _ref2.containerId,
        toastId = _ref2.toastId,
        updateId = _ref2.updateId;
    return !containerRef.current || instance.props.enableMultiContainer && containerId !== instance.props.containerId || collection[toastId] && updateId == null ? true : false;
  } // this function and all the function called inside needs to rely on ref(`useKeeper`)


  function buildToast(content, _ref3) {
    var delay = _ref3.delay,
        staleId = _ref3.staleId,
        options = _objectWithoutPropertiesLoose(_ref3, ["delay", "staleId"]);

    if (!canBeRendered(content) || isNotValid(options)) return;
    var toastId = options.toastId,
        updateId = options.updateId;
    var props = instance.props;

    var closeToast = function closeToast() {
      return removeToast(toastId);
    };

    var isNotAnUpdate = options.updateId == null;
    if (isNotAnUpdate) toastCount++;
    var toastProps = {
      toastId: toastId,
      updateId: updateId,
      isIn: false,
      key: options.key || instance.toastKey++,
      type: options.type,
      closeToast: closeToast,
      closeButton: options.closeButton,
      rtl: props.rtl,
      position: options.position || props.position,
      transition: options.transition || props.transition,
      className: parseClassName(options.className || props.toastClassName),
      bodyClassName: parseClassName(options.bodyClassName || props.bodyClassName),
      style: options.style || props.toastStyle,
      bodyStyle: options.bodyStyle || props.bodyStyle,
      onClick: options.onClick || props.onClick,
      pauseOnHover: isBool(options.pauseOnHover) ? options.pauseOnHover : props.pauseOnHover,
      pauseOnFocusLoss: isBool(options.pauseOnFocusLoss) ? options.pauseOnFocusLoss : props.pauseOnFocusLoss,
      draggable: isBool(options.draggable) ? options.draggable : props.draggable,
      draggablePercent: isNum(options.draggablePercent) ? options.draggablePercent : props.draggablePercent,
      draggableDirection: options.draggableDirection || props.draggableDirection,
      closeOnClick: isBool(options.closeOnClick) ? options.closeOnClick : props.closeOnClick,
      progressClassName: parseClassName(options.progressClassName || props.progressClassName),
      progressStyle: options.progressStyle || props.progressStyle,
      autoClose: getAutoCloseDelay(options.autoClose, props.autoClose),
      hideProgressBar: isBool(options.hideProgressBar) ? options.hideProgressBar : props.hideProgressBar,
      progress: options.progress,
      role: isStr(options.role) ? options.role : props.role,
      deleteToast: function deleteToast() {
        removeFromCollection(toastId);
      }
    };
    if (isFn(options.onOpen)) toastProps.onOpen = options.onOpen;
    if (isFn(options.onClose)) toastProps.onClose = options.onClose; //  tweak for vertical dragging

    if (toastProps.draggableDirection === "y"
    /* Y */
    && toastProps.draggablePercent === 80
    /* DRAGGABLE_PERCENT */
    ) {
        toastProps.draggablePercent *= 1.5;
      }

    var closeButton = props.closeButton;

    if (options.closeButton === false || canBeRendered(options.closeButton)) {
      closeButton = options.closeButton;
    } else if (options.closeButton === true) {
      closeButton = canBeRendered(props.closeButton) ? props.closeButton : true;
    }

    toastProps.closeButton = closeButton;
    var toastContent = content;

    if ((0,react.isValidElement)(content) && !isStr(content.type)) {
      toastContent = (0,react.cloneElement)(content, {
        closeToast: closeToast,
        toastProps: toastProps
      });
    } else if (isFn(content)) {
      toastContent = content({
        closeToast: closeToast,
        toastProps: toastProps
      });
    } // not handling limit + delay by design. Waiting for user feedback first


    if (props.limit && props.limit > 0 && toastCount > props.limit && isNotAnUpdate) {
      queue.push({
        toastContent: toastContent,
        toastProps: toastProps,
        staleId: staleId
      });
    } else if (isNum(delay) && delay > 0) {
      setTimeout(function () {
        appendToast(toastContent, toastProps, staleId);
      }, delay);
    } else {
      appendToast(toastContent, toastProps, staleId);
    }
  }

  function appendToast(content, toastProps, staleId) {
    var toastId = toastProps.toastId;
    if (staleId) delete collection[staleId];
    collection[toastId] = {
      content: content,
      props: toastProps
    };
    dispatch({
      type: 0
      /* ADD */
      ,
      toastId: toastId,
      staleId: staleId
    });
  }

  function removeFromCollection(toastId) {
    delete collection[toastId];
    var queueLen = queue.length;
    toastCount = isToastIdValid(toastId) ? toastCount - 1 : toastCount - instance.displayedToast;
    if (toastCount < 0) toastCount = 0;

    if (queueLen > 0) {
      var freeSlot = isToastIdValid(toastId) ? 1 : instance.props.limit;

      if (queueLen === 1 || freeSlot === 1) {
        instance.displayedToast++;
        dequeueToast();
      } else {
        var toDequeue = freeSlot > queueLen ? queueLen : freeSlot;
        instance.displayedToast = toDequeue;

        for (var i = 0; i < toDequeue; i++) {
          dequeueToast();
        }
      }
    } else {
      forceUpdate();
    }
  }

  function getToastToRender(cb) {
    var toastToRender = {};
    var toastList = props.newestOnTop ? Object.keys(collection).reverse() : Object.keys(collection);

    for (var i = 0; i < toastList.length; i++) {
      var _toast = collection[toastList[i]];
      var position = _toast.props.position;
      toastToRender[position] || (toastToRender[position] = []);
      toastToRender[position].push(_toast);
    }

    return Object.keys(toastToRender).map(function (p) {
      return cb(p, toastToRender[p]);
    });
  }

  return {
    getToastToRender: getToastToRender,
    collection: collection,
    containerRef: containerRef,
    isToastActive: isToastActive
  };
}

function getX(e) {
  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientX : e.clientX;
}

function getY(e) {
  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientY : e.clientY;
}

function useToast(props) {
  var _useState = (0,react.useState)(true),
      isRunning = _useState[0],
      setIsRunning = _useState[1];

  var _useState2 = (0,react.useState)(false),
      preventExitTransition = _useState2[0],
      setPreventExitTransition = _useState2[1];

  var toastRef = (0,react.useRef)(null);
  var drag = useKeeper({
    start: 0,
    x: 0,
    y: 0,
    delta: 0,
    removalDistance: 0,
    canCloseOnClick: true,
    canDrag: false,
    boundingRect: null
  });
  var syncProps = useKeeper(props, true);
  var autoClose = props.autoClose,
      pauseOnHover = props.pauseOnHover,
      closeToast = props.closeToast,
      onClick = props.onClick,
      closeOnClick = props.closeOnClick;
  (0,react.useEffect)(function () {
    if (isFn(props.onOpen)) props.onOpen((0,react.isValidElement)(props.children) && props.children.props);
    return function () {
      if (isFn(syncProps.onClose)) syncProps.onClose((0,react.isValidElement)(syncProps.children) && syncProps.children.props);
    };
  }, []);
  (0,react.useEffect)(function () {
    props.draggable && bindDragEvents();
    return function () {
      props.draggable && unbindDragEvents();
    };
  }, [props.draggable]);
  (0,react.useEffect)(function () {
    props.pauseOnFocusLoss && bindFocusEvents();
    return function () {
      props.pauseOnFocusLoss && unbindFocusEvents();
    };
  }, [props.pauseOnFocusLoss]);

  function onDragStart(e) {
    if (props.draggable) {
      var toast = toastRef.current;
      drag.canCloseOnClick = true;
      drag.canDrag = true;
      drag.boundingRect = toast.getBoundingClientRect();
      toast.style.transition = '';
      drag.x = getX(e.nativeEvent);
      drag.y = getY(e.nativeEvent);

      if (props.draggableDirection === "x"
      /* X */
      ) {
          drag.start = drag.x;
          drag.removalDistance = toast.offsetWidth * (props.draggablePercent / 100);
        } else {
        drag.start = drag.y;
        drag.removalDistance = toast.offsetHeight * (props.draggablePercent / 100);
      }
    }
  }

  function onDragTransitionEnd() {
    if (drag.boundingRect) {
      var _drag$boundingRect = drag.boundingRect,
          top = _drag$boundingRect.top,
          bottom = _drag$boundingRect.bottom,
          left = _drag$boundingRect.left,
          right = _drag$boundingRect.right;

      if (props.pauseOnHover && drag.x >= left && drag.x <= right && drag.y >= top && drag.y <= bottom) {
        pauseToast();
      } else {
        playToast();
      }
    }
  }

  function playToast() {
    setIsRunning(true);
  }

  function pauseToast() {
    setIsRunning(false);
  }

  function bindFocusEvents() {
    if (!document.hasFocus()) pauseToast();
    window.addEventListener('focus', playToast);
    window.addEventListener('blur', pauseToast);
  }

  function unbindFocusEvents() {
    window.removeEventListener('focus', playToast);
    window.removeEventListener('blur', pauseToast);
  }

  function bindDragEvents() {
    document.addEventListener('mousemove', onDragMove);
    document.addEventListener('mouseup', onDragEnd);
    document.addEventListener('touchmove', onDragMove);
    document.addEventListener('touchend', onDragEnd);
  }

  function unbindDragEvents() {
    document.removeEventListener('mousemove', onDragMove);
    document.removeEventListener('mouseup', onDragEnd);
    document.removeEventListener('touchmove', onDragMove);
    document.removeEventListener('touchend', onDragEnd);
  }

  function onDragMove(e) {
    if (drag.canDrag) {
      e.preventDefault();
      var toast = toastRef.current;
      if (isRunning) pauseToast();
      drag.x = getX(e);
      drag.y = getY(e);

      if (props.draggableDirection === "x"
      /* X */
      ) {
          drag.delta = drag.x - drag.start;
        } else {
        drag.delta = drag.y - drag.start;
      } // prevent false positif during a toast click


      if (drag.start !== drag.x) drag.canCloseOnClick = false;
      toast.style.transform = "translate" + props.draggableDirection + "(" + drag.delta + "px)";
      toast.style.opacity = "" + (1 - Math.abs(drag.delta / drag.removalDistance));
    }
  }

  function onDragEnd() {
    var toast = toastRef.current;

    if (drag.canDrag) {
      drag.canDrag = false;

      if (Math.abs(drag.delta) > drag.removalDistance) {
        setPreventExitTransition(true);
        props.closeToast();
        return;
      }

      toast.style.transition = 'transform 0.2s, opacity 0.2s';
      toast.style.transform = "translate" + props.draggableDirection + "(0)";
      toast.style.opacity = '1';
    }
  }

  var eventHandlers = {
    onMouseDown: onDragStart,
    onTouchStart: onDragStart,
    onMouseUp: onDragTransitionEnd,
    onTouchEnd: onDragTransitionEnd
  };

  if (autoClose && pauseOnHover) {
    eventHandlers.onMouseEnter = pauseToast;
    eventHandlers.onMouseLeave = playToast;
  } // prevent toast from closing when user drags the toast


  if (closeOnClick) {
    eventHandlers.onClick = function (e) {
      onClick && onClick(e);
      drag.canCloseOnClick && closeToast();
    };
  }

  return {
    playToast: playToast,
    pauseToast: pauseToast,
    isRunning: isRunning,
    preventExitTransition: preventExitTransition,
    toastRef: toastRef,
    eventHandlers: eventHandlers
  };
}

function CloseButton(_ref) {
  var closeToast = _ref.closeToast,
      type = _ref.type,
      _ref$ariaLabel = _ref.ariaLabel,
      ariaLabel = _ref$ariaLabel === void 0 ? 'close' : _ref$ariaLabel;
  return (0,react.createElement)("button", {
    className: "Toastify"
    /* CSS_NAMESPACE */
    + "__close-button " + "Toastify"
    /* CSS_NAMESPACE */
    + "__close-button--" + type,
    type: "button",
    onClick: function onClick(e) {
      e.stopPropagation();
      closeToast(e);
    },
    "aria-label": ariaLabel
  }, (0,react.createElement)("svg", {
    "aria-hidden": "true",
    viewBox: "0 0 14 16"
  }, (0,react.createElement)("path", {
    fillRule: "evenodd",
    d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
  })));
}

function ProgressBar(_ref) {
  var _cx, _animationEvent;

  var delay = _ref.delay,
      isRunning = _ref.isRunning,
      closeToast = _ref.closeToast,
      type = _ref.type,
      hide = _ref.hide,
      className = _ref.className,
      userStyle = _ref.style,
      controlledProgress = _ref.controlledProgress,
      progress = _ref.progress,
      rtl = _ref.rtl,
      isIn = _ref.isIn;

  var style = _extends({}, userStyle, {
    animationDuration: delay + "ms",
    animationPlayState: isRunning ? 'running' : 'paused',
    opacity: hide ? 0 : 1
  });

  if (controlledProgress) style.transform = "scaleX(" + progress + ")";
  var defaultClassName = clsx_m("Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar", controlledProgress ? "Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar--controlled" : "Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar--animated", "Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar--" + type, (_cx = {}, _cx["Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar--rtl"] = rtl, _cx));
  var classNames = isFn(className) ? className({
    rtl: rtl,
    type: type,
    defaultClassName: defaultClassName
  }) : clsx_m(defaultClassName, className); // 🧐 controlledProgress is derived from progress
  // so if controlledProgress is set
  // it means that this is also the case for progress

  var animationEvent = (_animationEvent = {}, _animationEvent[controlledProgress && progress >= 1 ? 'onTransitionEnd' : 'onAnimationEnd'] = controlledProgress && progress < 1 ? null : function () {
    isIn && closeToast();
  }, _animationEvent); // TODO: add aria-valuenow, aria-valuemax, aria-valuemin

  return (0,react.createElement)("div", Object.assign({
    role: "progressbar",
    "aria-hidden": hide ? 'true' : 'false',
    "aria-label": "notification timer",
    className: classNames,
    style: style
  }, animationEvent));
}
ProgressBar.defaultProps = {
  type: TYPE.DEFAULT,
  hide: false
};

var Toast = function Toast(props) {
  var _cx;

  var _useToast = useToast(props),
      isRunning = _useToast.isRunning,
      preventExitTransition = _useToast.preventExitTransition,
      toastRef = _useToast.toastRef,
      eventHandlers = _useToast.eventHandlers;

  var closeButton = props.closeButton,
      children = props.children,
      autoClose = props.autoClose,
      onClick = props.onClick,
      type = props.type,
      hideProgressBar = props.hideProgressBar,
      closeToast = props.closeToast,
      Transition = props.transition,
      position = props.position,
      className = props.className,
      style = props.style,
      bodyClassName = props.bodyClassName,
      bodyStyle = props.bodyStyle,
      progressClassName = props.progressClassName,
      progressStyle = props.progressStyle,
      updateId = props.updateId,
      role = props.role,
      progress = props.progress,
      rtl = props.rtl,
      toastId = props.toastId,
      deleteToast = props.deleteToast,
      isIn = props.isIn;
  var defaultClassName = clsx_m("Toastify"
  /* CSS_NAMESPACE */
  + "__toast", "Toastify"
  /* CSS_NAMESPACE */
  + "__toast--" + type, (_cx = {}, _cx["Toastify"
  /* CSS_NAMESPACE */
  + "__toast--rtl"] = rtl, _cx));
  var cssClasses = isFn(className) ? className({
    rtl: rtl,
    position: position,
    type: type,
    defaultClassName: defaultClassName
  }) : clsx_m(defaultClassName, className);
  var isProgressControlled = !!progress;

  function renderCloseButton(closeButton) {
    if (!closeButton) return;
    var props = {
      closeToast: closeToast,
      type: type
    };
    if (isFn(closeButton)) return closeButton(props);
    if ((0,react.isValidElement)(closeButton)) return (0,react.cloneElement)(closeButton, props);
  }

  return (0,react.createElement)(Transition, {
    isIn: isIn,
    done: deleteToast,
    position: position,
    preventExitTransition: preventExitTransition,
    nodeRef: toastRef
  }, (0,react.createElement)("div", Object.assign({
    id: toastId,
    onClick: onClick,
    className: cssClasses
  }, eventHandlers, {
    style: style,
    ref: toastRef
  }), (0,react.createElement)("div", Object.assign({}, isIn && {
    role: role
  }, {
    className: isFn(bodyClassName) ? bodyClassName({
      type: type
    }) : clsx_m("Toastify"
    /* CSS_NAMESPACE */
    + "__toast-body", bodyClassName),
    style: bodyStyle
  }), children), renderCloseButton(closeButton), (autoClose || isProgressControlled) && (0,react.createElement)(ProgressBar, Object.assign({}, updateId && !isProgressControlled ? {
    key: "pb-" + updateId
  } : {}, {
    rtl: rtl,
    delay: autoClose,
    isRunning: isRunning,
    isIn: isIn,
    closeToast: closeToast,
    hide: hideProgressBar,
    type: type,
    style: progressStyle,
    className: progressClassName,
    controlledProgress: isProgressControlled,
    progress: progress
  }))));
};

var Bounce = /*#__PURE__*/cssTransition({
  enter: "Toastify"
  /* CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* CSS_NAMESPACE */
  + "__bounce-enter",
  exit: "Toastify"
  /* CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* CSS_NAMESPACE */
  + "__bounce-exit",
  appendPosition: true
});
var Slide = /*#__PURE__*/cssTransition({
  enter: "Toastify"
  /* CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* CSS_NAMESPACE */
  + "__slide-enter",
  exit: "Toastify"
  /* CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* CSS_NAMESPACE */
  + "__slide-exit",
  appendPosition: true
});
var Zoom = /*#__PURE__*/cssTransition({
  enter: "Toastify"
  /* CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* CSS_NAMESPACE */
  + "__zoom-enter",
  exit: "Toastify"
  /* CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* CSS_NAMESPACE */
  + "__zoom-exit"
});
var Flip = /*#__PURE__*/cssTransition({
  enter: "Toastify"
  /* CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* CSS_NAMESPACE */
  + "__flip-enter",
  exit: "Toastify"
  /* CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* CSS_NAMESPACE */
  + "__flip-exit"
});

var ToastContainer = function ToastContainer(props) {
  var _useToastContainer = useToastContainer(props),
      getToastToRender = _useToastContainer.getToastToRender,
      containerRef = _useToastContainer.containerRef,
      isToastActive = _useToastContainer.isToastActive;

  var className = props.className,
      style = props.style,
      rtl = props.rtl,
      containerId = props.containerId;

  function getClassName(position) {
    var _cx;

    var defaultClassName = clsx_m("Toastify"
    /* CSS_NAMESPACE */
    + "__toast-container", "Toastify"
    /* CSS_NAMESPACE */
    + "__toast-container--" + position, (_cx = {}, _cx["Toastify"
    /* CSS_NAMESPACE */
    + "__toast-container--rtl"] = rtl, _cx));
    return isFn(className) ? className({
      position: position,
      rtl: rtl,
      defaultClassName: defaultClassName
    }) : clsx_m(defaultClassName, parseClassName(className));
  }

  return (0,react.createElement)("div", {
    ref: containerRef,
    className: "Toastify"
    /* CSS_NAMESPACE */
    ,
    id: containerId
  }, getToastToRender(function (position, toastList) {
    var containerStyle = toastList.length === 0 ? _extends({}, style, {
      pointerEvents: 'none'
    }) : _extends({}, style);
    return (0,react.createElement)("div", {
      className: getClassName(position),
      style: containerStyle,
      key: "container-" + position
    }, toastList.map(function (_ref) {
      var content = _ref.content,
          toastProps = _ref.props;
      return (0,react.createElement)(Toast, Object.assign({}, toastProps, {
        isIn: isToastActive(toastProps.toastId),
        key: "toast-" + toastProps.key,
        closeButton: toastProps.closeButton === true ? CloseButton : toastProps.closeButton
      }), content);
    }));
  }));
};
ToastContainer.defaultProps = {
  position: POSITION.TOP_RIGHT,
  transition: Bounce,
  rtl: false,
  autoClose: 5000,
  hideProgressBar: false,
  closeButton: CloseButton,
  pauseOnHover: true,
  pauseOnFocusLoss: true,
  closeOnClick: true,
  newestOnTop: false,
  draggable: true,
  draggablePercent: 80
  /* DRAGGABLE_PERCENT */
  ,
  draggableDirection: "x"
  /* X */
  ,
  role: 'alert'
};

var containers = /*#__PURE__*/new Map();
var latestInstance;
var containerDomNode;
var containerConfig;
var queue = [];
var lazy = false;
/**
 * Check whether any container is currently mounted in the DOM
 */

function isAnyContainerMounted() {
  return containers.size > 0;
}
/**
 * Get the toast by id, given it's in the DOM, otherwise returns null
 */


function getToast(toastId, _ref) {
  var containerId = _ref.containerId;
  var container = containers.get(containerId || latestInstance);
  if (!container) return null;
  return container.getToast(toastId);
}
/**
 * Generate a random toastId
 */


function generateToastId() {
  return Math.random().toString(36).substr(2, 9);
}
/**
 * Generate a toastId or use the one provided
 */


function getToastId(options) {
  if (options && (isStr(options.toastId) || isNum(options.toastId))) {
    return options.toastId;
  }

  return generateToastId();
}
/**
 * If the container is not mounted, the toast is enqueued and
 * the container lazy mounted
 */


function dispatchToast(content, options) {
  if (isAnyContainerMounted()) {
    eventManager.emit(0
    /* Show */
    , content, options);
  } else {
    queue.push({
      content: content,
      options: options
    });

    if (lazy && canUseDom) {
      lazy = false;
      containerDomNode = document.createElement('div');
      document.body.appendChild(containerDomNode);
      (0,react_dom.render)((0,react.createElement)(ToastContainer, Object.assign({}, containerConfig)), containerDomNode);
    }
  }

  return options.toastId;
}
/**
 * Merge provided options with the defaults settings and generate the toastId
 */


function mergeOptions(type, options) {
  return _extends({}, options, {
    type: options && options.type || type,
    toastId: getToastId(options)
  });
}

var createToastByType = function createToastByType(type) {
  return function (content, options) {
    return dispatchToast(content, mergeOptions(type, options));
  };
};

var toast = function toast(content, options) {
  return dispatchToast(content, mergeOptions(TYPE.DEFAULT, options));
};

toast.success = /*#__PURE__*/createToastByType(TYPE.SUCCESS);
toast.info = /*#__PURE__*/createToastByType(TYPE.INFO);
toast.error = /*#__PURE__*/createToastByType(TYPE.ERROR);
toast.warning = /*#__PURE__*/createToastByType(TYPE.WARNING);
toast.dark = /*#__PURE__*/createToastByType(TYPE.DARK);
toast.warn = toast.warning;
/**
 * Remove toast programmaticaly
 */

toast.dismiss = function (id) {
  return eventManager.emit(1
  /* Clear */
  , id);
};
/**
 * Clear waiting queue when limit is used
 */


toast.clearWaitingQueue = function (params) {
  if (params === void 0) {
    params = {};
  }

  return eventManager.emit(5
  /* ClearWaitingQueue */
  , params);
};
/**
 * return true if one container is displaying the toast
 */


toast.isActive = function (id) {
  var isToastActive = false;
  containers.forEach(function (container) {
    if (container.isToastActive && container.isToastActive(id)) {
      isToastActive = true;
    }
  });
  return isToastActive;
};

toast.update = function (toastId, options) {
  if (options === void 0) {
    options = {};
  }

  // if you call toast and toast.update directly nothing will be displayed
  // this is why I defered the update
  setTimeout(function () {
    var toast = getToast(toastId, options);

    if (toast) {
      var oldOptions = toast.props,
          oldContent = toast.content;

      var nextOptions = _extends({}, oldOptions, options, {
        toastId: options.toastId || toastId,
        updateId: generateToastId()
      });

      if (nextOptions.toastId !== toastId) nextOptions.staleId = toastId;
      var content = nextOptions.render || oldContent;
      delete nextOptions.render;
      dispatchToast(content, nextOptions);
    }
  }, 0);
};
/**
 * Used for controlled progress bar.
 */


toast.done = function (id) {
  toast.update(id, {
    progress: 1
  });
};
/**
 * Track changes. The callback get the number of toast displayed
 *
 */


toast.onChange = function (callback) {
  if (isFn(callback)) {
    eventManager.on(4
    /* Change */
    , callback);
  }

  return function () {
    isFn(callback) && eventManager.off(4
    /* Change */
    , callback);
  };
};
/**
 * Configure the ToastContainer when lazy mounted
 */


toast.configure = function (config) {
  if (config === void 0) {
    config = {};
  }

  lazy = true;
  containerConfig = config;
};

toast.POSITION = POSITION;
toast.TYPE = TYPE;
/**
 * Wait until the ToastContainer is mounted to dispatch the toast
 * and attach isActive method
 */

eventManager.on(2
/* DidMount */
, function (containerInstance) {
  latestInstance = containerInstance.containerId || containerInstance;
  containers.set(latestInstance, containerInstance);
  queue.forEach(function (item) {
    eventManager.emit(0
    /* Show */
    , item.content, item.options);
  });
  queue = [];
}).on(3
/* WillUnmount */
, function (containerInstance) {
  containers["delete"](containerInstance.containerId || containerInstance);

  if (containers.size === 0) {
    eventManager.off(0
    /* Show */
    ).off(1
    /* Clear */
    ).off(5
    /* ClearWaitingQueue */
    );
  }

  if (canUseDom && containerDomNode) {
    document.body.removeChild(containerDomNode);
  }
});


//# sourceMappingURL=react-toastify.esm.js.map

// EXTERNAL MODULE: ./node_modules/react-toastify/dist/ReactToastify.css
var ReactToastify = __webpack_require__(40993);
;// CONCATENATED MODULE: ./src/components/Layout/PageLayout.tsx


function PageLayout_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var PageLayout = function PageLayout(_ref) {
  var _getAppOsInfo;

  var children = _ref.children;

  var _useState = (0,react.useState)(0),
      footerHeight = _useState[0],
      setFooterHeight = _useState[1];

  var footerRef = (0,react.useRef)(null);
  var isAndroid = ((_getAppOsInfo = (0,utils/* getAppOsInfo */.ZA)()) === null || _getAppOsInfo === void 0 ? void 0 : _getAppOsInfo.osType) === 'Android';
  (0,react.useEffect)(function () {
    var _footerRef$current;

    if (!footerRef) return;
    setFooterHeight((_footerRef$current = footerRef.current) === null || _footerRef$current === void 0 ? void 0 : _footerRef$current.offsetHeight);
  }, [footerRef]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ContainerColumn, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(provider/* ScrollProvider */.ID, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderContainer, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContainerRow, {
        footerHeight: footerHeight,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentsContainer, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PageWrap, {
            children: children
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterContainer, {
        footerRef: footerRef
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToastContainer, {
      position: "bottom-center",
      hideProgressBar: true,
      autoClose: 2000,
      transition: Slide,
      style: {
        marginBottom: isAndroid ? '42px' : '0px',
        zIndex: 10001
      }
    })]
  });
};

var ContainerColumn = (0,emotion_styled_base_browser_esm["default"])("div",  true ? {
  target: "encumyy3"
} : 0)( true ? {
  name: "1hv1tju",
  styles: "display:flex;flex-direction:column;min-height:100vh;position:relative"
} : 0);

var ContainerRow = (0,emotion_styled_base_browser_esm["default"])("div",  true ? {
  target: "encumyy2"
} : 0)("display:flex;width:100%;", function (_ref2) {
  var footerHeight = _ref2.footerHeight;
  return footerHeight && "padding-bottom: ".concat((0,dist/* pxToRem */.Q1c)(footerHeight), ";");
}, ";" + ( true ? "" : 0));

var ContentsContainer = (0,emotion_styled_base_browser_esm["default"])("div",  true ? {
  target: "encumyy1"
} : 0)( true ? {
  name: "1js61ur",
  styles: "width:100%;@media screen and (min-width: 768px){padding:0px 60px;margin:0 auto;box-sizing:border-box;flex:1 0 auto;max-width:1256px;}"
} : 0);

var PageWrap = (0,emotion_styled_base_browser_esm["default"])("div",  true ? {
  target: "encumyy0"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);
;// CONCATENATED MODULE: ./src/components/Layout/index.ts








/***/ }),

/***/ 39411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "EC": function() { return /* reexport */ getNavigationData; },
  "N1": function() { return /* reexport */ useNavigationMenu; }
});

// UNUSED EXPORTS: getNavigationHnCData

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@bucketplace/design-system/dist/index.js
var design_system_dist = __webpack_require__(41149);
// EXTERNAL MODULE: ./src/common/index.ts + 2 modules
var common = __webpack_require__(24911);
// EXTERNAL MODULE: ./src/components/Layout/index.ts + 9 modules
var Layout = __webpack_require__(59989);
// EXTERNAL MODULE: ./node_modules/humps/humps.js
var humps = __webpack_require__(56264);
;// CONCATENATED MODULE: ./src/hooks/Navigation/getNavigationData.tsx



var getNavigationData = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var response, json;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch('/api/navigation', {
              method: 'GET',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
              credentials: 'include'
            });

          case 2:
            response = _context.sent;

            if (response.ok) {
              _context.next = 5;
              break;
            }

            throw new Error('unexpected http error occured');

          case 5:
            _context.next = 7;
            return response.json();

          case 7:
            json = _context.sent;
            return _context.abrupt("return", (0,humps.camelizeKeys)(json));

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getNavigationData() {
    return _ref.apply(this, arguments);
  };
}();
var getNavigationHnCData = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
    var response, data;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetch('/api/navigation/topics');

          case 2:
            response = _context2.sent;
            _context2.next = 5;
            return response.json();

          case 5:
            data = _context2.sent;
            return _context2.abrupt("return", data);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getNavigationHnCData() {
    return _ref2.apply(this, arguments);
  };
}();
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./src/hooks/Navigation/useCreateHnCMenu.tsx









var useCreateHnCMenu = function useCreateHnCMenu(_ref) {
  var experiments = _ref.experiments;

  var _useState = (0,react.useState)({
    "default": {
      key: '',
      name: ''
    },
    fixed: []
  }),
      topics = _useState[0],
      setTopics = _useState[1];

  var experimentType = experiments === null || experiments === void 0 ? void 0 : experiments.contents;

  var formatTopics = function formatTopics(topics) {
    var _topics$find;

    /** recommendTopic 찾는 순서
     * 1. defaultTopic = true
     * 2. key = 'recommend'(DEFAULT_TOPIC_KEY)
     * 3. topics 중 첫번째 item
     */
    var recommendTopic = (_topics$find = topics.find(function (_ref2) {
      var defaultTopic = _ref2.defaultTopic,
          key = _ref2.key;
      return defaultTopic || key === 'recommend';
    })) !== null && _topics$find !== void 0 ? _topics$find : topics[0];
    var lifeTopics = topics.filter(function (topic) {
      return topic !== recommendTopic;
    });
    return {
      "default": recommendTopic,
      fixed: lifeTopics
    };
  };

  var createTopicMenu = function createTopicMenu(topics) {
    return topics.map(function (_ref3) {
      var name = _ref3.name,
          key = _ref3.key;
      return {
        title: "".concat(name),
        href: "".concat(common/* CONTENT_HOST */.Ro, "/topics/").concat(key),
        logId: key
      };
    });
  };

  var legacyMenu = (0,react.useMemo)(function () {
    return [{
      title: '커뮤니티',
      icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(design_system_dist/* Icon */.JO$, {
        size: 24,
        name: "home_outline"
      }),
      href: "".concat(common/* OHS_HOST */.K2),
      entries: [{
        title: '홈',
        href: "".concat(common/* OHS_HOST */.K2, "/")
      }, {
        title: '팔로잉',
        href: "".concat(common/* OHS_HOST */.K2, "/contents/follow/feed")
      }, {
        title: '사진',
        href: "".concat(common/* OHS_HOST */.K2, "/contents/card_collections")
      }, {
        title: '집들이',
        href: "".concat(common/* OHS_HOST */.K2, "/projects?writer=self")
      }, {
        title: '노하우',
        href: "".concat(common/* OHS_HOST */.K2, "/advices")
      }, {
        title: '전문가집들이',
        href: "".concat(common/* OHS_HOST */.K2, "/projects?writer=pro")
      }, {
        title: '셀프가이드',
        href: "".concat(common/* OHS_HOST */.K2, "/advices/guides/self_interior")
      }, {
        title: '3D인테리어',
        href: "".concat(common/* OHS_HOST */.K2, "/interior3ds"),
        badge: {
          text: 'BETA',
          type: 'fill',
          variant: 'base2'
        }
      }, {
        title: '이벤트',
        href: "".concat(common/* OHS_HOST */.K2, "/competitions/feed")
      }].filter(Boolean)
    }].filter(Boolean);
  }, []);
  var newMenu = (0,react.useMemo)(function () {
    return [{
      title: '커뮤니티',
      icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(design_system_dist/* Icon */.JO$, {
        size: 24,
        name: "home_outline"
      }),
      href: "".concat(common/* OHS_HOST */.K2),
      entries: [{
        title: '홈',
        href: "".concat(common/* OHS_HOST */.K2),
        logId: 'home'
      }].concat((0,toConsumableArray/* default */.Z)(createTopicMenu([topics["default"]])), [{
        title: '집들이',
        href: "".concat(common/* OHS_HOST */.K2, "/projects?writer=self"),
        logId: 'project'
      }, {
        title: '집사진',
        href: "".concat(common/* OHS_HOST */.K2, "/contents/card_collections"),
        logId: 'card'
      }], (0,toConsumableArray/* default */.Z)(createTopicMenu(topics.fixed)), [{
        title: '3D인테리어',
        href: "".concat(common/* OHS_HOST */.K2, "/interior3ds"),
        logId: 'interior3d'
      }, {
        title: '이벤트',
        href: "".concat(common/* OHS_HOST */.K2, "/competitions/feed"),
        logId: 'event'
      }]).filter(Boolean)
    }];
  }, [topics["default"], topics.fixed]);
  (0,react.useEffect)(function () {
    if (experimentType === Layout/* CONTENTS_EXPERIMENT_TYPE.LEGACY */.X_.LEGACY) return;

    var getHnCTopics = /*#__PURE__*/function () {
      var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var res, formattedTopics;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return getNavigationHnCData();

              case 3:
                res = _context.sent;
                formattedTopics = formatTopics(res.topics);
                setTopics(formattedTopics);
                _context.next = 10;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 8]]);
      }));

      return function getHnCTopics() {
        return _ref4.apply(this, arguments);
      };
    }();

    getHnCTopics();
  }, [experimentType]);
  return experimentType === Layout/* CONTENTS_EXPERIMENT_TYPE.LEGACY */.X_.LEGACY ? legacyMenu : newMenu;
};
;// CONCATENATED MODULE: ./src/hooks/Navigation/createO2OMenu.tsx



var createO2OMenu = function createO2OMenu() {
  return [{
    title: '이사/시공/수리',
    icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(design_system_dist/* Icon */.JO$, {
      size: 24,
      name: "truck_outline"
    }),
    href: "".concat(common/* OHS_HOST */.K2, "/experts"),
    entries: [{
      title: '홈',
      href: "".concat(common/* OHS_HOST */.K2, "/experts")
    }, {
      title: '주거공간시공',
      href: "".concat(common/* O2O_HOST */.al, "/remodeling/home/discovery")
    }, {
      title: '상업공간시공',
      href: "".concat(common/* O2O_HOST */.al, "/remodeling/business/discovery")
    }, {
      title: '아파트시공사례',
      href: "".concat(common/* OHS_HOST */.K2, "/experts/town")
    }, {
      title: '설치수리',
      href: "".concat(common/* O2O_HOST */.al, "/repair")
    }, {
      title: '이사',
      href: "".concat(common/* OHS_HOST */.K2, "/experts/moving")
    }, {
      title: '집보기체크리스트',
      href: "".concat(common/* O2O_HOST */.al, "/hometour")
    }]
  }];
};
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/querystring/index.js
var querystring = __webpack_require__(17673);
;// CONCATENATED MODULE: ./src/hooks/Navigation/createStoreMenu.tsx






var createStoreMenu = function createStoreMenu() {
  return [{
    title: '쇼핑',
    icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(design_system_dist/* Icon */.JO$, {
      size: 24,
      name: "store_outline"
    }),
    href: "".concat(common/* OHS_HOST */.K2, "/store"),
    active: true,
    entries: []
  }];
};
var STORE_FEEDS = {
  StoreWedding: 'StoreWeddingFeed',
  StoreCustom: 'StoreCustomFeed',
  Store: 'StoreFeed'
};

var getFeeds = function getFeeds(storeFeeds, type) {
  switch (type) {
    case STORE_FEEDS.StoreWedding:
      return storeFeeds.find(function (feed) {
        return feed.type === STORE_FEEDS.StoreWedding;
      });

    case STORE_FEEDS.StoreCustom:
      return storeFeeds.find(function (feed) {
        return feed.type === STORE_FEEDS.StoreCustom;
      });

    case STORE_FEEDS.Store:
      return storeFeeds.filter(function (feed) {
        return feed.type === STORE_FEEDS.Store;
      });

    default:
      return undefined;
  }
};

var composeStoreFeeds = function composeStoreFeeds(data, pathname) {
  var _data$storeFeeds, _data$storeHamburger$, _data$storeHamburger, _weddingItem$feedTitl;

  var storeFeeds = (_data$storeFeeds = data === null || data === void 0 ? void 0 : data.storeFeeds) !== null && _data$storeFeeds !== void 0 ? _data$storeFeeds : [];
  var weddingItem = getFeeds(storeFeeds, STORE_FEEDS.StoreWedding);
  var customFeedItem = getFeeds(storeFeeds, STORE_FEEDS.StoreCustom);
  var specialFeedItems = getFeeds(storeFeeds, STORE_FEEDS.Store);
  var storeHamburgerItems = ((_data$storeHamburger$ = data === null || data === void 0 ? void 0 : (_data$storeHamburger = data.storeHamburger) === null || _data$storeHamburger === void 0 ? void 0 : _data$storeHamburger.categories) !== null && _data$storeHamburger$ !== void 0 ? _data$storeHamburger$ : []).map(function (_ref) {
    var id = _ref.id,
        title = _ref.title,
        hash = _ref.hash,
        count = _ref.count,
        imageUrl = _ref.imageUrl;
    var queryString = querystring.stringify({
      affect_type: 'StoreHamburger',
      category: hash
    });
    return {
      title: title,
      hash: hash,
      count: count,
      imageUrl: imageUrl,
      id: +id,
      to: "".concat(common/* OHS_HOST */.K2, "/store/category?").concat(queryString)
    };
  });
  return [{
    title: '쇼핑홈',
    href: "".concat(common/* OHS_HOST */.K2, "/store")
  }, {
    title: '카테고리',
    href: "".concat(common/* OHS_HOST */.K2, "/store/category?category=0&order=popular"),
    renderBarChild: function renderBarChild() {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(design_system_dist/* StoreCategory */.DWR, {
        categories: storeHamburgerItems,
        selectedIndex: -1,
        onSelect: function onSelect() {//
        }
      });
    }
  }, {
    title: '베스트',
    href: "".concat(common/* OHS_HOST */.K2, "/commerces/ranks")
  }].concat((0,toConsumableArray/* default */.Z)(specialFeedItems.map(function (item) {
    var _$exec;

    var match = /(https?:\/\/[^/]+)(\/[^?]+)(\?[^#]+)?(#.+)?$/.exec(item.content.url);

    if (match == null) {
      return null;
    }

    var newUrl = "".concat(match[1]).concat(match[2]).concat(match[3] ? "".concat(match[3], "&") : '?', "special_feed=true"); // in events.ohou.se, special_feed must be active even when the first segment of full path matches

    var _ref2 = (_$exec = /^(\/[^/]*)/.exec(pathname)) !== null && _$exec !== void 0 ? _$exec : [],
        _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 2),
        firstSegment = _ref3[1];

    return {
      title: item.feedTitle,
      bullet: item.updateAlert ? 'new' : undefined,
      href: match[2].includes('today_deals') ? "".concat(common/* OHS_HOST */.K2).concat(match[2]) : newUrl,
      active: match[2].startsWith(firstSegment)
    };
  })), [weddingItem != null ? {
    title: (_weddingItem$feedTitl = weddingItem.feedTitle) !== null && _weddingItem$feedTitl !== void 0 ? _weddingItem$feedTitl : '프리미엄',
    bullet: weddingItem.updateAlert ? 'new' : undefined,
    href: "".concat(common/* OHS_HOST */.K2, "/productions/premium")
  } : null, {
    title: '기획전',
    href: "".concat(common/* STORE_HOST */.PH, "/exhibitions?showroom=false")
  }, customFeedItem != null ? {
    title: customFeedItem.feedTitle,
    bullet: customFeedItem.updateAlert ? 'new' : undefined,
    href: "".concat(common/* OHS_HOST */.K2, "/commerces/custom_feeds/feed?logic=0")
  } : null]).filter(Boolean);
};
;// CONCATENATED MODULE: ./src/hooks/Navigation/useNavigationMenu.tsx



var _excluded = ["data"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var useCreateMenu = function useCreateMenu(navItems, pathname, experiments) {
  var hncMenu = useCreateHnCMenu({
    experiments: experiments
  });
  var navigationMenuList = [].concat((0,toConsumableArray/* default */.Z)(hncMenu), (0,toConsumableArray/* default */.Z)(createStoreMenu()), (0,toConsumableArray/* default */.Z)(createO2OMenu()));
  var navigationData = navigationMenuList.map(function (data) {
    // hooks over `/store/*`
    if (data.href != null && data.href.endsWith('/store')) {
      return _objectSpread(_objectSpread({}, data), {}, {
        entries: composeStoreFeeds(navItems, pathname)
      });
    }

    return data;
  });
  return navigationData;
};

var useNavigationMenu = function useNavigationMenu(pathname, experiments) {
  var _useSWR = (0,dist/* default */.ZP)(['navigation', 'menu'], function () {
    return getNavigationData();
  }),
      data = _useSWR.data,
      res = (0,objectWithoutProperties/* default */.Z)(_useSWR, _excluded);

  var combined = useCreateMenu(data, pathname, experiments);
  return _objectSpread(_objectSpread({}, res), {}, {
    data: combined
  });
};
;// CONCATENATED MODULE: ./src/hooks/Navigation/index.ts



/***/ }),

/***/ 37910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "EC": function() { return /* reexport */ Navigation/* getNavigationData */.EC; },
  "Yz": function() { return /* reexport */ useInterval; },
  "N1": function() { return /* reexport */ Navigation/* useNavigationMenu */.N1; },
  "bg": function() { return /* reexport */ useNowTime; }
});

// UNUSED EXPORTS: SWITCHED_DEVICE_RATIO, getNavigationHnCData, useDeviceRatioType, useHash, useImpressionLog, useIsVideoPlaying, usePreventAutoPageviewLog, useResponsiveQuery, useScrollSpy, useTab

// EXTERNAL MODULE: ./src/hooks/Navigation/index.ts + 5 modules
var Navigation = __webpack_require__(39411);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/provider/index.ts + 5 modules
var provider = __webpack_require__(52437);
;// CONCATENATED MODULE: ./src/hooks/useScrollSpy.ts


var useScrollSpy_useScrollSpy = function useScrollSpy(id, isAnchoring, isFirstTab, isMainTab) {
  var _target$getBoundingCl, _target$getBoundingCl2;

  var _useState = useState(null),
      target = _useState[0],
      setTarget = _useState[1];

  var _useState2 = useState(false),
      isActive = _useState2[0],
      setIsActive = _useState2[1];

  var _useScrollContext = useScrollContext(),
      stickyHeight = _useScrollContext.stickyHeight,
      scrollPosition = _useScrollContext.scrollPosition;

  var _useTabContext = useTabContext(),
      currentMainId = _useTabContext.currentMainId;

  var top = target === null || target === void 0 ? void 0 : (_target$getBoundingCl = target.getBoundingClientRect()) === null || _target$getBoundingCl === void 0 ? void 0 : _target$getBoundingCl.top;
  var offsetTop = scrollPosition + top || 0;
  var startPosition = Math.floor(offsetTop - stickyHeight);
  var endPosition = Math.floor(startPosition + (target === null || target === void 0 ? void 0 : (_target$getBoundingCl2 = target.getBoundingClientRect()) === null || _target$getBoundingCl2 === void 0 ? void 0 : _target$getBoundingCl2.height));
  var isInScreen = startPosition <= scrollPosition && scrollPosition < endPosition;
  var isBeforeReachingTarget = scrollPosition < startPosition;
  useEffect(function () {
    setTarget(document.getElementById(id));
  }, [id]);
  useEffect(function () {
    setIsActive(isInScreen);

    if (isFirstTab && isBeforeReachingTarget) {
      setIsActive(true);
    }
  }, [scrollPosition, isBeforeReachingTarget, isFirstTab, isInScreen]);
  useEffect(function () {
    if (!isMainTab && isFirstTab) {
      setIsActive(true);
    }
  }, [currentMainId, isFirstTab, isMainTab]);
  return {
    isActiveAnchor: isAnchoring && isActive
  };
};
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/hooks/useTab.ts




var useTab = function useTab(to, isFirstTab, isMainTab) {
  var isAnchoring = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var boundaryPrefix = arguments.length > 4 ? arguments[4] : undefined;
  var router = useRouter();

  var _useState = useState(false),
      isActive = _useState[0],
      setIsActive = _useState[1];

  var _useScrollSpy = useScrollSpy(boundaryPrefix ? "".concat(boundaryPrefix, "-").concat(to) : to, isAnchoring, isFirstTab, isMainTab),
      isActiveAnchor = _useScrollSpy.isActiveAnchor;

  var _useTabContext = useTabContext(),
      setCurrentMainId = _useTabContext.setCurrentMainId;

  var href = isAnchoring ? "#".concat(to) : "/".concat(to);
  useEffect(function () {
    if (isAnchoring) return;

    if (href.includes(router.pathname)) {
      setIsActive(true);
    }
  }, [router.pathname, href, isAnchoring]);
  useEffect(function () {
    if (!isAnchoring) return;

    if (isMainTab && isActiveAnchor) {
      setCurrentMainId(to);
    }

    setIsActive(isActiveAnchor);
  }, [isActiveAnchor, isMainTab, setCurrentMainId, to, isAnchoring]);
  return {
    isActive: isActive,
    href: href
  };
};
;// CONCATENATED MODULE: ./src/hooks/useInterval.tsx

var useInterval = function useInterval(callback, delay) {
  var savedCallback = (0,react.useRef)(null); // Remember the latest callback.

  (0,react.useEffect)(function () {
    savedCallback.current = callback;
  }, [callback]); // Set up the interval.

  (0,react.useEffect)(function () {
    var tick = function tick() {
      savedCallback.current();
    };

    var intervalHandle;

    if (delay !== null) {
      intervalHandle = window.setInterval(tick, delay);
    }

    return function () {
      if (intervalHandle != null) {
        clearInterval(intervalHandle);
      }
    };
  }, [delay]);
};
// EXTERNAL MODULE: ./node_modules/@bucketplace/bucket-log/dist/index.esm.js
var index_esm = __webpack_require__(5061);
;// CONCATENATED MODULE: ./src/hooks/usePreventAutoPageviewLog.ts


/**
 * This prevents automated pageview log from occurring.
 * With this hook, you can issue pageview event with additional data,
 * or prevent pageview event from occurring at all.
 */

function usePreventAutoPageviewLog() {
  useLayoutEffect(function () {
    bucketLog({
      category: 'disableAutoPageview'
    });
    return function () {
      bucketLog({
        category: 'enableAutoPageview'
      });
    };
  }, []);
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
;// CONCATENATED MODULE: ./src/hooks/useNowTime.ts





var getNowTime = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var _yield$axios$get, data, nowDate;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axios_default().get('/api/time');

          case 2:
            _yield$axios$get = _context.sent;
            data = _yield$axios$get.data;
            nowDate = new Date(data);
            return _context.abrupt("return", nowDate);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getNowTime() {
    return _ref.apply(this, arguments);
  };
}();

var useNowTime = function useNowTime() {
  return (0,dist/* default */.ZP)(['date'], getNowTime);
};
;// CONCATENATED MODULE: ./src/hooks/useImpressionLog.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




function useImpressionLog(_ref) {
  var logData = _ref.logData,
      threshold = _ref.threshold,
      disable = _ref.disable;

  var _useInView = useInView({
    threshold: threshold,
    skip: disable,
    triggerOnce: true
  }),
      ref = _useInView.ref,
      inView = _useInView.inView;

  useEffect(function () {
    if (inView && !disable && !!logData) {
      bucketLog({
        category: 'impression',
        data: [_objectSpread(_objectSpread({}, formattingLogData(logData)), {}, {
          time: Date.now()
        })]
      });
    }
  }, [inView, disable, logData]);
  return {
    ref: ref
  };
}
;// CONCATENATED MODULE: ./src/hooks/useResponsiveQuery.ts



function useResponsiveQuery(type, breakpoint, useMatchMediaOptions) {
  var query = useMemo(function () {
    return createMediaBreakQuery(type, breakpoint);
  }, [type, breakpoint]);

  var _useMatchMedia = useMatchMedia(query, useMatchMediaOptions),
      matches = _useMatchMedia.matches;

  return matches !== null && matches !== void 0 ? matches : false;
}
;// CONCATENATED MODULE: ./src/hooks/useHash.ts



function parseHash(url) {
  var _url$split = url.split('#'),
      _url$split2 = _slicedToArray(_url$split, 2),
      segment = _url$split2[1];

  return segment != null ? "#".concat(segment) : '';
}

function useHash(router) {
  // a hash should always result in empty string ('') as an initial value in
  // both server/client environment or you will get hydration errors.
  var _useState = useState(''),
      hash = _useState[0],
      setHash = _useState[1];

  useEffect(function () {
    var handleHashChangeStart = function handleHashChangeStart(url) {
      setHash(parseHash(url));
    };

    var handleHashChange = function handleHashChange(e) {
      setHash(parseHash(e.newURL));
    };

    router.events.on('hashChangeStart', handleHashChangeStart);
    window.addEventListener('hashchange', handleHashChange);
    setHash(parseHash(router.asPath));
    return function () {
      router.events.off('hashChangeStart', handleHashChangeStart);
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [router]);
  return hash;
}
;// CONCATENATED MODULE: ./src/hooks/useIsVideoPlaying.tsx

var useIsVideoPlaying = function useIsVideoPlaying(videoRef) {
  var _useState = useState(false),
      isVideoPlaying = _useState[0],
      setVideoPlaying = _useState[1];

  useEffect(function () {
    if (!videoRef.current) return null;
    var videoDOM = videoRef.current;

    var handleSuspend = function handleSuspend() {
      setVideoPlaying(false);
    };

    var handlePlay = function handlePlay() {
      setVideoPlaying(true);
    };

    videoDOM.addEventListener('suspend', handleSuspend);
    videoDOM.addEventListener('pause', handleSuspend);
    videoDOM.addEventListener('play', handlePlay);
    return function () {
      videoDOM.removeEventListener('suspend', handleSuspend);
      videoDOM.removeEventListener('pause', handleSuspend);
      videoDOM.removeEventListener('play', handlePlay);
    };
  }, [videoRef]);
  return isVideoPlaying;
};
;// CONCATENATED MODULE: ./src/campaign/hooks/useDeviceRatio.ts

/**
 * 디바이스 화면 비율 height / width
 */

var SWITCHED_DEVICE_RATIO = (/* unused pure expression or super */ null && (812 / 375));

/**
 * 디바이스 비율 종류를 반환합니다.
 * @return {string} 'long' | 'short'
 */
var useDeviceRatioType = function useDeviceRatioType() {
  var _useState = useState('long'),
      ratio = _useState[0],
      setRatio = _useState[1];

  useEffect(function () {
    var ratio = window.screen.availHeight / window.screen.availWidth;
    setRatio(function () {
      return ratio >= SWITCHED_DEVICE_RATIO ? 'long' : 'short';
    });
  }, []);
  if (false) {}
  return ratio;
};
;// CONCATENATED MODULE: ./src/hooks/index.ts













/***/ }),

/***/ 74127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__(35666);
// EXTERNAL MODULE: ./node_modules/abortcontroller-polyfill/dist/polyfill-patch-fetch.js
var polyfill_patch_fetch = __webpack_require__(63367);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./node_modules/next/app.js
var app = __webpack_require__(7544);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@bucketplace/design-system/dist/index.js
var design_system_dist = __webpack_require__(41149);
// EXTERNAL MODULE: ./src/provider/index.ts + 5 modules
var provider = __webpack_require__(52437);
// EXTERNAL MODULE: ./src/api/fetcher.ts
var fetcher = __webpack_require__(76129);
// EXTERNAL MODULE: ./src/utils/index.ts + 7 modules
var utils = __webpack_require__(90130);
// EXTERNAL MODULE: ./src/components/Layout/index.ts + 9 modules
var Layout = __webpack_require__(59989);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(81531);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(63553);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
;// CONCATENATED MODULE: ./src/components/ErrorBoundary.tsx






function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }


var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(ErrorBoundary, _React$Component);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, ErrorBoundary);

    _this = _super.call(this, props);
    _this.state = {
      hasError: false
    };
    return _this;
  }

  (0,createClass/* default */.Z)(ErrorBoundary, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          fallback = _this$props.fallback,
          children = _this$props.children;
      var hasError = this.state.hasError;

      if (hasError) {
        return fallback;
      }

      return children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasError: true
      };
    }
  }]);

  return ErrorBoundary;
}(react.Component);
// EXTERNAL MODULE: ./src/components/Error.tsx
var Error = __webpack_require__(35507);
// EXTERNAL MODULE: ./src/styles/global.css
var global = __webpack_require__(29885);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./src/pages/_app.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

















function MyApp(_ref) {
  var Component = _ref.Component,
      pageProps = _ref.pageProps;
  var router = (0,next_router.useRouter)();
  (0,react.useEffect)(function () {
    (0,utils/* setUtmData */.A2)();
    (0,utils/* saveAppOsInfo */.d5)();
    (0,utils/* sendA1MediaInflow */.gu)();
    router.events.on('routeChangeComplete', utils/* setUtmData */.A2);
    return function () {
      return router.events.off('routeChangeComplete', utils/* setUtmData */.A2);
    };
  }, [router.events]);

  var getLayout = Component.getLayout || function (page) {
    return page;
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(design_system_dist/* BdsProvider */.Mdh, {
    mode: "light",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* SWRConfig */.J$, {
      value: {
        revalidateOnFocus: false,
        fetcher: fetcher/* fetcher */._
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(provider/* SearchQueryContextProvider */._9, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(provider/* UserContextProvider */.fS, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Layout/* Layout */.Ar, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Layout/* PageLayout */.Xg, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ErrorBoundary, {
                fallback: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Error/* Error */.j, {}),
                children: getLayout((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Component, _objectSpread({}, pageProps)))
              })
            })
          })
        })
      })
    })
  });
}

MyApp.getInitialProps = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(context) {
    var appProps;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return app["default"].getInitialProps(context);

          case 2:
            appProps = _context.sent;
            return _context.abrupt("return", _objectSpread({}, appProps));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}();

/* harmony default export */ var _app = (MyApp);

/***/ }),

/***/ 52437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "KY": function() { return /* reexport */ RaffleInfoProvider; },
  "ID": function() { return /* reexport */ ScrollProvider; },
  "_9": function() { return /* reexport */ SearchQueryContextProvider; },
  "fS": function() { return /* reexport */ UserContextProvider; },
  "Km": function() { return /* reexport */ useRaffleInfoContext; },
  "VN": function() { return /* reexport */ useSearchQueryContext; },
  "SE": function() { return /* reexport */ useUserContext; }
});

// UNUSED EXPORTS: TabProvider, useScrollContext, useTabContext

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/index.ts + 7 modules
var utils = __webpack_require__(90130);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./src/provider/ScrollProvider.tsx



var ScrollContext = /*#__PURE__*/(0,react.createContext)({
  scrollPosition: 0,
  activeCategory: 0,
  setActiveCategory: function setActiveCategory() {
    /* noop */
  },
  stickyHeight: 0,
  setStickyHeight: function setStickyHeight() {
    /* noop */
  }
});
var ScrollProvider = function ScrollProvider(_ref) {
  var children = _ref.children;

  var _useState = (0,react.useState)(-1),
      scrollPosition = _useState[0],
      setScrollPosition = _useState[1];

  var _useState2 = (0,react.useState)(0),
      activeCategory = _useState2[0],
      setActiveCategory = _useState2[1];

  var _useState3 = (0,react.useState)(0),
      stickyHeight = _useState3[0],
      setStickyHeight = _useState3[1];

  (0,react.useEffect)(function () {
    var timerId = null;

    var handleScroll = function handleScroll() {
      if (timerId != null) {
        cancelAnimationFrame(timerId);
      }

      setScrollPosition(Math.floor(window.pageYOffset));
    };

    var throttleHandleScroll = (0,utils/* throttle */.P2)(handleScroll, 100);
    document.addEventListener('scroll', throttleHandleScroll, {
      passive: true
    });
    return function () {
      if (timerId != null) {
        cancelAnimationFrame(timerId);
      }

      document.removeEventListener('scroll', throttleHandleScroll);
    };
  }, []);
  var scrollValue = (0,react.useMemo)(function () {
    return {
      scrollPosition: scrollPosition,
      activeCategory: activeCategory,
      setActiveCategory: setActiveCategory,
      stickyHeight: stickyHeight,
      setStickyHeight: setStickyHeight
    };
  }, [activeCategory, scrollPosition, stickyHeight]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ScrollContext.Provider, {
    value: scrollValue,
    children: children
  });
};
var useScrollContext = function useScrollContext() {
  var context = useContext(ScrollContext);
  return context;
};
;// CONCATENATED MODULE: ./src/provider/TabProvider.tsx


var TabContext = /*#__PURE__*/(0,react.createContext)({
  currentMainId: '',
  setCurrentMainId: function setCurrentMainId() {
    /* noop */
  }
});
var TabProvider = function TabProvider(_ref) {
  var children = _ref.children,
      tabList = _ref.tabList;

  var _useState = useState(tabList[0]['id']),
      currentMainId = _useState[0],
      setCurrentMainId = _useState[1];

  var tabValue = useMemo(function () {
    return {
      currentMainId: currentMainId,
      setCurrentMainId: setCurrentMainId
    };
  }, [currentMainId]);
  return _jsx(TabContext.Provider, {
    value: tabValue,
    children: children
  });
};
var useTabContext = function useTabContext() {
  return useContext(TabContext);
};
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/humps/humps.js
var humps = __webpack_require__(56264);
// EXTERNAL MODULE: ./node_modules/@bucketplace/bucket-log/dist/index.esm.js
var index_esm = __webpack_require__(5061);
// EXTERNAL MODULE: ./src/hooks/index.ts + 10 modules
var hooks = __webpack_require__(37910);
;// CONCATENATED MODULE: ./src/provider/UserContextProvider.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var UserContext = /*#__PURE__*/(0,react.createContext)({});
var UserContextProvider = function UserContextProvider(_ref) {
  var children = _ref.children;
  var router = (0,next_router.useRouter)();
  var prevLocationRef = (0,react.useRef)(null);

  var _useState = (0,react.useState)(undefined),
      userInfo = _useState[0],
      setUserInfo = _useState[1];

  var _useState2 = (0,react.useState)(!userInfo),
      pending = _useState2[0],
      setPending = _useState2[1];

  var _useState3 = (0,react.useState)(null),
      appBanner = _useState3[0],
      setAppBanner = _useState3[1];

  var _useState4 = (0,react.useState)(null),
      pcBanner = _useState4[0],
      setPcBanner = _useState4[1];

  var fetchNavigationData = (0,react.useCallback)(function () {
    setPending(true);
    (0,hooks/* getNavigationData */.EC)().then(function (data) {
      return convertNavigationData(data);
    }).then(function (data) {
      var _data$loginUser, _data$storePcTopBanne;

      var userId = data === null || data === void 0 ? void 0 : (_data$loginUser = data.loginUser) === null || _data$loginUser === void 0 ? void 0 : _data$loginUser.userId;
      window.bucketLog.push({
        user_id: userId || null
      });
      setUserInfo({
        user: data === null || data === void 0 ? void 0 : data.loginUser,
        cartCount: data === null || data === void 0 ? void 0 : data.cartCount,
        notificationCount: data === null || data === void 0 ? void 0 : data.unseenNotification
      });
      setAppBanner(data === null || data === void 0 ? void 0 : data.appDownloadBanner);
      setPcBanner(data === null || data === void 0 ? void 0 : (_data$storePcTopBanne = data.storePcTopBanner) === null || _data$storePcTopBanne === void 0 ? void 0 : _data$storePcTopBanne.contents);
    })["finally"](function () {
      setPending(false);
    });
  }, []);
  (0,react.useLayoutEffect)(function () {
    if (userInfo == null) {
      fetchNavigationData();
    }
  }, [userInfo, fetchNavigationData]);
  (0,react.useEffect)(function () {
    if (userInfo != null) {
      router.events.on('routeChangeComplete', index_esm.logPageviewAfterLoad);
    }

    return function () {
      return router.events.off('routeChangeComplete', index_esm.logPageviewAfterLoad);
    };
  }, [userInfo, router.events]);
  (0,react.useEffect)(function () {
    if (userInfo == null) return;

    if (prevLocationRef.current == null) {
      prevLocationRef.current = router.asPath;
      return;
    }

    var prevPath = prevLocationRef.current;
    var currPath = router.asPath;

    if (prevPath !== currPath) {
      prevLocationRef.current = currPath;
      (0,index_esm.logPageviewBeforeLoad)(prevPath, currPath);
    }
  }, [prevLocationRef, router, userInfo]);
  var signOut = (0,react.useCallback)(function () {
    axios_default()["delete"]('/api/navigation/signOut', {
      withCredentials: true
    }).then(function (_ref2) {
      var data = _ref2.data;

      if (data.success) {
        fetchNavigationData();
        window.bucketLog.push({
          user_id: null
        });
      }
    });
    (0,utils/* airbridgeLogout */.jQ)();
  }, [fetchNavigationData]);

  var convertNavigationData = function convertNavigationData(navigationData) {
    navigationData = (0,humps.camelizeKeys)(navigationData);
    var _navigationData = navigationData,
        loginUser = _navigationData.loginUser;
    return _objectSpread(_objectSpread({}, navigationData), {}, {
      loginUser: loginUser ? {
        userId: loginUser.id,
        isAdmin: loginUser.isAdmin,
        imageUrl: loginUser.profileImageUrl,
        nickname: loginUser.nickname,
        userableType: loginUser.userableType
      } : null
    });
  };

  var userValue = (0,react.useMemo)(function () {
    return {
      userInfo: userInfo,
      appBanner: appBanner,
      pcBanner: pcBanner,
      pending: pending,
      signOut: signOut
    };
  }, [appBanner, pcBanner, pending, signOut, userInfo]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UserContext.Provider, {
    value: userValue,
    children: children
  });
};
var useUserContext = function useUserContext() {
  var context = (0,react.useContext)(UserContext);
  return context;
};
// EXTERNAL MODULE: ./src/types/index.ts + 2 modules
var types = __webpack_require__(66256);
;// CONCATENATED MODULE: ./src/provider/SearchQueryProvider.tsx


function SearchQueryProvider_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SearchQueryProvider_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SearchQueryProvider_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SearchQueryProvider_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var defaultQuery = {
  osType: 'WEB',
  qaMode: false
};
var SearchQueryContext = /*#__PURE__*/(0,react.createContext)({});
var SearchQueryContextProvider = function SearchQueryContextProvider(_ref) {
  var children = _ref.children;

  var _useState = (0,react.useState)(defaultQuery),
      query = _useState[0],
      setQuery = _useState[1];

  (0,react.useEffect)(function () {
    handleQuery();
    router_default().events.on('routeChangeComplete', handleQuery);
  }, []);

  var handleQuery = function handleQuery() {
    var query = (0,humps.camelizeKeys)((0,utils/* getQuery */.pm)(location.href));
    var queryList = (0,utils/* filter */.hX)(query, function (_, k) {
      return types.searchQueryKeyList.includes(k);
    });
    setQuery(SearchQueryProvider_objectSpread(SearchQueryProvider_objectSpread(SearchQueryProvider_objectSpread({}, defaultQuery), queryList), {}, {
      osType: (0,utils/* getOSType */.z2)((router_default()).query)
    }));
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchQueryContext.Provider, {
    value: query,
    children: children
  });
};
var useSearchQueryContext = function useSearchQueryContext() {
  var context = (0,react.useContext)(SearchQueryContext);
  return context;
};
;// CONCATENATED MODULE: ./src/provider/RaffleInfoProvider.tsx


var RaffleInfoContext = /*#__PURE__*/(0,react.createContext)(null);
var RaffleInfoProvider = function RaffleInfoProvider(_ref) {
  var children = _ref.children,
      initialData = _ref.initialData;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RaffleInfoContext.Provider, {
    value: initialData,
    children: children
  });
};
var useRaffleInfoContext = function useRaffleInfoContext() {
  var context = (0,react.useContext)(RaffleInfoContext);
  return context;
};
;// CONCATENATED MODULE: ./src/provider/index.ts






/***/ }),

/***/ 66256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "DELIVERY_SERVICE_CODE": function() { return /* reexport */ DELIVERY_SERVICE_CODE; },
  "searchQueryKeyList": function() { return /* reexport */ searchQueryKeyList; }
});

;// CONCATENATED MODULE: ./src/types/Product.ts
var DELIVERY_SERVICE_CODE = {
  /** 화물택배 배송 */
  Cargo: 'CARGO',

  /** 미노출 */
  None: 'NONE',

  /** 일반택배 */
  Normal: 'NORMAL',

  /** 오늘의집 배송 */
  Ohouse: 'OHOUSE',

  /** 직접배송 */
  Seller: 'SELLER',

  /** 빠른가전배송 */
  ThirdPartyAppliance: 'THIRD_PARTY_APPLIANCE',

  /** 빠른가구배송 */
  ThirdPartyFurniture: 'THIRD_PARTY_FURNITURE'
};
;// CONCATENATED MODULE: ./src/types/Query.ts
var searchQueryKeyList = ['osType', 'version', 'qaMode'];
;// CONCATENATED MODULE: ./src/types/index.ts






/***/ }),

/***/ 89897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "hA": function() { return /* reexport */ getMarketingFooterScript; },
  "JM": function() { return /* reexport */ getMarketingHeaderScript; },
  "gk": function() { return /* reexport */ getNavigationProps; },
  "My": function() { return /* reexport */ handleLog; },
  "Qe": function() { return /* reexport */ handleOpenApp; },
  "d4": function() { return /* reexport */ runMarketingFooterScript; },
  "Ht": function() { return /* reexport */ runMarketingHeaderScript; }
});

// UNUSED EXPORTS: getSupplementary, runAmplitudeScript

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./src/utils/Navigation/_marketingFooter.js
/* eslint-disable */




var getNaverSearch = function getNaverSearch() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((script_default()), {
    type: "text/javascript",
    src: "https://wcs.naver.net/wcslog.js"
  }, 'naver-search-js');
};

var runNaverSearch = function runNaverSearch() {
  if (window.wcs != null) {
    if (!window.wcs_add) window.wcs_add = {};
    window.wcs_add['wa'] = 's_2e85116be219';
    if (!_nasa) var _nasa = {};
    wcs.inflow('ohou.se');
    wcs_do(_nasa);
  }
};

var getKakaoMomentScript = function getKakaoMomentScript() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((script_default()), {
    type: "text/javascript",
    charset: "UTF-8",
    src: "//t1.daumcdn.net/adfit/static/kp.js"
  }, 'kakao-moment-js');
};

var runKakaoMomentScript = function runKakaoMomentScript() {
  if (window.kakaoPixel != null) {
    kakaoPixel('7919701595446099671').pageView();
  }
};

var getEnlipleScript = function getEnlipleScript() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((script_default()), {
    src: "https://cdn.megadata.co.kr/js/en_script/3.5/enliple_min3.5.js",
    async: "async",
    onLoad: function onLoad() {
      var rf = new EN();
      rf.setData('userid', 'bucketplace');
      rf.setSSL(true);
      rf.sendRf();

      if (typeof handleEnlipleLoadShop === 'function') {
        handleEnlipleLoadShop();
      }
    }
  }, 'enliple-js');
};

var getWiderPlanetScript = function getWiderPlanetScript() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((script_default()), {
    type: "text/javascript",
    async: "async",
    src: "//cdn-aitg.widerplanet.com/js/wp_astg_4.0.js"
  }, 'wider-planet-js');
};

var getWiderPrepareDiv = function getWiderPrepareDiv() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    id: "wp_tg_cts",
    style: {
      display: 'none'
    }
  }, 'wider-planer-div');
};

var runWiderPlanetScript = function runWiderPlanetScript(user) {
  window.wptg_tagscript_vars = window.wptg_tagscript_vars || [];
  window.wptg_tagscript_vars.push(function () {
    return {
      wp_hcuid: user !== null && user !== void 0 && user.userId ? user.userId : '',
      ti: '47350',
      ty: 'Home',
      device: navigator.userAgent.match(/ios|iphone|ipad|android/i) ? 'mobile' : 'web'
    };
  });
};

var getMarketingFooterScript = function getMarketingFooterScript() {
  var isProduction = true;
  var scriptList = [];

  if (isProduction) {
    scriptList.push(getNaverSearch());
    scriptList.push(getKakaoMomentScript());
    scriptList.push(getEnlipleScript());
    scriptList.push(getWiderPrepareDiv());
    scriptList.push(getWiderPlanetScript());
  }

  return scriptList;
};
var runMarketingFooterScript = function runMarketingFooterScript(user) {
  var isProduction = true;

  if (isProduction) {
    runNaverSearch();
    runKakaoMomentScript();
    runWiderPlanetScript(user);
  } else {
    window.wptg_tagscript_vars = window.wptg_tagscript_vars || [];
  }
};
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
;// CONCATENATED MODULE: ./src/utils/Navigation/_marketingHeader.js



/* eslint-disable */





var runPrepareScript = function runPrepareScript() {
  window.dataLayer = [];
  window.bucketLog = window.bucketLog || [];

  window.fbq = function () {};
};

var getBucketLogScript = function getBucketLogScript() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
    id: "logging-js",
    src: "https://assets.ohou.se/logging/logging.js",
    defer: true
  }, 'logging-js');
};

var runProdLogOhouseScript = function runProdLogOhouseScript(user) {
  window.bucketLog = window.bucketLog || [];

  if (user != null) {
    window.bucketLog.push({
      user_id: user.userId || null
    });
  }
};

var runGoogleTagManagerScript = function runGoogleTagManagerScript(user) {
  if (user !== null && user !== void 0 && user.userId) {
    var dataLayer = [{
      userID: user.userId
    }];
  }

  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });
    var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', 'GTM-MK8DN2Q');
};

var getGoogleTagManagerScript = function getGoogleTagManagerScript() {
  (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("noscript", {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("iframe", {
      src: "https://www.googletagmanager.com/ns.html?id=GTM-MK8DN2Q",
      height: "0",
      width: "0",
      style: "display:none;visibility:hidden",
      allowfullscreen: true
    })
  });
};

var runFaceBookPixelCodeScript = function runFaceBookPixelCodeScript() {
  !function (f, b, e, v, n, t, s) {
    if (f.fbq) return;

    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };

    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  fbq('set', 'autoConfig', 'false', '937204509645248');
  fbq('init', '937204509645248');
  fbq('track', 'PageView');
};

var getFaceBookPixelPrepare = function getFaceBookPixelPrepare() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("noscript", {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
      height: "1",
      width: "1",
      style: {
        display: 'none'
      },
      src: "https://www.facebook.com/tr?id=937204509645248&ev=PageView&noscript=1"
    })
  }, 'facebookpixel-prepare');
};

var runCriteoScript = function runCriteoScript(user) {
  (function () {
    var ua = navigator.userAgent.toLowerCase();
    var mobile = {
      isAndroid: ua.indexOf('android') > -1,
      isIos: ua.match(/(ipad|iphone|ipod)/g)
    };
    var type = '';

    if (mobile.isAndroid || mobile.isIos) {
      type = 'm';
    } else {
      type = 'd';
    }

    window.criteo_q = window.criteo_q || [];
    window.criteo_q.push({
      event: 'setAccount',
      account: 50838
    }, {
      event: 'setEmail',
      email: user !== null && user !== void 0 && user.userId ? "".concat(user.userId, "@bucketplace.net") : ''
    }, {
      event: 'setSiteType',
      type: type
    });
  })();
};

var getCriteoScript = function getCriteoScript() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
    type: "text/javascript",
    src: "//static.criteo.net/js/ld/ld.js",
    async: true
  }, 'criteo-js');
};

var runAmplitudeBefore = function runAmplitudeBefore() {
  (function (e, t) {
    var n = e.amplitude || {
      _q: [],
      _iq: {}
    };

    function i(e, t) {
      e.prototype[t] = function () {
        this._q.push([t].concat(Array.prototype.slice.call(arguments, 0)));

        return this;
      };
    }

    var o = function o() {
      this._q = [];
      return this;
    };

    var a = ["add", "append", "clearAll", "prepend", "set", "setOnce", "unset", "preInsert", "postInsert", "remove"];

    for (var c = 0; c < a.length; c++) {
      i(o, a[c]);
    }

    n.Identify = o;

    var l = function l() {
      this._q = [];
      return this;
    };

    var u = ["setProductId", "setQuantity", "setPrice", "setRevenueType", "setEventProperties"];

    for (var p = 0; p < u.length; p++) {
      i(l, u[p]);
    }

    n.Revenue = l;
    var d = ["init", "logEvent", "logRevenue", "setUserId", "setUserProperties", "setOptOut", "setVersionName", "setDomain", "setDeviceId", "enableTracking", "setGlobalUserProperties", "identify", "clearUserProperties", "setGroup", "logRevenueV2", "regenerateDeviceId", "groupIdentify", "onInit", "onNewSessionStart", "logEventWithTimestamp", "logEventWithGroups", "setSessionId", "resetSessionId", "getDeviceId", "getUserId", "setMinTimeBetweenSessionsMillis", "setEventUploadThreshold", "setUseDynamicConfig", "setServerZone", "setServerUrl", "sendEvents", "setLibrary", "setTransport"];

    function v(t) {
      function e(e) {
        t[e] = function () {
          t._q.push([e].concat(Array.prototype.slice.call(arguments, 0)));
        };
      }

      for (var n = 0; n < d.length; n++) {
        e(d[n]);
      }
    }

    v(n);

    n.getInstance = function (e) {
      e = (!e || e.length === 0 ? "$default_instance" : e).toLowerCase();

      if (!Object.prototype.hasOwnProperty.call(n._iq, e)) {
        n._iq[e] = {
          _q: []
        };
        v(n._iq[e]);
      }

      return n._iq[e];
    };

    e.amplitude = n;
  })(window, document);
};

var initAmplitude = function initAmplitude(isProduction, user) {
  var _user$userId;

  window.amplitude.getInstance().init(isProduction ? '5a87b5059b95b7a68fda866acf155c56' : 'dc73f13a3e81af36c9f61718642148af', (_user$userId = user === null || user === void 0 ? void 0 : user.userId) !== null && _user$userId !== void 0 ? _user$userId : null, function () {
    var accountGroup = '';

    if (user !== null && user !== void 0 && user.isAdmin) {
      accountGroup = '어드민';
    } else if ((user === null || user === void 0 ? void 0 : user.userableType) === 'ExpertUser') {
      accountGroup = '전문가';
    } else if ((user === null || user === void 0 ? void 0 : user.userableType) === 'SalesUser') {
      accountGroup = '판매자';
    } else if (user != null) {
      accountGroup = '일반회원';
    } else {
      accountGroup = null;
    }

    window.amplitude.getInstance().setUserProperties({
      'State of 로그인': user !== null && user !== void 0 && user.userId ? 'true' : 'false',
      'Account Group': accountGroup
    });
  });
};

var runAmplitudeBridge = function runAmplitudeBridge(isProduction, user) {
  var androidAvailable = window.ohouseAmplitudeInterface != null;
  var iosAvailable = window.webkit != null && window.webkit.messageHandlers != null && window.webkit.messageHandlers.ohouseAmplitudeInterface != null;

  if (androidAvailable || iosAvailable) {
    // Use a mock interface of Amplitude. However, we shouldn't override
    // original Amplitude object - it contains a queue that needs to be
    // executed.
    // Therefore, instead of overriding the object as whole, we should override
    // its methods.
    // First, read out all objects in window.amplitude
    var amplitude = window.amplitude || {
      _q: [],
      _iq: {}
    };
    window.amplitude = amplitude;

    var override = function override(v) {
      // Then, override certain methods we need to track
      v.logEvent = function (name, props, callback) {
        if (androidAvailable) {
          window.ohouseAmplitudeInterface.sendEvent(name, JSON.stringify(props));
        } else if (iosAvailable) {
          window.webkit.messageHandlers.ohouseAmplitudeInterface.postMessage({
            type: 'sendEvent',
            name: name,
            properties: props
          });
        }

        if (callback != null) callback();
      };

      v.setUserProperties = function (props) {
        var identify = new v.Identify(); // eslint-disable-next-line guard-for-in

        for (var name in props) {
          identify.set(name, props[name]);
        }

        v.identify(identify);
      };

      v.identify = function (identify) {
        // Fortunately identify's _q is equivalent to what we need to send
        if (androidAvailable) {
          window.ohouseAmplitudeInterface.identify(JSON.stringify(identify._q));
        } else if (iosAvailable) {
          window.webkit.messageHandlers.ohouseAmplitudeInterface.postMessage({
            type: 'identify',
            actions: identify._q
          });
        }
      }; // Supply 'Identify', 'Revenue' object


      v.Identify = amplitude.Identify;
      v.Revenue = amplitude.Revenue; // Finally, execute the queue.

      for (var i = 0; i < v._q.length; i += 1) {
        var command = v._q[i];

        if (['logEvent', 'setUserProperties', 'identify'].indexOf(command[0]) !== -1) {
          // eslint-disable-next-line prefer-spread
          v[command[0]].apply(v, command.slice(1));
        }
      }

      v._q = [];
    }; // Override amplitude object itself, and _iq


    override(amplitude); // eslint-disable-next-line guard-for-in

    for (var name in amplitude._iq) {
      override(amplitude._iq[name]);
    }
  } else {
    // Normal environment detected; just use regular SDK
    var r = document.createElement('script');
    r.type = 'text/javascript';
    r.integrity = 'sha384-cukXwabQy+j/QA1+RqiXSzxhgQg5Rrn3zVszlwH3pWj/bXJxlA8Ge7NhcD6vP2Ik';
    r.crossOrigin = 'anonymous';
    r.async = true;
    r.src = 'https://cdn.amplitude.com/libs/amplitude-7.1.0-min.gz.js';

    r.onload = function () {
      if (!window.amplitude.runQueuedFunctions) {
        console.log('[Amplitude] Error: could not load SDK');
      }

      initAmplitude(isProduction, user);
    };

    var i = document.getElementsByTagName('script')[0];
    i.parentNode.insertBefore(r, i);
  }
};

var runAmplitudeScript = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(isProduction, user) {
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return runAmplitudeBefore();

          case 2:
            _context.next = 4;
            return runAmplitudeBridge(isProduction, user);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function runAmplitudeScript(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var getADInsightScript = function getADInsightScript() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
      type: "text/javascript",
      children: "var TRS_AIDX = /iPhone|iPad|iPod|Android/.test(navigator.userAgent) ? 11603 : 11598;"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
      type: "text/javascript",
      src: "https://analysis.adinsight.co.kr/emnet/trs_esc.js",
      defer: true
    }, 'ad-insight-js')]
  });
};

var runSentryTestingScript = function runSentryTestingScript(isProduction, user) {
  if (isProduction) {
    Raven.config('https://b8e5cc27b3eb44be8b976b0c81dd4115@sentry.io/271486').install();

    if (user != null) {
      Raven.setUserContext({
        id: user.userId,
        email: user.userId ? "".concat(user.userId, "@bucketplace.net") : '',
        nickname: user.nickname
      });
    }

    Raven.setUserContext({});
  }
};

var getSentryTestingScript = function getSentryTestingScript() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
    src: "https://cdn.ravenjs.com/3.26.4/raven.min.js",
    crossOrigin: "anonymous"
  }, 'sentry-testing-js');
};

var getJSONDataScript = function getJSONDataScript() {
  var structuredData = {
    "@context": "http://schema.org",
    "@type": "Organization",
    "name": "오늘의집",
    "url": "https://ohou.se",
    "sameAs": ["https://www.instagram.com/todayhouse/?hl=ko", "https://www.facebook.com/interiortoday", "https://m.post.naver.com/my.nhn?memberNo=202156", "https://itunes.apple.com/kr/app/id1008236892", "https://play.google.com/store/apps/details?id=net.bucketplace&hl=ko", "https://www.youtube.com/channel/UCBKtitA1RwY7F32rCniV1dA/featured"]
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(structuredData)
    }
  });
};

var runAirbridgeScript = function runAirbridgeScript(user) {
  (function (a_, i_, r_, _b, _r, _i, _d, _g, _e) {
    if (!a_[_b]) {
      var d = {
        queue: []
      };

      _r.concat(_i).forEach(function (a) {
        var i_ = a.split("."),
            a_ = i_.pop();

        i_.reduce(function (a, i_) {
          return a[i_] = a[i_] || {};
        }, d)[a_] = function () {
          d.queue.push([a, arguments]);
        };
      });

      a_[_b] = d;
      a_ = i_.getElementsByTagName(r_)[0];
      i_ = i_.createElement(r_);

      i_.onerror = function () {
        d.queue.filter(function (a) {
          return 0 <= _i.indexOf(a[0]);
        }).forEach(function (a) {
          a = a[1];
          a = a[a.length - 1];
          "function" === typeof a && a("error occur when load airbridge");
        });
      };

      i_.async = 1;
      i_.src = "//static.airbridge.io/sdk/latest/airbridge.min.js";
      a_.parentNode.insertBefore(i_, a_);
    }
  })(window, document, "script", "airbridge", "init fetchResource setBanner setDownload setDownloads setDeeplinks sendWeb setUserAgent setUserAlias addUserAlias setMobileAppData setUserId setUserEmail setUserPhone setUserAttributes clearUser setDeviceIFV setDeviceIFA setDeviceGAID events.send events.signIn events.signUp events.signOut events.purchased events.addedToCart events.productDetailsViewEvent events.homeViewEvent events.productListViewEvent events.searchResultViewEvent".split(" "), ["events.wait"]);

  var initObject = {
    app: 'ohouse',
    webToken: '2bd43efc5ef8401baece946c84ba155d',
    cookieWindow: 1,
    userHash: false,
    urlQueryMapping: {
      channel: 'utm_source',
      campaign: 'utm_campaign',
      term: 'utm_term',
      ad_creative: 'utm_content',
      ad_group: 'bp_adset',
      content: 'bp_content',
      sub_id: 'bp_sub_id',
      sub_id_1: 'bp_sub_id_1',
      sub_id_2: 'bp_sub_id_2',
      sub_id_3: 'utm_medium'
    }
  };

  if (user != null) {
    initObject.user = {
      externalUserID: "".concat(user.userId),
      externalUserEmail: "".concat(user.userId, "@bucketplace.net")
    };
  }

  airbridge.init(initObject);
};

var runA1mediaScript = function runA1mediaScript() {
  var linkback = linkback || {};

  (function () {
    var d = document,
        scr = d.createElement('script'),
        tar = d.getElementsByTagName('script')[0];
    scr.type = 'text/javascript';
    scr.async = true;
    var dt = new Date();
    var date_s = dt.getFullYear().toString() + ('0' + (dt.getMonth() + 1)).slice(-2) + ('0' + dt.getDate()).slice(-2);
    scr.src = 'https://linkback.contentsfeed.com/src/' + date_s + '/lb4ohouse.min.js';
    scr.charset = 'utf-8';

    if (!linkback.l) {
      linkback.l = true;
      tar.parentNode.insertBefore(scr, tar);
    }
  })();
};

var getMarketingHeaderScript = function getMarketingHeaderScript(userInfo) {
  var isProduction = true;
  var scriptList = [];

  if (userInfo) {
    scriptList.push(getBucketLogScript());
  }

  if (isProduction) {
    scriptList.push(getFaceBookPixelPrepare());
    scriptList.push(getCriteoScript());
    scriptList.push(getADInsightScript());
    scriptList.push(getSentryTestingScript());
    scriptList.push(getJSONDataScript());
    scriptList.push(getGoogleTagManagerScript());
  }

  return scriptList;
};
var runMarketingHeaderScript = function runMarketingHeaderScript(user) {
  var isProduction = true;

  if (isProduction) {
    runGoogleTagManagerScript(user);
    runFaceBookPixelCodeScript();
    runCriteoScript(user);
    runProdLogOhouseScript(user);
    runAmplitudeScript(isProduction, user);
    runSentryTestingScript(isProduction, user);
    runAirbridgeScript(user);
    runA1mediaScript();
  } else {
    runPrepareScript();
  }
};
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/@bucketplace/bucket-log/dist/index.esm.js
var index_esm = __webpack_require__(5061);
;// CONCATENATED MODULE: ./src/utils/cookie.ts

var VISITOR_ID_KEY = 'b_visitor_id';
var getCookie = function getCookie(cookieName) {
  var _document;

  var cookieValue = null;

  if ((_document = document) !== null && _document !== void 0 && _document.cookie) {
    var array = document.cookie.split("".concat(escape(cookieName), "="));

    if (array.length >= 2) {
      var arraySub = array[1].split(';');
      cookieValue = unescape(arraySub[0]);
    }
  }

  return cookieValue;
};
var setCookie = function setCookie(name, value, delay) {
  document.cookie = ["".concat(name, "=").concat(value), 'path=/', 'domain=.ohou.se', "expires=".concat(new Date(Date.now() + delay).toUTCString())].join(';');
  document.cookie = ["".concat(name, "=").concat(value), 'path=/', "expires=".concat(new Date(Date.now() + delay).toUTCString())].join(';');
};
/**
 * document.cookie를 object 형태로 변환합니다.
 * @param {string} cookieString document.cookie
 * @return {object} cookie의 키-값 쌍
 */

var getDocumentCookieObject = function getDocumentCookieObject(cookieString) {
  return cookieString.split('; ').reduce(function (prev, current) {
    var _current$split = current.split('='),
        _current$split2 = _toArray(_current$split),
        name = _current$split2[0],
        value = _current$split2.slice(1);

    prev[name] = value.join('=');
    return prev;
  }, {});
};
/**
 * document.cookie에서 b_visitor_id 값을 추출합니다.
 * @param {object} context next api context
 * @return {string|undefined} b_visitor_id 값
 */

var getVisitorId = function getVisitorId(context) {
  var _context$req, _context$req$headers;

  var cookieObj = getDocumentCookieObject(((_context$req = context.req) === null || _context$req === void 0 ? void 0 : (_context$req$headers = _context$req.headers) === null || _context$req$headers === void 0 ? void 0 : _context$req$headers.cookie) || '');
  return cookieObj[VISITOR_ID_KEY];
};
// EXTERNAL MODULE: ./src/utils/tracking.ts
var tracking = __webpack_require__(76170);
;// CONCATENATED MODULE: ./src/utils/Navigation/banner.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var LOG_MAP = {
  'banner.top.pc.click': {
    bucket: {
      section: '네비 배너'
    }
  },
  'banner.top.pc.close': {
    bucket: {
      section: '네비 배너 닫기'
    },
    cookie: 'ohsTopBannerClosed'
  },
  'banner.top.mobile.click': {
    bucket: {
      section: '네비 배너'
    }
  },
  'banner.top.mobile.close': {
    bucket: {
      section: '네비 배너 닫기'
    },
    cookie: 'ohsTopBannerClosed'
  },
  'banner.bottom.mobile.click': {
    bucket: {
      section: '앱 다운로드'
    }
  },
  'banner.bottom.mobile.close': {
    bucket: {
      section: '앱 다운로드 닫기'
    },
    cookie: 'ohsAppDownloadPopupClosed'
  }
};
var handleLog = function handleLog(type, index) {
  var _LOG_MAP$type = LOG_MAP[type],
      bucket = _LOG_MAP$type.bucket,
      cookie = _LOG_MAP$type.cookie;

  if (index !== undefined) {
    bucket = _objectSpread(_objectSpread({}, bucket), {}, {
      index: index
    });
  }

  if (bucket) {
    (0,index_esm.bucketLog)(_objectSpread({
      category: 'click'
    }, bucket));
  }

  if (cookie) {
    setCookie(cookie, 'yes', 24 * 3600 * 1000);
  }
};
var APP_OPEN_MAP = {
  'banner.bottom.mobile.click': {
    sub_id_1: 'web_bottom_bnr'
  },
  'banner.top.mobile.click': {
    sub_id_1: 'web_top_bnr'
  }
};
var handleOpenApp = function handleOpenApp(type) {
  window.location.href = (0,tracking/* getDeepLink */.bW)(APP_OPEN_MAP[type]);
};
// EXTERNAL MODULE: ./node_modules/querystring/index.js
var querystring = __webpack_require__(17673);
// EXTERNAL MODULE: ./node_modules/humps/humps.js
var humps = __webpack_require__(56264);
// EXTERNAL MODULE: ./src/common/index.ts + 2 modules
var common = __webpack_require__(24911);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/@bucketplace/design-system/dist/index.js
var dist = __webpack_require__(41149);
;// CONCATENATED MODULE: ./src/utils/search.ts



var filterHistory = function filterHistory(history, query) {
  return typeof history === 'string' ? history !== query : history.query !== query;
};
var getHistories = function getHistories() {
  var matches = document.cookie.match(new RegExp('(?:^|; )searchHistory=([^;]*)'));
  return matches ? JSON.parse(decodeURIComponent(matches[1])) : [];
};
var setHistories = function setHistories(histories) {
  var value = encodeURIComponent(JSON.stringify(histories.slice(0, 5)));
  document.cookie = "searchHistory=".concat(value, "; domain=").concat(window.location.hostname, "; max-age=2147483647;");
};
var appendHistory = function appendHistory(history) {
  var query = typeof history === 'string' ? history : history.query;
  setHistories([history].concat((0,toConsumableArray/* default */.Z)(getHistories().filter(function (h) {
    return filterHistory(h, query);
  }))));
};
var removeHistory = function removeHistory(history) {
  var query = typeof history === 'string' ? history : history.query;
  setHistories(getHistories().filter(function (h) {
    return filterHistory(h, query);
  }));
};
var removeHistoryAll = function removeHistoryAll() {
  setHistories([]);
};
function getSearchPath(type, query) {
  switch (type) {
    case dist/* SEARCH_TYPE.STORE */.VOb.STORE:
      return '/productions/feed?' + querystring.stringify({
        query: query
      });

    case dist/* SEARCH_TYPE.EXPERT */.VOb.EXPERT:
      return '/expert_users?' + querystring.stringify({
        query: query
      });

    case dist/* SEARCH_TYPE.TOTAL */.VOb.TOTAL:
      return '/search/index?' + querystring.stringify({
        query: query
      });

    default:
      return '';
  }
}
// EXTERNAL MODULE: ./src/components/Layout/index.ts + 9 modules
var Layout = __webpack_require__(59989);
// EXTERNAL MODULE: ./src/utils/Navigation/tracking.ts
var Navigation_tracking = __webpack_require__(61563);
;// CONCATENATED MODULE: ./src/utils/Navigation/log.ts


function log_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function log_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? log_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : log_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable camelcase */



var log_handleLog = function handleLog(_ref) {
  var key = _ref.key,
      category = _ref.category,
      params = _ref.params;
  var logData = dist/* TYPE_MAP */.zY_[key](params || {})[category];

  var _ref2 = logData || {},
      bucket = _ref2.bucket,
      amplitude = _ref2.amplitude;

  if (bucket) {
    switch (category) {
      case 'click':
        {
          (0,index_esm.bucketLog)(log_objectSpread({
            category: 'click'
          }, bucket));
          break;
        }

      case 'impression':
        {
          (0,index_esm.bucketLog)({
            category: 'impression',
            data: [log_objectSpread(log_objectSpread({}, (0,index_esm.formattingLogData)(bucket)), {}, {
              time: Date.now()
            })]
          });
          break;
        }
    }
  }

  if (amplitude) {
    var type = amplitude.type,
        data = amplitude.data;
    (0,Navigation_tracking/* logAmplitude */.a)("".concat(type), data);
  }
};
;// CONCATENATED MODULE: ./src/utils/Navigation/menu.tsx


var getLoginPath = function getLoginPath(path, user) {
  if (user != null) {
    return path;
  }

  return "".concat(common/* OHS_HOST */.K2, "/users/sign_in?redirect_to=").concat(encodeURIComponent(path));
};

var getUserMenu = function getUserMenu(signOut, user) {
  return [{
    title: '마이페이지',
    href: user != null ? "".concat(common/* OHS_HOST */.K2, "/users/").concat(user.userId) : "".concat(common/* OHS_HOST */.K2, "/users/sign_in"),
    showOn: ['drawer', 'bar']
  }, {
    title: '나의 쇼핑',
    href: getLoginPath("".concat(common/* OHS_HOST */.K2, "/user_shopping_pages/order_list"), user),
    showOn: ['drawer', 'bar']
  }, {
    title: '스크랩북',
    href: user != null ? "".concat(common/* OHS_HOST */.K2, "/users/").concat(user.userId, "/collections") : "".concat(common/* OHS_HOST */.K2, "/users/sign_in"),
    showOn: ['drawer']
  }, {
    title: '알림',
    href: getLoginPath("".concat(common/* OHS_HOST */.K2, "/notifications/feed"), user),
    showOn: ['drawer']
  }, {
    title: '이벤트',
    href: "".concat(common/* OHS_HOST */.K2, "/competitions/feed"),
    showOn: ['drawer', 'bar']
  }, {
    title: '사진 올리기',
    href: getLoginPath("".concat(common/* OHS_HOST */.K2, "/contents/card_collections/new"), user),
    showOn: ['drawer']
  }, {
    title: '집들이 글쓰기',
    href: getLoginPath("".concat(common/* OHS_HOST */.K2, "/projects/write"), user),
    showOn: ['drawer']
  }, {
    title: '노하우 글쓰기',
    href: getLoginPath("".concat(common/* OHS_HOST */.K2, "/advices/write"), user),
    showOn: ['drawer']
  }, {
    title: '상품 리뷰 쓰기',
    href: getLoginPath("".concat(common/* OHS_HOST */.K2, "/production_reviews/write"), user),
    showOn: ['drawer']
  }, {
    title: '시공 전문가 리뷰 쓰기',
    href: getLoginPath("".concat(common/* OHS_HOST */.K2, "/expert_reviews/new?source=6"), user),
    showOn: ['drawer']
  }, user == null || user.userableType !== 'ExpertUser' ? {
    title: '전문가 신청',
    href: "".concat(common/* PRO_HOST */.Xt, "/?utm_source=ohouse&utm_medium=web&utm_campaign=prosignup&utm_content=myhome"),
    showOn: ['bar'],
    type: 'bottom'
  } : null, user == null || user.userableType !== 'SalesUser' ? {
    title: '판매자 신청',
    href: "".concat(common/* PARTNERS_HOST */.df, "/partner/applications/new"),
    showOn: ['bar'],
    type: 'bottom'
  } : null, {
    title: '고객센터',
    href: "".concat(common/* OHS_HOST */.K2, "/customer_center"),
    showOn: ['drawer', 'bar']
  }, user != null ? {
    title: '로그아웃',
    showOn: ['bar'],
    type: 'bottom',
    onClick: signOut
  } : null].filter(function (menu) {
    return menu != null;
  });
};
;// CONCATENATED MODULE: ./src/utils/Navigation/navigationProps.ts












var AUTOCOMPLETE_BASE_URL_STAGE = 'https://autocomplete.stage.datahou.se';
var AUTOCOMPLETE_BASE_URL_PROD = 'https://autocomplete.datahou.se';
var AUTOCOMPLETE_API_VERSION = 2;
var getSupplementary = function getSupplementary(userInfo, pathname, signOut, experiments) {
  var _userInfo$user, _userInfo$cartCount, _userInfo$notificatio;

  return {
    userProfile: userInfo === null || userInfo === void 0 ? void 0 : userInfo.user,
    userMenu: getUserMenu(signOut, userInfo === null || userInfo === void 0 ? void 0 : userInfo.user),
    scrap: {
      href: "".concat(common/* OHS_HOST */.K2, "/users/").concat(userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$user = userInfo.user) === null || _userInfo$user === void 0 ? void 0 : _userInfo$user.userId, "/collections")
    },
    cart: {
      count: (_userInfo$cartCount = userInfo === null || userInfo === void 0 ? void 0 : userInfo.cartCount) !== null && _userInfo$cartCount !== void 0 ? _userInfo$cartCount : 0,
      href: "".concat(common/* OHS_HOST */.K2, "/cart")
    },
    notification: {
      count: (_userInfo$notificatio = userInfo === null || userInfo === void 0 ? void 0 : userInfo.notificationCount) !== null && _userInfo$notificatio !== void 0 ? _userInfo$notificatio : 0,
      href: "".concat(common/* OHS_HOST */.K2, "/notifications/feed")
    },
    signin: {
      href: "".concat(common/* OHS_HOST */.K2, "/users/sign_in?redirect_to=/events").concat(encodeURIComponent(pathname))
    },
    signup: {
      href: "".concat(common/* OHS_HOST */.K2, "/normal_users/new")
    },
    cs: {
      href: "".concat(common/* OHS_HOST */.K2, "/customer_center")
    },
    seller: {
      href: "".concat(common/* OHS_HOST */.K2, "/sellers/auth/request_multi_factor_auth")
    },
    uploadMenuLinks: {
      photo: "".concat(common/* OHS_HOST */.K2, "/contents/card_collections/new").concat(experiments.contents === Layout/* CONTENTS_EXPERIMENT_TYPE.NEW */.X_.NEW ? '?media=photo' : ''),
      project: "".concat(common/* OHS_HOST */.K2, "/projects/write"),
      advice: "".concat(common/* OHS_HOST */.K2, "/advices/write"),
      productionReview: "".concat(common/* OHS_HOST */.K2, "/production_reviews/write"),
      expertReview: "".concat(common/* OHS_HOST */.K2, "/expert_reviews/new?source=6")
    }
  };
};

var handleSubmit = function handleSubmit(value, router, searchType) {
  if (value == null || value.trim() === '') {
    // Do nothing if value is empty
    return;
  }

  appendHistory(value);
  var path = getSearchPath(searchType, value);
  (0,Navigation_tracking/* logAmplitude */.a)('검색어 Searched', {
    search_type: searchType,
    query_type: '직접 입력',
    query: value
  });
  router.push("".concat(common/* OHS_HOST */.K2).concat(path));
};

var formatAutoCompleteKeywords = function formatAutoCompleteKeywords(data) {
  var _ref = (0,humps.camelizeKeys)(data),
      results = _ref.results;

  return results.map(function (item) {
    return {
      type: item.dataType,
      value: item,
      query: item.orgDisplay
    };
  });
};

var getSearchProps = function getSearchProps(router) {
  var searchType = 'store';
  return {
    searchType: searchType,
    onFetch: function () {
      var _onFetch = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(query) {
        var isProd, url, res, json;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isProd = "prod" === 'prod';
                url = isProd ? AUTOCOMPLETE_BASE_URL_PROD : AUTOCOMPLETE_BASE_URL_STAGE;
                _context.next = 4;
                return fetch("".concat(url, "/commerce?").concat((0,querystring.stringify)({
                  query: query,
                  v: "v".concat(AUTOCOMPLETE_API_VERSION)
                })), {
                  method: 'GET',
                  credentials: 'same-origin'
                });

              case 4:
                res = _context.sent;
                _context.next = 7;
                return res.json();

              case 7:
                json = _context.sent;
                return _context.abrupt("return", formatAutoCompleteKeywords(json));

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function onFetch(_x) {
        return _onFetch.apply(this, arguments);
      }

      return onFetch;
    }(),
    onSubmitItem: function onSubmitItem(item) {
      handleSubmit(item.query, router, searchType);
    },
    onSubmit: function onSubmit(value) {
      handleSubmit(value, router, searchType);
    },
    onInputFocus: function onInputFocus() {
      (0,index_esm.bucketLog)({
        category: 'click',
        section: '검색'
      });
      (0,Navigation_tracking/* logAmplitude */.a)('검색 필드 Clicked', {
        search_type: searchType
      });
    },
    placeholder: '쇼핑 검색',
    historyStorage: {
      get: getHistories,
      set: setHistories,
      append: appendHistory,
      remove: removeHistory,
      removeAll: removeHistoryAll
    }
  };
};

var handleDownloadApp = function handleDownloadApp() {
  window.location.href = (0,tracking/* getDeepLink */.bW)({
    sub_id_1: 'web_left_bnr'
  });
};

var getNavigationProps = function getNavigationProps(_ref2) {
  var navigationMenu = _ref2.navigationMenu,
      router = _ref2.router,
      userInfo = _ref2.userInfo,
      signOut = _ref2.signOut,
      experiments = _ref2.experiments;
  var query = router.query,
      asPath = router.asPath;
  var search = "?".concat((0,tracking/* getQueryString */.Wz)(query));
  return {
    menuSchema: navigationMenu,
    searchOptions: getSearchProps(router),
    supplementary: getSupplementary(userInfo, asPath, signOut, experiments),
    linkComponent: Layout/* SuperLink */.jf,
    fallbackMenuSchema: [],
    onLog: log_handleLog,
    onLogout: signOut,
    onAppDownload: handleDownloadApp,
    location: {
      pathname: asPath,
      search: search
    },
    logo: {
      href: common/* OHS_HOST */.K2
    }
  };
};
;// CONCATENATED MODULE: ./src/utils/Navigation/index.ts





/***/ }),

/***/ 61563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ logAmplitude; }
/* harmony export */ });
/* unused harmony export getAmplitude */
var windowObj =  true ? window : 0;
function getAmplitude() {
  var _windowObj$amplitude$, _windowObj$amplitude;

  if (windowObj.amplitude == null) return null;
  return (_windowObj$amplitude$ = (_windowObj$amplitude = windowObj.amplitude).getInstance) === null || _windowObj$amplitude$ === void 0 ? void 0 : _windowObj$amplitude$.call(_windowObj$amplitude);
}
function logAmplitude(type, data) {
  var amplitude = getAmplitude();
  if (amplitude == null) return;
  amplitude.logEvent(type, data);
}

/***/ }),

/***/ 14063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getAppOsInfo; },
/* harmony export */   "d": function() { return /* binding */ saveAppOsInfo; }
/* harmony export */ });
/* harmony import */ var querystring__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17673);
/* harmony import */ var _isSSR__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78751);


var saveAppOsInfo = function saveAppOsInfo() {
  var search = querystring__WEBPACK_IMPORTED_MODULE_0__.parse(location.search.slice(1));

  try {
    localStorage.os_type = search.os_type;
    localStorage.os_version = search.version;
  } catch (err) {//
  }
}; // TODO: Type 구체화

var getAppOsInfo = function getAppOsInfo() {
  if (_isSSR__WEBPACK_IMPORTED_MODULE_1__/* .isSSR */ .y) {
    return null;
  }

  var search = querystring__WEBPACK_IMPORTED_MODULE_0__.parse(location.search.slice(1));
  var osType = null;
  var osVersion = null;

  if (search.os_type != null) {
    osType = search.os_type;
    localStorage.os_type = search.os_type;
  } else {
    osType = localStorage.os_type;
  }

  if (search.version != null) {
    osVersion = search.version;
    localStorage.os_version = search.version;
  } else {
    osVersion = localStorage.os_version;
  }

  return {
    osType: osType,
    osVersion: osVersion
  };
};

/***/ }),

/***/ 90130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "jQ": function() { return /* reexport */ tracking/* airbridgeLogout */.jQ; },
  "Kc": function() { return /* reexport */ checkAppVersion; },
  "hX": function() { return /* reexport */ tracking/* filter */.hX; },
  "ZA": function() { return /* reexport */ OSVersion/* getAppOsInfo */.Z; },
  "l7": function() { return /* reexport */ getDeviceType; },
  "gk": function() { return /* reexport */ Navigation/* getNavigationProps */.gk; },
  "z2": function() { return /* reexport */ getOSType; },
  "pm": function() { return /* reexport */ tracking/* getQuery */.pm; },
  "Wz": function() { return /* reexport */ tracking/* getQueryString */.Wz; },
  "fe": function() { return /* reexport */ handleClickLog; },
  "mT": function() { return /* reexport */ Navigation/* handleLog */.My; },
  "Qe": function() { return /* reexport */ Navigation/* handleOpenApp */.Qe; },
  "a4": function() { return /* reexport */ intComma; },
  "Z0": function() { return /* reexport */ isInApp; },
  "tq": function() { return /* reexport */ isMobile; },
  "d5": function() { return /* reexport */ OSVersion/* saveAppOsInfo */.d; },
  "gu": function() { return /* reexport */ tracking/* sendA1MediaInflow */.gu; },
  "A2": function() { return /* reexport */ tracking/* setUtmData */.A2; },
  "P2": function() { return /* reexport */ throttle; },
  "Vl": function() { return /* reexport */ useAutoChangeComponent; }
});

// UNUSED EXPORTS: ANDROID_VERSION_ERROR_NAME, detectDeviceSSR, fetchKakaoAPI, formatOsType, getCookie, getDeepLink, getDocumentCookieObject, getMarketingFooterScript, getMarketingHeaderScript, getOSTypeSSR, getSupplementary, getUtmData, getUtmDataFromUrl, getVisitorId, imageLoader, isEmptyString, isSSR, memoize, omitKeys, runAmplitudeScript, runMarketingFooterScript, runMarketingHeaderScript, sendAirbridgeLog, setCookie, share, shareKakao, useDetectDevice

// EXTERNAL MODULE: ./node_modules/querystring/index.js
var querystring = __webpack_require__(17673);
// EXTERNAL MODULE: ./node_modules/ua-parser-js/src/ua-parser.js
var ua_parser = __webpack_require__(42238);
var ua_parser_default = /*#__PURE__*/__webpack_require__.n(ua_parser);
// EXTERNAL MODULE: ./src/utils/isSSR.ts
var isSSR = __webpack_require__(78751);
;// CONCATENATED MODULE: ./src/utils/detectDevice.ts




var isMobile = function isMobile() {
  if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
    return true;
  }

  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
};
var isInApp = function isInApp(query) {
  if (isSSR/* isSSR */.y) {
    if (query != null) {
      return query.os_type != null || query.app != null;
    }

    return false;
  }

  var triggered = false;

  try {
    triggered = sessionStorage.webviewTriggered === 'yes';
  } catch (e) {//
  }

  var search = querystring.parse(location.search.slice(1));

  if (triggered || search.os_type != null && search.os_type !== '' || search.app != null) {
    try {
      sessionStorage.webviewTriggered = 'yes';
    } catch (e) {//
    }

    return true;
  }

  return false;
};
var useDetectDevice = function useDetectDevice() {
  var isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 768px)'
  });

  if (isInApp()) {
    return 'mobile';
  }

  if (isDesktopOrLaptop) {
    return 'web';
  }

  return 'mobileWeb';
};
var getOSType = function getOSType(query) {
  var _navigator;

  if (isSSR/* isSSR */.y) return 'WEB';
  var osType = query === null || query === void 0 ? void 0 : query.os_type;
  var osTypeParams = osType === null || osType === void 0 ? void 0 : osType.toUpperCase();
  var userAgent = (_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.userAgent;
  var parser = new (ua_parser_default())(userAgent);
  var result = parser.getResult();
  var isApp = osTypeParams && ['ANDROID', 'IOS'].includes(osTypeParams);

  if (isApp) {
    return osTypeParams;
  } else if (result.device.type) {
    return result.os.name === 'iOS' ? 'MWEBIOS' : 'MWEBANDROID';
  } else {
    return 'WEB';
  }
};
var getOSTypeSSR = function getOSTypeSSR(req) {
  var _req$_parsedUrl, _params$get;

  var params = new URLSearchParams(req === null || req === void 0 ? void 0 : (_req$_parsedUrl = req._parsedUrl) === null || _req$_parsedUrl === void 0 ? void 0 : _req$_parsedUrl.query);
  var osTypeParams = (_params$get = params.get('os_type')) === null || _params$get === void 0 ? void 0 : _params$get.toUpperCase();
  var userAgent = req === null || req === void 0 ? void 0 : req.headers['user-agent'];
  var parser = new UAParser(userAgent);
  var result = parser.getResult();
  var isApp = osTypeParams && ['ANDROID', 'IOS'].includes(osTypeParams);

  if (isApp) {
    return osTypeParams;
  } else if (result.device.type) {
    return result.os.name === 'iOS' ? 'MWEBIOS' : 'MWEBANDROID';
  } else {
    return 'WEB';
  }
};
var getDeviceType = function getDeviceType(osType) {
  switch (osType) {
    case 'IOS':
    case 'ANDROID':
      return 'mobile';

    case 'MWEBANDROID':
    case 'MWEBIOS':
      return 'mobileWeb';

    case 'WEB':
      return 'web';
  }
};
var detectDeviceSSR = function detectDeviceSSR(req) {
  var osType = getOSTypeSSR(req);
  return getDeviceType(osType);
};
// EXTERNAL MODULE: ./src/utils/tracking.ts
var tracking = __webpack_require__(76170);
// EXTERNAL MODULE: ./src/hooks/index.ts + 10 modules
var hooks = __webpack_require__(37910);
;// CONCATENATED MODULE: ./src/utils/autoChangeComponent.ts

var useAutoChangeComponent = function useAutoChangeComponent(targetDate) {
  var _useNowTime = (0,hooks/* useNowTime */.bg)(),
      nowDate = _useNowTime.data,
      error = _useNowTime.error;

  if (!nowDate || error) {
    return function (original, _) {
      return original;
    };
  }

  return function (original, change) {
    if (nowDate > targetDate) {
      return change;
    } else {
      return original;
    }
  };
};
// EXTERNAL MODULE: ./src/utils/OSVersion.ts
var OSVersion = __webpack_require__(14063);
// EXTERNAL MODULE: ./src/utils/Navigation/index.ts + 8 modules
var Navigation = __webpack_require__(89897);
;// CONCATENATED MODULE: ./src/utils/throttle.ts
var throttle = function throttle(callback) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var waiting = false;
  return function (args) {
    if (!waiting) {
      callback(args);
      waiting = true;
      setTimeout(function () {
        waiting = false;
      }, limit);
    }
  };
};
;// CONCATENATED MODULE: ./src/utils/text.ts
var intComma = function intComma(x) {
  if (x == null || isNaN(Number(x))) {
    return '';
  }

  return x.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
;// CONCATENATED MODULE: ./src/utils/share.ts




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Web Share API를 사용하여 시스템 공유창을 띄웁니다.
 * @param {object} data ShareData(lib.dom.d.ts)
 * @param {function} fallback Web Share API가 지원되지 않는 환경인 경우의 fallback
 * @return {Promise} Promise&lt;void&gt;
 */
var share = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var _ref$data, data, fallback, _document;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref$data = _ref.data, data = _ref$data === void 0 ? {} : _ref$data, fallback = _ref.fallback;

            if (!navigator.share) {
              _context.next = 12;
              break;
            }

            _context.prev = 2;
            _context.next = 5;
            return navigator.share(_objectSpread({
              title: data.title || ((_document = document) === null || _document === void 0 ? void 0 : _document.title)
            }, data));

          case 5:
            _context.next = 10;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](2);
            console.error(_context.t0);

          case 10:
            _context.next = 13;
            break;

          case 12:
            fallback === null || fallback === void 0 ? void 0 : fallback();

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 7]]);
  }));

  return function share(_x) {
    return _ref2.apply(this, arguments);
  };
}()));
// EXTERNAL MODULE: ./src/campaign/utils/kakao.ts
var kakao = __webpack_require__(11399);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
;// CONCATENATED MODULE: ./src/utils/handleClickLog.ts


var handleClickLog = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {
    var osType, promotionId, type;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            osType = _ref.osType, promotionId = _ref.promotionId, type = _ref.type;
            _context.prev = 1;
            _context.next = 4;
            return fetch('/api/clicks', {
              headers: {
                'Content-Type': 'application/json'
              },
              credentials: 'include',
              method: 'PUT',
              body: JSON.stringify({
                promotionId: promotionId,
                platform: osType,
                type: type
              })
            });

          case 4:
            _context.next = 8;
            break;

          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](1);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 6]]);
  }));

  return function handleClickLog(_x) {
    return _ref2.apply(this, arguments);
  };
}();
;// CONCATENATED MODULE: ./src/utils/platform.ts
var formatOsType = function formatOsType(osType) {
  switch (osType) {
    case 'Android':
      return 'aos';

    case 'iOS':
      return 'ios';

    case 'mWebIOS':
    case 'mWebAndroid':
      return 'mweb';

    default:
      return 'web';
  }
};
var checkAppVersion = function checkAppVersion(_ref) {
  var _ref$osType = _ref.osType,
      osType = _ref$osType === void 0 ? 'Web' : _ref$osType,
      currentVersion = _ref.currentVersion,
      androidVersion = _ref.androidVersion,
      iosVersion = _ref.iosVersion;
  var targetSelected;

  if (osType === 'Android') {
    targetSelected = androidVersion;
  } else if (osType === 'iOS') {
    targetSelected = iosVersion;
  } else {
    return true;
  }

  if (currentVersion == null) {
    return true;
  }

  var versionFragments = currentVersion.split('.');
  var targetFragments = targetSelected.split('.');

  for (var i = 0; i < targetFragments.length; i += 1) {
    var _versionFragments$i;

    var targetFragment = parseInt(targetFragments[i], 10);
    var versionFragment = parseInt((_versionFragments$i = versionFragments[i]) !== null && _versionFragments$i !== void 0 ? _versionFragments$i : '0', 10);

    if (targetFragment > versionFragment) {
      return false;
    } else if (targetFragment < versionFragment) {
      return true;
    }
  }

  return true;
};
;// CONCATENATED MODULE: ./src/utils/index.ts

















/***/ }),

/***/ 78751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ isSSR; }
/* harmony export */ });
var isSSR = false;

/***/ }),

/***/ 76170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A2": function() { return /* binding */ setUtmData; },
/* harmony export */   "Wz": function() { return /* binding */ getQueryString; },
/* harmony export */   "bW": function() { return /* binding */ getDeepLink; },
/* harmony export */   "gu": function() { return /* binding */ sendA1MediaInflow; },
/* harmony export */   "hX": function() { return /* binding */ filter; },
/* harmony export */   "jQ": function() { return /* binding */ airbridgeLogout; },
/* harmony export */   "pm": function() { return /* binding */ getQuery; }
/* harmony export */ });
/* unused harmony exports memoize, omitKeys, getUtmDataFromUrl, getUtmData, sendAirbridgeLog */
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16835);
/* harmony import */ var querystring__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17673);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _bucketplace_bucket_log__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5061);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var QUERY_BLACKLIST = ['airbridge_referrer', 'fallback_ios', 'fallback_android', 'short_id', 'https_deeplink', 'campaign', 'ad_group', 'ad_creative', 'term', 'deeplink_url', 'fallback_desktop', 'n_media', 'n_query', 'n_rank', 'n_ad_group', 'n_ad', 'n_keyword_id', 'n_keyword', 'n_campaign_type', 'n_ad_group_type', 'NaPm', 'routing_short_id', 'content', 'sub_id_1', 'sub_id_2', 'sub_id_3', 'campaign_id', 'ad_group_id', 'ad_creative_id', 'term_id'];
var UTM_TAG_LIST = ['source', 'utm_source', 'utm_campaign', 'utm_content', 'utm_media', 'utm_term', 'utm_medium', 'bp_adset', 'bp_content', 'bp_sub_id', 'bp_sub_id_1', 'bp_sub_id_2'];
function memoize(func) {
  var prevArgs = null;
  var prevResult = null;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (prevArgs == null || prevArgs.length !== args.length || prevArgs.some(function (v, i) {
      return v !== args[i];
    })) {
      prevArgs = args;
      prevResult = func.apply(void 0, args);
    }

    return prevResult;
  };
} // eslint-disable-next-line @typescript-eslint/ban-types

function omitKeys(obj, keys) {
  var output = {};
  Object.keys(obj).filter(function (k) {
    return !keys.includes(k);
  }).forEach(function (k) {
    return output[k] = obj[k];
  });
  return output;
}
function filter(obj, cb) {
  var output = {};

  for (var _k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, _k) && cb(obj[_k], _k)) {
      output[_k] = obj[_k];
    }
  }

  return output;
}
var getQueryString = function getQueryString(query) {
  return querystring__WEBPACK_IMPORTED_MODULE_1__.stringify(query);
};
var getQuery = memoize(function (url) {
  var search = (/\?(.+)$/.exec(url) || ['', ''])[1];
  return querystring__WEBPACK_IMPORTED_MODULE_1__.parse(search.replace(/&amp;/g, '&'));
});
/**
 * 쿼리 문자열에서 utm 파라미터 객체를 추출합니다.
 * @param {string} queryString utmData를 추출하고픈 target 쿼리 문자열
 * @return {object} 추출된 utm 파라미터 객체
 */

var getUtmDataFromUrl = function getUtmDataFromUrl(queryString) {
  var query = getQuery(queryString !== null && queryString !== void 0 ? queryString : location.search);
  var utmQuery = (0,lodash__WEBPACK_IMPORTED_MODULE_2__.pick)(query, UTM_TAG_LIST);
  return escapeBracesInQuery(utmQuery);
};
var getUtmData = function getUtmData() {
  try {
    return JSON.parse(sessionStorage['ohsUtmData'] || '{}');
  } catch (e) {
    //
    return {};
  }
};
/**
 * 현재 url의 utmData를 추출하여 sessionStorage에 저장합니다.
 */

var setUtmData = function setUtmData() {
  var urlData = getUtmDataFromUrl();
  if ((0,lodash__WEBPACK_IMPORTED_MODULE_2__.isEmpty)(urlData)) return;

  try {
    sessionStorage.setItem('ohsUtmData', JSON.stringify(urlData));
  } catch (e) {//
  }
}; // eslint-disable-next-line @typescript-eslint/ban-types

function escapeBracesInQuery(query) {
  var trimmed = Object.fromEntries(Object.entries(query).map(function (_ref) {
    var _ref2 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return [key, value === null || value === void 0 ? void 0 : value.replace(/([\\_]?{[^}]+})+/g, '')];
  }));
  return filter(trimmed, function (v) {
    return v != null && v !== '';
  });
}

var getDeepLink = function getDeepLink(additionalParams, pathname, query) {
  var queryObj = getQuery(query !== null && query !== void 0 ? query : location.search);
  var essentialQuery = filter(_objectSpread({}, omitKeys(queryObj, [].concat(UTM_TAG_LIST, QUERY_BLACKLIST))), function (v) {
    return v != null;
  });
  var escapedQuery = escapeBracesInQuery(essentialQuery);
  var searchString = querystring__WEBPACK_IMPORTED_MODULE_1__.stringify(_objectSpread(_objectSpread({}, escapedQuery), {}, {
    click_action_type: 'webview'
  }));
  var path = "/events".concat(pathname !== null && pathname !== void 0 ? pathname : location.pathname, "?").concat(searchString);
  var utmData = getUtmData(); // const isProd = process.env.APP_PROFILE === 'prod';
  // const host = isProd ? 'ohou.se': 'stage-web.dailyhou.se';

  return "https://link.ohou.se/@ohouse/".concat(utmData['utm_source'] || 'web_organic', "?") + querystring__WEBPACK_IMPORTED_MODULE_1__.stringify(_objectSpread({
    deeplink_url: "ohouseapp://ohou.se".concat(path),
    fallback_desktop: "https://ohou.se".concat(path),
    campaign: queryObj.campaign || utmData['utm_campaign'],
    term: queryObj.term || utmData['utm_term'],
    client_id: (0,_bucketplace_bucket_log__WEBPACK_IMPORTED_MODULE_3__.getPageVariable)('visitor_id'),
    sub_id: queryObj.sub_id || utmData['bp_sub_id'],
    sub_id_1: 'ohouseWeb',
    sub_id_2: queryObj.sub_id_2 || utmData['bp_sub_id_2'],
    sub_id_3: queryObj.sub_id_3 || utmData['utm_medium'],
    ad_creative: queryObj.ad_creative || utmData['utm_content'],
    ad_group: queryObj.ad_group || utmData['bp_adset'],
    content: queryObj.content || utmData['bp_content']
  }, additionalParams !== null && additionalParams !== void 0 ? additionalParams : {}));
};
var airbridgeLogout = function airbridgeLogout() {
  var _window, _window$airbridge;

  sendAirbridgeLog({
    category: 'airbridge.user.signout'
  });
  (_window = window) === null || _window === void 0 ? void 0 : (_window$airbridge = _window.airbridge) === null || _window$airbridge === void 0 ? void 0 : _window$airbridge.clearUser();
};
var sendAirbridgeLog = function sendAirbridgeLog(_ref3) {
  var _window2, _window2$airbridge, _window2$airbridge$ev;

  var category = _ref3.category,
      attribute = _ref3.attribute;
  (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$airbridge = _window2.airbridge) === null || _window2$airbridge === void 0 ? void 0 : (_window2$airbridge$ev = _window2$airbridge.events) === null || _window2$airbridge$ev === void 0 ? void 0 : _window2$airbridge$ev.send(category, attribute);
};
var KEYWORD_INFLOW_PATH_LIST = ['google', 'brand_google', 'naver', 'brand_naver', 'daum', 'brand_daum'];
var SHOPPING_INFLOW_PATH_LIST = ['naver_shop', 'google_shop', 'enuri_shop', 'googleadwords_int'];
var sendA1MediaInflow = function sendA1MediaInflow() {
  var utmData = getUtmData();

  if (KEYWORD_INFLOW_PATH_LIST.includes(utmData === null || utmData === void 0 ? void 0 : utmData.utm_source)) {
    var _window3, _window3$linkback, _window3$linkback$sen;

    (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$linkback = _window3.linkback) === null || _window3$linkback === void 0 ? void 0 : (_window3$linkback$sen = _window3$linkback.send) === null || _window3$linkback$sen === void 0 ? void 0 : _window3$linkback$sen.call(_window3$linkback, 'inflow');
  } else if (SHOPPING_INFLOW_PATH_LIST.includes(utmData === null || utmData === void 0 ? void 0 : utmData.utm_source)) {
    var _window4, _window4$linkback, _window4$linkback$tra;

    (_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$linkback = _window4.linkback) === null || _window4$linkback === void 0 ? void 0 : (_window4$linkback$tra = _window4$linkback.track) === null || _window4$linkback$tra === void 0 ? void 0 : _window4$linkback$tra.call(_window4$linkback, 'inflow');
  }
};

/***/ }),

/***/ 6840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(74127);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 40993:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 29885:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(72717)


/***/ }),

/***/ 41664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(7942)


/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(69898)


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(72189)


/***/ }),

/***/ 34155:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 62587:
/***/ (function(module) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (Array.isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};


/***/ }),

/***/ 12361:
/***/ (function(module) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return Object.keys(obj).map(function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (Array.isArray(obj[k])) {
        return obj[k].map(function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).filter(Boolean).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};


/***/ }),

/***/ 17673:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(62587);
exports.encode = exports.stringify = __webpack_require__(12361);


/***/ }),

/***/ 69590:
/***/ (function(module) {

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),

/***/ 69921:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 59864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(69921);
} else {}


/***/ }),

/***/ 9764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "GroupedVirtuoso": function() { return /* binding */ mn; },
  "LogLevel": function() { return /* binding */ h; },
  "TableVirtuoso": function() { return /* binding */ dn; },
  "Virtuoso": function() { return /* binding */ cn; },
  "VirtuosoGrid": function() { return /* binding */ fn; },
  "VirtuosoGridMockContext": function() { return /* binding */ _t; },
  "VirtuosoMockContext": function() { return /* binding */ Gt; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@virtuoso.dev/urx/dist/urx.esm.js
var PUBLISH = 0;
var SUBSCRIBE = 1;
var RESET = 2;
var VALUE = 4;

/**
 * Utils includes
 * - a handful of functional utilities inspired by or taken from the [Ramda library](https://ramdajs.com/);
 * - TypeScript crutches - the [[tup]] function.
 *
 * Use these for your convenience - they are here so that urx is zero-dependency package.
 *
 * @packageDocumentation
 */

/**
 * Performs left to right composition of two functions.
 */
function compose(a, b) {
  return function (arg) {
    return a(b(arg));
  };
}
/**
 * Takes a value and applies a function to it.
 */

function thrush(arg, proc) {
  return proc(arg);
}
/**
 * Takes a 2 argument function and partially applies the first argument.
 */

function curry2to1(proc, arg1) {
  return function (arg2) {
    return proc(arg1, arg2);
  };
}
/**
 * Takes a 1 argument function and returns a function which when called, executes it with the provided argument.
 */

function curry1to0(proc, arg) {
  return function () {
    return proc(arg);
  };
}
/**
 * Returns a function which extracts the property from from the passed object.
 */

function prop(property) {
  return function (object) {
    return object[property];
  };
}
/**
 * Calls callback with the first argument, and returns it.
 */

function tap(arg, proc) {
  proc(arg);
  return arg;
}
/**
 *  Utility function to help typescript figure out that what we pass is a tuple and not a generic array.
 *  Taken from (this StackOverflow tread)[https://stackoverflow.com/questions/49729550/implicitly-create-a-tuple-in-typescript/52445008#52445008]
 */

function tup() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args;
}
/**
 * Calls the passed function.
 */

function call(proc) {
  proc();
}
/**
 * returns a function which when called always returns the passed value
 */

function always(value) {
  return function () {
    return value;
  };
}
/**
 * returns a function which calls all passed functions in the passed order.
 * joinProc does not pass arguments or collect return values.
 */

function joinProc() {
  for (var _len2 = arguments.length, procs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    procs[_key2] = arguments[_key2];
  }

  return function () {
    procs.map(call);
  };
}
function noop() {}

/**
 * urx Actions operate on streams - `publish` publishes data in a stream, and `subscribe` attaches a subscription to a stream.
 * @packageDocumentation
 */
/**
 * Subscribes the specified [[Subscription]] to the updates from the Emitter.
 * The emitter calls the subscription with the new data each time new data is published into it.
 *
 * ```ts
 * const foo = stream<number>();
 * subscribe(foo, (value) => console.log(value));
 * ```
 *
 * @returns an [[Unsubscribe]] handle  - calling it will unbind the subscription from the emitter.
 *```ts
 * const foo = stream<number>();
 * const unsub = subscribe(foo, (value) => console.log(value));
 * unsub();
 *```
 */

function subscribe(emitter, subscription) {
  return emitter(SUBSCRIBE, subscription);
}
/**
 * Publishes the value into the passed [[Publisher]].
 *
 * ```ts
 * const foo = stream<number>();
 * publish(foo, 42);
 * ```
 */

function publish(publisher, value) {
  publisher(PUBLISH, value);
}
/**
 * Clears all subscriptions from the [[Emitter]].
 * ```ts
 * const foo = stream<number>();
 * subscribe(foo, (value) => console.log(value));
 * reset(foo);
 * publish(foo, 42);
 * ```
 */

function urx_esm_reset(emitter) {
  emitter(RESET);
}
/**
 * Extracts the current value from a stateful stream. Use it only as an escape hatch, as it violates the concept of reactive programming.
 * ```ts
 * const foo = statefulStream(42);
 * console.log(getValue(foo));
 * ```
 */

function getValue(depot) {
  return depot(VALUE);
}
/**
 * Connects two streams - any value emitted from the emitter will be published in the publisher.
 * ```ts
 * const foo = stream<number>();
 * const bar = stream<number>();
 * subscribe(bar, (value) => console.log(`Bar emitted ${value}`));
 *
 * connect(foo, bar);
 * publish(foo);
 * ```
 * @returns an [[Unsubscribe]] handle which will disconnect the two streams.
 */

function connect(emitter, publisher) {
  return subscribe(emitter, curry2to1(publisher, PUBLISH));
}
/**
 * Executes the passed subscription at most once, for the next emit from the emitter.
 * ```ts
 * const foo = stream<number>()
 * handleNext(foo, value => console.log(value)) // called once, with 42
 * publish(foo, 42)
 * publish(foo, 43)
 * ```
 * @returns an [[Unsubscribe]] handle to unbind the subscription if necessary.
 */

function handleNext(emitter, subscription) {
  var unsub = emitter(SUBSCRIBE, function (value) {
    unsub();
    subscription(value);
  });
  return unsub;
}

/**
 * Streams are the basic building blocks of a reactive system. Think of them as the system permanent "data tubes".
 *
 * A stream acts as both an [[Emitter]] and [[Publisher]]. Each stream can have multiple {@link Subscription | Subscriptions}.
 *
 * urx streams are either **stateless** or **stateful**.
 * Stateless streams emit data to existing subscriptions when published, without keeping track of it.
 * Stateful streams remember the last published value and immediately publish it to new subscriptions.
 *
 * ```ts
 * import { stream, statefulStream, publish, subscribe } from "@virtuoso.dev/urx";
 *
 * // foo is a stateless stream
 * const foo = stream<number>();
 *
 * publish(foo, 42);
 * // this subsription will not be called...
 * subscribe(foo, (value) => console.log(value));
 * // it will only catch published values after it
 * publish(foo, 43);
 *
 * // stateful streams always start with an initial value
 * const bar = statefulStream(42);
 *
 * // subscribing to a stateful stream
 * // immediately calls the subscription with the current value
 * subscribe(bar, (value) => console.log(value));
 *
 * // subsequent publishing works just like stateless streams
 * publish(bar, 43);
 * ```
 * @packageDocumentation
 */
/**
 * Constructs a new stateless stream.
 * ```ts
 * const foo = stream<number>();
 * ```
 * @typeParam T the type of values to publish in the stream.
 * @returns a [[Stream]]
 */

function stream() {
  var subscriptions = [];
  return function (action, arg) {
    switch (action) {
      case RESET:
        subscriptions.splice(0, subscriptions.length);
        return;

      case SUBSCRIBE:
        subscriptions.push(arg);
        return function () {
          var indexOf = subscriptions.indexOf(arg);

          if (indexOf > -1) {
            subscriptions.splice(indexOf, 1);
          }
        };

      case PUBLISH:
        subscriptions.slice().forEach(function (subscription) {
          subscription(arg);
        });
        return;

      default:
        throw new Error("unrecognized action " + action);
    }
  };
}
/**
 * Constructs a new stateful stream.
 * ```ts
 * const foo = statefulStream(42);
 * ```
 * @param initial the initial value in the stream.
 * @typeParam T the type of values to publish in the stream. If omitted, the function infers it from the initial value.
 * @returns a [[StatefulStream]]
 */

function statefulStream(initial) {
  var value = initial;
  var innerSubject = stream();
  return function (action, arg) {
    switch (action) {
      case SUBSCRIBE:
        var subscription = arg;
        subscription(value);
        break;

      case PUBLISH:
        value = arg;
        break;

      case VALUE:
        return value;
    }

    return innerSubject(action, arg);
  };
}
/**
 * Event handlers are special emitters which can have **at most one active subscription**.
 * Subscribing to an event handler unsubscribes the previous subscription, if present.
 * ```ts
 * const foo = stream<number>();
 * const fooEvent = eventHandler(foo);
 *
 * // will be called once with 42
 * subscribe(fooEvent, (value) => console.log(`Sub 1 ${value}`));
 * publish(foo, 42);
 *
 * // unsubscribes sub 1
 * subscribe(fooEvent, (value) => console.log(`Sub 2 ${value}`));
 * publish(foo, 43);
 * ```
 * @param emitter the source emitter.
 * @returns the single-subscription emitter.
 */

function eventHandler(emitter) {
  var unsub;
  var currentSubscription;

  var cleanup = function cleanup() {
    return unsub && unsub();
  };

  return function (action, subscription) {
    switch (action) {
      case SUBSCRIBE:
        if (subscription) {
          if (currentSubscription === subscription) {
            return;
          }

          cleanup();
          currentSubscription = subscription;
          unsub = subscribe(emitter, subscription);
          return unsub;
        } else {
          cleanup();
          return noop;
        }

      case RESET:
        cleanup();
        currentSubscription = null;
        return;

      default:
        throw new Error("unrecognized action " + action);
    }
  };
}
/**
 * Creates and connects a "junction" stream to the specified emitter. Often used with [[pipe]], to avoid the multiple evaluation of operator sets.
 *
 * ```ts
 * const foo = stream<number>();
 *
 * const fooX2 = pipe(
 *   foo,
 *   map((value) => {
 *     console.log(`multiplying ${value}`);
 *     return value * 2;
 *   })
 * );
 *
 * subscribe(fooX2, (value) => console.log(value));
 * subscribe(fooX2, (value) => console.log(value));
 *
 * publish(foo, 42); // executes the map operator twice for each subscription.
 *
 * const sharedFooX2 = streamFromEmitter(pipe(
 *   foo,
 *   map((value) => {
 *     console.log(`shared multiplying ${value}`);
 *     return value * 2;
 *   })
 * ));
 *
 * subscribe(sharedFooX2, (value) => console.log(value));
 * subscribe(sharedFooX2, (value) => console.log(value));
 *
 * publish(foo, 42);
 *```
 * @returns the resulting stream.
 */

function streamFromEmitter(emitter) {
  return tap(stream(), function (stream) {
    return connect(emitter, stream);
  });
}
/**
 * Creates and connects a "junction" stateful stream to the specified emitter. Often used with [[pipe]], to avoid the multiple evaluation of operator sets.
 *
 * ```ts
 * const foo = stream<number>();
 *
 * const fooX2 = pipe(
 *   foo,
 *   map((value) => {
 *     console.log(`multiplying ${value}`);
 *     return value * 2;
 *   })
 * );
 *
 * subscribe(fooX2, (value) => console.log(value));
 * subscribe(fooX2, (value) => console.log(value));
 *
 * publish(foo, 42); // executes the map operator twice for each subscription.
 *
 * const sharedFooX2 = statefulStreamFromEmitter(pipe(
 *   foo,
 *   map((value) => {
 *     console.log(`shared multiplying ${value}`);
 *     return value * 2;
 *   })
 * ), 42);
 *
 * subscribe(sharedFooX2, (value) => console.log(value));
 * subscribe(sharedFooX2, (value) => console.log(value));
 *
 * publish(foo, 42);
 *```
 * @param initial the initial value in the stream.
 * @returns the resulting stateful stream.
 */

function statefulStreamFromEmitter(emitter, initial) {
  return tap(statefulStream(initial), function (stream) {
    return connect(emitter, stream);
  });
}

/**
 *
 * Stream values can be transformed and controlled by {@link pipe | **piping**} through **operators**.
 * urx includes several operators like [[map]], [[filter]], [[scan]], and [[throttleTime]].
 * The [[withLatestFrom]] operator allows the combination of values from other streams.
 *
 * ```ts
 * const foo = stream<number>()
 *
 * // create an emitter that first adds 2 to the passed value, then multiplies it by * 2
 * const bar = pipe(foo, map(value => value + 2), map(value => value * 2))
 * subscribe(bar, value => console.log(value))
 * publish(foo, 2) // outputs 8
 * ```
 *
 * ### Implementing Custom Operators
 * To implement your own operators, implement the [[Operator]] interface.
 * @packageDocumentation
 */
/** @internal */

function combineOperators() {
  for (var _len = arguments.length, operators = new Array(_len), _key = 0; _key < _len; _key++) {
    operators[_key] = arguments[_key];
  }

  return function (subscriber) {
    return operators.reduceRight(thrush, subscriber);
  };
}

function pipe(source) {
  for (var _len2 = arguments.length, operators = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    operators[_key2 - 1] = arguments[_key2];
  }

  // prettier-ignore
  var project = combineOperators.apply(void 0, operators);
  return function (action, subscription) {
    switch (action) {
      case SUBSCRIBE:
        return subscribe(source, project(subscription));

      case RESET:
        urx_esm_reset(source);
        return;

      default:
        throw new Error("unrecognized action " + action);
    }
  };
}
/**
 * The default [[Comparator]] for [[distinctUntilChanged]] and [[duc]].
 */

function defaultComparator(previous, next) {
  return previous === next;
}
/**
 * Filters out identical values. Pass an optional [[Comparator]] if you need to filter non-primitive values.
 * ```ts
 * const foo = stream<number>()
 *
 * subscribe(
 *  pipe(foo, distinctUntilChanged()),
 *  console.log
 * ) // will be called only once
 *
 * publish(foo, 42)
 * publish(foo, 42)
 * ```
 */

function distinctUntilChanged(comparator) {
  if (comparator === void 0) {
    comparator = defaultComparator;
  }

  var current;
  return function (done) {
    return function (next) {
      if (!comparator(current, next)) {
        current = next;
        done(next);
      }
    };
  };
}
/**
 * Filters out values for which the predicator does not return `true`-ish.
 * ```ts
 * const foo = stream<number>()
 *
 * subscribe(
 *  pipe(foo, filter(value => value % 2 === 0)),
 *  console.log
 * ) // will be called only with even values
 *
 * publish(foo, 2)
 * publish(foo, 3)
 * publish(foo, 4)
 * publish(foo, 5)
 * ```
 */

function filter(predicate) {
  return function (done) {
    return function (value) {
      predicate(value) && done(value);
    };
  };
}
/**
 * Maps values using the provided project function.
 * ```ts
 * const foo = stream<number>()
 *
 * subscribe(
 *  pipe(foo, map(value => value * 2)),
 *  console.log
 * ) // 4, 6
 *
 * publish(foo, 2)
 * publish(foo, 3)
 * ```
 */

function map(project) {
  return function (done) {
    return compose(done, project);
  };
}
/**
 * Maps values to the hard-coded value.
 * ```ts
 * const foo = stream<number>()
 *
 * subscribe(
 *  pipe(foo, mapTo(3)),
 *  console.log
 * ) // 3, 3
 *
 * publish(foo, 1)
 * publish(foo, 2)
 * ```
 */

function mapTo(value) {
  return function (done) {
    return function () {
      return done(value);
    };
  };
}
/**
 * Works like Array#reduce.
 * Applies an accumulator function on the emitter, and outputs intermediate result. Starts with the initial value.
 * ```ts
 * const foo = stream<number>()
 *
 * subscribe(
 *  pipe(foo, scan((acc, value) => acc + value, 2),
 *  console.log
 * ) // 3, 5
 *
 * publish(foo, 1)
 * publish(foo, 2)
 * ```
 */

function scan(scanner, initial) {
  return function (done) {
    return function (value) {
      return done(initial = scanner(initial, value));
    };
  };
}
/**
 * Skips the specified amount of values from the emitter.
 * ```ts
 * const foo = stream<number>()
 *
 * subscribe(
 *  pipe(foo, skip(2)),
 *  console.log
 * ) // 3, 4
 *
 * publish(foo, 1) // skipped
 * publish(foo, 2) // skipped
 * publish(foo, 3)
 * publish(foo, 4)
 * ```
 */

function skip(times) {
  return function (done) {
    return function (value) {
      times > 0 ? times-- : done(value);
    };
  };
}
/**
 * Throttles flowing values at the provided interval in milliseconds.
 * [Throttle VS Debounce in SO](https://stackoverflow.com/questions/25991367/difference-between-throttling-and-debouncing-a-function).
 *
 * ```ts
 *  const foo = stream<number>()
 *  publish(foo, 1)
 *
 *  setTimeout(() => publish(foo, 2), 20)
 *  setTimeout(() => publish(foo, 3), 20)
 *
 *  subscribe(pipe(foo, throttleTime(50)), val => {
 *    console.log(value); // 3
 *  })
 * ```
 */

function throttleTime(interval) {
  var currentValue;
  var timeout;
  return function (done) {
    return function (value) {
      currentValue = value;

      if (timeout) {
        return;
      }

      timeout = setTimeout(function () {
        timeout = undefined;
        done(currentValue);
      }, interval);
    };
  };
}
/**
 * Debounces flowing values at the provided interval in milliseconds.
 * [Throttle VS Debounce in SO](https://stackoverflow.com/questions/25991367/difference-between-throttling-and-debouncing-a-function).
 *
 * ```ts
 *  const foo = stream<number>()
 *  publish(foo, 1)
 *
 *  setTimeout(() => publish(foo, 2), 20)
 *  setTimeout(() => publish(foo, 3), 20)
 *
 *  subscribe(pipe(foo, debounceTime(50)), val => {
 *    console.log(value); // 3
 *  })
 * ```
 */

function debounceTime(interval) {
  var currentValue;
  var timeout;
  return function (done) {
    return function (value) {
      currentValue = value;

      if (timeout) {
        clearTimeout(timeout);
      }

      timeout = setTimeout(function () {
        done(currentValue);
      }, interval);
    };
  };
}
function withLatestFrom() {
  for (var _len3 = arguments.length, sources = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    sources[_key3] = arguments[_key3];
  }

  var values = new Array(sources.length);
  var called = 0;
  var pendingCall = null;
  var allCalled = Math.pow(2, sources.length) - 1;
  sources.forEach(function (source, index) {
    var bit = Math.pow(2, index);
    subscribe(source, function (value) {
      var prevCalled = called;
      called = called | bit;
      values[index] = value;

      if (prevCalled !== allCalled && called === allCalled && pendingCall) {
        pendingCall();
        pendingCall = null;
      }
    });
  });
  return function (done) {
    return function (value) {
      var call = function call() {
        return done([value].concat(values));
      };

      if (called === allCalled) {
        call();
      } else {
        pendingCall = call;
      }
    };
  };
}

/**
 * Transformers change and combine streams, similar to operators.
 * urx comes with two combinators - [[combineLatest]] and [[merge]], and one convenience filter - [[duc]].
 *
 * @packageDocumentation
 */
/**
 * Merges one or more emitters from the same type into a new Emitter which emits values from any of the source emitters.
 * ```ts
 * const foo = stream<number>()
 * const bar = stream<number>()
 *
 * subscribe(merge(foo, bar), (value) => console.log(value)) // 42, 43
 *
 * publish(foo, 42)
 * publish(bar, 43)
 * ```
 */

function merge() {
  for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
    sources[_key] = arguments[_key];
  }

  return function (action, subscription) {
    switch (action) {
      case SUBSCRIBE:
        return joinProc.apply(void 0, sources.map(function (source) {
          return subscribe(source, subscription);
        }));

      case RESET:
        // do nothing, we are stateless
        return;

      default:
        throw new Error("unrecognized action " + action);
    }
  };
}
/**
 * A convenience wrapper that emits only the distinct values from the passed Emitter. Wraps [[pipe]] and [[distinctUntilChanged]].
 *
 * ```ts
 * const foo = stream<number>()
 *
 * // this line...
 * const a = duc(foo)
 *
 * // is equivalent to this
 * const b = pipe(distinctUntilChanged(foo))
 * ```
 *
 * @param source The source emitter.
 * @param comparator optional custom comparison function for the two values.
 *
 * @typeParam T the type of the value emitted by the source.
 *
 * @returns the resulting emitter.
 */

function duc(source, comparator) {
  if (comparator === void 0) {
    comparator = defaultComparator;
  }

  return pipe(source, distinctUntilChanged(comparator));
}
function combineLatest() {
  var innerSubject = stream();

  for (var _len2 = arguments.length, emitters = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    emitters[_key2] = arguments[_key2];
  }

  var values = new Array(emitters.length);
  var called = 0;
  var allCalled = Math.pow(2, emitters.length) - 1;
  emitters.forEach(function (source, index) {
    var bit = Math.pow(2, index);
    subscribe(source, function (value) {
      values[index] = value;
      called = called | bit;

      if (called === allCalled) {
        publish(innerSubject, values);
      }
    });
  });
  return function (action, subscription) {
    switch (action) {
      case SUBSCRIBE:
        if (called === allCalled) {
          subscription(values);
        }

        return subscribe(innerSubject, subscription);

      case RESET:
        return urx_esm_reset(innerSubject);

      default:
        throw new Error("unrecognized action " + action);
    }
  };
}

/**
 * `system` defines a specification of a system - its constructor, dependencies and if it should act as a singleton in a system dependency tree.
 * When called, system returns a [[SystemSpec]], which is then initialized along with its dependencies by passing it to [[init]].
 *
 * ```ts
 * @import { subscribe, publish, system, init, tup, connect, map, pipe } from 'urx'
 *
 * // a simple system with two streams
 * const sys1 = system(() => {
 *  const a = stream<number>()
 *  const b = stream<number>()
 *
 *  connect(pipe(a, map(value => value * 2)), b)
 *  return { a, b }
 * })
 *
 * // a second system which depends on the streams from the first one
 * const sys2 = system(([ {a, b} ]) => {
 *  const c = stream<number>()
 *  connect(pipe(b, map(value => value * 2)), c)
 *  // re-export the `a` stream, keep `b` internal
 *  return { a, c }
 * }, tup(sys1))
 *
 * // init will recursively initialize sys2 dependencies, in this case sys1
 * const { a, c } = init(sys2)
 * subscribe(c, c => console.log(`Value multiplied by 4`, c))
 * publish(a, 2)
 * ```
 *
 * #### Singletons in Dependency Tree
 *
 * By default, systems will be initialized only once if encountered multiple times in the dependency tree.
 * In the below dependency system tree, systems `b` and `c` will receive the same stream instances from system `a` when system `d` is initialized.
 * ```txt
 *   a
 *  / \
 * b   c
 *  \ /
 *   d
 * ```
 * If `a` gets `{singleton: false}` as a last argument, `init` creates two separate instances - one for `b` and one for `c`.
 *
 * @param constructor the system constructor function. Initialize and connect the streams in its body.
 *
 * @param dependencies the system dependencies, which the constructor will receive as arguments.
 * Use the [[tup]] utility **For TypeScript type inference to work correctly**.
 * ```ts
 * const sys3 = system(() => { ... }, tup(sys2, sys1))
 * ```
 * @param __namedParameters Options
 * @param singleton determines if the system will act as a singleton in a system dependency tree. `true` by default.
 */
function system(constructor, dependencies, _temp) {
  if (dependencies === void 0) {
    dependencies = [];
  }

  var _ref = _temp === void 0 ? {
    singleton: true
  } : _temp,
      singleton = _ref.singleton;

  return {
    id: id(),
    constructor: constructor,
    dependencies: dependencies,
    singleton: singleton
  };
}
/** @internal */

var id = function id() {
  return Symbol();
};
/**
 * Initializes a [[SystemSpec]] by recursively initializing its dependencies.
 *
 * ```ts
 * // a simple system with two streams
 * const sys1 = system(() => {
 *  const a = stream<number>()
 *  const b = stream<number>()
 *
 *  connect(pipe(a, map(value => value * 2)), b)
 *  return { a, b }
 * })
 *
 * const { a, b } = init(sys1)
 * subscribe(b, b => console.log(b))
 * publish(a, 2)
 * ```
 *
 * @returns the [[System]] constructed by the spec constructor.
 * @param systemSpec the system spec to initialize.
 */


function init(systemSpec) {
  var singletons = new Map();

  var _init = function _init(_ref2) {
    var id = _ref2.id,
        constructor = _ref2.constructor,
        dependencies = _ref2.dependencies,
        singleton = _ref2.singleton;

    if (singleton && singletons.has(id)) {
      return singletons.get(id);
    }

    var system = constructor(dependencies.map(function (e) {
      return _init(e);
    }));

    if (singleton) {
      singletons.set(id, system);
    }

    return system;
  };

  return _init(systemSpec);
}


//# sourceMappingURL=urx.esm.js.map

;// CONCATENATED MODULE: ./node_modules/@virtuoso.dev/react-urx/dist/react-urx.esm.js



function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var _excluded = ["children"];
/** @internal */

function omit(keys, obj) {
  var result = {};
  var index = {};
  var idx = 0;
  var len = keys.length;

  while (idx < len) {
    index[keys[idx]] = 1;
    idx += 1;
  }

  for (var prop in obj) {
    if (!index.hasOwnProperty(prop)) {
      result[prop] = obj[prop];
    }
  }

  return result;
}

var useIsomorphicLayoutEffect = typeof document !== 'undefined' ? react.useLayoutEffect : react.useEffect;
/**
 * Converts a system spec to React component by mapping the system streams to component properties, events and methods. Returns hooks for querying and modifying
 * the system streams from the component's child components.
 * @param systemSpec The return value from a [[system]] call.
 * @param map The streams to props / events / methods mapping Check [[SystemPropsMap]] for more details.
 * @param Root The optional React component to render. By default, the resulting component renders nothing, acting as a logical wrapper for its children.
 * @returns an object containing the following:
 *  - `Component`: the React component.
 *  - `useEmitterValue`: a hook that lets child components use values emitted from the specified output stream.
 *  - `useEmitter`: a hook that calls the provided callback whenever the specified stream emits a value.
 *  - `usePublisher`: a hook which lets child components publish values to the specified stream.
 *  <hr />
 */

function systemToComponent(systemSpec, map, Root) {
  var requiredPropNames = Object.keys(map.required || {});
  var optionalPropNames = Object.keys(map.optional || {});
  var methodNames = Object.keys(map.methods || {});
  var eventNames = Object.keys(map.events || {});
  var Context = (0,react.createContext)({});

  function applyPropsToSystem(system, props) {
    if (system['propsReady']) {
      publish(system['propsReady'], false);
    }

    for (var _iterator = _createForOfIteratorHelperLoose(requiredPropNames), _step; !(_step = _iterator()).done;) {
      var requiredPropName = _step.value;
      var stream = system[map.required[requiredPropName]];
      publish(stream, props[requiredPropName]);
    }

    for (var _iterator2 = _createForOfIteratorHelperLoose(optionalPropNames), _step2; !(_step2 = _iterator2()).done;) {
      var optionalPropName = _step2.value;

      if (optionalPropName in props) {
        var _stream = system[map.optional[optionalPropName]];
        publish(_stream, props[optionalPropName]);
      }
    }

    if (system['propsReady']) {
      publish(system['propsReady'], true);
    }
  }

  function buildMethods(system) {
    return methodNames.reduce(function (acc, methodName) {

      acc[methodName] = function (value) {
        var stream = system[map.methods[methodName]];
        publish(stream, value);
      };

      return acc;
    }, {});
  }

  function buildEventHandlers(system) {
    return eventNames.reduce(function (handlers, eventName) {
      handlers[eventName] = eventHandler(system[map.events[eventName]]);
      return handlers;
    }, {});
  }
  /**
   * A React component generated from an urx system
   */


  var Component = (0,react.forwardRef)(function (propsWithChildren, ref) {
    var children = propsWithChildren.children,
        props = _objectWithoutPropertiesLoose(propsWithChildren, _excluded);

    var _useState = (0,react.useState)(function () {
      return tap(init(systemSpec), function (system) {
        return applyPropsToSystem(system, props);
      });
    }),
        system = _useState[0];

    var _useState2 = (0,react.useState)(curry1to0(buildEventHandlers, system)),
        handlers = _useState2[0];

    useIsomorphicLayoutEffect(function () {
      for (var _iterator3 = _createForOfIteratorHelperLoose(eventNames), _step3; !(_step3 = _iterator3()).done;) {
        var eventName = _step3.value;

        if (eventName in props) {
          subscribe(handlers[eventName], props[eventName]);
        }
      }

      return function () {
        Object.values(handlers).map(urx_esm_reset);
      };
    }, [props, handlers, system]);
    useIsomorphicLayoutEffect(function () {
      applyPropsToSystem(system, props);
    });
    (0,react.useImperativeHandle)(ref, always(buildMethods(system)));
    return (0,react.createElement)(Context.Provider, {
      value: system
    }, Root ? (0,react.createElement)(Root, omit([].concat(requiredPropNames, optionalPropNames, eventNames), props), children) : children);
  });

  var usePublisher = function usePublisher(key) {
    return (0,react.useCallback)(curry2to1(publish, (0,react.useContext)(Context)[key]), [key]);
  };
  /**
   * Returns the value emitted from the stream.
   */


  var useEmitterValue = function useEmitterValue(key) {
    var context = (0,react.useContext)(Context);
    var source = context[key];

    var _useState3 = (0,react.useState)(curry1to0(getValue, source)),
        value = _useState3[0],
        setValue = _useState3[1];

    useIsomorphicLayoutEffect(function () {
      return subscribe(source, function (next) {
        if (next !== value) {
          setValue(always(next));
        }
      });
    }, [source, value]);
    return value;
  };

  var useEmitter = function useEmitter(key, callback) {
    var context = (0,react.useContext)(Context);
    var source = context[key];
    useIsomorphicLayoutEffect(function () {
      return subscribe(source, callback);
    }, [callback, source]);
  };

  return {
    Component: Component,
    usePublisher: usePublisher,
    useEmitterValue: useEmitterValue,
    useEmitter: useEmitter
  };
}


//# sourceMappingURL=react-urx.esm.js.map

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/react-virtuoso/dist/index.m.js
function c(){return c=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t},c.apply(this,arguments)}function m(t,e){if(null==t)return{};var n,o,r={},i=Object.keys(t);for(o=0;o<i.length;o++)e.indexOf(n=i[o])>=0||(r[n]=t[n]);return r}function d(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,o=new Array(e);n<e;n++)o[n]=t[n];return o}function f(t,e){var n="undefined"!=typeof Symbol&&t[Symbol.iterator]||t["@@iterator"];if(n)return(n=n.call(t)).next.bind(n);if(Array.isArray(t)||(n=function(t,e){if(t){if("string"==typeof t)return d(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);return"Object"===n&&t.constructor&&(n=t.constructor.name),"Map"===n||"Set"===n?Array.from(t):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?d(t,e):void 0}}(t))||e&&t&&"number"==typeof t.length){n&&(t=n);var o=0;return function(){return o>=t.length?{done:!0}:{done:!1,value:t[o++]}}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var p,h,g="undefined"!=typeof document?react.useLayoutEffect:react.useEffect;!function(t){t[t.DEBUG=0]="DEBUG",t[t.INFO=1]="INFO",t[t.WARN=2]="WARN",t[t.ERROR=3]="ERROR"}(h||(h={}));var v=((p={})[h.DEBUG]="debug",p[h.INFO]="log",p[h.WARN]="warn",p[h.ERROR]="error",p),S=system(function(){var t=statefulStream(h.ERROR);return{log:statefulStream(function(n,o,r){var i;void 0===r&&(r=h.INFO),r>=(null!=(i=("undefined"==typeof globalThis?window:globalThis).VIRTUOSO_LOG_LEVEL)?i:getValue(t))&&console[v[r]]("%creact-virtuoso: %c%s %o","color: #0253b3; font-weight: bold","color: initial",n,o)}),logLevel:t}},[],{singleton:!0});function C(t,e){void 0===e&&(e=!0);var n=(0,react.useRef)(null),o=function(t){};if("undefined"!=typeof ResizeObserver){var r=new ResizeObserver(function(e){var n=e[0].target;null!==n.offsetParent&&t(n)});o=function(t){t&&e?(r.observe(t),n.current=t):(n.current&&r.unobserve(n.current),n.current=null)}}return{ref:n,callbackRef:o}}function I(t,e){return void 0===e&&(e=!0),C(t,e).callbackRef}function T(t,e,n,o,r,i,a){return C(function(n){for(var l=function(t,e,n,o){var r=t.length;if(0===r)return null;for(var i=[],a=0;a<r;a++){var l=t.item(a);if(l&&void 0!==l.dataset.index){var s=parseInt(l.dataset.index),u=parseFloat(l.dataset.knownSize),c=e(l,"offsetHeight");if(0===c&&o("Zero-sized element, this should not happen",{child:l},h.ERROR),c!==u){var m=i[i.length-1];0===i.length||m.size!==c||m.endIndex!==s-1?i.push({startIndex:s,endIndex:s,size:c}):i[i.length-1].endIndex++}}}return i}(n.children,e,0,r),s=n.parentElement;!s.dataset.virtuosoScroller;)s=s.parentElement;var u="window"===s.firstElementChild.dataset.viewportType,c=a?a.scrollTop:u?window.pageYOffset||document.documentElement.scrollTop:s.scrollTop,m=a?a.scrollHeight:u?document.documentElement.scrollHeight:s.scrollHeight,d=a?a.offsetHeight:u?window.innerHeight:s.offsetHeight;o({scrollTop:Math.max(c,0),scrollHeight:m,viewportHeight:d}),null==i||i(function(t,e,n){return"normal"===e||null!=e&&e.endsWith("px")||n("row-gap was not resolved to pixel value correctly",e,h.WARN),"normal"===e?0:parseInt(null!=e?e:"0",10)}(0,getComputedStyle(n).rowGap,r)),null!==l&&t(l)},n)}function w(t,e){return Math.round(t.getBoundingClientRect()[e])}function x(t,e){return Math.abs(t-e)<1.01}function b(t,n,o,l,s){void 0===l&&(l=noop);var c=(0,react.useRef)(null),m=(0,react.useRef)(null),d=(0,react.useRef)(null),f=(0,react.useRef)(!1),p=(0,react.useCallback)(function(e){var o=e.target,r=o===window||o===document,i=r?window.pageYOffset||document.documentElement.scrollTop:o.scrollTop,a=r?document.documentElement.scrollHeight:o.scrollHeight,l=r?window.innerHeight:o.offsetHeight,s=function(){t({scrollTop:Math.max(i,0),scrollHeight:a,viewportHeight:l})};f.current?(0,react_dom.flushSync)(s):s(),f.current=!1,null!==m.current&&(i===m.current||i<=0||i===a-l)&&(m.current=null,n(!0),d.current&&(clearTimeout(d.current),d.current=null))},[t,n]);return (0,react.useEffect)(function(){var t=s||c.current;return l(s||c.current),p({target:t}),t.addEventListener("scroll",p,{passive:!0}),function(){l(null),t.removeEventListener("scroll",p)}},[c,p,o,l,s]),{scrollerRef:c,scrollByCallback:function(t){f.current=!0,c.current.scrollBy(t)},scrollToCallback:function(e){var o=c.current;if(o&&(!("offsetHeight"in o)||0!==o.offsetHeight)){var r,i,a,l="smooth"===e.behavior;if(o===window?(i=Math.max(w(document.documentElement,"height"),document.documentElement.scrollHeight),r=window.innerHeight,a=document.documentElement.scrollTop):(i=o.scrollHeight,r=w(o,"height"),a=o.scrollTop),e.top=Math.ceil(Math.max(Math.min(i-r,e.top),0)),x(r,i)||e.top===a)return t({scrollTop:a,scrollHeight:i,viewportHeight:r}),void(l&&n(!0));l?(m.current=e.top,d.current&&clearTimeout(d.current),d.current=setTimeout(function(){d.current=null,m.current=null,n(!0)},1e3)):m.current=null,o.scrollTo(e)}}}}var y=system(function(){var t=stream(),n=stream(),o=statefulStream(0),r=stream(),i=statefulStream(0),a=stream(),l=stream(),s=statefulStream(0),u=statefulStream(0),c=statefulStream(0),m=statefulStream(0),d=stream(),f=stream(),p=statefulStream(!1),h=statefulStream(!1);return connect(pipe(t,map(function(t){return t.scrollTop})),n),connect(pipe(t,map(function(t){return t.scrollHeight})),l),connect(n,i),{scrollContainerState:t,scrollTop:n,viewportHeight:a,headerHeight:s,fixedHeaderHeight:u,fixedFooterHeight:c,footerHeight:m,scrollHeight:l,smoothScrollTargetReached:r,react18ConcurrentRendering:h,scrollTo:d,scrollBy:f,statefulScrollTop:i,deviation:o,scrollingInProgress:p}},[],{singleton:!0}),H={lvl:0};function E(t,e,n,o,r){return void 0===o&&(o=H),void 0===r&&(r=H),{k:t,v:e,lvl:n,l:o,r:r}}function R(t){return t===H}function L(){return H}function F(t,e){if(R(t))return H;var n=t.k,o=t.l,r=t.r;if(e===n){if(R(o))return r;if(R(r))return o;var i=O(o);return U(W(t,{k:i[0],v:i[1],l:M(o)}))}return U(W(t,e<n?{l:F(o,e)}:{r:F(r,e)}))}function k(t,e,n){if(void 0===n&&(n="k"),R(t))return[-Infinity,void 0];if(t[n]===e)return[t.k,t.v];if(t[n]<e){var o=k(t.r,e,n);return-Infinity===o[0]?[t.k,t.v]:o}return k(t.l,e,n)}function z(t,e,n){return R(t)?E(e,n,1):e===t.k?W(t,{k:e,v:n}):function(t){return D(G(t))}(W(t,e<t.k?{l:z(t.l,e,n)}:{r:z(t.r,e,n)}))}function B(t,e,n){if(R(t))return[];var o=t.k,r=t.v,i=t.r,a=[];return o>e&&(a=a.concat(B(t.l,e,n))),o>=e&&o<=n&&a.push({k:o,v:r}),o<=n&&(a=a.concat(B(i,e,n))),a}function P(t){return R(t)?[]:[].concat(P(t.l),[{k:t.k,v:t.v}],P(t.r))}function O(t){return R(t.r)?[t.k,t.v]:O(t.r)}function M(t){return R(t.r)?t.l:U(W(t,{r:M(t.r)}))}function W(t,e){return E(void 0!==e.k?e.k:t.k,void 0!==e.v?e.v:t.v,void 0!==e.lvl?e.lvl:t.lvl,void 0!==e.l?e.l:t.l,void 0!==e.r?e.r:t.r)}function V(t){return R(t)||t.lvl>t.r.lvl}function U(t){var e=t.l,n=t.r,o=t.lvl;if(n.lvl>=o-1&&e.lvl>=o-1)return t;if(o>n.lvl+1){if(V(e))return G(W(t,{lvl:o-1}));if(R(e)||R(e.r))throw new Error("Unexpected empty nodes");return W(e.r,{l:W(e,{r:e.r.l}),r:W(t,{l:e.r.r,lvl:o-1}),lvl:o})}if(V(t))return D(W(t,{lvl:o-1}));if(R(n)||R(n.l))throw new Error("Unexpected empty nodes");var r=n.l,i=V(r)?n.lvl-1:n.lvl;return W(r,{l:W(t,{r:r.l,lvl:o-1}),r:D(W(n,{l:r.r,lvl:i})),lvl:r.lvl+1})}function A(t,e,n){return R(t)?[]:N(B(t,k(t,e)[0],n),function(t){return{index:t.k,value:t.v}})}function N(t,e){var n=t.length;if(0===n)return[];for(var o=e(t[0]),r=o.index,i=o.value,a=[],l=1;l<n;l++){var s=e(t[l]),u=s.index,c=s.value;a.push({start:r,end:u-1,value:i}),r=u,i=c}return a.push({start:r,end:Infinity,value:i}),a}function D(t){var e=t.r,n=t.lvl;return R(e)||R(e.r)||e.lvl!==n||e.r.lvl!==n?t:W(e,{l:W(t,{r:e.l}),lvl:n+1})}function G(t){var e=t.l;return R(e)||e.lvl!==t.lvl?t:W(e,{r:W(t,{l:e.r})})}function _(t,e,n,o){void 0===o&&(o=0);for(var r=t.length-1;o<=r;){var i=Math.floor((o+r)/2),a=n(t[i],e);if(0===a)return i;if(-1===a){if(r-o<2)return i-1;r=i-1}else{if(r===o)return i;o=i+1}}throw new Error("Failed binary finding record in array - "+t.join(",")+", searched for "+e)}function j(t,e,n){return t[_(t,e,n)]}var K=system(function(){return{recalcInProgress:statefulStream(!1)}},[],{singleton:!0});function Y(t){var e=t.size,n=t.startIndex,o=t.endIndex;return function(t){return t.start===n&&(t.end===o||Infinity===t.end)&&t.value===e}}function q(t,e){var n=t.index;return e===n?0:e<n?-1:1}function Z(t,e){var n=t.offset;return e===n?0:e<n?-1:1}function J(t){return{index:t.index,value:t}}function $(t,e,n,o){var r=t,i=0,a=0,l=0,s=0;if(0!==e){l=r[s=_(r,e-1,q)].offset;var u=k(n,e-1);i=u[0],a=u[1],r.length&&r[s].size===k(n,e)[1]&&(s-=1),r=r.slice(0,s+1)}else r=[];for(var c,m=f(A(n,e,Infinity));!(c=m()).done;){var d=c.value,p=d.start,h=d.value,g=p-i,v=g*a+l+g*o;r.push({offset:v,size:h,index:p}),i=p,l=v,a=h}return{offsetTree:r,lastIndex:i,lastOffset:l,lastSize:a}}function Q(t,e){var n=e[0],o=e[1],r=e[3];n.length>0&&(0,e[2])("received item sizes",n,h.DEBUG);var i=t.sizeTree,a=i,l=0;if(o.length>0&&R(i)&&2===n.length){var s=n[0].size,u=n[1].size;a=o.reduce(function(t,e){return z(z(t,e,s),e+1,u)},a)}else{var c=function(t,e){for(var n,o=R(t)?0:Infinity,r=f(e);!(n=r()).done;){var i=n.value,a=i.size,l=i.startIndex,s=i.endIndex;if(o=Math.min(o,l),R(t))t=z(t,0,a);else{var u=A(t,l-1,s+1);if(!u.some(Y(i))){for(var c,m=!1,d=!1,p=f(u);!(c=p()).done;){var h=c.value,g=h.start,v=h.end,S=h.value;m?(s>=g||a===S)&&(t=F(t,g)):(d=S!==a,m=!0),v>s&&s>=g&&S!==a&&(t=z(t,s+1,S))}d&&(t=z(t,l,a))}}}return[t,o]}(a,n);a=c[0],l=c[1]}if(a===i)return t;var m=$(t.offsetTree,l,a,r),d=m.offsetTree;return{sizeTree:a,offsetTree:d,lastIndex:m.lastIndex,lastOffset:m.lastOffset,lastSize:m.lastSize,groupOffsetTree:o.reduce(function(t,e){return z(t,e,X(e,d,r))},L()),groupIndices:o}}function X(t,e,n){if(0===e.length)return 0;var o=j(e,t,q),r=t-o.index,i=o.size*r+(r-1)*n+o.offset;return i>0?i+n:i}function tt(t,e,n){if(function(t){return void 0!==t.groupIndex}(t))return e.groupIndices[t.groupIndex]+1;var o=et("LAST"===t.index?n:t.index,e);return Math.max(0,o,Math.min(n,o))}function et(t,e){if(!nt(e))return t;for(var n=0;e.groupIndices[n]<=t+n;)n++;return t+n}function nt(t){return!R(t.groupOffsetTree)}var ot={offsetHeight:"height",offsetWidth:"width"},rt=system(function(t){var n=t[0].log,o=t[1].recalcInProgress,r=stream(),i=stream(),a=statefulStreamFromEmitter(i,0),l=stream(),s=stream(),u=statefulStream(0),m=statefulStream([]),d=statefulStream(void 0),f=statefulStream(void 0),p=statefulStream(function(t,e){return w(t,ot[e])}),g=statefulStream(void 0),v=statefulStream(0),S={offsetTree:[],sizeTree:L(),groupOffsetTree:L(),lastIndex:0,lastOffset:0,lastSize:0,groupIndices:[]},C=statefulStreamFromEmitter(pipe(r,withLatestFrom(m,n,v),scan(Q,S),distinctUntilChanged()),S);connect(pipe(m,filter(function(t){return t.length>0}),withLatestFrom(C,v),map(function(t){var e=t[0],n=t[1],o=t[2],r=e.reduce(function(t,e,r){return z(t,e,X(e,n.offsetTree,o)||r)},L());return c({},n,{groupIndices:e,groupOffsetTree:r})})),C),connect(pipe(i,withLatestFrom(C),filter(function(t){return t[0]<t[1].lastIndex}),map(function(t){var e=t[1];return[{startIndex:t[0],endIndex:e.lastIndex,size:e.lastSize}]})),r),connect(d,f);var I=statefulStreamFromEmitter(pipe(d,map(function(t){return void 0===t})),!0);connect(pipe(f,filter(function(t){return void 0!==t&&R(getValue(C).sizeTree)}),map(function(t){return[{startIndex:0,endIndex:0,size:t}]})),r);var T=streamFromEmitter(pipe(r,withLatestFrom(C),scan(function(t,e){var n=e[1];return{changed:n!==t.sizes,sizes:n}},{changed:!1,sizes:S}),map(function(t){return t.changed})));subscribe(pipe(u,scan(function(t,e){return{diff:t.prev-e,prev:e}},{diff:0,prev:0}),map(function(t){return t.diff})),function(t){t>0?(publish(o,!0),publish(l,t)):t<0&&publish(s,t)}),subscribe(pipe(u,withLatestFrom(n)),function(t){t[0]<0&&(0,t[1])("`firstItemIndex` prop should not be set to less than zero. If you don't know the total count, just use a very high value",{firstItemIndex:u},h.ERROR)});var x=streamFromEmitter(l);connect(pipe(l,withLatestFrom(C),map(function(t){var e=t[0],n=t[1];if(n.groupIndices.length>0)throw new Error("Virtuoso: prepending items does not work with groups");return P(n.sizeTree).reduce(function(t,n){var o=n.k,r=n.v;return{ranges:[].concat(t.ranges,[{startIndex:t.prevIndex,endIndex:o+e-1,size:t.prevSize}]),prevIndex:o+e,prevSize:r}},{ranges:[],prevIndex:0,prevSize:n.lastSize}).ranges})),r);var b=streamFromEmitter(pipe(s,withLatestFrom(C,v),map(function(t){return X(-t[0],t[1].offsetTree,t[2])})));return connect(pipe(s,withLatestFrom(C,v),map(function(t){var e=t[0],n=t[1],o=t[2];if(n.groupIndices.length>0)throw new Error("Virtuoso: shifting items does not work with groups");var r=P(n.sizeTree).reduce(function(t,n){var o=n.v;return z(t,Math.max(0,n.k+e),o)},L());return c({},n,{sizeTree:r},$(n.offsetTree,0,r,o))})),C),{data:g,totalCount:i,sizeRanges:r,groupIndices:m,defaultItemSize:f,fixedItemSize:d,unshiftWith:l,shiftWith:s,shiftWithOffset:b,beforeUnshiftWith:x,firstItemIndex:u,gap:v,sizes:C,listRefresh:T,statefulTotalCount:a,trackItemSizes:I,itemSize:p}},tup(S,K),{singleton:!0}),it="undefined"!=typeof document&&"scrollBehavior"in document.documentElement.style;function at(t){var e="number"==typeof t?{index:t}:t;return e.align||(e.align="start"),e.behavior&&it||(e.behavior="auto"),e.offset||(e.offset=0),e}var lt=system(function(t){var n=t[0],o=n.sizes,r=n.totalCount,i=n.listRefresh,a=n.gap,l=t[1],s=l.scrollingInProgress,u=l.viewportHeight,c=l.scrollTo,m=l.smoothScrollTargetReached,d=l.headerHeight,f=l.footerHeight,p=l.fixedHeaderHeight,g=l.fixedFooterHeight,v=t[2].log,S=stream(),C=statefulStream(0),I=null,T=null,w=null;function x(){I&&(I(),I=null),w&&(w(),w=null),T&&(clearTimeout(T),T=null),publish(s,!1)}return connect(pipe(S,withLatestFrom(o,u,r,C,d,f,v),withLatestFrom(a,p,g),map(function(t){var n=t[0],o=n[0],r=n[1],a=n[2],l=n[3],u=n[4],c=n[5],d=n[6],f=n[7],p=t[1],g=t[2],v=t[3],C=at(o),b=C.align,y=C.behavior,H=C.offset,E=l-1,R=tt(C,r,E),L=X(R,r.offsetTree,p)+c;"end"===b?(L+=g+k(r.sizeTree,R)[1]-a+v,R===E&&(L+=d)):"center"===b?L+=(g+k(r.sizeTree,R)[1]-a+v)/2:L-=u,H&&(L+=H);var F=function(t){x(),t?(f("retrying to scroll to",{location:o},h.DEBUG),publish(S,o)):f("list did not change, scroll successful",{},h.DEBUG)};if(x(),"smooth"===y){var z=!1;w=subscribe(i,function(t){z=z||t}),I=handleNext(m,function(){F(z)})}else I=handleNext(pipe(i,function(t){var e=setTimeout(function(){t(!1)},150);return function(n){n&&(t(!0),clearTimeout(e))}}),F);return T=setTimeout(function(){x()},1200),publish(s,!0),f("scrolling from index to",{index:R,top:L,behavior:y},h.DEBUG),{top:L,behavior:y}})),c),{scrollToIndex:S,topListHeight:C}},tup(rt,y,S),{singleton:!0}),st="up",ut={atBottom:!1,notAtBottomBecause:"NOT_SHOWING_LAST_ITEM",state:{offsetBottom:0,scrollTop:0,viewportHeight:0,scrollHeight:0}},ct=system(function(t){var n=t[0],o=n.scrollContainerState,r=n.scrollTop,i=n.viewportHeight,a=n.headerHeight,l=n.footerHeight,s=n.scrollBy,u=statefulStream(!1),c=statefulStream(!0),m=stream(),d=stream(),f=statefulStream(4),p=statefulStream(0),h=statefulStreamFromEmitter(pipe(merge(pipe(duc(r),skip(1),mapTo(!0)),pipe(duc(r),skip(1),mapTo(!1),debounceTime(100))),distinctUntilChanged()),!1),g=statefulStreamFromEmitter(pipe(merge(pipe(s,mapTo(!0)),pipe(s,mapTo(!1),debounceTime(200))),distinctUntilChanged()),!1);connect(pipe(combineLatest(duc(r),duc(p)),map(function(t){return t[0]<=t[1]}),distinctUntilChanged()),c),connect(pipe(c,throttleTime(50)),d);var v=streamFromEmitter(pipe(combineLatest(o,duc(i),duc(a),duc(l),duc(f)),scan(function(t,e){var n,o,r=e[0],i=r.scrollTop,a=r.scrollHeight,l=e[1],s={viewportHeight:l,scrollTop:i,scrollHeight:a};return i+l-a>-e[4]?(i>t.state.scrollTop?(n="SCROLLED_DOWN",o=t.state.scrollTop-i):(n="SIZE_DECREASED",o=t.state.scrollTop-i||t.scrollTopDelta),{atBottom:!0,state:s,atBottomBecause:n,scrollTopDelta:o}):{atBottom:!1,notAtBottomBecause:s.scrollHeight>t.state.scrollHeight?"SIZE_INCREASED":l<t.state.viewportHeight?"VIEWPORT_HEIGHT_DECREASING":i<t.state.scrollTop?"SCROLLING_UPWARDS":"NOT_FULLY_SCROLLED_TO_LAST_ITEM_BOTTOM",state:s}},ut),distinctUntilChanged(function(t,e){return t&&t.atBottom===e.atBottom}))),S=statefulStreamFromEmitter(pipe(o,scan(function(t,e){var n=e.scrollTop,o=e.scrollHeight,r=e.viewportHeight;return x(t.scrollHeight,o)?{scrollTop:n,scrollHeight:o,jump:0,changed:!1}:t.scrollTop!==n&&o-(n+r)<1?{scrollHeight:o,scrollTop:n,jump:t.scrollTop-n,changed:!0}:{scrollHeight:o,scrollTop:n,jump:0,changed:!0}},{scrollHeight:0,jump:0,scrollTop:0,changed:!1}),filter(function(t){return t.changed}),map(function(t){return t.jump})),0);connect(pipe(v,map(function(t){return t.atBottom})),u),connect(pipe(u,throttleTime(50)),m);var C=statefulStream("down");connect(pipe(o,map(function(t){return t.scrollTop}),distinctUntilChanged(),scan(function(t,n){return getValue(g)?{direction:t.direction,prevScrollTop:n}:{direction:n<t.prevScrollTop?st:"down",prevScrollTop:n}},{direction:"down",prevScrollTop:0}),map(function(t){return t.direction})),C),connect(pipe(o,throttleTime(50),mapTo("none")),C);var I=statefulStream(0);return connect(pipe(h,filter(function(t){return!t}),mapTo(0)),I),connect(pipe(r,throttleTime(100),withLatestFrom(h),filter(function(t){return!!t[1]}),scan(function(t,e){return[t[1],e[0]]},[0,0]),map(function(t){return t[1]-t[0]})),I),{isScrolling:h,isAtTop:c,isAtBottom:u,atBottomState:v,atTopStateChange:d,atBottomStateChange:m,scrollDirection:C,atBottomThreshold:f,atTopThreshold:p,scrollVelocity:I,lastJumpDueToItemResize:S}},tup(y)),mt=system(function(t){var n=t[0].log,o=statefulStream(!1),r=streamFromEmitter(pipe(o,filter(function(t){return t}),distinctUntilChanged()));return subscribe(o,function(t){t&&getValue(n)("props updated",{},h.DEBUG)}),{propsReady:o,didMount:r}},tup(S),{singleton:!0}),dt=system(function(t){var n=t[0],o=n.sizes,r=n.listRefresh,i=n.defaultItemSize,a=t[1].scrollTop,l=t[2].scrollToIndex,s=t[3].didMount,u=statefulStream(!0),c=statefulStream(0);return connect(pipe(s,withLatestFrom(c),filter(function(t){return!!t[1]}),mapTo(!1)),u),subscribe(pipe(combineLatest(r,s),withLatestFrom(u,o,i),filter(function(t){var e=t[1],n=t[3];return t[0][1]&&(!R(t[2].sizeTree)||void 0!==n)&&!e}),withLatestFrom(c)),function(t){var n=t[1];setTimeout(function(){handleNext(a,function(){publish(u,!0)}),publish(l,n)})}),{scrolledToInitialItem:u,initialTopMostItemIndex:c}},tup(rt,y,lt,mt),{singleton:!0});function ft(t){return!!t&&("smooth"===t?"smooth":"auto")}var pt=system(function(t){var n=t[0],o=n.totalCount,r=n.listRefresh,i=t[1],a=i.isAtBottom,l=i.atBottomState,s=t[2].scrollToIndex,u=t[3].scrolledToInitialItem,c=t[4],m=c.propsReady,d=c.didMount,f=t[5].log,p=t[6].scrollingInProgress,g=statefulStream(!1),v=stream(),S=null;function C(t){publish(s,{index:"LAST",align:"end",behavior:t})}function I(t){var n=handleNext(l,function(n){!t||n.atBottom||"SIZE_INCREASED"!==n.notAtBottomBecause||S||(getValue(f)("scrolling to bottom due to increased size",{},h.DEBUG),C("auto"))});setTimeout(n,100)}return subscribe(pipe(combineLatest(pipe(duc(o),skip(1)),d),withLatestFrom(duc(g),a,u,p),map(function(t){var e=t[0],n=e[0],o=e[1]&&t[3],r="auto";return o&&(r=function(t,e){return"function"==typeof t?ft(t(e)):e&&ft(t)}(t[1],t[2]||t[4]),o=o&&!!r),{totalCount:n,shouldFollow:o,followOutputBehavior:r}}),filter(function(t){return t.shouldFollow})),function(t){var n=t.totalCount,o=t.followOutputBehavior;S&&(S(),S=null),S=handleNext(r,function(){getValue(f)("following output to ",{totalCount:n},h.DEBUG),C(o),S=null})}),subscribe(pipe(combineLatest(duc(g),o,m),filter(function(t){return t[0]&&t[2]}),scan(function(t,e){var n=e[1];return{refreshed:t.value===n,value:n}},{refreshed:!1,value:0}),filter(function(t){return t.refreshed}),withLatestFrom(g,o)),function(t){I(!1!==t[1])}),subscribe(v,function(){I(!1!==getValue(g))}),subscribe(combineLatest(duc(g),l),function(t){var e=t[1];t[0]&&!e.atBottom&&"VIEWPORT_HEIGHT_DECREASING"===e.notAtBottomBecause&&C("auto")}),{followOutput:g,autoscrollToBottom:v}},tup(rt,ct,lt,dt,mt,S,y));function ht(t){return t.reduce(function(t,e){return t.groupIndices.push(t.totalCount),t.totalCount+=e+1,t},{totalCount:0,groupIndices:[]})}var gt=system(function(t){var n=t[0],o=n.totalCount,r=n.groupIndices,i=n.sizes,a=t[1],l=a.scrollTop,s=a.headerHeight,u=stream(),c=stream(),m=streamFromEmitter(pipe(u,map(ht)));return connect(pipe(m,map(function(t){return t.totalCount})),o),connect(pipe(m,map(function(t){return t.groupIndices})),r),connect(pipe(combineLatest(l,i,s),filter(function(t){return nt(t[1])}),map(function(t){return k(t[1].groupOffsetTree,Math.max(t[0]-t[2],0),"v")[0]}),distinctUntilChanged(),map(function(t){return[t]})),c),{groupCounts:u,topItemsIndexes:c}},tup(rt,y));function vt(t,e){return!(!t||t[0]!==e[0]||t[1]!==e[1])}function St(t,e){return!(!t||t.startIndex!==e.startIndex||t.endIndex!==e.endIndex)}function Ct(t,e,n){return"number"==typeof t?n===st&&"top"===e||"down"===n&&"bottom"===e?t:0:n===st?"top"===e?t.main:t.reverse:"bottom"===e?t.main:t.reverse}function It(t,e){return"number"==typeof t?t:t[e]||0}var Tt=system(function(t){var n=t[0],o=n.scrollTop,r=n.viewportHeight,i=n.deviation,a=n.headerHeight,l=n.fixedHeaderHeight,s=stream(),u=statefulStream(0),c=statefulStream(0),m=statefulStream(0),d=statefulStreamFromEmitter(pipe(combineLatest(duc(o),duc(r),duc(a),duc(s,vt),duc(m),duc(u),duc(l),duc(i),duc(c)),map(function(t){var e=t[0],n=t[1],o=t[2],r=t[3],i=r[0],a=r[1],l=t[4],s=t[6],u=t[7],c=t[8],m=e-u,d=t[5]+s,f=Math.max(o-m,0),p="none",h=It(c,"top"),g=It(c,"bottom");return i-=u,a+=o+s,(i+=o+s)>e+d-h&&(p=st),(a-=u)<e-f+n+g&&(p="down"),"none"!==p?[Math.max(m-o-Ct(l,"top",p)-h,0),m-f-s+n+Ct(l,"bottom",p)+g]:null}),filter(function(t){return null!=t}),distinctUntilChanged(vt)),[0,0]);return{listBoundary:s,overscan:m,topListHeight:u,increaseViewportBy:c,visibleRange:d}},tup(y),{singleton:!0}),wt={items:[],topItems:[],offsetTop:0,offsetBottom:0,top:0,bottom:0,topListHeight:0,totalCount:0,firstItemIndex:0};function xt(t,e,n){if(0===t.length)return[];if(!nt(e))return t.map(function(t){return c({},t,{index:t.index+n,originalIndex:t.index})});for(var o,r=[],i=A(e.groupOffsetTree,t[0].index,t[t.length-1].index),a=void 0,l=0,s=f(t);!(o=s()).done;){var u=o.value;(!a||a.end<u.index)&&(a=i.shift(),l=e.groupIndices.indexOf(a.start)),r.push(c({},u.index===a.start?{type:"group",index:l}:{index:u.index-(l+1)+n,groupIndex:l},{size:u.size,offset:u.offset,originalIndex:u.index,data:u.data}))}return r}function bt(t,e,n,o,r,i){var a=0,l=0;if(t.length>0){a=t[0].offset;var s=t[t.length-1];l=s.offset+s.size}var u=n-r.lastIndex,c=a,m=r.lastOffset+u*r.lastSize+(u-1)*o-l;return{items:xt(t,r,i),topItems:xt(e,r,i),topListHeight:e.reduce(function(t,e){return e.size+t},0),offsetTop:a,offsetBottom:m,top:c,bottom:l,totalCount:n,firstItemIndex:i}}var yt=system(function(t){var n=t[0],o=n.sizes,r=n.totalCount,i=n.data,a=n.firstItemIndex,l=n.gap,s=t[1],u=t[2],m=u.visibleRange,d=u.listBoundary,p=u.topListHeight,h=t[3],g=h.scrolledToInitialItem,v=h.initialTopMostItemIndex,S=t[4].topListHeight,C=t[5],I=t[6].didMount,T=t[7].recalcInProgress,w=statefulStream([]),x=stream();connect(s.topItemsIndexes,w);var b=statefulStreamFromEmitter(pipe(combineLatest(I,T,duc(m,vt),duc(r),duc(o),duc(v),g,duc(w),duc(a),duc(l),i),filter(function(t){return t[0]&&!t[1]}),map(function(t){var n=t[2],o=n[0],r=n[1],i=t[3],a=t[5],l=t[6],s=t[7],u=t[8],m=t[9],d=t[10],p=t[4],h=p.sizeTree,g=p.offsetTree;if(0===i||0===o&&0===r)return c({},wt,{totalCount:i});if(R(h))return bt(function(t,e,n){if(nt(e)){var o=et(t,e);return[{index:k(e.groupOffsetTree,o)[0],size:0,offset:0},{index:o,size:0,offset:0,data:n&&n[0]}]}return[{index:t,size:0,offset:0,data:n&&n[0]}]}(function(t,e){return"number"==typeof t?t:"LAST"===t.index?e-1:t.index}(a,i),p,d),[],i,m,p,u);var v=[];if(s.length>0)for(var S,C=s[0],I=s[s.length-1],T=0,w=f(A(h,C,I));!(S=w()).done;)for(var x=S.value,b=x.value,y=Math.max(x.start,C),H=Math.min(x.end,I),E=y;E<=H;E++)v.push({index:E,size:b,offset:T,data:d&&d[E]}),T+=b;if(!l)return bt([],v,i,m,p,u);var L=s.length>0?s[s.length-1]+1:0,F=function(t,e,n,o){return void 0===o&&(o=0),o>0&&(e=Math.max(e,j(t,o,q).offset)),N((i=n,l=_(r=t,e,a=Z),s=_(r,i,a,l),r.slice(l,s+1)),J);var r,i,a,l,s}(g,o,r,L);if(0===F.length)return null;var z=i-1;return bt(tap([],function(t){for(var e,n=f(F);!(e=n()).done;){var i=e.value,a=i.value,l=a.offset,s=i.start,u=a.size;if(a.offset<o){var c=(s+=Math.floor((o-a.offset+m)/(u+m)))-i.start;l+=c*u+c*m}s<L&&(l+=(L-s)*u,s=L);for(var p=Math.min(i.end,z),h=s;h<=p&&!(l>=r);h++)t.push({index:h,size:u,offset:l,data:d&&d[h]}),l+=u+m}}),v,i,m,p,u)}),filter(function(t){return null!==t}),distinctUntilChanged()),wt);return connect(pipe(i,filter(function(t){return void 0!==t}),map(function(t){return t.length})),r),connect(pipe(b,map(function(t){return t.topListHeight})),S),connect(S,p),connect(pipe(b,map(function(t){return[t.top,t.bottom]})),d),connect(pipe(b,map(function(t){return t.items})),x),c({listState:b,topItemsIndexes:w,endReached:streamFromEmitter(pipe(b,filter(function(t){return t.items.length>0}),withLatestFrom(r,i),filter(function(t){var e=t[0].items;return e[e.length-1].originalIndex===t[1]-1}),map(function(t){return[t[1]-1,t[2]]}),distinctUntilChanged(vt),map(function(t){return t[0]}))),startReached:streamFromEmitter(pipe(b,throttleTime(200),filter(function(t){var e=t.items;return e.length>0&&e[0].originalIndex===t.topItems.length}),map(function(t){return t.items[0].index}),distinctUntilChanged())),rangeChanged:streamFromEmitter(pipe(b,filter(function(t){return t.items.length>0}),map(function(t){for(var e=t.items,n=0,o=e.length-1;"group"===e[n].type&&n<o;)n++;for(;"group"===e[o].type&&o>n;)o--;return{startIndex:e[n].index,endIndex:e[o].index}}),distinctUntilChanged(St))),itemsRendered:x},C)},tup(rt,gt,Tt,dt,lt,ct,mt,K),{singleton:!0}),Ht=system(function(t){var n=t[0],o=n.sizes,r=n.firstItemIndex,i=n.data,a=n.gap,l=t[1].listState,s=t[2].didMount,u=statefulStream(0);return connect(pipe(s,withLatestFrom(u),filter(function(t){return 0!==t[1]}),withLatestFrom(o,r,a,i),map(function(t){var e=t[0][1],n=t[1],o=t[2],r=t[3],i=t[4],a=void 0===i?[]:i,l=0;if(n.groupIndices.length>0)for(var s,u=f(n.groupIndices);!((s=u()).done||s.value-l>=e);)l++;var c=e+l;return bt(Array.from({length:c}).map(function(t,e){return{index:e,size:0,offset:0,data:a[e]}}),[],c,r,n,o)})),l),{initialItemCount:u}},tup(rt,yt,mt),{singleton:!0}),Et=system(function(t){var n=t[0].scrollVelocity,o=statefulStream(!1),r=stream(),i=statefulStream(!1);return connect(pipe(n,withLatestFrom(i,o,r),filter(function(t){return!!t[1]}),map(function(t){var e=t[0],n=t[1],o=t[2],r=t[3],i=n.enter;if(o){if((0,n.exit)(e,r))return!1}else if(i(e,r))return!0;return o}),distinctUntilChanged()),o),subscribe(pipe(combineLatest(o,n,r),withLatestFrom(i)),function(t){var e=t[0],n=t[1];return e[0]&&n&&n.change&&n.change(e[1],e[2])}),{isSeeking:o,scrollSeekConfiguration:i,scrollVelocity:n,scrollSeekRangeChanged:r}},tup(ct),{singleton:!0}),Rt=system(function(t){var n=t[0].topItemsIndexes,o=statefulStream(0);return connect(pipe(o,filter(function(t){return t>0}),map(function(t){return Array.from({length:t}).map(function(t,e){return e})})),n),{topItemCount:o}},tup(yt)),Lt=system(function(t){var n=t[0],o=n.footerHeight,r=n.headerHeight,i=n.fixedHeaderHeight,a=n.fixedFooterHeight,l=t[1].listState,s=stream(),u=statefulStreamFromEmitter(pipe(combineLatest(o,a,r,i,l),map(function(t){var e=t[4];return t[0]+t[1]+t[2]+t[3]+e.offsetBottom+e.bottom})),0);return connect(duc(u),s),{totalListHeight:u,totalListHeightChanged:s}},tup(y,yt),{singleton:!0});function Ft(t){var e,n=!1;return function(){return n||(n=!0,e=t()),e}}var kt=Ft(function(){return/iP(ad|od|hone)/i.test(navigator.userAgent)&&/WebKit/i.test(navigator.userAgent)}),zt=system(function(t){var n=t[0],o=n.scrollBy,r=n.scrollTop,i=n.deviation,a=n.scrollingInProgress,l=t[1],s=l.isScrolling,u=l.isAtBottom,c=l.scrollDirection,m=t[3],d=m.beforeUnshiftWith,f=m.shiftWithOffset,p=m.sizes,g=m.gap,v=t[4].log,S=t[5].recalcInProgress,C=streamFromEmitter(pipe(t[2].listState,withLatestFrom(l.lastJumpDueToItemResize),scan(function(t,e){var n=t[1],o=e[0],r=o.items,i=o.totalCount,a=o.bottom+o.offsetBottom,l=0;return t[2]===i&&n.length>0&&r.length>0&&(0===r[0].originalIndex&&0===n[0].originalIndex||0!=(l=a-t[3])&&(l+=e[1])),[l,r,i,a]},[0,[],0,0]),filter(function(t){return 0!==t[0]}),withLatestFrom(r,c,a,u,v),filter(function(t){return!t[3]&&0!==t[1]&&t[2]===st}),map(function(t){var e=t[0][0];return(0,t[5])("Upward scrolling compensation",{amount:e},h.DEBUG),e})));function I(t){t>0?(publish(o,{top:-t,behavior:"auto"}),publish(i,0)):(publish(i,0),publish(o,{top:-t,behavior:"auto"}))}return subscribe(pipe(C,withLatestFrom(i,s)),function(t){var n=t[0],o=t[1];t[2]&&kt()?publish(i,o-n):I(-n)}),subscribe(pipe(combineLatest(statefulStreamFromEmitter(s,!1),i,S),filter(function(t){return!t[0]&&!t[2]&&0!==t[1]}),map(function(t){return t[1]}),throttleTime(1)),I),connect(pipe(f,map(function(t){return{top:-t}})),o),subscribe(pipe(d,withLatestFrom(p,g),map(function(t){var e=t[0];return e*t[1].lastSize+e*t[2]})),function(t){publish(i,t),requestAnimationFrame(function(){publish(o,{top:t}),requestAnimationFrame(function(){publish(i,0),publish(S,!1)})})}),{deviation:i}},tup(y,ct,yt,rt,S,K)),Bt=system(function(t){var n=t[0].totalListHeight,o=t[1].didMount,r=t[2].scrollTo,i=statefulStream(0);return subscribe(pipe(o,withLatestFrom(i),filter(function(t){return 0!==t[1]}),map(function(t){return{top:t[1]}})),function(t){handleNext(pipe(n,filter(function(t){return 0!==t})),function(){setTimeout(function(){publish(r,t)})})}),{initialScrollTop:i}},tup(Lt,mt,y),{singleton:!0}),Pt=system(function(t){var n=t[0].viewportHeight,o=t[1].totalListHeight,r=statefulStream(!1);return{alignToBottom:r,paddingTopAddition:statefulStreamFromEmitter(pipe(combineLatest(r,n,o),filter(function(t){return t[0]}),map(function(t){return Math.max(0,t[1]-t[2])}),distinctUntilChanged()),0)}},tup(y,Lt),{singleton:!0}),Ot=system(function(t){var n=t[0],o=n.scrollTo,r=n.scrollContainerState,i=stream(),a=stream(),l=stream(),s=statefulStream(!1),u=statefulStream(void 0);return connect(pipe(combineLatest(i,a),map(function(t){var e=t[0],n=e.viewportHeight,o=e.scrollHeight;return{scrollTop:Math.max(0,e.scrollTop-t[1].offsetTop),scrollHeight:o,viewportHeight:n}})),r),connect(pipe(o,withLatestFrom(a),map(function(t){var e=t[0];return c({},e,{top:e.top+t[1].offsetTop})})),l),{useWindowScroll:s,customScrollParent:u,windowScrollContainerState:i,windowViewportRect:a,windowScrollTo:l}},tup(y)),Mt=["done","behavior","align"],Wt=system(function(t){var n=t[0],o=n.sizes,r=n.totalCount,i=n.gap,a=t[1],l=a.scrollTop,s=a.viewportHeight,u=a.headerHeight,d=a.fixedHeaderHeight,f=a.fixedFooterHeight,p=a.scrollingInProgress,h=t[2].scrollToIndex,g=stream();return connect(pipe(g,withLatestFrom(o,s,r,u,d,f,l),withLatestFrom(i),map(function(t){var n=t[0],o=n[0],r=n[1],i=n[2],a=n[3],l=n[4],s=n[5],u=n[6],d=n[7],f=t[1],h=o.done,g=o.behavior,v=o.align,S=m(o,Mt),C=null,I=tt(o,r,a-1),T=X(I,r.offsetTree,f)+l+s;return T<d+s?C=c({},S,{behavior:g,align:null!=v?v:"start"}):T+k(r.sizeTree,I)[1]>d+i-u&&(C=c({},S,{behavior:g,align:null!=v?v:"end"})),C?h&&handleNext(pipe(p,skip(1),filter(function(t){return!1===t})),h):h&&h(),C}),filter(function(t){return null!==t})),h),{scrollIntoView:g}},tup(rt,y,lt,yt,S),{singleton:!0}),Vt=["listState","topItemsIndexes"],Ut=system(function(t){return c({},t[0],t[1],t[2],t[3],t[4],t[5],t[6],t[7],t[8])},tup(Tt,Ht,mt,Et,Lt,Bt,Pt,Ot,Wt)),At=system(function(t){var n=t[0],o=n.totalCount,r=n.sizeRanges,i=n.fixedItemSize,a=n.defaultItemSize,l=n.trackItemSizes,s=n.itemSize,u=n.data,d=n.firstItemIndex,f=n.groupIndices,p=n.statefulTotalCount,h=n.gap,g=t[1],v=g.initialTopMostItemIndex,S=g.scrolledToInitialItem,C=t[2],I=t[3],T=t[4],w=T.listState,x=T.topItemsIndexes,b=m(T,Vt),y=t[5].scrollToIndex,H=t[7].topItemCount,E=t[8].groupCounts,R=t[9],L=t[10];return connect(b.rangeChanged,R.scrollSeekRangeChanged),connect(pipe(R.windowViewportRect,map(function(t){return t.visibleHeight})),C.viewportHeight),c({totalCount:o,data:u,firstItemIndex:d,sizeRanges:r,initialTopMostItemIndex:v,scrolledToInitialItem:S,topItemsIndexes:x,topItemCount:H,groupCounts:E,fixedItemHeight:i,defaultItemHeight:a,gap:h},I,{statefulTotalCount:p,listState:w,scrollToIndex:y,trackItemSizes:l,itemSize:s,groupIndices:f},b,R,C,L)},tup(rt,dt,y,pt,yt,lt,zt,Rt,gt,Ut,S)),Nt=Ft(function(){if("undefined"==typeof document)return"sticky";var t=document.createElement("div");return t.style.position="-webkit-sticky","-webkit-sticky"===t.style.position?"-webkit-sticky":"sticky"});function Dt(t,e){var n=(0,react.useRef)(null),o=(0,react.useCallback)(function(o){if(null!==o&&o.offsetParent){var r,i,a=o.getBoundingClientRect(),l=a.width;if(e){var s=e.getBoundingClientRect(),u=a.top-s.top;r=s.height-Math.max(0,u),i=u+e.scrollTop}else r=window.innerHeight-Math.max(0,a.top),i=a.top+window.pageYOffset;n.current={offsetTop:i,visibleHeight:r,visibleWidth:l},t(n.current)}},[t,e]),l=C(o),s=l.callbackRef,u=l.ref,c=(0,react.useCallback)(function(){o(u.current)},[o,u]);return (0,react.useEffect)(function(){if(e){e.addEventListener("scroll",c);var t=new ResizeObserver(c);return t.observe(e),function(){e.removeEventListener("scroll",c),t.unobserve(e)}}return window.addEventListener("scroll",c),window.addEventListener("resize",c),function(){window.removeEventListener("scroll",c),window.removeEventListener("resize",c)}},[c,e]),s}var Gt=react.createContext(void 0),_t=react.createContext(void 0),jt=["placeholder"],Kt=["style","children"],Yt=["style","children"];function qt(t){return t}var Zt=system(function(){var t=statefulStream(function(t){return"Item "+t}),n=statefulStream(null),o=statefulStream(function(t){return"Group "+t}),r=statefulStream({}),i=statefulStream(qt),a=statefulStream("div"),l=statefulStream(noop),s=function(t,n){return void 0===n&&(n=null),statefulStreamFromEmitter(pipe(r,map(function(e){return e[t]}),distinctUntilChanged()),n)};return{context:n,itemContent:t,groupContent:o,components:r,computeItemKey:i,headerFooterTag:a,scrollerRef:l,FooterComponent:s("Footer"),HeaderComponent:s("Header"),TopItemListComponent:s("TopItemList"),ListComponent:s("List","div"),ItemComponent:s("Item","div"),GroupComponent:s("Group","div"),ScrollerComponent:s("Scroller","div"),EmptyPlaceholder:s("EmptyPlaceholder"),ScrollSeekPlaceholder:s("ScrollSeekPlaceholder")}});function Jt(t,n){var o=stream();return subscribe(o,function(){return console.warn("react-virtuoso: You are using a deprecated property. "+n,"color: red;","color: inherit;","color: blue;")}),connect(o,t),o}var $t=system(function(t){var n=t[0],o=t[1],r={item:Jt(o.itemContent,"Rename the %citem%c prop to %citemContent."),group:Jt(o.groupContent,"Rename the %cgroup%c prop to %cgroupContent."),topItems:Jt(n.topItemCount,"Rename the %ctopItems%c prop to %ctopItemCount."),itemHeight:Jt(n.fixedItemHeight,"Rename the %citemHeight%c prop to %cfixedItemHeight."),scrollingStateChange:Jt(n.isScrolling,"Rename the %cscrollingStateChange%c prop to %cisScrolling."),adjustForPrependedItems:stream(),maxHeightCacheSize:stream(),footer:stream(),header:stream(),HeaderContainer:stream(),FooterContainer:stream(),ItemContainer:stream(),ScrollContainer:stream(),GroupContainer:stream(),ListContainer:stream(),emptyComponent:stream(),scrollSeek:stream()};function i(t,n,r){connect(pipe(t,withLatestFrom(o.components),map(function(t){var e,o=t[0],i=t[1];return console.warn("react-virtuoso: "+r+" property is deprecated. Pass components."+n+" instead."),c({},i,((e={})[n]=o,e))})),o.components)}return subscribe(r.adjustForPrependedItems,function(){console.warn("react-virtuoso: adjustForPrependedItems is no longer supported. Use the firstItemIndex property instead - https://virtuoso.dev/prepend-items.","color: red;","color: inherit;","color: blue;")}),subscribe(r.maxHeightCacheSize,function(){console.warn("react-virtuoso: maxHeightCacheSize is no longer necessary. Setting it has no effect - remove it from your code.")}),subscribe(r.HeaderContainer,function(){console.warn("react-virtuoso: HeaderContainer is deprecated. Use headerFooterTag if you want to change the wrapper of the header component and pass components.Header to change its contents.")}),subscribe(r.FooterContainer,function(){console.warn("react-virtuoso: FooterContainer is deprecated. Use headerFooterTag if you want to change the wrapper of the footer component and pass components.Footer to change its contents.")}),subscribe(r.scrollSeek,function(t){var r=t.placeholder,i=m(t,jt);console.warn("react-virtuoso: scrollSeek property is deprecated. Pass scrollSeekConfiguration and specify the placeholder in components.ScrollSeekPlaceholder instead."),publish(o.components,c({},getValue(o.components),{ScrollSeekPlaceholder:r})),publish(n.scrollSeekConfiguration,i)}),i(r.footer,"Footer","footer"),i(r.header,"Header","header"),i(r.ItemContainer,"Item","ItemContainer"),i(r.ListContainer,"List","ListContainer"),i(r.ScrollContainer,"Scroller","ScrollContainer"),i(r.emptyComponent,"EmptyPlaceholder","emptyComponent"),i(r.GroupContainer,"Group","GroupContainer"),c({},n,o,r)},tup(At,Zt)),Qt=function(t){return react.createElement("div",{style:{height:t.height}})},Xt={position:Nt(),zIndex:1,overflowAnchor:"none"},te={overflowAnchor:"none"},ee=react.memo(function(t){var o=t.showTopList,r=void 0!==o&&o,i=ge("listState"),a=he("sizeRanges"),s=ge("useWindowScroll"),u=ge("customScrollParent"),m=he("windowScrollContainerState"),d=he("scrollContainerState"),f=u||s?m:d,p=ge("itemContent"),h=ge("context"),g=ge("groupContent"),v=ge("trackItemSizes"),S=ge("itemSize"),C=ge("log"),I=he("gap"),w=T(a,S,v,r?noop:f,C,I,u).callbackRef,x=react.useState(0),b=x[0],y=x[1];ve("deviation",function(t){b!==t&&y(t)});var H=ge("EmptyPlaceholder"),E=ge("ScrollSeekPlaceholder")||Qt,R=ge("ListComponent"),L=ge("ItemComponent"),F=ge("GroupComponent"),k=ge("computeItemKey"),z=ge("isSeeking"),B=ge("groupIndices").length>0,P=ge("paddingTopAddition"),O=r?{}:{boxSizing:"border-box",paddingTop:i.offsetTop+P,paddingBottom:i.offsetBottom,marginTop:b};return!r&&0===i.totalCount&&H?(0,react.createElement)(H,ie(H,h)):(0,react.createElement)(R,c({},ie(R,h),{ref:w,style:O,"data-test-id":r?"virtuoso-top-item-list":"virtuoso-item-list"}),(r?i.topItems:i.items).map(function(t){var e=t.originalIndex,n=k(e+i.firstItemIndex,t.data,h);return z?(0,react.createElement)(E,c({},ie(E,h),{key:n,index:t.index,height:t.size,type:t.type||"item"},"group"===t.type?{}:{groupIndex:t.groupIndex})):"group"===t.type?(0,react.createElement)(F,c({},ie(F,h),{key:n,"data-index":e,"data-known-size":t.size,"data-item-index":t.index,style:Xt}),g(t.index)):(0,react.createElement)(L,c({},ie(L,h),{key:n,"data-index":e,"data-known-size":t.size,"data-item-index":t.index,"data-item-group-index":t.groupIndex,style:te}),B?p(t.index,t.groupIndex,t.data,h):p(t.index,t.data,h))}))}),ne={height:"100%",outline:"none",overflowY:"auto",position:"relative",WebkitOverflowScrolling:"touch"},oe={width:"100%",height:"100%",position:"absolute",top:0},re={width:"100%",position:Nt(),top:0};function ie(t,e){if("string"!=typeof t)return{context:e}}var ae=react.memo(function(){var t=ge("HeaderComponent"),e=he("headerHeight"),n=ge("headerFooterTag"),o=I(function(t){return e(w(t,"height"))}),r=ge("context");return t?(0,react.createElement)(n,{ref:o},(0,react.createElement)(t,ie(t,r))):null}),le=react.memo(function(){var t=ge("FooterComponent"),e=he("footerHeight"),n=ge("headerFooterTag"),o=I(function(t){return e(w(t,"height"))}),r=ge("context");return t?(0,react.createElement)(n,{ref:o},(0,react.createElement)(t,ie(t,r))):null});function se(t){var e=t.usePublisher,o=t.useEmitter,r=t.useEmitterValue;return react.memo(function(t){var n=t.style,i=t.children,a=m(t,Kt),s=e("scrollContainerState"),u=r("ScrollerComponent"),d=e("smoothScrollTargetReached"),f=r("scrollerRef"),p=r("context"),h=b(s,d,u,f),g=h.scrollerRef,v=h.scrollByCallback;return o("scrollTo",h.scrollToCallback),o("scrollBy",v),(0,react.createElement)(u,c({ref:g,style:c({},ne,n),"data-test-id":"virtuoso-scroller","data-virtuoso-scroller":!0,tabIndex:0},a,ie(u,p)),i)})}function ue(t){var o=t.usePublisher,r=t.useEmitter,i=t.useEmitterValue;return react.memo(function(t){var n=t.style,a=t.children,s=m(t,Yt),u=o("windowScrollContainerState"),d=i("ScrollerComponent"),f=o("smoothScrollTargetReached"),p=i("totalListHeight"),h=i("deviation"),v=i("customScrollParent"),S=i("context"),C=b(u,f,d,noop,v),I=C.scrollerRef,T=C.scrollByCallback,w=C.scrollToCallback;return g(function(){return I.current=v||window,function(){I.current=null}},[I,v]),r("windowScrollTo",w),r("scrollBy",T),(0,react.createElement)(d,c({style:c({position:"relative"},n,0!==p?{height:p+h}:{}),"data-virtuoso-scroller":!0},s,ie(d,S)),a)})}var ce=function(t){var o=t.children,r=(0,react.useContext)(Gt),i=he("viewportHeight"),a=he("fixedItemHeight"),l=I(compose(i,function(t){return w(t,"height")}));return react.useEffect(function(){r&&(i(r.viewportHeight),a(r.itemHeight))},[r,i,a]),react.createElement("div",{style:oe,ref:l,"data-viewport-type":"element"},o)},me=function(t){var e=t.children,o=(0,react.useContext)(Gt),r=he("windowViewportRect"),i=he("fixedItemHeight"),a=ge("customScrollParent"),l=Dt(r,a);return react.useEffect(function(){o&&(i(o.itemHeight),r({offsetTop:0,visibleHeight:o.viewportHeight,visibleWidth:100}))},[o,r,i]),react.createElement("div",{ref:l,style:oe,"data-viewport-type":"window"},e)},de=function(t){var e=t.children,n=ge("TopItemListComponent"),o=ge("headerHeight"),r=c({},re,{marginTop:o+"px"}),i=ge("context");return (0,react.createElement)(n||"div",{style:r,context:i},e)},fe=systemToComponent($t,{required:{},optional:{context:"context",followOutput:"followOutput",firstItemIndex:"firstItemIndex",itemContent:"itemContent",groupContent:"groupContent",overscan:"overscan",increaseViewportBy:"increaseViewportBy",totalCount:"totalCount",topItemCount:"topItemCount",initialTopMostItemIndex:"initialTopMostItemIndex",components:"components",groupCounts:"groupCounts",atBottomThreshold:"atBottomThreshold",atTopThreshold:"atTopThreshold",computeItemKey:"computeItemKey",defaultItemHeight:"defaultItemHeight",fixedItemHeight:"fixedItemHeight",itemSize:"itemSize",scrollSeekConfiguration:"scrollSeekConfiguration",headerFooterTag:"headerFooterTag",data:"data",initialItemCount:"initialItemCount",initialScrollTop:"initialScrollTop",alignToBottom:"alignToBottom",useWindowScroll:"useWindowScroll",customScrollParent:"customScrollParent",scrollerRef:"scrollerRef",logLevel:"logLevel",react18ConcurrentRendering:"react18ConcurrentRendering",item:"item",group:"group",topItems:"topItems",itemHeight:"itemHeight",scrollingStateChange:"scrollingStateChange",maxHeightCacheSize:"maxHeightCacheSize",footer:"footer",header:"header",ItemContainer:"ItemContainer",ScrollContainer:"ScrollContainer",ListContainer:"ListContainer",GroupContainer:"GroupContainer",emptyComponent:"emptyComponent",HeaderContainer:"HeaderContainer",FooterContainer:"FooterContainer",scrollSeek:"scrollSeek"},methods:{scrollToIndex:"scrollToIndex",scrollIntoView:"scrollIntoView",scrollTo:"scrollTo",scrollBy:"scrollBy",adjustForPrependedItems:"adjustForPrependedItems",autoscrollToBottom:"autoscrollToBottom"},events:{isScrolling:"isScrolling",endReached:"endReached",startReached:"startReached",rangeChanged:"rangeChanged",atBottomStateChange:"atBottomStateChange",atTopStateChange:"atTopStateChange",totalListHeightChanged:"totalListHeightChanged",itemsRendered:"itemsRendered",groupIndices:"groupIndices"}},react.memo(function(t){var e=ge("useWindowScroll"),o=ge("topItemsIndexes").length>0,r=ge("customScrollParent"),i=r||e?me:ce;return react.createElement(r||e?Ce:Se,c({},t),react.createElement(i,null,react.createElement(ae,null),react.createElement(ee,null),react.createElement(le,null)),o&&react.createElement(de,null,react.createElement(ee,{showTopList:!0})))})),pe=fe.Component,he=fe.usePublisher,ge=fe.useEmitterValue,ve=fe.useEmitter,Se=se({usePublisher:he,useEmitterValue:ge,useEmitter:ve}),Ce=ue({usePublisher:he,useEmitterValue:ge,useEmitter:ve}),Ie={items:[],offsetBottom:0,offsetTop:0,top:0,bottom:0,itemHeight:0,itemWidth:0},Te={items:[{index:0}],offsetBottom:0,offsetTop:0,top:0,bottom:0,itemHeight:0,itemWidth:0},we=Math.round,xe=Math.ceil,be=Math.floor,ye=Math.min,He=Math.max;function Ee(t,e,n){return Array.from({length:e-t+1}).map(function(e,o){return{index:o+t,data:null==n?void 0:n[o+t]}})}function Re(t,e){return t&&t.column===e.column&&t.row===e.row}var Le=system(function(t){var n=t[0],o=n.overscan,r=n.visibleRange,i=n.listBoundary,a=t[1],l=a.scrollTop,s=a.viewportHeight,u=a.scrollBy,m=a.scrollTo,d=a.smoothScrollTargetReached,f=a.scrollContainerState,p=a.footerHeight,h=a.headerHeight,g=t[2],v=t[3],S=t[4],C=S.propsReady,I=S.didMount,T=t[5],w=T.windowViewportRect,x=T.windowScrollTo,b=T.useWindowScroll,y=T.customScrollParent,H=T.windowScrollContainerState,E=t[6],R=statefulStream(0),L=statefulStream(0),F=statefulStream(Ie),k=statefulStream({height:0,width:0}),z=statefulStream({height:0,width:0}),B=stream(),P=stream(),O=statefulStream(0),M=statefulStream(void 0),W=statefulStream({row:0,column:0});connect(pipe(combineLatest(I,L,M),filter(function(t){return 0!==t[1]}),map(function(t){return{items:Ee(0,t[1]-1,t[2]),top:0,bottom:0,offsetBottom:0,offsetTop:0,itemHeight:0,itemWidth:0}})),F),connect(pipe(combineLatest(duc(R),r,duc(W,Re),duc(z,function(t,e){return t&&t.width===e.width&&t.height===e.height}),M),withLatestFrom(k),map(function(t){var e=t[0],n=e[0],o=e[1],r=o[0],i=o[1],a=e[2],l=e[3],s=e[4],u=t[1],m=a.row,d=a.column,f=l.height,p=l.width,h=u.width;if(0===n||0===h)return Ie;if(0===p)return function(t){return c({},Te,{items:t})}(Ee(0,0,s));var g=ze(h,p,d),v=g*be((r+m)/(f+m)),S=g*xe((i+m)/(f+m))-1;S=ye(n-1,He(S,g-1));var C=Ee(v=ye(S,He(0,v)),S,s),I=Fe(u,a,l,C),T=I.top,w=I.bottom,x=xe(n/g);return{items:C,offsetTop:T,offsetBottom:x*f+(x-1)*m-w,top:T,bottom:w,itemHeight:f,itemWidth:p}})),F),connect(pipe(M,filter(function(t){return void 0!==t}),map(function(t){return t.length})),R),connect(pipe(k,map(function(t){return t.height})),s),connect(pipe(combineLatest(k,z,F,W),map(function(t){var e=Fe(t[0],t[3],t[1],t[2].items);return[e.top,e.bottom]}),distinctUntilChanged(vt)),i);var V=streamFromEmitter(pipe(duc(F),filter(function(t){return t.items.length>0}),withLatestFrom(R),filter(function(t){var e=t[0].items;return e[e.length-1].index===t[1]-1}),map(function(t){return t[1]-1}),distinctUntilChanged())),U=streamFromEmitter(pipe(duc(F),filter(function(t){var e=t.items;return e.length>0&&0===e[0].index}),mapTo(0),distinctUntilChanged())),A=streamFromEmitter(pipe(duc(F),filter(function(t){return t.items.length>0}),map(function(t){var e=t.items;return{startIndex:e[0].index,endIndex:e[e.length-1].index}}),distinctUntilChanged(St)));connect(A,v.scrollSeekRangeChanged),connect(pipe(B,withLatestFrom(k,z,R,W),map(function(t){var e=t[1],n=t[2],o=t[3],r=t[4],i=at(t[0]),a=i.align,l=i.behavior,s=i.offset,u=i.index;"LAST"===u&&(u=o-1);var c=ke(e,r,n,u=He(0,u,ye(o-1,u)));return"end"===a?c=we(c-e.height+n.height):"center"===a&&(c=we(c-e.height/2+n.height/2)),s&&(c+=s),{top:c,behavior:l}})),m);var N=statefulStreamFromEmitter(pipe(F,map(function(t){return t.offsetBottom+t.bottom})),0);return connect(pipe(w,map(function(t){return{width:t.visibleWidth,height:t.visibleHeight}})),k),c({data:M,totalCount:R,viewportDimensions:k,itemDimensions:z,scrollTop:l,scrollHeight:P,overscan:o,scrollBy:u,scrollTo:m,scrollToIndex:B,smoothScrollTargetReached:d,windowViewportRect:w,windowScrollTo:x,useWindowScroll:b,customScrollParent:y,windowScrollContainerState:H,deviation:O,scrollContainerState:f,footerHeight:p,headerHeight:h,initialItemCount:L,gap:W},v,{gridState:F,totalListHeight:N},g,{startReached:U,endReached:V,rangeChanged:A,propsReady:C},E)},tup(Tt,y,ct,Et,mt,Ot,S));function Fe(t,e,n,o){var r=n.height;return void 0===r||0===o.length?{top:0,bottom:0}:{top:ke(t,e,n,o[0].index),bottom:ke(t,e,n,o[o.length-1].index)+r}}function ke(t,e,n,o){var r=ze(t.width,n.width,e.column),i=be(o/r),a=i*n.height+He(0,i-1)*e.row;return a>0?a+e.row:a}function ze(t,e,n){return He(1,be((t+n)/(e+n)))}var Be=["placeholder"],Pe=system(function(){var t=statefulStream(function(t){return"Item "+t}),n=statefulStream({}),o=statefulStream(null),r=statefulStream("virtuoso-grid-item"),i=statefulStream("virtuoso-grid-list"),a=statefulStream(qt),l=statefulStream("div"),s=statefulStream(noop),u=function(t,o){return void 0===o&&(o=null),statefulStreamFromEmitter(pipe(n,map(function(e){return e[t]}),distinctUntilChanged()),o)};return{context:o,itemContent:t,components:n,computeItemKey:a,itemClassName:r,listClassName:i,headerFooterTag:l,scrollerRef:s,FooterComponent:u("Footer"),HeaderComponent:u("Header"),ListComponent:u("List","div"),ItemComponent:u("Item","div"),ScrollerComponent:u("Scroller","div"),ScrollSeekPlaceholder:u("ScrollSeekPlaceholder","div")}}),Oe=system(function(t){var n=t[0],o=t[1],r={item:Jt(o.itemContent,"Rename the %citem%c prop to %citemContent."),ItemContainer:stream(),ScrollContainer:stream(),ListContainer:stream(),emptyComponent:stream(),scrollSeek:stream()};function i(t,n,r){connect(pipe(t,withLatestFrom(o.components),map(function(t){var e,o=t[0],i=t[1];return console.warn("react-virtuoso: "+r+" property is deprecated. Pass components."+n+" instead."),c({},i,((e={})[n]=o,e))})),o.components)}return subscribe(r.scrollSeek,function(t){var r=t.placeholder,i=m(t,Be);console.warn("react-virtuoso: scrollSeek property is deprecated. Pass scrollSeekConfiguration and specify the placeholder in components.ScrollSeekPlaceholder instead."),publish(o.components,c({},getValue(o.components),{ScrollSeekPlaceholder:r})),publish(n.scrollSeekConfiguration,i)}),i(r.ItemContainer,"Item","ItemContainer"),i(r.ListContainer,"List","ListContainer"),i(r.ScrollContainer,"Scroller","ScrollContainer"),c({},n,o,r)},tup(Le,Pe)),Me=react.memo(function(){var t=_e("gridState"),e=_e("listClassName"),n=_e("itemClassName"),o=_e("itemContent"),r=_e("computeItemKey"),i=_e("isSeeking"),a=Ge("scrollHeight"),s=_e("ItemComponent"),u=_e("ListComponent"),m=_e("ScrollSeekPlaceholder"),d=_e("context"),f=Ge("itemDimensions"),p=Ge("gap"),h=_e("log"),g=I(function(t){a(t.parentElement.parentElement.scrollHeight);var e=t.firstChild;e&&f(e.getBoundingClientRect()),p({row:qe("row-gap",getComputedStyle(t).rowGap,h),column:qe("column-gap",getComputedStyle(t).columnGap,h)})});return (0,react.createElement)(u,c({ref:g,className:e},ie(u,d),{style:{paddingTop:t.offsetTop,paddingBottom:t.offsetBottom}}),t.items.map(function(e){var a=r(e.index,e.data,d);return i?(0,react.createElement)(m,c({key:a},ie(m,d),{index:e.index,height:t.itemHeight,width:t.itemWidth})):(0,react.createElement)(s,c({},ie(s,d),{className:n,"data-index":e.index,key:a}),o(e.index,e.data,d))}))}),We=react.memo(function(){var t=_e("HeaderComponent"),e=Ge("headerHeight"),n=_e("headerFooterTag"),o=I(function(t){return e(w(t,"height"))}),r=_e("context");return t?(0,react.createElement)(n,{ref:o},(0,react.createElement)(t,ie(t,r))):null}),Ve=react.memo(function(){var t=_e("FooterComponent"),e=Ge("footerHeight"),n=_e("headerFooterTag"),o=I(function(t){return e(w(t,"height"))}),r=_e("context");return t?(0,react.createElement)(n,{ref:o},(0,react.createElement)(t,ie(t,r))):null}),Ue=function(t){var e=t.children,o=(0,react.useContext)(_t),r=Ge("itemDimensions"),i=Ge("viewportDimensions"),a=I(function(t){i(t.getBoundingClientRect())});return react.useEffect(function(){o&&(i({height:o.viewportHeight,width:o.viewportWidth}),r({height:o.itemHeight,width:o.itemWidth}))},[o,i,r]),react.createElement("div",{style:oe,ref:a},e)},Ae=function(t){var e=t.children,o=(0,react.useContext)(_t),r=Ge("windowViewportRect"),i=Ge("itemDimensions"),a=_e("customScrollParent"),l=Dt(r,a);return react.useEffect(function(){o&&(i({height:o.itemHeight,width:o.itemWidth}),r({offsetTop:0,visibleHeight:o.viewportHeight,visibleWidth:o.viewportWidth}))},[o,r,i]),react.createElement("div",{ref:l,style:oe},e)},Ne=systemToComponent(Oe,{optional:{context:"context",totalCount:"totalCount",overscan:"overscan",itemContent:"itemContent",components:"components",computeItemKey:"computeItemKey",data:"data",initialItemCount:"initialItemCount",scrollSeekConfiguration:"scrollSeekConfiguration",headerFooterTag:"headerFooterTag",listClassName:"listClassName",itemClassName:"itemClassName",useWindowScroll:"useWindowScroll",customScrollParent:"customScrollParent",scrollerRef:"scrollerRef",item:"item",ItemContainer:"ItemContainer",ScrollContainer:"ScrollContainer",ListContainer:"ListContainer",scrollSeek:"scrollSeek"},methods:{scrollTo:"scrollTo",scrollBy:"scrollBy",scrollToIndex:"scrollToIndex"},events:{isScrolling:"isScrolling",endReached:"endReached",startReached:"startReached",rangeChanged:"rangeChanged",atBottomStateChange:"atBottomStateChange",atTopStateChange:"atTopStateChange"}},react.memo(function(t){var e=c({},t),o=_e("useWindowScroll"),r=_e("customScrollParent"),i=r||o?Ae:Ue;return react.createElement(r||o?Ye:Ke,c({},e),react.createElement(i,null,react.createElement(We,null),react.createElement(Me,null),react.createElement(Ve,null)))})),De=Ne.Component,Ge=Ne.usePublisher,_e=Ne.useEmitterValue,je=Ne.useEmitter,Ke=se({usePublisher:Ge,useEmitterValue:_e,useEmitter:je}),Ye=ue({usePublisher:Ge,useEmitterValue:_e,useEmitter:je});function qe(t,e,n){return"normal"===e||null!=e&&e.endsWith("px")||n(t+" was not resolved to pixel value correctly",e,h.WARN),"normal"===e?0:parseInt(null!=e?e:"0",10)}var Ze=system(function(){var t=statefulStream(function(t){return react.createElement("td",null,"Item $",t)}),o=statefulStream(null),r=statefulStream(null),i=statefulStream(null),a=statefulStream({}),l=statefulStream(qt),s=statefulStream(noop),u=function(t,n){return void 0===n&&(n=null),statefulStreamFromEmitter(pipe(a,map(function(e){return e[t]}),distinctUntilChanged()),n)};return{context:o,itemContent:t,fixedHeaderContent:r,fixedFooterContent:i,components:a,computeItemKey:l,scrollerRef:s,TableComponent:u("Table","table"),TableHeadComponent:u("TableHead","thead"),TableFooterComponent:u("TableFoot","tfoot"),TableBodyComponent:u("TableBody","tbody"),TableRowComponent:u("TableRow","tr"),ScrollerComponent:u("Scroller","div"),EmptyPlaceholder:u("EmptyPlaceholder"),ScrollSeekPlaceholder:u("ScrollSeekPlaceholder"),FillerRow:u("FillerRow")}}),Je=system(function(t){return c({},t[0],t[1])},tup(At,Ze)),$e=function(t){return react.createElement("tr",null,react.createElement("td",{style:{height:t.height}}))},Qe=function(t){return react.createElement("tr",null,react.createElement("td",{style:{height:t.height,padding:0,border:0}}))},Xe=react.memo(function(){var t=an("listState"),e=rn("sizeRanges"),o=an("useWindowScroll"),r=an("customScrollParent"),i=rn("windowScrollContainerState"),a=rn("scrollContainerState"),s=r||o?i:a,u=an("itemContent"),m=an("trackItemSizes"),d=T(e,an("itemSize"),m,s,an("log"),void 0,r),f=d.callbackRef,p=d.ref,h=react.useState(0),g=h[0],v=h[1];ln("deviation",function(t){g!==t&&(p.current.style.marginTop=t+"px",v(t))});var S=an("EmptyPlaceholder"),C=an("ScrollSeekPlaceholder")||$e,I=an("FillerRow")||Qe,w=an("TableBodyComponent"),x=an("TableRowComponent"),b=an("computeItemKey"),y=an("isSeeking"),H=an("paddingTopAddition"),E=an("firstItemIndex"),R=an("statefulTotalCount"),L=an("context");if(0===R&&S)return (0,react.createElement)(S,ie(S,L));var F=t.offsetTop+H+g,k=t.offsetBottom,z=F>0?react.createElement(I,{height:F,key:"padding-top"}):null,B=k>0?react.createElement(I,{height:k,key:"padding-bottom"}):null,P=t.items.map(function(t){var e=t.originalIndex,n=b(e+E,t.data,L);return y?(0,react.createElement)(C,c({},ie(C,L),{key:n,index:t.index,height:t.size,type:t.type||"item"})):(0,react.createElement)(x,c({},ie(x,L),{key:n,"data-index":e,"data-known-size":t.size,"data-item-index":t.index,style:{overflowAnchor:"none"}}),u(t.index,t.data,L))});return (0,react.createElement)(w,c({ref:f,"data-test-id":"virtuoso-item-list"},ie(w,L)),[z].concat(P,[B]))}),tn=function(t){var o=t.children,r=(0,react.useContext)(Gt),i=rn("viewportHeight"),a=rn("fixedItemHeight"),l=I(compose(i,function(t){return w(t,"height")}));return react.useEffect(function(){r&&(i(r.viewportHeight),a(r.itemHeight))},[r,i,a]),react.createElement("div",{style:oe,ref:l,"data-viewport-type":"element"},o)},en=function(t){var e=t.children,o=(0,react.useContext)(Gt),r=rn("windowViewportRect"),i=rn("fixedItemHeight"),a=an("customScrollParent"),l=Dt(r,a);return react.useEffect(function(){o&&(i(o.itemHeight),r({offsetTop:0,visibleHeight:o.viewportHeight,visibleWidth:100}))},[o,r,i]),react.createElement("div",{ref:l,style:oe,"data-viewport-type":"window"},e)},nn=systemToComponent(Je,{required:{},optional:{context:"context",followOutput:"followOutput",firstItemIndex:"firstItemIndex",itemContent:"itemContent",fixedHeaderContent:"fixedHeaderContent",fixedFooterContent:"fixedFooterContent",overscan:"overscan",increaseViewportBy:"increaseViewportBy",totalCount:"totalCount",topItemCount:"topItemCount",initialTopMostItemIndex:"initialTopMostItemIndex",components:"components",groupCounts:"groupCounts",atBottomThreshold:"atBottomThreshold",atTopThreshold:"atTopThreshold",computeItemKey:"computeItemKey",defaultItemHeight:"defaultItemHeight",fixedItemHeight:"fixedItemHeight",itemSize:"itemSize",scrollSeekConfiguration:"scrollSeekConfiguration",data:"data",initialItemCount:"initialItemCount",initialScrollTop:"initialScrollTop",alignToBottom:"alignToBottom",useWindowScroll:"useWindowScroll",customScrollParent:"customScrollParent",scrollerRef:"scrollerRef",logLevel:"logLevel",react18ConcurrentRendering:"react18ConcurrentRendering"},methods:{scrollToIndex:"scrollToIndex",scrollIntoView:"scrollIntoView",scrollTo:"scrollTo",scrollBy:"scrollBy"},events:{isScrolling:"isScrolling",endReached:"endReached",startReached:"startReached",rangeChanged:"rangeChanged",atBottomStateChange:"atBottomStateChange",atTopStateChange:"atTopStateChange",totalListHeightChanged:"totalListHeightChanged",itemsRendered:"itemsRendered",groupIndices:"groupIndices"}},react.memo(function(t){var o=an("useWindowScroll"),r=an("customScrollParent"),i=rn("fixedHeaderHeight"),a=rn("fixedFooterHeight"),l=an("fixedHeaderContent"),s=an("fixedFooterContent"),u=an("context"),m=I(compose(i,function(t){return w(t,"height")})),d=I(compose(a,function(t){return w(t,"height")})),f=r||o?un:sn,p=r||o?en:tn,h=an("TableComponent"),g=an("TableHeadComponent"),v=an("TableFooterComponent"),S=l?react.createElement(g,c({key:"TableHead",style:{zIndex:1,position:"sticky",top:0},ref:m},ie(g,u)),l()):null,C=s?react.createElement(v,c({key:"TableFoot",style:{zIndex:1,position:"sticky",bottom:0},ref:d},ie(v,u)),s()):null;return react.createElement(f,c({},t),react.createElement(p,null,react.createElement(h,c({style:{borderSpacing:0}},ie(h,u)),[S,react.createElement(Xe,{key:"TableBody"}),C])))})),on=nn.Component,rn=nn.usePublisher,an=nn.useEmitterValue,ln=nn.useEmitter,sn=se({usePublisher:rn,useEmitterValue:an,useEmitter:ln}),un=ue({usePublisher:rn,useEmitterValue:an,useEmitter:ln}),cn=pe,mn=pe,dn=on,fn=De;
//# sourceMappingURL=index.m.js.map


/***/ }),

/***/ 35666:
/***/ (function(module) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : 0
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),

/***/ 70655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__assign": function() { return /* binding */ __assign; },
/* harmony export */   "__asyncDelegator": function() { return /* binding */ __asyncDelegator; },
/* harmony export */   "__asyncGenerator": function() { return /* binding */ __asyncGenerator; },
/* harmony export */   "__asyncValues": function() { return /* binding */ __asyncValues; },
/* harmony export */   "__await": function() { return /* binding */ __await; },
/* harmony export */   "__awaiter": function() { return /* binding */ __awaiter; },
/* harmony export */   "__classPrivateFieldGet": function() { return /* binding */ __classPrivateFieldGet; },
/* harmony export */   "__classPrivateFieldIn": function() { return /* binding */ __classPrivateFieldIn; },
/* harmony export */   "__classPrivateFieldSet": function() { return /* binding */ __classPrivateFieldSet; },
/* harmony export */   "__createBinding": function() { return /* binding */ __createBinding; },
/* harmony export */   "__decorate": function() { return /* binding */ __decorate; },
/* harmony export */   "__exportStar": function() { return /* binding */ __exportStar; },
/* harmony export */   "__extends": function() { return /* binding */ __extends; },
/* harmony export */   "__generator": function() { return /* binding */ __generator; },
/* harmony export */   "__importDefault": function() { return /* binding */ __importDefault; },
/* harmony export */   "__importStar": function() { return /* binding */ __importStar; },
/* harmony export */   "__makeTemplateObject": function() { return /* binding */ __makeTemplateObject; },
/* harmony export */   "__metadata": function() { return /* binding */ __metadata; },
/* harmony export */   "__param": function() { return /* binding */ __param; },
/* harmony export */   "__read": function() { return /* binding */ __read; },
/* harmony export */   "__rest": function() { return /* binding */ __rest; },
/* harmony export */   "__spread": function() { return /* binding */ __spread; },
/* harmony export */   "__spreadArray": function() { return /* binding */ __spreadArray; },
/* harmony export */   "__spreadArrays": function() { return /* binding */ __spreadArrays; },
/* harmony export */   "__values": function() { return /* binding */ __values; }
/* harmony export */ });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}


/***/ }),

/***/ 42238:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v1.0.2
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License *//*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */
/////////////////////////////////////////////////////////////////////////////////

(function (window, undefined) {

    'use strict';

    //////////////
    // Constants
    /////////////


    var LIBVERSION  = '1.0.2',
        EMPTY       = '',
        UNKNOWN     = '?',
        FUNC_TYPE   = 'function',
        UNDEF_TYPE  = 'undefined',
        OBJ_TYPE    = 'object',
        STR_TYPE    = 'string',
        MAJOR       = 'major',
        MODEL       = 'model',
        NAME        = 'name',
        TYPE        = 'type',
        VENDOR      = 'vendor',
        VERSION     = 'version',
        ARCHITECTURE= 'architecture',
        CONSOLE     = 'console',
        MOBILE      = 'mobile',
        TABLET      = 'tablet',
        SMARTTV     = 'smarttv',
        WEARABLE    = 'wearable',
        EMBEDDED    = 'embedded',
        UA_MAX_LENGTH = 255;

    var AMAZON  = 'Amazon',
        APPLE   = 'Apple',
        ASUS    = 'ASUS',
        BLACKBERRY = 'BlackBerry',
        BROWSER = 'Browser',
        CHROME  = 'Chrome',
        EDGE    = 'Edge',
        FIREFOX = 'Firefox',
        GOOGLE  = 'Google',
        HUAWEI  = 'Huawei',
        LG      = 'LG',
        MICROSOFT = 'Microsoft',
        MOTOROLA  = 'Motorola',
        OPERA   = 'Opera',
        SAMSUNG = 'Samsung',
        SONY    = 'Sony',
        XIAOMI  = 'Xiaomi',
        ZEBRA   = 'Zebra',
        FACEBOOK   = 'Facebook';

    ///////////
    // Helper
    //////////

    var extend = function (regexes, extensions) {
            var mergedRegexes = {};
            for (var i in regexes) {
                if (extensions[i] && extensions[i].length % 2 === 0) {
                    mergedRegexes[i] = extensions[i].concat(regexes[i]);
                } else {
                    mergedRegexes[i] = regexes[i];
                }
            }
            return mergedRegexes;
        },
        enumerize = function (arr) {
            var enums = {};
            for (var i=0; i<arr.length; i++) {
                enums[arr[i].toUpperCase()] = arr[i];
            }
            return enums;
        },
        has = function (str1, str2) {
            return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
        },
        lowerize = function (str) {
            return str.toLowerCase();
        },
        majorize = function (version) {
            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined;
        },
        trim = function (str, len) {
            if (typeof(str) === STR_TYPE) {
                str = str.replace(/^\s\s*/, EMPTY).replace(/\s\s*$/, EMPTY);
                return typeof(len) === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
            }
    };

    ///////////////
    // Map helper
    //////////////

    var rgxMapper = function (ua, arrays) {

            var i = 0, j, k, p, q, matches, match;

            // loop through all regexes maps
            while (i < arrays.length && !matches) {

                var regex = arrays[i],       // even sequence (0,2,4,..)
                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
                j = k = 0;

                // try matching uastring with regexes
                while (j < regex.length && !matches) {

                    matches = regex[j++].exec(ua);

                    if (!!matches) {
                        for (p = 0; p < props.length; p++) {
                            match = matches[++k];
                            q = props[p];
                            // check if given property is actually array
                            if (typeof q === OBJ_TYPE && q.length > 0) {
                                if (q.length === 2) {
                                    if (typeof q[1] == FUNC_TYPE) {
                                        // assign modified match
                                        this[q[0]] = q[1].call(this, match);
                                    } else {
                                        // assign given value, ignore regex match
                                        this[q[0]] = q[1];
                                    }
                                } else if (q.length === 3) {
                                    // check whether function or regex
                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                        // call function (usually string mapper)
                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                    } else {
                                        // sanitize match using given regex
                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                    }
                                } else if (q.length === 4) {
                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                                }
                            } else {
                                this[q] = match ? match : undefined;
                            }
                        }
                    }
                }
                i += 2;
            }
        },

        strMapper = function (str, map) {

            for (var i in map) {
                // check if current value is array
                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                    for (var j = 0; j < map[i].length; j++) {
                        if (has(map[i][j], str)) {
                            return (i === UNKNOWN) ? undefined : i;
                        }
                    }
                } else if (has(map[i], str)) {
                    return (i === UNKNOWN) ? undefined : i;
                }
            }
            return str;
    };

    ///////////////
    // String map
    //////////////

    // Safari < 3.0
    var oldSafariMap = {
            '1.0'   : '/8',
            '1.2'   : '/1',
            '1.3'   : '/3',
            '2.0'   : '/412',
            '2.0.2' : '/416',
            '2.0.3' : '/417',
            '2.0.4' : '/419',
            '?'     : '/'
        },
        windowsVersionMap = {
            'ME'        : '4.90',
            'NT 3.11'   : 'NT3.51',
            'NT 4.0'    : 'NT4.0',
            '2000'      : 'NT 5.0',
            'XP'        : ['NT 5.1', 'NT 5.2'],
            'Vista'     : 'NT 6.0',
            '7'         : 'NT 6.1',
            '8'         : 'NT 6.2',
            '8.1'       : 'NT 6.3',
            '10'        : ['NT 6.4', 'NT 10.0'],
            'RT'        : 'ARM'
    };

    //////////////
    // Regex map
    /////////////

    var regexes = {

        browser : [[

            /\b(?:crmo|crios)\/([\w\.]+)/i                                      // Chrome for Android/iOS
            ], [VERSION, [NAME, 'Chrome']], [
            /edg(?:e|ios|a)?\/([\w\.]+)/i                                       // Microsoft Edge
            ], [VERSION, [NAME, 'Edge']], [

            // Presto based
            /(opera mini)\/([-\w\.]+)/i,                                        // Opera Mini
            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,                 // Opera Mobi/Tablet
            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i                           // Opera
            ], [NAME, VERSION], [
            /opios[\/ ]+([\w\.]+)/i                                             // Opera mini on iphone >= 8.0
            ], [VERSION, [NAME, OPERA+' Mini']], [
            /\bopr\/([\w\.]+)/i                                                 // Opera Webkit
            ], [VERSION, [NAME, OPERA]], [

            // Mixed
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,      // Lunascape/Maxthon/Netfront/Jasmine/Blazer
            // Trident based
            /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,               // Avant/IEMobile/SlimBrowser
            /(ba?idubrowser)[\/ ]?([\w\.]+)/i,                                  // Baidu Browser
            /(?:ms|\()(ie) ([\w\.]+)/i,                                         // Internet Explorer

            // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
            /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([-\w\.]+)/i,
                                                                                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
            /(weibo)__([\d\.]+)/i                                               // Weibo
            ], [NAME, VERSION], [
            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i                 // UCBrowser
            ], [VERSION, [NAME, 'UC'+BROWSER]], [
            /\bqbcore\/([\w\.]+)/i                                              // WeChat Desktop for Windows Built-in Browser
            ], [VERSION, [NAME, 'WeChat(Win) Desktop']], [
            /micromessenger\/([\w\.]+)/i                                        // WeChat
            ], [VERSION, [NAME, 'WeChat']], [
            /konqueror\/([\w\.]+)/i                                             // Konqueror
            ], [VERSION, [NAME, 'Konqueror']], [
            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i                       // IE11
            ], [VERSION, [NAME, 'IE']], [
            /yabrowser\/([\w\.]+)/i                                             // Yandex
            ], [VERSION, [NAME, 'Yandex']], [
            /(avast|avg)\/([\w\.]+)/i                                           // Avast/AVG Secure Browser
            ], [[NAME, /(.+)/, '$1 Secure '+BROWSER], VERSION], [
            /\bfocus\/([\w\.]+)/i                                               // Firefox Focus
            ], [VERSION, [NAME, FIREFOX+' Focus']], [
            /\bopt\/([\w\.]+)/i                                                 // Opera Touch
            ], [VERSION, [NAME, OPERA+' Touch']], [
            /coc_coc\w+\/([\w\.]+)/i                                            // Coc Coc Browser
            ], [VERSION, [NAME, 'Coc Coc']], [
            /dolfin\/([\w\.]+)/i                                                // Dolphin
            ], [VERSION, [NAME, 'Dolphin']], [
            /coast\/([\w\.]+)/i                                                 // Opera Coast
            ], [VERSION, [NAME, OPERA+' Coast']], [
            /miuibrowser\/([\w\.]+)/i                                           // MIUI Browser
            ], [VERSION, [NAME, 'MIUI '+BROWSER]], [
            /fxios\/([-\w\.]+)/i                                                // Firefox for iOS
            ], [VERSION, [NAME, FIREFOX]], [
            /\bqihu|(qi?ho?o?|360)browser/i                                     // 360
            ], [[NAME, '360 '+BROWSER]], [
            /(oculus|samsung|sailfish)browser\/([\w\.]+)/i
            ], [[NAME, /(.+)/, '$1 '+BROWSER], VERSION], [                      // Oculus/Samsung/Sailfish Browser
            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
            ], [[NAME, /_/g, ' '], VERSION], [
            /(electron)\/([\w\.]+) safari/i,                                    // Electron-based App
            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,                   // Tesla
            /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i            // QQBrowser/Baidu App/2345 Browser
            ], [NAME, VERSION], [
            /(metasr)[\/ ]?([\w\.]+)/i,                                         // SouGouBrowser
            /(lbbrowser)/i                                                      // LieBao Browser
            ], [NAME], [

            // WebView
            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i       // Facebook App for iOS & Android
            ], [[NAME, FACEBOOK], VERSION], [
            /safari (line)\/([\w\.]+)/i,                                        // Line App for iOS
            /\b(line)\/([\w\.]+)\/iab/i,                                        // Line App for Android
            /(chromium|instagram)[\/ ]([-\w\.]+)/i                              // Chromium/Instagram
            ], [NAME, VERSION], [
            /\bgsa\/([\w\.]+) .*safari\//i                                      // Google Search Appliance on iOS
            ], [VERSION, [NAME, 'GSA']], [

            /headlesschrome(?:\/([\w\.]+)| )/i                                  // Chrome Headless
            ], [VERSION, [NAME, CHROME+' Headless']], [

            / wv\).+(chrome)\/([\w\.]+)/i                                       // Chrome WebView
            ], [[NAME, CHROME+' WebView'], VERSION], [

            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i           // Android Browser
            ], [VERSION, [NAME, 'Android '+BROWSER]], [

            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i       // Chrome/OmniWeb/Arora/Tizen/Nokia
            ], [NAME, VERSION], [

            /version\/([\w\.]+) .*mobile\/\w+ (safari)/i                        // Mobile Safari
            ], [VERSION, [NAME, 'Mobile Safari']], [
            /version\/([\w\.]+) .*(mobile ?safari|safari)/i                     // Safari & Safari Mobile
            ], [VERSION, NAME], [
            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i                      // Safari < 3.0
            ], [NAME, [VERSION, strMapper, oldSafariMap]], [

            /(webkit|khtml)\/([\w\.]+)/i
            ], [NAME, VERSION], [

            // Gecko based
            /(navigator|netscape\d?)\/([-\w\.]+)/i                              // Netscape
            ], [[NAME, 'Netscape'], VERSION], [
            /mobile vr; rv:([\w\.]+)\).+firefox/i                               // Firefox Reality
            ], [VERSION, [NAME, FIREFOX+' Reality']], [
            /ekiohf.+(flow)\/([\w\.]+)/i,                                       // Flow
            /(swiftfox)/i,                                                      // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(firefox)\/([\w\.]+)/i,                                            // Other Firefox-based
            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,                         // Mozilla

            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
            /(links) \(([\w\.]+)/i                                              // Links
            ], [NAME, VERSION]
        ],

        cpu : [[

            /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i                     // AMD64 (x64)
            ], [[ARCHITECTURE, 'amd64']], [

            /(ia32(?=;))/i                                                      // IA32 (quicktime)
            ], [[ARCHITECTURE, lowerize]], [

            /((?:i[346]|x)86)[;\)]/i                                            // IA32 (x86)
            ], [[ARCHITECTURE, 'ia32']], [

            /\b(aarch64|arm(v?8e?l?|_?64))\b/i                                 // ARM64
            ], [[ARCHITECTURE, 'arm64']], [

            /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i                                   // ARMHF
            ], [[ARCHITECTURE, 'armhf']], [

            // PocketPC mistakenly identified as PowerPC
            /windows (ce|mobile); ppc;/i
            ], [[ARCHITECTURE, 'arm']], [

            /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i                            // PowerPC
            ], [[ARCHITECTURE, /ower/, EMPTY, lowerize]], [

            /(sun4\w)[;\)]/i                                                    // SPARC
            ], [[ARCHITECTURE, 'sparc']], [

            /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
            ], [[ARCHITECTURE, lowerize]]
        ],

        device : [[

            //////////////////////////
            // MOBILES & TABLETS
            // Ordered by popularity
            /////////////////////////

            // Samsung
            /\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]], [
            /\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i,
            /samsung[- ]([-\w]+)/i,
            /sec-(sgh\w+)/i
            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]], [

            // Apple
            /\((ip(?:hone|od)[\w ]*);/i                                         // iPod/iPhone
            ], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [
            /\((ipad);[-\w\),; ]+apple/i,                                       // iPad
            /applecoremedia\/[\w\.]+ \((ipad)/i,
            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [

            // Huawei
            /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ], [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]], [
            /(?:huawei|honor)([-\w ]+)[;\)]/i,
            /\b(nexus 6p|\w{2,4}-[atu]?[ln][01259x][012359][an]?)\b(?!.+d\/s)/i
            ], [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]], [

            // Xiaomi
            /\b(poco[\w ]+)(?: bui|\))/i,                                       // Xiaomi POCO
            /\b; (\w+) build\/hm\1/i,                                           // Xiaomi Hongmi 'numeric' models
            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,                             // Xiaomi Hongmi
            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,                   // Xiaomi Redmi
            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
            ], [[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, MOBILE]], [
            /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i                        // Mi Pad tablets
            ],[[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, TABLET]], [

            // OPPO
            /; (\w+) bui.+ oppo/i,
            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [

            // Vivo
            /vivo (\w+)(?: bui|\))/i,
            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ], [MODEL, [VENDOR, 'Vivo'], [TYPE, MOBILE]], [

            // Realme
            /\b(rmx[12]\d{3})(?: bui|;|\))/i
            ], [MODEL, [VENDOR, 'Realme'], [TYPE, MOBILE]], [

            // Motorola
            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
            /\bmot(?:orola)?[- ](\w*)/i,
            /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]], [
            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]], [

            // LG
            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ], [MODEL, [VENDOR, LG], [TYPE, TABLET]], [
            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
            /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
            /\blg-?([\d\w]+) bui/i
            ], [MODEL, [VENDOR, LG], [TYPE, MOBILE]], [

            // Lenovo
            /(ideatab[-\w ]+)/i,
            /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

            // Nokia
            /(?:maemo|nokia).*(n900|lumia \d+)/i,
            /nokia[-_ ]?([-\w\.]*)/i
            ], [[MODEL, /_/g, ' '], [VENDOR, 'Nokia'], [TYPE, MOBILE]], [

            // Google
            /(pixel c)\b/i                                                      // Google Pixel C
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]], [
            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i                         // Google Pixel
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]], [

            // Sony
            /droid.+ ([c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ], [MODEL, [VENDOR, SONY], [TYPE, MOBILE]], [
            /sony tablet [ps]/i,
            /\b(?:sony)?sgp\w+(?: bui|\))/i
            ], [[MODEL, 'Xperia Tablet'], [VENDOR, SONY], [TYPE, TABLET]], [

            // OnePlus
            / (kb2005|in20[12]5|be20[12][59])\b/i,
            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

            // Amazon
            /(alexa)webm/i,
            /(kf[a-z]{2}wi)( bui|\))/i,                                         // Kindle Fire without Silk
            /(kf[a-z]+)( bui|\)).+silk\//i                                      // Kindle Fire HD
            ], [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]], [
            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i                     // Fire Phone
            ], [[MODEL, /(.+)/g, 'Fire Phone $1'], [VENDOR, AMAZON], [TYPE, MOBILE]], [

            // BlackBerry
            /(playbook);[-\w\),; ]+(rim)/i                                      // BlackBerry PlayBook
            ], [MODEL, VENDOR, [TYPE, TABLET]], [
            /\b((?:bb[a-f]|st[hv])100-\d)/i,
            /\(bb10; (\w+)/i                                                    // BlackBerry 10
            ], [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]], [

            // Asus
            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ], [MODEL, [VENDOR, ASUS], [TYPE, TABLET]], [
            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ], [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]], [

            // HTC
            /(nexus 9)/i                                                        // HTC Nexus 9
            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [
            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,                         // HTC

            // ZTE
            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
            /(alcatel|geeksphone|nexian|panasonic|sony)[-_ ]?([-\w]*)/i         // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

            // Acer
            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

            // Meizu
            /droid.+; (m[1-5] note) bui/i,
            /\bmz-([-\w]{2,})/i
            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [

            // Sharp
            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, MOBILE]], [

            // MIXED
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
                                                                                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp) ([\w ]+\w)/i,                                                 // HP iPAQ
            /(asus)-?(\w+)/i,                                                   // Asus
            /(microsoft); (lumia[\w ]+)/i,                                      // Microsoft Lumia
            /(lenovo)[-_ ]?([-\w]+)/i,                                          // Lenovo
            /(jolla)/i,                                                         // Jolla
            /(oppo) ?([\w ]+) bui/i                                             // OPPO
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /(archos) (gamepad2?)/i,                                            // Archos
            /(hp).+(touchpad(?!.+tablet)|tablet)/i,                             // HP TouchPad
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(nook)[\w ]+build\/(\w+)/i,                                        // Nook
            /(dell) (strea[kpr\d ]*[\dko])/i,                                   // Dell Streak
            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,                                  // Le Pan Tablets
            /(trinity)[- ]*(t\d{3}) bui/i,                                      // Trinity Tablets
            /(gigaset)[- ]+(q\w{1,9}) bui/i,                                    // Gigaset Tablets
            /(vodafone) ([\w ]+)(?:\)| bui)/i                                   // Vodafone
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(surface duo)/i                                                    // Surface Duo
            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]], [
            /droid [\d\.]+; (fp\du?)(?: b|\))/i                                 // Fairphone
            ], [MODEL, [VENDOR, 'Fairphone'], [TYPE, MOBILE]], [
            /(u304aa)/i                                                         // AT&T
            ], [MODEL, [VENDOR, 'AT&T'], [TYPE, MOBILE]], [
            /\bsie-(\w*)/i                                                      // Siemens
            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [
            /\b(rct\w+) b/i                                                     // RCA Tablets
            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [
            /\b(venue[\d ]{2,7}) b/i                                            // Dell Venue Tablets
            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [
            /\b(q(?:mv|ta)\w+) b/i                                              // Verizon Tablet
            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [
            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i                       // Barnes & Noble Tablet
            ], [MODEL, [VENDOR, 'Barnes & Noble'], [TYPE, TABLET]], [
            /\b(tm\d{3}\w+) b/i
            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [
            /\b(k88) b/i                                                        // ZTE K Series Tablet
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [
            /\b(nx\d{3}j) b/i                                                   // ZTE Nubia
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
            /\b(gen\d{3}) b.+49h/i                                              // Swiss GEN Mobile
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [
            /\b(zur\d{3}) b/i                                                   // Swiss ZUR Tablet
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [
            /\b((zeki)?tb.*\b) b/i                                              // Zeki Tablets
            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [
            /\b([yr]\d{2}) b/i,
            /\b(dragon[- ]+touch |dt)(\w{5}) b/i                                // Dragon Touch Tablet
            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [
            /\b(ns-?\w{0,9}) b/i                                                // Insignia Tablets
            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [
            /\b((nxa|next)-?\w{0,9}) b/i                                        // NextBook Tablets
            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [
            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i                  // Voice Xtreme Phones
            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [
            /\b(lvtel\-)?(v1[12]) b/i                                           // LvTel Phones
            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [
            /\b(ph-1) /i                                                        // Essential PH-1
            ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [
            /\b(v(100md|700na|7011|917g).*\b) b/i                               // Envizen Tablets
            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [
            /\b(trio[-\w\. ]+) b/i                                              // MachSpeed Tablets
            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [
            /\btu_(1491) b/i                                                    // Rotor Tablets
            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [
            /(shield[\w ]+) b/i                                                 // Nvidia Shield Tablets
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, TABLET]], [
            /(sprint) (\w+)/i                                                   // Sprint Phones
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
            ], [[MODEL, /\./g, ' '], [VENDOR, MICROSOFT], [TYPE, MOBILE]], [
            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i             // Zebra
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]], [
            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]], [

            ///////////////////
            // CONSOLES
            ///////////////////

            /(ouya)/i,                                                          // Ouya
            /(nintendo) ([wids3utch]+)/i                                        // Nintendo
            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [
            /droid.+; (shield) bui/i                                            // Nvidia
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [
            /(playstation [345portablevi]+)/i                                   // Playstation
            ], [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]], [
            /\b(xbox(?: one)?(?!; xbox))[\); ]/i                                // Microsoft Xbox
            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]], [

            ///////////////////
            // SMARTTVS
            ///////////////////

            /smart-tv.+(samsung)/i                                              // Samsung
            ], [VENDOR, [TYPE, SMARTTV]], [
            /hbbtv.+maple;(\d+)/i
            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, SAMSUNG], [TYPE, SMARTTV]], [
            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i        // LG SmartTV
            ], [[VENDOR, LG], [TYPE, SMARTTV]], [
            /(apple) ?tv/i                                                      // Apple TV
            ], [VENDOR, [MODEL, APPLE+' TV'], [TYPE, SMARTTV]], [
            /crkey/i                                                            // Google Chromecast
            ], [[MODEL, CHROME+'cast'], [VENDOR, GOOGLE], [TYPE, SMARTTV]], [
            /droid.+aft(\w)( bui|\))/i                                          // Fire TV
            ], [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]], [
            /\(dtv[\);].+(aquos)/i                                              // Sharp
            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [
            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,                          // Roku
            /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i               // HbbTV devices
            ], [[VENDOR, trim], [MODEL, trim], [TYPE, SMARTTV]], [
            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i                   // SmartTV from Unidentified Vendors
            ], [[TYPE, SMARTTV]], [

            ///////////////////
            // WEARABLES
            ///////////////////

            /((pebble))app/i                                                    // Pebble
            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [
            /droid.+; (glass) \d/i                                              // Google Glass
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]], [
            /droid.+; (wt63?0{2,3})\)/i
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]], [
            /(quest( 2)?)/i                                                     // Oculus Quest
            ], [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]], [

            ///////////////////
            // EMBEDDED
            ///////////////////

            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i                              // Tesla
            ], [VENDOR, [TYPE, EMBEDDED]], [

            ////////////////////
            // MIXED (GENERIC)
            ///////////////////

            /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i           // Android Phones from Unidentified Vendors
            ], [MODEL, [TYPE, MOBILE]], [
            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i       // Android Tablets from Unidentified Vendors
            ], [MODEL, [TYPE, TABLET]], [
            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i                      // Unidentifiable Tablet
            ], [[TYPE, TABLET]], [
            /(phone|mobile(?:[;\/]| safari)|pda(?=.+windows ce))/i              // Unidentifiable Mobile
            ], [[TYPE, MOBILE]], [
            /(android[-\w\. ]{0,9});.+buil/i                                    // Generic Android Device
            ], [MODEL, [VENDOR, 'Generic']]
        ],

        engine : [[

            /windows.+ edge\/([\w\.]+)/i                                       // EdgeHTML
            ], [VERSION, [NAME, EDGE+'HTML']], [

            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i                         // Blink
            ], [VERSION, [NAME, 'Blink']], [

            /(presto)\/([\w\.]+)/i,                                             // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
            /ekioh(flow)\/([\w\.]+)/i,                                          // Flow
            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,                           // KHTML/Tasman/Links
            /(icab)[\/ ]([23]\.[\d\.]+)/i                                       // iCab
            ], [NAME, VERSION], [

            /rv\:([\w\.]{1,9})\b.+(gecko)/i                                     // Gecko
            ], [VERSION, NAME]
        ],

        os : [[

            // Windows
            /microsoft (windows) (vista|xp)/i                                   // Windows (iTunes)
            ], [NAME, VERSION], [
            /(windows) nt 6\.2; (arm)/i,                                        // Windows RT
            /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,            // Windows Phone
            /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
            ], [NAME, [VERSION, strMapper, windowsVersionMap]], [
            /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ], [[NAME, 'Windows'], [VERSION, strMapper, windowsVersionMap]], [

            // iOS/macOS
            /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,              // iOS
            /cfnetwork\/.+darwin/i
            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [
            /(mac os x) ?([\w\. ]*)/i,
            /(macintosh|mac_powerpc\b)(?!.+haiku)/i                             // Mac OS
            ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [

            // Mobile OSes
            /droid ([\w\.]+)\b.+(android[- ]x86)/i                              // Android-x86
            ], [VERSION, NAME], [                                               // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
            /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
            /(blackberry)\w*\/([\w\.]*)/i,                                      // Blackberry
            /(tizen|kaios)[\/ ]([\w\.]+)/i,                                     // Tizen/KaiOS
            /\((series40);/i                                                    // Series 40
            ], [NAME, VERSION], [
            /\(bb(10);/i                                                        // BlackBerry 10
            ], [VERSION, [NAME, BLACKBERRY]], [
            /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i         // Symbian
            ], [VERSION, [NAME, 'Symbian']], [
            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ], [VERSION, [NAME, FIREFOX+' OS']], [
            /web0s;.+rt(tv)/i,
            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i                              // WebOS
            ], [VERSION, [NAME, 'webOS']], [

            // Google Chromecast
            /crkey\/([\d\.]+)/i                                                 // Google Chromecast
            ], [VERSION, [NAME, CHROME+'cast']], [
            /(cros) [\w]+ ([\w\.]+\w)/i                                         // Chromium OS
            ], [[NAME, 'Chromium OS'], VERSION],[

            // Console
            /(nintendo|playstation) ([wids345portablevuch]+)/i,                 // Nintendo/Playstation
            /(xbox); +xbox ([^\);]+)/i,                                         // Microsoft Xbox (360, One, X, S, Series X, Series S)

            // Other
            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,                            // Joli/Palm
            /(mint)[\/\(\) ]?(\w*)/i,                                           // Mint
            /(mageia|vectorlinux)[; ]/i,                                        // Mageia/VectorLinux
            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                                                                                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
            /(hurd|linux) ?([\w\.]*)/i,                                         // Hurd/Linux
            /(gnu) ?([\w\.]*)/i,                                                // GNU
            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
            /(haiku) (\w+)/i                                                    // Haiku
            ], [NAME, VERSION], [
            /(sunos) ?([\w\.\d]*)/i                                             // Solaris
            ], [[NAME, 'Solaris'], VERSION], [
            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,                              // Solaris
            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,                                  // AIX
            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i,            // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX
            /(unix) ?([\w\.]*)/i                                                // UNIX
            ], [NAME, VERSION]
        ]
    };

    /////////////////
    // Constructor
    ////////////////

    var UAParser = function (ua, extensions) {

        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }

        if (!(this instanceof UAParser)) {
            return new UAParser(ua, extensions).getResult();
        }

        var _ua = ua || ((typeof window !== UNDEF_TYPE && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;

        this.getBrowser = function () {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser.major = majorize(_browser.version);
            return _browser;
        };
        this.getCPU = function () {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function () {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            return _device;
        };
        this.getEngine = function () {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function () {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            return _os;
        };
        this.getResult = function () {
            return {
                ua      : this.getUA(),
                browser : this.getBrowser(),
                engine  : this.getEngine(),
                os      : this.getOS(),
                device  : this.getDevice(),
                cpu     : this.getCPU()
            };
        };
        this.getUA = function () {
            return _ua;
        };
        this.setUA = function (ua) {
            _ua = (typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH) ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER =  enumerize([NAME, VERSION, MAJOR]);
    UAParser.CPU = enumerize([ARCHITECTURE]);
    UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
    UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]);

    ///////////
    // Export
    //////////

    // check js environment
    if (typeof(exports) !== UNDEF_TYPE) {
        // nodejs env
        if ("object" !== UNDEF_TYPE && module.exports) {
            exports = module.exports = UAParser;
        }
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if ("function" === FUNC_TYPE && __webpack_require__.amdO) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
                return UAParser;
            }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (typeof window !== UNDEF_TYPE) {
            // browser env
            window.UAParser = UAParser;
        }
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window !== UNDEF_TYPE && (window.jQuery || window.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function () {
            return parser.getUA();
        };
        $.ua.set = function (ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for (var prop in result) {
                $.ua[prop] = result[prop];
            }
        };
    }

})(typeof window === 'object' ? window : this);


/***/ }),

/***/ 44682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ h; },
/* harmony export */   "kr": function() { return /* binding */ E; },
/* harmony export */   "qp": function() { return /* binding */ m; }
/* harmony export */ });
/* unused harmony exports BridgeProvider, useBridgeValue, useContextUpdate */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var scheduler__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63840);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73935);
/* provided dependency */ var process = __webpack_require__(34155);
const d=Symbol(),f=Symbol(),v="undefined"==typeof window||/ServerSideRendering/.test(window.navigator&&window.navigator.userAgent)?react__WEBPACK_IMPORTED_MODULE_0__.useEffect:react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect,a=scheduler__WEBPACK_IMPORTED_MODULE_1__.unstable_runWithPriority?e=>(0,scheduler__WEBPACK_IMPORTED_MODULE_1__.unstable_runWithPriority)(scheduler__WEBPACK_IMPORTED_MODULE_1__.unstable_NormalPriority,e):e=>e(),w=e=>e;function E(r){const t=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({[d]:{v:{current:r},n:{current:-1},l:new Set,u:e=>e()}});var o;return t[f]=t.Provider,t.Provider=(o=t.Provider,({value:e,children:r})=>{const t=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(e),c=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0),[i,p]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);i&&(i(e),p(null));const f=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();if(!f.current){const e=new Set,r=(r,t)=>{(0,react_dom__WEBPACK_IMPORTED_MODULE_2__.unstable_batchedUpdates)(()=>{c.current+=1;const n={n:c.current};null!=t&&t.suspense&&(n.n*=-1,n.p=new Promise(e=>{p(()=>r=>{n.v=r,delete n.p,e(r)})})),e.forEach(e=>e(n)),r()})};f.current={[d]:{v:t,n:c,l:e,u:r}}}return v(()=>{t.current=e,c.current+=1,a(()=>{f.current[d].l.forEach(r=>{r({n:c.current,v:e})})})},[e]),(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(o,{value:f.current},r)}),delete t.Consumer,t}function h(e,n){const o=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(e)[d];if("object"==typeof process&&"production"!=="production"&&0){}const{v:{current:c},n:{current:u},l:s}=o,i=n(c),[p,l]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)((e,r)=>{if(!r)return[c,i];if("p"in r)throw r.p;if(r.n===u)return Object.is(e[1],i)?e:[c,i];try{if("v"in r){if(Object.is(e[0],r.v))return e;const t=n(r.v);return Object.is(e[1],t)?e:[r.v,t]}}catch(e){}return[...e]},[c,i]);return Object.is(p[1],i)||l(),v(()=>(s.add(l),()=>{s.delete(l)}),[s]),p[1]}function m(e){return h(e,w)}function b(e){const t=r(e)[d];if("object"==typeof process&&"production"!=="production"&&0){}const{u:n}=t;return n}const x=({context:e,value:r,children:t})=>{const{[f]:o}=e;if("object"==typeof process&&"production"!=="production"&&0){}return n(o,{value:r},t)},j=e=>{const t=r(e);if("object"==typeof process&&"production"!=="production"&&0){}return t};
//# sourceMappingURL=index.modern.js.map


/***/ }),

/***/ 42473:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),

/***/ 87462:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 52587:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),

/***/ 10748:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),

/***/ 50029:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ }),

/***/ 92777:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 82262:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/***/ }),

/***/ 59499:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ 37247:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ 81531:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90607);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}

/***/ }),

/***/ 4730:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 63553:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var next_dist_compiled_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14027);
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10748);


function _possibleConstructorReturn(self, call) {
  if (call && (next_dist_compiled_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(self);
}

/***/ }),

/***/ 90607:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ 16835:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(2937);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || _nonIterableRest();
}

/***/ }),

/***/ 27812:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(52587);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,arrayLikeToArray/* default */.Z)(arr);
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(2937);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || _nonIterableSpread();
}

/***/ }),

/***/ 2937:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52587);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}

/***/ }),

/***/ 8100:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J$": function() { return /* binding */ SWRConfig; },
/* harmony export */   "ZP": function() { return /* binding */ useSWR; }
/* harmony export */ });
/* unused harmony exports mutate, unstable_serialize, useSWRConfig */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var noop = function () { };
// Using noop() as the undefined value as undefined can possibly be replaced
// by something else.  Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
var UNDEFINED = ( /*#__NOINLINE__*/noop());
var OBJECT = Object;
var isUndefined = function (v) { return v === UNDEFINED; };
var isFunction = function (v) { return typeof v == 'function'; };
var mergeObjects = function (a, b) { return OBJECT.assign({}, a, b); };
var STR_UNDEFINED = 'undefined';
// NOTE: Use function to guarantee it's re-evaluated between jsdom and node runtime for tests.
var hasWindow = function () { return typeof window != STR_UNDEFINED; };
var hasDocument = function () { return typeof document != STR_UNDEFINED; };
var hasRequestAnimationFrame = function () {
    return hasWindow() && typeof window['requestAnimationFrame'] != STR_UNDEFINED;
};

// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
var table = new WeakMap();
// counter of the key
var counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsible.
var stableHash = function (arg) {
    var type = typeof arg;
    var constructor = arg && arg.constructor;
    var isDate = constructor == Date;
    var result;
    var index;
    if (OBJECT(arg) === arg && !isDate && constructor != RegExp) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = table.get(arg);
        if (result)
            return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++counter + '~';
        table.set(arg, result);
        if (constructor == Array) {
            // Array.
            result = '@';
            for (index = 0; index < arg.length; index++) {
                result += stableHash(arg[index]) + ',';
            }
            table.set(arg, result);
        }
        if (constructor == OBJECT) {
            // Object, sort keys.
            result = '#';
            var keys = OBJECT.keys(arg).sort();
            while (!isUndefined((index = keys.pop()))) {
                if (!isUndefined(arg[index])) {
                    result += index + ':' + stableHash(arg[index]) + ',';
                }
            }
            table.set(arg, result);
        }
    }
    else {
        result = isDate
            ? arg.toJSON()
            : type == 'symbol'
                ? arg.toString()
                : type == 'string'
                    ? JSON.stringify(arg)
                    : '' + arg;
    }
    return result;
};

/**
 * Due to bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a work around, we always assume it's online on first load, and change
 * the status upon `online` or `offline` events.
 */
var online = true;
var isOnline = function () { return online; };
var hasWin = hasWindow();
var hasDoc = hasDocument();
// For node and React Native, `add/removeEventListener` doesn't exist on window.
var onWindowEvent = hasWin && window.addEventListener
    ? window.addEventListener.bind(window)
    : noop;
var onDocumentEvent = hasDoc ? document.addEventListener.bind(document) : noop;
var offWindowEvent = hasWin && window.removeEventListener
    ? window.removeEventListener.bind(window)
    : noop;
var offDocumentEvent = hasDoc
    ? document.removeEventListener.bind(document)
    : noop;
var isVisible = function () {
    var visibilityState = hasDoc && document.visibilityState;
    return isUndefined(visibilityState) || visibilityState !== 'hidden';
};
var initFocus = function (callback) {
    // focus revalidate
    onDocumentEvent('visibilitychange', callback);
    onWindowEvent('focus', callback);
    return function () {
        offDocumentEvent('visibilitychange', callback);
        offWindowEvent('focus', callback);
    };
};
var initReconnect = function (callback) {
    // revalidate on reconnected
    var onOnline = function () {
        online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    var onOffline = function () {
        online = false;
    };
    onWindowEvent('online', onOnline);
    onWindowEvent('offline', onOffline);
    return function () {
        offWindowEvent('online', onOnline);
        offWindowEvent('offline', onOffline);
    };
};
var preset = {
    isOnline: isOnline,
    isVisible: isVisible
};
var defaultConfigOptions = {
    initFocus: initFocus,
    initReconnect: initReconnect
};

var IS_SERVER = !hasWindow() || 'Deno' in window;
// Polyfill requestAnimationFrame
var rAF = function (f) {
    return hasRequestAnimationFrame() ? window['requestAnimationFrame'](f) : setTimeout(f, 1);
};
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
var useIsomorphicLayoutEffect = IS_SERVER ? react__WEBPACK_IMPORTED_MODULE_0__.useEffect : react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;
// This assignment is to extend the Navigator type to use effectiveType.
var navigatorConnection = typeof navigator !== 'undefined' &&
    navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
var slowConnection = !IS_SERVER &&
    navigatorConnection &&
    (['slow-2g', '2g'].includes(navigatorConnection.effectiveType) ||
        navigatorConnection.saveData);

var serialize = function (key) {
    if (isFunction(key)) {
        try {
            key = key();
        }
        catch (err) {
            // dependencies not ready
            key = '';
        }
    }
    var args = [].concat(key);
    // If key is not falsy, or not an empty array, hash it.
    key =
        typeof key == 'string'
            ? key
            : (Array.isArray(key) ? key.length : key)
                ? stableHash(key)
                : '';
    var infoKey = key ? '$swr$' + key : '';
    return [key, args, infoKey];
};

// Global state used to deduplicate requests and store listeners
var SWRGlobalState = new WeakMap();

var FOCUS_EVENT = 0;
var RECONNECT_EVENT = 1;
var MUTATE_EVENT = 2;

var broadcastState = function (cache, key, data, error, isValidating, revalidate, broadcast) {
    if (broadcast === void 0) { broadcast = true; }
    var _a = SWRGlobalState.get(cache), EVENT_REVALIDATORS = _a[0], STATE_UPDATERS = _a[1], FETCH = _a[3];
    var revalidators = EVENT_REVALIDATORS[key];
    var updaters = STATE_UPDATERS[key];
    // Cache was populated, update states of all hooks.
    if (broadcast && updaters) {
        for (var i = 0; i < updaters.length; ++i) {
            updaters[i](data, error, isValidating);
        }
    }
    // If we also need to revalidate, only do it for the first hook.
    if (revalidate) {
        // Invalidate the key by deleting the concurrent request markers so new
        // requests will not be deduped.
        delete FETCH[key];
        if (revalidators && revalidators[0]) {
            return revalidators[0](MUTATE_EVENT).then(function () {
                return cache.get(key);
            });
        }
    }
    return cache.get(key);
};

// Global timestamp.
var __timestamp = 0;
var getTimestamp = function () { return ++__timestamp; };

var internalMutate = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return __awaiter(void 0, void 0, void 0, function () {
        var cache, _key, _data, _opts, options, populateCache, revalidate, rollbackOnError, optimisticData, _a, key, keyInfo, _b, MUTATION, data, error, beforeMutationTs, hasOptimisticData, rollbackData, res;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    cache = args[0], _key = args[1], _data = args[2], _opts = args[3];
                    options = typeof _opts === 'boolean' ? { revalidate: _opts } : _opts || {};
                    populateCache = options.populateCache !== false;
                    revalidate = options.revalidate !== false;
                    rollbackOnError = options.rollbackOnError !== false;
                    optimisticData = options.optimisticData;
                    _a = serialize(_key), key = _a[0], keyInfo = _a[2];
                    if (!key)
                        return [2 /*return*/];
                    _b = SWRGlobalState.get(cache), MUTATION = _b[2];
                    // If there is no new data provided, revalidate the key with current state.
                    if (args.length < 3) {
                        // Revalidate and broadcast state.
                        return [2 /*return*/, broadcastState(cache, key, cache.get(key), UNDEFINED, UNDEFINED, revalidate, populateCache)];
                    }
                    data = _data;
                    beforeMutationTs = getTimestamp();
                    MUTATION[key] = [beforeMutationTs, 0];
                    hasOptimisticData = !isUndefined(optimisticData);
                    rollbackData = cache.get(key);
                    // Do optimistic data update.
                    if (hasOptimisticData) {
                        cache.set(key, optimisticData);
                        broadcastState(cache, key, optimisticData);
                    }
                    if (isFunction(data)) {
                        // `data` is a function, call it passing current cache value.
                        try {
                            data = data(cache.get(key));
                        }
                        catch (err) {
                            // If it throws an error synchronously, we shouldn't update the cache.
                            error = err;
                        }
                    }
                    if (!(data && isFunction(data.then))) return [3 /*break*/, 2];
                    return [4 /*yield*/, data.catch(function (err) {
                            error = err;
                        })
                        // Check if other mutations have occurred since we've started this mutation.
                        // If there's a race we don't update cache or broadcast the change,
                        // just return the data.
                    ];
                case 1:
                    // This means that the mutation is async, we need to check timestamps to
                    // avoid race conditions.
                    data = _c.sent();
                    // Check if other mutations have occurred since we've started this mutation.
                    // If there's a race we don't update cache or broadcast the change,
                    // just return the data.
                    if (beforeMutationTs !== MUTATION[key][0]) {
                        if (error)
                            throw error;
                        return [2 /*return*/, data];
                    }
                    else if (error && hasOptimisticData && rollbackOnError) {
                        // Rollback. Always populate the cache in this case.
                        populateCache = true;
                        data = rollbackData;
                        cache.set(key, rollbackData);
                    }
                    _c.label = 2;
                case 2:
                    if (populateCache) {
                        if (!error) {
                            // Only update cached data if there's no error. Data can be `undefined` here.
                            cache.set(key, data);
                        }
                        // Always update or reset the error.
                        cache.set(keyInfo, mergeObjects(cache.get(keyInfo), { error: error }));
                    }
                    // Reset the timestamp to mark the mutation has ended.
                    MUTATION[key][1] = getTimestamp();
                    return [4 /*yield*/, broadcastState(cache, key, data, error, UNDEFINED, revalidate, populateCache)
                        // Throw error or return data
                    ];
                case 3:
                    res = _c.sent();
                    // Throw error or return data
                    if (error)
                        throw error;
                    return [2 /*return*/, populateCache ? res : data];
            }
        });
    });
};

var revalidateAllKeys = function (revalidators, type) {
    for (var key in revalidators) {
        if (revalidators[key][0])
            revalidators[key][0](type);
    }
};
var initCache = function (provider, options) {
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that bound to
    // the cache.
    // Provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!SWRGlobalState.has(provider)) {
        var opts = mergeObjects(defaultConfigOptions, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        var EVENT_REVALIDATORS = {};
        var mutate = internalMutate.bind(UNDEFINED, provider);
        var unmount = noop;
        // Update the state if it's new, or the provider has been extended.
        SWRGlobalState.set(provider, [EVENT_REVALIDATORS, {}, {}, {}, mutate]);
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        if (!IS_SERVER) {
            // When listening to the native events for auto revalidations,
            // we intentionally put a delay (setTimeout) here to make sure they are
            // fired after immediate JavaScript executions, which can possibly be
            // React's state updates.
            // This avoids some unnecessary revalidations such as
            // https://github.com/vercel/swr/issues/1680.
            var releaseFocus_1 = opts.initFocus(setTimeout.bind(UNDEFINED, revalidateAllKeys.bind(UNDEFINED, EVENT_REVALIDATORS, FOCUS_EVENT)));
            var releaseReconnect_1 = opts.initReconnect(setTimeout.bind(UNDEFINED, revalidateAllKeys.bind(UNDEFINED, EVENT_REVALIDATORS, RECONNECT_EVENT)));
            unmount = function () {
                releaseFocus_1 && releaseFocus_1();
                releaseReconnect_1 && releaseReconnect_1();
                // When un-mounting, we need to remove the cache provider from the state
                // storage too because it's a side-effect. Otherwise when re-mounting we
                // will not re-register those event listeners.
                SWRGlobalState.delete(provider);
            };
        }
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [provider, mutate, unmount];
    }
    return [provider, SWRGlobalState.get(provider)[4]];
};

// error retry
var onErrorRetry = function (_, __, config, revalidate, opts) {
    var maxRetryCount = config.errorRetryCount;
    var currentRetryCount = opts.retryCount;
    // Exponential backoff
    var timeout = ~~((Math.random() + 0.5) *
        (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!isUndefined(maxRetryCount) && currentRetryCount > maxRetryCount) {
        return;
    }
    setTimeout(revalidate, timeout, opts);
};
// Default cache provider
var _a = initCache(new Map()), cache = _a[0], mutate = _a[1];
// Default config
var defaultConfig = mergeObjects({
    // events
    onLoadingSlow: noop,
    onSuccess: noop,
    onError: noop,
    onErrorRetry: onErrorRetry,
    onDiscarded: noop,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: slowConnection ? 10000 : 5000,
    focusThrottleInterval: 5 * 1000,
    dedupingInterval: 2 * 1000,
    loadingTimeout: slowConnection ? 5000 : 3000,
    // providers
    compare: function (currentData, newData) {
        return stableHash(currentData) == stableHash(newData);
    },
    isPaused: function () { return false; },
    cache: cache,
    mutate: mutate,
    fallback: {}
}, 
// use web preset by default
preset);

var mergeConfigs = function (a, b) {
    // Need to create a new object to avoid mutating the original here.
    var v = mergeObjects(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        var u1 = a.use, f1 = a.fallback;
        var u2 = b.use, f2 = b.fallback;
        if (u1 && u2) {
            v.use = u1.concat(u2);
        }
        if (f1 && f2) {
            v.fallback = mergeObjects(f1, f2);
        }
    }
    return v;
};

var SWRConfigContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
var SWRConfig$1 = function (props) {
    var value = props.value;
    // Extend parent context values and middleware.
    var extendedConfig = mergeConfigs((0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(SWRConfigContext), value);
    // Should not use the inherited provider.
    var provider = value && value.provider;
    // Use a lazy initialized state to create the cache on first access.
    var cacheContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function () {
        return provider
            ? initCache(provider(extendedConfig.cache || cache), value)
            : UNDEFINED;
    })[0];
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    useIsomorphicLayoutEffect(function () { return (cacheContext ? cacheContext[2] : UNDEFINED); }, []);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(SWRConfigContext.Provider, mergeObjects(props, {
        value: extendedConfig
    }));
};

/**
 * An implementation of state with dependency-tracking.
 */
var useStateWithDeps = function (state, unmountedRef) {
    var rerender = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({})[1];
    var stateRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(state);
    // If a state property (data, error or isValidating) is accessed by the render
    // function, we mark the property as a dependency so if it is updated again
    // in the future, we trigger a rerender.
    // This is also known as dependency-tracking.
    var stateDependenciesRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
        data: false,
        error: false,
        isValidating: false
    });
    /**
     * @param payload To change stateRef, pass the values explicitly to setState:
     * @example
     * ```js
     * setState({
     *   isValidating: false
     *   data: newData // set data to newData
     *   error: undefined // set error to undefined
     * })
     *
     * setState({
     *   isValidating: false
     *   data: undefined // set data to undefined
     *   error: err // set error to err
     * })
     * ```
     */
    var setState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (payload) {
        var shouldRerender = false;
        var currentState = stateRef.current;
        for (var _ in payload) {
            var k = _;
            // If the property has changed, update the state and mark rerender as
            // needed.
            if (currentState[k] !== payload[k]) {
                currentState[k] = payload[k];
                // If the property is accessed by the component, a rerender should be
                // triggered.
                if (stateDependenciesRef.current[k]) {
                    shouldRerender = true;
                }
            }
        }
        if (shouldRerender && !unmountedRef.current) {
            rerender({});
        }
    }, 
    // config.suspense isn't allowed to change during the lifecycle
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Always update the state reference.
    useIsomorphicLayoutEffect(function () {
        stateRef.current = state;
    });
    return [stateRef, stateDependenciesRef.current, setState];
};

var normalize = function (args) {
    return isFunction(args[1])
        ? [args[0], args[1], args[2] || {}]
        : [args[0], null, (args[1] === null ? args[2] : args[1]) || {}];
};

var useSWRConfig = function () {
    return mergeObjects(defaultConfig, (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(SWRConfigContext));
};

// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
var withArgs = function (hook) {
    return function useSWRArgs() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // Get the default and inherited configuration.
        var fallbackConfig = useSWRConfig();
        // Normalize arguments.
        var _a = normalize(args), key = _a[0], fn = _a[1], _config = _a[2];
        // Merge configurations.
        var config = mergeConfigs(fallbackConfig, _config);
        // Apply middleware
        var next = hook;
        var use = config.use;
        if (use) {
            for (var i = use.length; i-- > 0;) {
                next = use[i](next);
            }
        }
        return next(key, fn || config.fetcher, config);
    };
};

// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
var subscribeCallback = function (key, callbacks, callback) {
    var keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return function () {
        var index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};

var WITH_DEDUPE = { dedupe: true };
var useSWRHandler = function (_key, fetcher, config) {
    var cache = config.cache, compare = config.compare, fallbackData = config.fallbackData, suspense = config.suspense, revalidateOnMount = config.revalidateOnMount, refreshInterval = config.refreshInterval, refreshWhenHidden = config.refreshWhenHidden, refreshWhenOffline = config.refreshWhenOffline;
    var _a = SWRGlobalState.get(cache), EVENT_REVALIDATORS = _a[0], STATE_UPDATERS = _a[1], MUTATION = _a[2], FETCH = _a[3];
    // `key` is the identifier of the SWR `data` state, `keyInfo` holds extra
    // states such as `error` and `isValidating` inside,
    // all of them are derived from `_key`.
    // `fnArgs` is an array of arguments parsed from the key, which will be passed
    // to the fetcher.
    var _b = serialize(_key), key = _b[0], fnArgs = _b[1], keyInfo = _b[2];
    // If it's the initial render of this hook.
    var initialMountedRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    var unmountedRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    // Refs to keep the key and config.
    var keyRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(key);
    var fetcherRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(fetcher);
    var configRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(config);
    var getConfig = function () { return configRef.current; };
    var isActive = function () { return getConfig().isVisible() && getConfig().isOnline(); };
    var patchFetchInfo = function (info) {
        return cache.set(keyInfo, mergeObjects(cache.get(keyInfo), info));
    };
    // Get the current state that SWR should return.
    var cached = cache.get(key);
    var fallback = isUndefined(fallbackData)
        ? config.fallback[key]
        : fallbackData;
    var data = isUndefined(cached) ? fallback : cached;
    var info = cache.get(keyInfo) || {};
    var error = info.error;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    var shouldRevalidateOnMount = function () {
        // If `revalidateOnMount` is set, we take the value directly.
        if (!isUndefined(revalidateOnMount))
            return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused())
            return false;
        return suspense
            ? // Under suspense mode, it will always fetch on render if there is no
                // stale data so no need to revalidate immediately on mount again.
                !isUndefined(data)
            : // If there is no stale data, we need to revalidate on mount;
                // If `revalidateIfStale` is set to true, we will always revalidate.
                isUndefined(data) || config.revalidateIfStale;
    };
    // Resolve the current validating state.
    var resolveValidating = function () {
        if (!key || !fetcher)
            return false;
        if (info.isValidating)
            return true;
        // If it's not mounted yet and it should revalidate on mount, revalidate.
        return !initialMountedRef.current && shouldRevalidateOnMount();
    };
    var isValidating = resolveValidating();
    var _c = useStateWithDeps({
        data: data,
        error: error,
        isValidating: isValidating
    }, unmountedRef), stateRef = _c[0], stateDependencies = _c[1], setState = _c[2];
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    var revalidate = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (revalidateOpts) { return __awaiter(void 0, void 0, void 0, function () {
        var currentFetcher, newData, startAt, loading, opts, shouldStartNewRequest, isCurrentKeyMounted, cleanupState, newState, finishRequestAndUpdateState, mutationInfo, err_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    currentFetcher = fetcherRef.current;
                    if (!key ||
                        !currentFetcher ||
                        unmountedRef.current ||
                        getConfig().isPaused()) {
                        return [2 /*return*/, false];
                    }
                    loading = true;
                    opts = revalidateOpts || {};
                    shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
                    isCurrentKeyMounted = function () {
                        return !unmountedRef.current &&
                            key === keyRef.current &&
                            initialMountedRef.current;
                    };
                    cleanupState = function () {
                        // Check if it's still the same request before deleting.
                        var requestInfo = FETCH[key];
                        if (requestInfo && requestInfo[1] === startAt) {
                            delete FETCH[key];
                        }
                    };
                    newState = { isValidating: false };
                    finishRequestAndUpdateState = function () {
                        patchFetchInfo({ isValidating: false });
                        // We can only set state if it's safe (still mounted with the same key).
                        if (isCurrentKeyMounted()) {
                            setState(newState);
                        }
                    };
                    // Start fetching. Change the `isValidating` state, update the cache.
                    patchFetchInfo({
                        isValidating: true
                    });
                    setState({ isValidating: true });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    if (shouldStartNewRequest) {
                        // Tell all other hooks to change the `isValidating` state.
                        broadcastState(cache, key, stateRef.current.data, stateRef.current.error, true);
                        // If no cache being rendered currently (it shows a blank page),
                        // we trigger the loading slow event.
                        if (config.loadingTimeout && !cache.get(key)) {
                            setTimeout(function () {
                                if (loading && isCurrentKeyMounted()) {
                                    getConfig().onLoadingSlow(key, config);
                                }
                            }, config.loadingTimeout);
                        }
                        // Start the request and save the timestamp.
                        FETCH[key] = [currentFetcher.apply(void 0, fnArgs), getTimestamp()];
                    }
                    _a = FETCH[key], newData = _a[0], startAt = _a[1];
                    return [4 /*yield*/, newData];
                case 2:
                    newData = _b.sent();
                    if (shouldStartNewRequest) {
                        // If the request isn't interrupted, clean it up after the
                        // deduplication interval.
                        setTimeout(cleanupState, config.dedupingInterval);
                    }
                    // If there're other ongoing request(s), started after the current one,
                    // we need to ignore the current one to avoid possible race conditions:
                    //   req1------------------>res1        (current one)
                    //        req2---------------->res2
                    // the request that fired later will always be kept.
                    // The timestamp maybe be `undefined` or a number
                    if (!FETCH[key] || FETCH[key][1] !== startAt) {
                        if (shouldStartNewRequest) {
                            if (isCurrentKeyMounted()) {
                                getConfig().onDiscarded(key);
                            }
                        }
                        return [2 /*return*/, false];
                    }
                    // Clear error.
                    patchFetchInfo({
                        error: UNDEFINED
                    });
                    newState.error = UNDEFINED;
                    mutationInfo = MUTATION[key];
                    if (!isUndefined(mutationInfo) &&
                        // case 1
                        (startAt <= mutationInfo[0] ||
                            // case 2
                            startAt <= mutationInfo[1] ||
                            // case 3
                            mutationInfo[1] === 0)) {
                        finishRequestAndUpdateState();
                        if (shouldStartNewRequest) {
                            if (isCurrentKeyMounted()) {
                                getConfig().onDiscarded(key);
                            }
                        }
                        return [2 /*return*/, false];
                    }
                    // Deep compare with latest state to avoid extra re-renders.
                    // For local state, compare and assign.
                    if (!compare(stateRef.current.data, newData)) {
                        newState.data = newData;
                    }
                    else {
                        // data and newData are deeply equal
                        // it should be safe to broadcast the stale data
                        newState.data = stateRef.current.data;
                        // At the end of this function, `brocastState` invokes the `onStateUpdate` function,
                        // which takes care of avoiding the re-render
                    }
                    // For global state, it's possible that the key has changed.
                    // https://github.com/vercel/swr/pull/1058
                    if (!compare(cache.get(key), newData)) {
                        cache.set(key, newData);
                    }
                    // Trigger the successful callback if it's the original request.
                    if (shouldStartNewRequest) {
                        if (isCurrentKeyMounted()) {
                            getConfig().onSuccess(newData, key, config);
                        }
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _b.sent();
                    cleanupState();
                    // Not paused, we continue handling the error. Otherwise discard it.
                    if (!getConfig().isPaused()) {
                        // Get a new error, don't use deep comparison for errors.
                        patchFetchInfo({ error: err_1 });
                        newState.error = err_1;
                        // Error event and retry logic. Only for the actual request, not
                        // deduped ones.
                        if (shouldStartNewRequest && isCurrentKeyMounted()) {
                            getConfig().onError(err_1, key, config);
                            if ((typeof config.shouldRetryOnError === 'boolean' &&
                                config.shouldRetryOnError) ||
                                (isFunction(config.shouldRetryOnError) &&
                                    config.shouldRetryOnError(err_1))) {
                                // When retrying, dedupe is always enabled
                                if (isActive()) {
                                    // If it's active, stop. It will auto revalidate when refocusing
                                    // or reconnecting.
                                    getConfig().onErrorRetry(err_1, key, config, revalidate, {
                                        retryCount: (opts.retryCount || 0) + 1,
                                        dedupe: true
                                    });
                                }
                            }
                        }
                    }
                    return [3 /*break*/, 4];
                case 4:
                    // Mark loading as stopped.
                    loading = false;
                    // Update the current hook's state.
                    finishRequestAndUpdateState();
                    // Here is the source of the request, need to tell all other hooks to
                    // update their states.
                    if (isCurrentKeyMounted() && shouldStartNewRequest) {
                        broadcastState(cache, key, newState.data, newState.error, false);
                    }
                    return [2 /*return*/, true];
            }
        });
    }); }, 
    // `setState` is immutable, and `eventsCallback`, `fnArgs`, `keyInfo`,
    // and `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [key]);
    // Similar to the global mutate, but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var boundMutate = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    // By using `bind` we don't need to modify the size of the rest arguments.
    internalMutate.bind(UNDEFINED, cache, function () { return keyRef.current; }), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Always update fetcher and config refs.
    useIsomorphicLayoutEffect(function () {
        fetcherRef.current = fetcher;
        configRef.current = config;
    });
    // After mounted or key changed.
    useIsomorphicLayoutEffect(function () {
        if (!key)
            return;
        // Not the initial render.
        var keyChanged = initialMountedRef.current;
        var softRevalidate = revalidate.bind(UNDEFINED, WITH_DEDUPE);
        // Expose state updater to global event listeners. So we can update hook's
        // internal state from the outside.
        var onStateUpdate = function (updatedData, updatedError, updatedIsValidating) {
            setState(mergeObjects({
                error: updatedError,
                isValidating: updatedIsValidating
            }, 
            // Since `setState` only shallowly compares states, we do a deep
            // comparison here.
            compare(stateRef.current.data, updatedData)
                ? UNDEFINED
                : {
                    data: updatedData
                }));
        };
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        var nextFocusRevalidatedAt = 0;
        var onRevalidate = function (type) {
            if (type == FOCUS_EVENT) {
                var now = Date.now();
                if (getConfig().revalidateOnFocus &&
                    now > nextFocusRevalidatedAt &&
                    isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            }
            else if (type == RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) {
                    softRevalidate();
                }
            }
            else if (type == MUTATE_EVENT) {
                return revalidate();
            }
            return;
        };
        var unsubUpdate = subscribeCallback(key, STATE_UPDATERS, onStateUpdate);
        var unsubEvents = subscribeCallback(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // When `key` updates, reset the state to the initial value
        // and trigger a rerender if necessary.
        if (keyChanged) {
            setState({
                data: data,
                error: error,
                isValidating: isValidating
            });
        }
        // Trigger a revalidation.
        if (shouldRevalidateOnMount()) {
            if (isUndefined(data) || IS_SERVER) {
                // Revalidate immediately.
                softRevalidate();
            }
            else {
                // Delay the revalidate if we have data to return so we won't block
                // rendering.
                rAF(softRevalidate);
            }
        }
        return function () {
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubUpdate();
            unsubEvents();
        };
    }, [key, revalidate]);
    // Polling
    useIsomorphicLayoutEffect(function () {
        var timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            var interval = isFunction(refreshInterval)
                ? refreshInterval(data)
                : refreshInterval;
            // We only start next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) {
                timer = setTimeout(execute, interval);
            }
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online and not errored.
            if (!stateRef.current.error &&
                (refreshWhenHidden || getConfig().isVisible()) &&
                (refreshWhenOffline || getConfig().isOnline())) {
                revalidate(WITH_DEDUPE).then(next);
            }
            else {
                // Schedule next interval to check again.
                next();
            }
        }
        next();
        return function () {
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [refreshInterval, refreshWhenHidden, refreshWhenOffline, revalidate]);
    // Display debug info in React DevTools.
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useDebugValue)(data);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense && isUndefined(data) && key) {
        // Always update fetcher and config refs even with the Suspense mode.
        fetcherRef.current = fetcher;
        configRef.current = config;
        throw isUndefined(error) ? revalidate(WITH_DEDUPE) : error;
    }
    return {
        mutate: boundMutate,
        get data() {
            stateDependencies.data = true;
            return data;
        },
        get error() {
            stateDependencies.error = true;
            return error;
        },
        get isValidating() {
            stateDependencies.isValidating = true;
            return isValidating;
        }
    };
};
var SWRConfig = OBJECT.defineProperty(SWRConfig$1, 'default', {
    value: defaultConfig
});
var unstable_serialize = function (key) { return serialize(key)[0]; };
var useSWR = withArgs(useSWRHandler);

// useSWR




/***/ }),

/***/ 88593:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"name":"axios","version":"0.21.4","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.min.js","unpkg":"dist/axios.min.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,179], function() { return __webpack_exec__(6840), __webpack_exec__(69898); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);